(function () {
    'use strict';

    angular
        .module('app.questions',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.evaluations.questions', {
                url: '/questions/:questionnaire/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/evaluations/views/questions/questions.html',
                        controller: 'QuestionsController as vm'
                    }
                },
                resolve: {
                    Questionnaire: function ($stateParams, Questionnaires) {
                        if(!$stateParams.questionnaire && Questionnaires && Questionnaires.data[0] && Questionnaires.data[0].id){
                            $stateParams.questionnaire=Questionnaires.data[0].id;
                        }
                        return Questionnaires.data[$stateParams.questionnaire-1];
                    },
                    Questions: function (questionsService, Questionnaire) {
                        questionsService.questions.filters={};
                        questionsService.questions.filters.questionnaire=Questionnaire.id;
                        return questionsService.getQuestions();
                    },
                    Breadcrumb: function (Questionnaire) {
                        return ['Cuestionarios',
                            Questionnaire.name];
                    }
                },
                bodyClass: 'todo'
            });



    }
})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .controller('QuestionOptionDialogController', QuestionOptionDialogController);

    /** @ngInject */
    function QuestionOptionDialogController($rootScope, $mdDialog, QuestionOptions, Question, questionsService,
                                                    questionOptionsService, NotifyService, $document, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Opciones de selector');
        vm.questionOptions = QuestionOptions;
        vm.questionOption = questionOptionsService.getEmptyQuestionOption(Question.id);

        // Methods
        vm.saveQuestionOption = saveQuestionOption;
        vm.closeDialog = closeDialog;
        vm.removeQuestionOption = removeQuestionOption;
        vm.hasPermission=$rootScope.hasPermission;

        //////////

        /**
         * Guardar opción
         */
        function saveQuestionOption() {
            return questionOptionsService.saveQuestionOption(vm.questionOption).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Opción guardada correctamente"));
                vm.questionOption = questionOptionsService.getEmptyQuestionOption(Question.id);
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la opción. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            if(vm.questionOptions.count){
                $mdDialog.hide();
            }else{
                removeQuestion(null,Question);
            }
        }

        /**
         * Elimina una opcion
         *
         * @param ev
         * @param questionOption
         */
        function removeQuestionOption(ev, questionOption) {

            questionOptionsService.removeQuestionOption(questionOption).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Opción borrada correctamente."));
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al borrar la opción. ") + (error.data.detail || "") + (error.data.error || ""));
            });
        }

        /**
         * Abre el dialogo para eliminar un trámite
         *
         * @param ev
         * @param question
         */
        function removeQuestion(ev, question) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Borrar cuestionario'))
                .textContent(gettextCatalog.getString('Si no añade ninguna opción el cuestionario se eliminará. ¿Seguro que quieres eliminar el cuestionario?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cuestionario'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cuestionario'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                questionsService.removeQuestion(question).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cuestionario borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar el cuestionario. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            },function(){
                openQuestionOptionsDialog(null, Question);
            });

        }

        /**
         * Abre el dialogo para crear/editar un selector
         *
         * @param ev
         * @param question
         */
        function openQuestionOptionsDialog(ev, question) {
            questionOptionsService.questionOptions.filters.question=question.id;
            $mdDialog.show({

                controller: 'QuestionOptionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/evaluations/views/questions/dialogs/questionOptions/questionOptions-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Question:question,
                    event: ev,
                    QuestionOptions: questionOptionsService.getQuestionOptions()
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .controller('QuestionDialogController', QuestionDialogController);

    /** @ngInject */
    function QuestionDialogController($mdDialog, Question, Questionnaire, questionsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Edición de criterio a valorar');
        vm.typeQuestions=questionsService.typeQuestions();

        if (!Question) {
            vm.title = gettextCatalog.getString('Crear criterio a valorar');
            vm.question = questionsService.getEmptyQuestion(Questionnaire);
        } else {
            vm.question = angular.copy(Question); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveQuestion = saveQuestion;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar questiono
         */
        function saveQuestion() {
            return questionsService.saveQuestion(angular.copy(vm.question)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Criterio guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el criterio. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.answers',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.dossiers.get.answers', {
                abstract: true,
                url: 'answers/:point/',
                resolve: {
                    Evaluations: function ($stateParams, evaluationsService, Points, Dossier) {
                        evaluationsService.evaluations.filters={};
                        evaluationsService.evaluations.filters.evaluation_point=$stateParams.point;
                        return evaluationsService.getEvaluations().then(function (response) {
                            for(var i in Dossier.evaluations_points){
                                if(Dossier.evaluations_points[i].id*1===$stateParams.point*1){
                                    Dossier.evaluations_points[i].evaluations=response.data;
                                }
                            }
                            return response;
                        });
                    }
                },
                bodyClass: 'todo'
            })

            .state('app.dossiers.get.answers.questionnaire', {
                url: 'questionnaire/:questionnaire',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/evaluations/views/answers/answers.html',
                        controller: 'AnswersController as vm'
                    }
                },
                resolve: {
                    Point: function ($stateParams, Dossier, Evaluations) {
                        for(var i in Dossier.evaluations_points){
                            if(Dossier.evaluations_points[i].id*1===$stateParams.point*1){
                                return Dossier.evaluations_points[i];
                            }
                        }
                    },
                    Questionnaire: function ($stateParams, Dossier, Evaluations, questionnairesService) {
                        if(!$stateParams.questionnaire){
                            for(var i in Dossier.evaluations_points){
                                if(Dossier.evaluations_points[i].id*1===$stateParams.point*1){
                                    if(Dossier.evaluations_points[i].evaluations[0]){
                                        $stateParams.questionnaire=Dossier.evaluations_points[i].evaluations[0].questionnaire;
                                    }
                                }
                            }
                        }
                        if($stateParams.questionnaire){
                            return questionnairesService.getQuestionnaire($stateParams.questionnaire);
                        }else{
                            return {};
                        }
                    },
                    Evaluation: function (Evaluations,Questionnaire) {
                        for(var i in Evaluations.data){
                            if(Evaluations.data[i].questionnaire*1===Questionnaire.id*1){
                                return Evaluations.data[i];
                            }
                        }
                        return {};
                    },
                    Questions: function (questionsService, Questionnaire) {
                        questionsService.questions.filters={};
                        questionsService.questions.filters.page="all";
                        questionsService.questions.filters.questionnaire=Questionnaire.id;
                        return questionsService.getQuestions();
                    },
                    Answers: function (answersService, Evaluation) {
                        answersService.answers.filters={};
                        answersService.answers.filters.page="all";
                        answersService.answers.filters.evaluation=Evaluation.id;
                        answersService.answers.data=Evaluation.answers;
                        return answersService.answers;
                    },
                    Breadcrumb: function (Dossier, Questionnaire) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Evaluación',
                            Questionnaire.name];
                    }
                },
                bodyClass: 'todo'
            });



    }
})();

(function () {
    'use strict';

    angular
        .module('app.answers')
        .controller('AnswerDialogController', AnswerDialogController);

    /** @ngInject */
    function AnswerDialogController($mdDialog, Question, Answer, Evaluation, Options, answersService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Responder');
        vm.evaluation=Evaluation;
        vm.question=Question;
        vm.options=Options.data;

        if (!Answer) {
            vm.answer = answersService.getEmptyAnswer(Evaluation, Question);
        } else {
            vm.answer = angular.copy(Answer); // Copiamos para no modificar el original hasta guardar
            if(vm.question.type==='assessment'){
                vm.answer.body=parseInt(vm.answer.body);
            }

        }

        // Methods
        vm.saveAnswer = saveAnswer;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar answero
         */
        function saveAnswer() {
            return answersService.saveAnswer(angular.copy(vm.answer)).then(function(response){
                Question.answer=response;
                NotifyService.successMessage(gettextCatalog.getString("Evaluación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al evaluar. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierResignations',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.dossiers.get.dossierResignations', {
                url: 'resignations/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/dossierResignations/dossierResignations.html',
                        controller: 'DossierResignationsController as vm'
                    }
                },
                resolve: {
                    DossierResignations: function (dossierResignationsService, Dossier) {
                        dossierResignationsService.dossierResignations.filters={};
                        dossierResignationsService.dossierResignations.filters.dossier=Dossier.id;
                        return dossierResignationsService.getDossierResignations();
                    },
                    Breadcrumb: function (Dossier, $filter) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Cancelaciones'];
                    }
                },
                bodyClass: 'todo'
            });



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierResignations')
        .controller('DossierResignationDialogController', DossierResignationDialogController);

    /** @ngInject */
    function DossierResignationDialogController($mdDialog, DossierResignation, AuthService, Dossier, dossierResignationsService,
                                                dossiersService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Solicitar cancelacion');
        vm.user = AuthService.currentUser;

        // La UCA y el tutor académico crean la rescisión ya aceptada:
        // el backend exige la fecha efectiva de cese (corte de cotización a la SS)
        vm.requiresEffectiveEndDate = vm.user.group_type === 'manager' || vm.user.group_type === 'curricular_practices_tutor';

        if (!DossierResignation) {
            vm.title = gettextCatalog.getString('Solicitar cancelacion');
            vm.dossierResignation = dossierResignationsService.getEmptyDossierResignation(Dossier);
        } else {
            vm.dossierResignation = angular.copy(DossierResignation); // Copiamos para no modificar el original hasta guardar
            vm.dossierResignation.start_date= moment(vm.dossierResignation.start_date).toDate();
            vm.dossierResignation.end_date= moment(vm.dossierResignation.end_date).toDate();
        }

        // Methods
        vm.saveDossierResignation = saveDossierResignation;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar dossierResignationo
         */
        function saveDossierResignation() {
            return dossierResignationsService.saveDossierResignation(angular.copy(vm.dossierResignation)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Cancelacion solicitada correctamente"));
                closeDialog();

                dossiersService.getDossier(Dossier.id).then(function(res){
                    Dossier.status=res.status;
                });

            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar la cancelacion. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossiers',
            [
                'app.dossierInterruptions',
                'app.dossierExtensions',
                'app.dossierResignations',
                'app.dossierQuotes',
                'app.dossierDocuments'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider
            .state('app.dossiers', {
                abstract: true,
                url: '/dossiers',
                resolve:{
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    }
                }
            })
            .state('app.dossiers.list', {
                url: '/?offer&student&demand',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/list/dossiers.html',
                        controller: 'DossiersController as vm'
                    }
                },
                resolve: {
                    Offer: function (offersService,$stateParams) {
                        if($stateParams.offer){
                            return offersService.getOffer($stateParams.offer);
                        }else{
                            return false;
                        }
                    },
                    Demand: function (demandsService,$stateParams) {
                        if($stateParams.demand){
                            return demandsService.getDemand($stateParams.demand);
                        }else{
                            return false;
                        }
                    },
                    StudentsDetail: function (currentUser, $rootScope, studentsDetailService, studentsListService, $stateParams) {
                        if($stateParams.student && $rootScope.hasPermission("studentsList","LIST")){
                            return studentsListService.getStudents($stateParams.student);
                        }else if(currentUser.group_type==='student' && !$stateParams.offer){
                            return studentsDetailService.getStudentsDetail();
                        }else{
                            return false;
                        }
                    },
                    Dossiers: function (currentUser, StudentsDetail, Offer, Demand, $rootScope, dossiersService, myDossiersService, $stateParams) {
                        if($rootScope.hasPermission('myDossiers','LIST')){
                            myDossiersService.myDossiers.filters={};
                            myDossiersService.myDossiers.filters.offer=$stateParams.offer;
                            return myDossiersService.getMyDossiers();
                        }else{
                            var obj={offer:$stateParams.offer,student:$stateParams.student,offer__schedule__demand:$stateParams.demand};
                            //Si no se muestra el búscador no filtramos por este estado ya que no podremos cambiarlo
                            // if(!StudentsDetail && !Offer && !Demand) {
                            //     obj.status__iexact = "in progress";
                            // }
                            var concat=[Object.assign({}, obj, dossiersService.dossiers.filtersAdvances[0])];
                            dossiersService.dossiers.filtersAdvances[0]=concat[0];
                            //Si filtramos por demanda debebemos traer todos los resultados
                            if($stateParams.demand){
                                dossiersService.dossiers.filters.offer__schedule__demand=$stateParams.demand;
                                return dossiersService.getAllDossiers().then(function (res) {
                                    //Damos el mismo formato que si fuese paginado
                                    var obj={
                                        data:res,
                                        count:res.length
                                    };
                                    return obj;
                                })
                            }
                            return dossiersService.getDossiers();

                        }
                    },
                    SearchsBasics: function (searchsAdvancesService, $rootScope) {
                        if($rootScope.hasPermission('myDossiers','LIST')){
                            return [];
                        }else{
                            return searchsAdvancesService.getSearchsAdvances('dossiers');
                        }
                    },
                    Breadcrumb: function (Offer, StudentsDetail, Demand) {
                        if(Offer){
                            return ['<a ui-sref="app.offers"> Ofertas extracurriculares</a>',
                                'Expedientes de la oferta '+Offer.code];
                        }
                        if(Demand){
                            return ['<a ui-sref="app.demands.list"> Ofertas curriculares</a>',
                                'Expedientes de la oferta '+(Demand.code || Demand.id)];
                        }
                        if(StudentsDetail){
                            return ['Alumno',
                                'Expedientes'];
                        }
                        return ['Expedientes',
                            'Listado'];
                    }
                },
                bodyClass: 'dossiers'
            })
            .state('app.dossiers.get', {
                abstract: true,
                url: '/:dossier/',
                resolve:{
                    Dossier: function (dossiersService,$stateParams) {
                        return dossiersService.getDossier($stateParams.dossier);
                    },
                    Points: function (currentUser, evaluationsPointsService, $rootScope, $stateParams, Dossier) {
                        if($rootScope.hasPermission("evaluationsPoints","LIST")){
                            evaluationsPointsService.evaluationsPoints.filters={};
                            evaluationsPointsService.evaluationsPoints.filters.dossier=$stateParams.dossier;
                            return evaluationsPointsService.getEvaluationsPoints().then(function(response){
                                Dossier.evaluations_points=response.data;
                                return response.data;
                            });
                        }else{
                            return [];
                        }
                    }
                }
            })
            .state('app.dossiers.get.detail', {
                url      : 'detail',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/detail/dossier.html',
                        controller : 'DossierController as vm'
                    }
                },
                resolve  : {
                    Breadcrumb: function (Dossier, $filter) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            'Expediente '+Dossier.code];
                    }
                },
                bodyClass: 'todo'
            })
            .state('app.dossiers.get.edit', {
                url      : 'edit',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/edit/dossier.html',
                        controller : 'DossierEditController as vm'
                    }
                },
                resolve  : {
                    Centers: function (centersService, Dossier) {
                        centersService.centers.filters={};
                        centersService.centers.filters.company=Dossier.seat_data.company;
                        // return centersService.getAllCenters();
                        return centersService.getCenters().then(function(res){
                            if(res.count>10){
                                return [];
                            }
                            return res.data;
                        });
                    },
                    Tutors: function (contactsService,Dossier) {
                        contactsService.contacts.filters={};
                        contactsService.contacts.filters.professional_tutor='True';
                        contactsService.contacts.filters.company=Dossier.seat_data.company;
                        // return contactsService.getAllContacts();
                        return contactsService.getContacts().then(function(res){
                            if(res.count>10){
                                return [];
                            }
                            return angular.copy(res.data);
                        });
                    },
                    ManagementContacts: function (contactsService,Dossier, Tutors) {
                        contactsService.contacts.filters={};
                        contactsService.contacts.filters.company_manager='True';
                        contactsService.contacts.filters.company=Dossier.seat_data.company;
                        // return contactsService.getAllContacts();
                        return contactsService.getContacts().then(function(res){
                            if(res.count>10){
                                return [];
                            }
                            return angular.copy(res.data);
                        });
                    },
                    Breadcrumb: function (Dossier, $filter) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            'Expediente '+Dossier.code];
                    },
                    Dossier: function (dossiersService,$stateParams) {
                        return dossiersService.getDossier($stateParams.dossier);
                    },
                },
                bodyClass: 'todo'
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .controller('DossierDocumentRequiredDialogController', DossierDocumentRequiredDialogController);

    /** @ngInject */
    function DossierDocumentRequiredDialogController($scope, $mdDialog, NotifyService, $timeout, Dossier, dossiersService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Documentación requerida');
        vm.dossier = Dossier;
        vm.documents={
            id:vm.dossier.id,
            iban_student:vm.dossier.iban_student,
            dni_student:vm.dossier.dni_student,
            ss_student:vm.dossier.ss_student,
            iban_student_number:vm.dossier.iban_student_number
        };

        vm.ngFlowOptionsIban={
            query:function(file){
                return {name:'IBAN',type:'iban_student'};
            }
        };

        vm.ngFlowOptionsDNI={
            query:function(file){
                return {name:'DNI',type:'dni_student'};
            }
        };

        vm.ngFlowOptionsSS={
            query:function(file){
                return {name:'Número de la seguridad social',type:'ss_student'};
            }
        };


        // Methods
        vm.saveDossierDocumentRequired = saveDossierDocumentRequired;
        vm.closeDialog = closeDialog;
        vm.fileError = fileError;
        vm.fileSuccessIban = fileSuccessIban;
        vm.fileSuccessDNI = fileSuccessDNI;
        vm.fileSuccessSS = fileSuccessSS;


        //////////
        /**
         * Guardar documentos
         */
        function saveDossierDocumentRequired() {
            return dossiersService.documents(angular.copy(vm.documents)).then(function(res){
                Dossier.iban_student=res.iban_student;
                Dossier.dni_student=res.dni_student;
                Dossier.ss_student=res.ss_student;
                Dossier.iban_student_number=res.iban_student_number;
                NotifyService.successMessage(gettextCatalog.getString("Documentación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la documentación") + (error.data.non_field_errors || ""));
            });
        }


        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /* Error al subir imagen */
        function fileError($file, $message, $flow) {
            $file.cancel();
            NotifyService.errorMessage(gettextCatalog.getString("Error al subir el archivo. "));
        }

        /* Iban subida con exito */
        function fileSuccessIban($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.iban_student=obj.id;
                vm.documents.iban_student_data=obj;
            }
        }

        /* DNI subida con exito */
        function fileSuccessDNI($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.dni_student=obj.id;
                vm.documents.dni_student_data=obj;
            }
        }

        /* SS subida con exito */
        function fileSuccessSS($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.ss_student=obj.id;
                vm.documents.ss_student_data=obj;
            }
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierQuotes',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        
        // State
        $stateProvider
            .state('app.dossiers.get.dossierQuotes', {
                url: 'quotes/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/dossierQuotes/dossierQuotes.html',
                        controller: 'DossierQuotesController as vm'
                    }
                },
                resolve: {
                    DossierQuotes: function (dossierQuotesService, Dossier) {
                        dossierQuotesService.dossierQuotes.filters={};
                        dossierQuotesService.dossierQuotes.filters.dossier=Dossier.id;
                        // return dossierQuotesService.getDossierQuotes();
                        return dossierQuotesService.getAllDossierQuotes();
                    },
                    Breadcrumb: function (Dossier) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Documentación'];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierQuotes')
        .controller('DossierQuotesDialogController', DossierQuotesDialogController);

    /** @ngInject */
    function DossierQuotesDialogController($scope, $mdDialog, DossierQuote,
                                           dossierQuotesService, NotifyService, $timeout, Dossier, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar cotización');

        if (!DossierQuote) {
            vm.title = gettextCatalog.getString('Nuevo documento');
            vm.dossierQuotes = dossierQuotesService.getEmptyDossierQuote(Dossier);
        } else {
            vm.dossierQuotes = angular.copy(DossierQuote); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveDossierQuotes = saveDossierQuotes;
        vm.closeDialog = closeDialog;

        /**
         * Guardar usuario
         */
        function saveDossierQuotes() {
            return dossierQuotesService.saveDossierQuotes(angular.copy(vm.dossierQuotes)).then(function () {
                NotifyService.successMessage(gettextCatalog.getString("Cotización guardado correctamente"));
                closeDialog();
            }, function (error) {
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el cotización. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierInterruptions',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.dossiers.get.dossierInterruptions', {
                url: 'interruptions/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/dossierInterruptions/dossierInterruptions.html',
                        controller: 'DossierInterruptionsController as vm'
                    }
                },
                resolve: {
                    DossierInterruptions: function (dossierInterruptionsService, Dossier) {
                        dossierInterruptionsService.dossierInterruptions.filters={};
                        dossierInterruptionsService.dossierInterruptions.filters.dossier=Dossier.id;
                        return dossierInterruptionsService.getDossierInterruptions();
                    },
                    Breadcrumb: function (Dossier, $filter) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Interrupciones'];
                    }
                },
                bodyClass: 'todo'
            });



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierInterruptions')
        .controller('DossierInterruptionDialogController', DossierInterruptionDialogController);

    /** @ngInject */
    function DossierInterruptionDialogController($mdDialog, DossierInterruption, Dossier, dossierInterruptionsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Solicitar interrupción');

        if (!DossierInterruption) {
            vm.title = gettextCatalog.getString('Solicitar interrupción');
            vm.dossierInterruption = dossierInterruptionsService.getEmptyDossierInterruption(Dossier);
        } else {
            vm.dossierInterruption = angular.copy(DossierInterruption); // Copiamos para no modificar el original hasta guardar
            vm.dossierInterruption.start_date= moment(vm.dossierInterruption.start_date).toDate();
            vm.dossierInterruption.end_date= moment(vm.dossierInterruption.end_date).toDate();
        }

        // Methods
        vm.saveDossierInterruption = saveDossierInterruption;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar dossierInterruptiono
         */
        function saveDossierInterruption() {
            return dossierInterruptionsService.saveDossierInterruption(angular.copy(vm.dossierInterruption)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Interrupción solicitada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar la interrupción. ") + (error.data.non_field_errors || error.data.dossier || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .controller('DossierDocumentRequiredDialogController', DossierDocumentRequiredDialogController);

    /** @ngInject */
    function DossierDocumentRequiredDialogController($scope, $mdDialog, NotifyService, $timeout, Dossier, dossiersService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Documentación requerida');
        vm.dossier = Dossier;
        vm.documents={
            id:vm.dossier.id,
            iban_student:vm.dossier.iban_student,
            dni_student:vm.dossier.dni_student,
            ss_student:vm.dossier.ss_student,
            iban_student_number:vm.dossier.iban_student_number
        };

        vm.ngFlowOptionsIban={
            query:function(file){
                return {name:'IBAN',type:'iban_student'};
            }
        };

        vm.ngFlowOptionsDNI={
            query:function(file){
                return {name:'DNI',type:'dni_student'};
            }
        };

        vm.ngFlowOptionsSS={
            query:function(file){
                return {name:'Número de la seguridad social',type:'ss_student'};
            }
        };


        // Methods
        vm.saveDossierDocumentRequired = saveDossierDocumentRequired;
        vm.closeDialog = closeDialog;
        vm.fileError = fileError;
        vm.fileSuccessIban = fileSuccessIban;
        vm.fileSuccessDNI = fileSuccessDNI;
        vm.fileSuccessSS = fileSuccessSS;


        //////////
        /**
         * Guardar documentos
         */
        function saveDossierDocumentRequired() {
            return dossiersService.documents(angular.copy(vm.documents)).then(function(res){
                Dossier.iban_student=res.iban_student;
                Dossier.dni_student=res.dni_student;
                Dossier.ss_student=res.ss_student;
                Dossier.iban_student_number=res.iban_student_number;
                NotifyService.successMessage(gettextCatalog.getString("Documentación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la documentación") + (error.data.non_field_errors || ""));
            });
        }


        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /* Error al subir imagen */
        function fileError($file, $message, $flow) {
            $file.cancel();
            NotifyService.errorMessage(gettextCatalog.getString("Error al subir el archivo. "));
        }

        /* Iban subida con exito */
        function fileSuccessIban($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.iban_student=obj.id;
                vm.documents.iban_student_data=obj;
            }
        }

        /* DNI subida con exito */
        function fileSuccessDNI($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.dni_student=obj.id;
                vm.documents.dni_student_data=obj;
            }
        }

        /* SS subida con exito */
        function fileSuccessSS($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.documents.ss_student=obj.id;
                vm.documents.ss_student_data=obj;
            }
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierDocuments',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        
        // State
        $stateProvider
            .state('app.dossiers.get.dossierDocuments', {
                url: 'documents/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/dossierDocuments/dossierDocuments.html',
                        controller: 'DossierDocumentsController as vm'
                    }
                },
                resolve: {
                    DossierDocuments: function (dossierDocumentsService, Dossier) {
                        dossierDocumentsService.dossierDocuments.filters={};
                        dossierDocumentsService.dossierDocuments.filters.id=Dossier.id;
                        return dossierDocumentsService.getDossierDocuments();
                    },
                    Breadcrumb: function (Dossier) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Documentación'];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierDocuments')
        .controller('DossierDocumentDialogController', DossierDocumentDialogController);

    /** @ngInject */
    function DossierDocumentDialogController($scope, $mdDialog, DossierDocument, dossierDocumentsService, NotifyService, $timeout, Dossier, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar documento');

        if (!DossierDocument) {
            vm.title = gettextCatalog.getString('Nuevo documento');
            vm.dossierDocument = dossierDocumentsService.getEmptyDossierDocument(Dossier);
        } else {
            vm.dossierDocument = angular.copy(DossierDocument); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveDossierDocument = saveDossierDocument;
        vm.closeDialog = closeDialog;
        vm.openFiles = openFiles;

        init();
        //////////

        function init(){
            $timeout(function(){
                $("#file-uploader").change(function(){
                    readURL(this);
                });
            });
        }

        /**
         * Guardar usuario
         */
        function saveDossierDocument() {
            return dossierDocumentsService.saveDossierDocument(angular.copy(vm.dossierDocument)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Documento guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el documento. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function openFiles(){
            $("#file-uploader").trigger("click");
        }

        /**
         * Image change
         * @param input
         */
        function readURL(input)
        {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    vm.dossierDocument.document = e.target.result;

                    if(!$scope.$$phase) {
                        $scope.$digest();
                    }
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierExtensions',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.dossiers.get.dossierExtensions', {
                url: 'extensions/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/dossiers/views/dossierExtensions/dossierExtensions.html',
                        controller: 'DossierExtensionsController as vm'
                    }
                },
                resolve: {
                    DossierExtensions: function (dossierExtensionsService, Dossier) {
                        dossierExtensionsService.dossierExtensions.filters={};
                        dossierExtensionsService.dossierExtensions.filters.dossier=Dossier.id;
                        return dossierExtensionsService.getDossierExtensions();
                    },
                    Breadcrumb: function (Dossier, $filter) {
                        return ['<a ui-sref="app.dossiers.list"> Expedientes</a>',
                            '<a ui-sref="app.dossiers.get.detail({dossier:'+Dossier.id+'})">Expediente '+Dossier.code+"</a>",
                            'Prórrogas'];
                    }
                },
                bodyClass: 'todo'
            });



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossierExtensions')
        .controller('DossierExtensionDialogController', DossierExtensionDialogController);

    /** @ngInject */
    function DossierExtensionDialogController($mdDialog, DossierExtension, Dossier, dossierExtensionsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar prórroga');

        if (!DossierExtension) {
            vm.title = gettextCatalog.getString('Solicitar prórroga');
            vm.dossierExtension = dossierExtensionsService.getEmptyDossierExtension(Dossier);
        } else {
            vm.dossierExtension = angular.copy(DossierExtension); // Copiamos para no modificar el original hasta guardar
        }

        // La fecha fin se introduce a mano: al editar, la que tiene guardada
        vm.endDate = DossierExtension && DossierExtension.end_date ? moment(DossierExtension.end_date).toDate() : null;
        // La prórroga empieza el día siguiente a la fecha fin del periodo normal (PRO-1); la tarjeta
        // relee el expediente antes de abrir el diálogo, así que la fecha ya viene actualizada
        setStartDate(Dossier);

        // Methods
        vm.saveDossierExtension = saveDossierExtension;
        vm.closeDialog = closeDialog;
        vm.updateDuration = updateDuration;
        vm.durationText = durationText;

        /**
         * Duración en días contando el último día = fecha fin − fecha inicio + 1 (la API la valida
         * con los límites de R2). Se envían la fecha fin y la duración.
         */
        function updateDuration(form) {
            vm.dossierExtension.end_date = vm.endDate;
            vm.dossierExtension.duration = vm.endDate ?
                moment(vm.endDate).startOf('day').diff(moment(vm.dossierExtension.start_date).startOf('day'), 'days') + 1 : 0;
            // Al corregir la fecha fin se limpia el error del servidor para poder reenviar
            if (form && form.end_date) {
                form.end_date.$setValidity('serverError', true);
            }
        }

        /**
         * «X meses y Y días» con el mes de 30 días de la prórroga
         */
        function durationText() {
            var duration = vm.dossierExtension.duration || 0;
            if (!vm.endDate || duration <= 0) {
                return "";
            }
            var months = Math.floor(duration / 30), days = duration % 30, parts = [];
            if (months) {
                parts.push(months === 1 ? "1 mes" : months + " meses");
            }
            if (days) {
                parts.push(days === 1 ? "1 día" : days + " días");
            }
            return parts.join(" y ");
        }

        /**
         * Inicio de la prórroga: día siguiente a la fecha fin del periodo normal del expediente
         */
        function setStartDate(dossier) {
            var normalEndDate = dossier.normal_end_date || dossier.end_date;
            if (!normalEndDate) {
                return;
            }
            vm.dossierExtension.start_date = moment(normalEndDate).add(1, 'days').toDate();
            // Al editar se conserva la duración guardada mientras no cambien el inicio ni la fecha fin (una
            // prórroga anterior, con fecha fin legada inicio + duración, no cambia solo por abrir el diálogo)
            if (!DossierExtension || !moment(vm.dossierExtension.start_date).isSame(DossierExtension.start_date, 'day')) {
                updateDuration();
            }
        }

        //////////
        /**
         * Guardar dossierExtensiono
         */
        function saveDossierExtension() {
            return dossierExtensionsService.saveDossierExtension(angular.copy(vm.dossierExtension)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Prórroga solicitada correctamente"));
                closeDialog();
            }, function(error){
                var errors = angular.copy(error.data || {});
                // La API valida la duración en días; el formulario la introduce como fecha fin
                if (errors.duration) {
                    errors.end_date = errors.duration;
                }
                vm.serverErrors = errors;
                NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar la prórroga. ") +
                    (errors.non_field_errors || errors.start_date || errors.duration || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pendingAssignments',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider
            .state('app.demands.get.pendingAssignments', {
                url: 'pendingAssignments/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/pendingAssignments/pendingAssignments.html',
                        controller: 'pendingAssignmentsController as vm'
                    }
                },
                resolve: {
                    Students: function (Demand) {
                        return Demand.subject_data.students;
                    },
                    OffersPostulates: function (offersPostulatesService, Demand) {
                        offersPostulatesService.offersPostulates.filters={};
                        offersPostulatesService.offersPostulates.filters.schedule__demand=Demand.id;
                        offersPostulatesService.offersPostulates.filters.offer_requests='noempty';
                        offersPostulatesService.offersPostulates.filters.page="all";
                        return offersPostulatesService.getOffersPostulates();
                    },
                    SubjectsTeachers: function (subjectsService, Demand) {
                        return subjectsService.getSubjectsTeachers(Demand.subject);
                    },
                    Breadcrumb: function (Demand) {
                        return ['<a ui-sref="app.demands.list"> Ofertas curriculares</a>',
                            '<a ui-sref="app.demands.get.detail({demand:'+Demand.id+'})">Oferta '+Demand.code+'</a>',
                            'Asignaciones pendientes'];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pendingAssignments')
        .controller('pendingAssignmentDialogController', pendingAssignmentDialogController);

    /** @ngInject */
    function pendingAssignmentDialogController($mdDialog, Student, OffersPostulates, demandsRequestsService, NotifyService,
                                               SubjectsTeachers, Orders, demandsSchedulesService, gettextCatalog) {
        var vm = this;

        // Data
        var student=Student.identification+" - "+(Student.name || "")+" "+(Student.surname || "")+" "+(Student.second_surname || "");
        vm.title = gettextCatalog.getString('Asignar plaza a '+student);
        vm.workingdays=demandsSchedulesService.getTypes();
        vm.subjectsTeachers=SubjectsTeachers;

        if(!Student.offer_data){
            //Es una creación
            vm.pendingAssignment = {
                identification:Student.identification,
                company:-1 //le ponemos -1 para forzar a cambiar este campo
            };
        }else{
            //Es una edición
            vm.pendingAssignment = {
                id:Student.offer_data.request_offer_data.id,
                identification:Student.identification,
                offer:Student.offer_data.id,
                academic_tutor:Student.offer_data.request_offer_data.academic_tutor
            };
        }

        vm.companies=[];
        vm.offers=[];
        vm.orders=Orders;

        init();


        // Methods
        vm.savependingAssignment = savependingAssignment;
        vm.closeDialog = closeDialog;
        vm.getSelectedOffer = getSelectedOffer;

        //////////

        /**
         * Oferta (plaza) seleccionada en el desplegable de fecha de inicio
         */
        function getSelectedOffer(){
            var offers = vm.offers[vm.pendingAssignment.company] || [];
            for(var i in offers){
                if(offers[i].id === vm.pendingAssignment.offer){
                    return offers[i];
                }
            }
            return null;
        }

        function init(){
            var companies={};
            var offers={};

            //creamos el array de empresas
            for(var i in OffersPostulates.data){
                var keyCompany='E'+OffersPostulates.data[i].seat_data.company+'C'+OffersPostulates.data[i].seat_data.id;
                if(!OffersPostulates.data[i].request_offer_data.id || (Student.offer_data && Student.offer_data.id===OffersPostulates.data[i].id)) {
                    if(!companies[keyCompany]){
                        var o={}; //formamos un objeto empresa
                        o.id=OffersPostulates.data[i].seat_data.company;
                        o.business_name=OffersPostulates.data[i].seat_data.company_name;
                        o.seat_data=OffersPostulates.data[i].seat_data;
                        companies[keyCompany]=o;
                        companies[keyCompany].students=0;
                    }
                }
            }

            //De las empresas que tengamos en nuestro array le incluimos los alumnos inscritos
            for(var i in OffersPostulates.data){
                var keyCompanyByNumOffers='E'+OffersPostulates.data[i].seat_data.company+'C'+OffersPostulates.data[i].seat_data.id;
                if(OffersPostulates.data[i].request_offer_data.id){
                    if(companies[keyCompanyByNumOffers]){
                        companies[keyCompanyByNumOffers].students++;
                    }
                }
            }

            //creamos el array de ofertas
            for(var i in OffersPostulates.data){
                var keyCenter='E'+OffersPostulates.data[i].seat_data.company+'C'+OffersPostulates.data[i].seat_data.id;
                if(!OffersPostulates.data[i].request_offer_data.id || (Student.offer_data && Student.offer_data.id===OffersPostulates.data[i].id)) {
                    if (!offers[keyCenter]) {
                        offers[keyCenter] = [];
                    }
                    var obj = {
                        id: OffersPostulates.data[i].id,
                        start_date: OffersPostulates.data[i].start_date,
                        schedule_data: OffersPostulates.data[i].schedule_data,
                        seat_data: OffersPostulates.data[i].seat_data,
                        demand_profile_name: OffersPostulates.data[i].demand_profile_name,
                        professional_tutor_data: OffersPostulates.data[i].professional_tutor_data
                    };
                    offers[keyCenter].push(obj);
                }
            }

            //Para luego poder ordenar los pasamos a un array normal
            for(var i in companies){
                vm.companies.push(companies[i]);
            }
            for(var i in offers){
                vm.offers.push(offers[i]);
            }
            //Preseleccionamos la empresa si fuese necesario
            if(Student.offer_data) {
                for (var i in vm.companies){
                    if(Student.offer_data.seat_data.id===vm.companies[i].seat_data.id){
                        vm.pendingAssignment.company=i;
                    }
                }
            }
        }

        /**
         * Guardar pendingAssignmento
         */
        function savependingAssignment() {
            return demandsRequestsService.saveDemandsRequest(angular.copy(vm.pendingAssignment)).then(function(response){
                Student.offer_data=angular.copy(response.offer_data);
                Student.offer_data.demand_profile_name=angular.copy(response.demand_profile_data.name);
                Student.offer_data.request_offer_data=angular.copy(response);
                NotifyService.successMessage(gettextCatalog.getString("Plaza asignada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al asignar la plaza. ") + (error.data.non_field_errors || "") + (error.data.student || ""));
            });
        }
        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersPostulates',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider
            .state('app.demands.get.offersPostulates', {
                url: 'offersPostulates/?company',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/offersPostulates/offersPostulates.html',
                        controller: 'OffersPostulatesController as vm'
                    }
                },
                resolve: {
                    DemandsSchedules: function (demandsSchedulesService,$stateParams) {
                        demandsSchedulesService.demandsSchedules.filters={};
                        demandsSchedulesService.demandsSchedules.filters.page="all";
                        demandsSchedulesService.demandsSchedules.filters.demand=$stateParams.demand;
                        return demandsSchedulesService.getDemandsSchedules();
                    },
                    DemandsProfiles: function (demandsProfilesService,$stateParams) {
                        demandsProfilesService.demandsProfiles.filters={};
                        demandsProfilesService.demandsProfiles.filters.page="all";
                        demandsProfilesService.demandsProfiles.filters.demand=$stateParams.demand;
                        return demandsProfilesService.getDemandsProfiles();
                    },
                    OffersPostulates: function (DemandsSchedules, offersPostulatesService, $stateParams) {
                        var f=[];
                        for(var i in DemandsSchedules.data){
                            f.push(DemandsSchedules.data[i].id);
                        }
                        offersPostulatesService.offersPostulates.filters={};
                        offersPostulatesService.offersPostulates.filters.schedule__in=f.join();
                        offersPostulatesService.offersPostulates.filters.seat__company=$stateParams.company;
                        offersPostulatesService.offersPostulates.filters.page="all";
                        return offersPostulatesService.getOffersPostulates();
                    },
                    Tutors: function (contactsService, $stateParams) {
                        contactsService.contacts.filters={};
                        contactsService.contacts.filters.professional_tutor='True';
                        contactsService.contacts.filters.company=$stateParams.company;
                        return contactsService.getAllContacts();
                    },
                    Centers: function (centersService, $stateParams) {
                        centersService.centers.filters={};
                        centersService.centers.filters.company=$stateParams.company;
                        return centersService.getAllCenters();
                    },
                    Breadcrumb: function (Demand) {
                        return ['<a ui-sref="app.demands.list"> Ofertas curriculares</a>',
                            '<a ui-sref="app.demands.get.detail({demand:'+Demand.id+'})">Oferta '+Demand.code+'</a>',
                            'Mis plazas'];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersPostulates')
        .controller('OffersPostulateDialogController', OffersPostulateDialogController);

    /** @ngInject */
    function OffersPostulateDialogController($mdDialog, Tutors, DemandSchedule, demandsSchedulesService, DemandsProfiles, offersPostulatesService,
                                             NotifyService, Centers, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Añadir plazas');
        vm.offersPostulate = offersPostulatesService.getEmptyOffersPostulate(DemandSchedule);
        vm.offersPostulate.start_date = null;
        vm.tutors=Tutors;
        vm.demandsProfiles=DemandsProfiles;
        vm.demands=DemandSchedule;
        vm.workingdays=demandsSchedulesService.getTypes();
        vm.centers=Centers;

        // Methods
        vm.saveOffersPostulate = saveOffersPostulate;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar offersPostulateo
         */
        function saveOffersPostulate() {
            return offersPostulatesService.saveOffersPostulate(angular.copy(vm.offersPostulate)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Plazas añadidas correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al añadir plazas. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersPostulates')
        .controller('OffersCurricularDialogController', OffersCurricularDialogController);

    /** @ngInject */
    function OffersCurricularDialogController($mdDialog, Tutors, OffersCurricular, offersPostulatesService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar plaza');
        vm.offersCurricular = angular.copy(OffersCurricular);
        vm.offersCurricular.start_date=moment(vm.offersCurricular.start_date).toDate();
        vm.tutors=Tutors;

        // Methods
        vm.saveOffersCurricular = saveOffersCurricular;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar offersCurricularo
         */
        function saveOffersCurricular() {
            return offersPostulatesService.saveOffersCurricular(angular.copy(vm.offersCurricular)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Plaza editada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al editar plaza. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .factory('questionsService', questionsService);

    /** @ngInject */
    function questionsService($q, api, gettextCatalog) {

        var service = {
            questions: {
                data: [],
                count: 0,
                filters: {}
            },
            getQuestions: getQuestions,
            getAllQuestions: getAllQuestions,
            getQuestion: getQuestion,
            saveQuestion: saveQuestion,
            getEmptyQuestion: getEmptyQuestion,
            removeQuestion: removeQuestion,
            typeQuestions: typeQuestions
        };

        return service;

        //////////

        /**
         * Obtiene el listado de questions
         */
        function getQuestions() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questions.get(service.questions.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.questions.data = response.results;
                service.questions.count = response.count;

                deferred.resolve(service.questions);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.questions.filters.page!=1){
                    service.questions.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de questions filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllQuestions(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.questions.filters);
            f.search=search;
            f.page="all";
            api.questions.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una question determinado por su ID
         *
         * @param id
         */
        function getQuestion(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questions.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la question que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveQuestion(form) {
            var deferred = $q.defer();

            var question = angular.copy(form);

            if (form.id) {
                api.questions.update(question, updateOK, saveKO);
            } else {
                api.questions.create(question, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.questions.data.push(response);
                service.questions.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getQuestions();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un cuestionario vacío
         */
        function getEmptyQuestion(Questionnaire) {
            return {
                "questionnaire": Questionnaire.id
            };
        }
        
        function removeQuestion(question){
            var deferred = $q.defer();

            api.questions.remove({id: question.id}, questionRemoveOK, removeKO);

            // Cuestionario borrado correctamente
            function questionRemoveOK(response){
                // Quitamos la question en los datos locales
                for (var i = 0; i < service.questions.data.length; i++) {
                    if (service.questions.data[i].id === question.id) {
                        service.questions.data.splice(i,1);
                        service.questions.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar cuestionario
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Tipos de preguntas
         *
         */
        function typeQuestions() {
            return [
                {
                    id:"text",
                    value:gettextCatalog.getString("Texto")
                },
                {
                    id:"options",
                    value:gettextCatalog.getString("Lista de opciones")
                },
                {
                    id:"assessment",
                    value:gettextCatalog.getString("Valoración")
                }
            ];

        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.questions')
        .factory('questionOptionsService', questionOptionsService);

    /** @ngInject */
    function questionOptionsService($q, api) {

        var service = {
            questionOptions: {
                data: [],
                count: 0,
                filters: {
                    page:"all"
                }
            },
            getQuestionOptions: getQuestionOptions,
            getQuestionOption: getQuestionOption,
            saveQuestionOption: saveQuestionOption,
            removeQuestionOption: removeQuestionOption,
            getEmptyQuestionOption: getEmptyQuestionOption
        };

        return service;

        //////////

        /**
         * Obtiene el listado de usuarios
         */
        function getQuestionOptions() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questionOptions.get(service.questionOptions.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                // Store the questionOptions
                service.questionOptions.data = response.results;
                service.questionOptions.count = response.count;

                deferred.resolve(service.questionOptions);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de un usuario determinado por su ID
         *
         * @param id
         */
        function getQuestionOption(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questionOptions.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda el questionOption que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param questionOption
         */
        function saveQuestionOption(questionOption) {
            var deferred = $q.defer();

            if (questionOption.id) {
                api.questionOptions.update(questionOption, updateOK, saveKO);
            } else {
                api.questionOptions.create(questionOption, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.questionOptions.data.push(response);
                service.questionOptions.count += 1;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.questionOptions.data.length; i++) {
                    if (service.questionOptions.data[i].id === response.id) {
                        service.questionOptions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        function removeQuestionOption(questionOption){
            var deferred = $q.defer();

           api.questionOptions.remove({id: questionOption.id}, questionOptionRemoveOK, removeKO);

            // QuestionOption borrada correctamente
            function questionOptionRemoveOK(response){
                // Quitamos la questionOption en los datos locales
                for (var i = 0; i < service.questionOptions.data.length; i++) {
                    if (service.questionOptions.data[i].id === questionOption.id) {
                        service.questionOptions.data.splice(i,1);
                        service.questionOptions.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar questionOptiones o usuarios
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Devuelve un questionOption vacío
         */
        function getEmptyQuestionOption(questionOption) {
            return {
                "question": questionOption
            };
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.answers')
        .factory('answersService', answersService);

    /** @ngInject */
    function answersService($q, api, gettextCatalog) {

        var service = {
            answers: {
                data: [],
                count: 0,
                filters: {}
            },
            getAnswers: getAnswers,
            getAllAnswers: getAllAnswers,
            getAnswer: getAnswer,
            saveAnswer: saveAnswer,
            getEmptyAnswer: getEmptyAnswer,
            removeAnswer: removeAnswer,
            typeAnswers: typeAnswers
        };

        return service;

        //////////

        /**
         * Obtiene el listado de answers
         */
        function getAnswers() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.answers.get(service.answers.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.answers.data = response.results;
                service.answers.count = response.count;

                deferred.resolve(service.answers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.answers.filters.page!=1){
                    service.answers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de answers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllAnswers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.answers.filters);
            f.search=search;
            f.page="all";
            api.answers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una answer determinado por su ID
         *
         * @param id
         */
        function getAnswer(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.answers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la answer que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveAnswer(form) {
            var deferred = $q.defer();

            var answer = angular.copy(form);

            if (form.id) {
                api.answers.update(answer, updateOK, saveKO);
            } else {
                api.answers.create(answer, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.answers.data.push(response);
                service.answers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.answers.data.length; i++) {
                    if (service.answers.data[i].id === response.id) {
                        service.answers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un cuestionario vacío
         */
        function getEmptyAnswer(Evaluation, Question) {
            return {
                "evaluation": Evaluation.id,
                "question": Question.id
            };
        }
        
        function removeAnswer(answer){
            var deferred = $q.defer();

            api.answers.remove({id: answer.id}, answerRemoveOK, removeKO);

            // Cuestionario borrado correctamente
            function answerRemoveOK(response){
                // Quitamos la answer en los datos locales
                for (var i = 0; i < service.answers.data.length; i++) {
                    if (service.answers.data[i].id === answer.id) {
                        service.answers.data.splice(i,1);
                        service.answers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar cuestionario
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Tipos de preguntas
         *
         */
        function typeAnswers() {
            return [
                {
                    id:"text",
                    value:gettextCatalog.getString("Texto")
                },
                {
                    id:"options",
                    value:gettextCatalog.getString("Lista de opciones")
                },
                {
                    id:"assessment",
                    value:gettextCatalog.getString("Valoración")
                }
            ];

        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossierResignations')
        .factory('dossierResignationsService', dossierResignationsService);

    /** @ngInject */
    function dossierResignationsService($q, api, gettextCatalog) {

        var service = {
            dossierResignations: {
                data: [],
                count: 0,
                filters: {}
            },
            getDossierResignations: getDossierResignations,
            getAllDossierResignations: getAllDossierResignations,
            getDossierResignation: getDossierResignation,
            saveDossierResignation: saveDossierResignation,
            getEmptyDossierResignation: getEmptyDossierResignation,
            removeDossierResignation: removeDossierResignation,
            acceptResignation: acceptResignation,
            rejectResignation: rejectResignation
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossierResignations
         */
        function getDossierResignations() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierResignations.get(service.dossierResignations.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierResignations.data = response.results;
                service.dossierResignations.count = response.count;

                deferred.resolve(service.dossierResignations);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.dossierResignations.filters.page!=1){
                    service.dossierResignations.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossierResignations filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossierResignations(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.dossierResignations.filters);
            f.search=search;
            f.page="all";
            api.dossierResignations.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una dossierResignation determinado por su ID
         *
         * @param id
         */
        function getDossierResignation(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierResignations.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossierResignation que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossierResignation(form) {
            var deferred = $q.defer();

            var dossierResignation = angular.copy(form);
            dossierResignation.start_date= moment(dossierResignation.start_date).format("YYYY-MM-DD");
            dossierResignation.end_date= moment(dossierResignation.end_date).format("YYYY-MM-DD");
            if (dossierResignation.effective_end_date) {
                dossierResignation.effective_end_date = moment(dossierResignation.effective_end_date).format("YYYY-MM-DD");
            }

            if (form.id) {
                api.dossierResignations.update(dossierResignation, updateOK, saveKO);
            } else {
                api.dossierResignations.create(dossierResignation, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossierResignations.data.push(response);
                service.dossierResignations.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierResignations.data.length; i++) {
                    if (service.dossierResignations.data[i].id === response.id) {
                        service.dossierResignations.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }
        
        /**
         * Aceptación de una interrupcion
         *
         * @param dossierResignation
         */
        function acceptResignation(dossierResignation) {
            var deferred = $q.defer();

            var payload = {id:dossierResignation.id,resolution:dossierResignation.resolution};
            if (dossierResignation.effective_end_date) {
                payload.effective_end_date = moment(dossierResignation.effective_end_date).format("YYYY-MM-DD");
            }
            api.dossierResignations.accept(payload, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierResignations.data.length; i++) {
                    if (service.dossierResignations.data[i].id === response.id) {
                        service.dossierResignations.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Rechazo de una interrupcion
         *
         * @param dossierResignation
         */
        function rejectResignation(dossierResignation) {
            var deferred = $q.defer();

            api.dossierResignations.reject({id:dossierResignation.id,resolution:dossierResignation.resolution}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actualiza el listado
                for (var i = 0; i < service.dossierResignations.data.length; i++) {
                    if (service.dossierResignations.data[i].id === response.id) {
                        service.dossierResignations.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un dossierResignation vacío
         */
        function getEmptyDossierResignation(Dossier) {
            return {
                "dossier": Dossier.id
            };
        }
        
        function removeDossierResignation(dossierResignation){
            var deferred = $q.defer();

            api.dossierResignations.remove({id: dossierResignation.id}, dossierResignationRemoveOK, removeKO);

            // dossierResignation borrado correctamente
            function dossierResignationRemoveOK(response){
                // Quitamos la dossierResignation en los datos locales
                for (var i = 0; i < service.dossierResignations.data.length; i++) {
                    if (service.dossierResignations.data[i].id === dossierResignation.id) {
                        service.dossierResignations.data.splice(i,1);
                        service.dossierResignations.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar dossierResignation
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossierQuotes')
        .factory('dossierQuotesService', dossierQuotesService);

    /** @ngInject */
    function dossierQuotesService($q, api, $http, gettextCatalog) {

        var service = {
            dossierQuotes: {
                data: [],
                count: 0,
                filters: {}
            },
            getDossierQuotes: getDossierQuotes,
            getAllDossierQuotes: getAllDossierQuotes,
            getDossierQuote: getDossierQuote,
            saveDossierQuotes: saveDossierQuote,
            getEmptyDossierQuote: getEmptyDossierQuote,
            changePermission: changePermission
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossierQuotes
         */
        function getDossierQuotes() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierQuotes.queryAll(service.dossierQuotes.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierQuotes.data = response;
                service.dossierQuotes.count = response.length;

                deferred.resolve(service.dossierQuotes);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if (response.status === 404 && service.dossierQuotes.filters.page !== 1) {
                    service.dossierQuotes.filters.page = 1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossierQuotes filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossierQuotes(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f = angular.copy(service.dossierQuotes.filters);
            f.search = search;
            f.page = "all";
            api.dossierQuotes.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierQuotes.data = response.results;
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Descarga un dossierQuoteo
         *
         * @param id
         */
        function getDossierQuote(id) {
            var deferred = $q.defer();

            $http.get(api.baseUrl + 'dossierQuotes/' + id + '/download/', {responseType: 'arraybuffer'}).then(getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossierQuote que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossierQuote(form) {
            var deferred = $q.defer();


            var dossierQuote = angular.copy(form);


            if (form.id) {
                api.dossierQuotesSave.update({id: form.id}, dossierQuote, updateOK, saveKO);
            } else {
                api.dossierQuotesSave.create(dossierQuote, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossierQuotes.data.push(response);
                service.dossierQuotes.count++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierQuotes.data.length; i++) {
                    if (service.dossierQuotes.data[i].id === response.id) {
                        service.dossierQuotes.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Devuelve un dossierQuote vacío
         */
        function getEmptyDossierQuote(dossier) {
            return {
                dossier: dossier.id
            };
        }


        /**
         * Guarda la quote que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function changePermission(form) {
            var deferred = $q.defer();

            api.dossierQuotes.changePermission(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierQuotes.data.length; i++) {
                    if (service.dossierQuotes.data[i].id === response.id) {
                        service.dossierQuotes.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();



(function () {
    'use strict';

    angular
        .module('app.dossierInterruptions')
        .factory('dossierInterruptionsService', dossierInterruptionsService);

    /** @ngInject */
    function dossierInterruptionsService($q, api, gettextCatalog) {

        var service = {
            dossierInterruptions: {
                data: [],
                count: 0,
                filters: {}
            },
            getDossierInterruptions: getDossierInterruptions,
            getAllDossierInterruptions: getAllDossierInterruptions,
            getDossierInterruption: getDossierInterruption,
            saveDossierInterruption: saveDossierInterruption,
            getEmptyDossierInterruption: getEmptyDossierInterruption,
            removeDossierInterruption: removeDossierInterruption,
            acceptInterrumption: acceptInterrumption,
            rejectInterrumption: rejectInterrumption
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossierInterruptions
         */
        function getDossierInterruptions() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierInterruptions.get(service.dossierInterruptions.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierInterruptions.data = response.results;
                service.dossierInterruptions.count = response.count;

                deferred.resolve(service.dossierInterruptions);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.dossierInterruptions.filters.page!=1){
                    service.dossierInterruptions.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossierInterruptions filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossierInterruptions(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.dossierInterruptions.filters);
            f.search=search;
            f.page="all";
            api.dossierInterruptions.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una dossierInterruption determinado por su ID
         *
         * @param id
         */
        function getDossierInterruption(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierInterruptions.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossierInterruption que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossierInterruption(form) {
            var deferred = $q.defer();

            var dossierInterruption = angular.copy(form);
            dossierInterruption.start_date= moment(dossierInterruption.start_date).format("YYYY-MM-DD");
            dossierInterruption.end_date= moment(dossierInterruption.end_date).format("YYYY-MM-DD");

            if (form.id) {
                api.dossierInterruptions.update(dossierInterruption, updateOK, saveKO);
            } else {
                api.dossierInterruptions.create(dossierInterruption, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossierInterruptions.data.push(response);
                service.dossierInterruptions.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierInterruptions.data.length; i++) {
                    if (service.dossierInterruptions.data[i].id === response.id) {
                        service.dossierInterruptions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Aceptación de una interrupcion
         *
         * @param dossierInterruption
         */
        function acceptInterrumption(dossierInterruption) {
            var deferred = $q.defer();

            api.dossierInterruptions.accept({id:dossierInterruption.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierInterruptions.data.length; i++) {
                    if (service.dossierInterruptions.data[i].id === response.id) {
                        service.dossierInterruptions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Rechazo de una interrupcion
         *
         * @param dossierInterruption
         */
        function rejectInterrumption(dossierInterruption) {
            var deferred = $q.defer();

            api.dossierInterruptions.reject({id:dossierInterruption.id,rejected_message:dossierInterruption.rejected_message}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actualiza el listado
                for (var i = 0; i < service.dossierInterruptions.data.length; i++) {
                    if (service.dossierInterruptions.data[i].id === response.id) {
                        service.dossierInterruptions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un dossierInterruption vacío
         */
        function getEmptyDossierInterruption(Dossier) {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "dossier": Dossier.id
            };
        }
        
        function removeDossierInterruption(dossierInterruption){
            var deferred = $q.defer();

            api.dossierInterruptions.remove({id: dossierInterruption.id}, dossierInterruptionRemoveOK, removeKO);

            // dossierInterruption borrado correctamente
            function dossierInterruptionRemoveOK(response){
                // Quitamos la dossierInterruption en los datos locales
                for (var i = 0; i < service.dossierInterruptions.data.length; i++) {
                    if (service.dossierInterruptions.data[i].id === dossierInterruption.id) {
                        service.dossierInterruptions.data.splice(i,1);
                        service.dossierInterruptions.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar dossierInterruption
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossierExtensions')
        .factory('dossierExtensionsService', dossierExtensionsService);

    /** @ngInject */
    function dossierExtensionsService($q, api, gettextCatalog) {

        var service = {
            dossierExtensions: {
                data: [],
                count: 0,
                filters: {}
            },
            getDossierExtensions: getDossierExtensions,
            getAllDossierExtensions: getAllDossierExtensions,
            getDossierExtension: getDossierExtension,
            saveDossierExtension: saveDossierExtension,
            getEmptyDossierExtension: getEmptyDossierExtension,
            removeDossierExtension: removeDossierExtension,
            acceptExtension: acceptExtension,
            sendAdjudicationResolution: sendAdjudicationResolution,
            rejectExtension: rejectExtension,
            getCofinancingCalculate: getCofinancingCalculate
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossierExtensions
         */
        function getDossierExtensions() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierExtensions.get(service.dossierExtensions.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierExtensions.data = response.results;
                service.dossierExtensions.count = response.count;

                deferred.resolve(service.dossierExtensions);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.dossierExtensions.filters.page!=1){
                    service.dossierExtensions.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossierExtensions filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossierExtensions(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.dossierExtensions.filters);
            f.search=search;
            f.page="all";
            api.dossierExtensions.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una dossierExtension determinado por su ID
         *
         * @param id
         */
        function getDossierExtension(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierExtensions.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossierExtension que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossierExtension(form) {
            var deferred = $q.defer();

            var dossierExtension = angular.copy(form);
            dossierExtension.start_date= moment(dossierExtension.start_date).format("YYYY-MM-DD");
            if (dossierExtension.end_date) {
                dossierExtension.end_date = moment(dossierExtension.end_date).format("YYYY-MM-DD");
            }

            if (form.id) {
                api.dossierExtensions.update(dossierExtension, updateOK, saveKO);
            } else {
                api.dossierExtensions.create(dossierExtension, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossierExtensions.data.push(response);
                service.dossierExtensions.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierExtensions.data.length; i++) {
                    if (service.dossierExtensions.data[i].id === response.id) {
                        service.dossierExtensions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un dossierExtension vacío
         */
        function getEmptyDossierExtension(Dossier) {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "duration": 0,
                "dossier": Dossier.id
            };
        }
        
        function removeDossierExtension(dossierExtension){
            var deferred = $q.defer();

            api.dossierExtensions.remove({id: dossierExtension.id}, dossierExtensionRemoveOK, removeKO);

            // dossierExtension borrado correctamente
            function dossierExtensionRemoveOK(response){
                // Quitamos la dossierExtension en los datos locales
                for (var i = 0; i < service.dossierExtensions.data.length; i++) {
                    if (service.dossierExtensions.data[i].id === dossierExtension.id) {
                        service.dossierExtensions.data.splice(i,1);
                        service.dossierExtensions.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar dossierExtension
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }
        
        /**
         * Aceptación de una prorroga
         *
         * @param dossierExtension
         */
        /**
         * Envía a firma la resolución de adjudicación de una prórroga concedida (administración)
         */
        function sendAdjudicationResolution(dossierExtension) {
            var deferred = $q.defer();

            api.dossierExtensions.sendAdjudicationResolution({id:dossierExtension.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                for (var i = 0; i < service.dossierExtensions.data.length; i++) {
                    if (service.dossierExtensions.data[i].id === response.id) {
                        service.dossierExtensions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

        function acceptExtension(dossierExtension) {
            var deferred = $q.defer();

            api.dossierExtensions.accept({id:dossierExtension.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierExtensions.data.length; i++) {
                    if (service.dossierExtensions.data[i].id === response.id) {
                        service.dossierExtensions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Rechazo de una prorroga
         *
         * @param dossierExtension
         */
        function rejectExtension(dossierExtension) {
            var deferred = $q.defer();

            api.dossierExtensions.reject({id:dossierExtension.id,rejected_message:dossierExtension.rejected_message}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actualiza el listado
                for (var i = 0; i < service.dossierExtensions.data.length; i++) {
                    if (service.dossierExtensions.data[i].id === response.id) {
                        service.dossierExtensions.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Cálculo de remuneración que aporta la empresa y remuneración que aporta la cofinanciación
         */
        function getCofinancingCalculate(params) {
            var deferred = $q.defer();
            api.dossierExtensions.cofinancingCalculate(params, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossierDocuments')
        .factory('dossierDocumentsService', dossierDocumentsService);

    /** @ngInject */
    function dossierDocumentsService($q, api, $http, gettextCatalog) {

        var service = {
            dossierDocuments: {
                data: [],
                count: 0,
                filters: {}
            },
            getDossierDocuments: getDossierDocuments,
            getAllDossierDocuments: getAllDossierDocuments,
            getDossierDocument: getDossierDocument,
            saveDossierDocument: saveDossierDocument,
            getEmptyDossierDocument: getEmptyDossierDocument,
            removeDossierDocument: removeDossierDocument,
            changePermission: changePermission
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossierDocuments
         */
        function getDossierDocuments() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossierDocuments.queryAll(service.dossierDocuments.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossierDocuments.data = response;
                service.dossierDocuments.count = response.length;

                deferred.resolve(service.dossierDocuments);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.dossierDocuments.filters.page!=1){
                    service.dossierDocuments.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossierDocuments filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossierDocuments(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.dossierDocuments.filters);
            f.search=search;
            f.page="all";
            api.dossierDocuments.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Descarga un dossierDocumento
         *
         * @param id
         */
        function getDossierDocument(id) {
            var deferred = $q.defer();

            $http.get(api.baseUrl + 'dossierDocuments/'+id+'/download/', {responseType:'arraybuffer'}).then(getOK, getKO);

            return deferred.promise;

            function getOK(response){
                deferred.resolve(response.data);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossierDocument que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossierDocument(form) {
            var deferred = $q.defer();

            // Preparamos la filen para la subida al servidor
            // Comprobamos si existe en file.element y de forma directa ya
            // que parece que en ios no lo encuentra bien con el file.element.
            var file_data = null;
            var $fileUploader = $("#file-uploader");
            var files = $fileUploader.prop('files');

            if (files && files.length) {
                file_data = files[0];
            }

            if (file_data){
                form.document = file_data;
            }else{
                delete form.document;
            }
            delete form.user;

            //Convertimos los datos aun FormData para poder enviar el archivo
            var formData = new FormData();
            angular.forEach(form, function(value, key){
                if(Array.isArray(value) && value.length){
                    angular.forEach(value, function(v, k){
                        formData.append(key, v);
                    });
                }else{
                    formData.append(key, value);
                }
            });

            if (form.id) {
                api.documents.update({id: form.id}, formData, updateOK, saveKO);
            } else {
                api.documents.create(formData, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossierDocuments.data.push(response);
                service.dossierDocuments.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierDocuments.data.length; i++) {
                    if (service.dossierDocuments.data[i].id === response.id) {
                        service.dossierDocuments.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un dossierDocument vacío
         */
        function getEmptyDossierDocument(dossier) {
            return {
                dossier:dossier.id
            };
        }

        function removeDossierDocument(dossierDocument){
            var deferred = $q.defer();

            api.documents.remove({id: dossierDocument.id}, dossierDocumentRemoveOK, removeKO);

            // dossierDocument borrado correctamente
            function dossierDocumentRemoveOK(response){
                // Quitamos la dossierDocument en los datos locales
                for (var i = 0; i < service.dossierDocuments.data.length; i++) {
                    if (service.dossierDocuments.data[i].id === dossierDocument.id) {
                        service.dossierDocuments.data.splice(i,1);
                        service.dossierDocuments.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar dossierDocument
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Guarda la document que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function changePermission(form) {
            var deferred = $q.defer();

            api.documents.changePermission(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossierDocuments.data.length; i++) {
                    if (service.dossierDocuments.data[i].id === response.id) {
                        service.dossierDocuments.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();



(function () {
    'use strict';

    angular
        .module('app.pendingAssignments')
        .factory('demandsRequestsService', demandsRequestsService);

    /** @ngInject */
    function demandsRequestsService($q, api, gettextCatalog) {

        var service = {
            demandsRequests: {
                data: [],
                count: 0,
                filters: {}
            },
            getDemandsRequests: getDemandsRequests,
            getAllDemandsRequests: getAllDemandsRequests,
            getDemandsRequest: getDemandsRequest,
            saveDemandsRequest: saveDemandsRequest,
            createDossier: createDossier,
            createDossiers: createDossiers,
            getEmptyDemandsRequest: getEmptyDemandsRequest,
            removeDemandsRequest: removeDemandsRequest
        };

        return service;

        //////////

        /**
         * Obtiene el listado de demandsRequests
         */
        function getDemandsRequests() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsRequests.get(service.demandsRequests.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.demandsRequests.data = response.results;
                service.demandsRequests.count = response.count;

                deferred.resolve(service.demandsRequests);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.demandsRequests.filters.page!=1){
                    service.demandsRequests.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de demandsRequests filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDemandsRequests(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.demandsRequests.filters);
            f.search=search;
            f.page="all";
            api.demandsRequests.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una demandsRequest determinado por su ID
         *
         * @param id
         */
        function getDemandsRequest(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsRequests.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la demandsRequest que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDemandsRequest(form) {
            var deferred = $q.defer();

            var demandsRequest = angular.copy(form);

            if (form.id) {
                api.demandsRequests.update(demandsRequest, updateOK, saveKO);
            } else {
                api.demandsRequests.create(demandsRequest, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.demandsRequests.data.push(response);
                service.demandsRequests.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demandsRequests.data.length; i++) {
                    if (service.demandsRequests.data[i].id === response.id) {
                        service.demandsRequests.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Crea el expediente de una oferta
         *
         * @param form
         */
        function createDossier( form) {
            var deferred = $q.defer();

            api.demandsRequests.createDossier({id:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Crea los expedientes de una oferta
         *
         * @param form
         */
        function createDossiers(form) {
            var deferred = $q.defer();

            api.demandsRequests.createDossiers({demand:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un objeto vacío
         */
        function getEmptyDemandsRequest(demand) {
            return {
                "demand": demand
            };
        }
        
        function removeDemandsRequest(demandsRequest){
            var deferred = $q.defer();

            api.demandsRequests.remove({id:demandsRequest.id}, demandsRequestRemoveOK, removeKO);

            // demandsRequest borrado correctamente
            function demandsRequestRemoveOK(response){
                // Quitamos la demandsRequest en los datos locales
                for (var i = 0; i < service.demandsRequests.data.length; i++) {
                    if (service.demandsRequests.data[i].id === demandsRequest.id) {
                        service.demandsRequests.data.splice(i,1);
                        service.demandsRequests.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar demandsRequest
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offersPostulates')
        .factory('offersPostulatesService', offersPostulatesService);

    /** @ngInject */
    function offersPostulatesService($q, api, gettextCatalog) {

        var service = {
            offersPostulates: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersPostulates: getOffersPostulates,
            getAllOffersPostulates: getAllOffersPostulates,
            getOffersPostulate: getOffersPostulate,
            saveOffersPostulate: saveOffersPostulate,
            saveOffersCurricular: saveOffersCurricular,
            getEmptyOffersPostulate: getEmptyOffersPostulate,
            removeOffersPostulate: removeOffersPostulate,
            discarded: discarded,
            discardedAll: discardedAll
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersPostulates
         */
        function getOffersPostulates() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersPostulates.get(service.offersPostulates.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersPostulates.data = response.results;
                service.offersPostulates.count = response.count;

                deferred.resolve(service.offersPostulates);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersPostulates.filters.page!=1){
                    service.offersPostulates.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersPostulates filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersPostulates(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersPostulates.filters);
            f.search=search;
            f.page="all";
            api.offersPostulates.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersPostulate determinado por su ID
         *
         * @param id
         */
        function getOffersPostulate(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersPostulates.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersPostulate que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersPostulate(form) {
            var deferred = $q.defer();

            var offersPostulate = angular.copy(form);
            offersPostulate.start_date=moment(offersPostulate.start_date).format("YYYY-MM-DD");

            if (form.id) {
                api.offersPostulates.update(offersPostulate, updateOK, saveKO);
            } else {
                api.offersPostulates.create(offersPostulate, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                for(var i in response.results){
                    service.offersPostulates.data.push(response.results[i]);
                }
                service.offersPostulates.count +=response.count;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersPostulates.data.length; i++) {
                    if (service.offersPostulates.data[i].id === response.id) {
                        service.offersPostulates.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Edita la oferta curricular
         *
         * @param form
         */
        function saveOffersCurricular(form) {
            var deferred = $q.defer();

            var offersPostulate = angular.copy(form);

            api.offers.update(offersPostulate, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersPostulates.data.length; i++) {
                    if (service.offersPostulates.data[i].id === response.id) {
                        service.offersPostulates.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersPostulate vacío
         */
        function getEmptyOffersPostulate(demandSchedule) {
            return {
                "schedule": demandSchedule.id,
                "start_date":moment(demandSchedule.start_date_start_practices).toDate()
            };
        }
        
        function removeOffersPostulate(offersPostulate){
            var deferred = $q.defer();

            api.offersPostulates.remove({id:offersPostulate.id}, offersPostulateRemoveOK, removeKO);

            // offersPostulate borrado correctamente
            function offersPostulateRemoveOK(response){
                // Quitamos la offersPostulate en los datos locales
                for (var i = 0; i < service.offersPostulates.data.length; i++) {
                    if (service.offersPostulates.data[i].id === offersPostulate.id) {
                        service.offersPostulates.data.splice(i,1);
                        service.offersPostulates.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersPostulate
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Descarta la plaza no asignada de una oferta
         *
         * @param offersPostulate
         */
        function discarded(offersPostulate) {
            var deferred = $q.defer();

            api.offersPostulates.discarded({id:offersPostulate.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Quitamos la offersPostulate en los datos locales
                for (var i = 0; i < service.offersPostulates.data.length; i++) {
                    if (service.offersPostulates.data[i].id === offersPostulate.id) {
                        service.offersPostulates.data.splice(i,1);
                        service.offersPostulates.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Descarta las plazas no asignadas de una oferta
         *
         * @param form
         */
        function discardedAll(form) {
            var deferred = $q.defer();

            api.offersPostulates.discardedAll({demand:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.demandsCompanies',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider
            .state('app.demands.get.demandsCompanies', {
                url: 'demandsCompanies/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/demandsCompanies/demandsCompanies.html',
                        controller: 'DemandsCompaniesController as vm'
                    }
                },
                resolve: {
                    DemandsCompanies: function (demandsCompaniesService, Demand) {
                        demandsCompaniesService.demandsCompanies.filters={};
                        demandsCompaniesService.demandsCompanies.filters.demand=Demand.id;
                        return demandsCompaniesService.getDemandsCompanies();
                    },
                    Breadcrumb: function (Demand) {
                        return ['<a ui-sref="app.demands.list"> Ofertas curriculares</a>',
                            '<a ui-sref="app.demands.get.detail({demand:'+Demand.id+'})">Oferta '+Demand.code+'</a>',
                            'Empresas con ofertas'];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.demandsCompanies')
        .factory('demandsCompaniesService', demandsCompaniesService);

    /** @ngInject */
    function demandsCompaniesService($q, api) {

        var service = {
            demandsCompanies: {
                data: [],
                count: 0,
                filters: {}
            },
            getDemandsCompanies: getDemandsCompanies
        };

        return service;

        //////////

        /**
         * Obtiene el listado de demandsCompanies
         */
        function getDemandsCompanies() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsCompanies.get(service.demandsCompanies.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.demandsCompanies.data = response;
                service.demandsCompanies.count = Object.keys(response).length;

                deferred.resolve(service.demandsCompanies);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.demandsCompanies.filters.page!=1){
                    service.demandsCompanies.filters.page=1;
                }
                deferred.reject(response);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.company',
            [
                'ng-sortable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider.state('app.company', {
            url      : '/company/:id',
            abstract: true,
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                CompanyDetail: function (currentUser, $rootScope, companyDetailService, companyListService, $stateParams) {
                    if($stateParams.id && $rootScope.hasPermission("companyList","GET")){
                        return companyListService.getCompany($stateParams.id);
                    }else{
                        return companyDetailService.getCompanyDetail();

                    }
                }
            },
            bodyClass: 'todo'
        })
        .state('app.companyList', {
            url      : '/company/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/company/companyList/companyList.html',
                    controller : 'CompanyListController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                CompanyList: function (companyListService) {
                    companyListService.companyList.filters={};
                    return companyListService.getCompanyList();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('companies');
                }
            },
            bodyClass: 'todo'
        })
        .state('app.company.detail', {
            url: '/detail',
            views: {
                'content@app': {
                    templateUrl: 'app/main/company/companyDetail/companyDetail.html',
                    controller: 'CompanyDetailController as vm'
                }
            },
            resolve: {
                Centers: function (centersService, CompanyDetail) {
                    centersService.centers.filters={};
                    centersService.centers.filters.company=CompanyDetail.id;
                    // return centersService.getAllCenters();
                    return centersService.getCenters().then(function(res){
                        /* @TODO Para probar, se va a forzar a cargar todos los centros*/
                        /*if(res.count>10){
                            return [];
                        }*/
                        return res.data;
                    });
                },
                CompanyId:function(CompanyDetail, $stateParams){
                    $stateParams.id=CompanyDetail.id;
                },
                Activities: function (activitiesService) {
                    activitiesService.activities.filters={};
                    return activitiesService.getAllActivities();
                },
                Validate: function (companyListService,CompanyDetail) {
                    return companyListService.getCompanyValidate(CompanyDetail.id);
                }

            },
            bodyClass: 'companyDetail'
        })
        .state('app.company.centers', {
            url      : '/centers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/company/centers/centers.html',
                    controller : 'CentersController as vm'
                }
            },
            resolve  : {
                Centers: function (centersService, CompanyDetail) {
                    centersService.centers.filters={};
                    centersService.centers.filters.company=CompanyDetail.id;
                    return centersService.getCenters();
                },
                CompanyId:function(CompanyDetail, $stateParams){
                    $stateParams.id=CompanyDetail.id;
                }
            },
            bodyClass: 'todo'
        })
        .state('app.company.contacts', {
            url      : '/contacts/?center',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/company/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve  : {
                Contacts: function (contactsService,CompanyDetail,$stateParams) {
                    contactsService.contacts.filters={};
                    contactsService.contacts.filters.centers_data={};
                    contactsService.contacts.filters.centers_data.id=$stateParams.center;
                    contactsService.contacts.filters.company=CompanyDetail.id;
                    return contactsService.getContacts();
                },
                Centers: function (centersService, CompanyDetail) {
                    centersService.centers.filters={};
                    centersService.centers.filters.company=CompanyDetail.id;
                    // return centersService.getAllCenters();
                    return centersService.getCenters().then(function(res){
                        console.log("Número de centros :" + res.count);
                        /* @TODO Para probar, se va a forzar a cargar todos los centros*/
                        /*if(res.count>10){
                            return [];
                        }*/
                        return res.data;
                    });
                },
                CompanyId:function(CompanyDetail, $stateParams){
                    $stateParams.id=CompanyDetail.id;
                }
            },
            bodyClass: 'todo'
        })
        .state('app.company.agreements', {
            url      : '/agreements',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/company/agreements/views/list/agreements.html',
                    controller : 'AgreementsController as vm'
                }
            },
            resolve  : {
                Agreements_historical: function (agreementsService,CompanyDetail) {
                    //este va a ser paginado, los demas vamos a traernos todos los resultados
                    agreementsService.agreements.filters.status="filed";
                    agreementsService.agreements.filters.company=CompanyDetail.id;
                    return agreementsService.getAgreements();
                },
                Agreements_valid: function (agreementsService,CompanyDetail) {
                    var filters={};
                    filters.status="valid";
                    filters.company=CompanyDetail.id;
                    return agreementsService.getAllAgreements(null,filters);
                },
                Agreements_in_progress: function (agreementsService,CompanyDetail) {
                    var filters={};
                    filters.status="draft";
                    filters.company=CompanyDetail.id;
                    return agreementsService.getAllAgreements(null,filters);
                },
                Agreements_partially_signed: function (agreementsService,CompanyDetail) {
                    var filters={};
                    filters.status="partially_signed";
                    filters.company=CompanyDetail.id;
                    return agreementsService.getAllAgreements(null,filters);
                },
                CompanyId:function(CompanyDetail, $stateParams){
                    $stateParams.id=CompanyDetail.id;
                }
            },
            bodyClass: 'todo'
        })
        .state('app.company.agreement', {
            url      : '/agreements/:agreement',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/company/agreements/views/detail/agreement.html',
                    controller : 'AgreementController as vm'
                }
            },
            resolve  : {
                Agreement: function (agreementsService,$stateParams) {
                    return agreementsService.getAgreement($stateParams.agreement);
                },
                AgreementBase64: function (agreementsService,$stateParams) {
                    return agreementsService.getAgreementBase64($stateParams.agreement);
                },
                AgreementsConditions: function (Agreement, agreementsConditionsService) {
                    agreementsConditionsService.agreementsConditions.data=Agreement.conditions;
                    agreementsConditionsService.agreementsConditions.count=Agreement.conditions.length;
                    return agreementsConditionsService.agreementsConditions;
                },
                Signers: function (contactsService,CompanyDetail) {
                    contactsService.contacts.filters={};
                    contactsService.contacts.filters.responsible_signing="single,joint";
                    contactsService.contacts.filters.company=CompanyDetail.id;
                    return contactsService.getAllContacts();
                },
                CompanyId:function(CompanyDetail, $stateParams){
                    $stateParams.id=CompanyDetail.id;
                },
                Breadcrumb: function (CompanyDetail, Agreement,$filter) {
                    return ['Empresa',
                        '<a ui-sref="app.company.agreements({id:'+CompanyDetail.id+'})"> Convenios</a>',
                        "Convenio "+$filter('date')(Agreement.start_date,'dd/MM/yyyy')+" - "+$filter('date')(Agreement.end_date,'dd/MM/yyyy')];
                }
            },
            bodyClass: 'todo'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($rootScope, AuthService, PrivacyPolicy, $mdDialog, contactsService, Centers, Contact,
                                     CompanyDetail, companyDetailService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Nuevo contacto');
        vm.user=AuthService.currentUser;
        vm.centers=Centers;
        vm.identification_types=companyDetailService.getIdentificationTypes();
        vm.privacyPolicy=PrivacyPolicy;
        vm.company=CompanyDetail;
        vm.UCA_COMPANY_CIF=$rootScope.UCA_COMPANY_CIF;

        if(!Contact){
            vm.form = {
                "user": {},
                "company":CompanyDetail.id
            };
        }else{
            vm.title = gettextCatalog.getString('Editar contacto');
            vm.form=angular.copy(Contact);
        }

        // Methods
        vm.saveContact = saveContact;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar contacto
         */
        function saveContact() {
            return contactsService.saveContact(vm.form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Contacto guardado correctamente"));
                if(vm.user.id===vm.form.user.id){
                    AuthService.checkStatus();
                }
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el contacto. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('CenterDialogController', CenterDialogController);

    /** @ngInject */
    function CenterDialogController($mdDialog, Center, centersService, NotifyService, CompanyDetail, localitiesService,
                                    provincesService, $q, gettextCatalog, $rootScope) {
        var vm = this;

        // Data
        vm.company=CompanyDetail;
        vm.UCA_COMPANY_CIF=$rootScope.UCA_COMPANY_CIF;

        vm.title = gettextCatalog.getString('Editar sede');
        if(vm.company.identification===vm.UCA_COMPANY_CIF){
            vm.title = gettextCatalog.getString('Editar organismo');
        }


        if (!Center) {
            vm.title = gettextCatalog.getString('Nueva sede');
            vm.center = centersService.getEmptyCenter(CompanyDetail);
        } else {
            vm.center = angular.copy(Center); // Copiamos para no modificar el original hasta guardar
            if(Center.town_data){
                vm.center.province_data=angular.copy(Center.town_data.province_data);
            }
        }

        // Methods
        vm.saveCenter = saveCenter;
        vm.getProvinces = getProvinces;
        vm.getLocalities = getLocalities;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar centro
         */
        function saveCenter() {
            return centersService.saveCenter(vm.center).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Sede guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la sede. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function createFilterFor(query) {
          var lowercaseQuery = getCleanedString(query);
          return function filterFn(location) {
            return (getCleanedString(location.name).includes(lowercaseQuery));
          };
        }

        /* Provincias */
        function getProvinces(searchText) {
            var deferred = $q.defer();

            provincesService.getProvinces(null, searchText).then(function(provinces){
                var results = searchText ? provinces.filter( createFilterFor(searchText) ) : provinces;
                deferred.resolve(results);
            });

            return deferred.promise;
        }

        /* Localidades */
        function getLocalities(searchText) {
            var deferred = $q.defer();

            localitiesService.getLocalities(vm.center.province_data.id, searchText).then(function(localities){
                var results = searchText ? localities.filter( createFilterFor(searchText) ) : localities;
                deferred.resolve(results);
            });

            return deferred.promise;
        }

        function getCleanedString(cadena){
           // Lo queremos devolver limpio en minusculas
           cadena = cadena.toLowerCase();

           // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
           cadena = cadena.replace(/á/gi,"a");
           cadena = cadena.replace(/é/gi,"e");
           cadena = cadena.replace(/í/gi,"i");
           cadena = cadena.replace(/ó/gi,"o");
           cadena = cadena.replace(/ú/gi,"u");
           return cadena;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('AgreementsConditionDialogController', AgreementsConditionDialogController);

    /** @ngInject */
    function AgreementsConditionDialogController($mdDialog, AuthService, AgreementsCondition, agreementsConditionsService, Agreement, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'bold', 'italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertLink', 'redo', 'undo', 'clear','insertTable']
        ];

        vm.user = AuthService.currentUser;
        vm.title = gettextCatalog.getString('Editar cláusula');
        vm.newCondition=false;
        if (!AgreementsCondition) {
            vm.title = gettextCatalog.getString('Nueva cláusula');
            vm.agreementsCondition = agreementsConditionsService.getEmptyAgreementsCondition(Agreement);
            vm.newCondition=true;
        } else {
            if(AgreementsCondition.status==="done"){
                vm.agreementsCondition = agreementsConditionsService.getEmptyAgreementsCondition(Agreement, AgreementsCondition);
            }else{
                vm.agreementsCondition = angular.copy(AgreementsCondition);
            }
        }

        // Methods
        vm.saveAgreementsCondition = saveAgreementsCondition;
        vm.closeDialog = closeDialog;
        vm.copy = copy;

        //////////
        /**
         * Guardar convenio
         */
        function saveAgreementsCondition() {
            var agreementsCondition=angular.copy(vm.agreementsCondition);
            return agreementsConditionsService.saveAgreementsCondition(agreementsCondition).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Cláusula guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la cláusula. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Copia la cláusula vigente
         */
        function copy() {
            if(!vm.agreementsCondition.status || vm.agreementsCondition.status==='done'){
                vm.agreementsCondition.description=vm.agreementsCondition.modified_condition.description;
            }
            if(vm.agreementsCondition.status==='rejected' || vm.agreementsCondition.status==='pending'){
                vm.agreementsCondition.description=vm.agreementsCondition.previous_version;
            }
        }
        
    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.company')
        .controller('AgreementsController', AgreementsController);
    /** @ngInject */
    function AgreementsController($scope, currentUser, Agreements_historical, Agreements_valid, Agreements_in_progress, Agreements_partially_signed, $state, $mdSidenav,
                                    agreementsService, NotifyService, CompanyDetail, $mdDialog, companyDetailService, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.agreements_historical=Agreements_historical;
        vm.agreements_valid=Agreements_valid;
        vm.agreements_in_progress=Agreements_in_progress;
        vm.agreements_partially_signed=Agreements_partially_signed;
        vm.form = CompanyDetail;

        // Methods
        vm.openAgreementDialog = openAgreementDialog;
        vm.removeAgreement = removeAgreement;
        vm.setValid = setValid;
        vm.toggleSidenav = toggleSidenav;

        // Watchers
        $scope.$watch('vm.agreements_historical.filters', DebounceService(agreementsService.getAgreements, 300), true);

        //////////
        /**
         * Abre el dialogo para crear/editar un agreementa
         *
         * @param ev
         * @param agreement
         */
        function openAgreementDialog(ev, agreement) {
            var obj = agreementsService.getEmptyAgreement(CompanyDetail);
            if(agreement){
                obj.agreement_renewal=agreement.id;
            }
            return agreementsService.saveAgreement(obj).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Convenio guardado correctamente"));
                $state.go("app.company.agreement",{agreement:response.id});
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el convenio. ") + (error.data.non_field_errors || "") + (error.data.company || ""));
            });
        }

        /**
         * Valida la empresa y crea posteriormente un convenio
         *
         */
        function setValid() {
            var obj={
                id:vm.form.id,
                status:"without-agreement"
            };
            return companyDetailService.saveCompanyDetail(obj).then(function(response){
                vm.form=response;
                openAgreementDialog();
                NotifyService.successMessage(gettextCatalog.getString("Empresa validada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al validar empresa. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Abre el dialogo para eliminar una agreement
         *
         * @param ev
         * @param agreement
         */
        function removeAgreement(ev, agreement) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar convenio'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el convenio?'))
                .ariaLabel(gettextCatalog.getString('Eliminar convenio'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar convenio'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                agreementsService.removeAgreement(agreement).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Convenio borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar el convenio. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('AgreementDialogController', AgreementDialogController);

    /** @ngInject */
    function AgreementDialogController($mdDialog, Agreement, CompanyDetail, agreementsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Renovar convenio');

        if (!Agreement) {
            vm.title = gettextCatalog.getString('Nuevo convenio');
            vm.agreement = agreementsService.getEmptyAgreement(CompanyDetail);
        } else {
            //Se trata de una renovacion de convenio, por lo que le pasamos el antiguo como parametro "agreement_renewal"
            var t=angular.copy(Agreement); // Copiamos para no modificar el original hasta guardar
            vm.agreement = agreementsService.getEmptyAgreement(CompanyDetail);
            vm.agreement.agreement_renewal=t;
        }

        // Methods
        vm.saveAgreement = saveAgreement;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar convenio
         */
        function saveAgreement() {
            var agreement=angular.copy(vm.agreement);
            agreement.start_date=moment(agreement.start_date).format("YYYY-MM-DD");
            agreement.end_date=moment(agreement.end_date).format("YYYY-MM-DD");
            return agreementsService.saveAgreement(agreement).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Convenio guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el convenio. ") + (error.data.non_field_errors || "") + (error.data.company || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('AgreementController', AgreementController);

    /** @ngInject */
    function AgreementController($rootScope, currentUser, Agreement, Signers, agreementsService, NotifyService,
                                 AgreementsConditions, api, agreementsConditionsService, CompanyDetail, $mdDialog,
                                 $document, $mdSidenav, $filter, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.agreement = formatAgreement(Agreement);
        vm.signers=Signers;
        vm.agreementsConditions=AgreementsConditions;
        vm.form = CompanyDetail;
        vm.types=agreementsService.getTypes();
        vm.loadOrder=false;

        vm.sortableOptions = {
            handle        : '.handle',
            forceFallback : true,
            ghostClass    : 'todo-item-placeholder',
            fallbackClass : 'todo-item-ghost',
            fallbackOnBody: true,
            sort          : true,
            onUpdate  : function(evt){
                var obj=evt.model;
                obj.load=true;
                obj.order=evt.newIndex+1;
                vm.loadOrder=true;
                agreementsConditionsService.orderAgreementsCondition(obj).then(function(){
                    vm.loadOrder=false;
                }, function(error){
                    vm.loadOrder=false;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al mover la cláusula. ") + (error.data.detail || ""));
                });
            }
        };

        vm.ngFlowOptions={
            target: api.URLs.agreementsDocuments,
            query:function(file){
                return {type:'agreement', name:"Convenio "+
                            $filter('date')(vm.agreement.start_date,"dd/MM/yyyy")+
                            " - "+
                            $filter('date')(vm.agreement.end_date,"dd/MM/yyyy")+
                            " ("+vm.form.business_name+")"
                        };
            }
        };

        // Methods
        vm.digisignerSuccess=digisignerSuccess;
        vm.digisignerError=digisignerError;
        vm.saveAgreement = saveAgreement;
        vm.changeUCASigner = changeUCASigner;
        vm.saveWithNotify = saveWithNotify;
        vm.setSigned = setSigned;
        vm.changeSwapSignature = changeSwapSignature;
        vm.openAgreementsConditionDialog = openAgreementsConditionDialog;
        vm.removeAgreementsCondition = removeAgreementsCondition;
        vm.acceptAgreementsCondition = acceptAgreementsCondition;
        vm.rejectAgreementsCondition = rejectAgreementsCondition;
        vm.isSignedByContact = isSignedByContact;
        vm.toggleEditable = toggleEditable;
        vm.uploadFile = uploadFile;
        vm.deleteFile = deleteFile;
        vm.toggleSidenav = toggleSidenav;
        vm.getDocument=getDocument;
        vm.printAgreement=printAgreement;
        vm.getBase64=getBase64;
        vm.contactSigner=contactSigner;


        //////////

        /**
         * Callback de la firma electrónica correcta.
         *
         * @param signatureB64
         * @param certificateB64
         */
        function digisignerSuccess(signatureB64, certificateB64){
            contactSigner(signatureB64);
        }

        /**
         * Callback de la firma electrónica fallida.
         *
         * @param errorType
         * @param errorMessage
         */
        function digisignerError(errorType, errorMessage){
            console.log("error",arguments);
        }

        /**
         * Da el formato necesario al convenio para poder trabajar con el
         */
        function formatAgreement(agreement) {
            var a = angular.copy(agreement);
            a.start_date=new Date(moment(a.start_date).format());
            a.end_date=new Date(moment(a.end_date).format());
            return a;
        }

        function getBase64(){
            var deferred = $q.defer();
            //actualizamos el base64 del convenio
            agreementsService.getAgreementBase64(vm.agreement.id).then(function(response){
                deferred.resolve(response);
            },function(response){
                deferred.reject(response);
            });
            return deferred.promise;
        }

        /**
         * Guardar detalle de empresa
         */
        function saveAgreement(successCallback, errorCallback) {
            var agreement=angular.copy(vm.agreement);
            if(agreement.start_date && agreement.end_date){
                agreement.start_date=moment(agreement.start_date).format("YYYY-MM-DD");
                agreement.end_date=moment(agreement.end_date).format("YYYY-MM-DD");
            }
            return agreementsService.saveAgreement(agreement).then(function(response){
                vm.agreement=formatAgreement(response);
                agreementsConditionsService.getAgreementsConditions(vm.agreement.id);
                if(successCallback){
                    successCallback(response);
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Convenio guardado correctamente"));
                }
            }, function(error){
                vm.serverErrors = error.data;
                if(errorCallback){
                    errorCallback(error);
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error al guardar convenio. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                }
            });
        }

        /**
         * Cambia el firmante de la uca
         */
        function changeUCASigner(signer) {
            vm.agreement.uca_signer=signer;
            saveAgreement();
        }

        function saveWithNotify(){
            if(vm.agreement.type!==Agreement.type){
                var confirm = $mdDialog.confirm()
                    .title(gettextCatalog.getString('Guardar datos de convenio'))
                    .textContent(gettextCatalog.getString('¿Seguro que quieres modificar el tipo de convenio? Las cláusulas del convenio se recalcularán.'))
                    .ariaLabel(gettextCatalog.getString('Guardar'))
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .ok(gettextCatalog.getString('Guardar'))
                    .cancel(gettextCatalog.getString('Cancelar'));

                $mdDialog.show(confirm).then(function() {
                    return saveAgreement();
                });
            }else{
                return saveAgreement();
            }
        }

        /**
         * Marca el convenio como firmado
         */
        function setSigned(){
            var obj={
                id:vm.agreement.id,
                signed:!vm.agreement.signed
            };
            return agreementsService.setSigned(obj).then(function(response){
                vm.agreement=formatAgreement(response);
                agreementsConditionsService.getAgreementsConditions(vm.agreement.id);
                if(vm.agreement.signed){
                    NotifyService.successMessage(gettextCatalog.getString("Convenio marcado como firmado"));
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Convenio desmarcado como firmado"));
                }

            }, function(error){
                vm.serverErrors = error.data;
                if(vm.agreement.signed){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al desmarcar el convenio como firmado. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error al marcar el convenio como firmado. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                }

            });
        }

        /**
         * Activa/Desactiva la edición de clausulas
         */
        function toggleEditable(){
            var a={
                id:vm.agreement.id
            };
            return agreementsService.editableAgreement(a).then(function(response){
                vm.agreement=formatAgreement(response);
                agreementsConditionsService.getAgreementsConditions(vm.agreement.id);
                if(vm.agreement.editable){
                    NotifyService.successMessage(gettextCatalog.getString("Activada la edición de cláusulas"));
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Desactivada la edición de cláusulas"));
                }
            },function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Ha ocurrido un error. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Firma por parte de un contacto
         */
        function contactSigner(base64){
            var a={
                id:vm.agreement.id,
                base64:base64
            };
            return agreementsService.signAgreement(a).then(function(response){
                vm.agreement=formatAgreement(response);
                NotifyService.successMessage(gettextCatalog.getString("Firma realizada correctamente"));
            },function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al realizar la firma. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Informa si el contacto ha firmado el convenio
         */
        function isSignedByContact(contact){
            return vm.agreement.signers.indexOf(contact.id)>-1;
        }

        /**
         * Cambia el orden de firma
         */
        function changeSwapSignature(){
            vm.agreement.swap_signature=!vm.agreement.swap_signature;
            return saveAgreement(function(){
                NotifyService.successMessage(gettextCatalog.getString("Orden de firma cambiado"));
            },function(error){
                vm.agreement.swap_signature=!vm.agreement.swap_signature;
                NotifyService.errorMessage(gettextCatalog.getString("Error al cambiar el orden de firma. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }


        /**
         * Abre el dialogo para crear/editar un agreementsConditiona
         *
         * @param ev
         * @param agreementsCondition
         */
        function openAgreementsConditionDialog(ev, agreementsCondition) {
            $mdDialog.show({
                controller: 'AgreementsConditionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/company/agreementsConditions/dialogs/agreementsCondition/agreementsCondition-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Agreement:Agreement,
                    AgreementsCondition:agreementsCondition,
                    event: ev
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una agreementsCondition
         *
         * @param ev
         * @param agreementsCondition
         */
        function removeAgreementsCondition(ev, agreementsCondition) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula de convenio'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula de convenio?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula de convenio'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula de convenio'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                var obj;
                if(agreementsCondition.status==="done"){
                    obj = agreementsConditionsService.getEmptyAgreementsCondition(Agreement, agreementsCondition);
                }else{
                    obj = angular.copy(agreementsCondition);
                    obj.description="";
                }
                return agreementsConditionsService.saveAgreementsCondition(obj).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula eliminada correctamente"));
                }, function(error){
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al eliminar la cláusula. ") + (error.data.non_field_errors || ""));
                });
            });

        }

        /**
         * Acepta una cláusa de convenio
         *
         * @param ev
         * @param agreementsCondition
         */
        function acceptAgreementsCondition(ev, agreementsCondition) {
            var obj = angular.copy(agreementsCondition);
            obj.status="done";
            return agreementsConditionsService.changeStatusAgreementsCondition(obj).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Cláusula aceptada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al aceptar la cláusula. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Acepta una cláusa de convenio
         *
         * @param ev
         * @param agreementsCondition
         */
        function rejectAgreementsCondition(ev, agreementsCondition) {
            var obj = angular.copy(agreementsCondition);
            obj.status="rejected";
            return agreementsConditionsService.changeStatusAgreementsCondition(obj).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Cláusula rechazada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al rechazar la cláusula. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Subida de fichero de convenio satisfactoria
         *
         * @param $file
         * @param $message
         * @param $flow
         */
        function uploadFile($file, $message, $flow) {
            var file=JSON.parse($message);
            return agreementsService.uploadFile(vm.agreement,file).then(function(response){
                vm.agreement=formatAgreement(response);
                NotifyService.successMessage(gettextCatalog.getString("Convenio subido correctamente"));
            },function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al subir convenio. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Borra el documento del convenio
         */
        function deleteFile(){
            return agreementsService.uploadFile(vm.agreement).then(function(response){
                vm.agreement=formatAgreement(response);
                NotifyService.successMessage(gettextCatalog.getString("Convenio eliminado correctamente"));
            },function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al eliminar convenio. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Nombre del fichero PDF del convenio
         */
        function agreementFileName(agreement){
            return "Convenio "+
                        $filter('date')(agreement.start_date,"dd/MM/yyyy")+
                        " - "+
                        $filter('date')(agreement.end_date,"dd/MM/yyyy")+
                        " ("+vm.form.business_name+").pdf";
        }

        /**
         * Descarga el convenio en pdf
         */
        function getDocument(agreement){
            var name=agreementFileName(agreement);

            return agreementsService.getAgreementDownload(agreement.id).then(function(response){
                $rootScope.downloadFile(response,name,$rootScope.getMimetype(name));
            }, function(){
                NotifyService.errorMessage(gettextCatalog.getString("No se ha podido obtener el documento."));
            });
        }

        /**
         * Vista previa e impresión del convenio en pdf (mismo diálogo que los documentos)
         */
        function printAgreement(agreement, ev){
            var name=agreementFileName(agreement);

            return agreementsService.getAgreementDownload(agreement.id).then(function(response){
                $rootScope.openDocumentPreview(ev, name, new Blob([response], {type: 'application/pdf'}));
            }, function(){
                NotifyService.errorMessage(gettextCatalog.getString("No se ha podido obtener el documento."));
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.users',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider
            .state('app.users', {
                abstract: true,
                url: '/users'
            })


            .state('app.users.list', {
                url: '/list',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/users/views/list/users-list.html',
                        controller: 'UsersController as vm'
                    }
                },
                resolve: {
                    Users: function (usersService) {
                        return usersService.getUsers();
                    }
                },
                bodyClass: 'users'
            })

            .state('app.users.detail', {
                url: '/detail',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/users/views/detail/user-detail.html',
                        controller: 'UserController as vm'
                    }
                },
                resolve  : {
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($scope, Users, usersService, $mdDialog, $document, DebounceService, NotifyService) {
        var vm = this;

        // Data
        vm.users = Users;

        // Watchers
        $scope.$watch('vm.users.filters', DebounceService(usersService.getUsers, 300), true);

        // Methods
        vm.openUserDialog = openUserDialog;
        vm.removeUser = removeUser;

        //////////

        /**
         * Abre el formulario de nuevo administrador
         *
         * @param ev
         * @param user
         */
        function openUserDialog(ev, user) {
            $mdDialog.show({

                controller: 'UserDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/users/dialogs/user/user-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    User: user,
                    event: ev
                }
            });
        }

        function removeUser(ev, user) {
            var confirm = $mdDialog.confirm()
                .title('Eliminar administrador')
                .textContent('¿Seguro que quieres eliminar el administrador '+user.first_name+' '+user.last_name+ '?')
                .ariaLabel('Eliminar administrador')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Borrar administrador')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function() {
                usersService.removeUser(user).then(function(){
                    NotifyService.successMessage("Administrador borrado correctamente.");
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el administrador. " + (error.data.detail || ""));
                });
            });

        }


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.users')
        .controller('UserController', UserController);
    /** @ngInject */
    function UserController($scope, usersService, AuthService, NotifyService, $mdDialog, $document, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = AuthService.currentUser;

        // Methods
        vm.saveUser = saveUser;
        vm.openUserDialog = openUserDialog;

        vm.languages = [
            {
                code:'es',
                name:gettextCatalog.getString('Español')
            },
            {
                code:'en',
                name:gettextCatalog.getString('Inglés')
            },
            {
                code:'fr',
                name:gettextCatalog.getString('Francés')
            },
            {
                code:'pt',
                name:gettextCatalog.getString('Portugués')
            },
            {
                code:'it',
                name:gettextCatalog.getString('Italiano')
            },
            {
                code:'de',
                name:gettextCatalog.getString('Alemán')
            }
        ];

        //////////
        /**
         * Guardar usuario
         */
        function saveUser() {
            //Quitamos el id para que haga la edicion del usuario activo
            var obj=angular.copy(vm.user);
            delete obj.id;
            return usersService.saveUser(obj).then(function(){
                NotifyService.successMessage("Usuario guardado correctamente.");
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al guardar el usuario. " + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Abre el formulario de cambio de contraseña
         *
         * @param ev
         * @param user
         */
        function openUserDialog(ev, user) {
            $mdDialog.show({

                controller: 'UserDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/users/dialogs/users/user-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    User: user,
                    event: ev
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.users')
        .controller('UserDialogController', UserDialogController);

    /** @ngInject */
    function UserDialogController($mdDialog, User, usersService, NotifyService) {
        var vm = this;

        // Data
        vm.title = 'Cambiar contraseña';
        vm.user = User;

        // Methods
        vm.saveUser = saveUser;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar usuario
         */
        function saveUser() {
            //le quitamos el id para que haga un guardado sobre el perfil logueado
            delete vm.user.id;
            return usersService.saveUser(vm.user).then(function(){
                NotifyService.successMessage("Contraseña modificada correctamente");
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al guardar el usuario. " + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.teachers',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.teachers', {
            url      : '/teachers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/teachers/views/list/teachers.html',
                    controller : 'TeachersController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Teachers: function (teachersService) {
                    return teachersService.getTeachers();
                }
            },
            bodyClass: 'todo'
        })
        .state('app.teacher', {
            url      : '/teachers/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/teachers/views/detail/teacher.html',
                    controller : 'TeacherController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Teacher: function (currentUser, $rootScope, teachersService,$stateParams) {
                    if($rootScope.hasPermission("teachersDetail","LIST")){
                        return teachersService.getTeacherDetail();
                    }else{
                        return teachersService.getTeacher($stateParams.id);
                    }
                },
                TeachersDegrees: function (teachersDegreesService,Teacher) {
                    teachersDegreesService.teachersDegrees.data=Teacher.tutor_degrees;
                    teachersDegreesService.teachersDegrees.count=Teacher.tutor_degrees.length;
                    return teachersDegreesService.teachersDegrees;
                },
                TeachersCoordinatorDegrees: function (teachersCoordinatorDegreesService,Teacher) {
                    teachersCoordinatorDegreesService.teachersCoordinatorDegrees.data=Teacher.coordinator_subjects;
                    teachersCoordinatorDegreesService.teachersCoordinatorDegrees.count=Teacher.coordinator_subjects.length;
                    return teachersCoordinatorDegreesService.teachersCoordinatorDegrees;
                },
                Breadcrumb: function (currentUser, Teacher, $rootScope, $stateParams) {
                    $stateParams.id=Teacher.id;
                    if($rootScope.hasPermission("teachersDetail","LIST")) {
                        return ['Mis datos'];
                    }else{
                        return ['<a ui-sref="app.tutors"> Tutores académicos</a>',
                            Teacher.name + " " + Teacher.surname + " " + Teacher.second_surname];
                    }
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .controller('TeacherController', TeacherController);

    /** @ngInject */
    function TeacherController(currentUser, Teacher, teachersService, NotifyService, TeachersDegrees, TeachersCoordinatorDegrees,
                             teachersDegreesService, teachersCoordinatorDegreesService, $mdSidenav, $mdDialog, $document, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.teacher = Teacher;
        vm.teachersDegrees = TeachersDegrees;
        vm.teachersCoordinatorDegrees = TeachersCoordinatorDegrees;

        // Methods
        vm.openTeachersDegreeDialog = openTeachersDegreeDialog;
        vm.openTeachersCoordinatorDegreeDialog = openTeachersCoordinatorDegreeDialog;
        vm.removeTeachersDegree = removeTeachersDegree;
        vm.removeTeachersCoordinatorDegree = removeTeachersCoordinatorDegree;

        //////////

        /**
         * Abre el dialogo para crear un titulación
         *
         * @param ev
         * @param teachersDegree
         */
        function openTeachersDegreeDialog(ev, teachersDegree) {
            $mdDialog.show({
                controller: 'TeachersDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersDegree/teachersDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: Teacher,
                    event: ev,
                    TeachersDegree: teachersDegree
                }
            });
        }

        /**
         * Abre el dialogo para coordinar una titulación
         *
         * @param ev
         * @param teachersCoordinatorDegree
         */
        function openTeachersCoordinatorDegreeDialog(ev, teachersCoordinatorDegree) {
            $mdDialog.show({
                controller: 'TeachersCoordinatorDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersCoordinatorDegree/teachersCoordinatorDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: Teacher,
                    event: ev,
                    TeachersCoordinatorDegree: teachersCoordinatorDegree
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una titulación
         *
         * @param ev
         * @param teachersDegree
         */
        function removeTeachersDegree(ev, teachersDegree) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar titulación'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la titulación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar titulación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar titulación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                teachersDegreesService.removeTeachersDegree(teachersDegree).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Titulación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la titulación. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para eliminar una titulación
         *
         * @param ev
         * @param teachersCoordinatorDegree
         */
        function removeTeachersCoordinatorDegree(ev, teachersCoordinatorDegree) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar titulación'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la titulación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar titulación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar titulación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                teachersCoordinatorDegreesService.removeTeachersCoordinatorDegree(teachersCoordinatorDegree).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Titulación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la titulación. " + (error.data.detail || ""));
                });
            });

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .controller('TeachersDegreeDialogController', TeachersDegreeDialogController);

    /** @ngInject */
    function TeachersDegreeDialogController($mdDialog, TeachersDegree, teachersService, teachersDegreesService, Teacher, NotifyService,
                                             $state, degreesService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar titulación');

        if (!TeachersDegree) {
            vm.title = gettextCatalog.getString('Nueva titulación para tutor académico');
            vm.teachersDegree = teachersDegreesService.getEmptyTeachersDegree(Teacher.id);
        } else {
            vm.teachersDegree = angular.copy(TeachersDegree); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveTeachersDegree = saveTeachersDegree;
        vm.getDegrees = getDegrees;
        vm.getFullNameDegree = getFullNameDegree;
        vm.getTutors = getTutors;
        vm.closeDialog = closeDialog;
        vm.getFullTextTutor = getFullTextTutor;

        //////////
        /**
         * Guardar titulación
         */
        function saveTeachersDegree() {
            var form=angular.copy(vm.teachersDegree);
            return teachersDegreesService.saveTeachersDegree(form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación añadida correctamente para este tutor"));
                if(vm.teachersDegree.tutor_data){
                    $state.go("app.teacher",{id:vm.teachersDegree.tutor_data.id});
                }
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Obtiene los profesores para rellenar el autocomplete
         */
        function getTutors(searchText) {
            var deferred = $q.defer();
            teachersService.getAllTeachers(searchText).then(function(teachers){
                deferred.resolve(teachers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            var teacher=vm.teachersDegree.tutor_data ? vm.teachersDegree.tutor_data.id : vm.teachersDegree.tutor;
            degreesService.getAllDegrees(searchText,teacher).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

        function getFullNameDegree(degree) {
            return degreesService.getFullNameDegree(degree);
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getFullTextTutor(tutor) {
            return tutor.name+" "+tutor.surname+" "+tutor.second_surname+" ("+tutor.id+")";
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .controller('TeachersCoordinatorDegreeDialogController', TeachersCoordinatorDegreeDialogController);

    /** @ngInject */
    function TeachersCoordinatorDegreeDialogController($mdDialog, TeachersCoordinatorDegree, teachersService, teachersCoordinatorDegreesService, Teacher, NotifyService,
                                             $state, degreesService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar titulación');

        if (!TeachersCoordinatorDegree) {
            vm.title = gettextCatalog.getString('Nueva titulación para coordinador académico');
            vm.teachersCoordinatorDegree = teachersCoordinatorDegreesService.getEmptyTeachersCoordinatorDegree(Teacher.id);
        } else {
            vm.teachersCoordinatorDegree = angular.copy(TeachersCoordinatorDegree); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveTeachersCoordinatorDegree = saveTeachersCoordinatorDegree;
        vm.getDegrees = getDegrees;
        vm.getFullNameDegree = getFullNameDegree;
        vm.getCoordinators = getCoordinators;
        vm.closeDialog = closeDialog;
        vm.getFullTextCoordinator = getFullTextCoordinator;

        //////////
        /**
         * Guardar titulación
         */
        function saveTeachersCoordinatorDegree() {
            var form=angular.copy(vm.teachersCoordinatorDegree);
            return teachersCoordinatorDegreesService.saveTeachersCoordinatorDegree(form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación añadida correctamente para este coordinador"));
                if(vm.teachersCoordinatorDegree.coordinator_data){
                    $state.go("app.teacher",{id:vm.teachersCoordinatorDegree.coordinator_data.id});
                }
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Obtiene los profesores para rellenar el autocomplete
         */
        function getCoordinators(searchText) {
            var deferred = $q.defer();
            teachersService.getAllTeachers(searchText).then(function(teachers){
                deferred.resolve(teachers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            degreesService.getAllDegrees(searchText).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

        function getFullNameDegree(degree) {
            return degreesService.getFullNameDegree(degree);
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getFullTextCoordinator(coordinator) {
            return coordinator.name+" "+coordinator.surname+" "+coordinator.second_surname+" ("+coordinator.id+")";
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.students',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider.state('app.students', {
            url      : '/students/:id',
            abstract: true,
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                StudentsDetail: function (currentUser, $rootScope, studentsDetailService, studentsListService, $stateParams) {
                    if($stateParams.id && $rootScope.hasPermission("studentsList","LIST")){
                        return studentsListService.getStudents($stateParams.id);
                    }else{
                        return studentsDetailService.getStudentsDetail();

                    }
                }
            },
            bodyClass: 'todo'
        })
        .state('app.studentsList', {
            url      : '/students/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/students/studentsList/studentsList.html',
                    controller : 'StudentsListController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                StudentsList: function (studentsListService) {
                    return studentsListService.getStudentsList();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('students');
                }
            },
            bodyClass: 'todo'
        })
        .state('app.students.detail', {
            url: '/detail',
            views: {
                'content@app': {
                    templateUrl: 'app/main/students/studentsDetail/studentsDetail.html',
                    controller: 'StudentsDetailController as vm'
                }
            },
            resolve: {
                StudentsId:function(StudentsDetail, $stateParams){
                    $stateParams.id=StudentsDetail.id;
                },
                StudentsLanguages: function (StudentsId, studentsLanguagesService,$stateParams) {
                    studentsLanguagesService.studentsLanguages.filters={};
                    studentsLanguagesService.studentsLanguages.filters.page="all";
                    studentsLanguagesService.studentsLanguages.filters.student=$stateParams.id;
                    return studentsLanguagesService.getStudentsLanguages();
                },
                StudentsSkills: function (StudentsId, studentsSkillsService,$stateParams) {
                    studentsSkillsService.studentsSkills.filters={};
                    studentsSkillsService.studentsSkills.filters.page="all";
                    studentsSkillsService.studentsSkills.filters.student=$stateParams.id;
                    return studentsSkillsService.getStudentsSkills();
                },
                StudentsDegrees: function (StudentsId, studentsDegreesService, StudentsDetail) {
                    var degrees=StudentsDetail.degrees_data || [];
                    studentsDegreesService.studentsDegrees.data=degrees;
                    studentsDegreesService.studentsDegrees.count=degrees.length;
                    return studentsDegreesService.studentsDegrees;
                }
            },
            bodyClass: 'studentsDetail'
        })
        .state('app.students.myOffersRequests', {
            url      : '/offersRequests',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/students/myOffersRequests/myOffersRequests.html',
                    controller : 'MyOffersRequestsController as vm'
                }
            },
            resolve  : {
                StudentsId:function(StudentsDetail, $stateParams){
                    $stateParams.id=StudentsDetail.id;
                },
                MyOffersRequests: function (StudentsId, $rootScope, myOffersRequestsService, offersRequestsService, $stateParams) {
                    if($stateParams.id && $rootScope.hasPermission('offersRequests','LIST')){
                        offersRequestsService.offersRequests.filters={};
                        offersRequestsService.offersRequests.filters.student=$stateParams.id;
                        return offersRequestsService.getOffersRequests();
                    }else{
                        myOffersRequestsService.myOffersRequests.filters={};
                        return myOffersRequestsService.getMyOffersRequests();
                    }
                }
            },
            bodyClass: 'todo'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('studentsListService', studentsListService);

    /** @ngInject */
    function studentsListService($q, api, gettextCatalog) {

        var service = {
            studentsList: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances:[],
                exportFields:{}
            },
            getStudentsList: getStudentsList,
            getAllStudentsList: getAllStudentsList,
            getStudents: getStudents,
            saveStudentsDetail: saveStudentsDetail,
            saveGadesStudents: saveGadesStudents,
            collisionsStudents: collisionsStudents,
            getEmptyStudent: getEmptyStudent,
            removeStudents: removeStudents
        };

        return service;

        //////////

        /**
         * Obtiene el listado de studentsList
         */
        function getStudentsList() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.students,
                filters:service.studentsList.filtersAdvances
            };
            obj = Object.assign({}, obj, service.studentsList.filters);
            api.searchsAdvances.search(obj, getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                service.studentsList.data = response.results;
                service.studentsList.count = response.count;
                // service.studentsList.filtersAdvances = [];
                deferred.resolve(service.studentsList);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.studentsList.filters.page!=1){
                    service.studentsList.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de studentsList filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllStudentsList(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.studentsList.get({search:search,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una students determinado por su ID
         *
         * @param id
         */
        function getStudents(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.studentsList.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la students que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param studentsDetail
         */
        function saveStudentsDetail(studentsDetail) {
            var deferred = $q.defer();

            delete studentsDetail.logo;

            api.studentsList.update(studentsDetail, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Guarda la students que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param studentsDetail
         * @param edit
         */
        function saveGadesStudents(studentsDetail, edit) {
            var deferred = $q.defer();

            if(edit){
                studentsDetail.id=studentsDetail.identification;
                api.studentsList.updateGades(studentsDetail, updateOK, saveKO);
            }else{
                api.studentsList.createGades(studentsDetail, createOK, saveKO);
            }
            // api.studentsList.create(studentsDetail, updateOK, saveKO);

            return deferred.promise;

            function createOK(response) {

                service.studentsList.data.push(response);
                service.studentsList.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.studentsList.data.length; i++) {
                    if (service.studentsList.data[i].contact_student_data.identification === response.contact_student_data.identification) {
                        service.studentsList.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Guarda la students que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param identification
         */
        function collisionsStudents(identification) {
            var deferred = $q.defer();

            api.studentsList.collisions({identification:identification}, getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un students vacío
         */
        function getEmptyStudent() {
            return {
                identification_type:"NIF"
            };
        }
        
        function removeStudents(students){
            var deferred = $q.defer();

            api.studentsList.remove({id: students.contact_student}, studentsRemoveOK, removeKO);

            // students borrado correctamente
            function studentsRemoveOK(response){
                // Quitamos la students en los datos locales
                for (var i = 0; i < service.studentsList.data.length; i++) {
                    if (service.studentsList.data[i].id === students.id) {
                        service.studentsList.data.splice(i,1);
                        service.studentsList.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar students
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('studentsSkillsService', studentsSkillsService);

    /** @ngInject */
    function studentsSkillsService($q, api, gettextCatalog) {

        var service = {
            studentsSkills: {
                data: [],
                count: 0,
                filters: {}
            },
            getStudentsSkills: getStudentsSkills,
            getAllStudentsSkills: getAllStudentsSkills,
            getStudentsSkill: getStudentsSkill,
            saveStudentsSkill: saveStudentsSkill,
            getEmptyStudentsSkill: getEmptyStudentsSkill,
            removeStudentsSkill: removeStudentsSkill,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de studentsSkills
         */
        function getStudentsSkills() {
            // Create a new deferred object
            var deferred = $q.defer();
            service.studentsSkills.filters.page="all";
            api.studentsSkills.get(service.studentsSkills.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.studentsSkills.data = response.results;
                service.studentsSkills.count = response.count;

                deferred.resolve(service.studentsSkills);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.studentsSkills.filters.page!=1){
                    service.studentsSkills.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de studentsSkills filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllStudentsSkills(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.studentsSkills.filters);
            f.search=search;
            f.page="all";
            api.studentsSkills.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una studentsSkill determinado por su ID
         *
         * @param id
         */
        function getStudentsSkill(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.studentsSkills.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la studentsSkill que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveStudentsSkill(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.studentsSkills.update(form, updateOK, saveKO);
            } else {
                api.studentsSkills.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.studentsSkills.data.push(response);
                service.studentsSkills.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.studentsSkills.data.length; i++) {
                    if (service.studentsSkills.data[i].id === response.id) {
                        service.studentsSkills.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un studentsSkill vacío
         */
        function getEmptyStudentsSkill(student) {
            return {
                "student":student
            };
        }
        
        function removeStudentsSkill(studentsSkill){
            var deferred = $q.defer();

            api.studentsSkills.remove({id: studentsSkill.id}, studentsSkillRemoveOK, removeKO);

            // studentsSkill borrado correctamente
            function studentsSkillRemoveOK(response){
                // Quitamos la studentsSkill en los datos locales
                for (var i = 0; i < service.studentsSkills.data.length; i++) {
                    if (service.studentsSkills.data[i].id === studentsSkill.id) {
                        service.studentsSkills.data.splice(i,1);
                        service.studentsSkills.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar studentsSkill
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('studentsLanguagesService', studentsLanguagesService);

    /** @ngInject */
    function studentsLanguagesService($q, api, gettextCatalog) {

        var service = {
            studentsLanguages: {
                data: [],
                count: 0,
                filters: {}
            },
            getStudentsLanguages: getStudentsLanguages,
            getAllStudentsLanguages: getAllStudentsLanguages,
            getStudentsLanguage: getStudentsLanguage,
            saveStudentsLanguage: saveStudentsLanguage,
            getEmptyStudentsLanguage: getEmptyStudentsLanguage,
            removeStudentsLanguage: removeStudentsLanguage,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de studentsLanguages
         */
        function getStudentsLanguages() {
            // Create a new deferred object
            var deferred = $q.defer();
            service.studentsLanguages.filters.page="all";
            api.studentsLanguages.get(service.studentsLanguages.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.studentsLanguages.data = response.results;
                service.studentsLanguages.count = response.count;

                deferred.resolve(service.studentsLanguages);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.studentsLanguages.filters.page!=1){
                    service.studentsLanguages.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de studentsLanguages filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllStudentsLanguages(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.studentsLanguages.filters);
            f.search=search;
            f.page="all";
            api.studentsLanguages.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una studentsLanguage determinado por su ID
         *
         * @param id
         */
        function getStudentsLanguage(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.studentsLanguages.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la studentsLanguage que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveStudentsLanguage(form) {
            var deferred = $q.defer();

            form.language=form.language_data.id;
            delete form.language_data;

            if (form.id) {
                api.studentsLanguages.update(form, updateOK, saveKO);
            } else {
                api.studentsLanguages.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.studentsLanguages.data.push(response);
                service.studentsLanguages.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.studentsLanguages.data.length; i++) {
                    if (service.studentsLanguages.data[i].id === response.id) {
                        service.studentsLanguages.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un studentsLanguage vacío
         */
        function getEmptyStudentsLanguage(student) {
            return {
                "student":student
            };
        }

        function removeStudentsLanguage(studentsLanguage){
            var deferred = $q.defer();

            api.studentsLanguages.remove({id: studentsLanguage.id}, studentsLanguageRemoveOK, removeKO);

            // studentsLanguage borrado correctamente
            function studentsLanguageRemoveOK(response){
                // Quitamos la studentsLanguage en los datos locales
                for (var i = 0; i < service.studentsLanguages.data.length; i++) {
                    if (service.studentsLanguages.data[i].id === studentsLanguage.id) {
                        service.studentsLanguages.data.splice(i,1);
                        service.studentsLanguages.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar studentsLanguage
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('studentsDetailService', studentsDetailService);

    /** @ngInject */
    function studentsDetailService($q, api, gettextCatalog) {

        var service = {
            getStudentsDetail: getStudentsDetail,
            saveStudentsDetail: saveStudentsDetail
        };

        return service;

        //////////

        /**
        * Obtiene los datos basicos de la empresa
        */
        function getStudentsDetail() {
            var deferred = $q.defer();
            api.studentsDetail.get({}, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                deferred.resolve(response);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Guarda los datos basicos de la empresa que se pasan como parámetro.
         *
         * @param studentsDetail
         */
        function saveStudentsDetail(studentsDetail) {
            var deferred = $q.defer();

            delete studentsDetail.logo;
            api.studentsList.update(studentsDetail, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('studentsDegreesService', studentsDegreesService);

    /** @ngInject */
    function studentsDegreesService($q, api, gettextCatalog) {

        var service = {
            studentsDegrees: {
                data: [],
                count: 0,
                filters: {}
            },
            saveStudentsDegree: saveStudentsDegree,
            getEmptyStudentsDegree: getEmptyStudentsDegree,
            removeStudentsDegree: removeStudentsDegree
        };

        return service;

        //////////

        /**
         * Guarda la studentsDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveStudentsDegree(form) {
            var deferred = $q.defer();

            if(form.degree_data &&
                form.degree_data.subjects_data &&
                form.degree_data.subjects_data[0] &&
                form.degree_data.subjects_data[0].id){
                //Como son titulaciones gades solo tienen asignada una asignatura,
                // por lo que cogemos la primera que encontramos
                // (Cuando se crea una titulación gades se crea un asignatura con el mismo nombre para esa titulación)
                form.subject_codnum=form.degree_data.subjects_data[0].id;
            }
            delete form.degree_data;

            if (form.id) {
                api.studentsDegrees.update(form, updateOK, saveKO);
            } else {
                api.studentsDegrees.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                var obj=response.subject_data.degree;
                obj.registration=response.id;
                service.studentsDegrees.data.push(obj);
                service.studentsDegrees.count ++;
                deferred.resolve(obj);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.studentsDegrees.data.length; i++) {
                    if (service.studentsDegrees.data[i].id === response.id) {
                        service.studentsDegrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un studentDegree vacío
         */
        function getEmptyStudentsDegree(student) {
            return {
                "student":student
            };
        }

        function removeStudentsDegree(studentsDegree){
            var deferred = $q.defer();

            api.studentsDegrees.remove({id: studentsDegree.registration}, studentsDegreeRemoveOK, removeKO);

            // studentsDegree borrado correctamente
            function studentsDegreeRemoveOK(response){
                // Quitamos la studentsDegree en los datos locales
                for (var i = 0; i < service.studentsDegrees.data.length; i++) {
                    if (service.studentsDegrees.data[i].id === studentsDegree.id) {
                        service.studentsDegrees.data.splice(i,1);
                        service.studentsDegrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar studentsDegree
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .factory('myOffersRequestsService', myOffersRequestsService);

    /** @ngInject */
    function myOffersRequestsService($q, api, gettextCatalog) {

        var service = {
            myOffersRequests: {
                data: [],
                count: 0,
                filters: {}
            },
            getMyOffersRequests: getMyOffersRequests,
            getAllMyOffersRequests: getAllMyOffersRequests
        };

        return service;

        //////////

        /**
         * Obtiene el listado de myOffersRequests
         */
        function getMyOffersRequests() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.myOffersRequests.get(service.myOffersRequests.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.myOffersRequests.data = response.results;
                service.myOffersRequests.count = response.count;

                deferred.resolve(service.myOffersRequests);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.myOffersRequests.filters.page!=1){
                    service.myOffersRequests.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de myOffersRequests filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllMyOffersRequests(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.myOffersRequests.filters);
            f.search=search;
            f.page="all";
            api.myOffersRequests.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentsSkillDialogController', StudentsSkillDialogController);

    /** @ngInject */
    function StudentsSkillDialogController($mdDialog, StudentsSkill, studentsSkillsService, Student, skillsService, NotifyService, Categories, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar competencia');
        vm.categories=Categories;
        vm.skills=[];

        if (!StudentsSkill) {
            vm.title = gettextCatalog.getString('Nueva competencia');
            vm.studentsSkill = studentsSkillsService.getEmptyStudentsSkill(Student.id);
        } else {
            vm.studentsSkill = angular.copy(StudentsSkill); // Copiamos para no modificar el original hasta guardar
            loadSkills();
        }

        // Methods
        vm.saveStudentsSkill = saveStudentsSkill;
        vm.loadSkills = loadSkills;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar competencia
         */
        function saveStudentsSkill() {
            return studentsSkillsService.saveStudentsSkill(angular.copy(vm.studentsSkill)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Competencia guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la competencia. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Carga las competencias segun la categoría que haya seleccionada
         */
        function loadSkills() {
            skillsService.skills.filters={};
            skillsService.skills.filters.category=vm.studentsSkill.skill_data.category;
            skillsService.getAllSkills().then(function(res){
                vm.skills=res;
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentsLanguageDialogController', StudentsLanguageDialogController);

    /** @ngInject */
    function StudentsLanguageDialogController($mdDialog, StudentsLanguage, studentsLanguagesService, Student, languagesService, NotifyService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar idioma');

        if (!StudentsLanguage) {
            vm.title = gettextCatalog.getString('Nuevo idioma');
            vm.studentsLanguage = studentsLanguagesService.getEmptyStudentsLanguage(Student.id);
        } else {
            vm.studentsLanguage = angular.copy(StudentsLanguage); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveStudentsLanguage = saveStudentsLanguage;
        vm.getLanguages = getLanguages;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar competencia
         */
        function saveStudentsLanguage() {
            return studentsLanguagesService.saveStudentsLanguage(angular.copy(vm.studentsLanguage)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Idioma guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el idioma. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


        /**
         * Obtiene las competencias para rellenar el autocomplete
         */
        function getLanguages(searchText) {
            var deferred = $q.defer();
            languagesService.getAllLanguages(searchText).then(function(languages){
                deferred.resolve(languages);
            });
            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentsDegreeDialogController', StudentsDegreeDialogController);

    /** @ngInject */
    function StudentsDegreeDialogController($mdDialog, StudentsDegree, studentsDegreesService, Student, gadesDegreesService, NotifyService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar titulación');

        if (!StudentsDegree) {
            vm.title = gettextCatalog.getString('Nueva titulación');
            vm.studentsDegree = studentsDegreesService.getEmptyStudentsDegree(Student.contact_student);
        } else {
            vm.studentsDegree = angular.copy(StudentsDegree); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveStudentsDegree = saveStudentsDegree;
        vm.getDegrees = getDegrees;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar competencia
         */
        function saveStudentsDegree() {
            return studentsDegreesService.saveStudentsDegree(angular.copy(vm.studentsDegree)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


        /**
         * Obtiene las competencias para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            gadesDegreesService.getAllGadesDegrees(searchText).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentDialogController', StudentDialogController);

    /** @ngInject */
    function StudentDialogController($mdDialog, Student, studentsListService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar estudiante');
        vm.edit=false;
        vm.isDNIValid=false;
        vm.foundStudent={};

        if (!Student) {
            vm.title = gettextCatalog.getString('Nuevo estudiante');
            vm.student = studentsListService.getEmptyStudent();
        } else {
            vm.student = angular.copy(Student); // Copiamos para no modificar el original hasta guardar
            vm.edit=true;
        }

        // Methods
        vm.saveStudent = saveStudent;
        vm.closeDialog = closeDialog;
        vm.validDNI = validDNI;

        //////////
        /**
         * Guardar studiante
         */
        function saveStudent() {
            var obj=angular.copy(vm.student);
            //obtenemos el dni sin letra
            obj.dni_prs=obj.identification.substring(0, 8);
            return studentsListService.saveGadesStudents(obj,vm.edit).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Estudiante guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el estudiante. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function validDNI(identification) {
            //solo en el caso de que el dni tenga 9 caracteres o mas
            if(identification.length>8){
                return studentsListService.collisionsStudents(identification).then(function(res){
                    //si hay colisiones mostramos el error, y damos la posibilidad de enlazar con el estudiante
                    if(res.collision>0){
                        vm.isDNIValid=false;
                        vm.serverErrors={};
                        vm.serverErrors.identification=[res.msg];
                        vm.foundStudent=res.student;
                    }else{
                        //Si no hay colisiones mostramos el resto del formulario y limpiamos de errores
                        vm.isDNIValid=true;
                        vm.serverErrors={};
                    }

                }, function(error){
                    // si esto da algun tipo de fallo bloqueamos que pueda continuar
                    vm.isDNIValid=false;
                });
            }else{
                vm.isDNIValid=false;
            }
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.skills',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.skills', {
            url      : '/skills',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/skills/skills.html',
                    controller : 'SkillsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Skills: function (skillsService) {
                    return skillsService.getSkills();
                },
                SkillsTypes: function (categorySkillsService) {
                    return categorySkillsService.getAllCategorySkills();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.skills')
        .controller('SkillDialogController', SkillDialogController);

    /** @ngInject */
    function SkillDialogController($mdDialog, Skill, SkillsTypes, skillsService, categorySkillsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar competencia');
        vm.skillsTypes = SkillsTypes;
        vm.categorySkill = "";
        vm.showNewCategory=false;

        if (!Skill) {
            vm.title = gettextCatalog.getString('Nueva competencia');
            vm.skill = skillsService.getEmptySkill();
        } else {
            vm.skill = angular.copy(Skill); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveSkill = saveSkill;
        vm.saveCategorySkill = saveCategorySkill;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar compentencia
         */
        function saveSkill() {
            return skillsService.saveSkill(angular.copy(vm.skill)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Competencia guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la competencia. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Guardar categoria de competencia
         */
        function saveCategorySkill() {
            return categorySkillsService.saveCategorySkill(angular.copy(vm.categorySkill)).then(function(response){
                vm.skill.category=response.id;
                vm.categorySkill.name="";
                vm.showNewCategory=false;
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la categoria. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.searchsAdvances', {
            url      : '/searchsAdvances/:module',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/searchsAdvances/searchsAdvances.html',
                    controller : 'SearchsAdvancesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Module:function ($stateParams) {
                    return $stateParams.module;
                },
                SearchsAdvances: function (searchsAdvancesService,Module) {
                    return searchsAdvancesService.getSearchsAdvances(Module);
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances')
        .controller('SearchsAdvanceDialogController', SearchsAdvanceDialogController);

    /** @ngInject */
    function SearchsAdvanceDialogController($mdDialog, Report, Action, SearchsAdvances, searchsAdvancesService, $state, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Rellene estos datos para acceder al informe');
        vm.action=Action;
        if(vm.action==="export"){
            vm.title = gettextCatalog.getString('Rellene estos datos para exportar el informe');
        }

        vm.searchTabs = [];
        vm.searchsAdvances=SearchsAdvances;

        vm.report = angular.copy(Report);
        vm.report.data=JSON.parse(vm.report.data);

        init();

        // Methods
        vm.search = search;
        vm.existVariableField = existVariableField;
        vm.closeDialog = closeDialog;

        //////////

        function init(){
            //al menos debe haber un filtro
            if(vm.report.data.filters.length<1){
                vm.report.data.filters.push({});
            }

            for(var i in vm.report.data.filters){
                vm.searchTabs.push({});
            }
        }

        function existVariableField(field){
            return (vm.report.data.variables.indexOf(field)!==-1);
        }

        function search(){
            var config=searchsAdvancesService.getConfig(vm.report.endpoint);
            var form=vm.report.data.filters;
            for(var i in vm.searchTabs){
                for(var j in vm.searchTabs[i]){
                    var value=angular.copy(vm.searchTabs[i][j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.searchTabs[i][j].option==='range'){
                            var value_range=angular.copy(vm.searchTabs[i][j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[i][j + "__" + vm.searchTabs[i][j].option] = [value,value_range];
                        }else {
                            form[i][j + "__" + vm.searchTabs[i][j].option] = value;
                        }
                    }
                }
            }

            config.service[config.param].filtersAdvances=form;
            if(vm.action==="export"){
                $state.go("app.export",{module:vm.report.endpoint});
            }else{
                $state.go(config.state);
            }
            $mdDialog.hide();
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.roles',
            []
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider.state('app.roles', {
            url      : '/roles?&page&search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/roles/views/list/list.html',
                    controller : 'RolesListController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Roles: function(roleService, $stateParams){
                    // Configura el servicio con los filtros y parámetros de ordenación
                    roleService.roles.filters = angular.copy($stateParams);
                    return roleService.list();
                }
            },
            bodyClass: 'roles'
        });


        // State
        $stateProvider.state('app.roles.edit', {
            url      : '/edit/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/roles/views/edit/edit.html',
                    controller : 'RoleEditController as vm'
                }
            },
            resolve  : {
                Role: function(roleService, $stateParams){
                    // Configura el servicio con los filtros y parámetros de ordenación
                    return roleService.get($stateParams.id);
                },
                Permissions: function (contentTypeService) {
                    return contentTypeService.list();
                },
                Breadcrumb: function (Role) {
                    return ['<a ui-sref="app.roles"> Roles</a>',
                        Role.name];
                }
            },
            bodyClass: 'roles'
        });

        // State
        $stateProvider.state('app.roleUsers', {
            url      : '/roles/:id/?&page',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/roles/views/users/users.html',
                    controller : 'RoleUsersListController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Role: function(currentUser, roleService, $stateParams){
                    // Configura el servicio con los filtros y parámetros de ordenación
                    return roleService.get($stateParams.id);
                },
                Contacts : function(currentUser, contactService, $stateParams){
                    contactService.contacts.filters = {};
                    contactService.contacts.filters.groups__id__in = $stateParams.id;
                    contactService.contacts.filters.page = $stateParams.page;
                    return contactService.list();
                },
                Breadcrumb: function (Role) {
                    return ['<a ui-sref="app.roles"> Roles</a>',
                        Role.name];
                }
            },
            bodyClass: 'roles'
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('RoleUsersListController', RoleUsersListController);

    /** @ngInject */
    function RoleUsersListController(Role, api, Contacts, $q, contactService, $mdDialog, NotifyService, $document, $state, $scope, utils)
    {
        var vm = this;

        // Data
        vm.role = Role;
        vm.contacts = Contacts;
        vm.contactSearch = [];
        vm.hideFirstMessage = false;


        // Methods
        vm.filter = filter;
        vm.searchContact = searchContact;
        vm.addContact = addContact;
        vm.removeFromRole = removeFromRole;


        // Filtros


        // Ordenación de campos
        utils.filtersAndOrdering($scope, vm, "contactOrdering", contactService);

        function filter(){
            vm.hideFirstMessage = true;
            $state.go('.', vm.contacts.filters, {notify:false});
        }

        function searchContact(query){
            var deferred = $q.defer();
            if(query.length>2){
                return contactService.searchContact(query).then(function(data){
                    vm.contactSearch = data;
                    deferred.resolve(vm.contactSearch);
                });
            }else{
                vm.contactSearch = [];
                deferred.resolve(vm.contactSearch);
            }
            return deferred.promise;
        }


        function addContact(ev, contact){
            contact.groups_data.push(vm.role);
            contact.groups.push(vm.role.id);

            return contactService.saveContact(contact).then(function(){
                vm.contacts.data.push(contact);
                vm.contacts.count++;
                NotifyService.successMessage("Rol añadido al contacto correctamente.");
            }, function(error){
                NotifyService.errorMessage("Error al añadir el rol al contacto. " + (error.data.detail || ""));
            });
        }

        function removeFromRole(ev, contact){
            var index2 = contact.groups.indexOf(vm.role.id);
            if (index2 !== -1){
                contact.groups.splice(index2, 1);

                return contactService.saveContact(contact).then(function(data){
                    contact = data;
                    NotifyService.successMessage("Contacto eliminado del grupo correctamente.");
                    vm.contacts.data.splice(vm.contacts.data.map(function(x){return x.id}).indexOf(contact.id), 1);
                    vm.contacts.count--;
                }, function(error){
                    NotifyService.errorMessage("Error al eliminar el rol al contacto. " + (error.data.detail || ""));
                });
            }
        }




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('RolesListController', RolesListController);

    /** @ngInject */
    function RolesListController(Roles, $document, $mdDialog, $mdSidenav, roleService, NotifyService, $state, $scope, utils)
    {

        var vm = this;

        // Data
        vm.roles = Roles;

        // Methods
        vm.filter = filter;
        vm.newRole = openRoleDialog;
        vm.editRole = openRoleDialog;
        vm.removeRole = removeRole;
        vm.toggleSidenav = toggleSidenav;

        // Filtros


        // Ordenación de campos
        utils.filtersAndOrdering($scope, vm, "roleOrdering", roleService);

        function filter(){
            $state.go('.', vm.roles.filters, {notify:false});
        }

        function openRoleDialog(ev, role) {
            $mdDialog.show({
                controller: 'RoleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/roles/dialogs/role/role-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Role: role,
                    event: ev
                }
            });
        }

        function removeRole(ev, role) {
            var confirm = $mdDialog.confirm()
                .title('Eliminar rol')
                .textContent('¿Seguro que quieres eliminar el rol:  ' + role.name + ' ?')
                .ariaLabel('Eliminar rol')
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok('Borrar rol')
                .cancel('Cancelar');

            $mdDialog.show(confirm).then(function () {
                roleService.remove(role).then(function () {
                    NotifyService.successMessage("Rol borrado correctamente.");
                }, function (error) {
                    NotifyService.errorMessage("Error al borrar el rol. " + (error.data.detail || ""));
                });
            });
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.roles')
        .controller('RoleEditController', RoleEditController);

    /** @ngInject */
    function RoleEditController(Role, Permissions, $filter, roleService, NotifyService, $state)
    {
        var vm = this;

        vm.role = Role;
        vm.permissions = Permissions.data;

        // Methods
        vm.addPermissions = addPermissions;
        vm.removePermissions = removePermissions;
        vm.filterPermissions = filterPermissions;
        vm.save = save;

        //////////

        function save(){
            return roleService.save(vm.role).then(function(){
                NotifyService.successMessage("Rol guardado correctamente.");
                $state.go("^");
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al guardar el rol. " + (error.data.non_field_errors || ""));
            });
        }

        function addPermissions(){
            angular.forEach(vm.permissions, function(permission){
                if (permission.selected){
                    permission.selected = false;
                    vm.role.permissions_groups_data.push(angular.copy(permission));
                }
            });
        }

        function removePermissions(){

            for (var i = vm.role.permissions_groups_data.length -1; i>=0; i--){
                if (vm.role.permissions_groups_data[i].selected){
                    vm.role.permissions_groups_data.splice(i, 1);
                }
            }
        }

        function filterPermissions(permission){

            var found = $filter('filter')(vm.role.permissions_groups_data, {key: permission.key}, true);
            if (found.length) {
                return false;
            } else {
                return true;
            }
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.roles')
        .controller('RoleDialogController', RoleDialogController);

    /** @ngInject */
    function RoleDialogController($mdDialog, AuthService, Role, roleService, NotifyService) {
        var vm = this;

        // Data
        vm.title = 'Editar Rol';
        vm.newRole = false;
        vm.user = AuthService.currentUser;

        // Decide si es nuevo o es una edición
        if (!Role) {
            vm.role = {};
            vm.title = 'Nuevo Rol';
            vm.newRole = true;
        } else {
            vm.role = angular.copy(Role); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;

        //////////


        function save() {
            return roleService.save(vm.role).then(function(){
                NotifyService.successMessage("Rol guardado correctamente.");
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al guardar el rol. " + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.reports', {
            url      : '/reports',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/reports/reports.html',
                    controller : 'ReportsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Reports: function (reportsService) {
                    return reportsService.getReports();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportDialogController', ReportDialogController);

    /** @ngInject */
    function ReportDialogController($mdDialog, Report, SearchsAdvances, reportsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar informe');
        vm.searchsAdvances=SearchsAdvances;

        vm.report = angular.copy(Report); // Copiamos para no modificar el original hasta guardar
        if (!Report.name) {
            vm.title = gettextCatalog.getString('Nuevo informe');
        }else{
            vm.report.data=JSON.parse(vm.report.data);
        }

        init();

        // Methods
        vm.saveReport = saveReport;
        vm.closeDialog = closeDialog;

        //////////

        /*
        * Inicializamos los checkboxes de los campos que son variables
        * */
        function init(){
            for(var i in vm.report.data.variables){
                for(var j in vm.searchsAdvances){
                    if(vm.report.data.variables[i]===vm.searchsAdvances[j].field_name){
                        vm.searchsAdvances[j].variable=true;
                    }
                }
            }
        }

        /**
         * Guardar informe
         */
        function saveReport() {

            // Tratamos los checkboxes, si ya no está lo borramos y si está y no está ya añadido lo añadimos
            // Quizás con un array asociativo se resuelva mejor esto.
            for(var i in vm.searchsAdvances){
                var index = vm.report.data.variables.indexOf(vm.searchsAdvances[i].field_name);
                if(vm.searchsAdvances[i].variable && index===-1){
                    vm.report.data.variables.push(vm.searchsAdvances[i].field_name);
                }else if(!vm.searchsAdvances[i].variable){
                    if (index > -1) {
                      vm.report.data.variables.splice(index, 1);
                    }
                }
            }

            return reportsService.saveReport(angular.copy(vm.report)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Informe guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el informe. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.pyconfrests',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.pyconfrests', {
            url      : '/category/:category/pyconfrests',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pyconfrests/pyconfrests.html',
                    controller : 'PyconfrestsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Categories: function (pyconfrestCategoriesService) {
                    return pyconfrestCategoriesService.getPyconfrestCategories();
                },
                Pyconfrests: function (Categories, pyconfrestsService, $stateParams) {
                    if(Categories.count>0 && !$stateParams.category){
                        $stateParams.category=Categories.data[0].pk;
                    }
                    if($stateParams.category){
                        return pyconfrestsService.getPyconfrests($stateParams.category);
                    }
                    return pyconfrestsService.pyconfrests;
                },
                CloneAcademicYear: function (currentUser, $rootScope, cloneAcademicYearsService) {
                    if ($rootScope.hasPermission("cloneAcademicYears","POST")) {
                        return cloneAcademicYearsService.saveCloneAcademicYear().then(function (res) {
                            return true;
                        }, function () {
                            return false;
                        });
                    }
                    return false;
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.pyconfrests')
        .controller('PyconfrestDialogController', PyconfrestDialogController);

    /** @ngInject */
    function PyconfrestDialogController($mdDialog, Pyconfrest, pyconfrestsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        // Data
        // vm.taToolbar = [
        //     ['bold', 'italics', 'underline', 'ul', 'ol', 'insertLink', 'redo', 'undo', 'clear']
        // ];
        vm.taToolbar = [
            ['bold', 'italics', 'underline']
        ];

        vm.title = gettextCatalog.getString('Editar variable');
        vm.pyconfrest = angular.copy(Pyconfrest); // Copiamos para no modificar el original hasta guardar

        if(vm.pyconfrest.type==='DateField'){
            vm.pyconfrest.value=new Date(vm.pyconfrest.value);
        }


        // Methods
        vm.savePyconfrest = savePyconfrest;
        vm.isRt = isRt;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar pyconfresto
         */
        function savePyconfrest() {
            var obj={
                "id":vm.pyconfrest.id
            };
            obj[vm.pyconfrest.key]=vm.pyconfrest.value;
            if(vm.pyconfrest.type==='DateField'){
                obj[vm.pyconfrest.key]=moment(vm.pyconfrest.value).format("YYYY-MM-DD");
            }
            return pyconfrestsService.savePyconfrest(obj).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Variable guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la variable. ") + (error.data.non_field_errors || ""));
            });
        }

        function isRt(key){
            var arr=key.split("_");
            return arr[arr.length-1]==="rt";
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.programs',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.programs', {
            url      : '/programs',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/programs/programs.html',
                    controller : 'ProgramsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Programs: function (programsService) {
                    programsService.programs.filters={};
                    return programsService.getPrograms();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.programs')
        .controller('ProgramXlsDialogController', ProgramXlsDialogController);

    /** @ngInject */
    function ProgramXlsDialogController($scope, $mdDialog, Program, programsService, type, NotifyService, $timeout, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Configurar empresas autorizadas');
        if(type==='student'){
            vm.title = gettextCatalog.getString('Configurar alumnos autorizados');
        }

        vm.programXls = programsService.getEmptyProgramXls(Program,type);
        vm.type = type;


        // Methods
        vm.saveProgramXls = saveProgramXls;
        vm.closeDialog = closeDialog;
        vm.openFiles = openFiles;

        init();

        //////////
        function init(){
            $timeout(function(){
                $("#file-uploader").change(function(){
                    readURL(this);
                });
            });
        }

        /**
         * Guardar programXlso
         */
        function saveProgramXls() {
            return programsService.loadXls(angular.copy(vm.programXls)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Configuración guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function openFiles(){
            $("#file-uploader").trigger("click");
        }

        /**
         * Image change
         * @param input
         */
        function readURL(input)
        {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    vm.programXls.file = e.target.result;

                    if(!$scope.$$phase) {
                        $scope.$digest();
                    }
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.programs')
        .controller('ProgramManagerDialogController', ProgramManagerDialogController);

    /** @ngInject */
    function ProgramManagerDialogController($scope, $mdDialog, ProgramManagers, Program, programManagersService, NotifyService,
                                            $document, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Gestores de programa');
        vm.programManagers = ProgramManagers;
        vm.programManager = programManagersService.getEmptyProgramManager(Program.id);

        // Methods
        vm.saveProgramManager = saveProgramManager;
        vm.closeDialog = closeDialog;
        vm.removeProgramManager = removeProgramManager;

        //////////

        /**
         * Guardar opción
         */
        function saveProgramManager() {
            return programManagersService.saveProgramManager(vm.programManager).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Gestor guardado correctamente"));
                vm.programManager = programManagersService.getEmptyProgramManager(Program.id);
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar al gestor. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Elimina una opcion
         *
         * @param ev
         * @param programManager
         */
        function removeProgramManager(ev, programManager) {

            programManagersService.removeProgramManager(programManager).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Gestor borrado correctamente."));
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al borrar al gestor. ") + (error.data.detail || "") + (error.data.error || ""));
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.programs')
        .controller('ProgramDialogController', ProgramDialogController);

    /** @ngInject */
    function ProgramDialogController($mdDialog, Program, programsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar programa');

        if (!Program) {
            vm.title = gettextCatalog.getString('Nuevo programa');
            vm.program = programsService.getEmptyProgram();
        } else {
            vm.program = angular.copy(Program); // Copiamos para no modificar el original hasta guardar
            vm.program.start_date= moment(vm.program.start_date).toDate();
            vm.program.end_date= moment(vm.program.end_date).toDate();
        }

        // Methods
        vm.saveProgram = saveProgram;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar programo
         */
        function saveProgram() {
            return programsService.saveProgram(angular.copy(vm.program)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Programa guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el programa. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersTemplates',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.offersTemplates', {
            url      : '/offers/:offer/offersTemplates',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/offersTemplates/offersTemplates.html',
                    controller : 'OffersTemplatesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Offer: function (offersService,$stateParams) {
                    return offersService.getOffer($stateParams.offer);
                },
                OffersTemplates: function (offersTemplatesService, $stateParams) {
                    offersTemplatesService.offersTemplates.filters={};
                    offersTemplatesService.offersTemplates.filters.offer=$stateParams.offer;
                    return offersTemplatesService.getOffersTemplates();
                },
                Breadcrumb: function (Offer) {
                    return ['<a ui-sref="app.offers"> Ofertas extracurriculares</a>',
                        'Candidatos de la oferta '+Offer.code];
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersTemplates')
        .controller('OffersTemplateDialogController', OffersTemplateDialogController);

    /** @ngInject */
    function OffersTemplateDialogController($mdDialog, OffersTemplate, Offer, offersTemplatesService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Guardar plantilla');

        if (!OffersTemplate) {
            vm.title = gettextCatalog.getString('Guardar plantilla');
            vm.offersTemplate = offersTemplatesService.getEmptyOffersTemplate(Offer.id);
        } else {
            vm.offersTemplate = angular.copy(OffersTemplate); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveOffersTemplate = saveOffersTemplate;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar offersTemplateo
         */
        function saveOffersTemplate() {
            return offersTemplatesService.saveOffersTemplate(angular.copy(vm.offersTemplate)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Plantilla guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la plantilla. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersRequests',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.offersRequests', {
            url      : '/offers/:offer/offersRequests',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/offersRequests/offersRequests.html',
                    controller : 'OffersRequestsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Offer: function (offersService,$stateParams) {
                    return offersService.getOffer($stateParams.offer);
                },
                OffersRequests: function (offersRequestsService, $stateParams) {
                    offersRequestsService.offersRequests.filters={};
                    offersRequestsService.offersRequests.filters.offer=$stateParams.offer;
                    return offersRequestsService.getOffersRequests();
                },
                Breadcrumb: function (Offer) {
                    return ['<a ui-sref="app.offers"> Ofertas extracurriculares</a>',
                        'Candidatos de la oferta '+Offer.code];
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersRequests')
        .controller('OffersStudentDialogController', OffersStudentDialogController);

    /** @ngInject */
    function OffersStudentDialogController($mdDialog, OffersStudent, offersRequestsService, studentsLanguagesService,
                                           $rootScope, studentsSkillsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Ficha de alumno');
        vm.offersStudent = angular.copy(OffersStudent); // Copiamos para no modificar el original hasta guardar
        vm.studentsLanguages=[];
        vm.studentsSkills=[];
        $rootScope.getPhoto(vm.offersStudent.student,vm);

        if(vm.offersStudent.visible){
            studentsLanguagesService.studentsLanguages.filters={};
            studentsLanguagesService.studentsLanguages.filters.page="all";
            studentsLanguagesService.studentsLanguages.filters.student=OffersStudent.student_data.id;
            studentsLanguagesService.getStudentsLanguages().then(function(response){
                vm.studentsLanguages=response;
            });

            studentsSkillsService.studentsSkills.filters={};
            studentsSkillsService.studentsSkills.filters.page="all";
            studentsSkillsService.studentsSkills.filters.student=OffersStudent.student_data.id;
            studentsSkillsService.getStudentsSkills().then(function(response){
                vm.studentsSkills=response;
            });
        }

        // Methods
        vm.saveOffersStudent = saveOffersStudent;
        vm.confirmRequest = confirmRequest;
        vm.closeDialog = closeDialog;
        vm.getDocument = $rootScope.getDocument;
        vm.isPrintable = $rootScope.isPrintable;
        vm.printDocument = $rootScope.printDocument;
        vm.hasPermission = $rootScope.hasPermission;

        //////////

        /**
         * Cambia el estado de un offersStudent
         */
        function saveOffersStudent(status) {
            var obj={};
            obj.id=vm.offersStudent.id;
            obj.status=status;

            return offersRequestsService.saveOffersRequest(obj).then(function(response){
                if(status && status==='selected'){
                    NotifyService.successMessage(gettextCatalog.getString("Alumno seleccionado correctamente"));
                }else if(status && status==='pre-selected'){
                    NotifyService.successMessage(gettextCatalog.getString("Alumno preseleccionado correctamente"));
                }else if(status && status==='discarded'){
                    NotifyService.successMessage(gettextCatalog.getString("Alumno descartado correctamente"));
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Accion realizada correctamente"));
                }
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                if(status && status==='selected'){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al seleccionar alumno. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }else if(status && status==='pre-selected'){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al preseleccionar alumno. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }else if(status && status==='discarded'){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al descartar alumno. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }
            });
        }

        function confirmRequest(){
            var obj={};
            obj.id=vm.offersStudent.id;
            return offersRequestsService.confirmRequest(obj).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Accion realizada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.offersRequests')
        .controller('OffersRequestDialogController', OffersRequestDialogController);

    /** @ngInject */
    function OffersRequestDialogController($mdDialog, OffersRequest, Offer, offersRequestsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar candidato');

        if (!OffersRequest) {
            vm.title = gettextCatalog.getString('Nuevo candidato');
            vm.offersRequest = offersRequestsService.getEmptyOffersRequest(Offer.id);
        } else {
            vm.offersRequest = angular.copy(OffersRequest); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveOffersRequest = saveOffersRequest;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar offersRequesto
         */
        function saveOffersRequest() {
            return offersRequestsService.saveOffersRequest(angular.copy(vm.offersRequest)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Candidato guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el candidato. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.offers', {
            url      : '/offers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/offers/views/list/offers.html',
                    controller : 'OffersController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Offers: function (offersService) {
                    offersService.offers.filters={};
                    var obj={status__iexact:"published"};
                    var concat=[Object.assign({}, obj, offersService.offers.filtersAdvances[0])];
                    offersService.offers.filtersAdvances[0]=concat[0];
                    return offersService.getOffers();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('offers');
                }
            },
            bodyClass: 'todo'
        })
        .state('app.offer', {
            url      : '/offers/:id/?student',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/offers/views/detail/offer.html',
                    controller : 'OfferController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Offer: function (offersService,$stateParams) {
                    return offersService.getOffer($stateParams.id);
                },
                OffersDegrees: function (offersDegreesService,$stateParams) {
                    offersDegreesService.offersDegrees.filters={};
                    offersDegreesService.offersDegrees.filters.page="all";
                    offersDegreesService.offersDegrees.filters.offer=$stateParams.id;
                    return offersDegreesService.getOffersDegrees();
                },
                OffersSkills: function (offersSkillsService,$stateParams) {
                    offersSkillsService.offersSkills.filters={};
                    offersSkillsService.offersSkills.filters.page="all";
                    offersSkillsService.offersSkills.filters.offer=$stateParams.id;
                    return offersSkillsService.getOffersSkills();
                },
                OffersLanguages: function (offersLanguagesService,$stateParams) {
                    offersLanguagesService.offersLanguages.filters={};
                    offersLanguagesService.offersLanguages.filters.page="all";
                    offersLanguagesService.offersLanguages.filters.offer=$stateParams.id;
                    return offersLanguagesService.getOffersLanguages();
                },
                MyOfferRequest: function (myOffersRequestsService, offersRequestsService, $stateParams) {
                    if($stateParams.student){
                        offersRequestsService.offersRequests.filters={};
                        offersRequestsService.offersRequests.filters.page="all";
                        offersRequestsService.offersRequests.filters.student=$stateParams.student;
                        offersRequestsService.offersRequests.filters.offer=$stateParams.id;
                        return offersRequestsService.getOffersRequests().then(function(response){
                            return response.data[0];
                        });
                    }else{
                        myOffersRequestsService.myOffersRequests.filters={};
                        myOffersRequestsService.myOffersRequests.filters.page="all";
                        myOffersRequestsService.myOffersRequests.filters.offer=$stateParams.id;
                        return myOffersRequestsService.getMyOffersRequests().then(function(response){
                            return response.data[0];
                        });
                    }
                },
                Breadcrumb: function (Offer) {
                    return ['<a ui-sref="app.offers"> Ofertas extracurriculares</a>',
                        'Oferta '+Offer.code];
                }
            },
            bodyClass: 'todo'
        })

        .state('app.offerEdit', {
            url      : '/offers/:id/edit',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/offers/views/edit/offer.html',
                    controller : 'OfferEditController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Offer: function (offersService,$stateParams) {
                    return offersService.getOffer($stateParams.id);
                },
                OffersDegrees: function (offersDegreesService,$stateParams) {
                    offersDegreesService.offersDegrees.filters={};
                    offersDegreesService.offersDegrees.filters.page="all";
                    offersDegreesService.offersDegrees.filters.offer=$stateParams.id;
                    return offersDegreesService.getOffersDegrees();
                },
                OffersSkills: function (offersSkillsService,$stateParams) {
                    offersSkillsService.offersSkills.filters={};
                    offersSkillsService.offersSkills.filters.page="all";
                    offersSkillsService.offersSkills.filters.offer=$stateParams.id;
                    return offersSkillsService.getOffersSkills();
                },
                OffersLanguages: function (offersLanguagesService,$stateParams) {
                    offersLanguagesService.offersLanguages.filters={};
                    offersLanguagesService.offersLanguages.filters.page="all";
                    offersLanguagesService.offersLanguages.filters.offer=$stateParams.id;
                    return offersLanguagesService.getOffersLanguages();
                },
                OffersRequests: function (offersRequestsService, $stateParams) {
                    offersRequestsService.offersRequests.filters={};
                    offersRequestsService.offersRequests.filters.page="all";
                    offersRequestsService.offersRequests.filters.status__in="selected,accepted";
                    offersRequestsService.offersRequests.filters.offer=$stateParams.id;
                    return offersRequestsService.getOffersRequests();
                },
                Centers: function (centersService, Offer) {
                    centersService.centers.filters={};
                    centersService.centers.filters.company=Offer.company.id;
                    // return centersService.getAllCenters();
                    return centersService.getCenters().then(function(res){
                        if(res.count>10){
                            return [];
                        }
                        return res.data;
                    });

                },
                Tutors: function (contactsService,Offer) {
                    contactsService.contacts.filters={};
                    contactsService.contacts.filters.professional_tutor='True';
                    contactsService.contacts.filters.company=Offer.company.id;
                    // return contactsService.getAllContacts();
                    return contactsService.getContacts().then(function(res){
                        if(res.count>10){
                            return [];
                        }
                        return angular.copy(res.data);
                    });
                },
                ManagementContacts: function (contactsService,Offer) {
                    contactsService.contacts.filters={};
                    contactsService.contacts.filters.company_manager='True';
                    contactsService.contacts.filters.company=Offer.company.id;
                    // return contactsService.getAllContacts();
                    return contactsService.getContacts().then(function(res){
                        if(res.count>10){
                            return [];
                        }
                        return angular.copy(res.data);
                    });
                },
                Breadcrumb: function (Offer) {
                    return ['<a ui-sref="app.offers"> Ofertas extracurriculares</a>',
                        'Oferta '+Offer.code];
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.offers')
        .controller('OffersController', OffersController);
    /** @ngInject */
    function OffersController($scope, currentUser, offersService, Offers, NotifyService, programsService, $mdDialog,
                              SearchsBasics, $rootScope, $document, DebounceService, $state, $timeout, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.offers=Offers;
        vm.searchsBasics=SearchsBasics;

        init();

        // Watchers
        $scope.$watch('vm.offers.filters', DebounceService(offersService.getOffers, 300), true);

        // Methods
        vm.openOfferDialog = openOfferDialog;
        vm.removeOffer = removeOffer;
        vm.go = go;
        vm.search = search;

        //////////
        function init(){
            $timeout(function(){
                //Si no se muestra el búscador no filtramos por este estado ya que no podremos cambiarlo
                if(vm.filterBasic && vm.filterBasic['status']){
                    vm.filterBasic['status'].value='published';
                }

                var form=[{}];

                for(var j in vm.filterBasic){
                    var value=angular.copy(vm.filterBasic[j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.filterBasic[j].option==='range'){
                            var value_range=angular.copy(vm.filterBasic[j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                        }else {
                            form[0][j+"__"+vm.filterBasic[j].option]=value;
                        }
                    }
                }

                vm.offers.filtersAdvances=form;
            });
        }

        /**
         * Abre el dialogo para crear una offer
         *
         * @param ev
         */
        function openOfferDialog(ev) {
            programsService.programs.filters={};
            programsService.programs.filters.active=1;
            $mdDialog.show({
                controller: 'OfferDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offers/dialogs/offer/offer-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Programs:programsService.getPrograms(),
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una offer
         *
         * @param ev
         * @param offer
         */
        function removeOffer(ev, offer) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar oferta'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la oferta?'))
                .ariaLabel(gettextCatalog.getString('Eliminar oferta'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar oferta'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                offersService.removeOffer(offer).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Oferta borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la oferta. " + (error.data.detail || ""));
                });
            });
        }

        /**
         * Redirecciona al detalle de la oferta dependiendo de los permismos que tenga
         *
         * @param offer
         */
        function go(offer) {
            if($rootScope.hasPermission('offers','PATCH')){
                $state.go("app.offerEdit",{id:offer.id});
            }else if($rootScope.hasPermission('offers','GET')){
                $state.go("app.offer",{id:offer.id});
            }

        }
        
        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.offers.filtersAdvances=form;
            vm.offers.filters={};
            vm.offers.filters.page=1;
            return offersService.getOffers();
        }



    }
})();
(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OfferEditController', OfferEditController);

    /** @ngInject */
    function OfferEditController(currentUser, Offer, offersService, OffersRequests, offersRequestsService, OffersSkills,
                             offersSkillsService, NotifyService, offersDegreesService, Centers, Tutors, ManagementContacts,
                             $rootScope, categorySkillsService, tutorsService, OffersDegrees, OffersLanguages,
                             centersService, contactsService,
                             offersLanguagesService, $mdSidenav, $mdDialog, $document, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.UCA_COMPANY_CIF = $rootScope.UCA_COMPANY_CIF;
        vm.offer = formatOffer(Offer);
        vm.offersDegrees = OffersDegrees;
        vm.offersSkills = OffersSkills;
        vm.offersLanguages = OffersLanguages;
        vm.offersRequests = OffersRequests;
        vm.messageCofinance="";

        vm.disabledInputs=(vm.offer.status!=='draft' && !$rootScope.hasPermission('editOffersPublished','PATCH'));

        vm.centers=Centers;

        vm.tutors=Tutors;
        vm.managementContacts=ManagementContacts;

        init();

        // Methods
        vm.saveOffer = saveOffer;
        vm.openOffersDegreeDialog = openOffersDegreeDialog;
        vm.removeOffersDegree = removeOffersDegree;
        vm.openOffersSkillDialog = openOffersSkillDialog;
        vm.removeOffersSkill = removeOffersSkill;
        vm.openOffersLanguageDialog = openOffersLanguageDialog;
        vm.removeOffersLanguage = removeOffersLanguage;
        vm.openOffersRequestDialog = openOffersRequestDialog;
        vm.removeOffersRequest = removeOffersRequest;
        vm.toggleSidenav = toggleSidenav;
        vm.publishOffer = publishOffer;
        vm.confirmOffer = confirmOffer;
        vm.openOffersStudentDialog = openOffersStudentDialog;
        vm.getTutors = getTutors;
        vm.getFullNameTutor = getFullNameTutor;
        vm.cofinancingCalculate = cofinancingCalculate;
        vm.getTotalHours = getTotalHours;
        vm.durationBlur = durationBlur;
        vm.openOffersTemplateDialog = openOffersTemplateDialog;
        vm.getCenters = getCenters;
        vm.getFullNameCenter = getFullNameCenter;
        vm.getProfessionalTutors = getProfessionalTutors;
        vm.getManagementContacts = getManagementContacts;
        vm.updateDurationDays = updateDurationDays;

        //////////

        function init() {
            if(!vm.offer.duration){
                vm.offer.duration=(vm.offer.program_data.cofinancing_max_months || 6)*30;
            }
            // Entrada meses+días: derivada de la duración en días (mes fijo de 30 días)
            vm.durationMonths=Math.floor(vm.offer.duration/30);
            vm.durationDays=vm.offer.duration%30;
            if(!vm.offer.economic_endowment){
                vm.offer.economic_endowment=vm.offer.program_data.min_monthly_payment;
            }

            getTotalHours();
            cofinancingCalculate();
        }

        /**
         * Da el formato necesario a la oferta para poder trabajar con ella
         */
        function formatOffer(offer) {
            var a = angular.copy(offer);
            a.start_date=a.start_date ? new Date(moment(a.start_date).format()) : new Date();
            a.start_date_interruption=a.start_date_interruption ? new Date(moment(a.start_date_interruption).format()) : new Date();
            a.end_date_interruption=a.end_date_interruption ? new Date(moment(a.end_date_interruption).format()) : new Date();
            a.accept=(a.accepted_regulations===a.normative);
            vm.disabledInputs=(a.status!=='draft' && !$rootScope.hasPermission('editOffersPublished','PATCH'));
            return a;
        }

        /**
         * Guardar detalle de empresa
         */
        function saveOffer(successCallback, errorCallback) {
            var offer=angular.copy(vm.offer);
            if(offer.start_date){
                offer.start_date=moment(offer.start_date).format("YYYY-MM-DD");
            }
            if(offer.start_date_interruption && offer.end_date_interruption){
                offer.start_date_interruption=moment(offer.start_date_interruption).format("YYYY-MM-DD");
                offer.end_date_interruption=moment(offer.end_date_interruption).format("YYYY-MM-DD");
            }
            if(offer.accept){
                offer.accepted_regulations=offer.normative;
            }else{
                offer.accepted_regulations=null;
            }
            return offersService.saveOffer(offer).then(function(response){
                vm.offer=formatOffer(response);
                if(successCallback){
                    successCallback(response);
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Oferta guardada correctamente"));
                }
            }, function(error){
                vm.serverErrors = durationServerErrors(error.data);
                if(errorCallback){
                    errorCallback(error);
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error al guardar oferta. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                }
            });
        }

        /**
         * Publicar oferta
         */
        function publishOffer() {
            var offer=angular.copy(vm.offer);
            if(offer.start_date){
                offer.start_date=moment(offer.start_date).format("YYYY-MM-DD");
            }
            if(offer.start_date_interruption && offer.end_date_interruption){
                offer.start_date_interruption=moment(offer.start_date_interruption).format("YYYY-MM-DD");
                offer.end_date_interruption=moment(offer.end_date_interruption).format("YYYY-MM-DD");
            }
            if(offer.accept){
                offer.accepted_regulations=offer.normative;
            }else{
                offer.accepted_regulations=null;
            }
            return offersService.publishOffer(offer).then(function(response){
                vm.offer=formatOffer(response);
                NotifyService.successMessage(gettextCatalog.getString("Oferta solicitada correctamente"));
            }, function(error){
                vm.serverErrors = durationServerErrors(error.data);
                NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar oferta. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Publicar oferta
         */
        function confirmOffer() {
            var offer=angular.copy(vm.offer);
            return offersService.confirmOffer(offer).then(function(response){
                vm.offer=formatOffer(response);
                NotifyService.successMessage(gettextCatalog.getString("Oferta confirmada correctamente"));
            }, function(error){
                vm.serverErrors = durationServerErrors(error.data);
                NotifyService.errorMessage(gettextCatalog.getString("Error al confirmar oferta. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }


        /**
         * Abre el dialogo para crear una titulación
         *
         * @param ev
         * @param offersDegree
         */
        function openOffersDegreeDialog(ev, offersDegree) {
            $mdDialog.show({
                controller: 'OffersDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offers/dialogs/offersDegree/offersDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Offer: Offer,
                    event: ev,
                    OffersDegree: offersDegree
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una titulación
         *
         * @param ev
         * @param offersDegree
         */
        function removeOffersDegree(ev, offersDegree) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar titulación'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la titulación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar titulación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar titulación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                offersDegreesService.removeOffersDegree(offersDegree).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Titulación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la titulación. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para crear una competencia
         *
         * @param ev
         * @param offersSkill
         */
        function openOffersSkillDialog(ev, offersSkill) {
            $mdDialog.show({
                controller: 'OffersSkillDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offers/dialogs/offersSkill/offersSkill-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Offer: Offer,
                    Categories: categorySkillsService.getAllCategorySkills(),
                    event: ev,
                    OffersSkill: offersSkill
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una competencia
         *
         * @param ev
         * @param offersSkill
         */
        function removeOffersSkill(ev, offersSkill) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar competencia'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la competencia?'))
                .ariaLabel(gettextCatalog.getString('Eliminar competencia'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar competencia'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                offersSkillsService.removeOffersSkill(offersSkill).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Competencia borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la competencia. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para crear un idioma
         *
         * @param ev
         * @param offersLanguage
         */
        function openOffersLanguageDialog(ev, offersLanguage) {
            $mdDialog.show({
                controller: 'OffersLanguageDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offers/dialogs/offersLanguage/offersLanguage-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Offer: Offer,
                    event: ev,
                    OffersLanguage: offersLanguage
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una idioma
         *
         * @param ev
         * @param offersLanguage
         */
        function removeOffersLanguage(ev, offersLanguage) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar idioma'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el idioma?'))
                .ariaLabel(gettextCatalog.getString('Eliminar idioma'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar idioma'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                offersLanguagesService.removeOffersLanguage(offersLanguage).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Idioma borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el idioma. " + (error.data.detail || ""));
                });
            });

        }


        /**
         * Abre el dialogo para crear una competencia
         *
         * @param ev
         * @param offersRequest
         */
        function openOffersRequestDialog(ev, offersRequest) {
            $mdDialog.show({
                controller: 'OffersRequestDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offersRequests/dialogs/offersRequest/offersRequest-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Offer: Offer,
                    event: ev,
                    OffersRequest: offersRequest
                }
            });
        }

        /**
         * Abre el dialogo para descartar un alumno
         *
         * @param ev
         * @param offersRequest
         */
        function removeOffersRequest(ev, offersRequest) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Descartar alumno'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres descartar al alumno?'))
                .ariaLabel(gettextCatalog.getString('Descartar alumno'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Descartar alumno'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                offersRequestsService.removeOffersRequest(offersRequest).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Alumno descartado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al descartar el alumno. " + (error.data.detail || ""));
                });
            });
        }

        /**
         * Abre la ficha de un alumno con relación a la oferta
         *
         * @param ev
         * @param offersStudent
         */
        function openOffersStudentDialog(ev, offersStudent) {
            $mdDialog.show({
                controller: 'OffersStudentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offersRequests/dialogs/offersStudent/offersStudent-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    OffersStudent:offersStudent,
                    event: ev
                }
            });
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getTutors(searchText) {
            var deferred = $q.defer();
            tutorsService.tutors.filters={};
            tutorsService.tutors.filters.offer=Offer.id;
            tutorsService.getAllTutors(searchText).then(function(tutors){
                deferred.resolve(tutors);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del tutor
         */
        function getFullNameTutor(tutor) {
            return tutor.name+" "+tutor.surname+" "+tutor.second_surname;
        }

        function updateDurationDays(form){
            // Convierte la entrada meses+días a días (mes fijo de 30); horas y cofinanciación, al salir (durationBlur)
            vm.offer.duration=(vm.durationMonths||0)*30+(vm.durationDays||0);
            // Limpia el error del servidor bajo ambos campos al corregir
            if(form){
                angular.forEach(['duration_months', 'duration_days_part'], function(name){
                    if(form[name]){
                        form[name].$setValidity('serverError', true);
                    }
                });
            }
        }

        /**
         * Horas y cofinanciación al salir de meses o días, como en master con su único campo:
         * calcularlas a cada pulsación dejaba las horas en valores intermedios (al teclear «12»
         * pasaba por «1») y lanzaba peticiones que llegaban desordenadas
         */
        function durationBlur(){
            // Reordena la entrada con el mes fijo de 30 días (0 meses y 180 días -> 6 meses y 0 días)
            var duration=(vm.durationMonths||0)*30+(vm.durationDays||0);
            vm.durationMonths=Math.floor(duration/30);
            vm.durationDays=duration%30;
            vm.offer.duration=duration;
            cofinancingCalculate();
            getTotalHours();
        }

        /**
         * La API valida `duration` en días; el formulario la edita como meses + días:
         * ambos campos se marcan en rojo (el texto sale una vez bajo los dos), porque el exceso puede venir de cualquiera
         */
        function durationServerErrors(data) {
            var errors = angular.copy(data || {});
            if (errors.duration) {
                errors.duration_months = errors.duration;
                errors.duration_days_part = errors.duration;
            }
            return errors;
        }

        function cofinancingCalculate(){
            var params={
                id:vm.offer.id,
                duration:vm.offer.duration,
                economic_endowment:vm.offer.economic_endowment
            };
            return offersService.getCofinancingCalculate(params).then(function(response){
                // Respuesta de una duración anterior (llegan desordenadas al salir de meses y de días): se descarta
                if(params.duration!==vm.offer.duration){
                    return;
                }
                vm.messageCofinance=response.message;
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("No se pudo calcular la cofinanciación"));
            });
        }

        function getTotalHours(){
            var params={
                id:vm.offer.id,
                duration:vm.offer.duration
            };
            return offersService.getTotalHours(params).then(function(response){
                // Respuesta de una duración anterior (llegan desordenadas al salir de meses y de días): se descarta
                if(params.duration!==vm.offer.duration){
                    return;
                }
                // Solo baja las horas que haya puesto la empresa; las que puso el propio precálculo
                // lo siguen en los dos sentidos (meses y días se rellenan en dos campos)
                var automatic=vm.autoTotalHours!==undefined && Number(vm.offer.total_hours)===vm.autoTotalHours;
                if(!vm.offer.total_hours || vm.offer.total_hours==='0' || vm.offer.total_hours===0 || vm.offer.total_hours>response.total_hours || automatic){
                    vm.offer.total_hours=response.total_hours;
                    vm.autoTotalHours=response.total_hours;
                }
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("No se pudieron calcular las horas totales"));
            });
        }

        /**
         * Abre el dialogo para crear una plantilla
         *
         * @param ev
         * @param offersTemplate
         */
        function openOffersTemplateDialog(ev, offersTemplate) {
            $mdDialog.show({
                controller: 'OffersTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/offersTemplates/dialogs/offersTemplate/offersTemplate-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Offer: Offer,
                    event: ev,
                    OffersTemplate: offersTemplate
                }
            });
        }

        /**
         * Obtiene los centros para rellenar el autocomplete
         */
        function getCenters(searchText) {
            var deferred = $q.defer();
            centersService.centers.filters={};
            centersService.centers.filters.company=Offer.company.id;;
            centersService.getAllCenters(searchText).then(function(centers){
                deferred.resolve(centers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del center
         */
        function getFullNameCenter(center) {
            return center.name+" "+center.address;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getProfessionalTutors(searchText) {
            var deferred = $q.defer();
            contactsService.contacts.filters={};
            contactsService.contacts.filters.professional_tutor='True';
            contactsService.contacts.filters.company=Offer.company.id;
            contactsService.getAllContacts(searchText).then(function(tutors){
                deferred.resolve(tutors);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getManagementContacts(searchText) {
            var deferred = $q.defer();
            contactsService.contacts.filters={};
            contactsService.contacts.filters.company_manager='True';
            contactsService.contacts.filters.company=Offer.company.id;
            contactsService.getAllContacts(searchText).then(function(contacts){
                deferred.resolve(contacts);
            });
            return deferred.promise;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OfferController', OfferController);

    /** @ngInject */
    function OfferController(currentUser, Offer,  OffersSkills, offersRequestsService, NotifyService, $state,
                              $rootScope, MyOfferRequest, OffersDegrees, OffersLanguages, $mdSidenav, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.UCA_COMPANY_CIF = $rootScope.UCA_COMPANY_CIF;
        vm.offer = formatOffer(Offer);
        vm.offersDegrees = OffersDegrees;
        vm.offersSkills = OffersSkills;
        vm.offersLanguages = OffersLanguages;
        vm.myOfferRequest=MyOfferRequest;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.saveOffersRequest = saveOffersRequest;
        //////////

        /**
         * Da el formato necesario a la oferta para poder trabajar con ella
         */
        function formatOffer(offer) {
            var a = angular.copy(offer);
            a.start_date=a.start_date ? new Date(moment(a.start_date).format()) : new Date();
            a.start_date_interruption=a.start_date_interruption ? new Date(moment(a.start_date_interruption).format()) : new Date();
            a.end_date_interruption=a.end_date_interruption ? new Date(moment(a.end_date_interruption).format()) : new Date();
            a.accept=(a.accepted_regulations===a.normative);
            return a;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Guardar offersRequest para el alumno
         */
        function saveOffersRequest(status) {
            var obj={};
            if(vm.myOfferRequest && status){
                obj=angular.copy(vm.myOfferRequest);
                obj.status=status;
            }else{
                obj.offer=vm.offer.id;
            }
            return offersRequestsService.saveOffersRequest(obj).then(function(response){
                vm.myOfferRequest=response;
                if(status && status==='accepted'){
                    NotifyService.successMessage(gettextCatalog.getString("Plaza aceptada correctamente"));
                    //si aceptamos la oferta redireccionamos al expediente
                    if($rootScope.hasPermission('dossiers','GET') && !$rootScope.hasPermission('dossiers','PATCH') && response.dossier_data.id){
                        $state.go("app.dossiers.get.detail",{dossier:response.dossier_data.id});
                    }
                }else if(status && status==='rejected'){
                    NotifyService.successMessage(gettextCatalog.getString("Plaza rechazada correctamente"));
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Plaza solicitada correctamente"));
                }
            }, function(error){
                vm.serverErrors = error.data;
                if(status && status==='accepted'){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al aceptar plaza. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }else if(status && status==='rejected'){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al rechazar plaza. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar plaza. ") + (error.data.non_field_errors || "") + (error.data.status || ""));
                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OffersSkillDialogController', OffersSkillDialogController);

    /** @ngInject */
    function OffersSkillDialogController($mdDialog, OffersSkill, offersSkillsService, Offer, skillsService, NotifyService, Categories, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar competencia');
        vm.categories=Categories;
        vm.skills=[];

        if (!OffersSkill) {
            vm.title = gettextCatalog.getString('Nueva competencia');
            vm.offersSkill = offersSkillsService.getEmptyOffersSkill(Offer.id);
        } else {
            vm.offersSkill = angular.copy(OffersSkill); // Copiamos para no modificar el original hasta guardar
            loadSkills();
        }

        // Methods
        vm.saveOffersSkill = saveOffersSkill;
        vm.loadSkills = loadSkills;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar competencia
         */
        function saveOffersSkill() {
            return offersSkillsService.saveOffersSkill(angular.copy(vm.offersSkill)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Competencia guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la competencia. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Carga las competencias segun la categoría que haya seleccionada
         */
        function loadSkills() {
            skillsService.skills.filters={};
            skillsService.skills.filters.category=vm.offersSkill.skill_data.category;
            skillsService.getAllSkills().then(function(res){
                vm.skills=res;
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OffersLanguageDialogController', OffersLanguageDialogController);

    /** @ngInject */
    function OffersLanguageDialogController($mdDialog, OffersLanguage, offersLanguagesService, Offer, languagesService, NotifyService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar competencia');

        if (!OffersLanguage) {
            vm.title = gettextCatalog.getString('Nueva competencia');
            vm.offersLanguage = offersLanguagesService.getEmptyOffersLanguage(Offer.id);
        } else {
            vm.offersLanguage = angular.copy(OffersLanguage); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveOffersLanguage = saveOffersLanguage;
        vm.getLanguages = getLanguages;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar competencia
         */
        function saveOffersLanguage() {
            return offersLanguagesService.saveOffersLanguage(angular.copy(vm.offersLanguage)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Idioma guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el idioma. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


        /**
         * Obtiene las competencias para rellenar el autocomplete
         */
        function getLanguages(searchText) {
            var deferred = $q.defer();
            languagesService.getAllLanguages(searchText).then(function(languages){
                deferred.resolve(languages);
            });
            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OffersDegreeDialogController', OffersDegreeDialogController);

    /** @ngInject */
    function OffersDegreeDialogController($mdDialog, OffersDegree, offersDegreesService, degreesService, Offer, NotifyService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar titulación');

        if (!OffersDegree) {
            vm.title = gettextCatalog.getString('Nueva titulación');
            vm.offersDegree = offersDegreesService.getEmptyOffersDegree(Offer.id);
        } else {
            vm.offersDegree = angular.copy(OffersDegree); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveOffersDegree = saveOffersDegree;
        vm.getDegrees = getDegrees;
        vm.getFullNameDegree = getFullNameDegree;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar titulación
         */
        function saveOffersDegree() {
            return offersDegreesService.saveOffersDegree(angular.copy(vm.offersDegree)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            degreesService.getAllDegrees(searchText).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

        function getFullNameDegree(degree) {
            return degreesService.getFullNameDegree(degree);

        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .controller('OfferDialogController', OfferDialogController);

    /** @ngInject */
    function OfferDialogController($rootScope, $mdDialog, Programs, offersService, offersTemplatesService, NotifyService,
                                   $state, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Nueva oferta');
        vm.offer = offersService.getEmptyOffer();
        vm.programs = Programs;
        vm.templates=offersTemplatesService.offersTemplates;

        // Methods
        vm.saveOffer = saveOffer;
        vm.saveOfferTemplate = saveOfferTemplate;
        vm.showTemplates = showTemplates;
        vm.closeDialog = closeDialog;
        vm.hasPermission=$rootScope.hasPermission;
        //////////
        /**
         * Muestra plantillas del programa
         */
        function showTemplates(program) {
            for(var i in vm.programs.data){
                vm.programs.data[i].showTemplates=false;
            }
            offersTemplatesService.offersTemplates.filters={};
            offersTemplatesService.offersTemplates.filters.program=program.id;
            offersTemplatesService.offersTemplates.filters.page='all';
            return offersTemplatesService.getOffersTemplates().then(function(){
                program.showTemplates=true;
            });
        }

        /**
         * Guardar offer
         */
        function saveOffer(program) {
            vm.offer.program=program.id;
            return offersService.saveOffer(angular.copy(vm.offer)).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Oferta guardada correctamente"));
                $state.go("app.offerEdit",{id:response.id});
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la oferta. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Guardar offer desde plantilla
         */
        function saveOfferTemplate(template) {
            vm.offer.offer_template=template.id;
            return offersService.createFromTemplate(angular.copy(vm.offer)).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Oferta guardada correctamente"));
                $state.go("app.offerEdit",{id:response.id});
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la oferta. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.managerDegrees',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.managerDegrees', {
            url      : '/managerDegrees',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/managerDegrees/managerDegrees.html',
                    controller : 'ManagerDegreesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                ManagerDegrees: function (managerDegreesService) {
                    managerDegreesService.managerDegrees.filters={};
                    return managerDegreesService.getManagerDegrees();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.managerDegrees')
        .controller('ManagerDegreeDialogController', ManagerDegreeDialogController);

    /** @ngInject */
    function ManagerDegreeDialogController($mdDialog, ManagerDegree, teachersService, managerDegreesService, Teacher, NotifyService,
                                             $state, degreesService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar gestor de titulación');

        if (!ManagerDegree) {
            vm.title = gettextCatalog.getString('Nuevo gestor de titulación');
            vm.managerDegree = managerDegreesService.getEmptyManagerDegree(Teacher.id);
            vm.degrees_managed=[];
        } else {
            vm.managerDegree = {
                exist:!!ManagerDegree.id,
                identification:ManagerDegree.uca_user.identification
            };
            vm.degrees_managed=ManagerDegree.degrees_managed;

        }

        // Methods
        vm.saveManagerDegree = saveManagerDegree;
        vm.getDegrees = getDegrees;
        vm.getFullNameDegree = getFullNameDegree;
        vm.closeDialog = closeDialog;
        vm.removeManagerDegree = removeManagerDegree;

        //////////
        /**
         * Guardar titulación
         */
        function saveManagerDegree() {
            var form=angular.copy(vm.managerDegree);
            return managerDegreesService.saveManagerDegree(form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación añadida correctamente para este gestor"));
                if(vm.managerDegree.tutor_data){
                    $state.go("app.teacher",{id:vm.managerDegree.tutor_data.id});
                }
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            degreesService.getAllDegrees(searchText).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

        function getFullNameDegree(degree) {
            return degreesService.getFullNameDegree(degree);
        }

        /**
         * elimina una managerDegree
         *
         * @param ev
         * @param managerDegree
         */
        function removeManagerDegree(ev, managerDegree) {
            managerDegreesService.removeManagerDegree(managerDegree).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Gestor de titulación borrado correctamente."));

                for (var i = 0; i < vm.degrees_managed.length; i++) {
                    if (vm.degrees_managed[i].id === managerDegree.id) {
                        vm.degrees_managed.splice(i,1);
                        break;
                    }
                }

            }, function(error){
                NotifyService.errorMessage("Error al borrar el gestor de titulación. " + (error.data.detail || ""));
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.gadesDegrees',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.gadesDegrees', {
            url      : '/gadesDegrees',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/gadesDegrees/gadesDegrees.html',
                    controller : 'GadesDegreesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                GadesDegrees: function (gadesDegreesService) {
                    return gadesDegreesService.getGadesDegrees();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.gadesDegrees')
        .controller('GadesDegreeDialogController', GadesDegreeDialogController);

    /** @ngInject */
    function GadesDegreeDialogController($scope, $mdDialog, $rootScope, GadesDegree, gadesDegreesService, NotifyService, gettextCatalog, $q) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar titulación');

        if (!GadesDegree) {
            vm.title = gettextCatalog.getString('Nueva titulación');
            vm.gadesDegree = gadesDegreesService.getEmptyGadesDegree();
        } else {
            vm.gadesDegree = angular.copy(GadesDegree); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveGadesDegree = saveGadesDegree;
        vm.closeDialog = closeDialog;
        $scope.getFullName=$rootScope.getFullName;

        //////////
        /**
         * Guardar titulacion
         */
        function saveGadesDegree() {
            return gadesDegreesService.saveGadesDegree(angular.copy(vm.gadesDegree)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Titulación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la titulación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.eventNotifications',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.eventNotifications', {
            url      : '/category/:category/events/:event/eventNotifications',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/eventNotifications/eventNotifications.html',
                    controller : 'EventNotificationsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                EventNotifications: function (eventNotificationsService, $stateParams) {
                    return eventNotificationsService.getEventNotifications($stateParams.event);
                },
                Event: function (EventNotifications, eventNotificationsService) {
                    return eventNotificationsService.event;
                },
                Parameters: function (EventNotifications, eventNotificationsService) {
                    return eventNotificationsService.parameters;
                },
                Breadcrumb: function (Event) {
                    return ['<a ui-sref="app.events({category:'+Event.category+'})"> Eventos</a>',
                        Event.name,
                        'Notificaciones'];
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.eventNotifications')
        .controller('EventNotificationDialogController', EventNotificationDialogController);

    /** @ngInject */
    function EventNotificationDialogController($scope, $mdDialog, EventNotification, Event, Parameters, eventNotificationsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['bold', 'italics', 'underline', 'ul', 'ol', 'insertLink', 'redo', 'undo', 'clear']
        ];

        vm.title = gettextCatalog.getString('Editar notificación');
        vm.parameters=Parameters;

        if (!EventNotification.id) {
            vm.title = gettextCatalog.getString('Nueva notificación');
            vm.eventNotification = eventNotificationsService.getEmptyEventNotification(Event.id);
        } else {
            formatEdit(EventNotification); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveEventNotification = saveEventNotification;
        vm.closeDialog = closeDialog;

        //////////
        function formatEdit(eventNotification){
            vm.eventNotification = angular.copy(EventNotification); // Copiamos para no modificar el original hasta guardar
            vm.eventNotification.recipients_email=[];
            vm.eventNotification.recipients_group=[];
            vm.eventNotification.recipients_user=[];
            for(var n in vm.eventNotification.recipients){
                if(vm.eventNotification.recipients[n].type==="email"){
                    vm.eventNotification.recipients_email.push(vm.eventNotification.recipients[n].recipient);
                }
                if(vm.eventNotification.recipients[n].type==="group"){
                    vm.eventNotification.recipients_group.push(vm.eventNotification.recipients[n].recipient);
                }
                if(vm.eventNotification.recipients[n].type==="user"){
                    vm.eventNotification.recipients_user.push(vm.eventNotification.recipients[n].recipient);
                }
            }
            vm.eventNotification.prov_files=[];
            for(var f in vm.eventNotification.files){
                vm.eventNotification.prov_files.push(vm.eventNotification.files[f].file);
            }
        }

        /**
         * Guardar eventNotification
         */
        function saveEventNotification() {
            return eventNotificationsService.saveEventNotification(angular.copy(vm.eventNotification)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Notificación guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la notificación. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.questions')
        .controller('QuestionsController', QuestionsController);
    /** @ngInject */
    function QuestionsController($scope, currentUser, questionsService, Questions, Questionnaires, Questionnaire,
                               questionOptionsService, $mdSidenav, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.questionnaire=Questionnaire;
        vm.questionnaires=Questionnaires;
        vm.questions=Questions;

        // Watchers
        $scope.$watch('vm.questions.filters', DebounceService(questionsService.getQuestions, 300), true);

        // Methods
        vm.openQuestionDialog = openQuestionDialog;
        vm.openQuestionOptionsDialog = openQuestionOptionsDialog;
        vm.removeQuestion = removeQuestion;
        vm.toggleSidenav = toggleSidenav;

        //////////
        /**
         * Abre el dialogo para crear/editar una question
         *
         * @param ev
         * @param question
         */
        function openQuestionDialog(ev, question) {
            $mdDialog.show({
                controller: 'QuestionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/evaluations/views/questions/dialogs/question/question-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Question:question,
                    Questionnaire:Questionnaire,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para crear/editar un selector
         *
         * @param ev
         * @param question
         */
        function openQuestionOptionsDialog(ev, question) {
            questionOptionsService.questionOptions.filters.question=question.id;
            $mdDialog.show({

                controller: 'QuestionOptionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/evaluations/views/questions/dialogs/questionOptions/questionOptions-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    Question:question,
                    event: ev,
                    QuestionOptions: questionOptionsService.getQuestionOptions()
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una question
         *
         * @param ev
         * @param question
         */
        function removeQuestion(ev, question) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cuestionario'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar este cuestionario?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cuestionario'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Eliminar cuestionario'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                questionsService.removeQuestion(question).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cuestionario eliminado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al eliminar el cuestionario. " + (error.data.detail || "") + (error.data[0] || ""));
                });
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.answers')
        .controller('AnswersController', AnswersController);
    /** @ngInject */
    function AnswersController($scope, currentUser, answersService, Evaluations, Dossier, Questions, Questionnaire,
                               $rootScope, Answers, Evaluation, questionOptionsService, evaluationsService, Point,
                               evaluationsPointsService, $mdSidenav, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;

        vm.dossier = Dossier;
        vm.questionnaire=Questionnaire;
        vm.evaluations=Evaluations;
        vm.evaluation=Evaluation;
        vm.point=Point;
        vm.pointOriginal=angular.copy(Point);
        vm.questions=Questions;
        vm.answers=Answers;

        vm.ngFlowOptions={
            query:function(file){
                return {name:'Memoria de prácticas',type:'practice_memorie'};
            }
        };

        init();

        // Watchers
        // $scope.$watch('vm.answers.filters', DebounceService(answersService.getAnswers, 300), true);

        // Methods
        vm.openAnswerDialog = openAnswerDialog;
        vm.removeAnswer = removeAnswer;
        vm.toggleSidenav = toggleSidenav;
        vm.saveEvaluation = saveEvaluation;
        vm.finalizeEvaluation = finalizeEvaluation;
        vm.confirmFinalizeEvaluation = confirmFinalizeEvaluation;
        vm.fileError = fileError;
        vm.fileSuccess = fileSuccess;
        vm.canEdit = canEdit;
        vm.evaluate = evaluate;
        vm.setHours = setHours;
        vm.setCredits = setCredits;
        vm.literalCalification = literalCalification;

        //////////

        //Combinamos preguntas con respuestas
        function init(){
            for(var i in vm.questions.data){
                for(var j in vm.answers.data){
                    if(parseInt(vm.questions.data[i].id)===parseInt(vm.answers.data[j].question)){
                        vm.questions.data[i].answer=vm.answers.data[j];
                    }
                }
            }
        }

        /**
         * Abre el dialogo para crear/editar una answer
         *
         * @param ev
         * @param question
         */
        function openAnswerDialog(ev, question) {
            questionOptionsService.questionOptions.filters.question=question.id;
            $mdDialog.show({
                controller: 'AnswerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/evaluations/views/answers/dialogs/answer/answer-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Question:question,
                    Evaluation:vm.evaluation,
                    Answer:question.answer,
                    Options:(question.type==="options") ? questionOptionsService.getQuestionOptions():{},
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una answer
         *
         * @param ev
         * @param answer
         */
        function removeAnswer(ev, answer) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cuestionario'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar este cuestionario?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cuestionario'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Eliminar cuestionario'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                answersService.removeAnswer(answer).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cuestionario eliminado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al eliminar el cuestionario. " + (error.data.detail || "") + (error.data[0] || ""));
                });
            });

        }

        /**
         * Guarda una evaluación
         */
        function saveEvaluation() {
            evaluationsService.saveEvaluation(vm.evaluation).then(function(response){
                vm.evaluation=response;
                NotifyService.successMessage(gettextCatalog.getString("Evaluación guardada correctamente."));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al guardar la evaluación. " + (error.data.detail || "") + (error.data.finished || ""));
            });
        }

        /**
         * Finaliza una evaluación
         */
        /**
         * Pide confirmación antes de finalizar: la finalización es definitiva
         * (no existe reapertura) y en el tutor académico dispara los informes finales.
         */
        function confirmFinalizeEvaluation() {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Finalizar cuestionario'))
                .textContent(gettextCatalog.getString('Una vez finalizado no podrá modificarse. ¿Seguro que quieres finalizar el cuestionario?'))
                .ariaLabel(gettextCatalog.getString('Finalizar cuestionario'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Finalizar cuestionario'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                finalizeEvaluation();
            });
        }

        function finalizeEvaluation() {
            return evaluationsService.finalizeEvaluation(vm.evaluation).then(function(response){
                vm.evaluation=response;
                NotifyService.successMessage(gettextCatalog.getString("Evaluación finalizada correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al finalizar la evaluación. " + (error.data.detail || "") + (error.data.finished || ""));
            });
        }

        /**
         * Evalua el punto de evaluación
         */
        function evaluate() {
            var obj={
                id:vm.point.id,
                calification:vm.point.calification
            };
            return evaluationsPointsService.evaluate(obj).then(function(response){
                // vm.point=response;
                vm.pointOriginal = angular.copy(response)
                NotifyService.successMessage(gettextCatalog.getString("Nota establecida correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al establecer la nota. " + (error.data.detail || "") + (error.data.finished || ""));
            });
        }

        /**
         * Establece las horas
         */
        function setHours() {
            var obj={
                id:vm.point.id,
                hours:vm.point.hours
            };
            return evaluationsPointsService.evaluate(obj).then(function(response){
                // vm.point=response;
                vm.pointOriginal = angular.copy(response)
                NotifyService.successMessage(gettextCatalog.getString("Horas establecidas correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al establecer las horas. " + (error.data.detail || "") + (error.data.finished || ""));
            });
        }

        /**
         * Establece los créditos superados
         */
        function setCredits() {
            var obj={
                id:vm.point.id,
                credits:vm.point.credits
            };
            return evaluationsPointsService.evaluate(obj).then(function(response){
                // vm.point=response;
                vm.pointOriginal = angular.copy(response)
                NotifyService.successMessage(gettextCatalog.getString("Créditos establecidos correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al establecer los créditos. " + (error.data.detail || "") + (error.data.finished || ""));
            });
        }

        /* Error al subir imagen */
        function fileError($file, $message, $flow) {
            $file.cancel();
            NotifyService.errorMessage(gettextCatalog.getString("Error al subir el archivo. "));
        }

        /* Memoria subida con exito */
        function fileSuccess($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.evaluation.practice_memories=obj.id;
                vm.evaluation.practice_memories_data=obj;
                saveEvaluation();
            }
        }

        /**
         * Indica si puede o no editar el cuestionario
         */
        function canEdit()
        {
            var hasPermission=$rootScope.hasPermission;
            //Comprueba que tenga permisos para cada uno de los tipos de roles que pueden evaluar y
            // que coincida con el tipo de formulario que ese usuario podría evaluar
            return hasPermission('answers','POST') && hasPermission('evaluations','PATCH') && !vm.evaluation.finished &&
               ((hasPermission('evaluationsAcademicTutors','POST') &&
               (vm.questionnaire.type==='academic_tutor_pc' || vm.questionnaire.type==='academic_tutor_pex')) ||
               (hasPermission('evaluationsProfessionalTutors','POST') &&
               (vm.questionnaire.type==='professional_tutor_pc' || vm.questionnaire.type==='professional_tutor_pex')) ||
               (hasPermission('evaluationsStudents','POST') &&
               (vm.questionnaire.type==='student_pc' || vm.questionnaire.type==='student_pex')));
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Literal calification
         *
         * @param calification
         */
        function literalCalification(calification)
        {
          if(calification>=9){
            return gettextCatalog.getString("Sobresaliente");
          }
          if(calification>=7){
            return gettextCatalog.getString("Notable");
          }
          if(calification>=5){
            return gettextCatalog.getString("Aprobado");
          }
          return gettextCatalog.getString("Suspenso");
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.download',
            ['ui.calendar']
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.download', {
            url: '/download/:categoryDownload',
            views: {
                'content@app': {
                    templateUrl: 'app/main/download/views/view/view.html',
                    controller: 'DownloadViewController as vm'
                }
            },
            resolve: {
                Permissions: function (contentTypeService) {
                    return contentTypeService.list();
                },
                Breadcrumb: function ($stateParams) {
                    if (!$stateParams.categoryDownload) {
                        $stateParams.categoryDownload = 1;
                    }
                    return ['<a ui-sref="app.download"> Descargas</a>'];
                }
            },
            bodyClass: 'download'
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.download')
        .controller('DownloadViewController', DownloadViewController);

    /** @ngInject */
    function DownloadViewController(
        Permissions, downloadService, NotifyService, $stateParams, $state) {
        var vm = this;

        vm.permissions = Permissions.data;
        vm.disabled = false;
        vm.categoriesDownload = [
            {pk: 1, name: 'Altas'},
            {pk: 2, name: 'Cotizaciones'},
            // {pk: 3, name: 'Calendario laboral'},
        ];
        vm.categoryDownload = $stateParams.categoryDownload;
        vm.zones = [
            {id: 1, name: 'Altas'},
            {id: 2, name: 'Cotizaciones'}
        ];
        vm.months = [
            {id: 1, name: 'Enero'},
            {id: 2, name: 'Febrero'},
            {id: 3, name: 'Marzo'},
            {id: 4, name: 'Abril'},
            {id: 5, name: 'Mayo'},
            {id: 6, name: 'Junio'},
            {id: 7, name: 'Julio'},
            {id: 8, name: 'Agosto'},
            {id: 9, name: 'Septiembre'},
            {id: 10, name: 'Octubre'},
            {id: 11, name: 'Noviembre'},
            {id: 12, name: 'Diciembre'}
        ];
        vm.eventSources = [];
        vm.form = {};
        vm.date = {from:'', to:''};
        // Rango de periodo (mes/año) para Cotizaciones
        vm.period = {fromMonth: null, fromYear: null, toMonth: null, toYear: null};
        vm.includeDownloaded = false;
        var currentYear = new Date().getFullYear();
        vm.years = [];
        for (var y = currentYear; y >= currentYear - 10; y--) {
            vm.years.push(y);
        }
        vm.uiConfig = {
            calendar: {
                height: 450,
                editable: true,
                header: {
                    left: 'month basicWeek basicDay agendaWeek agendaDay',
                    center: 'title',
                    right: 'today prev,next'
                },
                eventClick: vm.alertOnEventClick,
                eventDrop: vm.alertOnDrop,
                eventResize: vm.alertOnResize,
                eventRender: vm.eventRender
            }
        };
        // Methods
        vm.downloadHight = downloadHight;
        vm.downloadDocument = downloadDocument;
        vm.selectCategoryDownload = selectCategory;

        //////////

        function downloadDocument(seccion) {
            vm.disabled = true;
            var date ={};
            downloadService.download.filtersAdvances = undefined;
            downloadService.download.extraParams = undefined;
            // Cada extremo se envía solo si su fecha está informada (las
            // condiciones estaban invertidas y con un solo extremo relleno
            // se enviaba "Invalid date")
            if(vm.date.from){
                date.start_date=moment(vm.date.from).format("YYYY-MM-DD");
            }
            if(vm.date.to){
                date.end_date=moment(vm.date.to).format("YYYY-MM-DD");
            }

            if(date.end_date && date.start_date){
            downloadService.download.filtersAdvances=[{"start_date__range": [date.start_date,date.end_date]}];
            }

            $state.go("app.export", {"module": seccion});
        }

        /**
         * Listado de Cotizaciones en el exportador: por defecto solo las
         * pendientes de descarga; con el toggle se ven también las descargadas
         * (con su fecha). La descarga se hace desde el propio listado: el botón
         * Excel del datatable genera el fichero y marca lo listado en servidor.
         */
        vm.viewQuotes = function () {
            var params = buildQuotesParams();
            if (vm.includeDownloaded) {
                params.include_downloaded = '1';
            }
            downloadService.download.filtersAdvances = undefined;
            downloadService.download.extraParams = params;
            $state.go("app.export", {"module": 'Cotizaciones'});
        };

        /**
         * Parámetros de periodo del listado de Cotizaciones.
         */
        function buildQuotesParams() {
            var params = {};
            if (vm.period.fromMonth && vm.period.fromYear) {
                params.period_from = vm.period.fromYear + '-' + vm.period.fromMonth;
            }
            if (vm.period.toMonth && vm.period.toYear) {
                params.period_to = vm.period.toYear + '-' + vm.period.toMonth;
            }
            return params;
        }

        function downloadHight() {
            var date ={};
            // Cada extremo se envía solo si su fecha está informada
            if(vm.date.from){
                date.start_date=moment(vm.date.from).format("YYYY-MM-DD");
            }
            if(vm.date.to){
                date.end_date=moment(vm.date.to).format("YYYY-MM-DD");
            }
            return downloadService.getDocumentHight(date).then(function (result) {
                // Agregar BOM (Byte Order Mark) para forzar UTF-8
                var bom = "\uFEFF";
                var utf8Result = bom + result;

                var blob = new Blob([utf8Result], { type: "application/vnd.ms-excel;charset=UTF-8" });

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob);
                } else {
                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);

                    var fechaActual = new Date();
                    var anio = fechaActual.getFullYear();
                    var mes = fechaActual.getMonth() + 1;
                    var dia = fechaActual.getDate();

                    link.download = 'GADES_INSCRIPCIONES_SS_' + anio + "" + mes + "" + dia + '.xls';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                vm.disabled = false;
            }, function (error) {
                vm.disabled = false;
                vm.serverErrors = error.data;
                NotifyService.errorMessage("Error al realizar la descarga. " + (error.data.non_field_errors || error.data[0]) || "");
            });
        }

        /**
         * Muestra las variables de una categoria
         *
         * @param category
         */
        function selectCategory(category) {
            $state.go("app.download", {"categoryDownload": category.pk});
        }

        ///CALENDAR///
        /* alert on eventClick */
        vm.alertOnEventClick = function (date, jsEvent, view) {
            vm.alertMessage = (date.title + ' was clicked ');
        };
        /* alert on Drop */
        vm.alertOnDrop = function (event, delta, revertFunc, jsEvent, ui, view) {
            vm.alertMessage = ('Event Dropped to make dayDelta ' + delta);
        };
        /* alert on Resize */
        vm.alertOnResize = function (event, delta, revertFunc, jsEvent, ui, view) {
            vm.alertMessage = ('Event Resized to make dayDelta ' + delta);
        };
        /* add and removes an event source of choice */
        vm.addRemoveEventSource = function (sources, source) {
            var canAdd = 0;
            angular.forEach(sources, function (value, key) {
                if (sources[key] === source) {
                    sources.splice(key, 1);
                    canAdd = 1;
                }
            });
            if (canAdd === 0) {
                sources.push(source);
            }
        };
        /* add custom event*/
        vm.addEvent = function () {
            vm.events.push({
                title: 'Open Sesame',
                start: new Date(y, m, 28),
                end: new Date(y, m, 29),
                className: ['openSesame']
            });
        };
        /* remove event */
        vm.remove = function (index) {
            vm.events.splice(index, 1);
        };
        /* Change View */
        vm.changeView = function (view, calendar) {
            uiCalendarConfig.calendars[calendar].fullCalendar('changeView', view);
        };
        /* Change View */
        vm.renderCalendar = function (calendar) {
            $timeout(function () {
                if (uiCalendarConfig.calendars[calendar]) {
                    uiCalendarConfig.calendars[calendar].fullCalendar('render');
                }
            });
        };
        /* Render Tooltip */
        vm.eventRender = function (event, element, view) {
            element.attr({
                'tooltip': event.title,
                'tooltip-append-to-body': true
            });
            $compile(element)(vm);
        };
        vm.eventSources = [vm.events, vm.eventSource, vm.eventsF];
        vm.eventSources2 = [vm.calEventsExt, vm.eventsF, vm.events];

    }

})();
(function ()
{
    'use strict';
    angular
        .module('app.dossiers')
        .controller('DossiersController', DossiersController);
    /** @ngInject */
    function DossiersController($scope, currentUser, dossiersService, myDossiersService, Dossiers, Offer, NotifyService,
                                Demand, $mdSidenav, SearchsBasics, $mdDialog, $rootScope, StudentsDetail, $document,
                                DebounceService, $state, $timeout, degreesService, $stateParams, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossiers=Dossiers;
        vm.offer = Offer;
        vm.demand = Demand;
        vm.form = StudentsDetail;
        vm.searchsBasics=SearchsBasics;
        vm.filter={};
        vm.pageSize=10;
        if($stateParams.demand){
            //Si estamos filtrando por demanda traemos todos los resultados, por lo que igualamos el pagesize al tamaño de la respuesta
            vm.pageSize=dossiers.count;
        }

        init();

        // Watchers
        if($rootScope.hasPermission('myDossiers','LIST')){
            $scope.$watch('vm.dossiers.filters', DebounceService(myDossiersService.getMyDossiers, 300), true);
        }else{
            $scope.$watch('vm.dossiers.filters', DebounceService(dossiersService.getDossiers, 300), true);
        }

        // Methods
        vm.openDossierDialog = openDossierDialog;
        vm.removeDossier = removeDossier;
        vm.go = go;
        vm.search = search;
        vm.toggleSidenav = toggleSidenav;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;

        //////////
        function init(){
            $timeout(function(){
                //Si no se muestra el búscador no filtramos por este estado ya que no podremos cambiarlo
                if(vm.filterBasic && vm.filterBasic['status'] && !vm.form && !vm.offer && !vm.demand){
                    // vm.filterBasic['status'].value='in progress';
                    vm.filterBasic['status'].value='';
                }

                if(!vm.filterBasic){
                    vm.filterBasic={};
                }

                if($stateParams.offer){
                    vm.filterBasic['offer']=vm.filterBasic['offer'] || {};
                    vm.filterBasic['offer'].value=$stateParams.offer;
                    vm.filterBasic['offer'].option="exact";
                }
                if($stateParams.student){
                    vm.filterBasic['student']=vm.filterBasic['student'] || {};
                    vm.filterBasic['student'].value=$stateParams.student;
                    vm.filterBasic['student'].option="exact";
                }
                if($stateParams.demand){
                    vm.filterBasic['offer__schedule__demand']=vm.filterBasic['offer__schedule__demand'] || {};
                    vm.filterBasic['offer__schedule__demand'].value=$stateParams.demand;
                    vm.filterBasic['offer__schedule__demand'].option="exact";
                }

                var form=[{}];

                for(var j in vm.filterBasic){
                    var value=angular.copy(vm.filterBasic[j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.filterBasic[j].option==='range'){
                            var value_range=angular.copy(vm.filterBasic[j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                        }else {
                            form[0][j+"__"+vm.filterBasic[j].option]=value;
                        }
                    }
                }

                vm.dossiers.filtersAdvances=form;
            });
        }

        /**
         * Abre el dialogo para crear/editar una dossier
         *
         * @param ev
         * @param dossier
         */
        function openDossierDialog(ev, dossier) {
            $mdDialog.show({
                controller: 'DossierDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/dialogs/dossier/dossier-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Dossier:dossier,
                    event: ev
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una dossier
         *
         * @param ev
         * @param dossier
         */
        function removeDossier(ev, dossier) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar dossiera')+' "'+dossier.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el dossiera?'))
                .ariaLabel(gettextCatalog.getString('Eliminar dossiera'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar dossiera'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                dossiersService.removeDossier(dossier).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Dossiera borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el dossiera. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Redirecciona al detalle del expediente dependiendo de los permismos que tenga
         *
         * @param dossier
         */
        function go(dossier) {
            if($rootScope.hasPermission('dossiers','PATCH')){
                $state.go("app.dossiers.get.edit",{dossier:dossier.id});
            }else if($rootScope.hasPermission('dossiers','GET')){
                $state.go("app.dossiers.get.detail",{dossier:dossier.id});
            }

        }

        function search(clear){
            var form=[{}];
            if(!clear){
                for(var j in vm.filterBasic){
                    var value=angular.copy(vm.filterBasic[j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.filterBasic[j].option==='range'){
                            var value_range=angular.copy(vm.filterBasic[j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                        }else {
                            form[0][j+"__"+vm.filterBasic[j].option]=value;
                        }
                    }
                }
            }

            vm.dossiers.filtersAdvances=form;
            vm.dossiers.filters={};
            vm.dossiers.filters.page=1;
            return dossiersService.getDossiers();
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .controller('DossierEditController', DossierEditController);

    /** @ngInject */
    function DossierEditController(currentUser, Dossier, dossiersService, Centers, Tutors, ManagementContacts, tutorsService,
                                   $rootScope, evaluationsPointsService, $state, offersRequestsService, NotifyService,
                                   centersService, contactsService, $mdSidenav, $q, $mdDialog, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.UCA_COMPANY_CIF = $rootScope.UCA_COMPANY_CIF;
        vm.dossier = formatDossier(Dossier);

        vm.centers=Centers;

        vm.tutors=Tutors;
        vm.managementContacts=ManagementContacts;

        // Se edita en borrador, en bloqueado (un borrador a la espera de que termine el activo) y confirmado
        vm.disabledInputs=(vm.dossier.status!=='draft' && vm.dossier.status!=='blocked' && vm.dossier.status!=='confirmed');

        $rootScope.getPhoto(vm.dossier.student.id,vm);

        // Methods
        vm.saveDossier = saveDossier;
        vm.confirmDossier = confirmDossier;
        vm.confirmDossierCurricular = confirmDossierCurricular;
        vm.confirmDossierAcademicTutor = confirmDossierAcademicTutor;
        vm.signedDossier = signedDossierFake;
        vm.getCenters = getCenters;
        vm.getFullNameCenter = getFullNameCenter;
        vm.getProfessionalTutors = getProfessionalTutors;
        vm.getManagementContacts = getManagementContacts;
        vm.getTutors = getTutors;
        vm.getFullNameTutor = getFullNameTutor;
        vm.discardDossier = discardDossier;
        vm.toggleSidenav = toggleSidenav;
        vm.durationLabel = durationLabel;
        vm.ssExemptionLocked = ssExemptionLocked;
        vm.updateDurationDays = updateDurationDays;

        // Estados desde los que la exención de cotización ya no puede desmarcarse
        var SS_EXEMPTION_LOCK_STATUSES=['in progress', 'closed-without-certificate', 'pending-by-at', 'filed'];

        //////////

        function formatDossier(dossier) {
            var a = angular.copy(dossier);
            a.start_date=a.start_date ? new Date(moment(a.start_date).format()) : new Date();
            a.end_date=a.end_date ? new Date(moment(a.end_date).format()) : null;
            a.start_date_interruption=a.start_date_interruption ? new Date(moment(a.start_date_interruption).format()) : new Date();
            a.end_date_interruption=a.end_date_interruption ? new Date(moment(a.end_date_interruption).format()) : new Date();
            vm.disabledInputs=(a.status!=='draft' && a.status!=='blocked' && a.status!=='confirmed');

            // Valor guardado de la exención de cotización: el bloqueo se evalúa
            // sobre lo persistido, no sobre lo que se esté editando en el formulario
            vm.savedSSExemption=a.exclude_ss_contribution;

            // Entrada meses+días (solo extracurriculares) con los meses y días de
            // calendario que calcula el servidor desde la fecha de inicio; en
            // curriculares la duración viene de los créditos y solo se muestra como texto
            vm.durationMonths=a.duration_months_part||0;
            vm.durationDays=a.duration_days_part||0;

            //recalculamos los puntos de evaluación si tenemos permisos
            if($rootScope.hasPermission("evaluationsPoints","LIST")) {
                evaluationsPointsService.getEvaluationsPoints().then(function (response) {
                    Dossier.evaluations_points = response.data;
                    vm.dossier.evaluations_points = response.data;
                });
            }

            return a;
        }
        
        /**
         * Duración en texto («X meses y Y días»), la que calcula el servidor por
         * calendario desde la fecha de inicio. Se usa en los expedientes curriculares,
         * cuya duración viene de los créditos y no se edita.
         */
        function durationLabel() {
            return (vm.dossier && vm.dossier.duration_display) || "";
        }

        /**
         * La exención de cotización a la SS solo puede desmarcarse antes de que
         * el expediente esté en curso (espejo de la validación del servidor).
         */
        function ssExemptionLocked() {
            return vm.savedSSExemption && SS_EXEMPTION_LOCK_STATUSES.indexOf(vm.dossier.status)!==-1;
        }

        /**
         * Aviso previo a confirmar/firmar (administrador y tutor académico):
         * recuerda si el expediente cotiza o no a la Seguridad Social.
         * Devuelve la promesa del diálogo (rechazada si se cancela).
         */
        function confirmSSContributionNotice() {
            // Solo las prácticas curriculares cotizan: en extracurriculares no hay aviso
            if(!vm.dossier.curricular){
                return $q.when();
            }
            var message=vm.dossier.exclude_ss_contribution ?
                gettextCatalog.getString("Este expediente NO genera cotización a la Seguridad Social.") :
                gettextCatalog.getString("Este expediente SÍ genera cotización a la Seguridad Social.");
            var confirm=$mdDialog.confirm()
                .title(gettextCatalog.getString("Cotización a la Seguridad Social"))
                .textContent(message+" "+gettextCatalog.getString("¿Desea continuar?"))
                .ariaLabel("aviso cotización seguridad social")
                .ok(gettextCatalog.getString("Continuar"))
                .cancel(gettextCatalog.getString("Cancelar"));
            return $mdDialog.show(confirm);
        }

        /**
         * Entrada meses+días (extracurriculares): convierte a días de calendario desde
         * la fecha de inicio (moment recorta al fin de mes igual que relativedelta en el
         * servidor) y limpia el error del servidor bajo ambos campos al corregir. La duración
         * NO mueve la fecha fin (ni la fecha de inicio): la duración es el contrato y
         * la fecha fin la realidad del calendario (prácticas no continuas); la fecha
         * fin solo cambia desde su propio datepicker. El formulario la envía siempre,
         * así que el servidor tampoco la recalcula (decisión FIN-1 D3, 22/9/2026).
         */
        function updateDurationDays(form) {
            var start=moment(vm.dossier.start_date).startOf('day');
            vm.dossier.duration=start.clone().add(vm.durationMonths||0, 'months')
                .add(vm.durationDays||0, 'days').diff(start, 'days');
            if(form){
                angular.forEach(['duration_months', 'duration_days_part'], function(name){
                    if(form[name]){
                        form[name].$setValidity('serverError', true);
                    }
                });
            }
        }

        /**
         * Guardar detalle del expediente
         */
        function saveDossier() {
            var dossier=angular.copy(vm.dossier);
            if(dossier.start_date){
                dossier.start_date=moment(dossier.start_date).format("YYYY-MM-DD");
            }
            if(dossier.end_date){
                dossier.end_date=moment(dossier.end_date).format("YYYY-MM-DD");
            }
            if(dossier.start_date_interruption && dossier.end_date_interruption){
                dossier.start_date_interruption=moment(dossier.start_date_interruption).format("YYYY-MM-DD");
                dossier.end_date_interruption=moment(dossier.end_date_interruption).format("YYYY-MM-DD");
            }
            delete dossier.status;
            return dossiersService.saveDossier(dossier).then(function(response){
                vm.dossier=formatDossier(response);
                NotifyService.successMessage(gettextCatalog.getString("Datos básicos guardados correctamente"));
            }, function(error){
                var errors = angular.copy(error.data || {});
                // La API valida la duración en días; el formulario la edita como meses + días:
                // ambos campos se marcan en rojo (el texto sale una vez bajo los dos), porque el exceso puede venir de cualquiera
                if (errors.duration) {
                    errors.duration_months = errors.duration;
                    errors.duration_days_part = errors.duration;
                }
                vm.serverErrors = errors;
                NotifyService.errorMessage(gettextCatalog.getString("Hay errores en el formulario. Por favor, verifique los campos. ") + (errors.non_field_errors || "") + (errors.duration || "") + (errors.end_date || ""));
            });
        }

        /**
         * Confirmar expediente
         */
        function confirmDossier() {
            return confirmSSContributionNotice().then(function(){
                var dossier={
                    id:vm.dossier.id
                };
                return dossiersService.sign(dossier).then(function(response){
                    vm.dossier=formatDossier(response);
                    NotifyService.successMessage(gettextCatalog.getString("Expediente confirmado correctamente"));
                }, function(error){
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al confirmar expediente. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                });
            }, function(){
                // firma cancelada desde el aviso de cotización
            });
        }

        /**
         * Confirmar expediente curricular
         */
        function confirmDossierCurricular() {
            return confirmSSContributionNotice().then(function(){
                var dossier={
                    id:vm.dossier.id
                };
                return dossiersService.confirm(dossier).then(function(response){
                    vm.dossier=formatDossier(response);
                    NotifyService.successMessage(gettextCatalog.getString("Expediente confirmado correctamente"));
                }, function(error){
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al confirmar expediente. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                });
            }, function(){
                // confirmación cancelada desde el aviso de cotización
            });
        }

        /**
         * Confirmar expediente curricular por tutor profesional
         */
        function confirmDossierAcademicTutor() {
            return confirmSSContributionNotice().then(function(){
                var dossier={
                    id:vm.dossier.id
                };
                return dossiersService.confirmAcademicTutor(dossier).then(function(response){
                    vm.dossier=formatDossier(response);
                    NotifyService.successMessage(gettextCatalog.getString("Expediente confirmado correctamente"));
                }, function(error){
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al confirmar expediente. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                });
            }, function(){
                // confirmación cancelada desde el aviso de cotización
            });
        }

        /**
         * fake signed expediente
         */
        function signedDossierFake() {
            var dossier={
                id:vm.dossier.id,
                status:"signed"
            };
            return dossiersService.saveDossier(dossier).then(function(response){
                vm.dossier=formatDossier(response);
                NotifyService.successMessage(gettextCatalog.getString("Expediente firmado correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al firmar expediente. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Obtiene los centros para rellenar el autocomplete
         */
        function getCenters(searchText) {
            var deferred = $q.defer();
            centersService.centers.filters={};
            centersService.centers.filters.company=Dossier.seat_data.company;
            centersService.getAllCenters(searchText).then(function(centers){
                deferred.resolve(centers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del center
         */
        function getFullNameCenter(center) {
            return center.name+" "+center.address;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getProfessionalTutors(searchText) {
            var deferred = $q.defer();
            contactsService.contacts.filters={};
            contactsService.contacts.filters.professional_tutor='True';
            contactsService.contacts.filters.company=Dossier.seat_data.company;
            contactsService.getAllContacts(searchText).then(function(tutors){
                deferred.resolve(tutors);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getManagementContacts(searchText) {
            var deferred = $q.defer();
            contactsService.contacts.filters={};
            contactsService.contacts.filters.company_manager='True';
            contactsService.contacts.filters.company=Dossier.seat_data.company;
            contactsService.getAllContacts(searchText).then(function(contacts){
                deferred.resolve(contacts);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las titulaciones para rellenar el autocomplete
         */
        function getTutors(searchText) {
            var deferred = $q.defer();
            tutorsService.tutors.filters={};
            tutorsService.tutors.filters.dossier=Dossier.id;
            tutorsService.getAllTutors(searchText).then(function(tutors){
                deferred.resolve(tutors);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del tutor
         */
        function getFullNameTutor(tutor) {
            return tutor.name+" "+tutor.surname+" "+tutor.second_surname;
        }

        /**
         * Descarta un expediente
         */
        function discardDossier() {
            var confirm = $mdDialog.confirm()
                .title((vm.user.group_type==='manager') ? gettextCatalog.getString('Eliminar expediente'):gettextCatalog.getString('Rechazar candidato'))
                .textContent((vm.user.group_type==='manager') ? gettextCatalog.getString('¿Seguro que quieres eliminar este expediente?'):gettextCatalog.getString('¿Seguro que quieres rechazar este candidato?'))
                .ariaLabel((vm.user.group_type==='manager') ? gettextCatalog.getString('Eliminar expediente'):gettextCatalog.getString('Rechazar candidato'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString((vm.user.group_type==='manager') ? gettextCatalog.getString('Eliminar expediente'):gettextCatalog.getString('Rechazar candidato')))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                // La administración borra el expediente directamente: funciona aunque ya no
                // tenga solicitud de oferta (p. ej. plaza curricular descartada)
                if (vm.user.group_type==='manager') {
                    return dossiersService.removeDossier(Dossier).then(function () {
                        NotifyService.successMessage(gettextCatalog.getString("Expediente eliminado correctamente"));
                        $state.go("app.dossiers.list");
                    }, function (error) {
                        vm.serverErrors = error.data;
                        NotifyService.errorMessage(gettextCatalog.getString("Error al eliminar expediente. ") + ((error.data && (error.data.non_field_errors || error.data.detail)) || ""));
                    });
                }

                var obj = {};
                obj.id = Dossier.offer_request;
                obj.curricular = Dossier.curricular;
                obj.status = "discarded";

                return offersRequestsService.saveOffersRequest(obj).then(function (response) {
                    NotifyService.successMessage(gettextCatalog.getString("Expediente rechazado correctamente"));
                    $state.go("app.dossiers.list");
                }, function (error) {
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al rechazar expediente. ") + (error.data.non_field_errors || "") + (error.data.status || ""));

                });
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.dossierResignations')
        .controller('DossierResignationsController', DossierResignationsController);
    /** @ngInject */
    function DossierResignationsController($scope, Dossier, currentUser, dossierResignationsService, DossierResignations, dossiersService,
                                           $mdSidenav, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossier = Dossier;
        vm.dossierResignations=DossierResignations;

        // Watchers
        $scope.$watch('vm.dossierResignations.filters', DebounceService(dossierResignationsService.getDossierResignations, 300), true);

        // Methods
        vm.openDossierResignationDialog = openDossierResignationDialog;
        vm.removeDossierResignation = removeDossierResignation;
        vm.acceptResignation = acceptResignation;
        vm.rejectResignation = rejectResignation;
        vm.toggleSidenav = toggleSidenav;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Abre el dialogo para crear/editar una dossierResignation
         *
         * @param ev
         * @param dossierResignation
         */
        function openDossierResignationDialog(ev, dossierResignation) {
            $mdDialog.show({
                controller: 'DossierResignationDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierResignations/dialogs/dossierResignation/dossierResignation-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DossierResignation:dossierResignation,
                    Dossier:Dossier,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una dossierResignation
         *
         * @param ev
         * @param dossierResignation
         */
        function removeDossierResignation(ev, dossierResignation) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Cancelar solicitud'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres cancelar la solicitud?'))
                .ariaLabel(gettextCatalog.getString('Cancelar solicitud'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Cancelar solicitud'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                dossierResignationsService.removeDossierResignation(dossierResignation).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Solicitud cancelada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al cancelar la solicitud. " + (error.data.detail || "") + (error.data[0] || ""));
                });
            });

        }

        /**
         * Acepta una cancelacion de expediente
         *
         * @param ev
         * @param dossierResignation
         */
        function acceptResignation(ev, dossierResignation) {
            vm.prompt={};
            vm.prompt.title=gettextCatalog.getString('Aceptar solicitud');
            vm.prompt.textContent=gettextCatalog.getString('Escriba aquí el motivo:');
            vm.prompt.ok=gettextCatalog.getString('Aceptar');
            vm.prompt.cancel=gettextCatalog.getString('Cancelar');
            // La aceptación exige la fecha efectiva de cese: corte de cotización a la SS
            vm.prompt.showEffectiveEndDate=true;
            vm.prompt.effectiveEndDateLabel=gettextCatalog.getString('Fecha efectiva de cese');
            vm.prompt.effective_end_date=null;
            vm.prompt.save=function(result){
                $mdDialog.hide();
                dossierResignation.resolution = result;
                dossierResignation.effective_end_date = vm.prompt.effective_end_date;
                dossierResignationsService.acceptResignation(dossierResignation).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Solicitud aceptada correctamente."));
                    dossiersService.getDossier(vm.dossier.id).then(function(res){
                        Dossier.status=res.status;
                    });
                }, function(error){
                    NotifyService.errorMessage("Error al aceptar la solicitud. " + (error.data.detail || "") +(error.data.resolution ? "Debe dar un motivo. ":"") +(error.data.effective_end_date ? "Debe indicar la fecha efectiva de cese.":""));
                });
            };

            $mdDialog.show({
                templateUrl: "prompt.html",
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            });
        }
        
        /**
         * Rechaza una cancelacion de expediente
         *
         * @param ev
         * @param dossierResignation
         */
        function rejectResignation(ev, dossierResignation) {
            vm.prompt={};
            vm.prompt.title=gettextCatalog.getString('Rechazar solicitud');
            vm.prompt.textContent=gettextCatalog.getString('Escriba aquí el motivo del rechazo:');
            vm.prompt.ok=gettextCatalog.getString('Rechazar');
            vm.prompt.cancel=gettextCatalog.getString('Cancelar');
            vm.prompt.save=function(result){
                $mdDialog.hide();
                dossierResignation.resolution = result;
                dossierResignationsService.rejectResignation(dossierResignation).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Solicitud rechazada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al rechazar la solicitud. " + (error.data.detail || "") +(error.data.resolution ? "Debe dar un motivo":""));
                });
            };

            $mdDialog.show({
                templateUrl: "prompt.html",
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }



    }
})();
(function () {
    'use strict';
    angular
        .module('app.dossierQuotes')
        .controller('DossierQuotesController', DossierQuotesController);

    /** @ngInject */
    function DossierQuotesController($scope, currentUser, dossierQuotesService, DossierQuotes, Dossier,
                                     $mdSidenav, $mdDialog, $document, DebounceService) {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossier = Dossier;
        vm.dossierQuotes = DossierQuotes;
        vm.monthsLabel = {};

        // Watchers
        $scope.$watch('vm.dossierQuotes.filters', DebounceService(dossierQuotesService.getDossierQuotes, 300), true);

        // Methods
        vm.openQuoteDialog = openQuoteDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        vm.monthsLabel[1] ='Enero';
        vm.monthsLabel[2] ='Febrero';
        vm.monthsLabel[3] ='Marzo';
        vm.monthsLabel[4] ='Abril';
        vm.monthsLabel[5] ='Mayo';
        vm.monthsLabel[6] ='Junio';
        vm.monthsLabel[7] ='Julio';
        vm.monthsLabel[8] ='Agosto';
        vm.monthsLabel[9] ='Septiembre';
        vm.monthsLabel[10] ='Octubre';
        vm.monthsLabel[11] ='Noviembre';
        vm.monthsLabel[12] ='Diciembre';

        /**
         * Abre el dialogo para crear/editar una dossierQuote
         *
         * @param ev
         * @param dossierQuote
         */
        function openQuoteDialog(ev, dossierQuote) {
            $mdDialog.show({
                controller: 'DossierQuotesDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierQuotes/dialogs/dossierQuotes/dossierQuotes-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DossierQuote: dossierQuote,
                    event: ev,
                    Dossier: Dossier
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.dossierInterruptions')
        .controller('DossierInterruptionsController', DossierInterruptionsController);
    /** @ngInject */
    function DossierInterruptionsController($scope, Dossier, currentUser, dossierInterruptionsService, DossierInterruptions,
                                             $mdSidenav, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossier = Dossier;
        vm.dossierInterruptions=DossierInterruptions;

        // Watchers
        $scope.$watch('vm.dossierInterruptions.filters', DebounceService(dossierInterruptionsService.getDossierInterruptions, 300), true);

        // Methods
        vm.openDossierInterruptionDialog = openDossierInterruptionDialog;
        vm.acceptInterrumption = acceptInterrumption;
        vm.rejectInterrumption = rejectInterrumption;
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Abre el dialogo para crear/editar una dossierInterruption
         *
         * @param ev
         * @param dossierInterruption
         */
        function openDossierInterruptionDialog(ev, dossierInterruption) {
            $mdDialog.show({
                controller: 'DossierInterruptionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierInterruptions/dialogs/dossierInterruption/dossierInterruption-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DossierInterruption:dossierInterruption,
                    Dossier:Dossier,
                    event: ev
                }
            });
        }

        /**
         * Acepta una interrupción
         *
         * @param ev
         * @param dossierInterruption
         */
        function acceptInterrumption(ev, dossierInterruption) {
            return dossierInterruptionsService.acceptInterrumption(dossierInterruption).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Interrupción aceptada correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al aceptar la interrupción. " + (error.data.detail || ""));
            });
        }
        
        /**
         * Rechaza una interrupción
         *
         * @param ev
         * @param dossierInterruption
         */
        function rejectInterrumption(ev, dossierInterruption) {
            vm.prompt={};
            vm.prompt.title=gettextCatalog.getString('Rechazar interrupción');
            vm.prompt.textContent=gettextCatalog.getString('Escriba aquí el motivo del rechazo:');
            vm.prompt.ok=gettextCatalog.getString('Rechazar');
            vm.prompt.cancel=gettextCatalog.getString('Cancelar');
            vm.prompt.save=function(result){
                $mdDialog.hide();
                dossierInterruption.rejected_message = result;
                return dossierInterruptionsService.rejectInterrumption(dossierInterruption).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Interrupción rechazada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al rechazar la interrupción. " + (error.data.detail || "") +(error.data.rejected_message ? "Debe dar un motivo":""));
                });
            };

            $mdDialog.show({
                templateUrl: "prompt.html",
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            });
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.dossierExtensions')
        .controller('DossierExtensionsController', DossierExtensionsController);
    /** @ngInject */
    function DossierExtensionsController($scope, Dossier, currentUser, dossierExtensionsService, dossiersService, DossierExtensions,
                                         $mdSidenav, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossier = Dossier;
        vm.dossierExtensions=DossierExtensions;

        // Watchers
        $scope.$watch('vm.dossierExtensions.filters', DebounceService(dossierExtensionsService.getDossierExtensions, 300), true);

        // Methods
        vm.openDossierExtensionDialog = openDossierExtensionDialog;
        vm.removeDossierExtension = removeDossierExtension;
        vm.acceptExtension = acceptExtension;
        vm.sendAdjudicationResolution = sendAdjudicationResolution;
        vm.rejectExtension = rejectExtension;
        vm.cofinancingCalculate = cofinancingCalculate;
        vm.toggleSidenav = toggleSidenav;

        //////////
        /**
         * Abre el dialogo para crear/editar una dossierExtension
         *
         * @param ev
         * @param dossierExtension
         */
        function openDossierExtensionDialog(ev, dossierExtension) {
            // El expediente de la pestaña se cargó al entrar y su fecha fin puede haber cambiado (edición a
            // mano, prórroga concedida): se relee antes de abrir para que el inicio salga ya actualizado
            dossiersService.getDossier(Dossier.id).then(function(dossier){
                vm.dossier = dossier;
                showDossierExtensionDialog(ev, dossierExtension, dossier);
            }, function(){
                showDossierExtensionDialog(ev, dossierExtension, Dossier);
            });
        }

        function showDossierExtensionDialog(ev, dossierExtension, dossier) {
            $mdDialog.show({
                controller: 'DossierExtensionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierExtensions/dialogs/dossierExtension/dossierExtension-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DossierExtension:dossierExtension,
                    Dossier:dossier,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una dossierExtension
         *
         * @param ev
         * @param dossierExtension
         */
        function removeDossierExtension(ev, dossierExtension) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Cancelar prórroga'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres cancelar la prórroga?'))
                .ariaLabel(gettextCatalog.getString('Cancelar prórroga'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Cancelar prórroga'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                dossierExtensionsService.removeDossierExtension(dossierExtension).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Prórroga cancelada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al cancelar la prórroga. " + (error.data.detail || ""));
                });
            });

        }
        
        /**
         * Acepta una prórroga
         *
         * @param ev
         * @param dossierExtension
         */
        function acceptExtension(ev, dossierExtension) {
            return dossierExtensionsService.acceptExtension(dossierExtension).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Prórroga aceptada correctamente."));
            }, function(error){
                NotifyService.errorMessage("Error al aceptar la prórroga. " + (error.data.detail || ""));
            });
        }
        
        /**
         * Envía a firma la resolución de adjudicación de la prórroga
         *
         * @param ev
         * @param dossierExtension
         */
        function sendAdjudicationResolution(ev, dossierExtension) {
            return dossierExtensionsService.sendAdjudicationResolution(dossierExtension).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Resolución enviada a firma."));
            }, function(error){
                var data = error.data || {};
                NotifyService.errorMessage(gettextCatalog.getString("Error al enviar la resolución a firma. ") +
                    (data.non_field_errors || data.detail || ""));
            });
        }

        /**
         * Rechaza una prórroga
         *
         * @param ev
         * @param dossierExtension
         */
        function rejectExtension(ev, dossierExtension) {
            vm.prompt={};
            vm.prompt.title=gettextCatalog.getString('Rechazar prórroga');
            vm.prompt.textContent=gettextCatalog.getString('Escriba aquí el motivo del rechazo:');
            vm.prompt.ok=gettextCatalog.getString('Rechazar');
            vm.prompt.cancel=gettextCatalog.getString('Cancelar');
            vm.prompt.save=function(result){
                $mdDialog.hide();
                dossierExtension.rejected_message = result;
                return dossierExtensionsService.rejectExtension(dossierExtension).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Prórroga rechazada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al rechazar la prórroga. " + (error.data[0] || "") +(error.data.rejected_message ? "Debe dar un motivo":""));
                });
            };

            $mdDialog.show({
                templateUrl: "prompt.html",
                clickOutsideToClose: true,
                scope: $scope,
                preserveScope: true
            });
        }

        function cofinancingCalculate(dossierExtension){
            var params={
                id:vm.dossier.id,
                duration:dossierExtension.duration,
                extension:dossierExtension.id,
                economic_endowment:dossierExtension.economic_endowment
            };
            return dossierExtensionsService.getCofinancingCalculate(params).then(function(response){
                dossierExtension.messageCofinance=response.message;
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("No se pudo calcular la cofinanciación"));
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.dossierDocuments')
        .controller('DossierDocumentsController', DossierDocumentsController);
    /** @ngInject */
    function DossierDocumentsController($scope, currentUser, dossierDocumentsService, DossierDocuments, Dossier,
                                 $mdSidenav, $mdDialog, $document, DebounceService, NotifyService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.dossier = Dossier;
        vm.dossierDocuments=DossierDocuments;

        // Watchers
        $scope.$watch('vm.dossierDocuments.filters', DebounceService(dossierDocumentsService.getDossierDocuments, 300), true);

        // Methods
        vm.openDocumentDialog = openDocumentDialog;
        vm.removeDocument = removeDocument;
        vm.openDocumentPermissionDialog = openDocumentPermissionDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Abre el dialogo para crear/editar una dossierDocument
         *
         * @param ev
         * @param dossierDocument
         */
        function openDocumentDialog(ev, dossierDocument) {
            $mdDialog.show({
                controller: 'DossierDocumentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierDocuments/dialogs/dossierDocument/dossierDocument-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DossierDocument:dossierDocument,
                    event: ev,
                    Dossier:Dossier
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una document
         *
         * @param ev
         * @param document
         */
        function removeDocument(ev, document) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar documento')+' "'+document.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el documento?'))
                .ariaLabel(gettextCatalog.getString('Eliminar documento'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar documento'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                dossierDocumentsService.removeDossierDocument(document).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Documento borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la documento. " + (error.data.non_field_errors || ""));
                });
            });

        }

        /**
         * Abre el dialogo para editar permisos de un documento
         *
         * @param ev
         * @param document
         */
        function openDocumentPermissionDialog(ev, document) {
            $mdDialog.show({
                controller: 'DocumentPermissionDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/documents/dialogs/documentPermissions/documentPermissions-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DocumentPermission:document,
                    event: ev
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();
(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .controller('DossierController', DossierController);

    /** @ngInject */
    function DossierController($rootScope, currentUser, Dossier, offersRequestsService, dossiersService, NotifyService, $mdSidenav,
                               $document, $state, $mdDialog, evaluationsPointsService, Points, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.UCA_COMPANY_CIF = $rootScope.UCA_COMPANY_CIF;
        vm.dossier = formatDossier(Dossier);

        $rootScope.getPhoto(vm.dossier.student.id,vm);

        // Methods
        vm.acceptDossier = acceptDossier;
        vm.discardDossier = discardDossier;
        vm.reportRequest = reportRequest;
        vm.openDocumentDialog = openDocumentDialog;
        vm.toggleSidenav = toggleSidenav;
        vm.confirmDossierProfesionalTutor = confirmDossierProfesionalTutor;

        //////////
        
        function formatDossier(dossier) {
            var a = angular.copy(dossier);
            a.start_date=a.start_date ? new Date(moment(a.start_date).format()) : new Date();
            a.start_date_interruption=a.start_date_interruption ? new Date(moment(a.start_date_interruption).format()) : new Date();
            a.end_date_interruption=a.end_date_interruption ? new Date(moment(a.end_date_interruption).format()) : new Date();
            return a;
        }
        
        /**
         * Guardar detalle del expediente
         */
        function acceptDossier() {
            var obj={
                id:vm.dossier.id
            };
            return dossiersService.acceptDossier(obj).then(function(response){
                vm.dossier=formatDossier(response);
                NotifyService.successMessage(gettextCatalog.getString("Expediente aceptado correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al aceptar expediente. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Descarta un expediente
         */
        function discardDossier() {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Rechazar oferta'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres rechazar esta oferta?'))
                .ariaLabel(gettextCatalog.getString('Rechazar oferta'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Rechazar oferta'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                var obj = {};
                obj.id = Dossier.offer_request;
                obj.status = "rejected";

                return offersRequestsService.saveOffersRequest(obj).then(function (response) {
                    NotifyService.successMessage(gettextCatalog.getString("Expediente rechazado correctamente"));
                    $state.go("app.dossiers.list");
                }, function (error) {
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al rechazar expediente. ") + (error.data.non_field_errors || "") + (error.data.status || ""));

                });
            });
        }

        /**
         * Solicitar evaluación
         */
        function reportRequest() {
            var reportRequest={
                dossier:vm.dossier.id,
                reason:"Solicitud",
                user:vm.user.id
            };
            return dossiersService.reportRequest(reportRequest).then(function(response){
                vm.dossier=formatDossier(response);
                NotifyService.successMessage(gettextCatalog.getString("Evaluación solicitada correctamente"));

                evaluationsPointsService.evaluationsPoints.filters={};
                evaluationsPointsService.evaluationsPoints.filters.dossier=Dossier.id;
                return evaluationsPointsService.getEvaluationsPoints().then(function(response){
                    Dossier.evaluations_points=response.data;
                    vm.dossier.evaluations_points=response.data;
                });

            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al solicitar evaluación. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Abre el dialogo para crear/editar una dossierDocumentRequired
         *
         * @param ev
         */
        function openDocumentDialog(ev) {
            $mdDialog.show({
                controller: 'DossierDocumentRequiredDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dossiers/views/dossierDocuments/dialogs/dossierDocumentRequired/dossierDocumentRequired-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev,
                    Dossier:vm.dossier
                }
            });
        }

        /**
         * Confirmar expediente curricular por tutor profesional
         */
        function confirmDossierProfesionalTutor() {
            var dossier={
                id:vm.dossier.id
            };
            return dossiersService.confirmProfesionalTutor(dossier).then(function(response){
                vm.dossier=formatDossier(response);
                NotifyService.successMessage(gettextCatalog.getString("Expediente confirmado correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al confirmar expediente. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.documents',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        // State
        
        $stateProvider
            .state('app.documents', {
                abstract: true,
                url: '/documents',
                resolve:{
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    }
                }
            })
            .state('app.documents.list', {
                url: '/',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/documents/views/list/documents-list.html',
                        controller: 'DocumentsController as vm'
                    }
                },
                resolve: {
                    Documents: function (documentsService) {
                        return documentsService.getDocuments();
                    }
                },
                bodyClass: 'documents'
            })
            .state('app.documents.detail', {
                url      : '/:document/?filename',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/documents/views/detail/document.html',
                        controller : 'DocumentController as vm'
                    }
                },
                resolve  : {
                    Document: function ($stateParams) {
                        return {
                            name:$stateParams.filename,
                            id:$stateParams.document
                        };
                    }
                },
                bodyClass: 'todo'
            });
    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.documents')
        .controller('DocumentsController', DocumentsController);
    /** @ngInject */
    function DocumentsController($scope, currentUser, documentsService, Documents, NotifyService, $mdDialog,
                                 $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.documents=Documents;

        // Watchers
        $scope.$watch('vm.documents.filters', DebounceService(documentsService.getDocuments, 300), true);

        // Methods
        vm.openDocumentDialog = openDocumentDialog;
        vm.removeDocument = removeDocument;

        //////////
        /**
         * Abre el dialogo para crear/editar una document
         *
         * @param ev
         * @param document
         * @param type
         */
        function openDocumentDialog(ev, document, type) {
            $mdDialog.show({
                controller: 'DocumentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/documents/dialogs/document/document-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Document:document,
                    event: ev,
                    TypeDocument:type
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una document
         *
         * @param ev
         * @param document
         */
        function removeDocument(ev, document) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar documento')+' "'+document.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el documento?'))
                .ariaLabel(gettextCatalog.getString('Eliminar documento'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar documento'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                documentsService.removeDocument(document).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Documento borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la documento. " + (error.data.detail || ""));
                });
            });

        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.documents')
        .controller('DocumentController', DocumentController);
    /** @ngInject */
    function DocumentController($rootScope, Document)
    {
        var vm = this;

        //init
        $rootScope.getDocument(Document);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.documents')
        .controller('DocumentPreviewDialogController', DocumentPreviewDialogController);

    /**
     * Vista previa e impresión de un documento PDF.
     *
     * Recibe el blob ya obtenido por quien abre el diálogo (documentos, convenio...), de modo que el
     * diálogo no depende de ningún servicio: construye un blob URL, lo muestra en un iframe con el visor
     * del navegador y lanza la impresión desde ese iframe. Al cerrarse libera el blob URL.
     */
    /** @ngInject */
    function DocumentPreviewDialogController($scope, $rootScope, $mdDialog, $timeout, $window, FileName, FileBlob) {
        var vm = this;

        // Tiempo máximo de espera al evento load del iframe antes de habilitar Imprimir de todos modos
        var LOAD_TIMEOUT = 6000;
        var FRAME_ID = 'document-preview-frame';

        var blobUrl = null;
        var loadTimer = null;

        // Data
        vm.title = FileName;
        vm.canPreview = canPreview();
        vm.loaded = false;
        vm.printFailed = false;

        // Methods
        vm.print = print;
        vm.download = download;
        vm.closeDialog = closeDialog;

        init();

        //////////

        function init() {
            if (!vm.canPreview) {
                return;
            }

            blobUrl = $window.URL.createObjectURL(FileBlob);

            // El src se asigna desde aquí, tras engancharse al evento load, para no perderlo.
            $timeout(function () {
                var frame = getFrame();
                if (!frame) {
                    return;
                }
                frame.addEventListener('load', onFrameLoad);
                frame.src = blobUrl;
                loadTimer = $timeout(function () {
                    vm.loaded = true;
                }, LOAD_TIMEOUT);
            });

            $scope.$on('$destroy', cleanup);
        }

        /**
         * Detección conservadora de navegadores sin visor PDF inline
         * (IE11 con msSaveOrOpenBlob y navegadores móviles).
         */
        function canPreview() {
            var nav = $window.navigator || {};
            if (nav.msSaveOrOpenBlob) {
                return false;
            }
            var ua = nav.userAgent || '';
            return !(/Android|iPhone|iPad|iPod|Mobile/i.test(ua));
        }

        function getFrame() {
            return $window.document.getElementById(FRAME_ID);
        }

        function onFrameLoad() {
            $scope.$applyAsync(function () {
                vm.loaded = true;
            });
        }

        /**
         * Lanza el diálogo de impresión del visor del navegador sobre el PDF del iframe
         */
        function print() {
            var frame = getFrame();
            try {
                frame.contentWindow.focus();
                frame.contentWindow.print();
            } catch (e) {
                vm.printFailed = true;
            }
        }

        /**
         * Descarga el mismo blob ya recibido, sin nueva petición al servidor
         */
        function download() {
            $rootScope.downloadBlob(FileBlob, FileName);
        }

        function cleanup() {
            if (loadTimer) {
                $timeout.cancel(loadTimer);
            }
            var frame = getFrame();
            if (frame) {
                frame.removeEventListener('load', onFrameLoad);
            }
            if (blobUrl) {
                $window.URL.revokeObjectURL(blobUrl);
                blobUrl = null;
            }
        }

        /**
         * Cerrar el cuadro de diálogo
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .controller('DocumentPermissionDialogController', DocumentPermissionDialogController);

    /** @ngInject */
    function DocumentPermissionDialogController($mdDialog, DocumentPermission, dossierDocumentsService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar permisos');
        vm.documentPermission = angular.copy(DocumentPermission); // Copiamos para no modificar el original hasta guardar

        vm.permissions={
            'manager':gettextCatalog.getString("Administradores"),
            'student':gettextCatalog.getString("Estudiante"),
            'tutor':gettextCatalog.getString("Tutor académico"),
            'company_manager':gettextCatalog.getString("Gestor administrativo"),
            // 'companycontact':gettextCatalog.getString("Contactos de empresa"),
            // 'responsible_signing_agreement-single':gettextCatalog.getString("Responsable de firma"),
            // 'responsible_signing_agreement-joint':gettextCatalog.getString("Responsable de firma de forma mancomunada"),
            'human_resource_manager':gettextCatalog.getString("Responsable de recursos humanos"),
            'professional_tutor':gettextCatalog.getString("Tutor profesional")
        };

        // Methods
        vm.saveDocumentPermission = saveDocumentPermission;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar documentPermissiono
         */
        function saveDocumentPermission() {
            return dossierDocumentsService.changePermission(angular.copy(vm.documentPermission)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Permisos modificados correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al modificar permisos. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .controller('DocumentDialogController', DocumentDialogController);

    /** @ngInject */
    function DocumentDialogController($scope, $mdDialog, Document, documentsService, NotifyService, $timeout, TypeDocument,
                                      gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar documento');

        if (!Document) {
            vm.title = gettextCatalog.getString('Nuevo documento');
            vm.document = documentsService.getEmptyDocument(TypeDocument);
        } else {
            vm.document = angular.copy(Document); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveDocument = saveDocument;
        vm.closeDialog = closeDialog;
        vm.openFiles = openFiles;

        init();
        //////////

        function init(){
            $timeout(function(){
                $("#file-uploader").change(function(){
                    readURL(this);
                });
            });
        }

        /**
         * Guardar documento
         */
        function saveDocument() {
            return documentsService.saveDocument(angular.copy(vm.document)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Documento guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el documento. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        function openFiles(){
            $("#file-uploader").trigger("click");
        }

        /**
         * Image change
         * @param input
         */
        function readURL(input)
        {
            if (input.files && input.files[0]) {
                var reader = new FileReader();

                reader.onload = function (e) {
                    vm.document.document = e.target.result;

                    if(!$scope.$$phase) {
                        $scope.$digest();
                    }
                };

                reader.readAsDataURL(input.files[0]);
            }
        }

    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.pendingAssignments')
        .controller('pendingAssignmentsController', pendingAssignmentsController);
    /** @ngInject */
    function pendingAssignmentsController(currentUser, Students, Demand,  NotifyService, $mdDialog, demandsSchedulesService, SubjectsTeachers,
                              $document, offersPostulatesService, demandsRequestsService, OffersPostulates, degreesService, gettextCatalog,
                                          $mdToast, $location)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.students=Students;
        vm.demand=Demand;
        vm.workingdays=demandsSchedulesService.getTypes();

        vm.filters={};

        vm.orders={
            company:"",
            student:""
        };

        init();

        // Methods
        vm.openpendingAssignmentDialog = openpendingAssignmentDialog;
        vm.removependingAssignment = removependingAssignment;
        vm.createDossier = createDossier;
        vm.createDossiers = createDossiers;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;

        //////////

        function init(){
            for(var i in vm.students){
                for(var j in OffersPostulates.data){
                    if(vm.students[i].identification===OffersPostulates.data[j].request_offer_data.student_data.contact_student.identification){
                        vm.students[i].offer_data=OffersPostulates.data[j];
                    }else if(vm.students[i].identification===OffersPostulates.data[j].request_offer_data.student_data.contact_student){
                        vm.students[i].has_dossier=true;
                    }
                }
            }
        }

        /**
         * Abre el dialogo para crear una pendingAssignment
         *
         * @param ev
         * @param student
         */
        function openpendingAssignmentDialog(ev,student) {
            offersPostulatesService.offersPostulates.filters={};
            offersPostulatesService.offersPostulates.filters.schedule__demand=Demand.id;
            // offersPostulatesService.offersPostulates.filters.offer_requests='empty';
            offersPostulatesService.offersPostulates.filters.page="all";
            return offersPostulatesService.getOffersPostulates().then(function(res){
                $mdDialog.show({
                    controller: 'pendingAssignmentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/demands/views/pendingAssignments/dialogs/pendingAssignment/pendingAssignment-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        event: ev,
                        Student: student,
                        Orders: vm.orders,
                        OffersPostulates: res,
                        SubjectsTeachers: SubjectsTeachers
                    }
                });
            })
        }
        
        /**
         * Abre el dialogo para eliminar una pendingAssignment
         *
         * @param ev
         * @param student
         */
        function removependingAssignment(ev, student) {
            var pendingAssignment=student.offer_data.request_offer_data;
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar asignación'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la asignación de este alumno?'))
                .ariaLabel(gettextCatalog.getString('Eliminar asignación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar asignación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                demandsRequestsService.removeDemandsRequest(pendingAssignment).then(function(){
                    delete student.offer_data;
                    NotifyService.successMessage(gettextCatalog.getString("Asignación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la asignación. " + (error.data.detail || ""));
                });
            });
        }

        /**
         * Crea el expediente de una oferta relacionada con un alumno
         *
         * @param student
         */
        function createDossier(student) {
            if(student.offer_data.start_date < moment().format("YYYY-MM-DD")){
                create(student, true);

            }else{
                create(student);
            }

        }
        function create(student, popup){
            return demandsRequestsService.createDossier(student.offer_data.request_offer_data).then(function(response){
                delete student.offer_data;
                student.has_dossier=true;
                NotifyService.successMessage(gettextCatalog.getString("Expediente creado correctamente."));
            if(popup){
                setTimeout(function (){
                    NotifyService.successMessage(gettextCatalog.getString("La fecha que ha asignado " +
                        "tiene una fecha anterior a la actual. Por motivos de plazos con la Tesorería" +
                        " General de la Seguridad Social, la fecha de inicio debe ser hoy o posterior" +
                        " al día de hoy."));
                },1000)
            }
                }, function(error){
                showErrorMessage("Error al crear el expediente. " +
                    (error.data.non_field_errors[0] || error.data.detail || ""),
                    student.offer_data.request_offer_data.student);
            });
        }

        /**
         * Crea los expedientes de todas las ofertas relacionadas con un alumno
         *
         */
        function createDossiers() {
            return demandsRequestsService.createDossiers(Demand).then(function(response){
                for(var i in vm.students){
                    for(var j in response.results){
                        if(vm.students[i].identification===response.results[j].student_data.contact_student){
                            delete vm.students[i].offer_data;
                            vm.students[i].has_dossier=true;
                        }
                    }
                }
                NotifyService.successMessage(gettextCatalog.getString("Expedientes creados correctamente."));
            }, function(error){
                console.log(error)
                // NotifyService.errorMessage("Error al crear los expedientes. " + (error.data.detail || ""));
                showErrorMessage("Error al crear los expedientes. " +
                    (error.data.non_field_errors[0] || error.data.detail || ""), error.data.non_field_errors[1]);
            });
        }

        function showErrorMessage(message, id) {
            // Calculamos el tiempo adicional para mensajes largos
            var time = 6000;
            time += (message.length * 25);

            // Mostramos el toast con un botón de acción
            $mdToast.show(
                $mdToast.simple()
                    .textContent(message)
                    .theme('toast-error')
                    .hideDelay(time)
                    .action('Editar Alumno')
                    .highlightAction(true)
                    .highlightClass('md-accent') // Clase de estilo para el botón
            ).then(function(response) {
                if (response === 'ok') {
                    // Redirigir a la página del expediente
                    // window.location.href = http://localhost:3000/students/49172/detail;
                    $location.path('/students/'+id+'/detail');

                }
            });
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.offersPostulates')
        .controller('OffersPostulatesController', OffersPostulatesController);
    /** @ngInject */
    function OffersPostulatesController(currentUser, Demand, demandsSchedulesService, OffersPostulates, Centers, NotifyService, DemandsProfiles,
                                      offersPostulatesService, DemandsSchedules, $mdDialog, $document, Tutors, degreesService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.demand = Demand;
        vm.workingdays=demandsSchedulesService.getTypes();
        vm.offersPostulates=OffersPostulates;
        vm.demandsSchedules=DemandsSchedules;

        // Methods
        vm.openOffersPostulateDialog = openOffersPostulateDialog;
        vm.openOffersCurricularDialog = openOffersCurricularDialog;
        vm.discarded = discarded;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;
        vm.showObservations = showObservations;

        //////////
        /**
         * Abre el dialogo de creacion de plazas para un periodo de una oferta curricular
         *
         * @param ev
         * @param demandSchedule
         */
        function openOffersPostulateDialog(ev, demandSchedule) {
            $mdDialog.show({
                controller: 'OffersPostulateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demands/views/offersPostulates/dialogs/offersPostulate/offersPostulate-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    DemandSchedule: demandSchedule,
                    DemandsProfiles: DemandsProfiles,
                    Centers: Centers,
                    Tutors: Tutors,
                    event: ev
                }
            });
        }

        /**
         * Edita la oferta
         *
         * @param ev
         * @param offersCurricular
         */
        function openOffersCurricularDialog(ev, offersCurricular) {
            $mdDialog.show({
                controller: 'OffersCurricularDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demands/views/offersPostulates/dialogs/offersCurricular/offersCurricular-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    OffersCurricular: offersCurricular,
                    Tutors: Tutors,
                    event: ev
                }
            });
        }

        /**
         * Descarta la plaza no asignada de una oferta
         */
        function discarded(offersPostulate) {
            return offersPostulatesService.discarded(offersPostulate).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Plaza descartada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al descartar plaza. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Abre diálogo con la informacion de las observaciones
         */
        function showObservations(ev, observations) {
          $mdDialog.show(
            $mdDialog.alert()
              .parent(angular.element(document.querySelector('#popupContainer')))
              .clickOutsideToClose(true)
              .parent(angular.element(document.body))
              .title('Observaciones')
              .textContent(observations)
              .ariaLabel('Observaciones')
              .ok('Cerrar')
              .targetEvent(ev)
          );
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.demands',
            [
                'app.offersPostulates',
                'app.pendingAssignments',
                'app.demandsCompanies'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        
        $stateProvider
            .state('app.demands', {
                abstract: true,
                url: '/demands',
                resolve:{
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    }
                }
            })
            .state('app.demands.list', {
                url: '/?offer&student',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/list/demands.html',
                        controller: 'DemandsController as vm'
                    }
                },
                resolve: {
                    Demands: function (demandsService) {
                        var obj={status__iexact:"published"};
                        var concat=[Object.assign({}, obj, demandsService.demands.filtersAdvances[0])];
                        demandsService.demands.filtersAdvances[0]=concat[0];
                        return demandsService.getDemands();
                    },
                    SearchsBasics: function (searchsAdvancesService) {
                        return searchsAdvancesService.getSearchsAdvances('demands');
                    },
                    MyDemands: function () {
                      return false;
                    }
                },
                bodyClass: 'demands'
            })
            .state('app.mydemands', {
                url: '/misdemandas',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/list/demands.html',
                        controller: 'DemandsController as vm'
                    }
                },
                resolve: {
                    currentUser: function (AuthService){
                      return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                          return response;
                        }
                      });
                    },
                    Demands: function (myDemandsService) {
                        myDemandsService.myDemands.filters={};
                        return myDemandsService.getMyDemands();
                    },
                    SearchsBasics: function (searchsAdvancesService) {
                        return searchsAdvancesService.getSearchsAdvances('demands');
                    },
                    MyDemands: function () {
                        return true;
                    }
                },
                bodyClass: 'demands'
            })
            .state('app.demands.get', {
                abstract: true,
                url: '/:demand/',
                resolve:{
                    Demand: function (demandsService,$stateParams) {
                        return demandsService.getDemand($stateParams.demand);
                    },
                    DegreeCoordinator: function (demandsService,$stateParams) {
                        return demandsService.getDegreeCoordinator($stateParams.demand);
                    }
                }
            })
            .state('app.demands.get.detail', {
                url      : 'detail',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/demands/views/detail/demand.html',
                        controller : 'DemandController as vm'
                    }
                },
                resolve  : {
                    DemandsSchedules: function (demandsSchedulesService,$stateParams) {
                        demandsSchedulesService.demandsSchedules.filters={};
                        demandsSchedulesService.demandsSchedules.filters.page="all";
                        demandsSchedulesService.demandsSchedules.filters.demand=$stateParams.demand;
                        return demandsSchedulesService.getDemandsSchedules();
                    },
                    DemandsProfiles: function (demandsProfilesService,$stateParams) {
                        demandsProfilesService.demandsProfiles.filters={};
                        demandsProfilesService.demandsProfiles.filters.page="all";
                        demandsProfilesService.demandsProfiles.filters.demand=$stateParams.demand;
                        return demandsProfilesService.getDemandsProfiles();
                    },
                    Breadcrumb: function (Demand) {
                        return ['<a ui-sref="app.demands.list"> Ofertas curriculares</a>',
                            'Oferta '+(Demand.code || Demand.id)];
                    }
                },
                bodyClass: 'todo'
            });

    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.demands')
        .controller('DemandsController', DemandsController);
    /** @ngInject */
    function DemandsController($scope, currentUser, demandsService, Demands, NotifyService, SearchsBasics, $mdDialog,
                              $document, DebounceService, myDemandsService, $timeout, gettextCatalog, MyDemands, $rootScope)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.demands=Demands;
        vm.searchsBasics=SearchsBasics;
        vm.myDemands=MyDemands;

        init();
        // Watchers
        if(vm.myDemands){
          $scope.$watch('vm.demands.filters', DebounceService(myDemandsService.getMyDemands, 300), true);
        }else{
          $scope.$watch('vm.demands.filters', DebounceService(demandsService.getDemands, 300), true);
        }

        // Methods
        vm.openDemandDialog = openDemandDialog;
        vm.removeDemand = removeDemand;
        vm.search = search;

        //////////
        function init(){
            $timeout(function(){
                //Si no se muestra el búscador no filtramos por este estado ya que no podremos cambiarlo
                if(vm.filterBasic && vm.filterBasic['status']){
                    vm.filterBasic['status'].value='published';
                }

                var form=[{}];

                for(var j in vm.filterBasic){
                    var value=angular.copy(vm.filterBasic[j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.filterBasic[j].option==='range'){
                            var value_range=angular.copy(vm.filterBasic[j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                        }else {
                            form[0][j+"__"+vm.filterBasic[j].option]=value;
                        }
                    }
                }

                vm.demands.filtersAdvances=form;
            });
        }

        /**
         * Abre el dialogo para crear una demand
         *
         * @param ev
         */
        function openDemandDialog(ev) {
            $mdDialog.show({
                controller: 'DemandDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demands/dialogs/demand/demand-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una demand
         *
         * @param ev
         * @param demand
         */
        function removeDemand(ev, demand) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar oferta')+' "'+demand.subject_data.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la oferta?'))
                .ariaLabel(gettextCatalog.getString('Eliminar oferta'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar oferta'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                demandsService.removeDemand(demand).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Oferta borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la oferta. " + (error.data.detail || ""));
                });
            });
        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.demands.filtersAdvances=form;
            vm.demands.filters={};
            vm.demands.filters.page=1;
            return demandsService.getDemands();
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .controller('DemandController', DemandController);

    /** @ngInject */
    function DemandController(currentUser, Demand, demandsService, NotifyService, DemandsSchedules, DemandsProfiles, degreesService, offersPostulatesService,
                             DegreeCoordinator, demandsProfilesService, $rootScope, demandsSchedulesService, $mdSidenav, $mdDialog, $document, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.demand = Demand;
        vm.demandsSchedules = DemandsSchedules;
        vm.demandsProfiles = DemandsProfiles;
        vm.degreeCoordinator = DegreeCoordinator;
        vm.workingdays=demandsSchedulesService.getTypes();

        // Methods
        vm.saveDemand = saveDemand;
        vm.openDemandsScheduleDialog = openDemandsScheduleDialog;
        vm.openDemandsProfileDialog = openDemandsProfileDialog;
        vm.removeDemandsSchedule = removeDemandsSchedule;
        vm.removeDemandsProfile = removeDemandsProfile;
        vm.publishDemand = publishDemand;
        vm.discardedAll = discardedAll;
        vm.toggleSidenav = toggleSidenav;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;

        //////////

        /**
         * Guardar detalle de empresa
         */
        function saveDemand(successCallback, errorCallback) {
            var demand=angular.copy(vm.demand);

            return demandsService.saveDemand(demand).then(function(response){
                vm.demand=response;
                if(successCallback){
                    successCallback(response);
                }else{
                    NotifyService.successMessage(gettextCatalog.getString("Oferta guardada correctamente"));
                }
            }, function(error){
                vm.serverErrors = error.data;
                if(errorCallback){
                    errorCallback(error);
                }else{
                    NotifyService.errorMessage(gettextCatalog.getString("Error al guardar oferta. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                }
            });
        }

        /**
         * Abre el dialogo para crear un periodo
         *
         * @param ev
         * @param demandsSchedule
         */
        function openDemandsScheduleDialog(ev, demandsSchedule) {
            $mdDialog.show({
                controller: 'DemandsScheduleDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demands/dialogs/demandsSchedule/demandsSchedule-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Demand: Demand,
                    event: ev,
                    DemandsSchedule: demandsSchedule
                }
            });
        }

        /**
         * Abre el dialogo para crear un perfil
         *
         * @param ev
         * @param demandsProfile
         */
        function openDemandsProfileDialog(ev, demandsProfile) {
            $mdDialog.show({
                controller: 'DemandsProfileDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demands/dialogs/demandsProfile/demandsProfile-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Demand: Demand,
                    event: ev,
                    DemandsProfile: demandsProfile
                }
            });
        }

        /**
         * Abre el dialogo para eliminar un periodo
         *
         * @param ev
         * @param demandsSchedule
         */
        function removeDemandsSchedule(ev, demandsSchedule) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar periodo'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el periodo?'))
                .ariaLabel(gettextCatalog.getString('Eliminar periodo'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar periodo'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                demandsSchedulesService.removeDemandsSchedule(demandsSchedule).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Periodo borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el periodo. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para eliminar un perfil
         *
         * @param ev
         * @param demandsProfile
         */
        function removeDemandsProfile(ev, demandsProfile) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar perfil'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el perfil?'))
                .ariaLabel(gettextCatalog.getString('Eliminar perfil'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar perfil'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                demandsProfilesService.removeDemandsProfile(demandsProfile).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Perfil borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el perfil. " + (error.data.detail || ""));
                });
            });

        }
        
        /**
         * Publicar oferta
         */
        function publishDemand() {
            var demand=angular.copy(vm.demand);
            return demandsService.publishDemand(demand).then(function(response){
                vm.demand=response;
                Demand.status=response.status;
                NotifyService.successMessage(gettextCatalog.getString("Oferta publicada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al publicar oferta. ")+ (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Descarta las plazas no asignadas de una oferta
         */
        function discardedAll() {
            var demand=angular.copy(vm.demand);

            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Descartar plazas no asignadas'))
                .textContent(gettextCatalog.getString('Se eliminarán todas las plazas que no tengan creado un expediente ¿Desea continuar?'))
                .ariaLabel(gettextCatalog.getString('Descartar plazas no asignadas'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Descartar plazas'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                return offersPostulatesService.discardedAll(demand).then(function (response) {
                    NotifyService.successMessage(gettextCatalog.getString("Plazas descartadas correctamente"));
                    demandsService.getDemand(Demand.id).then(function (res) {
                        vm.demand.seats_method=res.seats_method;
                        vm.demand.companies=res.companies;
                    });
                }, function (error) {
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al descartar plazas. ") + (error.data.detail || "") + (error.data.error || "") + (error.data.non_field_errors || ""));
                });
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.demandsCompanies')
        .controller('DemandsCompaniesController', DemandsCompaniesController);
    /** @ngInject */
    function DemandsCompaniesController($scope, currentUser, demandsCompaniesService, DemandsCompanies, NotifyService, $mdDialog,
                              $document, DebounceService, Demand, degreesService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.demandsCompanies=DemandsCompanies;
        //LLega como objeto, asi que lo convertimos en array
        vm.demandsCompanies.data=Object.values(vm.demandsCompanies.data);
        vm.demand=Demand;
        vm.filters={};

        // Watchers
        $scope.$watch('vm.demandsCompanies.filters', DebounceService(demandsCompaniesService.getDemandsCompanies, 300), true);

        // Methods
        vm.openDemandDialog = openDemandDialog;
        vm.removeDemand = removeDemand;
        vm.search = search;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;

        //////////
        /**
         * Abre el dialogo para crear una demand
         *
         * @param ev
         */
        function openDemandDialog(ev) {
            $mdDialog.show({
                controller: 'DemandDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/demandsCompanies/dialogs/demand/demand-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una demand
         *
         * @param ev
         * @param demand
         */
        function removeDemand(ev, demand) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar oferta')+' "'+demand.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la oferta?'))
                .ariaLabel(gettextCatalog.getString('Eliminar oferta'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar oferta'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                demandsCompaniesService.removeDemand(demand).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Oferta borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la oferta. " + (error.data.detail || ""));
                });
            });
        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.demandsCompanies.filtersAdvances=form;
            vm.demandsCompanies.filters={};
            vm.demandsCompanies.filters.page=1;
            return demandsCompaniesService.getDemandsCompanies();
        }



    }
})();
(function () {
    'use strict';

    angular
        .module('app.demands')
        .controller('DemandsProfileDialogController', DemandsProfileDialogController);

    /** @ngInject */
    function DemandsProfileDialogController($mdDialog, DemandsProfile, demandsProfilesService, Demand, NotifyService,
                                            $rootScope, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar perfil');
        vm.hasPermission = $rootScope.hasPermission;

        if (!DemandsProfile) {
            vm.title = gettextCatalog.getString('Nuevo perfil');
            vm.demandsProfile = demandsProfilesService.getEmptyDemandsProfile(Demand.id);
        } else {
            vm.demandsProfile = angular.copy(DemandsProfile); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveDemandsProfile = saveDemandsProfile;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar perfil
         */
        function saveDemandsProfile() {
            var form=angular.copy(vm.demandsProfile);
            return demandsProfilesService.saveDemandsProfile(form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Perfil guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el perfil. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .controller('DemandsScheduleDialogController', DemandsScheduleDialogController);

    /** @ngInject */
    function DemandsScheduleDialogController($mdDialog, DemandsSchedule, demandsSchedulesService, Demand, NotifyService,
                                             gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Editar periodo');
        vm.workingdays=demandsSchedulesService.getTypes();

        if (!DemandsSchedule) {
            vm.title = gettextCatalog.getString('Nuevo periodo');
            vm.demandsSchedule = demandsSchedulesService.getEmptyDemandsSchedule(Demand.id);
            vm.demandsSchedule.duration=Demand.practice_credits;
        } else {
            vm.demandsSchedule = angular.copy(DemandsSchedule); // Copiamos para no modificar el original hasta guardar
            if(vm.demandsSchedule.start_date_start_practices){
                vm.demandsSchedule.start_date_start_practices=moment(vm.demandsSchedule.start_date_start_practices).toDate();
            }
            if(vm.demandsSchedule.end_date_start_practices){
                vm.demandsSchedule.end_date_start_practices=moment(vm.demandsSchedule.end_date_start_practices).toDate();
            }
            if(vm.demandsSchedule.end_date_practices){
                vm.demandsSchedule.end_date_practices=moment(vm.demandsSchedule.end_date_practices).toDate();
            }
        }

        // Methods
        vm.saveDemandsSchedule = saveDemandsSchedule;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar periodo
         */
        function saveDemandsSchedule() {
            var form=angular.copy(vm.demandsSchedule);
            if(form.start_date_start_practices){
                form.start_date_start_practices=moment(form.start_date_start_practices).format("YYYY-MM-DD");
            }
            if(form.end_date_start_practices){
                form.end_date_start_practices=moment(form.end_date_start_practices).format("YYYY-MM-DD");
            }
            if(form.end_date_practices){
                form.end_date_practices=moment(form.end_date_practices).format("YYYY-MM-DD");
            }
            return demandsSchedulesService.saveDemandsSchedule(form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Periodo guardado correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar el periodo. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .controller('DemandDialogController', DemandDialogController);

    /** @ngInject */
    function DemandDialogController($mdDialog, demandsService, degreesService, subjectsService,
                                    NotifyService, $state, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Nueva oferta de prácticas');
        vm.demand = demandsService.getEmptyDemand();

        // Methods
        vm.saveDemand = saveDemand;
        vm.closeDialog = closeDialog;
        vm.getDegrees = getDegrees;
        vm.getFullNameDegree = degreesService.getFullNameDegree;
        vm.getFullNameSubject = degreesService.getFullNameSubject;
        vm.getSubjects = getSubjects;

        //////////
        /**
         * Guardar demando
         */
        function saveDemand(program) {
            vm.demand.program=program;
            return demandsService.saveDemand(angular.copy(vm.demand)).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Oferta guardada correctamente"));
                $state.go("app.demands.get.detail",{demand:response.id});
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la oferta. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

        /**
         * Obtiene las competencias para rellenar el autocomplete
         */
        function getDegrees(searchText) {
            var deferred = $q.defer();
            degreesService.getAllDegrees(searchText).then(function(degrees){
                deferred.resolve(degrees);
            });
            return deferred.promise;
        }

        /**
         * Obtiene las competencias para rellenar el autocomplete
         */
        function getSubjects(searchText) {
            var deferred = $q.defer();
            subjectsService.subjects.filters.degree=(vm.demand.degree_data) ? vm.demand.degree_data.id:null;
            subjectsService.getAllSubjects(searchText).then(function(subjects){
                deferred.resolve(subjects);
            });
            return deferred.promise;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.conditionsTemplates',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.conditionsTemplates', {
            url      : '/conditionsTemplates',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/conditionsTemplates/conditionsTemplates.html',
                    controller : 'ConditionsTemplatesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                ConditionsTemplates: function (conditionsTemplatesService) {
                    return conditionsTemplatesService.getConditionsTemplates();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.conditionsTemplates')
        .controller('ConditionsTemplateDialogController', ConditionsTemplateDialogController);

    /** @ngInject */
    function ConditionsTemplateDialogController($mdDialog, ConditionsTemplate, conditionsTemplatesService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'bold', 'italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertLink', 'redo', 'undo', 'clear', 'insertTable']
        ];

        vm.title = gettextCatalog.getString('Editar cláusula de convenio');

        if (!ConditionsTemplate) {
            vm.title = gettextCatalog.getString('Nueva cláusula de convenio');
            vm.conditionsTemplate = conditionsTemplatesService.getEmptyConditionsTemplate();
        } else {
            vm.conditionsTemplate = angular.copy(ConditionsTemplate); // Copiamos para no modificar el original hasta guardar
        }

        if (vm.conditionsTemplate.curricular && vm.conditionsTemplate.extracurricular) {
            vm.conditionsTemplate.type = "both";
        } else {
            vm.conditionsTemplate.type = "curricular";
        }

        // Methods
        vm.saveConditionsTemplate = saveConditionsTemplate;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar conditionsTemplateo
         */
        function saveConditionsTemplate() {
            if (vm.conditionsTemplate.type === 'both') {
                vm.conditionsTemplate.curricular = true;
                vm.conditionsTemplate.extracurricular = true;
            } else {
                vm.conditionsTemplate.curricular = true;
                vm.conditionsTemplate.extracurricular = false;
            }
            return conditionsTemplatesService.saveConditionsTemplate(angular.copy(vm.conditionsTemplate)).then(function () {
                NotifyService.successMessage(gettextCatalog.getString("Cláusula guardada correctamente"));
                closeDialog();
            }, function (error) {
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la cláusula. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('contactsService', contactsService);

    /** @ngInject */
    function contactsService($q, api) {

        var service = {
            contacts: {
                data: [],
                count: 0,
                filters: {}
            },
            getContacts: getContacts,
            getAllContacts: getAllContacts,
            getContact: getContact,
            saveContact: saveContact,
            getEmptyContact: getEmptyContact,
            removeContact: removeContact,
            getPrivacyPolicy: getPrivacyPolicy
        };

        return service;

        //////////

        /**
         * Obtiene el listado de contacts
         */
        function getContacts() {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.contacts.filters);
            if(filters.centers_data && filters.centers_data.id){
                filters.centers=filters.centers_data.id;
            }
            delete filters.centers_data;

            api.contacts.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.contacts.data = response.results;
                service.contacts.count = response.count;

                deferred.resolve(service.contacts);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.contacts.filters.page!=1){
                    service.contacts.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de contacts filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllContacts(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.contacts.filters);
            f.search=search;
            f.page="all";
            api.contacts.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una contact determinado por su ID
         *
         * @param id
         */
        function getContact(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.contacts.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la contact que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveContact(form) {
            var deferred = $q.defer();

            if(form.company && form.company.id){
                form.company=form.company.id;
            }
            if (form.id) {
                var user=angular.copy(form.user);
                delete user.permissions;
                var contact=angular.copy(form);
                delete contact.user;

                //Para la edicion hay que hacer 3 peticiones diferentes, si te fijas hago primero la edicion de
                // los "hijos" siendo User -> Contact -> CompanyContact asi al editar el ultimo nos devuelve el
                // objeto con sus hijos ya editados y totalmente actualizado.
                api.users.update(user, updateRolContactOK, updateUserKO);
            } else {
                api.contacts.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.contacts.data.push(response);
                service.contacts.count ++;
                deferred.resolve(response);
            }

            function updateRolContactOK(response) {
                api.contacts.update(contact, updateOK, saveKO);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.contacts.data.length; i++) {
                    if (service.contacts.data[i].id === response.id) {
                        service.contacts.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

            function updateUserKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un contact vacío
         */
        function getEmptyContact() {
            return {
                "name": "",
                "phone": "",
                "email": "",
                "mobile": "",
                "address": "",
                "company": {}
            };
        }
        
        function removeContact(contact){
            var deferred = $q.defer();

            api.contacts.remove({id: contact.id}, contactRemoveOK, removeKO);

            // contact borrado correctamente
            function contactRemoveOK(response){
                // Quitamos la contact en los datos locales
                for (var i = 0; i < service.contacts.data.length; i++) {
                    if (service.contacts.data[i].id === contact.id) {
                        service.contacts.data.splice(i,1);
                        service.contacts.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar contact
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Obtiene la politica de privacidad que debe aceptar el contacto
         */
        function getPrivacyPolicy() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.privacyPolicy.get({}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.text);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('companyListService', companyListService);

    /** @ngInject */
    function companyListService($q, api, gettextCatalog) {

        var service = {
            companyList: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances:[],
                exportFields:{}
            },
            getCompanyList: getCompanyList,
            getAllCompanyList: getAllCompanyList,
            getCompany: getCompany,
            getCompanyValidate: getCompanyValidate,
            saveCompanyDetail: saveCompanyDetail,
            getEmptyCompany: getEmptyCompany,
            removeCompany: removeCompany,
            getStatus: getStatus,
            getCompanyAgreements: getCompanyAgreements
        };

        return service;

        //////////

        /**
         * Obtiene el listado de companyList
         */
        function getCompanyList() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.companies,
                filters:service.companyList.filtersAdvances
            };
            obj = Object.assign({}, obj, service.companyList.filters);
            api.searchsAdvances.search(obj, getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                service.companyList.data = response.results;
                service.companyList.count = response.count;
                deferred.resolve(service.companyList);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.companyList.filters.page!=1){
                    service.companyList.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de companyList filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllCompanyList(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.companyList.get({search:search,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una company determinado por su ID
         *
         * @param id
         */
        function getCompany(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.companyList.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de validacion de una company determinado por su ID
         *
         * @param id
         */
        function getCompanyValidate(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.companyValidate.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                for(var i in response.data){
                    response.data[i]=[response.data[i]];
                }
                deferred.resolve(response.data);
            }
        }

        /**
         * Guarda la company que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param companyDetail
         */
        function saveCompanyDetail(companyDetail) {
            var deferred = $q.defer();

            delete companyDetail.logo;

            api.companyList.update(companyDetail, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un company vacío
         */
        function getEmptyCompany() {
            return {
                "name": "",
                "phone": "",
                "email": "",
                "mobile": "",
                "address": "",
                "company": {}
            };
        }
        
        function removeCompany(company){
            var deferred = $q.defer();

            api.companyList.remove({id: company.id}, companyRemoveOK, removeKO);

            // company borrado correctamente
            function companyRemoveOK(response){
                // Quitamos la company en los datos locales
                for (var i = 0; i < service.companyList.data.length; i++) {
                    if (service.companyList.data[i].id === company.id) {
                        service.companyList.data.splice(i,1);
                        service.companyList.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar company
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Obtiene los estados de una empresa
         */
        function getStatus() {
            return [
                {
                    id:"not-validated",
                    value:gettextCatalog.getString("No validada")
                },
                {
                    id:"validation-candidate",
                    value:gettextCatalog.getString("Candidata a validación")
                },
                {
                    id:"without-agreement",
                    value:gettextCatalog.getString("Validada sin convenio")
                },
                {
                    id:"with-agreement",
                    value:gettextCatalog.getString("Con convenio")
                },
                {
                    id:"without-activity",
                    value:gettextCatalog.getString("Sin actividad")
                }
            ];
        }
        /**
         * Obtiene los estados del convenio
         */
        function getCompanyAgreements() {
            return [
                {
                    id:"draft",
                    value:gettextCatalog.getString("Borrador")
                },
                {
                    id:"filed",
                    value:gettextCatalog.getString("Histórico")
                },
                {
                    id:"partially_signed",
                    value:gettextCatalog.getString("Parcialmente firmado")
                },
                {
                    id:"valid",
                    value:gettextCatalog.getString("Vigente")
                },
            ];
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('companyDetailService', companyDetailService);

    /** @ngInject */
    function companyDetailService($q, api, gettextCatalog) {

        var service = {
            getCompanyDetail: getCompanyDetail,
            saveCompanyDetail: saveCompanyDetail,
            getIdentificationTypes: getIdentificationTypes,
            getOwnerships: getOwnerships,
            getTypesCompany:getTypesCompany,
            getActivitiesCompany:getActivitiesCompany,
            getStatusCompany:getStatusCompany,
            getCompanyAgreements:getCompanyAgreements,
            setCompanyBlock:setCompanyBlock
        };

        return service;

        //////////

        /**
        * Obtiene los datos basicos de la empresa
        */
        function getCompanyDetail() {
            var deferred = $q.defer();
            api.companyDetail.get({}, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                deferred.resolve(response);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Guarda los datos basicos de la empresa que se pasan como parámetro.
         *
         * @param companyDetail
         */
        function saveCompanyDetail(companyDetail) {
            var deferred = $q.defer();

            if(companyDetail.business_place_data && companyDetail.business_place_data.id){
                companyDetail.business_place=companyDetail.business_place_data.id;
            }
            delete companyDetail.business_place_data;

            if(companyDetail.notifications_place_data && companyDetail.notifications_place_data.id){
                companyDetail.notifications_place=companyDetail.notifications_place_data.id;
            }
            delete companyDetail.notifications_place_data;

            delete companyDetail.logo;
            api.companyList.update(companyDetail, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Bloquea empresa que se pasa como parámetro.
         *
         * @param companyDetail
         */
        function setCompanyBlock(companyDetail) {
            var deferred = $q.defer();

            delete companyDetail.logo;
            api.companyBlock.create(companyDetail, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

        function getIdentificationTypes(){
            return [
                {
                    id:"nif",
                    value:gettextCatalog.getString("NIF")
                },
                {
                    id:"nie",
                    value:gettextCatalog.getString("NIE")
                },
                {
                    id:"ext",
                    value:gettextCatalog.getString("EXT")
                }
            ];
        }

        function getOwnerships(){
            return [
                {
                    id:"private",
                    value:gettextCatalog.getString("Privada")
                },
                {
                    id:"public",
                    value:gettextCatalog.getString("Pública")
                }
            ];
        }

        function getTypesCompany(){
            return [
                {
                    id:"plc",
                    value:gettextCatalog.getString("Sociedad anónima")
                },
                {
                    id:"ltd",
                    value:gettextCatalog.getString("Sociedad limitada")
                }
            ];
        }

        function getActivitiesCompany(){
            return [
                {
                    id:"internet",
                    value:gettextCatalog.getString("Internet")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("Otros")
                }
            ];
        }

        function getStatusCompany(){
            return [
                {
                    id:"not-validated",
                    value:gettextCatalog.getString("No validada")
                },
                {
                    id:"validation-candidate",
                    value:gettextCatalog.getString("Candidata a validación")
                },
                {
                    id:"without-agreement",
                    value:gettextCatalog.getString("Validada sin convenio")
                },
                {
                    id:"with-agreement",
                    value:gettextCatalog.getString("Con convenio")
                },
                {
                    id:"without-activity",
                    value:gettextCatalog.getString("Sin actividad")
                },
                {
                    id:"without-activity",
                    value:gettextCatalog.getString("Firmado por la empresa")
                }
            ];
        }

        /**
         * Obtiene los estados del convenio
         */
        function getCompanyAgreements() {
            return [
                {
                    id:"draft",
                    value:gettextCatalog.getString("Borrador")
                },
                {
                    id:"filed",
                    value:gettextCatalog.getString("Histórico")
                },
                {
                    id:"partially_signed",
                    value:gettextCatalog.getString("Parcialmente firmado")
                },
                {
                    id:"valid",
                    value:gettextCatalog.getString("Vigente")
                },
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('centersService', centersService);

    /** @ngInject */
    function centersService($q, api) {

        var service = {
            centers: {
                data: [],
                count: 0,
                filters: {}
            },
            getCenters: getCenters,
            getAllCenters: getAllCenters,
            getCenter: getCenter,
            saveCenter: saveCenter,
            getEmptyCenter: getEmptyCenter,
            removeCenter: removeCenter
        };

        return service;

        //////////

        /**
         * Obtiene el listado de centers
         */
        function getCenters() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.centers.get(service.centers.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.centers.data = response.results;
                service.centers.count = response.count;

                deferred.resolve(service.centers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.centers.filters.page!=1){
                    service.centers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de centers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllCenters(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.centers.filters);
            f.search=search;
            f.page="all";
            api.centers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una center determinado por su ID
         *
         * @param id
         */
        function getCenter(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.centers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la center que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param center
         */
        function saveCenter(center) {
            var deferred = $q.defer();

            var c=angular.copy(center);
            if(c.town_data && c.town_data.id){
                c.town=c.town_data.id;
            }

            c.company=c.company.id;

            delete c.town_data;
            delete c.province_data;

            if (c.id) {
                api.centers.update(c, updateOK, saveKO);
            } else {
                api.centers.create(c, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.centers.data.push(response);
                service.centers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.centers.data.length; i++) {
                    if (service.centers.data[i].id === response.id) {
                        service.centers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un centro vacío
         */
        function getEmptyCenter(CompanyDetail) {
            return {
                "name": "",
                "phone": "",
                "email": "",
                "mobile": "",
                "address": "",
                "company": CompanyDetail
            };
        }
        
        function removeCenter(center){
            var deferred = $q.defer();

            api.centers.remove({id: center.id}, centerRemoveOK, removeKO);

            // Centro borrado correctamente
            function centerRemoveOK(response){
                // Quitamos la center en los datos locales
                for (var i = 0; i < service.centers.data.length; i++) {
                    if (service.centers.data[i].id === center.id) {
                        service.centers.data.splice(i,1);
                        service.centers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar centro
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('agreementsConditionsService', agreementsConditionsService);

    /** @ngInject */
    function agreementsConditionsService($q, api, gettextCatalog) {

        var service = {
            agreementsConditions: {
                data: [],
                count: 0,
                filters: {}
            },
            getAgreementsConditions: getAgreementsConditions,
            getAllAgreementsConditions: getAllAgreementsConditions,
            getAgreementsCondition: getAgreementsCondition,
            saveAgreementsCondition: saveAgreementsCondition,
            orderAgreementsCondition: orderAgreementsCondition,
            changeStatusAgreementsCondition: changeStatusAgreementsCondition,
            getEmptyAgreementsCondition: getEmptyAgreementsCondition,
            removeAgreementsCondition: removeAgreementsCondition
        };

        return service;

        //////////

        /**
         * Obtiene el listado de agreementsConditions
         */
        function getAgreementsConditions(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            api.agreements.get({id: id}, getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                service.agreementsConditions.data = response.conditions;
                service.agreementsConditions.count = response.conditions.lenght;

                deferred.resolve(service.agreementsConditions);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.agreementsConditions.filters.page!=1){
                    service.agreementsConditions.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de agreementsConditions filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllAgreementsConditions(search,filters) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=filters;
            f.search=search;
            api.agreementsConditions.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una agreementsCondition determinada por su ID
         *
         * @param id
         */
        function getAgreementsCondition(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.agreementsConditions.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la agreementsCondition que se pasa como parámetro. Si ya existe actualiza la existente.
         *
         * @param agreementsCondition
         */
        function saveAgreementsCondition(agreementsCondition) {
            var deferred = $q.defer();

            var a=angular.copy(agreementsCondition);

            delete a.status;
            delete a.order;

            if(a.modified_condition){
                a.modified_condition=a.modified_condition.id;
            }

            if (agreementsCondition.id) {
                api.agreementsConditions.update(a, updateOK, saveKO);
            } else {
                api.agreementsConditions.create(a, createOK, saveKO);
            }

            return deferred.promise;

            function createOK(response) {

                service.getAgreementsConditions(response.agreement).then(function(){
                    deferred.resolve(response);
                });
            }

            function updateOK(response) {
                // Actualiza el listado
                service.getAgreementsConditions(response.agreement).then(function(){
                    deferred.resolve(response);
                });
            }

            function saveKO(response) {
                service.getAgreementsConditions(agreementsCondition.agreement).then(function(){
                    deferred.reject(response);
                });
            }

        }

        /**
         * ordena la agreementsCondition que se pasa como parámetro. Si ya existe actualiza la existente.
         *
         * @param agreementsCondition
         */
        function orderAgreementsCondition(agreementsCondition) {
            var deferred = $q.defer();

            var a=angular.copy(agreementsCondition);

            delete a.status;

            if(a.modified_condition){
                a.modified_condition=a.modified_condition.id;
            }

            api.agreementsConditions.update(a, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actualiza el listado
                service.getAgreementsConditions(response.agreement).then(function(){
                    deferred.resolve(response);
                });
            }

            function saveKO(response) {
                service.getAgreementsConditions(agreementsCondition.agreement).then(function(){
                    deferred.reject(response);
                });
            }

        }

        /**
         * Guarda la agreementsCondition que se pasa como parámetro. Si ya existe actualiza la existente.
         *
         * @param agreementsCondition
         */
        function changeStatusAgreementsCondition(agreementsCondition) {
            var deferred = $q.defer();

            var a=angular.copy(agreementsCondition);
            delete a.order;

            api.agreementsConditions.update(a, updateOK, saveKO);

            return deferred.promise;


            function updateOK(response) {
                // Actualiza el listado
                service.getAgreementsConditions(response.agreement).then(function() {
                    deferred.resolve(response);
                });
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una agreementsCondition vacía
         */
        function getEmptyAgreementsCondition(Agreement,AgreementsCondition) {
            return {
                "name": (AgreementsCondition) ? AgreementsCondition.name:"",
                "description": "",
                "agreement": Agreement.id,
                "modified_condition": AgreementsCondition
            };
        }

        function removeAgreementsCondition(agreementsCondition){
            var deferred = $q.defer();

            api.agreementsConditions.remove({id: agreementsCondition.id}, agreementsConditionRemoveOK, removeKO);

            // AgreementsCondition borrada correctamente
            function agreementsConditionRemoveOK(response){
                // Quitamos la agreementsCondition en los datos locales
                for (var i = 0; i < service.agreementsConditions.data.length; i++) {
                    if (service.agreementsConditions.data[i].id === agreementsCondition.id) {
                        service.agreementsConditions.data.splice(i,1);
                        service.agreementsConditions.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar agreementsCondition
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .factory('agreementsService', agreementsService);

    /** @ngInject */
    function agreementsService($q, api, $http, gettextCatalog) {

        var service = {
            agreements: {
                data: [],
                count: 0,
                filters: {}
            },
            agreements_in_progress:[],
            getAgreements: getAgreements,
            getAllAgreements: getAllAgreements,
            getAgreement: getAgreement,
            getAgreementBase64: getAgreementBase64,
            getAgreementDownload: getAgreementDownload,
            saveAgreement: saveAgreement,
            setSigned: setSigned,
            signAgreement: signAgreement,
            editableAgreement: editableAgreement,
            getEmptyAgreement: getEmptyAgreement,
            uploadFile: uploadFile,
            removeAgreement: removeAgreement,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de agreements
         */
        function getAgreements() {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.agreements.filters);

            api.agreements.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.agreements.data = response.results;
                service.agreements.count = response.count;

                deferred.resolve(service.agreements);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.agreements.filters.page!=1){
                    service.agreements.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de agreements filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         * @param filters
         */
        function getAllAgreements(search,filters) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=filters;
            f.search=search;
            api.agreements.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                if(f.status==="draft"){
                    service.agreements_in_progress=response.results;
                    deferred.resolve(service.agreements_in_progress);
                }else{
                    deferred.resolve(response.results);
                }
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una agreement determinada por su ID
         *
         * @param id
         */
        function getAgreement(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.agreements.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos en base64 de un agreement determinada por su ID
         *
         * @param id
         */
        function getAgreementBase64(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.agreements.base64({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.base64);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos en base64 de un agreement determinada por su ID
         *
         * @param id
         */
        function getAgreementDownload(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            $http.get(api.baseUrl + 'agreements/'+id+'/download_pdf/', {responseType:'arraybuffer'}).then(getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la agreement que se pasa como parámetro. Si ya existe actualiza la existente.
         *
         * @param agreement
         */
        function saveAgreement(agreement) {
            var deferred = $q.defer();

            var a=angular.copy(agreement);
            if(a.company){
                a.company=a.company.id || a.company;
            }
            delete a.document;
            delete a.signed;

            if (agreement.id) {
                api.agreements.update(a, updateOK, saveKO);
            } else {
                api.agreements.create(a, createOK, saveKO);
            }

            return deferred.promise;

            function createOK(response) {
                // Lo que se cree estará pendiente de firma
                service.agreements_in_progress.push(response);
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actualiza el listado
                for (var i = 0; i < service.agreements.data.length; i++) {
                    if (service.agreements.data[i].id === response.id) {
                        service.agreements.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Marca como firmado el convenio
         *
         * @param agreement
         */
        function setSigned(agreement) {
            var deferred = $q.defer();

            var a=angular.copy(agreement);
            if(a.company){
                a.company=a.company.id || a.company;
            }
            delete a.document;

            if (agreement.id) {
                api.agreements.update(a, updateOK, saveKO);
            } else {
                api.agreements.create(a, createOK, saveKO);
            }

            return deferred.promise;

            function createOK(response) {
                // Lo que se cree estará pendiente de firma
                service.agreements_in_progress.push(response);
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actualiza el listado
                for (var i = 0; i < service.agreements.data.length; i++) {
                    if (service.agreements.data[i].id === response.id) {
                        service.agreements.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Sube un fichero como documento del convenio
         *
         * @param agreement
         * @param file
         */
        function uploadFile(agreement,file) {
            var deferred = $q.defer();

            var a={
                id:agreement.id,
                document:null
            };

            if(file && file.id){
                a.document=file.id;
            }

            api.agreements.upload(a, updateOK, saveKO);


            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Firma el convenio que se pasa como parámetro.
         *
         * @param agreement
         */
        function signAgreement(agreement) {
            var deferred = $q.defer();

            api.agreements.sign(agreement, updateOK, saveKO);

            return deferred.promise;


            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Marca como editable el convenio que se pasa como parámetro.
         *
         * @param agreement
         */
        function editableAgreement(agreement) {
            var deferred = $q.defer();

            api.agreements.editable(agreement, updateOK, saveKO);

            return deferred.promise;


            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una agreement vacía
         */
        function getEmptyAgreement(CompanyDetail) {
            return {
                "company": CompanyDetail
            };
        }

        function removeAgreement(agreement){
            var deferred = $q.defer();

            api.agreements.remove({id: agreement.id}, agreementRemoveOK, removeKO);

            // Agreement borrada correctamente
            function agreementRemoveOK(response){
                // Quitamos la agreement en los datos locales
                for (var i = 0; i < service.agreements.data.length; i++) {
                    if (service.agreements.data[i].id === agreement.id) {
                        service.agreements.data.splice(i,1);
                        service.agreements.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar agreement
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"curricular",
                    value:gettextCatalog.getString("Curricular")
                },
                {
                    id:"both",
                    value:gettextCatalog.getString("Curricular y extracurricular")
                }
            ];
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        $stateProvider.state('app.auth', {
            abstract: true,
            url: '/auth'
        })

        // State
        .state('app.auth.login', {
            url: '/login/:action',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.auth.login': {
                    templateUrl: 'app/main/auth/views/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        })

        // State
        .state('app.auth.forgot', {
            url      : '/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.forgot': {
                    templateUrl: 'app/main/auth/views/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        })

        // State
        .state('app.auth.reset', {
            url      : '/reset-password/:token',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.reset': {
                    templateUrl: 'app/main/auth/views/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        })

        // State
        .state('app.auth.register', {
            url      : '/register',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth.register': {
                    templateUrl: 'app/main/auth/views/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            resolve  : {
                PrivacyPolicy: function (contactsService) {
                    return contactsService.getPrivacyPolicy();
                }
            },
            bodyClass: 'register'
        });

        msApiProvider.setBaseUrl('api/');

        // Api
        msApiProvider.register('auth.login', ['roles/login/']);
        msApiProvider.register('auth.logout', ['roles/logout/']);
        msApiProvider.register('auth.currentUser', ['roles/current/']);
        msApiProvider.register('auth.reset', ['roles/reset_password/']);
        msApiProvider.register('auth.resetConfirm', ['roles/reset_confirm_password/']);
        msApiProvider.register('auth.register', ['companies/']);
        msApiProvider.register('auth.permissions', ['pydrfpermissions/pydrfpermissions/']);

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController(AuthService, NotifyService, $state, $stateParams)
    {
        var vm = this;
        // Data
        vm.form={
            token:$stateParams.token
        };

        // Methods
        vm.reset = reset;

        //////////
        function reset(){
            return AuthService.password.resetConfirm(vm.form).then(function(user){
                //console.log("OK")
                //se ejecutará el evento por broadcast
                NotifyService.successMessage("Contraseña modificada correctamente");
            }, function(error){
                vm.serverErrors=error.data;
                NotifyService.errorMessage("Ocurrió un error al modificar la contraseña. " + (error.data.msg || ''));
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController(AuthService, NotifyService, provincesService, localitiesService, companyDetailService,
                                PrivacyPolicy, $q, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.form = {
            "contact": {
            },
            "center": {
            }
        };

        vm.identification_types=companyDetailService.getIdentificationTypes();
        vm.ownerships=companyDetailService.getOwnerships();
        vm.privacyPolicy=PrivacyPolicy;

        // Methods
        vm.register = register;
        vm.getProvinces = getProvinces;
        vm.getLocalities = getLocalities;

        //////////

        /*
        * Registro de empresa
        * */
        function register(){
            var form=angular.copy(vm.form);

            if(form.town_data && form.town_data.id){
                form.center.town=form.town_data.id;
            }

            delete form.province_data;
            delete form.town_data;
            return AuthService.register(form).then(function(data){
                // $state.go("app.auth.login");
                NotifyService.successMessage(gettextCatalog.getString("Registro realizado correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al realizar el registro. ") + (error.data.accept_privacy_policy || ""));
            });
        }

        function createFilterFor(query) {
          var lowercaseQuery = getCleanedString(query);
          return function filterFn(location) {
            return (getCleanedString(location.name).includes(lowercaseQuery));
          };
        }

        /* Provincias */
        function getProvinces(searchText) {
            var deferred = $q.defer();

            provincesService.getProvinces(null, searchText).then(function(provinces){
                var results = searchText ? provinces.filter( createFilterFor(searchText) ) : provinces;
                deferred.resolve(results);
            });

            return deferred.promise;
        }

        /* Localidades */
        function getLocalities(searchText) {
            var deferred = $q.defer();

            localitiesService.getLocalities(vm.form.province_data.id, searchText).then(function(localities){
                var results = searchText ? localities.filter( createFilterFor(searchText) ) : localities;
                deferred.resolve(results);
            });

            return deferred.promise;
        }

        function getCleanedString(cadena){
           // Lo queremos devolver limpio en minusculas
           cadena = cadena.toLowerCase();

           // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
           cadena = cadena.replace(/á/gi,"a");
           cadena = cadena.replace(/é/gi,"e");
           cadena = cadena.replace(/í/gi,"i");
           cadena = cadena.replace(/ó/gi,"o");
           cadena = cadena.replace(/ú/gi,"u");
           return cadena;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(AuthService, NotifyService, $stateParams)
    {
        var vm = this;
        // Data

        // Methods
        vm.login = login;
        vm.loginSelected=$stateParams.action || "students";

        //////////
        function login(){
            return AuthService.login(vm.username, vm.password).then(function(user){
                //console.log("OK")
                //se ejecutará el evento por broadcast
            }, function(res){
                NotifyService.errorMessage(res.error);
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(AuthService, NotifyService, $state)
    {
        var vm = this;
        // Data

        // Methods
        vm.reset = reset;

        //////////
        function reset(){
            return AuthService.password.resetRequest(vm.form).then(function(res){
                $state.go("app.auth.login");
                NotifyService.successMessage("Se ha enviado una nueva contraseña a su email");
            }, function(error){
                NotifyService.errorMessage((error.data.non_field_errors[0] || ""));
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.activities',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.activities', {
            url      : '/activities',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/activities/activities.html',
                    controller : 'ActivitiesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Activities: function (activitiesService) {
                    activitiesService.activities.filters={};
                    return activitiesService.getActivities();
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.activities')
        .controller('ActivityDialogController', ActivityDialogController);

    /** @ngInject */
    function ActivityDialogController($mdDialog, Activity, activitiesService, NotifyService, gettextCatalog) {
        var vm = this;

        // Data
        vm.taToolbar = [
            ['h1', 'h2', 'h3', 'bold', 'italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent', 'insertLink', 'redo', 'undo', 'clear','insertTable']
        ];

        vm.title = gettextCatalog.getString('Editar actividad');

        if (!Activity) {
            vm.title = gettextCatalog.getString('Nueva actividad');
            vm.activity = activitiesService.getEmptyActivity();
        } else {
            vm.activity = angular.copy(Activity); // Copiamos para no modificar el original hasta guardar
        }

        // Methods
        vm.saveActivity = saveActivity;
        vm.closeDialog = closeDialog;

        //////////
        /**
         * Guardar activityo
         */
        function saveActivity() {
            return activitiesService.saveActivity(angular.copy(vm.activity)).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Actividad guardada correctamente"));
                closeDialog();
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar la actividad. ") + (error.data.non_field_errors || ""));
            });
        }

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.actionloggings',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.actionloggings', {
            url      : '/actionloggings',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/actionloggings/actionloggings.html',
                    controller : 'ActionloggingsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Actionloggings: function (actionloggingsService) {
                    return actionloggingsService.getActionloggings();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('actionloggings');
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.actionloggings')
        .controller('ActionloggingDialogController', ActionloggingDialogController);

    /** @ngInject */
    function ActionloggingDialogController($mdDialog, Actionlogging, gettextCatalog) {
        var vm = this;

        // Data
        vm.title = gettextCatalog.getString('Detalle de acción');

        vm.actionlogging = Actionlogging;

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Cerrar el cuadro de diálogo sin cambios
         */
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.users')
        .factory('usersService', usersService);

    /** @ngInject */
    function usersService($q, api) {

        var service = {
            users: {
                data: [],
                count: 0,
                filters: {}
            },
            getUsers: getUsers,
            getAllUsers: getAllUsers,
            getAllPagesUsers: getAllPagesUsers,
            getUser: getUser,
            saveUser: saveUser,
            getEmptyUser: getEmptyUser,
            removeUser: removeUser
        };

        return service;

        //////////

        /**
         * Obtiene el listado de usuarios
         */
        function getUsers() {
            var deferred = $q.defer();
            var filters=angular.copy(service.users.filters);

            if(filters.announcement_data && filters.announcement_data.id){
                filters.announcement=filters.announcement_data.id;
                delete filters.announcement_data;
            }

            api.users.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                // Store the users
                service.users.data = response.results;
                service.users.count = response.count;

                // Resolve the promise
                deferred.resolve(service.users);
            }

            function getKO(response){
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.users.filters.page!=1){
                    service.users.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de usuarios sin paginar
         */
        function getAllPagesUsers(filters) {
            var deferred = $q.defer();
            var f=angular.copy(filters);
            f.page="all";
            api.users.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de usuarios a los que se les puede enviar el email (depende del solicitante)
         */
        function getAllUsers(filters) {
            var deferred = $q.defer();
            api.contacts.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de un usuario determinado por su ID
         *
         * @param id
         */
        function getUser(id) {
            var deferred = $q.defer();
            api.users.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                deferred.resolve(response);
            }

            function getKO(response){
                deferred.reject(response);
            }

        }

        /**
         * Guarda el usuario que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param user
         */
        function saveUser(user) {
            var deferred = $q.defer();

            var c = angular.copy(user);

            // A continuacion editamos o creamos el usuario
            if (c.id) {
                api.users.update(c, userUpdateOK, saveKO);
            } else {
                api.usersEdit.update(c, userCreateOK, saveKO);
            }

            return deferred.promise;


            // usuario Creado correctamente
            function userCreateOK(response) {
                // Store the users
                service.users.data.push(response);
                service.users.count ++;
                deferred.resolve(response);
            }

            // usuario Actualizado correctamente
            function userUpdateOK(response) {
                // Actualizamos el administrador en los datos locales
                for (var i = 0; i < service.users.data.length; i++) {
                    if (service.users.data[i].id === response.id) {
                        service.users.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response){
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un usuario vacío
         */
        function getEmptyUser() {
            return {
                email: "",
                first_name: "",
                is_staff: true,
                last_name: "",
                username: ""
            };
        }

        function removeUser(user){
            var deferred = $q.defer();

            api.users.remove({id: user.id}, userRemoveOK, removeKO);

            // Usuario borrado correctamente
            function userRemoveOK(response){
                // quitamos el usuario en los datos locales
                for (var i = 0; i < service.users.data.length; i++) {
                    if (service.users.data[i].id === user.id) {
                        service.users.data.splice(i,1);
                        service.users.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar usuario
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.tutorsextracurriculars',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.tutorsextracurriculars', {
            url      : '/tutors-extracurriculars',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/tutorsextracurriculars/tutorsextracurriculars.html',
                    controller : 'TutorsextracurricularsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Tutorsextracurriculars: function (tutorsextracurricularsService) {
                    tutorsextracurricularsService.tutorsextracurriculars.filters={};
                    return tutorsextracurricularsService.getTutorsextracurriculars();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('tutorsextracurriculars');
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.tutorsextracurriculars')
        .factory('tutorsextracurricularsService', tutorsextracurricularsService);

    /** @ngInject */
    function tutorsextracurricularsService($q, api) {

        var service = {
            tutorsextracurriculars: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getTutorsextracurriculars: getTutorsextracurriculars,
            getAllTutorsextracurriculars: getAllTutorsextracurriculars,
            getTutor: getTutor,
            saveTutor: saveTutor,
            getEmptyTutor: getEmptyTutor,
            removeTutor: removeTutor
        };

        return service;

        //////////

        /**
         * Obtiene el listado de tutorsextracurriculars
         */
        function getTutorsextracurriculars() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.tutorsextracurriculars,
                filters:service.tutorsextracurriculars.filtersAdvances
            };
            obj = Object.assign({}, obj, service.tutorsextracurriculars.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            // api.tutorsextracurriculars.get(service.tutorsextracurriculars.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.tutorsextracurriculars.data = response.results;
                service.tutorsextracurriculars.count = response.count;
                // service.tutorsextracurriculars.filtersAdvances = [];
                deferred.resolve(service.tutorsextracurriculars);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.tutorsextracurriculars.filters.page!=1){
                    service.tutorsextracurriculars.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de tutorsextracurriculars filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllTutorsextracurriculars(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.tutorsextracurriculars.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una tutor determinado por su ID
         *
         * @param id
         */
        function getTutor(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.tutorsextracurriculars.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la tutor que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTutor(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.tutorsextracurriculars.update(form, updateOK, saveKO);
            } else {
                api.tutorsextracurriculars.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.tutorsextracurriculars.data.push(response);
                service.tutorsextracurriculars.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getTutorsextracurriculars();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un tutor vacío
         */
        function getEmptyTutor() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeTutor(tutor){
            var deferred = $q.defer();

            api.tutorsextracurriculars.remove({id: tutor.id}, tutorRemoveOK, removeKO);

            // tutor borrado correctamente
            function tutorRemoveOK(response){
                // Quitamos la tutor en los datos locales
                for (var i = 0; i < service.tutorsextracurriculars.data.length; i++) {
                    if (service.tutorsextracurriculars.data[i].id === tutor.id) {
                        service.tutorsextracurriculars.data.splice(i,1);
                        service.tutorsextracurriculars.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar tutor
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.tutorscurriculars',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.tutorscurriculars', {
            url      : '/tutors-curriculars',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/tutorscurriculars/tutorscurriculars.html',
                    controller : 'TutorscurricularsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Tutorscurriculars: function (tutorscurricularsService) {
                    tutorscurricularsService.tutorscurriculars.filters={};
                    return tutorscurricularsService.getTutorscurriculars();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('tutorscurriculars');
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.tutorscurriculars')
        .factory('tutorscurricularsService', tutorscurricularsService);

    /** @ngInject */
    function tutorscurricularsService($q, api) {

        var service = {
            tutorscurriculars: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getTutorscurriculars: getTutorscurriculars,
            getAllTutorscurriculars: getAllTutorscurriculars,
            getTutor: getTutor,
            saveTutor: saveTutor,
            getEmptyTutor: getEmptyTutor,
            removeTutor: removeTutor
        };

        return service;

        //////////

        /**
         * Obtiene el listado de tutorscurriculars
         */
        function getTutorscurriculars() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.tutorscurriculars,
                filters:service.tutorscurriculars.filtersAdvances
            };
            obj = Object.assign({}, obj, service.tutorscurriculars.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            // api.tutorscurriculars.get(service.tutorscurriculars.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.tutorscurriculars.data = response.results;
                service.tutorscurriculars.count = response.count;
                // service.tutorscurriculars.filtersAdvances = [];
                deferred.resolve(service.tutorscurriculars);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.tutorscurriculars.filters.page!=1){
                    service.tutorscurriculars.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de tutorscurriculars filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllTutorscurriculars(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.tutorscurriculars.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una tutor determinado por su ID
         *
         * @param id
         */
        function getTutor(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.tutorscurriculars.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la tutor que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTutor(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.tutorscurriculars.update(form, updateOK, saveKO);
            } else {
                api.tutorscurriculars.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.tutorscurriculars.data.push(response);
                service.tutorscurriculars.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getTutorscurriculars();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un tutor vacío
         */
        function getEmptyTutor() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeTutor(tutor){
            var deferred = $q.defer();

            api.tutorscurriculars.remove({id: tutor.id}, tutorRemoveOK, removeKO);

            // tutor borrado correctamente
            function tutorRemoveOK(response){
                // Quitamos la tutor en los datos locales
                for (var i = 0; i < service.tutorscurriculars.data.length; i++) {
                    if (service.tutorscurriculars.data[i].id === tutor.id) {
                        service.tutorscurriculars.data.splice(i,1);
                        service.tutorscurriculars.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar tutor
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.tutors',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.tutors', {
            url      : '/tutors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/tutors/tutors.html',
                    controller : 'TutorsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Tutors: function (tutorsService) {
                    tutorsService.tutors.filters={};
                    tutorsService.tutors.filters.tutors=1;
                    return tutorsService.getTutors();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('tutors');
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.tutors')
        .factory('tutorsService', tutorsService);

    /** @ngInject */
    function tutorsService($q, api) {

        var service = {
            tutors: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getTutors: getTutors,
            getAllTutors: getAllTutors,
            getTutor: getTutor,
            saveTutor: saveTutor,
            getEmptyTutor: getEmptyTutor,
            removeTutor: removeTutor
        };

        return service;

        //////////

        /**
         * Obtiene el listado de tutors
         */
        function getTutors() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.tutors,
                filters:service.tutors.filtersAdvances
            };
            obj = Object.assign({}, obj, service.tutors.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            // api.tutors.get(service.tutors.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.tutors.data = response.results;
                service.tutors.count = response.count;
                // service.tutors.filtersAdvances = [];
                deferred.resolve(service.tutors);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.tutors.filters.page!=1){
                    service.tutors.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de tutors filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllTutors(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.tutors.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una tutor determinado por su ID
         *
         * @param id
         */
        function getTutor(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.tutors.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la tutor que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTutor(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.tutors.update(form, updateOK, saveKO);
            } else {
                api.tutors.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.tutors.data.push(response);
                service.tutors.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getTutors();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un tutor vacío
         */
        function getEmptyTutor() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeTutor(tutor){
            var deferred = $q.defer();

            api.tutors.remove({id: tutor.id}, tutorRemoveOK, removeKO);

            // tutor borrado correctamente
            function tutorRemoveOK(response){
                // Quitamos la tutor en los datos locales
                for (var i = 0; i < service.tutors.data.length; i++) {
                    if (service.tutors.data[i].id === tutor.id) {
                        service.tutors.data.splice(i,1);
                        service.tutors.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar tutor
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .factory('teachersDegreesService', teachersDegreesService);

    /** @ngInject */
    function teachersDegreesService($q, api, gettextCatalog) {

        var service = {
            teachersDegrees: {
                data: [],
                count: 0,
                filters: {}
            },
            saveTeachersDegree: saveTeachersDegree,
            getEmptyTeachersDegree: getEmptyTeachersDegree,
            removeTeachersDegree: removeTeachersDegree
        };

        return service;

        //////////

        /**
         * Guarda la teachersDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTeachersDegree(form) {
            var deferred = $q.defer();

            if(form.degree_data && form.degree_data.id){
                form.degree=form.degree_data.id;
            }
            delete form.degree_data;

            if(form.tutor_data && form.tutor_data.id){
                form.tutor=form.tutor_data.id;
            }
            delete form.tutor_data;

            if (form.id) {
                api.teachersDegrees.update(form, updateOK, saveKO);
            } else {
                api.teachersDegrees.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.teachersDegrees.data.push(response);
                service.teachersDegrees.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.teachersDegrees.data.length; i++) {
                    if (service.teachersDegrees.data[i].id === response.id) {
                        service.teachersDegrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un teacherDegree vacío
         */
        function getEmptyTeachersDegree(teacher) {
            return {
                tutor:teacher
            };
        }

        function removeTeachersDegree(teachersDegree){
            var deferred = $q.defer();

            api.teachersDegrees.remove({id: teachersDegree.id}, teachersDegreeRemoveOK, removeKO);

            // TeacherDegree borrado correctamente
            function teachersDegreeRemoveOK(response){
                // Quitamos la teachersDegree en los datos locales
                for (var i = 0; i < service.teachersDegrees.data.length; i++) {
                    if (service.teachersDegrees.data[i].id === teachersDegree.id) {
                        service.teachersDegrees.data.splice(i,1);
                        service.teachersDegrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar teacherDegree
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .factory('teachersCoordinatorDegreesService', teachersCoordinatorDegreesService);

    /** @ngInject */
    function teachersCoordinatorDegreesService($q, api, gettextCatalog) {

        var service = {
            teachersCoordinatorDegrees: {
                data: [],
                count: 0,
                filters: {}
            },
            saveTeachersCoordinatorDegree: saveTeachersCoordinatorDegree,
            getEmptyTeachersCoordinatorDegree: getEmptyTeachersCoordinatorDegree,
            removeTeachersCoordinatorDegree: removeTeachersCoordinatorDegree
        };

        return service;

        //////////
        /**
         * Guarda la teachersCoordinatorDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTeachersCoordinatorDegree(form) {
            var deferred = $q.defer();

            if(form.degree_data && form.degree_data.id){
                form.degree=form.degree_data.id;
            }
            delete form.degree_data;

            if(form.coordinator_data && form.coordinator_data.id){
                form.coordinator=form.coordinator_data.id;
            }
            delete form.coordinator_data;

            if (form.id) {
                api.teachersCoordinatorDegrees.update(form, updateOK, saveKO);
            } else {
                api.teachersCoordinatorDegrees.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.teachersCoordinatorDegrees.data.push(response);
                service.teachersCoordinatorDegrees.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.teachersCoordinatorDegrees.data.length; i++) {
                    if (service.teachersCoordinatorDegrees.data[i].id === response.id) {
                        service.teachersCoordinatorDegrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un teacherDegree vacío
         */
        function getEmptyTeachersCoordinatorDegree(teacher) {
            return {
                coordinator:teacher
            };
        }

        function removeTeachersCoordinatorDegree(teachersCoordinatorDegree){
            var deferred = $q.defer();

            api.teachersCoordinatorDegrees.remove({id: teachersCoordinatorDegree.id}, teachersCoordinatorDegreeRemoveOK, removeKO);

            // TeacherDegree borrado correctamente
            function teachersCoordinatorDegreeRemoveOK(response){
                // Quitamos la teachersCoordinatorDegree en los datos locales
                for (var i = 0; i < service.teachersCoordinatorDegrees.data.length; i++) {
                    if (service.teachersCoordinatorDegrees.data[i].id === teachersCoordinatorDegree.id) {
                        service.teachersCoordinatorDegrees.data.splice(i,1);
                        service.teachersCoordinatorDegrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar teacherDegree
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.teachers')
        .factory('teachersService', teachersService);

    /** @ngInject */
    function teachersService($q, api, gettextCatalog) {

        var service = {
            teachers: {
                data: [],
                count: 0,
                filters: {}
            },
            getTeachers: getTeachers,
            getTeacherDetail: getTeacherDetail,
            getAllTeachers: getAllTeachers,
            getTeacher: getTeacher,
            saveTeacher: saveTeacher,
            publishTeacher: publishTeacher,
            getEmptyTeacher: getEmptyTeacher,
            removeTeacher: removeTeacher
        };

        return service;

        //////////

        /**
         * Obtiene los datos de una teachers logueado
         *
         */
        function getTeacherDetail() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.teachersDetail.get({}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de teachers
         */
        function getTeachers() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.teachers.get(service.teachers.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.teachers.data = response.results;
                service.teachers.count = response.count;

                deferred.resolve(service.teachers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.teachers.filters.page!=1){
                    service.teachers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de teachers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllTeachers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.teachers.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una teacher determinado por su ID
         *
         * @param id
         */
        function getTeacher(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.teachers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la teacher que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveTeacher(form) {
            var deferred = $q.defer();

            if(form.subject_data && form.subject_data.id){
                form.subject=form.subject_data.id;
            }

            delete form.degree_data;
            delete form.subject_data;

            if (form.id) {
                api.teachers.update(form, updateOK, saveKO);
            } else {
                api.teachers.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.teachers.data.push(response);
                service.teachers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.teachers.data.length; i++) {
                    if (service.teachers.data[i].id === response.id) {
                        service.teachers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Publica una oferta
         *
         * @param form
         */
        function publishTeacher(form) {
            var deferred = $q.defer();

            api.teachers.published(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.teachers.data.length; i++) {
                    if (service.teachers.data[i].id === response.id) {
                        service.teachers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un teacher vacío
         */
        function getEmptyTeacher() {
            return {
            };
        }
        
        function removeTeacher(teacher){
            var deferred = $q.defer();

            api.teachers.remove({id: teacher.id}, teacherRemoveOK, removeKO);

            // teacher borrado correctamente
            function teacherRemoveOK(response){
                // Quitamos la teacher en los datos locales
                for (var i = 0; i < service.teachers.data.length; i++) {
                    if (service.teachers.data[i].id === teacher.id) {
                        service.teachers.data.splice(i,1);
                        service.teachers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar teacher
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.subjects',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.subjects')
        .factory('subjectsService', subjectsService);

    /** @ngInject */
    function subjectsService($q, api) {

        var service = {
            subjects: {
                data: [],
                count: 0,
                filters: {}
            },
            getSubjects: getSubjects,
            getSubjectsTeachers: getSubjectsTeachers,
            getAllSubjects: getAllSubjects,
            getSubject: getSubject,
            saveSubject: saveSubject,
            getEmptySubject: getEmptySubject,
            removeSubject: removeSubject,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de subjects
         */
        function getSubjects() {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.subjects.filters);

            api.subjects.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.subjects.data = response.results;
                service.subjects.count = response.count;

                deferred.resolve(service.subjects);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.subjects.filters.page!=1){
                    service.subjects.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de profesores de una asignatura
         */
        function getSubjectsTeachers(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.subjects.filters);
            filters.id=id;

            api.subjectsTeachers.queryAll(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.subjects.data = response;
                service.subjects.count = response.length;

                deferred.resolve(service.subjects);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.subjects.filters.page!=1){
                    service.subjects.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de subjects filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllSubjects(search) {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.subjects.filters);
            filters.search=search;
            filters.page="all";
            api.subjects.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una subject determinado por su ID
         *
         * @param id
         */
        function getSubject(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.subjects.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

         /**
         * Guarda la subject que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param subject
         */
        function saveSubject(subject) {
            var deferred = $q.defer();

            if(subject.knowledge_area_data && subject.knowledge_area_data.id){
                subject.knowledge_area=subject.knowledge_area_data.id
            }
            if(subject.center_data && subject.center_data.id){
                subject.center=subject.center_data.id
            }

            if (subject.id) {
                api.subjects.update(subject, updateOK, saveKO);
            } else {
                api.subjects.create(subject, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.subjects.data.push(response);
                service.subjects.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.subjects.data.length; i++) {
                    if (service.subjects.data[i].id === response.id) {
                        service.subjects.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una titulación vacía
         */
        function getEmptySubject() {
            return {
                "code": "",
                "type": "",
                "name": "",
                "knowledge_area": "",
                "center": ""
            };
        }


        /**
        * Borra una titulación pasada como parámetro
        *
        * @param subject
        */
        function removeSubject(subject){
            var deferred = $q.defer();

            api.subjects.remove({id: subject.id}, subjectRemoveOK, removeKO);

            // Titulación borrada correctamente
            function subjectRemoveOK(response){
                // Quitamos la titulación en los datos locales
                for (var i = 0; i < service.subjects.data.length; i++) {
                    if (service.subjects.data[i].id === subject.id) {
                        service.subjects.data.splice(i,1);
                        service.subjects.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar titulación
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Obtiene los tipos de titulaciones
         */
        function getTypes() {
            return [
                {
                    id:"DOF",
                    value:"DOF"
                },
                {
                    id:"GRA",
                    value:"GRA"
                },
                {
                    id:"MOF",
                    value:"MOF"
                },
                {
                    id:"PSC",
                    value:"PSC"
                }
            ];
        }


    }

})();

(function ()
{
    'use strict';
    angular
        .module('app.students')
        .controller('StudentsListController', StudentsListController);
    /** @ngInject */
    function StudentsListController($scope, studentsListService, StudentsList, SearchsBasics, DebounceService, $mdDialog,
                                    $document, NotifyService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.studentsList=StudentsList;
        vm.searchsBasics=SearchsBasics;
        
        // Watchers
        $scope.$watch('vm.studentsList.filters', DebounceService(studentsListService.getStudentsList, 300), true);

        // Methods
        vm.search = search;
        vm.openStudentDialog = openStudentDialog;
        vm.removeStudent = removeStudent;

        //////////

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.studentsList.filtersAdvances=form;
            vm.studentsList.filters={};
            vm.studentsList.filters.page=1;
            return studentsListService.getStudentsList();
        }
        
        /**
         * Abre el dialogo para crear/editar una student
         *
         * @param ev
         * @param student
         */
        function openStudentDialog(ev, student) {
            var obj=(student && student.contact_student_data) ? student.contact_student_data:null;
            $mdDialog.show({
                controller: 'StudentDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/dialogs/student/student-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Student:obj,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una student
         *
         * @param ev
         * @param student
         */
        function removeStudent(ev, student) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar estudiante')+' "'+student.contact_student+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el estudiante?'))
                .ariaLabel(gettextCatalog.getString('Eliminar estudiante'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar estudiante'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                studentsListService.removeStudents(student).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Estudiante borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el estudiante. " + (error.data.detail || ""));
                });
            });

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.students')
        .controller('StudentsDetailController', StudentsDetailController);

    /** @ngInject */
    function StudentsDetailController($rootScope, currentUser, StudentsDetail, studentsDetailService, NotifyService, categorySkillsService,
                                     studentsSkillsService, studentsLanguagesService, StudentsDegrees, studentsDegreesService,
                                     StudentsLanguages, $mdSidenav, StudentsSkills, $mdDialog, $document, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.form = StudentsDetail;
        
        vm.studentsLanguages = StudentsLanguages;
        vm.studentsSkills = StudentsSkills;
        vm.studentsDegrees = StudentsDegrees;

        vm.ngFlowOptionsProfessional={
            query:function(file){
                return {name:'CV profesional del usuario '+vm.user.id,type:'profesional_cv'};
            }
        };

        vm.ngFlowOptionsResearcher={
            query:function(file){
                return {name:'CV investigador del usuario '+vm.user.id,type:'researcher_cv'};
            }
        };

        $rootScope.getPhoto(vm.form.id,vm);

        // Methods
        vm.saveStudentsDetail = saveStudentsDetail;
        vm.openStudentsSkillDialog = openStudentsSkillDialog;
        vm.removeStudentsSkill = removeStudentsSkill;
        vm.openStudentsLanguageDialog = openStudentsLanguageDialog;
        vm.openStudentsDegreeDialog = openStudentsDegreeDialog;
        vm.removeStudentsDegree = removeStudentsDegree;
        vm.removeStudentsLanguage = removeStudentsLanguage;
        vm.fileProfessionalSuccess = fileProfessionalSuccess;
        vm.fileResearcherSuccess = fileResearcherSuccess;
        vm.fileError = fileError;
        vm.toggleSidenav = toggleSidenav;

        //////////
        /**
         * Guardar detalle del alumno
         */
        function saveStudentsDetail() {
            return studentsDetailService.saveStudentsDetail(angular.copy(vm.form)).then(function(response){
                vm.form=response;
                StudentsDetail.status=response.status;
                NotifyService.successMessage(gettextCatalog.getString("Datos básicos guardados correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar los datos básicos. ") + (error.data.non_field_errors || ""));
            });
        }
        
        /**
         * Abre el dialogo para crear una competencia
         *
         * @param ev
         * @param studentsSkill
         */
        function openStudentsSkillDialog(ev, studentsSkill) {
            $mdDialog.show({
                controller: 'StudentsSkillDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/dialogs/studentsSkill/studentsSkill-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Student: StudentsDetail,
                    Categories: categorySkillsService.getAllCategorySkills(),
                    event: ev,
                    StudentsSkill: studentsSkill
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una competencia
         *
         * @param ev
         * @param studentsSkill
         */
        function removeStudentsSkill(ev, studentsSkill) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar competencia'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la competencia?'))
                .ariaLabel(gettextCatalog.getString('Eliminar competencia'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar competencia'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                studentsSkillsService.removeStudentsSkill(studentsSkill).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Competencia borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la competencia. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para crear un idioma
         *
         * @param ev
         * @param studentsLanguage
         */
        function openStudentsLanguageDialog(ev, studentsLanguage) {
            $mdDialog.show({
                controller: 'StudentsLanguageDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/dialogs/studentsLanguage/studentsLanguage-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Student: StudentsDetail,
                    event: ev,
                    StudentsLanguage: studentsLanguage
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una idioma
         *
         * @param ev
         * @param studentsLanguage
         */
        function removeStudentsLanguage(ev, studentsLanguage) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar idioma'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el idioma?'))
                .ariaLabel(gettextCatalog.getString('Eliminar idioma'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar idioma'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                studentsLanguagesService.removeStudentsLanguage(studentsLanguage).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Idioma borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el idioma. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo para crear una titulación
         *
         * @param ev
         * @param studentsDegree
         */
        function openStudentsDegreeDialog(ev, studentsDegree) {
            $mdDialog.show({
                controller: 'StudentsDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/students/dialogs/studentsDegree/studentsDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Student: StudentsDetail,
                    event: ev,
                    StudentsDegree: studentsDegree
                }
            });
        }

        /**
         * Abre el dialogo para eliminar una titulacion
         *
         * @param ev
         * @param studentsDegree
         */
        function removeStudentsDegree(ev, studentsDegree) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar titulación'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la titulación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar titulación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar titulación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                studentsDegreesService.removeStudentsDegree(studentsDegree).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Titualación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la titulación. " + (error.data.detail || ""));
                });
            });

        }

        /* Error al subir imagen */
        function fileError($file, $message, $flow) {
            $file.cancel();
            vm.serverErrors=JSON.parse($message);
            var msg="";
            if(vm.serverErrors.professional_cv && vm.serverErrors.professional_cv[0]){
                msg+=vm.serverErrors.professional_cv[0];
            }
            NotifyService.errorMessage(gettextCatalog.getString("Error al subir el archivo. ")+msg);
        }

        /* CV profesional subido con exito */
        function fileProfessionalSuccess($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.form.professional_cv=obj.id;
            }
        }

        /* CV profesional subido con exito */
        function fileResearcherSuccess($message) {
            if($message){
                var obj=JSON.parse($message);
                vm.form.researcher_cv=obj.id;
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.students')
        .controller('MyOffersRequestsController', MyOffersRequestsController);
    /** @ngInject */
    function MyOffersRequestsController($scope, $state, StudentsDetail, currentUser, myOffersRequestsService, MyOffersRequests,
                                        $rootScope, offersRequestsService, DebounceService)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.form = StudentsDetail;
        vm.myOffersRequests=MyOffersRequests;

        // Watchers
        if($state.params.id && $rootScope.hasPermission('offersRequests','LIST')){
            $scope.$watch('vm.myOffersRequests.filters', DebounceService(offersRequestsService.getOffersRequests, 300), true);
        }else{
            $scope.$watch('vm.myOffersRequests.filters', DebounceService(myOffersRequestsService.getMyOffersRequests, 300), true);
        }

        // Methods
        vm.go = go;

        /////////////

        /**
         * Redirecciona al detalle de la oferta dependiendo de los permismos que tenga
         *
         * @param offer
         * @param student
         * @param myOffersRequest
         */
        function go(offer,student, myOffersRequest) {
            if($rootScope.hasPermission('dossiers','GET') &&
                !$rootScope.hasPermission('dossiers','PATCH') &&
                myOffersRequest && myOffersRequest.dossier_data.id){
                $state.go("app.dossiers.get.detail",{dossier:myOffersRequest.dossier_data.id});
            } else if($rootScope.hasPermission('offers','PATCH')){
                $state.go("app.offer",{id:offer.id,student:student.id});
            }else if($rootScope.hasPermission('offers','GET')){
                $state.go("app.offer",{id:offer.id});
            }

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.skills')
        .factory('skillsService', skillsService);

    /** @ngInject */
    function skillsService($q, api, gettextCatalog) {

        var service = {
            skills: {
                data: [],
                count: 0,
                filters: {}
            },
            getSkills: getSkills,
            getAllSkills: getAllSkills,
            getSkill: getSkill,
            saveSkill: saveSkill,
            getEmptySkill: getEmptySkill,
            removeSkill: removeSkill,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de skills
         */
        function getSkills() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.skills.get(service.skills.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.skills.data = response.results;
                service.skills.count = response.count;

                deferred.resolve(service.skills);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.skills.filters.page!=1){
                    service.skills.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de skills filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllSkills(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.skills.filters);
            f.search=search;
            f.page="all";
            api.skills.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una skill determinado por su ID
         *
         * @param id
         */
        function getSkill(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.skills.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la skill que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveSkill(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.skills.update(form, updateOK, saveKO);
            } else {
                api.skills.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.skills.data.push(response);
                service.skills.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.skills.data.length; i++) {
                    if (service.skills.data[i].id === response.id) {
                        service.skills.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un skill vacío
         */
        function getEmptySkill() {
            return {
            };
        }
        
        function removeSkill(skill){
            var deferred = $q.defer();

            api.skills.remove({id: skill.id}, skillRemoveOK, removeKO);

            // skill borrado correctamente
            function skillRemoveOK(response){
                // Quitamos la skill en los datos locales
                for (var i = 0; i < service.skills.data.length; i++) {
                    if (service.skills.data[i].id === skill.id) {
                        service.skills.data.splice(i,1);
                        service.skills.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar skill
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.skills')
        .factory('categorySkillsService', categorySkillsService);

    /** @ngInject */
    function categorySkillsService($q, api, gettextCatalog) {

        var service = {
            categorySkills: {
                data: [],
                count: 0,
                filters: {}
            },
            getCategorySkills: getCategorySkills,
            getAllCategorySkills: getAllCategorySkills,
            getCategorySkill: getCategorySkill,
            saveCategorySkill: saveCategorySkill,
            getEmptyCategorySkill: getEmptyCategorySkill,
            removeCategorySkill: removeCategorySkill,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de categorySkills
         */
        function getCategorySkills() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.categorySkills.get(service.categorySkills.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.categorySkills.data = response.results;
                service.categorySkills.count = response.count;

                deferred.resolve(service.categorySkills);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.categorySkills.filters.page!=1){
                    service.categorySkills.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de categorySkills filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllCategorySkills(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.categorySkills.filters);
            f.search=search;
            f.page="all";
            api.categorySkills.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.categorySkills.data = response.results;
                service.categorySkills.count = response.count;

                deferred.resolve(service.categorySkills.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una categorySkill determinado por su ID
         *
         * @param id
         */
        function getCategorySkill(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.categorySkills.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la categorySkill que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveCategorySkill(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.categorySkills.update(form, updateOK, saveKO);
            } else {
                api.categorySkills.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.categorySkills.data.push(response);
                service.categorySkills.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.categorySkills.data.length; i++) {
                    if (service.categorySkills.data[i].id === response.id) {
                        service.categorySkills.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un categorySkill vacío
         */
        function getEmptyCategorySkill() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeCategorySkill(categorySkill){
            var deferred = $q.defer();

            api.categorySkills.remove({id: categorySkill.id}, categorySkillRemoveOK, removeKO);

            // categorySkill borrado correctamente
            function categorySkillRemoveOK(response){
                // Quitamos la categorySkill en los datos locales
                for (var i = 0; i < service.categorySkills.data.length; i++) {
                    if (service.categorySkills.data[i].id === categorySkill.id) {
                        service.categorySkills.data.splice(i,1);
                        service.categorySkills.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar categorySkill
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.sendsAdvances', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('app.sendsAdvances', {
            url: '/sendsAdvances/:module',
            views: {
                'content@app': {
                    templateUrl: 'app/main/sendsAdvances/sendsAdvances.html',
                    controller: 'SendsAdvancesController as vm'
                }
            },
            resolve: {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Module:function ($stateParams) {
                    return $stateParams.module;
                },
                Receivers: function (sendsAdvancesService, Module) {
                    return sendsAdvancesService.getSendsAdvances(Module);
                }
            },
            bodyClass: 'sendsAdvances'

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.sendsAdvances')
        .factory('sendsAdvancesService', sendsAdvancesService);

    /** @ngInject */
    function sendsAdvancesService($q, api) {

        var service = {
            getSendsAdvances: getSendsAdvances,
            sendMail: sendMail
        };

        return service;

        //////////

        /**
         * Obtiene los campos que son filtrables
         */
        function getSendsAdvances(module) {
            // Create a new deferred object
            var deferred = $q.defer();
            var obj={
                id:api.sendsAdvancesModules[module]
            };
            api.sendsAdvances.get(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el datatable a sendsAdvancesar
         */
        function sendMail(module,form) {
            // Create a new deferred object
            var deferred = $q.defer();
            form.id=api.sendsAdvancesModules[module];
            api.sendsAdvances.send(form, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances')
        .factory('searchsAdvancesService', searchsAdvancesService);

    /** @ngInject */
    function searchsAdvancesService($q, api, gettextCatalog,
                                    companyListService,
                                    offersService,
                                    studentsListService,
                                    dossiersService,
                                    tutorsService,
                                    downloadService,
                                    tutorscurricularsService,
                                    tutorsextracurricularsService,
                                    coordinatorsService,
                                    actionloggingsService,
                                    demandsService) {

        var service = {
            searchsAdvances: {},
            getSearchsAdvances: getSearchsAdvances,
            getAllConfig: getAllConfig,
            getConfig: getConfig
        };

        return service;

        //////////

        /**
         * Obtiene los campos que son filtrables
         */
        function getSearchsAdvances(module) {
            // Create a new deferred object
            var deferred = $q.defer();
            var obj={
                id:api.searchsAdvancesModules[module]
            };
            api.searchsAdvances.get(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.searchsAdvances = response;

                deferred.resolve(service.searchsAdvances);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene las configuraciones de los modulos.
         * `title` y `params` describen el estado de origen (`state`) al que
         * vuelven la exportación y la búsqueda avanzada (breadcrumb y botón Volver).
         */
        function getAllConfig(){
            return {
                companies:{
                    service:companyListService,
                    state:"app.companyList",
                    title:gettextCatalog.getString("Empresas"),
                    param:"companyList"
                },
                offers:{
                    service:offersService,
                    state:"app.offers",
                    title:gettextCatalog.getString("Ofertas extracurriculares"),
                    param:"offers"
                },
                students:{
                    service:studentsListService,
                    state:"app.studentsList",
                    title:gettextCatalog.getString("Alumnos"),
                    param:"studentsList"
                },
                Altas:{
                    service:downloadService,
                    state:"app.download",
                    title:gettextCatalog.getString("Seguridad Social"),
                    params:{categoryDownload: 1},
                    param:"download"
                },
                Cotizaciones:{
                    service:downloadService,
                    state:"app.download",
                    title:gettextCatalog.getString("Seguridad Social"),
                    params:{categoryDownload: 2},
                    param:"download"
                },
                dossiers:{
                    service:dossiersService,
                    state:"app.dossiers.list",
                    title:gettextCatalog.getString("Expedientes"),
                    param:"dossiers"
                },
                tutors:{
                    service:tutorsService,
                    state:"app.tutors",
                    title:gettextCatalog.getString("Tutores académicos"),
                    param:"tutors"
                },
                tutorscurriculars:{
                    service:tutorscurricularsService,
                    state:"app.tutorscurriculars",
                    title:gettextCatalog.getString("Tutores curriculares"),
                    param:"tutorscurriculars"
                },
                tutorsextracurriculars:{
                    service:tutorsextracurricularsService,
                    state:"app.tutorsextracurriculars",
                    title:gettextCatalog.getString("Tutores extracurriculares"),
                    param:"tutorsextracurriculars"
                },
                coordinators:{
                    service:coordinatorsService,
                    state:"app.coordinators",
                    title:gettextCatalog.getString("Coordinadores de asignatura"),
                    param:"coordinators"
                },
                demands:{
                    service:demandsService,
                    state:"app.demands.list",
                    title:gettextCatalog.getString("Ofertas curriculares"),
                    param:"demands"
                },
                actionloggings:{
                    service:actionloggingsService,
                    state:"app.actionloggings",
                    title:gettextCatalog.getString("Acciones del sistema"),
                    param:"actionloggings"
                }
            };
        }

        /**
         * Obtiene la configuración de un modulo
         */
        function getConfig(module) {
            var config=service.getAllConfig();
            return config[module];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances')
        .config(interceptor);

    function interceptor($provide, $httpProvider) {

        // Este interceptor captura todos los fallos de autenticación
        $provide.factory('SearchsAdvancesInterceptor', ['localStorageService', '$q', '$rootScope', function (localStorageService, $q, $rootScope) {
            return {
                request: function(config) {
                    //Para los parámetros que sean booleanos debemos tratarlos de la siguiente forma
                    if(config.url.indexOf('advanced_search')!==-1){
                        var filters=config.data.filters;
                        for(var i in filters){
                            for(var j in filters[i]){
                                if(j.indexOf('boolean')!==-1){
                                    var key=j.replace("__boolean","");
                                    if(filters[i][j]==="true"){
                                        filters[i][key]=true;
                                    }else if(filters[i][j]==="false"){
                                        filters[i][key]=false;
                                    }
                                    delete filters[i][j];
                                }
                            }
                        }
                    }

                    //Tenemos cuidado con los caracteres que pueden dar problemas
                    if(config.url.indexOf('get_filter_fields')!==-1 ||
                        config.url.indexOf('advanced_search')!==-1 ||
                        config.url.indexOf('export')!==-1){
                        config.url=config.url.replace("%2F","/");
                        config.url=config.url.replace("%2F","/");
                    }
                    return config || $q.when(config);
                },

                // Utilizamos el método response error ya que queremos capturar los 400
                responseError: function (rejection) {
                    if(rejection.config.url.indexOf('advanced_search')!==-1 ||
                        rejection.config.url.indexOf('export')!==-1) {
                        if (rejection.status === 400 && rejection.data && rejection.data.filters) {
                            $rootScope.showError(rejection.data.filters);

                        }
                    }

                    // Flujo normal de ejecución
                    return $q.reject(rejection);
                }
            };
        }]);

        // Add the interceptor to the $httpProvider.
        $httpProvider.interceptors.push('SearchsAdvancesInterceptor');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.roles')
        .factory('roleService', roleService);

    /** @ngInject */
    function roleService($q, api, localStorageService) {

        var service = {
            roles: {
                data: [],
                count: 0,
                filters: {}
            },
            list: getRoles,
            get: getRole,
            save: saveRole,
            remove: removeRole
        };

        return service;

        //////////

        /**
         * Obtiene el listado de roles
         */
        function getRoles() {
            var deferred = $q.defer();

            var filters = angular.copy(service.roles.filters);

            api.role.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                // Store the roles
                service.roles.data = response.results;
                service.roles.count = parseInt(response.count, 10);

                // Resolve the promise
                deferred.resolve(service.roles);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de un role determinado por su ID
         *
         * @param id
         */
        function getRole(id) {
            var deferred = $q.defer();
            api.role.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                deferred.resolve(response);
            }

            function getKO(response){
                deferred.reject(response);
            }

        }

        /**
         * Guarda el role que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param role
         */
        function saveRole(role) {
            var deferred = $q.defer();

            var c = angular.copy(role);

            if (!c.permissions_groups_data){
                c.permissions_groups = [];
            } else {
                c.permissions_groups = c.permissions_groups_data.map(function(val){return val.key;});
            }

            if (c.id){
                api.role.update(c, permissionsOK, saveKO);
            } else {
                api.role.create(c, createOK, saveKO);
            }

            return deferred.promise;

            // Cliente Creado correctamente
            function createOK(response) {
                // Store the roles
                service.roles.data.push(response);
                service.roles.count += 1;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actualizamos el cliente en los datos locales
                for (var i = 0; i < service.roles.data.length; i++) {
                    if (service.roles.data[i].id === response.id) {
                        service.roles.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }


            function permissionsOK(response) {
                api.role.permissions(c, updateOK, saveKO);
            }

            function saveKO(response){
                deferred.reject(response);
            }

        }


        function removeRole(role){
            var deferred = $q.defer();

            api.role.remove({id: role.id}, removeOK, removeKO);


            // Usuario borrado correctamente
            function removeOK(response){
                // Quitamos el cliente en los datos locales
                for (var i = 0; i < service.roles.data.length; i++) {
                    if (service.roles.data[i].id === role.id) {
                        service.roles.data.splice(i,1);
                        service.roles.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar clientes o usuarios
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.roles')
        .factory('contentTypeService', contentTypeService);

    /** @ngInject */
    function contentTypeService($q, api) {

        var service = {
            contentTypes: {
                data: [],
                count: 0,
                filters: {}
            },
            list: getContentTypes,
            get: getContentType
        };

        return service;

        //////////

        /**
         * Obtiene el listado de contentTypes
         */
        function getContentTypes() {
            var deferred = $q.defer();

            var filters = angular.copy(service.contentTypes.filters);

            api.contentType.queryAll(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response, headers){
                // Store the contentTypes
                service.contentTypes.data = response;
                service.contentTypes.count = response.length;

                // Resolve the promise
                deferred.resolve(service.contentTypes);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de un contentType determinado por su ID
         *
         * @param id
         */
        function getContentType(id) {
            var deferred = $q.defer();
            api.contentType.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response){
                deferred.resolve(response);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.roles')
        .factory('contactService', contactService);

    /** @ngInject */
    function contactService($q, api, localStorageService) {

        var service = {
            contacts: {
                data: [],
                count: 0,
                filters: {}
            },
            list: getContacts,
            searchContact: searchContact,
            saveContact: saveContact
        };

        return service;

        //////////

        /**
         * Obtiene el listado de contacts
         */
        function getContacts() {
            var deferred = $q.defer();

            var filters = angular.copy(service.contacts.filters);

            api.contact.get(filters, getOK, getKO);

            return deferred.promise;

            function getOK(response, headers){
                // Store the contacts
                service.contacts.data = response.results;
                service.contacts.count = parseInt(response.count, 10);

                // Resolve the promise
                deferred.resolve(service.contacts);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de contacts dada una búsqueda
         */
        function searchContact(query) {
            var deferred = $q.defer();

            api.contact.queryAllObj({search: query}, getOK, getKO);

            return deferred.promise;

            function getOK(response){
                // Resolve the promise
                deferred.resolve(response.results);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Guarda el contact que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param contact
         */
        function saveContact(contact) {
            var deferred = $q.defer();

            var c = angular.copy(contact);

            api.contact.update(c, updateOK, saveKO);

            return deferred.promise;

            // Cliente Actualizado correctamente
            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response){
                deferred.reject(response);
            }

        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.reports')
        .factory('reportsService', reportsService);

    /** @ngInject */
    function reportsService($q, api, gettextCatalog) {

        var service = {
            reports: {
                data: [],
                count: 0,
                filters: {}
            },
            getReports: getReports,
            getAllReports: getAllReports,
            getReport: getReport,
            saveReport: saveReport,
            getEmptyReport: getEmptyReport,
            removeReport: removeReport
        };

        return service;

        //////////

        /**
         * Obtiene el listado de reports
         */
        function getReports() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.reports.get(service.reports.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.reports.data = response.results;
                service.reports.count = response.count;

                deferred.resolve(service.reports);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.reports.filters.page!=1){
                    service.reports.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de reports filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllReports(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.reports.filters);
            f.search=search;
            f.page="all";
            api.reports.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una report determinado por su ID
         *
         * @param id
         */
        function getReport(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.reports.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la report que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveReport(form) {
            var deferred = $q.defer();

            var report = angular.copy(form);

            report.data=JSON.stringify(report.data);

            if (form.id) {
                api.reports.update(report, updateOK, saveKO);
            } else {
                api.reports.create(report, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.reports.data.push(response);
                service.reports.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.reports.data.length; i++) {
                    if (service.reports.data[i].id === response.id) {
                        service.reports.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un informe vacío
         */
        function getEmptyReport(data,module) {
            return {
                "data": data,
                "endpoint": module,
                "name": "",
                "description": ""
            };
        }
        
        function removeReport(report){
            var deferred = $q.defer();

            api.reports.remove({id: report.id}, reportRemoveOK, removeKO);

            // report borrado correctamente
            function reportRemoveOK(response){
                // Quitamos la report en los datos locales
                for (var i = 0; i < service.reports.data.length; i++) {
                    if (service.reports.data[i].id === report.id) {
                        service.reports.data.splice(i,1);
                        service.reports.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar report
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.pyconfrests')
        .factory('pyconfrestsService', pyconfrestsService);

    /** @ngInject */
    function pyconfrestsService($q, api) {

        var service = {
            pyconfrests: {
                data: {},
                count: 0,
                filters: {}
            },
            getPyconfrests: getPyconfrests,
            getAllPyconfrests: getAllPyconfrests,
            getPyconfrest: getPyconfrest,
            savePyconfrest: savePyconfrest,
        };

        return service;

        //////////

        /**
         * Obtiene el listado de pyconfrests
         */
        function getPyconfrests(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            service.pyconfrests.filters.id=id;
            api.pyconfrests.get(service.pyconfrests.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.pyconfrests.data = response.config_schema;
                service.pyconfrests.count = (response.config_schema) ? Object.keys(response.config_schema).length:0;

                deferred.resolve(service.pyconfrests);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.pyconfrests.filters.page!=1){
                    service.pyconfrests.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de pyconfrests filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllPyconfrests(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.pyconfrests.filters);
            f.search=search;
            f.page="all";
            api.pyconfrests.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una pyconfrest determinado por su ID
         *
         * @param id
         */
        function getPyconfrest(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.pyconfrests.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la pyconfrest que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function savePyconfrest(form) {
            var deferred = $q.defer();

            api.pyconfrests.update(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                service.pyconfrests.data = response.config_schema;
                service.pyconfrests.count = Object.keys(response.config_schema).length;
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }




    }

})();

(function () {
    'use strict';

    angular
        .module('app.pyconfrests')
        .factory('pyconfrestCategoriesService', pyconfrestCategoriesService);

    /** @ngInject */
    function pyconfrestCategoriesService($q, api) {

        var service = {
            pyconfrestCategories: {
                data: [],
                count: 0,
                filters: {}
            },
            getPyconfrestCategories: getPyconfrestCategories,
            getAllPyconfrestCategories: getAllPyconfrestCategories,
            getCategory: getCategory,
            saveCategory: saveCategory,
            getEmptyCategory: getEmptyCategory,
            removeCategory: removeCategory
        };

        return service;

        //////////

        /**
         * Obtiene el listado de pyconfrestCategories
         */
        function getPyconfrestCategories() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.pyconfrests.queryAllObj(service.pyconfrestCategories.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.pyconfrestCategories.data = response.results;
                service.pyconfrestCategories.count = response.count;

                deferred.resolve(service.pyconfrestCategories);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.pyconfrestCategories.filters.page!=1){
                    service.pyconfrestCategories.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de pyconfrestCategories filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllPyconfrestCategories(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.pyconfrestCategories.filters);
            f.search=search;
            f.page="all";
            api.pyconfrests.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una category determinado por su ID
         *
         * @param id
         */
        function getCategory(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.pyconfrests.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la category que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveCategory(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.pyconfrests.update(form, updateOK, saveKO);
            } else {
                api.pyconfrests.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.pyconfrestCategories.data.push(response);
                service.pyconfrestCategories.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getPyconfrestCategories();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un category vacío
         */
        function getEmptyCategory() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeCategory(category){
            var deferred = $q.defer();

            api.pyconfrests.remove({id: category.id}, categoryRemoveOK, removeKO);

            // category borrado correctamente
            function categoryRemoveOK(response){
                // Quitamos la category en los datos locales
                for (var i = 0; i < service.pyconfrestCategories.data.length; i++) {
                    if (service.pyconfrestCategories.data[i].id === category.id) {
                        service.pyconfrestCategories.data.splice(i,1);
                        service.pyconfrestCategories.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar category
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.pyconfrests')
        .factory('cloneAcademicYearsService', cloneAcademicYearsService);

    /** @ngInject */
    function cloneAcademicYearsService($q, api) {

        var service = {
            saveCloneAcademicYear: saveCloneAcademicYear
        };

        return service;

        //////////

        /**
         * Guarda la cloneAcademicYear que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveCloneAcademicYear(form) {
            var deferred = $q.defer();

            api.cloneAcademicYears.create(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }




    }

})();

(function () {
    'use strict';

    angular
        .module('app.programs')
        .factory('programsService', programsService);

    /** @ngInject */
    function programsService($q, api, gettextCatalog) {

        var service = {
            programs: {
                data: [],
                count: 0,
                filters: {}
            },
            getPrograms: getPrograms,
            getAllPrograms: getAllPrograms,
            getProgram: getProgram,
            saveProgram: saveProgram,
            loadXls: loadXls,
            getEmptyProgram: getEmptyProgram,
            getEmptyProgramXls: getEmptyProgramXls,
            removeProgram: removeProgram
        };

        return service;

        //////////

        /**
         * Obtiene el listado de programs
         */
        function getPrograms() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.programs.get(service.programs.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.programs.data = response.results;
                service.programs.count = response.count;

                deferred.resolve(service.programs);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.programs.filters.page!=1){
                    service.programs.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de programs filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllPrograms(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.programs.filters);
            f.search=search;
            f.page="all";
            api.programs.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una program determinado por su ID
         *
         * @param id
         */
        function getProgram(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.programs.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la program que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveProgram(form) {
            var deferred = $q.defer();

            var program = angular.copy(form);
            program.start_date= moment(program.start_date).format("YYYY-MM-DD");
            program.end_date= moment(program.end_date).format("YYYY-MM-DD");

            if (form.id) {
                api.programs.update(program, updateOK, saveKO);
            } else {
                api.programs.create(program, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.programs.data.push(response);
                service.programs.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.programs.data.length; i++) {
                    if (service.programs.data[i].id === response.id) {
                        service.programs.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Carga los xls
         *
         * @param form
         */
        function loadXls(form) {
            var deferred = $q.defer();

            // Preparamos la filen para la subida al servidor
            // Comprobamos si existe en file.element y de forma directa ya
            // que parece que en ios no lo encuentra bien con el file.element.
            var file_data = null;
            var $fileUploader = $("#file-uploader");
            var files = $fileUploader.prop('files');

            if (files && files.length) {
                file_data = files[0];
            }

            if (file_data){
                form.file = file_data;
            }else{
                delete form.file;
            }

            api.programs.xls(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un programa vacío
         */
        function getEmptyProgram() {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "name": ""
            };
        }

        /**
         * Devuelve un programaXls vacío
         */
        function getEmptyProgramXls(program,type) {
            return {
                "id": program.id,
                "type": type
            };
        }

        function removeProgram(program){
            var deferred = $q.defer();

            api.programs.remove({id: program.id}, programRemoveOK, removeKO);

            // programaXls borrado correctamente
            function programRemoveOK(response){
                // Quitamos la program en los datos locales
                for (var i = 0; i < service.programs.data.length; i++) {
                    if (service.programs.data[i].id === program.id) {
                        service.programs.data.splice(i,1);
                        service.programs.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar programaXls
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.programs')
        .factory('programManagersService', programManagersService);

    /** @ngInject */
    function programManagersService($q, api) {

        var service = {
            programManagers: {
                data: [],
                count: 0,
                filters: {}
            },
            getProgramManagers: getProgramManagers,
            getAllProgramManagers: getAllProgramManagers,
            getProgramManager: getProgramManager,
            saveProgramManager: saveProgramManager,
            getEmptyProgramManager: getEmptyProgramManager,
            removeProgramManager: removeProgramManager
        };

        return service;

        //////////

        /**
         * Obtiene el listado de programManagers
         */
        function getProgramManagers() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.programManagers.get(service.programManagers.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.programManagers.data = response.results;
                service.programManagers.count = response.count;

                deferred.resolve(service.programManagers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.programManagers.filters.page!=1){
                    service.programManagers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de programManagers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllProgramManagers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.programManagers.filters);
            f.search=search;
            f.page="all";
            api.programManagers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una programManager determinado por su ID
         *
         * @param id
         */
        function getProgramManager(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.programManagers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la programManager que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveProgramManager(form) {
            var deferred = $q.defer();

            var programManager = angular.copy(form);

            if (form.id) {
                api.programManagers.update(programManager, updateOK, saveKO);
            } else {
                api.programManagers.create(programManager, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.programManagers.data.push(response);
                service.programManagers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.programManagers.data.length; i++) {
                    if (service.programManagers.data[i].id === response.id) {
                        service.programManagers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un programManagera vacío
         */
        function getEmptyProgramManager(program) {
            return {
                "program": program
            };
        }

        function removeProgramManager(programManager){
            var deferred = $q.defer();

            api.programManagers.remove({id: programManager.id}, programManagerRemoveOK, removeKO);

            // Centro borrado correctamente
            function programManagerRemoveOK(response){
                // Quitamos la programManager en los datos locales
                for (var i = 0; i < service.programManagers.data.length; i++) {
                    if (service.programManagers.data[i].id === programManager.id) {
                        service.programManagers.data.splice(i,1);
                        service.programManagers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar centro
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offersTemplates')
        .factory('offersTemplatesService', offersTemplatesService);

    /** @ngInject */
    function offersTemplatesService($q, api, gettextCatalog) {

        var service = {
            offersTemplates: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersTemplates: getOffersTemplates,
            getAllOffersTemplates: getAllOffersTemplates,
            getOffersTemplate: getOffersTemplate,
            saveOffersTemplate: saveOffersTemplate,
            getEmptyOffersTemplate: getEmptyOffersTemplate,
            removeOffersTemplate: removeOffersTemplate
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersTemplates
         */
        function getOffersTemplates() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersTemplates.get(service.offersTemplates.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersTemplates.data = response.results;
                service.offersTemplates.count = response.count;

                deferred.resolve(service.offersTemplates);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersTemplates.filters.page!=1){
                    service.offersTemplates.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersTemplates filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersTemplates(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersTemplates.filters);
            f.search=search;
            f.page="all";
            api.offersTemplates.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersTemplate determinado por su ID
         *
         * @param id
         */
        function getOffersTemplate(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersTemplates.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersTemplate que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersTemplate(form) {
            var deferred = $q.defer();

            var offersTemplate = angular.copy(form);

            if (form.id) {
                api.offersTemplates.update(offersTemplate, updateOK, saveKO);
            } else {
                api.offersTemplates.create(offersTemplate, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offersTemplates.data.push(response);
                service.offersTemplates.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersTemplates.data.length; i++) {
                    if (service.offersTemplates.data[i].id === response.id) {
                        service.offersTemplates.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersTemplate vacío
         */
        function getEmptyOffersTemplate(offer) {
            return {
                "offer": offer
            };
        }
        
        function removeOffersTemplate(offersTemplate){
            var deferred = $q.defer();

            offersTemplate.status="discarded";
            api.offersTemplates.update(offersTemplate, offersTemplateRemoveOK, removeKO);

            // offersTemplate borrado correctamente
            function offersTemplateRemoveOK(response){
                // Quitamos la offersTemplate en los datos locales
                for (var i = 0; i < service.offersTemplates.data.length; i++) {
                    if (service.offersTemplates.data[i].id === offersTemplate.id) {
                        service.offersTemplates.data.splice(i,1);
                        service.offersTemplates.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersTemplate
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offersRequests')
        .factory('offersRequestsService', offersRequestsService);

    /** @ngInject */
    function offersRequestsService($q, api, gettextCatalog) {

        var service = {
            offersRequests: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersRequests: getOffersRequests,
            getAllOffersRequests: getAllOffersRequests,
            getOffersRequest: getOffersRequest,
            saveOffersRequest: saveOffersRequest,
            confirmRequest: confirmRequest,
            getEmptyOffersRequest: getEmptyOffersRequest,
            removeOffersRequest: removeOffersRequest
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersRequests
         */
        function getOffersRequests() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersRequests.get(service.offersRequests.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersRequests.data = response.results;
                service.offersRequests.count = response.count;

                deferred.resolve(service.offersRequests);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersRequests.filters.page!=1){
                    service.offersRequests.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersRequests filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersRequests(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersRequests.filters);
            f.search=search;
            f.page="all";
            api.offersRequests.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersRequest determinado por su ID
         *
         * @param id
         */
        function getOffersRequest(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersRequests.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersRequest que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersRequest(form) {
            var deferred = $q.defer();

            var offersRequest = angular.copy(form);

            if (form.id) {
                if(form.curricular){
                    api.offersCurricularRequests.update(offersRequest, updateOK, saveKO);
                }else{
                    api.offersRequests.update(offersRequest, updateOK, saveKO);
                }
            } else {
                api.offersRequests.create(offersRequest, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offersRequests.data.push(response);
                service.offersRequests.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersRequests.data.length; i++) {
                    if (service.offersRequests.data[i].id === response.id) {
                        service.offersRequests.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Confirma la offersRequest que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function confirmRequest(form) {
            var deferred = $q.defer();

            var offersRequest = angular.copy(form);

            api.offersRequests.confirm(offersRequest, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersRequests.data.length; i++) {
                    if (service.offersRequests.data[i].id === response.id) {
                        service.offersRequests.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersRequest vacío
         */
        function getEmptyOffersRequest(offer) {
            return {
                "offer": offer
            };
        }
        
        function removeOffersRequest(offersRequest){
            var deferred = $q.defer();

            offersRequest.status="discarded";
            api.offersRequests.update(offersRequest, offersRequestRemoveOK, removeKO);

            // offersRequest borrado correctamente
            function offersRequestRemoveOK(response){
                // Quitamos la offersRequest en los datos locales
                for (var i = 0; i < service.offersRequests.data.length; i++) {
                    if (service.offersRequests.data[i].id === offersRequest.id) {
                        service.offersRequests.data.splice(i,1);
                        service.offersRequests.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersRequest
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .factory('offersSkillsService', offersSkillsService);

    /** @ngInject */
    function offersSkillsService($q, api, gettextCatalog) {

        var service = {
            offersSkills: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersSkills: getOffersSkills,
            getAllOffersSkills: getAllOffersSkills,
            getOffersSkill: getOffersSkill,
            saveOffersSkill: saveOffersSkill,
            getEmptyOffersSkill: getEmptyOffersSkill,
            removeOffersSkill: removeOffersSkill,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersSkills
         */
        function getOffersSkills() {
            // Create a new deferred object
            var deferred = $q.defer();
            service.offersSkills.filters.page="all";
            api.offersSkills.get(service.offersSkills.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersSkills.data = response.results;
                service.offersSkills.count = response.count;

                deferred.resolve(service.offersSkills);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersSkills.filters.page!=1){
                    service.offersSkills.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersSkills filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersSkills(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersSkills.filters);
            f.search=search;
            f.page="all";
            api.offersSkills.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersSkill determinado por su ID
         *
         * @param id
         */
        function getOffersSkill(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersSkills.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersSkill que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersSkill(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.offersSkills.update(form, updateOK, saveKO);
            } else {
                api.offersSkills.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offersSkills.data.push(response);
                service.offersSkills.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersSkills.data.length; i++) {
                    if (service.offersSkills.data[i].id === response.id) {
                        service.offersSkills.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersSkill vacío
         */
        function getEmptyOffersSkill(offer) {
            return {
                "offer":offer
            };
        }
        
        function removeOffersSkill(offersSkill){
            var deferred = $q.defer();

            api.offersSkills.remove({id: offersSkill.id}, offersSkillRemoveOK, removeKO);

            // offersSkill borrado correctamente
            function offersSkillRemoveOK(response){
                // Quitamos la offersSkill en los datos locales
                for (var i = 0; i < service.offersSkills.data.length; i++) {
                    if (service.offersSkills.data[i].id === offersSkill.id) {
                        service.offersSkills.data.splice(i,1);
                        service.offersSkills.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersSkill
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .factory('offersLanguagesService', offersLanguagesService);

    /** @ngInject */
    function offersLanguagesService($q, api, gettextCatalog) {

        var service = {
            offersLanguages: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersLanguages: getOffersLanguages,
            getAllOffersLanguages: getAllOffersLanguages,
            getOffersLanguage: getOffersLanguage,
            saveOffersLanguage: saveOffersLanguage,
            getEmptyOffersLanguage: getEmptyOffersLanguage,
            removeOffersLanguage: removeOffersLanguage,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersLanguages
         */
        function getOffersLanguages() {
            // Create a new deferred object
            var deferred = $q.defer();
            service.offersLanguages.filters.page="all";
            api.offersLanguages.get(service.offersLanguages.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersLanguages.data = response.results;
                service.offersLanguages.count = response.count;

                deferred.resolve(service.offersLanguages);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersLanguages.filters.page!=1){
                    service.offersLanguages.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersLanguages filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersLanguages(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersLanguages.filters);
            f.search=search;
            f.page="all";
            api.offersLanguages.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersLanguage determinado por su ID
         *
         * @param id
         */
        function getOffersLanguage(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersLanguages.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersLanguage que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersLanguage(form) {
            var deferred = $q.defer();

            form.language=form.language_data.id;
            delete form.language_data;

            if (form.id) {
                api.offersLanguages.update(form, updateOK, saveKO);
            } else {
                api.offersLanguages.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offersLanguages.data.push(response);
                service.offersLanguages.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersLanguages.data.length; i++) {
                    if (service.offersLanguages.data[i].id === response.id) {
                        service.offersLanguages.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersLanguage vacío
         */
        function getEmptyOffersLanguage(offer) {
            return {
                "offer":offer
            };
        }

        function removeOffersLanguage(offersLanguage){
            var deferred = $q.defer();

            api.offersLanguages.remove({id: offersLanguage.id}, offersLanguageRemoveOK, removeKO);

            // offersLanguage borrado correctamente
            function offersLanguageRemoveOK(response){
                // Quitamos la offersLanguage en los datos locales
                for (var i = 0; i < service.offersLanguages.data.length; i++) {
                    if (service.offersLanguages.data[i].id === offersLanguage.id) {
                        service.offersLanguages.data.splice(i,1);
                        service.offersLanguages.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersLanguage
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .factory('offersDegreesService', offersDegreesService);

    /** @ngInject */
    function offersDegreesService($q, api, gettextCatalog) {

        var service = {
            offersDegrees: {
                data: [],
                count: 0,
                filters: {}
            },
            getOffersDegrees: getOffersDegrees,
            getAllOffersDegrees: getAllOffersDegrees,
            getOffersDegree: getOffersDegree,
            saveOffersDegree: saveOffersDegree,
            getEmptyOffersDegree: getEmptyOffersDegree,
            removeOffersDegree: removeOffersDegree,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offersDegrees
         */
        function getOffersDegrees() {
            // Create a new deferred object
            var deferred = $q.defer();
            service.offersDegrees.filters.page="all";
            api.offersDegrees.get(service.offersDegrees.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offersDegrees.data = response.results;
                service.offersDegrees.count = response.count;

                deferred.resolve(service.offersDegrees);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offersDegrees.filters.page!=1){
                    service.offersDegrees.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offersDegrees filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffersDegrees(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offersDegrees.filters);
            f.search=search;
            f.page="all";
            api.offersDegrees.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offersDegree determinado por su ID
         *
         * @param id
         */
        function getOffersDegree(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offersDegrees.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offersDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffersDegree(form) {
            var deferred = $q.defer();

            if(form.degree_data && form.degree_data.id){
                form.degree=form.degree_data.id;
            }
            delete form.degree_data;

            if (form.id) {
                api.offersDegrees.update(form, updateOK, saveKO);
            } else {
                api.offersDegrees.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offersDegrees.data.push(response);
                service.offersDegrees.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offersDegrees.data.length; i++) {
                    if (service.offersDegrees.data[i].id === response.id) {
                        service.offersDegrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un offersDegree vacío
         */
        function getEmptyOffersDegree(offer) {
            return {
                "offer":offer
            };
        }
        
        function removeOffersDegree(offersDegree){
            var deferred = $q.defer();

            api.offersDegrees.remove({id: offersDegree.id}, offersDegreeRemoveOK, removeKO);

            // offersDegree borrado correctamente
            function offersDegreeRemoveOK(response){
                // Quitamos la offersDegree en los datos locales
                for (var i = 0; i < service.offersDegrees.data.length; i++) {
                    if (service.offersDegrees.data[i].id === offersDegree.id) {
                        service.offersDegrees.data.splice(i,1);
                        service.offersDegrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offersDegree
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.offers')
        .factory('offersService', offersService);

    /** @ngInject */
    function offersService($q, api, gettextCatalog) {

        var service = {
            offers: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances:[],
                exportFields:{}
            },
            getOffers: getOffers,
            getAllOffers: getAllOffers,
            getOffer: getOffer,
            saveOffer: saveOffer,
            createFromTemplate: createFromTemplate,
            publishOffer: publishOffer,
            confirmOffer: confirmOffer,
            getEmptyOffer: getEmptyOffer,
            removeOffer: removeOffer,
            getTypes: getTypes,
            getCofinancingCalculate: getCofinancingCalculate,
            getTotalHours: getTotalHours
        };

        return service;

        //////////

        /**
         * Obtiene el listado de offers
         */
        function getOffers() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.offers,
                filters:service.offers.filtersAdvances
            };
            obj = Object.assign({}, obj, service.offers.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.offers.data = response.results;
                service.offers.count = response.count;
                // service.offers.filtersAdvances = [];
                deferred.resolve(service.offers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.offers.filters.page!=1){
                    service.offers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de offers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllOffers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.offers.filters);
            f.search=search;
            f.page="all";
            api.offers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una offer determinado por su ID
         *
         * @param id
         */
        function getOffer(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.offers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la offer que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveOffer(form) {
            var deferred = $q.defer();


            if(form.academic_tutor_data && form.academic_tutor_data.id){
                form.academic_tutor=form.academic_tutor_data.id;
            }
            delete form.academic_tutor_data;

            if(form.management_contact_data && form.management_contact_data.id){
                form.management_contact=form.management_contact_data.id;
            }
            delete form.management_contact_data;

            if(form.professional_tutor_data && form.professional_tutor_data.id){
                form.professional_tutor=form.professional_tutor_data.id;
            }
            delete form.professional_tutor_data;

            if(form.seat_data && form.seat_data.id){
                form.seat=form.seat_data.id;
            }
            delete form.seat_data;


            if (form.id) {
                api.offers.update(form, updateOK, saveKO);
            } else {
                api.offers.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.offers.data.push(response);
                service.offers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offers.data.length; i++) {
                    if (service.offers.data[i].id === response.id) {
                        service.offers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Guarda la offer que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function createFromTemplate(form) {
            var deferred = $q.defer();

            api.offers.createFromTemplate(form, createOK, saveKO);

            return deferred.promise;


            function createOK(response) {

                service.offers.data.push(response);
                service.offers.count ++;
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Solicita una oferta
         *
         * @param form
         */
        function publishOffer(form) {
            var deferred = $q.defer();

            if(form.academic_tutor_data && form.academic_tutor_data.id){
                form.academic_tutor=form.academic_tutor_data.id;
            }
            delete form.academic_tutor_data;

            if(form.management_contact_data && form.management_contact_data.id){
                form.management_contact=form.management_contact_data.id;
            }
            delete form.management_contact_data;

            if(form.professional_tutor_data && form.professional_tutor_data.id){
                form.professional_tutor=form.professional_tutor_data.id;
            }
            delete form.professional_tutor_data;

            if(form.seat_data && form.seat_data.id){
                form.seat=form.seat_data.id;
            }
            delete form.seat_data;

            api.offers.published(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.offers.data.length; i++) {
                    if (service.offers.data[i].id === response.id) {
                        service.offers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

      /**
       * confirmar una oferta
       *
       * @param form
       */
      function confirmOffer(form) {
        var deferred = $q.defer();

        api.offers.confirmed({id:form.id}, updateOK, saveKO);

        return deferred.promise;

        function updateOK(response) {
          // Actauliza el listado
          for (var i = 0; i < service.offers.data.length; i++) {
            if (service.offers.data[i].id === response.id) {
              service.offers.data[i] = angular.copy(response);
            }
          }
          deferred.resolve(response);
        }

        function saveKO(response) {
          deferred.reject(response);
        }

      }

        /**
         * Devuelve un offer vacío
         */
        function getEmptyOffer() {
            return {
            };
        }
        
        function removeOffer(offer){
            var deferred = $q.defer();

            api.offers.remove({id: offer.id}, offerRemoveOK, removeKO);

            // offer borrado correctamente
            function offerRemoveOK(response){
                // Quitamos la offer en los datos locales
                for (var i = 0; i < service.offers.data.length; i++) {
                    if (service.offers.data[i].id === offer.id) {
                        service.offers.data.splice(i,1);
                        service.offers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar offer
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

        /**
         * Cálculo de remuneración que aporta la empresa y remuneración que aporta la cofinanciación
         */
        function getCofinancingCalculate(params) {
            var deferred = $q.defer();
            api.offers.cofinancingCalculate(params, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Cálculo de numero de horas totales de la oferta
         */
        function getTotalHours(params) {
            var deferred = $q.defer();
            api.offers.totalHours(params, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.notifications',
            [
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.notifications', {
                url     : '/notifications',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/notifications/notifications.html',
                        controller : 'NotificationsController as vm'
                    }
                },
                resolve : {
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    },
                    Categories: function (currentUser,categoriesService, $rootScope) {
                        if(currentUser.group_type==='manager' && $rootScope.hasPermission("categories","LIST")){
                            return categoriesService.getCategories();
                        }else{
                            return false;
                        }
                    },
                    Notifications: function (currentUser, notificationsService) {
                        notificationsService.notifications.filters={};
                        return notificationsService.getNotifications();
                    }
                },
                bodyClass: 'notifications'
            })
            .state('app.notifications.detail', {
                url      : '/:threadId',
                bodyClass: 'notifications'
            });



    }
})();
(function () {
    'use strict';

    angular
        .module('app.notifications')
        .factory('notificationsService', notificationsService);

    /** @ngInject */
    function notificationsService($q, api) {

        var service = {
            notifications: {
                data: [],
                count: 0,
                unread_messages: 0,
                filters: {}
            },
            getNotifications: getNotifications,
            getAllNotifications: getAllNotifications,
            getNotification: getNotification,
            getReadPending: getReadPending,
            toggleImportant: toggleImportant
        };

        return service;

        //////////

        /**
         * Obtiene el listado de notifications
         */
        function getNotifications() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.notifications.get(service.notifications.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.notifications.data = response.results;
                service.notifications.count = response.count;
                deferred.resolve(service.notifications);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.notifications.filters.page!=1){
                    service.notifications.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el numero de notifications sin leer
         */
        function getReadPending() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.notifications.readPending(service.notifications.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.notifications.unread_messages=response.unread;
                deferred.resolve(service.notifications);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de notifications filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllNotifications(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.notifications.get({search:search}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una notification determinado por su ID
         *
         * @param id
         */
        function getNotification(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.notifications.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una notification determinado por su ID
         *
         * @param id
         */
        function toggleImportant(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.notifications.toggleImportant({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.managerDegrees')
        .factory('managerDegreesService', managerDegreesService);

    /** @ngInject */
    function managerDegreesService($q, api) {

        var service = {
            managerDegrees: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getManagerDegrees: getManagerDegrees,
            getAllManagerDegrees: getAllManagerDegrees,
            getManagerDegree: getManagerDegree,
            saveManagerDegree: saveManagerDegree,
            getEmptyManagerDegree: getEmptyManagerDegree,
            removeManagerDegree: removeManagerDegree
        };

        return service;

        //////////

        /**
         * Obtiene el listado de managerDegrees
         */
        function getManagerDegrees() {
            // Create a new deferred object
            var deferred = $q.defer();

            api.managerDegrees.get(service.managerDegrees.filters, getOK, getKO);

            return deferred.promise;

            function getOK(response) {
                service.managerDegrees.data = response.results;
                service.managerDegrees.count = response.count;
                // service.managerDegrees.filtersAdvances = [];
                deferred.resolve(service.managerDegrees);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.managerDegrees.filters.page!=1){
                    service.managerDegrees.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de managerDegrees filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllManagerDegrees(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.managerDegrees.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una managerDegree determinado por su ID
         *
         * @param id
         */
        function getManagerDegree(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.managerDegrees.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la managerDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveManagerDegree(form) {
            var deferred = $q.defer();

            if(form.degree_data && form.degree_data.id){
                form.degree=form.degree_data.id;
            }

            delete form.degree_data;

            if (form.id) {
                api.managerDegrees.update(form, updateOK, saveKO);
            } else {
                api.managerDegrees.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.getManagerDegrees();
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getManagerDegrees();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un managerDegree vacío
         */
        function getEmptyManagerDegree() {
            return {
            };
        }
        
        function removeManagerDegree(managerDegree){
            var deferred = $q.defer();

            api.managerDegrees.remove({id: managerDegree.id}, managerDegreeRemoveOK, removeKO);

            // managerDegree borrado correctamente
            function managerDegreeRemoveOK(response){
                // Actualizamos datos locales
                service.getManagerDegrees();
                deferred.resolve(response.data);
            }

            // Fallo al borrar managerDegree
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.languages',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.languages')
        .factory('languagesService', languagesService);

    /** @ngInject */
    function languagesService($q, api) {

        var service = {
            languages: {
                data: [],
                count: 0,
                filters: {}
            },
            getLanguages: getLanguages,
            getAllLanguages: getAllLanguages
        };

        return service;

        //////////

        /**
         * Obtiene el listado de languages
         */
        function getLanguages() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.languages.get(service.languages.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.languages.data = response.results;
                service.languages.count = response.count;

                deferred.resolve(service.languages);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if (response.status == 404 && service.languages.filters.page != 1) {
                    service.languages.filters.page = 1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de languages filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllLanguages(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f = angular.copy(service.languages.filters);
            f.search = search;
            f.page = "all";
            api.languages.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.impersonates',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.impersonates', {
            url      : '/impersonates',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/impersonates/impersonates.html',
                    controller : 'ImpersonatesController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.impersonates')
        .factory('impersonatesService', impersonatesService);

    /** @ngInject */
    function impersonatesService($q, api, gettextCatalog) {

        var service = {
            impersonates: {
                data: [],
                count: 0,
                filters: {}
            },
            getImpersonate: getImpersonate,
            endImpersonate: endImpersonate
        };

        return service;

        //////////

        /**
         * Login simulado
         *
         * @param id
         */
        function getImpersonate(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.impersonates.create({identification: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Fin del login simulado: refresca la sesión del administrador en el servidor
         * y deja traza en las acciones del sistema. Las cabeceras (token simulado +
         * ImpersonateAuthorization) las añade el interceptor.
         */
        function endImpersonate() {
            return api.impersonatesEnd.create({}).$promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.geopostcodes',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {}
})();

(function () {
    'use strict';

    angular
        .module('app.geopostcodes')
        .factory('provincesService', provincesService);

    /** @ngInject */
    function provincesService($q, api) {

        var service = {
            provinces: {
                data: [],
                count: 0,
                filters: {}
            },
            getProvinces: getProvinces
        };

        return service;

        //////////

        /**
         * Obtiene el listado de provinces
         */
        function getProvinces(country,search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.provinces.get({country:country,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.geopostcodes')
        .factory('localitiesService', localitiesService);

    /** @ngInject */
    function localitiesService($q, api) {

        var service = {
            localities: {
                data: [],
                count: 0,
                filters: {}
            },
            getLocalities: getLocalities
        };

        return service;

        //////////

        /**
         * Obtiene el listado de localities
         */
        function getLocalities(province, search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.localities.get({province:province,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.geopostcodes')
        .factory('countriesService', countriesService);

    /** @ngInject */
    function countriesService($q, api) {

        var service = {
            countries: {
                data: [],
                count: 0,
                filters: {}
            },
            getCountries: getCountries
        };

        return service;

        //////////

        /**
         * Obtiene el listado de countries
         */
        function getCountries() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.countries.getPaginate({page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.gadesDegrees')
        .factory('gadesDegreesService', gadesDegreesService);

    /** @ngInject */
    function gadesDegreesService($q, api) {

        var service = {
            gadesDegrees: {
                data: [],
                count: 0,
                filters: {}
            },
            getGadesDegrees: getGadesDegrees,
            getAllGadesDegrees: getAllGadesDegrees,
            getGadesDegree: getGadesDegree,
            saveGadesDegree: saveGadesDegree,
            getEmptyGadesDegree: getEmptyGadesDegree,
            removeGadesDegree: removeGadesDegree
        };

        return service;

        //////////

        /**
         * Obtiene el listado de gadesDegrees
         */
        function getGadesDegrees() {
            // Create a new deferred object
            var deferred = $q.defer();

            api.gadesDegrees.get(service.gadesDegrees.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.gadesDegrees.data = response.results;
                service.gadesDegrees.count = response.count;

                deferred.resolve(service.gadesDegrees);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.gadesDegrees.filters.page!=1){
                    service.gadesDegrees.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de gadesDegrees filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllGadesDegrees(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.gadesDegrees.get({search:search,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una gadesDegree determinado por su ID
         *
         * @param id
         */
        function getGadesDegree(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.gadesDegrees.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

         /**
         * Guarda la gadesDegree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param gadesDegree
         */
        function saveGadesDegree(gadesDegree) {
            var deferred = $q.defer();

            if (gadesDegree.id) {
                api.gadesDegrees.update(gadesDegree, updateOK, saveKO);
            } else {
                api.gadesDegrees.create(gadesDegree, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.gadesDegrees.data.push(response);
                service.gadesDegrees.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.gadesDegrees.data.length; i++) {
                    if (service.gadesDegrees.data[i].id === response.id) {
                        service.gadesDegrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una titulación vacía
         */
        function getEmptyGadesDegree() {
            return {
                "name": ""
            };
        }


        /**
        * Borra una titulación pasada como parámetro
        *
        * @param gadesDegree
        */
        function removeGadesDegree(gadesDegree){
            var deferred = $q.defer();

            api.gadesDegrees.remove({id: gadesDegree.id}, gadesDegreeRemoveOK, removeKO);

            // Titulación borrada correctamente
            function gadesDegreeRemoveOK(response){
                // Quitamos la titulación en los datos locales
                for (var i = 0; i < service.gadesDegrees.data.length; i++) {
                    if (service.gadesDegrees.data[i].id === gadesDegree.id) {
                        service.gadesDegrees.data.splice(i,1);
                        service.gadesDegrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar titulación
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.export', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider.state('app.export', {
            url: '/export/:module',
            views: {
                'content@app': {
                    templateUrl: 'app/main/export/export.html',
                    controller: 'ExportController as vm'
                }
            },
            resolve: {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Module:function ($stateParams) {
                    return $stateParams.module;
                },
                Fields: function (exportService, Module) {
                    return exportService.getExport(Module);
                },
                Breadcrumb: function (searchsAdvancesService, Module, gettextCatalog) {
                    var config = searchsAdvancesService.getConfig(Module) || {};
                    var items = [];
                    if (config.state && config.title) {
                        var params = angular.toJson(config.params || {});
                        items.push("<a ui-sref='" + config.state + "(" + params + ")'>" + config.title + '</a>');
                    }
                    items.push(gettextCatalog.getString('Exportaciones'));
                    return items;
                }
            },
            bodyClass: 'export'

        });

    }

})();
(function () {
    'use strict';

    angular
        .module('app.export')
        .factory('exportService', exportService);

    /** @ngInject */
    function exportService($q, api) {

        var service = {
            getExport: getExport,
            getDatatable: getDatatable
        };

        return service;

        //////////

        /**
         * Obtiene los campos que son filtrables
         */
        function getExport(module) {
            // Create a new deferred object
            var deferred = $q.defer();
            var obj={
                id:api.exportModules[module]
            };
            api.export.get(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                var fields=[];
                for(var i in response.titles){
                    var obj={order:response.titles[i].order,
                            name: response.titles[i].field,
                            filters: response.titles[i].filters,
                            title: response.titles[i].name};
                    fields.push(obj);
                }

                deferred.resolve(fields);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el datatable a exportar
         */
        function getDatatable(module,fields,filters,extraParams) {
            // Create a new deferred object
            var deferred = $q.defer();
            var obj={
                id:api.exportModules[module],
                fields:fields,
                filters:filters
            };
            // Parámetros extra de la consulta (p. ej. periodo/descargadas en Cotizaciones)
            if (extraParams) {
                angular.extend(obj, extraParams);
            }
            api.export.get(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.events',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.events', {
            url      : '/category/:category/events',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/events/events.html',
                    controller : 'EventsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Categories: function (categoriesService) {
                    return categoriesService.getCategories();
                },
                Events: function (Categories, eventsService, $stateParams) {
                    if(Categories.count>0 && !$stateParams.category){
                        $stateParams.category=Categories.data[0].id;
                    }
                    if($stateParams.category){
                        return eventsService.getEvents($stateParams.category);
                    }
                    return eventsService.events;
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.events')
        .factory('eventsService', eventsService);

    /** @ngInject */
    function eventsService($q, api) {

        var service = {
            events: {
                data: [],
                count: 0,
                filters: {}
            },
            getEvents: getEvents,
            getAllEvents: getAllEvents,
            getEvent: getEvent,
            saveEvent: saveEvent,
            getEmptyEvent: getEmptyEvent,
            removeEvent: removeEvent
        };

        return service;

        //////////

        /**
         * Obtiene el listado de events
         */
        function getEvents(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            service.events.filters.id=id;
            api.categories.get(service.events.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.events.data = response.events;
                service.events.count = response.events.length;

                deferred.resolve(service.events);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.events.filters.page!=1){
                    service.events.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de events filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllEvents(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.events.filters);
            f.search=search;
            f.page="all";
            api.events.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una event determinado por su ID
         *
         * @param id
         */
        function getEvent(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.events.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la event que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveEvent(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.events.update(form, updateOK, saveKO);
            } else {
                api.events.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.events.data.push(response);
                service.events.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getEvents();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un event vacío
         */
        function getEmptyEvent() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeEvent(event){
            var deferred = $q.defer();

            api.events.remove({id: event.id}, eventRemoveOK, removeKO);

            // event borrado correctamente
            function eventRemoveOK(response){
                // Quitamos la event en los datos locales
                for (var i = 0; i < service.events.data.length; i++) {
                    if (service.events.data[i].id === event.id) {
                        service.events.data.splice(i,1);
                        service.events.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar event
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.events')
        .factory('categoriesService', categoriesService);

    /** @ngInject */
    function categoriesService($q, api) {

        var service = {
            categories: {
                data: [],
                count: 0,
                filters: {}
            },
            getCategories: getCategories,
            getAllCategories: getAllCategories,
            getCategory: getCategory,
            saveCategory: saveCategory,
            getEmptyCategory: getEmptyCategory,
            removeCategory: removeCategory
        };

        return service;

        //////////

        /**
         * Obtiene el listado de categories
         */
        function getCategories() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.categories.queryAllObj(service.categories.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.categories.data = response.results;
                service.categories.count = response.count;

                deferred.resolve(service.categories);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.categories.filters.page!=1){
                    service.categories.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de categories filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllCategories(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.categories.filters);
            f.search=search;
            f.page="all";
            api.categories.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una category determinado por su ID
         *
         * @param id
         */
        function getCategory(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.categories.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la category que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveCategory(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.categories.update(form, updateOK, saveKO);
            } else {
                api.categories.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.categories.data.push(response);
                service.categories.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getCategories();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un category vacío
         */
        function getEmptyCategory() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeCategory(category){
            var deferred = $q.defer();

            api.categories.remove({id: category.id}, categoryRemoveOK, removeKO);

            // category borrado correctamente
            function categoryRemoveOK(response){
                // Quitamos la category en los datos locales
                for (var i = 0; i < service.categories.data.length; i++) {
                    if (service.categories.data[i].id === category.id) {
                        service.categories.data.splice(i,1);
                        service.categories.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar category
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.eventNotifications')
        .factory('eventNotificationsService', eventNotificationsService);

    /** @ngInject */
    function eventNotificationsService($q, api) {

        var service = {
            eventNotifications: {
                data: [],
                count: 0,
                filters: {}
            },
            event:{},
            parameters:[],
            getEventNotifications: getEventNotifications,
            getAllEventNotifications: getAllEventNotifications,
            getEventNotification: getEventNotification,
            saveEventNotification: saveEventNotification,
            getEmptyEventNotification: getEmptyEventNotification,
            removeEventNotification: removeEventNotification
        };

        return service;

        //////////
        function formatEventNotification(response){
            service.event = angular.copy(response);
            service.parameters = response.parameters;
            service.eventNotifications.data = response.notifications;
            service.eventNotifications.count = response.notifications.length;

            delete service.event.notifications;
            delete service.event.parameters;
        }

        /**
         * Obtiene el listado de eventNotifications
         */
        function getEventNotifications(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            service.eventNotifications.filters.id=id;
            api.events.get(service.eventNotifications.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                formatEventNotification(response);
                deferred.resolve(service.eventNotifications);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.eventNotifications.filters.page!=1){
                    service.eventNotifications.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de eventNotifications filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllEventNotifications(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.eventNotifications.filters);
            f.search=search;
            f.page="all";
            api.eventNotifications.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una eventNotification determinado por su ID
         *
         * @param id
         */
        function getEventNotification(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            if(id){
                api.eventNotifications.get({id: id}, getOK, getKO);
            }else{
                deferred.resolve(service.getEmptyEventNotification());
            }
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la eventNotification que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveEventNotification(form) {
            var deferred = $q.defer();

            form.recipients=[];
            //recipients_email
            for(var e in form.recipients_email){
                form.recipients.push({
                    recipient:form.recipients_email[e],
                    type:"email"
                });
            }
            delete form.recipients_email;
            //recipients_group
            for(var g in form.recipients_group){
                form.recipients.push({
                    recipient:form.recipients_group[g],
                    type:"group"
                });
            }
            delete form.recipients_group;
            //recipients_user
            for(var u in form.recipients_user){
                form.recipients.push({
                    recipient:form.recipients_user[u],
                    type:"user"
                });
            }
            delete form.recipients_user;

            //files
            form.files=[];
            for(var f in form.prov_files){
                form.files.push({
                    file:form.prov_files[f]
                });
            }
            delete form.recipients_user;

            if (form.id) {
                api.eventNotifications.update(form, updateOK, saveKO);
            } else {
                api.eventNotifications.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.eventNotifications.data.push(response);
                service.eventNotifications.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.eventNotifications.data.length; i++) {
                    if (service.eventNotifications.data[i].id === response.id) {
                        service.eventNotifications.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una notificacion vacía
         */
        function getEmptyEventNotification(event) {
            return {
                event:event,
                recipients_user:[],
                recipients_group:[],
                recipients_email:[],
                recipients:[],
                prov_files:[],
                description:"",
                message:"",
                subject:"",
                type:"email"
            };
        }
        
        function removeEventNotification(eventNotification){
            var deferred = $q.defer();

            api.eventNotifications.remove({id: eventNotification.id}, eventNotificationRemoveOK, removeKO);

            // eventNotification borrado correctamente
            function eventNotificationRemoveOK(response){
                // Quitamos la eventNotification en los datos locales
                for (var i = 0; i < service.eventNotifications.data.length; i++) {
                    if (service.eventNotifications.data[i].id === eventNotification.id) {
                        service.eventNotifications.data.splice(i,1);
                        service.eventNotifications.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar eventNotification
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.evaluations',
            [
                'app.questions',
                'app.answers'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        $stateProvider
            .state('app.evaluations', {
                abstract: true,
                url: '/evaluations',
                resolve:{
                    currentUser: function (AuthService){
                        return AuthService.getCurrentUser().then(function (response) {
                            if (response) {
                                return response;
                            }
                        });
                    },
                    Questionnaires: function (questionnairesService) {
                        questionnairesService.questionnaires.filters={};
                        return questionnairesService.getQuestionnaires();
                    }
                }
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.evaluations')
        .factory('questionnairesService', questionnairesService);

    /** @ngInject */
    function questionnairesService($q, api, gettextCatalog) {

        var service = {
            questionnaires: {
                data: [],
                count: 0,
                filters: {}
            },
            getQuestionnaires: getQuestionnaires,
            getAllQuestionnaires: getAllQuestionnaires,
            getQuestionnaire: getQuestionnaire,
            saveQuestionnaire: saveQuestionnaire,
            getEmptyQuestionnaire: getEmptyQuestionnaire,
            removeQuestionnaire: removeQuestionnaire
        };

        return service;

        //////////

        /**
         * Obtiene el listado de questionnaires
         */
        function getQuestionnaires() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questionnaires.get(service.questionnaires.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.questionnaires.data = response.results;
                service.questionnaires.count = response.count;

                deferred.resolve(service.questionnaires);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.questionnaires.filters.page!=1){
                    service.questionnaires.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de questionnaires filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllQuestionnaires(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.questionnaires.filters);
            f.search=search;
            f.page="all";
            api.questionnaires.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una questionnaire determinado por su ID
         *
         * @param id
         */
        function getQuestionnaire(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.questionnaires.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la questionnaire que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveQuestionnaire(form) {
            var deferred = $q.defer();

            var questionnaire = angular.copy(form);
            questionnaire.start_date= moment(questionnaire.start_date).format("YYYY-MM-DD");
            questionnaire.end_date= moment(questionnaire.end_date).format("YYYY-MM-DD");

            if (form.id) {
                api.questionnaires.update(questionnaire, updateOK, saveKO);
            } else {
                api.questionnaires.create(questionnaire, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.questionnaires.data.push(response);
                service.questionnaires.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.questionnaires.data.length; i++) {
                    if (service.questionnaires.data[i].id === response.id) {
                        service.questionnaires.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un questionnaire vacío
         */
        function getEmptyQuestionnaire() {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "name": ""
            };
        }
        
        function removeQuestionnaire(questionnaire){
            var deferred = $q.defer();

            api.questionnaires.remove({id: questionnaire.id}, questionnaireRemoveOK, removeKO);

            // questionnaire borrado correctamente
            function questionnaireRemoveOK(response){
                // Quitamos la questionnaire en los datos locales
                for (var i = 0; i < service.questionnaires.data.length; i++) {
                    if (service.questionnaires.data[i].id === questionnaire.id) {
                        service.questionnaires.data.splice(i,1);
                        service.questionnaires.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar questionnaire
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.evaluations')
        .factory('evaluationsPointsService', evaluationsPointsService);

    /** @ngInject */
    function evaluationsPointsService($q, api, gettextCatalog) {

        var service = {
            evaluationsPoints: {
                data: [],
                count: 0,
                filters: {}
            },
            getEvaluationsPoints: getEvaluationsPoints,
            evaluate: evaluate
        };

        return service;

        //////////

        /**
         * Obtiene el listado de evaluationsPoints
         */
        function getEvaluationsPoints() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.evaluationsPoints.get(service.evaluationsPoints.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.evaluationsPoints.data = response.results;
                service.evaluationsPoints.count = response.count;

                deferred.resolve(service.evaluationsPoints);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.evaluationsPoints.filters.page!=1){
                    service.evaluationsPoints.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de evaluationsPoints
         */
        function evaluate(form) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.evaluationsPoints.evaluate(form, evaluateOK, evaluateKO);
            return deferred.promise;

            function evaluateOK(response) {
                deferred.resolve(response);
            }

            function evaluateKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.evaluations')
        .factory('evaluationsService', evaluationsService);

    /** @ngInject */
    function evaluationsService($q, api) {

        var service = {
            evaluations: {
                data: [],
                count: 0,
                filters: {}
            },
            getEvaluations: getEvaluations,
            getAllEvaluations: getAllEvaluations,
            getEvaluation: getEvaluation,
            saveEvaluation: saveEvaluation,
            finalizeEvaluation: finalizeEvaluation,
            getEmptyEvaluation: getEmptyEvaluation,
            removeEvaluation: removeEvaluation
        };

        return service;

        //////////

        /**
         * Obtiene el listado de evaluations
         */
        function getEvaluations() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.evaluations.get(service.evaluations.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.evaluations.data = response.results;
                service.evaluations.count = response.count;

                deferred.resolve(service.evaluations);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.evaluations.filters.page!=1){
                    service.evaluations.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de evaluations filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllEvaluations(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.evaluations.filters);
            f.search=search;
            f.page="all";
            api.evaluations.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una evaluation determinado por su ID
         *
         * @param id
         */
        function getEvaluation(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.evaluations.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la evaluation que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveEvaluation(form) {
            var deferred = $q.defer();

            var evaluation = angular.copy(form);

            if (form.id) {
                api.evaluations.update(evaluation, updateOK, saveKO);
            } else {
                api.evaluations.create(evaluation, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.evaluations.data.push(response);
                service.evaluations.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.evaluations.data.length; i++) {
                    if (service.evaluations.data[i].id === response.id) {
                        service.evaluations.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Guarda la evaluation que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param evaluation
         */
        function finalizeEvaluation(evaluation) {
            var deferred = $q.defer();

            api.evaluations.finalize({id: evaluation.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.evaluations.data.length; i++) {
                    if (service.evaluations.data[i].id === response.id) {
                        service.evaluations.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un evaluation vacío
         */
        function getEmptyEvaluation() {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "name": ""
            };
        }
        
        function removeEvaluation(evaluation){
            var deferred = $q.defer();

            api.evaluations.remove({id: evaluation.id}, evaluationRemoveOK, removeKO);

            // evaluation borrado correctamente
            function evaluationRemoveOK(response){
                // Quitamos la evaluation en los datos locales
                for (var i = 0; i < service.evaluations.data.length; i++) {
                    if (service.evaluations.data[i].id === evaluation.id) {
                        service.evaluations.data.splice(i,1);
                        service.evaluations.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar evaluation
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.download')
        .factory('downloadService', downloadService);

    /** @ngInject */
    function downloadService($q, $http, api, localStorageService) {

        var service = {
            download: {
                filters: {},
                filtersAdvances:[],
                // Parámetros extra (periodo, descargadas) que el exportador
                // propaga a la consulta del listado de Cotizaciones
                extraParams: undefined,
            },
            getDocumentHight: getDocumentHight,
            markQuotesDownloaded: markQuotesDownloaded
        };

        return service;

        //////////

        /**
         * Obtiene el listado de roles
         */
        function getDocumentHight(date) {
            var deferred = $q.defer();

            api.downloadDocumentHight.get(date, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                // Resolve the promise
                var str = '';
                for (var key in response) {
                    if (Object.prototype.hasOwnProperty.call(response, key)) {
                        if (!isNaN(parseInt(key))) {
                            str += response[key];
                        }
                    }
                }
                deferred.resolve(str);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Marca como descargadas en servidor las cotizaciones listadas.
         * Lo invoca el exportador tras generar el Excel del datatable: el
         * Excel de DataTables es la única vía de descarga y este marcado
         * es su acompañante (las ya descargadas conservan su fecha).
         */
        function markQuotesDownloaded(ids) {
            return $http.post(api.URLs.markQuotesDownloaded, {ids: ids});
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .factory('myDossiersService', myDossiersService);

    /** @ngInject */
    function myDossiersService($q, api, gettextCatalog) {

        var service = {
            myDossiers: {
                data: [],
                count: 0,
                filters: {}
            },
            getMyDossiers: getMyDossiers,
            getAllMyDossiers: getAllMyDossiers
        };

        return service;

        //////////

        /**
         * Obtiene el listado de myDossiers
         */
        function getMyDossiers() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.myDossiers.get(service.myDossiers.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.myDossiers.data = response.results;
                service.myDossiers.count = response.count;

                deferred.resolve(service.myDossiers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.myDossiers.filters.page!=1){
                    service.myDossiers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de myDossiers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllMyDossiers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.myDossiers.filters);
            f.search=search;
            f.page="all";
            api.myDossiers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.dossiers')
        .factory('dossiersService', dossiersService);

    /** @ngInject */
    function dossiersService($q, api, gettextCatalog) {

        var service = {
            dossiers: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getDossiers: getDossiers,
            getAllDossiers: getAllDossiers,
            getDossier: getDossier,
            saveDossier: saveDossier,
            sign: sign,
            confirm: confirm,
            confirmProfesionalTutor: confirmProfesionalTutor,
            confirmAcademicTutor: confirmAcademicTutor,
            documents: documents,
            acceptDossier: acceptDossier,
            getEmptyDossier: getEmptyDossier,
            removeDossier: removeDossier,
            reportRequest: reportRequest
        };

        return service;

        //////////

        /**
         * Obtiene el listado de dossiers
         */
        function getDossiers() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.dossiers,
                filters:service.dossiers.filtersAdvances
            };
            obj = Object.assign({}, obj, service.dossiers.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.dossiers.data = response.results;
                service.dossiers.count = response.count;
                deferred.resolve(service.dossiers);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.dossiers.filters.page!=1){
                    service.dossiers.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de dossiers filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDossiers(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.dossiers.filters);
            f.search=search;
            f.page="all";
            api.dossiers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una dossier determinado por su ID
         *
         * @param id
         */
        function getDossier(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.dossiers.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la dossier que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDossier(form) {
            var deferred = $q.defer();

            if(form.academic_tutor_data && form.academic_tutor_data.id){
                form.academic_tutor=form.academic_tutor_data.id;
            }
            delete form.academic_tutor_data;

            if(form.management_contact_data && form.management_contact_data.id){
                form.management_contact=form.management_contact_data.id;
            }
            delete form.management_contact_data;

            if(form.professional_tutor_data && form.professional_tutor_data.id){
                form.professional_tutor=form.professional_tutor_data.id;
            }
            delete form.professional_tutor_data;

            if(form.seat_data && form.seat_data.id){
                form.seat=form.seat_data.id;
            }
            delete form.seat_data;

            var dossier = angular.copy(form);
            if(dossier.start_date){
                dossier.start_date= moment(dossier.start_date).format("YYYY-MM-DD");
            }
            if(dossier.end_date){
                dossier.end_date= moment(dossier.end_date).format("YYYY-MM-DD");
            }

            if (form.id) {
                api.dossiers.update(dossier, updateOK, saveKO);
            } else {
                api.dossiers.create(dossier, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.dossiers.data.push(response);
                service.dossiers.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossiers.data.length; i++) {
                    if (service.dossiers.data[i].id === response.id) {
                        service.dossiers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Firma un dossier
         *
         * @param form
         */
        function sign(form) {
            var deferred = $q.defer();

            api.dossiers.sign({id:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossiers.data.length; i++) {
                    if (service.dossiers.data[i].id === response.id) {
                        service.dossiers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Confirma un dossier
         *
         * @param form
         */
        function confirm(form) {
            var deferred = $q.defer();

            api.dossiers.confirm({id:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.dossiers.data.length; i++) {
                    if (service.dossiers.data[i].id === response.id) {
                        service.dossiers.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Confirma un dossier por tutor profesional
         *
         * @param form
         */
        function confirmProfesionalTutor(form) {
            var deferred = $q.defer();

            api.dossiers.confirmProfesionalTutor({id:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Confirma un dossier por tutor profesional
         *
         * @param form
         */
        function confirmAcademicTutor(form) {
            var deferred = $q.defer();

            api.dossiers.confirmAcademicTutor({id:form.id}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda documentso requeridos de un expediente
         *
         * @param form
         */
        function documents(form) {
            var deferred = $q.defer();

            api.dossiers.documents(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Acepta el dossier que se pasa como parámetro.
         *
         * @param form
         */
        function acceptDossier(form) {
            var deferred = $q.defer();

            api.dossiers.accept(form, createOK, saveKO);

            return deferred.promise;


            function createOK(response) {

                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un expediente vacío
         */
        function getEmptyDossier() {
            return {
            };
        }
        
        function removeDossier(dossier){
            var deferred = $q.defer();

            api.dossiers.remove({id: dossier.id}, dossierRemoveOK, removeKO);

            // dossier borrado correctamente
            function dossierRemoveOK(response){
                // Quitamos la dossier en los datos locales
                for (var i = 0; i < service.dossiers.data.length; i++) {
                    if (service.dossiers.data[i].id === dossier.id) {
                        service.dossiers.data.splice(i,1);
                        service.dossiers.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar dossier
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Solicitar evaluación
         *
         * @param form
         */
        function reportRequest(form) {
            var deferred = $q.defer();

            api.dossiers.reportRequest(form, createOK, saveKO);

            return deferred.promise;


            function createOK(response) {
                deferred.resolve(response.dossier_data);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.documents')
        .factory('documentsService', documentsService);

    /** @ngInject */
    function documentsService($q, api, $http, gettextCatalog) {

        var service = {
            documents: {
                data: [],
                count: 0,
                filters: {}
            },
            getDocuments: getDocuments,
            getAllDocuments: getAllDocuments,
            getDocument: getDocument,
            saveDocument: saveDocument,
            getEmptyDocument: getEmptyDocument,
            removeDocument: removeDocument,
            changePermission: changePermission
        };

        return service;

        //////////

        /**
         * Obtiene el listado de documents
         */
        function getDocuments() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.documents.get(service.documents.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.documents.data = response.results;
                service.documents.count = response.count;

                deferred.resolve(service.documents);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.documents.filters.page!=1){
                    service.documents.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de documents filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDocuments(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.documents.filters);
            f.search=search;
            f.page="all";
            api.documents.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Descarga un documento
         *
         * @param id
         */
        function getDocument(id) {
            var deferred = $q.defer();

            $http.get(api.baseUrl + 'documents/'+id+'/download/', {responseType:'arraybuffer'}).then(getOK, getKO);

            return deferred.promise;

            function getOK(response){
                deferred.resolve(response.data);
            }

            function getKO(response){
                deferred.reject(response);
            }
        }

        /**
         * Guarda la document que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDocument(form) {
            var deferred = $q.defer();

            // Preparamos la filen para la subida al servidor
            // Comprobamos si existe en file.element y de forma directa ya
            // que parece que en ios no lo encuentra bien con el file.element.
            var file_data = null;
            var $fileUploader = $("#file-uploader");
            var files = $fileUploader.prop('files');

            if (files && files.length) {
                file_data = files[0];
            }

            if (file_data){
                form.document = file_data;
            }else{
                delete form.document;
            }
            delete form.dossier;
            delete form.user;

            //Convertimos los datos aun FormData para poder enviar el archivo
            var formData = new FormData();
            angular.forEach(form, function(value, key){
                if(Array.isArray(value) && value.length){
                    angular.forEach(value, function(v, k){
                        formData.append(key, v);
                    });
                }else{
                    formData.append(key, value);
                }
            });

            if (form.id) {
                api.documents.update({id: form.id}, formData, updateOK, saveKO);
            } else {
                api.documents.create(formData, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.documents.data.push(response);
                service.documents.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.documents.data.length; i++) {
                    if (service.documents.data[i].id === response.id) {
                        service.documents.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un document vacío
         */
        function getEmptyDocument(type) {
            return {
                type:type || 'generic'
            };
        }

        function removeDocument(document){
            var deferred = $q.defer();

            api.documents.remove({id: document.id}, documentRemoveOK, removeKO);

            // document borrado correctamente
            function documentRemoveOK(response){
                // Quitamos la document en los datos locales
                for (var i = 0; i < service.documents.data.length; i++) {
                    if (service.documents.data[i].id === document.id) {
                        service.documents.data.splice(i,1);
                        service.documents.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar document
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Guarda la document que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function changePermission(form) {
            var deferred = $q.defer();

            api.documents.changePermission(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.documents.data.length; i++) {
                    if (service.documents.data[i].id === response.id) {
                        service.documents.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();



(function () {
    'use strict';

    angular
        .module('app.demands')
        .factory('myDemandsService', myDemandsService);

    /** @ngInject */
    function myDemandsService($q, api, gettextCatalog) {

        var service = {
            myDemands: {
                data: [],
                count: 0,
                filters: {}
            },
            getMyDemands: getMyDemands,
            getAllMyDemands: getAllMyDemands
        };

        return service;

        //////////

        /**
         * Obtiene el listado de myDemands
         */
        function getMyDemands() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.myDemands.get(service.myDemands.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.myDemands.data = response.results;
                service.myDemands.count = response.count;

                deferred.resolve(service.myDemands);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.myDemands.filters.page!=1){
                    service.myDemands.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de myDemands filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllMyDemands(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.myDemands.filters);
            f.search=search;
            f.page="all";
            api.myDemands.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .factory('demandsSchedulesService', demandsSchedulesService);

    /** @ngInject */
    function demandsSchedulesService($q, api, gettextCatalog) {

        var service = {
            demandsSchedules: {
                data: [],
                count: 0,
                filters: {}
            },
            getDemandsSchedules: getDemandsSchedules,
            getAllDemandsSchedules: getAllDemandsSchedules,
            getDemandsSchedule: getDemandsSchedule,
            saveDemandsSchedule: saveDemandsSchedule,
            publishDemandsSchedule: publishDemandsSchedule,
            getEmptyDemandsSchedule: getEmptyDemandsSchedule,
            removeDemandsSchedule: removeDemandsSchedule,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de demandsSchedules
         */
        function getDemandsSchedules() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsSchedules.get(service.demandsSchedules.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.demandsSchedules.data = response.results;
                service.demandsSchedules.count = response.count;

                deferred.resolve(service.demandsSchedules);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.demandsSchedules.filters.page!=1){
                    service.demandsSchedules.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de demandsSchedules filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDemandsSchedules(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.demandsSchedules.filters);
            f.search=search;
            f.page="all";
            api.demandsSchedules.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una demandsSchedule determinado por su ID
         *
         * @param id
         */
        function getDemandsSchedule(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsSchedules.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la demandsSchedule que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDemandsSchedule(form) {
            var deferred = $q.defer();

            if(form.subject_data && form.subject_data.id){
                form.subject=form.subject_data.id;
            }

            delete form.degree_data;
            delete form.subject_data;

            if (form.id) {
                api.demandsSchedules.update(form, updateOK, saveKO);
            } else {
                api.demandsSchedules.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.demandsSchedules.data.push(response);
                service.demandsSchedules.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demandsSchedules.data.length; i++) {
                    if (service.demandsSchedules.data[i].id === response.id) {
                        service.demandsSchedules.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Publica una oferta
         *
         * @param form
         */
        function publishDemandsSchedule(form) {
            var deferred = $q.defer();

            api.demandsSchedules.published(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demandsSchedules.data.length; i++) {
                    if (service.demandsSchedules.data[i].id === response.id) {
                        service.demandsSchedules.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un periodo vacío
         */
        function getEmptyDemandsSchedule(demand) {
            return {
                demand:demand
            };
        }

        function removeDemandsSchedule(demandsSchedule){
            var deferred = $q.defer();

            api.demandsSchedules.remove({id: demandsSchedule.id}, demandsScheduleRemoveOK, removeKO);

            // Periodo borrado correctamente
            function demandsScheduleRemoveOK(response){
                // Quitamos la demandsSchedule en los datos locales
                for (var i = 0; i < service.demandsSchedules.data.length; i++) {
                    if (service.demandsSchedules.data[i].id === demandsSchedule.id) {
                        service.demandsSchedules.data.splice(i,1);
                        service.demandsSchedules.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar periodo
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"part-time",
                    value:gettextCatalog.getString("Jornada partida")
                },
                {
                    id:"morning",
                    value:gettextCatalog.getString("Jornada de mañana")
                },
                {
                    id:"afternoon",
                    value:gettextCatalog.getString("Jornada de tarde")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .factory('demandsProfilesService', demandsProfilesService);

    /** @ngInject */
    function demandsProfilesService($q, api, gettextCatalog) {

        var service = {
            demandsProfiles: {
                data: [],
                count: 0,
                filters: {}
            },
            getDemandsProfiles: getDemandsProfiles,
            getAllDemandsProfiles: getAllDemandsProfiles,
            getDemandsProfile: getDemandsProfile,
            saveDemandsProfile: saveDemandsProfile,
            publishDemandsProfile: publishDemandsProfile,
            getEmptyDemandsProfile: getEmptyDemandsProfile,
            removeDemandsProfile: removeDemandsProfile,
            getTypes: getTypes
        };

        return service;

        //////////

        /**
         * Obtiene el listado de demandsProfiles
         */
        function getDemandsProfiles() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsProfiles.get(service.demandsProfiles.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.demandsProfiles.data = response.results;
                service.demandsProfiles.count = response.count;

                deferred.resolve(service.demandsProfiles);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.demandsProfiles.filters.page!=1){
                    service.demandsProfiles.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de demandsProfiles filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDemandsProfiles(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.demandsProfiles.filters);
            f.search=search;
            f.page="all";
            api.demandsProfiles.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una demandsProfile determinado por su ID
         *
         * @param id
         */
        function getDemandsProfile(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demandsProfiles.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la demandsProfile que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDemandsProfile(form) {
            var deferred = $q.defer();

            if(form.subject_data && form.subject_data.id){
                form.subject=form.subject_data.id;
            }

            delete form.degree_data;
            delete form.subject_data;

            if (form.id) {
                api.demandsProfiles.update(form, updateOK, saveKO);
            } else {
                api.demandsProfiles.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.demandsProfiles.data.push(response);
                service.demandsProfiles.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demandsProfiles.data.length; i++) {
                    if (service.demandsProfiles.data[i].id === response.id) {
                        service.demandsProfiles.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Publica una oferta
         *
         * @param form
         */
        function publishDemandsProfile(form) {
            var deferred = $q.defer();

            api.demandsProfiles.published(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demandsProfiles.data.length; i++) {
                    if (service.demandsProfiles.data[i].id === response.id) {
                        service.demandsProfiles.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un periodo vacío
         */
        function getEmptyDemandsProfile(demand) {
            return {
                demand:demand
            };
        }

        function removeDemandsProfile(demandsProfile){
            var deferred = $q.defer();

            api.demandsProfiles.remove({id: demandsProfile.id}, demandsProfileRemoveOK, removeKO);

            // Periodo borrado correctamente
            function demandsProfileRemoveOK(response){
                // Quitamos la demandsProfile en los datos locales
                for (var i = 0; i < service.demandsProfiles.data.length; i++) {
                    if (service.demandsProfiles.data[i].id === demandsProfile.id) {
                        service.demandsProfiles.data.splice(i,1);
                        service.demandsProfiles.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar periodo
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"part-time",
                    value:gettextCatalog.getString("Jornada partida")
                },
                {
                    id:"morning",
                    value:gettextCatalog.getString("Jornada de mañana")
                },
                {
                    id:"afternoon",
                    value:gettextCatalog.getString("Jornada de tarde")
                }
            ];
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.demands')
        .factory('demandsService', demandsService);

    /** @ngInject */
    function demandsService($q, api, gettextCatalog) {

        var service = {
            demands: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getDemands: getDemands,
            getAllDemands: getAllDemands,
            getDemand: getDemand,
            saveDemand: saveDemand,
            publishDemand: publishDemand,
            getEmptyDemand: getEmptyDemand,
            removeDemand: removeDemand,
            getTypes: getTypes,
            getDegreeCoordinator: getDegreeCoordinator
        };

        return service;

        //////////

        /**
         * Obtiene el listado de demands
         */
        function getDemands() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.demands,
                filters:service.demands.filtersAdvances
            };
            obj = Object.assign({}, obj, service.demands.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.demands.data = response.results;
                service.demands.count = response.count;
                // service.demands.filtersAdvances = [];
                deferred.resolve(service.demands);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.demands.filters.page!=1){
                    service.demands.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de demands filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllDemands(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.demands.filters);
            f.search=search;
            f.page="all";
            api.demands.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una demand determinado por su ID
         *
         * @param id
         */
        function getDemand(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demands.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la demand que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveDemand(form) {
            var deferred = $q.defer();

            if(form.subject_data && form.subject_data.id){
                form.subject=form.subject_data.id;
            }

            delete form.degree_data;
            delete form.subject_data;

            if (form.id) {
                api.demands.update(form, updateOK, saveKO);
            } else {
                api.demands.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.demands.data.push(response);
                service.demands.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demands.data.length; i++) {
                    if (service.demands.data[i].id === response.id) {
                        service.demands.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }


        /**
         * Publica una oferta
         *
         * @param form
         */
        function publishDemand(form) {
            var deferred = $q.defer();

            api.demands.published(form, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.demands.data.length; i++) {
                    if (service.demands.data[i].id === response.id) {
                        service.demands.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un demand vacío
         */
        function getEmptyDemand() {
            return {
            };
        }
        
        function removeDemand(demand){
            var deferred = $q.defer();

            api.demands.remove({id: demand.id}, demandRemoveOK, removeKO);

            // demand borrado correctamente
            function demandRemoveOK(response){
                // Quitamos la demand en los datos locales
                for (var i = 0; i < service.demands.data.length; i++) {
                    if (service.demands.data[i].id === demand.id) {
                        service.demands.data.splice(i,1);
                        service.demands.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar demand
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        function getTypes(){
            return [
                {
                    id:"language",
                    value:gettextCatalog.getString("idioma")
                },
                {
                    id:"computer",
                    value:gettextCatalog.getString("informática")
                },
                {
                    id:"other",
                    value:gettextCatalog.getString("otro")
                }
            ];
        }

        /**
         * Obtiene los datos de un coordinador determinado por el id de la demanda
         *
         * @param id
         */
        function getDegreeCoordinator(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.demands.degreeCoordinator({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.degrees',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.degrees')
        .factory('degreesService', degreesService);

    /** @ngInject */
    function degreesService($q, api) {

        var service = {
            degrees: {
                data: [],
                count: 0,
                filters: {}
            },
            getDegrees: getDegrees,
            getAllDegrees: getAllDegrees,
            getDegree: getDegree,
            saveDegree: saveDegree,
            getEmptyDegree: getEmptyDegree,
            removeDegree: removeDegree,
            getTypes: getTypes,
            getFullNameDegree: getFullNameDegree,
            getFullNameSubject: getFullNameSubject
        };

        return service;

        //////////

        /**
         * Obtiene el listado de degrees
         */
        function getDegrees() {
            // Create a new deferred object
            var deferred = $q.defer();

            var filters=angular.copy(service.degrees.filters);

            api.degrees.get(filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.degrees.data = response.results;
                service.degrees.count = response.count;

                deferred.resolve(service.degrees);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.degrees.filters.page!=1){
                    service.degrees.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de degrees filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         * @param teacher
         */
        function getAllDegrees(search, teacher) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.degrees.get({search:search,teacher:teacher,page:"all"}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una degree determinado por su ID
         *
         * @param id
         */
        function getDegree(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.degrees.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

         /**
         * Guarda la degree que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param degree
         */
        function saveDegree(degree) {
            var deferred = $q.defer();

            if(degree.knowledge_area_data && degree.knowledge_area_data.id){
                degree.knowledge_area=degree.knowledge_area_data.id
            }
            if(degree.center_data && degree.center_data.id){
                degree.center=degree.center_data.id
            }

            if (degree.id) {
                api.degrees.update(degree, updateOK, saveKO);
            } else {
                api.degrees.create(degree, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.degrees.data.push(response);
                service.degrees.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.degrees.data.length; i++) {
                    if (service.degrees.data[i].id === response.id) {
                        service.degrees.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve una titulación vacía
         */
        function getEmptyDegree() {
            return {
                "code": "",
                "type": "",
                "name": "",
                "knowledge_area": "",
                "center": ""
            };
        }


        /**
        * Borra una titulación pasada como parámetro
        *
        * @param degree
        */
        function removeDegree(degree){
            var deferred = $q.defer();

            api.degrees.remove({id: degree.id}, degreeRemoveOK, removeKO);

            // Titulación borrada correctamente
            function degreeRemoveOK(response){
                // Quitamos la titulación en los datos locales
                for (var i = 0; i < service.degrees.data.length; i++) {
                    if (service.degrees.data[i].id === degree.id) {
                        service.degrees.data.splice(i,1);
                        service.degrees.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar titulación
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

        /**
         * Obtiene los tipos de titulaciones
         */
        function getTypes() {
            return [
                {
                    id:"DOF",
                    value:"DOF"
                },
                {
                    id:"GRA",
                    value:"GRA"
                },
                {
                    id:"MOF",
                    value:"MOF"
                },
                {
                    id:"PSC",
                    value:"PSC"
                }
            ];
        }

        /*
        * Obtiene el nombre completo de una titulación
        * */
        function getFullNameDegree(degree) {
            return degree.id+" - "+degree.name;
        }

        /*
        * Obtiene el nombre completo de una asignatura
        * */
        function getFullNameSubject(subject) {
            return subject.id_subject+" - "+subject.name;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.dashboard',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.dashboard', {
            url      : '/dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.html',
                    controller : 'DashboardController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService)
                {
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .factory('dashboardService', dashboardService);

    /** @ngInject */
    function dashboardService($q, api) {

        var service = {
            dashboard: {
                data: [],
                count: 0,
                filters: {}
            },
            getUsers: getUsers,
            getUser: getUser,
            saveUser: saveUser,
            getEmptyUser: getEmptyUser
        };

        return service;

        //////////

        /**
         * Obtiene el listado de usuarios
         */
        function getUsers() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.users.get(service.users.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                // Store the users
                service.users.data = response.results;
                service.users.count = response.count;

                deferred.resolve(service.users);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de un usuario determinado por su ID
         *
         * @param id
         */
        function getUser(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.users.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda el usuario que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param client
         */
        function saveUser(user) {
            var deferred = $q.defer();

            if (user.id) {
                api.users.update(user, updateOK, saveKO);
            } else {
                api.users.create(user, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.users.data.push(response);
                service.users.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.users.data.length; i++) {
                    if (service.users.data[i].id === response.id) {
                        service.users.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un usuario vacío
         */
        function getEmptyUser() {
            return {
                email: "",
                first_name: "",
                last_name: "",
                password: "",
                password2: "",
                is_staff: false
            };
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.coordinators',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider.state('app.coordinators', {
            url      : '/coordinators',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/coordinators/coordinators.html',
                    controller : 'CoordinatorsController as vm'
                }
            },
            resolve  : {
                currentUser: function (AuthService){
                    return AuthService.getCurrentUser().then(function (response) {
                        if (response) {
                            return response;
                        }
                    });
                },
                Coordinators: function (coordinatorsService) {
                    coordinatorsService.coordinators.filters={};
                    coordinatorsService.coordinators.filters.coordinators=1;
                    return coordinatorsService.getCoordinators();
                },
                SearchsBasics: function (searchsAdvancesService) {
                    return searchsAdvancesService.getSearchsAdvances('coordinators');
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.coordinators')
        .factory('coordinatorsService', coordinatorsService);

    /** @ngInject */
    function coordinatorsService($q, api) {

        var service = {
            coordinators: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances: [],
                exportFields:{}
            },
            getCoordinators: getCoordinators,
            getAllCoordinators: getAllCoordinators,
            getCoordinator: getCoordinator,
            saveCoordinator: saveCoordinator,
            getEmptyCoordinator: getEmptyCoordinator,
            removeCoordinator: removeCoordinator
        };

        return service;

        //////////

        /**
         * Obtiene el listado de coordinators
         */
        function getCoordinators() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.coordinators,
                filters:service.coordinators.filtersAdvances
            };
            obj = Object.assign({}, obj, service.coordinators.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            // api.coordinators.get(service.coordinators.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.coordinators.data = response.results;
                service.coordinators.count = response.count;
                // service.coordinators.filtersAdvances = [];
                deferred.resolve(service.coordinators);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.coordinators.filters.page!=1){
                    service.coordinators.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de coordinators filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllCoordinators(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.coordinators.filters);
            f.search=search;
            f.page="all";
            api.teachers.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una coordinator determinado por su ID
         *
         * @param id
         */
        function getCoordinator(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.coordinators.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la coordinator que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveCoordinator(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.coordinators.update(form, updateOK, saveKO);
            } else {
                api.coordinators.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.coordinators.data.push(response);
                service.coordinators.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getCoordinators();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un coordinator vacío
         */
        function getEmptyCoordinator() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeCoordinator(coordinator){
            var deferred = $q.defer();

            api.coordinators.remove({id: coordinator.id}, coordinatorRemoveOK, removeKO);

            // coordinator borrado correctamente
            function coordinatorRemoveOK(response){
                // Quitamos la coordinator en los datos locales
                for (var i = 0; i < service.coordinators.data.length; i++) {
                    if (service.coordinators.data[i].id === coordinator.id) {
                        service.coordinators.data.splice(i,1);
                        service.coordinators.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar coordinator
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.conditionsTemplates')
        .factory('conditionsTemplatesService', conditionsTemplatesService);

    /** @ngInject */
    function conditionsTemplatesService($q, api) {

        var service = {
            conditionsTemplates: {
                data: [],
                count: 0,
                filters: {}
            },
            getConditionsTemplates: getConditionsTemplates,
            getAllConditionsTemplates: getAllConditionsTemplates,
            getConditionsTemplate: getConditionsTemplate,
            saveConditionsTemplate: saveConditionsTemplate,
            getEmptyConditionsTemplate: getEmptyConditionsTemplate,
            removeConditionsTemplate: removeConditionsTemplate
        };

        return service;

        //////////

        /**
         * Obtiene el listado de conditionsTemplates
         */
        function getConditionsTemplates() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.conditionsTemplates.get(service.conditionsTemplates.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.conditionsTemplates.data = response.results;
                service.conditionsTemplates.count = response.count;

                deferred.resolve(service.conditionsTemplates);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.conditionsTemplates.filters.page!=1){
                    service.conditionsTemplates.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de conditionsTemplates filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllConditionsTemplates(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.conditionsTemplates.filters);
            f.search=search;
            f.page="all";
            api.conditionsTemplates.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una conditionsTemplate determinado por su ID
         *
         * @param id
         */
        function getConditionsTemplate(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.conditionsTemplates.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la conditionsTemplate que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveConditionsTemplate(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.conditionsTemplates.update(form, updateOK, saveKO);
            } else {
                api.conditionsTemplates.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.conditionsTemplates.data.push(response);
                service.conditionsTemplates.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getConditionsTemplates();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un conditionsTemplate vacío
         */
        function getEmptyConditionsTemplate() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeConditionsTemplate(conditionsTemplate){
            var deferred = $q.defer();

            api.conditionsTemplates.remove({id: conditionsTemplate.id}, conditionsTemplateRemoveOK, removeKO);

            // conditionsTemplate borrado correctamente
            function conditionsTemplateRemoveOK(response){
                // Quitamos la conditionsTemplate en los datos locales
                for (var i = 0; i < service.conditionsTemplates.data.length; i++) {
                    if (service.conditionsTemplates.data[i].id === conditionsTemplate.id) {
                        service.conditionsTemplates.data.splice(i,1);
                        service.conditionsTemplates.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar conditionsTemplate
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function ()
{
    'use strict';
    angular
        .module('app.company')
        .controller('ContactsController', ContactsController);
    /** @ngInject */
    function ContactsController($scope, currentUser, contactsService, Contacts, Centers, CompanyDetail, NotifyService, $q,
                                $mdDialog, $document, DebounceService, gettextCatalog, $mdSidenav, centersService, $state)
    {
        var vm = this;
        // Data
        vm.contacts=Contacts;
        vm.centers=Centers;
        vm.form = CompanyDetail;
        vm.user=currentUser;

        // Methods
        vm.openContactDialog = openContactDialog;
        vm.removeContact = removeContact;
        vm.centerChange = centerChange;
        vm.toggleSidenav = toggleSidenav;
        vm.getCenters = getCenters;
        vm.getFullNameCenter = getFullNameCenter;

        // Watchers
        $scope.$watch('vm.contacts.filters', DebounceService(contactsService.getContacts, 300), true);

        //////////
        /**
         * Abre el dialogo para crear/editar una contact
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact) {
            centersService.centers.filters={};
            centersService.centers.filters.company=CompanyDetail.id;
            /* TODO: Hemos puesto un límite muy alto, pero lo ideal sería poner un buscador si nos pasamos de 20 centros */
            centersService.centers.filters.page_size=499;
            return centersService.getCenters().then(function(res){
                var centers=res.data;
                /*
                    TODO: Al comentar 
                    if(res.count>20) {
                    centers=[];
                }*/

                $mdDialog.show({
                    controller: 'ContactDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/company/contacts/dialogs/contact/contact-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        CompanyDetail:CompanyDetail,
                        Contact:contact,
                        Centers:centers,
                        PrivacyPolicy:contactsService.getPrivacyPolicy(),
                        event: ev
                    }
                });
            })
        }
        
        /**
         * Abre el dialogo para eliminar una contact
         *
         * @param ev
         * @param contact
         */
        function removeContact(ev, contact) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar contacto')+' "'+(contact.identification || "")+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el contacto?'))
                .ariaLabel(gettextCatalog.getString('Eliminar contacto'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar contacto'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                contactsService.removeContact(contact).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Contacto borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar el contacto. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });

        }

        function centerChange(){
            $state.go('app.company.contacts', vm.contacts.filters, {notify:false});
        }

        /**
         * Obtiene los centros para rellenar el autocomplete
         */
        function getCenters(searchText) {
            var deferred = $q.defer();
            centersService.centers.filters={};
            centersService.centers.filters.company=CompanyDetail.id;
            centersService.getAllCenters(searchText).then(function(centers){
                deferred.resolve(centers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del center
         */
        function getFullNameCenter(center) {
            return (center.name || '')+" "+(center.address || '');
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.company')
        .controller('CompanyListController', CompanyListController);
    /** @ngInject */
    function CompanyListController($scope, companyListService, CompanyList, NotifyService, $mdDialog, $document,
                                   SearchsBasics, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.companyList=CompanyList;
        vm.searchsBasics=SearchsBasics;

        console.log('searchsBasics: ',vm.searchsBasics)
        // Methods
        vm.openContactDialog = openContactDialog;
        vm.removeContact = removeContact;
        vm.removeCompany = removeCompany;
        vm.search = search;
        vm.status=companyListService.getStatus();
        vm.companyAgreements=companyListService.getCompanyAgreements();

        // Watchers
        $scope.$watch('vm.companyList.filters', DebounceService(companyListService.getCompanyList, 300), true);

        //////////
        /**
         * Abre el dialogo para crear/editar una contact
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact) {
            $mdDialog.show({
                controller: 'ContactDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/company/companyList/dialogs/contact/contact-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Contact:contact,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una contact
         *
         * @param ev
         * @param contact
         */
        function removeContact(ev, contact) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar sede')+' "'+contact.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la sede?'))
                .ariaLabel(gettextCatalog.getString('Eliminar sede'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar sede'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                companyListService.removeContact(contact).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Sede borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar la sede. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });

        }

        /**
         * Abre el dialogo para eliminar una empresa
         *
         * @param ev
         * @param company
         */
        function removeCompany(ev, company) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar empresa')+' "'+company.business_name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la empresa?'))
                .ariaLabel(gettextCatalog.getString('Eliminar empresa'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar empresa'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                companyListService.removeCompany(company).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Sede borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar la empresa. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });

        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.companyList.filtersAdvances=form;
            vm.companyList.filters={};
            vm.companyList.filters.page=1;
            return companyListService.getCompanyList();
        }



    }
})();

(function () {
    'use strict';

    angular
        .module('app.company')
        .controller('CompanyDetailController', CompanyDetailController);

    /** @ngInject */
    function CompanyDetailController(currentUser, CompanyDetail, Centers, Activities, companyDetailService, NotifyService,
                                     Validate, $scope, $stateParams, $mdSidenav, $element, $mdDialog, centersService, $q, gettextCatalog) {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.form = CompanyDetail;

        vm.identification_types=companyDetailService.getIdentificationTypes();
        vm.ownerships=companyDetailService.getOwnerships();
        vm.types_company=companyDetailService.getTypesCompany();
        vm.activities_company=Activities;
        vm.centers=Centers;

        // Para saber que campos son de validacion
        vm.serverErrors=Validate;

        //Para la búsqueda en el select de actividades debemos incluir este código:
        $element.find('input').on('keydown', function(ev) {
            ev.stopPropagation();
        });

        //Preparación de opciones para la subida de la imagen de perfil
        vm.ngFlowOptionsLogo={
            target: ($stateParams.id) ? "/api/companies/"+$stateParams.id+"/":"/api/companies/edit/",
            uploadMethod: "PATCH",
            headers: function (file, chunk, isTest) {
                return {
                    'Authorization': 'Token ' + ((localStorage['gades.token']) ? localStorage['gades.token'].split('"')[1] : '')
                };
            },
            singleFile: true,
            testChunks: false,
            chunkSize: 1024*1024*1024*1024*1024,
            fileParameterName: "logo"
        };

        // Methods
        vm.saveCompanyDetail = saveCompanyDetail;
        vm.setValid = setValid;
        vm.imageError = imageError;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleCompanyBlock = toggleCompanyBlock;
        vm.getCenters = getCenters;
        vm.getFullNameCenter = getFullNameCenter;

        //////////
        /**
         * Guardar detalle de empresa
         */
        function saveCompanyDetail(form) {
            return companyDetailService.saveCompanyDetail(angular.copy(vm.form)).then(function(response){
                vm.form=response;
                CompanyDetail.status=response.status;
                NotifyService.successMessage(gettextCatalog.getString("Datos básicos guardados correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al guardar los datos básicos. ") + (error.data.non_field_errors || ""));
            });
        }

        function setValid() {
            var obj=angular.copy(vm.form);
            obj.status="without-agreement";
            return companyDetailService.saveCompanyDetail(obj).then(function(response){
                vm.form=response;
                CompanyDetail.status=response.status;
                NotifyService.successMessage(gettextCatalog.getString("Empresa validada correctamente"));
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al validar empresa. ") + (error.data.non_field_errors || ""));
            });
        }

        function toggleCompanyBlock() {
            if (!vm.form.blocked_up) {
                vm.prompt = {};
                vm.prompt.title = gettextCatalog.getString('Bloquear empresa');
                vm.prompt.textContent = gettextCatalog.getString('Escriba aquí el motivo:');
                vm.prompt.ok = gettextCatalog.getString('Aceptar');
                vm.prompt.cancel = gettextCatalog.getString('Cancelar');
                vm.prompt.save = function (result) {
                    $mdDialog.hide();

                    var obj = {
                        id: vm.form.id,
                        block_reason: result
                    };
                    return companyDetailService.setCompanyBlock(obj).then(function (response) {
                        NotifyService.successMessage(gettextCatalog.getString("Empresa bloqueada correctamente"));
                        vm.form = response;
                        CompanyDetail.status = response.status;
                    }, function (error) {
                        vm.serverErrors = error.data;
                        NotifyService.errorMessage(gettextCatalog.getString("Error al bloquear empresa. ") + (error.data.non_field_errors || "") + (error.data.block_reason || ""));
                    });
                };

                $mdDialog.show({
                    templateUrl: "prompt.html",
                    clickOutsideToClose: true,
                    scope: $scope,
                    preserveScope: true
                });
            }else{
                var obj = {
                    id: vm.form.id
                };
                return companyDetailService.setCompanyBlock(obj).then(function (response) {
                    NotifyService.successMessage(gettextCatalog.getString("Empresa desbloqueada correctamente"));
                    vm.form = response;
                    CompanyDetail.status = response.status;

                }, function (error) {
                    vm.serverErrors = error.data;
                    NotifyService.errorMessage(gettextCatalog.getString("Error al desbloquear empresa. ") + (error.data.non_field_errors || ""));
                });
            }
        }


        /* Error al subir imagen */
        function imageError($file, $message, $flow) {
            $file.cancel();
            vm.serverErrors=JSON.parse($message);
            var msg="";
            if(vm.serverErrors.logo && vm.serverErrors.logo[0]){
                msg+=vm.serverErrors.logo[0];
            }
            NotifyService.errorMessage(gettextCatalog.getString("Error al editar el logo de la empresa. ")+msg);
        }

        /**
         * Obtiene los centros para rellenar el autocomplete
         */
        function getCenters(searchText) {
            var deferred = $q.defer();
            centersService.centers.filters={};
            centersService.centers.filters.company=CompanyDetail.id;
            centersService.getAllCenters(searchText).then(function(centers){
                deferred.resolve(centers);
            });
            return deferred.promise;
        }

        /**
         * Obtiene el nombre completo del center
         */
        function getFullNameCenter(center) {
            return center.name+" "+center.address;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.company')
        .controller('CentersController', CentersController);
    /** @ngInject */
    function CentersController($scope, currentUser, centersService, Centers, NotifyService, $mdDialog, $document,
                               DebounceService, CompanyDetail, $mdSidenav, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.centers=Centers;
        vm.form = CompanyDetail;
        vm.user=currentUser;

        // Methods
        vm.openCenterDialog = openCenterDialog;
        vm.removeCenter = removeCenter;
        vm.toggleSidenav = toggleSidenav;
        
        // Watchers
        $scope.$watch('vm.centers.filters', DebounceService(centersService.getCenters, 300), true);

        //////////
        /**
         * Abre el dialogo para crear/editar una center
         *
         * @param ev
         * @param center
         */
        function openCenterDialog(ev, center) {
            $mdDialog.show({
                controller: 'CenterDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/company/centers/dialogs/center/center-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Center:center,
                    CompanyDetail:CompanyDetail,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una center
         *
         * @param ev
         * @param center
         */
        function removeCenter(ev, center) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar sede')+' "'+(center.name || "")+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la sede?'))
                .ariaLabel(gettextCatalog.getString('Eliminar sede'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar sede'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                centersService.removeCenter(center).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Sede borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar la sede. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.auth')
        .factory("AuthService", AuthService);


    /** @ngInject */
    function AuthService ( $q, $rootScope, authSettings, msApi, localStorageService, api) {
        var service = {
            loggedIn : false,
            token: '',
            currentUser : null,
            getCurrentUser : getCurrentUser,
            checkStatus: checkStatus,
            login: login,
            logout: logout,
            register: register,
            changeGroup: changeGroup,
            password: {
                resetRequest: passwordResetRequest,
                resetConfirm: passwordResetConfirm,
                change: passwordChange
            }
        };

        return service;

        /////////////

        /**
         * Comprueba el estado de identificación del usuario actual
         */
        function checkStatus ( )
        {
            var deferred = $q.defer();

            msApi.request('auth.currentUser@get', {}, function(res){
                if (res){
                    for(var i in res.profiles){
                        for(var j in res.profiles[i]){
                            if(res.profiles[i][j].id===localStorageService.get('token')){
                                res.profile=res.profiles[i][j];
                                res.type_user=res.profiles[i][j].profile_type;
                            }
                        }
                    }

                    service.loggedIn = true;
                    service.currentUser = res;
                    service.token = localStorageService.get('token');

                    // deferred.resolve(service.currentUser);
                    msApi.request('auth.permissions@get', {}, function(res) {
                        service.currentUser.urlPermissions=res;
                        deferred.resolve(service.currentUser);
                    });
                } else {
                    deferred.reject({error:"No hay ningún usuario autenticado"});
                }
            }, function(){
                deferred.reject({error:"No hay ningún usuario autenticado"});
            });

            return deferred.promise;
        }

        /**
         * Devuelve el usuario logueado
         */
        function getCurrentUser ( )
        {
            var deferred = $q.defer();

            if(service.currentUser){
                deferred.resolve(service.currentUser);
            }else{
                service.checkStatus().then(function(){
                    deferred.resolve(service.currentUser);
                },function(){
                    deferred.reject({error:"No hay ningún usuario autenticado"});
                });
            }

            return deferred.promise;
        }

        /**
         * Realiza la acción / intento de login
         */
        function login (username, password, noevent )
        {
            var deferred = $q.defer();
            localStorageService.remove('token');
            localStorageService.remove('tokenImpersonate');

            msApi.request('auth.login@save', {username: username, password: password}, function(res){
                // On login success
                service.loggedIn = true;
                service.token = res.token;
                localStorageService.set('token', service.token);

                //service.currentUser = res.user;
                service.checkStatus().then(function(data){
                    if ( authSettings.ON_LOGIN_BROADCAST && noevent !== true) {
                        $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, data);
                    }
                    deferred.resolve(res);
                }, function(){
                    // On detail fail
                    deferred.reject({error: "Error al obtener los datos del usuario"});
                });

            }, function(){
                // On login fail
                deferred.reject({error: "Nombre de usuario o contraseña incorrecta"});
            });

            return deferred.promise;
        }

        /**
         * Realiza la acción de logout
         */
        function logout ()
        {
            var deferred = $q.defer();
            msApi.request('auth.logout@save', function(res){
                service.loggedIn = false;
                service.currentUser = null;
                service.token = null;
                localStorageService.remove('token');
                localStorageService.remove('tokenImpersonate');



                if ( authSettings.ON_LOGOUT_BROADCAST) {
                    $rootScope.$broadcast(authSettings.ON_LOGOUT_BROADCAST);
                }
            }, function(res){
                // On logout fail
                deferred.reject(res);
            });

        }


        /**
         * Realiza la acción de solicitud de reseteo de contraseña
         */
        function passwordResetRequest ( form )
        {
            var deferred = $q.defer();

            msApi.request('auth.reset@save', form, function(res){
                if (res){
                    deferred.resolve(res);
                } else {
                    deferred.reject({error:"No hay ningún usuario con este email"});
                }
            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        /**
         * Realiza la acción de confirmación de reseteo de contraseña
         */
        function passwordResetConfirm ( form )
        {
            var deferred = $q.defer();

            msApi.request('auth.resetConfirm@save', form, function(res){
                // On login success
                service.loggedIn = true;
                service.token = res.token;
                localStorageService.set('token', service.token);

                //service.currentUser = res.user;
                service.checkStatus().then(function(data){
                    if ( authSettings.ON_LOGIN_BROADCAST) {
                        $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, data);
                    }
                    deferred.resolve(res);
                });
            }, function(res){
                deferred.reject(res);
            });

            return deferred.promise;
        }

        /**
         * Realiza la acción de cambio de contraseña
         */
        function passwordChange ( oldPassword, newPassword, newPasswordRepeat )
        {
            var deferred = $q.defer();

            api.user.passwordChange({current_password: oldPassword, password: newPassword, password_repeat: newPasswordRepeat}, function(){
                deferred.resolve();
            }, function(res){
                // On password fail
                deferred.reject(res.data);
            });

            return deferred.promise;
        }

        /**
         * Realiza el registro de una empresa
         */
        function register ( form )
        {
            var deferred = $q.defer();

            localStorageService.remove('token');
            localStorageService.remove('tokenImpersonate');
            msApi.request('auth.register@save', form, function(res){

                service.loggedIn = true;
                service.token = res.token;
                localStorageService.set('token', service.token);

                //service.currentUser = res.user;
                service.checkStatus().then(function(data){
                    if ( authSettings.ON_LOGIN_BROADCAST) {
                        $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, data);
                    }
                    deferred.resolve(res);
                });

            }, function(error){
                deferred.reject(error);
            });

            return deferred.promise;
        }

        /**
         * Cambia de grupo al usuario logado
         */
        function changeGroup (group)
        {
            var deferred = $q.defer();

            api.changeGroup.update({'group_type': group}, updateOK, saveKO);

            return deferred.promise;

            function updateOK(response) {
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .config(interceptor);

    function interceptor($provide, $httpProvider, authSettings, AuthServiceProvider) {

        // Este interceptor captura todos los fallos de autenticación
        $provide.factory('AuthenticationInterceptor', ['localStorageService', '$q', '$rootScope', function (localStorageService, $q, $rootScope) {
            return {
                request: function(config) {
                    config.headers = config.headers || {};
                    if (localStorageService.get('token')) {
                        config.headers.Authorization = 'Token ' + localStorageService.get('token');
                    }
                    if (localStorageService.get('tokenImpersonate')) {
                        config.headers.ImpersonateAuthorization = 'Token ' + localStorageService.get('tokenImpersonate');
                    }
                    if($rootScope.languageSelected){
                       config.headers['Accept-Language'] = $rootScope.languageSelected;
                    }
                    return config || $q.when(config);
                },

                // Utilizamos el método response error ya que queremos capturar los 401
                responseError: function (rejection) {
                    if (rejection.status === 401 || rejection.status === 403) {

                        if (authSettings.ON_UNAUTHORIZED_REQUEST && localStorageService.get('token')){
                            AuthServiceProvider.$get().getCurrentUser().then(function(currentUser){
                                $rootScope.$broadcast(authSettings.ON_UNAUTHORIZED_REQUEST, currentUser);
                            });
                        }else{
                            $rootScope.$broadcast(authSettings.ON_UNAUTHORIZED_REQUEST);
                        }
                        localStorageService.remove('token');
                        localStorageService.remove('tokenImpersonate');

                    }

                    // Flujo normal de ejecución
                    return $q.reject(rejection);
                }
            };
        }]);

        // Add the interceptor to the $httpProvider.
        $httpProvider.interceptors.push('AuthenticationInterceptor');
    }
})();

(function()
{
    'use strict';

    angular
        .module('app.auth')
        .constant('authSettings', {

            /**
             * estado ($route) al que se cambiará cuando sea necesario pedir el login de usuario
             */
            LOGIN_STATE: 'app.home',

            /**
             * estado ($route) al que se cambiará cuando el logueo sea correcto
             */
            LOGIN_STATE_SUCCESS: 'app.notifications',

            /**
             * evento que se emitirá mediante $rootScope.broadcast() cuando el usuario se identifique correctamente. Si
             * es un valor que se evalúe como false, no se emitirá ningún evento
             */
            ON_LOGIN_BROADCAST: 'auth.login',

            /**
             * evento que se emitirá mediante $rootScope.broadcast() cuando el usuario cierra la sesión. Si
             * es un valor que se evalúe como false, no se emitirá ningún evento
             */
            ON_LOGOUT_BROADCAST: 'auth.logout',

            /**
             * evento que se emitirá mediante $rootScope.broadcast() cuando el usuario hace alguna petición
             * que devuelve un 401 o 403. Si es un valor que se evalúe como false, no se emitirá ningún evento
             */
            ON_UNAUTHORIZED_REQUEST: 'auth.unauthorized'

        } );

})();

(function () {
    'use strict';

    angular
        .module('app.activities')
        .factory('activitiesService', activitiesService);

    /** @ngInject */
    function activitiesService($q, api) {

        var service = {
            activities: {
                data: [],
                count: 0,
                filters: {}
            },
            getActivities: getActivities,
            getAllActivities: getAllActivities,
            getActivity: getActivity,
            saveActivity: saveActivity,
            getEmptyActivity: getEmptyActivity,
            removeActivity: removeActivity
        };

        return service;

        //////////

        /**
         * Obtiene el listado de activities
         */
        function getActivities() {
            // Create a new deferred object
            var deferred = $q.defer();
            api.activities.get(service.activities.filters, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.activities.data = response.results;
                service.activities.count = response.count;

                deferred.resolve(service.activities);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.activities.filters.page!=1){
                    service.activities.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de activities filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllActivities(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.activities.filters);
            f.search=search;
            f.page="all";
            api.activities.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una activity determinado por su ID
         *
         * @param id
         */
        function getActivity(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.activities.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.data);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la activity que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveActivity(form) {
            var deferred = $q.defer();

            if (form.id) {
                api.activities.update(form, updateOK, saveKO);
            } else {
                api.activities.create(form, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {
                service.activities.data.push(response);
                service.activities.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                service.getActivities();
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un activity vacío
         */
        function getEmptyActivity() {
            return {
                curricular:true,
                extracurricular:true
            };
        }
        
        function removeActivity(activity){
            var deferred = $q.defer();

            api.activities.remove({id: activity.id}, activityRemoveOK, removeKO);

            // Activity borrado correctamente
            function activityRemoveOK(response){
                // Quitamos la activity en los datos locales
                for (var i = 0; i < service.activities.data.length; i++) {
                    if (service.activities.data[i].id === activity.id) {
                        service.activities.data.splice(i,1);
                        service.activities.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar activity
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('app.actionloggings')
        .factory('actionloggingsService', actionloggingsService);

    /** @ngInject */
    function actionloggingsService($q, api, gettextCatalog) {

        var service = {
            actionloggings: {
                data: [],
                count: 0,
                filters: {},
                filtersAdvances:[],
                exportFields:{}
            },
            getActionloggings: getActionloggings,
            getAllActionloggings: getAllActionloggings,
            getActionlogging: getActionlogging,
            saveActionlogging: saveActionlogging,
            getEmptyActionlogging: getEmptyActionlogging,
            removeActionlogging: removeActionlogging
        };

        return service;

        //////////

        /**
         * Obtiene el listado de actionloggings
         */
        function getActionloggings() {
            // Create a new deferred object
            var deferred = $q.defer();

            var obj={
                id:api.searchsAdvancesModules.actionloggings,
                filters:service.actionloggings.filtersAdvances
            };
            obj = Object.assign({}, obj, service.actionloggings.filters);
            api.searchsAdvances.search(obj, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                service.actionloggings.data = response.results;
                service.actionloggings.count = response.count;
                // service.actionloggings.filtersAdvances = [];
                deferred.resolve(service.actionloggings);
            }

            function getKO(response) {
                //con esto evitamos que den problemas los not found cuando
                // filtramos y estamos en una página que ya no existe
                if(response.status==404 && service.actionloggings.filters.page!=1){
                    service.actionloggings.filters.page=1;
                }
                deferred.reject(response);
            }
        }

        /**
         * Obtiene el listado de actionloggings filtrando unicamente por el texto dado y sin guardar en el servicio
         *
         * @param search
         */
        function getAllActionloggings(search) {
            // Create a new deferred object
            var deferred = $q.defer();
            var f=angular.copy(service.actionloggings.filters);
            f.search=search;
            f.page="all";
            api.actionloggings.get(f, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response.results);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Obtiene los datos de una actionlogging determinado por su ID
         *
         * @param id
         */
        function getActionlogging(id) {
            // Create a new deferred object
            var deferred = $q.defer();
            api.actionloggings.get({id: id}, getOK, getKO);
            return deferred.promise;

            function getOK(response) {
                deferred.resolve(response);
            }

            function getKO(response) {
                deferred.reject(response);
            }
        }

        /**
         * Guarda la actionlogging que se pasa como parámetro. Si ya existe actualiza el existente.
         *
         * @param form
         */
        function saveActionlogging(form) {
            var deferred = $q.defer();

            var actionlogging = angular.copy(form);
            actionlogging.start_date= moment(actionlogging.start_date).format("YYYY-MM-DD");
            actionlogging.end_date= moment(actionlogging.end_date).format("YYYY-MM-DD");

            if (form.id) {
                api.actionloggings.update(actionlogging, updateOK, saveKO);
            } else {
                api.actionloggings.create(actionlogging, createOK, saveKO);
            }

            return deferred.promise;


            function createOK(response) {

                service.actionloggings.data.push(response);
                service.actionloggings.count ++;
                deferred.resolve(response);
            }

            function updateOK(response) {
                // Actauliza el listado
                for (var i = 0; i < service.actionloggings.data.length; i++) {
                    if (service.actionloggings.data[i].id === response.id) {
                        service.actionloggings.data[i] = angular.copy(response);
                    }
                }
                deferred.resolve(response);
            }

            function saveKO(response) {
                deferred.reject(response);
            }

        }

        /**
         * Devuelve un centro vacío
         */
        function getEmptyActionlogging() {
            return {
                "start_date": new Date(),
                "end_date": new Date(),
                "name": ""
            };
        }
        
        function removeActionlogging(actionlogging){
            var deferred = $q.defer();

            api.actionloggings.remove({id: actionlogging.id}, actionloggingRemoveOK, removeKO);

            // Centro borrado correctamente
            function actionloggingRemoveOK(response){
                // Quitamos la actionlogging en los datos locales
                for (var i = 0; i < service.actionloggings.data.length; i++) {
                    if (service.actionloggings.data[i].id === actionlogging.id) {
                        service.actionloggings.data.splice(i,1);
                        service.actionloggings.count -= 1;
                        break;
                    }
                }
                deferred.resolve(response.data);
            }

            // Fallo al borrar centro
            function removeKO(response){
                deferred.reject(response);
            }

            return deferred.promise;
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.utils.notify', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.utils.notify')
        .factory("NotifyService", NotifyService);


    /** @ngInject */
    function NotifyService ( $mdToast ) {
        var service = {
            errorMessage: showErrorMessage,
            successMessage: showSuccessMessage
        };

        return service;

        /////////////

        /**
         * Muestra un mensaje simple de error
         */
        function showErrorMessage ( message )
        {
            //Damos mas tiempo a lo mensajes mas largos
            var time=5000;
            time+=(message.length*20);
            $mdToast.show(
                $mdToast.simple()
                    .textContent(message)
                    .theme('toast-error')
                    .hideDelay(time)
            );
        }

        /**
         * Muestra un mensaje simple de éxito
         */
        function showSuccessMessage ( message )
        {
            //Damos mas tiempo a lo mensajes mas largos
            var time=5000;
            time+=(message.length*20);
            $mdToast.show(
                $mdToast.simple()
                    .textContent(message)
                    .theme('toast-success')
                    .hideDelay(time)
            );
        }



    }

})();

(function () {
    'use strict';

    angular
        .module('app.utils.filters', []
        )
        .config(config);

    /** @ngInject */
    function config() {


    }
})();

(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('syntaxHighlight', syntaxHighlight);

    function syntaxHighlight() {
        return function(json){
            if(typeof json === 'string' && json.charAt(0)==='{'){
                json = JSON.parse(json);
            }else{
                return json;
            }
            if (typeof json != 'string') {
                 json = JSON.stringify(json, undefined, 2);
            }

            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
            return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                var cls = 'number';
                if (/^"/.test(match)) {
                    if (/:$/.test(match)) {
                        cls = 'key';
                    } else {
                        cls = 'string';
                    }
                } else if (/true|false/.test(match)) {
                    cls = 'boolean';
                } else if (/null/.test(match)) {
                    cls = 'null';
                }
                return '<span class="' + cls + '">' + match + '</span>';
            });
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('promiseStatus', promiseStatus);

    function promiseStatus() {
        return function(promise) {
            var status = {
                inProgress: true,
                resolved: false,
                rejected: false
            };
            promise
                .then(function() {
                    status.resolved = true;
                })
                .catch(function() {
                    status.rejected = true;
                })
                .finally(function() {
                    status.inProgress = false;
                });
            return status;
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('level', level);

    function level(gettextCatalog) {
        return function(input) {
            if(input==="initial"){
                return gettextCatalog.getString("Inicial");
            }
            if(input==="medium"){
                return gettextCatalog.getString("Medio");
            }
            if(input==="advanced"){
                return gettextCatalog.getString("Avanzado");
            }
            return input;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('findBodyHtml', findBodyHtml);

    function findBodyHtml() {
        return function(html){
            var strVal = html; //obviously, this line can be omitted - just assign your string to the name strVal or put your string var in the pattern.exec call below
            var pattern = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
            var array_matches = pattern.exec(strVal);

            return array_matches || html;
        };
    }
})();


(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('durationHumanize', durationHumanize);

    function durationHumanize(moment) {
        return function(input) {
            return moment.duration(input, "minutes").format("D [días], h [horas], m [minutos]");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.utils.filters')
        .filter('currency6', currency6);

    function currency6(currencyFilter) {
        return function(amount){
            return currencyFilter(amount,'€',6);
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.utils.factory', [])
        .factory('utils', utils);

    function utils(localStorageService, DebounceService, $state) {
        return  {
            filtersAndOrdering : function(scope, vm, itemOrdering, service, filtered){
                vm.ordering = localStorageService.get(itemOrdering);
                scope.$watchCollection('vm.ordering', function (newValue, oldValue) {
                    if(newValue !== oldValue) {
                        if(vm.ordering !== undefined){
                            localStorageService.set(itemOrdering, vm.ordering);
                        }
                        if (filtered){
                            DebounceService(service.listFiltered, 300)();
                        }else{
                            DebounceService(service.list, 300)();
                        }
                    }
                });

                // Cambios en el número de páginas
                scope.$watch('config.itemsPerPage', function (newValue, oldValue) {
                    if (newValue !== oldValue){
                        if (filtered){
                            DebounceService(service.listFiltered, 300)();
                        }else{
                            DebounceService(service.list, 300)();
                        }
                    }
                });
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utils.directives', [])
        .directive('tableAjax', tableAjax)
        .config(config);

    /** @ngInject */
    function config()
    {

    }

    function tableAjax($compile,$timeout) {
        return {
            restrict: 'A',
            scope: {
                tableAjax: '='
            },
            link: function (scope, elem, attrs) {

                var title_table=$(elem).closest(".md-card").find(".md-card-toolbar .md-card-toolbar-heading-text").text();

                if(!window.location.host.includes("localhost")){
                    $.fn.dataTableExt.sErrMode = function(oSettings, iLevel, sMesg){
                        console.log(oSettings, iLevel, sMesg);
                    };
                }

                scope.$watch('tableAjax.data', function (newVal,oldVal) {
                    if(newVal!==oldVal){
                        var numPage=table_tableTools.page();
                        table_tableTools.clear().draw();
                        table_tableTools.rows.add(newVal); // Add new data
                        table_tableTools.columns.adjust().draw(); // Redraw the DataTable
                        if(newVal.length===oldVal.length){
                            table_tableTools.page(numPage).draw( 'page' );
                        }
                        else if(newVal.length>oldVal.length){
                            var data = table_tableTools.rows().data();
                            var id=newVal[newVal.length-1].id;
                            var pos=-1;
                            for(var i in data){
                                if(data[i].id && data[i].id===id){
                                    pos=i;
                                }
                            }
                            if(pos!==-1){
                                var page=pos/table_tableTools.page.len();
                                page=Math.trunc(page);
                                table_tableTools.page(page).draw( 'page' );
                            }
                        }
                    }

                });

                scope.$watch('tableAjax.reload', function (newVal,oldVal) {
                    if(newVal && newVal!==oldVal){
                        table_tableTools.ajax.reload();
                        scope.tableAjax.reload=false;
                    }
                },true);

                function collect() {
                  var ret = {};
                  var len = arguments.length;
                  for (var i=0; i<len; i++) {
                    for (var p in arguments[i]) {
                      if (arguments[i].hasOwnProperty(p)) {
                        ret[p] = arguments[i][p];
                      }
                    }
                  }
                  return ret;
                }

                var $dt_tableTools = $(elem);
                if ($dt_tableTools.length) {

                    var obj=
                        {
                            lengthMenu: [[10, 25, 50, 100, -1], [10, 25, 50, 100, "Todos"]],
                            "language": {
                                "sProcessing": '<div id="page_preloader" class="loaddatatable" style="display: block;opacity:1;width: 200px;height: 200px;margin-top: -100px;margin-left: -100px;top: 50%;left: 50%;border: 1px solid #ccc;"><img src="assets/img/page_preloader.gif" alt=""></div>',
                                "sLengthMenu": "Mostrar"+" _MENU_ "+"registros",
                                "sZeroRecords": "No se encontraron resultados",
                                "sEmptyTable": "Ningún dato disponible en esta tabla",
                                "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                                "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                                "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
                                "sInfoPostFix": "",
                                "sSearch": "Buscar"+":",
                                "sUrl": "",
                                "sInfoThousands": ",",
                                "sLoadingRecords": '<div id="page_preloader" class="loaddatatable" style="display: block;opacity:1;width: 200px;height: 200px;margin-top: -100px;margin-left: -100px;top: 50%;left: 50%;border: 1px solid #ccc;"><img src="assets/img/page_preloader.gif" alt=""></div>',
                                "oPaginate": {
                                    "sFirst": "Primero",
                                    "sLast": "Último",
                                    "sNext": "Siguiente",
                                    "sPrevious": "Anterior"
                                },
                                "oAria": {
                                    "sSortAscending": ": "+"Activar para ordenar la columna de manera ascendente",
                                    "sSortDescending": ": "+"Activar para ordenar la columna de manera descendente"
                                }
                            }
                        };

                    obj = collect(obj,scope.tableAjax);
                    var table_tableTools = $dt_tableTools.DataTable(obj);

                    var createButtons=function(){
                        $(".DTTT.uk-text-right").remove();
                        var tt = new $.fn.dataTable.TableTools(table_tableTools, {
                            "sSwfPath": "bower_components/datatables-tabletools/swf/copy_csv_xls_pdf.swf",
                            "aButtons": [
                                {
                                    "sExtends": "copy",
                                    "sButtonClass": "md-raised md-background md-button md-default-theme md-ink-ripple",
                                    "sButtonText": "Copiar"
                                },
                                {
                                    "sExtends": "xls",
                                    "sButtonClass": "md-raised md-background md-button md-default-theme md-ink-ripple",
                                    "sButtonText": "Excel",
                                    "fnCellRender": function ( sValue, iColumn, nTr, iDataIndex ) {
                                        return sValue;
                                    },
                                    "sFileName": "*.xls"
                                },
                                {
                                    "sExtends": "csv",
                                    "sButtonClass": "md-raised md-background md-button md-default-theme md-ink-ripple",
                                    "sButtonText": "CSV",
                                    "fnCellRender": function ( sValue, iColumn, nTr, iDataIndex ) {
                                        return sValue;
                                    }
                                }
                            ]


                        });
                        // $(tt.fnContainer()).insertBefore($dt_tableTools.closest('.content-card').find('.toolbar .options-datatable'));
                        $dt_tableTools.closest('.content-card').find('.toolbar .options-datatable').append($(tt.fnContainer()));
                        $("a.DTTT_button").removeClass("DTTT_button");
                    };
                    $timeout(function(){
                        createButtons();
                    });
                }
            }
        };
    }



})();

(function () {
    'use strict';

    angular
        .module('app.utils.directives')
        .directive('uniqueEmail', uniqueEmail);

    /** @ngInject */
    function uniqueEmail(api, $q) {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {
                ctrl.$asyncValidators.unique = function (modelValue, viewValue) {
                    var deferred = $q.defer();

                    api.user.emailCheck({email: viewValue}, function(data){
                        if (data.exists){
                            deferred.reject();
                        } else {
                            deferred.resolve();
                        }
                    });

                    return deferred.promise;
                };
            }
        };
    }
})();

/*
 * Angular Fixed Table Header
 * https://github.com/daniel-nagy/fixed-table-header
 * @license MIT
 * v0.2.1
 */

(function (window, angular, undefined) {
    'use strict';

    angular
        .module('app.utils.directives')
        .directive('tableFixedHeader', tableFixedHeader);

    /** @ngInject */
    function tableFixedHeader($compile, $window) {
        return {
            compile: function (element) {
                var table = {
                    clone: element.find("table").clone(),
                    original: element.find("table")
                };

                var container = element;

                element.css('position', 'relative');
                table.clone.css({
                    position: 'absolute',
                    'z-index':9999
                });


                return function postLink(scope) {
                    table.clone.find("tbody").remove();
                    container.before(table.clone);

                    var header = {
                        clone: table.clone.find("thead"),
                        original: table.original.find("thead")
                    };

                    function cells() {
                        return header.clone.find('th').length;
                    }

                    function getCells(node) {
                        return Array.prototype.map.call(node.find('th'), function (cell) {
                            return angular.element(cell);
                        });
                    }

                    function updateCells() {
                        var cells = {
                            clone: getCells(header.clone),
                            original: getCells(header.original)
                        };


                        cells.clone.forEach(function (clone, index) {
                            if(clone.data('isClone')) {
                                return;
                            }

                            // prevent duplicating watch listeners
                            clone.data('isClone', true);

                            var cell = cells.original[index];
                            var style = $window.getComputedStyle(cell[0]);

                            var setWidth = function () {
                                clone.css({minWidth: style.width, maxWidth: style.width});
                            };

                            var getWidth = function () {
                                return style.width;
                            };

                            var listener = scope.$watch(getWidth, setWidth);

                            $window.addEventListener('resize', setWidth);

                            clone.on('$destroy', function () {
                                listener();
                                $window.removeEventListener('resize', setWidth);
                            });

                            cell.on('$destroy', function () {
                                clone.remove();
                            });
                        });
                    }

                    scope.$watch(cells, updateCells);

                    $compile(table.clone)(scope);
                }
            }
        };
    }
})(window, angular);

(function () {
    'use strict';

    angular
        .module('app.utils.directives')
        .controller('ParametersController', ParametersController)
        .directive('parameters', parametersDirective);

    /** @ngInject */
    function ParametersController($timeout) {
        var vm = this;

        vm.selectedParameter=null;
        vm.breadcrumb=[];
        vm.load=false;

        // Methods
        vm.addToBreadcrumb = addToBreadcrumb;
        vm.addValueParemeter = addValueParemeter;
        vm.resetParameters = resetParameters;
        vm.showMenu = showMenu;
        vm.notEmpty = notEmpty;

        //////////

        /**
         * Añade al breadcrumb el rastro de migas
         */
        function addToBreadcrumb(key, obj) {
            vm.load=true;
            $timeout(function(){
                vm.load=false;
            },500);
            //si tiene key se entiende que es un paso hacia adelante
            if(key){
                vm.selectedParameter=obj.data || obj;
                vm.breadcrumb.push({
                    "key":key,
                    "value":obj.human_name,
                    "parameters":obj.data || obj
                });
            }else{
                //Si no tiene key es que quiere ir al padre
                vm.breadcrumb.splice(-1,1);
                if(vm.breadcrumb.length){
                    vm.selectedParameter=vm.breadcrumb[vm.breadcrumb.length-1].parameters;
                }else{
                    vm.selectedParameter=null;
                }
            }
        }

        /**
         * Añade al campo de texto la variable que hayamos indicado
         */
        function addValueParemeter(key) {
            var s="";
            for(var i in vm.breadcrumb){
                s+=vm.breadcrumb[i].key+".";
            }
            s+=key;
            if(typeof vm.model==="string"){
                vm.model+=" "+s+" ";
            }
            else if(typeof vm.model==="object"){
                if(vm.model.indexOf(s)===-1){
                    vm.model.push(s);
                }
            }
            resetParameters();
        }

        function resetParameters(){
            vm.selectedParameter=null;
            vm.breadcrumb=[];
        }

        function showMenu(params){
            for(var i in params){
                if(notEmpty(params[i][vm.filter])){
                    return true;
                }
            }
            return false;
        }

        function notEmpty(obj){
            return Object.keys(obj).length>0;
        }


    }

    /** @ngInject */
    function parametersDirective() {
        return {
            restrict: 'E',
            scope: {},
            bindToController: {
                model: '=model',
                filter: '=filter',
                parameters: '=parameters',
                icon: '@icon'
            },
            controller: 'ParametersController as Parameters',
            templateUrl: 'app/main/parameters/parameters.html',
            link: function (scope, iElement) {

            }
        };
    }
})();

(function (window, angular, undefined) {
    'use strict';

    angular
        .module('app.utils.directives')
        .directive('iframeAuthentication', iframeAuthentication);

    /** @ngInject */
    function iframeAuthentication($http, $rootScope) {
        return {
            restrict: 'E',
            scope: {
                src: '='
            },
            link: function (scope, element) {
                $http({
                    method: 'GET',
                    url: scope.src
                }).then(function successCallback(response) {
                    getOK(response);
                });

                function getOK(response){
                    var iframe = $(element);
                    var str=response.data;

                    var p1=str.indexOf("<body");
                    var p2=str.indexOf("</body>")+7;

                    str = str.slice(p1, p2);

                    str=str.replace("<body","<div");
                    str=str.replace("</body>","</div>");

                    if($rootScope.server){
                        str = str.replace(/<img[^<]*src=["']([^"]*)["']/g, "<img src='"+$rootScope.server+"$1'");
                    }

                    iframe.html(str);
                }
            }
        };
    }

})(window, angular);

(function (window, angular, undefined) {
    'use strict';

    angular
        .module('app.utils.directives')
        .directive('formTranslate', formTranslate)
        .directive('formTranslateTemplates', formTranslateTemplates)
        .directive('varTranslate', varTranslate)
        .directive('bindTranslate', bindTranslate)
        .directive('mdAutocompleteTranslate', mdAutocompleteTranslate);

    /** @ngInject */
    function formTranslate($rootScope) {
        return {
            restrict: 'A',
            scope: {
                formTranslate: '='
            },
            compile: function (elem, attrs) {
                /*var $form=$(elem).find("md-dialog-content");

                var html='<md-content><md-tabs md-dynamic-height md-border-bottom>';

                for(var i in $rootScope.languages){
                    var $formClone=$form.clone();

                    //vamos a buscar los campos que sean traducibles solo si no estamos mirando el idioma por defecto
                    if($rootScope.languages[i].code!==$rootScope.languageDefault){
                        var $inputs=$formClone.find("[data-input-translate]");
                        var $errors=$formClone.find("error-messages");

                        $inputs.each(function() {
                            if($(this).attr("name")){
                                $(this).attr("name",$(this).attr("name")+"_"+$rootScope.languages[i].code);
                            }
                            if($(this).attr("data-ng-model")){
                                $(this).attr("data-ng-model",$(this).attr("data-ng-model")+"_"+$rootScope.languages[i].code);
                            }
                        });

                        $errors.each(function() {
                            if($(this).attr("field")){
                                $(this).attr("field",$(this).attr("field")+"_"+$rootScope.languages[i].code);
                            }
                        });

                        // Además añadimos la extension del idioma a los campos adicionales
                        // que luego se usará solo para los campos de tipo texto.
                        var $extraFields=$formClone.find("extra-fields");
                        $extraFields.attr("language","_"+$rootScope.languages[i].code);
                    }

                    html+='<md-tab label="'+$rootScope.languages[i].name+'"><md-content class="md-padding">';

                    html+=$formClone.html();

                    html+='</md-content></md-tab>';

                }

                html+='</md-tabs></md-content>';

               $(elem).find("md-dialog-content").html(html);*/

            }
        };
    }

    /** @ngInject */
    function formTranslateTemplates($rootScope, gettextCatalog) {
        return {
            restrict: 'A',
            scope: {
                formTranslate: '='
            },
            compile: function (elem, attrs) {
                /*var $form=$(elem).find("md-dialog-content");

                var html='<md-content><md-tabs md-dynamic-height md-border-bottom>';

                var languages = [
                    {
                        code:'es',
                        name:gettextCatalog.getString('Español')
                    },
                    {
                        code:'en',
                        name:gettextCatalog.getString('Inglés')
                    },
                    {
                        code:'fr',
                        name:gettextCatalog.getString('Francés')
                    },
                    {
                        code:'pt',
                        name:gettextCatalog.getString('Portugués')
                    },
                    {
                        code:'it',
                        name:gettextCatalog.getString('Italiano')
                    },
                    {
                        code:'de',
                        name:gettextCatalog.getString('Alemán')
                    }
                ];

                for(var i in languages){
                    var $formClone=$form.clone();

                    //vamos a buscar los campos que sean traducibles solo si no estamos mirando el idioma por defecto
                    if(languages[i].code!==$rootScope.languageDefault){
                        var $inputs=$formClone.find("[data-input-translate]");
                        var $keys=$formClone.find(".attachment");

                        $inputs.each(function() {
                            if($(this).attr("name")){
                                $(this).attr("name",$(this).attr("name")+"_"+languages[i].code);
                            }
                            if($(this).attr("data-ng-model")){
                                $(this).attr("data-ng-model",$(this).attr("data-ng-model")+"_"+languages[i].code);
                            }
                            if($(this).attr("required")){
                                $(this).attr("required",false);
                            }
                        });

                        $keys.each(function() {
                            if($(this).attr("data-ng-click")) {
                                $(this).attr("data-ng-click","vm.template.description_"+languages[i].code+"=vm.template.description_"+languages[i].code+"+' {'+key+'} '");
                            }
                        });


                    }

                    html+='<md-tab label="'+languages[i].name+'"><md-content class="md-padding">';

                    html+=$formClone.html();

                    html+='</md-content></md-tab>';

                }

                html+='</md-tabs></md-content>';

               $(elem).find("md-dialog-content").html(html);*/

            }
        };
    }

    /** @ngInject */
    function varTranslate($rootScope) {
        return {
            restrict: 'A',
            compile: function (elem, attrs) {
                /*var text=$(elem).text();
                var arrText=text.split("}}");

                text="";
                for(var i=0; i<arrText.length-1; i++){
                    var t=arrText[i];
                    t=t.replace("{{","");
                    t=t.replace("}}","");
                    text+=" {{"+t.trim()+"_"+$rootScope.languageSelected+" || "+t.trim()+" }}";
                }

                $(elem).text(text);*/

            }
        };
    }
    /** @ngInject */
    function bindTranslate($rootScope) {
        return {
            restrict: 'A',
            compile: function (elem, attrs) {
                /*var text=attrs.ngBindHtml;
                text=text.trim()+"_"+$rootScope.languageSelected+" || "+text;
                attrs.ngBindHtml=text;*/
            }
        };
    }

    /** @ngInject */
    function mdAutocompleteTranslate($rootScope) {
        return {
            restrict: 'A',
            compile: function (elem, attrs) {
                /*
                //Hay que cambiar el atributo mdItemText que es lo que se muestra una vez seleccionado
                // y además hay que traducir las opciones posibles
                var text=attrs.mdItemText;
                // Compruebo que este atributo no sea una función, en el caso de que lo sea debemos controlar
                // la traduccion en la misma función que le pasamos como parámetro.
                // Puedes ver un ejemplo en index.run.js en la función "$rootScope.getFullName()"
                if(text.charAt(text.length-1)!==')'){
                    text=text.trim()+"_"+$rootScope.languageSelected+" || "+text;
                    attrs.mdItemText=text;
                }

                //Una vez cambiado el atributo cambios las opciones
                text=$(elem).find("span[md-highlight-text]").text();

                var arrText=text.split("}}");

                text="";
                for(var i=0; i<arrText.length-1; i++){
                    var t=arrText[i];
                    t=t.replace("{{","");
                    t=t.replace("}}","");
                    text+=" {{"+t.trim()+"_"+$rootScope.languageSelected+" || "+t.trim()+" }}";
                }

                $(elem).find("span[md-highlight-text]").text(text);
                */

            }
        };
    }
})(window, angular);

(function () {
    'use strict';

    angular
        .module('app.utils.directives')
        .controller('ErrorMessagesController', ErrorMessagesController)
        .directive('errorMessages', errorMessagesDirective);

    /** @ngInject */
    function ErrorMessagesController($attrs, $scope, $timeout, gettextCatalog) {
        var vm = this;
        vm.messages = [];
        vm.serverMessages = [];

        init();

        function init() {
            // Atributo required
            if (angular.isDefined($attrs.required)) {
                vm.messages.push({
                    type: ['required'],
                    message: gettextCatalog.getString('Este campo es obligatorio')
                });
            }

            if (angular.isDefined($attrs.mdRequireMatch)) {
                vm.messages.push({
                    type: ['md-require-match'],
                    message: gettextCatalog.getString('Debe seleccionar una opción de la lista')
                });
            }

            if (angular.isDefined($attrs.url)){
                vm.messages.push({
                    type: ['url'],
                    message: gettextCatalog.getString("La dirección web debe ser de la forma http://...")
                });
            }

            // Atributo pattern
            if (angular.isDefined($attrs.pattern)) {
                vm.messages.push({
                    type: ['pattern'],
                    message: gettextCatalog.getString($attrs.pattern)
                });
            }

            // Atributo match-password
            if (angular.isDefined($attrs.passwordMatch)) {
                vm.messages.push({
                    type: ['passwordMatch'],
                    message: gettextCatalog.getString("Las contraseñas no coinciden")
                });
            }

            // Atributo match-password
            if (angular.isDefined($attrs.unique)) {
                vm.messages.push({
                    type: ['unique'],
                    message: gettextCatalog.getString("El email indicado ya existe")
                });
            }
        }

        function getValueObject(obj,keys) {
            var o=obj;
            for(var i in keys){
                o=o[keys[i]];
                if(!o){
                    return false;
                }
            }
            return o[0];
        }

        $scope.$watch("ErrorMessages.errors", function () {
            vm.serverMessages.length = 0;
            if(vm.field && vm.field.$name && vm.errors){
                var parents=vm.field.$name.split("___");
                var message=getValueObject(vm.errors,parents);

                if(message){
                    vm.serverMessages.push(message);
                    vm.field.$setTouched();
                    vm.field.$setValidity("serverError", false);
                    if (angular.isDefined($attrs.forcechange)) {
                        $scope.$watch(
                            function () {
                                return vm.field.$modelValue;
                            },
                            function (newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    // Si el valor ha cambiado, elimina el error del servidor
                                    vm.field.$setValidity("serverError", true);
                                }
                            }
                        );

                        // $timeout(function(){
                        //     vm.field.$setValidity("serverError", true);
                        // },6000);
                    }
                }
            }
        });

        // $scope.$watch("ErrorMessages.errors", function () {
        //     vm.serverMessages.length = 0;
        //     angular.forEach(vm.errors, function (messageList, field) {
        //         if (vm.field && vm.field.$name === field) {
        //             angular.forEach(messageList, function (message) {
        //                 vm.serverMessages.push(message);
        //                 vm.field.$setTouched();
        //                 vm.field.$setValidity("serverError", false);
        //                 if (angular.isDefined($attrs.forcechange)) {
        //                     $timeout(function(){
        //                         vm.field.$setValidity("serverError", true);
        //                     },6000);
        //                 }
        //             });
        //         }
        //     }, true);
        // });

    }

    /** @ngInject */
    function errorMessagesDirective($timeout) {
        return {
            restrict: 'E',
            scope: {},
            replace: true,
            bindToController: {
                field: '=field',
                errors: '=serverErrors'
            },
            controller: 'ErrorMessagesController as ErrorMessages',
            template: '<div ng-messages="ErrorMessages.field.$error" ng-show="ErrorMessages.field.$touched || ErrorMessages.serverMessages.length > 0" role="alert"><div ng-hide="ErrorMessages.serverMessages.length > 0" ng-repeat="message in ErrorMessages.messages" ng-message-exp="message.type"><span>{{message.message}}</span></div><div ng-repeat="message in ErrorMessages.serverMessages" ng-message="serverError" class="has-animate"><span>{{message}}</span></div></div>',
            link: function (scope, iElement) {
                $timeout(function(){
                    var animate=$(iElement).find(".has-animate");
                    if(animate){
                        if(!animate.hasClass("ng-animate")){
                            animate.addClass("ng-animate");
                        }
                    }
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.utils.debounce', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.utils.debounce')
        .factory("DebounceService", DebounceService);


    /** @ngInject */
    function DebounceService ( $timeout, $rootScope ) {

        return debounce;

        /////////////

        /**
         * Muestra un mensaje simple de error
         */
        function debounce (callback, interval) {
            var timeout = null;
            return function(o,n) {
                //solo aplicamos esto si realmente cambian los filtros
                if(o!==n){
                    $rootScope.loadingProgress = true;
                    $timeout.cancel(timeout);
                    timeout = $timeout(function () {
                        callback.apply(this, arguments).then(function(){
                            $rootScope.loadingProgress = false;
                        });
                    }, interval);
                }
            };
        }
    }

})();

(function ()
{
    'use strict';
    angular
        .module('app.tutorsextracurriculars')
        .controller('TutorsextracurricularsController', TutorsextracurricularsController);
    /** @ngInject */
    function TutorsextracurricularsController($scope, currentUser, tutorsextracurricularsService, Tutorsextracurriculars, NotifyService, $mdDialog, $document,
                              SearchsBasics, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.tutorsextracurriculars=Tutorsextracurriculars;
        vm.searchsBasics=SearchsBasics;

        // Watchers
        $scope.$watch('vm.tutorsextracurriculars.filters', DebounceService(tutorsextracurricularsService.getTutorsextracurriculars, 300), true);

        // Methods
        vm.openTeachersDegreeDialog = openTeachersDegreeDialog;
        vm.removeTutor = removeTutor;
        vm.search = search;

        //////////
        /**
         * Abre el dialogo para crear un titulación
         *
         * @param ev
         * @param teachersDegree
         */
        function openTeachersDegreeDialog(ev, teachersDegree) {
            $mdDialog.show({
                controller: 'TeachersDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersDegree/teachersDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: {},
                    event: ev,
                    TeachersDegree: teachersDegree
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una tutor
         *
         * @param ev
         * @param tutor
         */
        function removeTutor(ev, tutor) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula')+' "'+tutor.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                tutorsextracurricularsService.removeTutor(tutor).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la cláusula. " + (error.data.detail || ""));
                });
            });

        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.tutorsextracurriculars.filtersAdvances=form;
            vm.tutorsextracurriculars.filters={};
            vm.tutorsextracurriculars.filters.page=1;
            return tutorsextracurricularsService.getTutorsextracurriculars();
        }



    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.tutorscurriculars')
        .controller('TutorscurricularsController', TutorscurricularsController);
    /** @ngInject */
    function TutorscurricularsController($scope, currentUser, tutorscurricularsService, Tutorscurriculars, NotifyService, $mdDialog, $document,
                              SearchsBasics, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.tutorscurriculars=Tutorscurriculars;
        vm.searchsBasics=SearchsBasics;

        // Watchers
        $scope.$watch('vm.tutorscurriculars.filters', DebounceService(tutorscurricularsService.getTutorscurriculars, 300), true);

        // Methods
        vm.openTeachersDegreeDialog = openTeachersDegreeDialog;
        vm.removeTutor = removeTutor;
        vm.search = search;

        //////////
        /**
         * Abre el dialogo para crear un titulación
         *
         * @param ev
         * @param teachersDegree
         */
        function openTeachersDegreeDialog(ev, teachersDegree) {
            $mdDialog.show({
                controller: 'TeachersDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersDegree/teachersDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: {},
                    event: ev,
                    TeachersDegree: teachersDegree
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una tutor
         *
         * @param ev
         * @param tutor
         */
        function removeTutor(ev, tutor) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula')+' "'+tutor.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                tutorscurricularsService.removeTutor(tutor).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la cláusula. " + (error.data.detail || ""));
                });
            });

        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.tutorscurriculars.filtersAdvances=form;
            vm.tutorscurriculars.filters={};
            vm.tutorscurriculars.filters.page=1;
            return tutorscurricularsService.getTutorscurriculars();
        }



    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.tutors')
        .controller('TutorsController', TutorsController);
    /** @ngInject */
    function TutorsController($scope, currentUser, tutorsService, Tutors, NotifyService, $mdDialog, $document,
                              SearchsBasics, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.tutors=Tutors;
        vm.searchsBasics=SearchsBasics;

        // Watchers
        $scope.$watch('vm.tutors.filters', DebounceService(tutorsService.getTutors, 300), true);

        // Methods
        vm.openTeachersDegreeDialog = openTeachersDegreeDialog;
        vm.removeTutor = removeTutor;
        vm.search = search;

        //////////
        /**
         * Abre el dialogo para crear un titulación
         *
         * @param ev
         * @param teachersDegree
         */
        function openTeachersDegreeDialog(ev, teachersDegree) {
            $mdDialog.show({
                controller: 'TeachersDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersDegree/teachersDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: {},
                    event: ev,
                    TeachersDegree: teachersDegree
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una tutor
         *
         * @param ev
         * @param tutor
         */
        function removeTutor(ev, tutor) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula')+' "'+tutor.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                tutorsService.removeTutor(tutor).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la cláusula. " + (error.data.detail || ""));
                });
            });

        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.tutors.filtersAdvances=form;
            vm.tutors.filters={};
            vm.tutors.filters.page=1;
            return tutorsService.getTutors();
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.skills')
        .controller('SkillsController', SkillsController);
    /** @ngInject */
    function SkillsController($scope, currentUser, skillsService, Skills, SkillsTypes, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.skills=Skills;
        vm.skillsTypes = SkillsTypes;

        // Watchers
        $scope.$watch('vm.skills.filters', DebounceService(skillsService.getSkills, 300), true);

        // Methods
        vm.openSkillDialog = openSkillDialog;
        vm.removeSkill = removeSkill;

        //////////
        /**
         * Abre el dialogo para crear/editar una skill
         *
         * @param ev
         * @param skill
         */
        function openSkillDialog(ev, skill) {
            $mdDialog.show({
                controller: 'SkillDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/skills/dialogs/skill/skill-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Skill:skill,
                    SkillsTypes:SkillsTypes,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una skill
         *
         * @param ev
         * @param skill
         */
        function removeSkill(ev, skill) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar competencia')+' "'+skill.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la competencia?'))
                .ariaLabel(gettextCatalog.getString('Eliminar competencia'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar competencia'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                skillsService.removeSkill(skill).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Competencia borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la competencia. " + (error.data.detail || ""));
                });
            });

        }



    }
})();
(function () {
    'use strict';

    angular
        .module('app.sendsAdvances')
        .controller('SendsAdvancesController', SendsAdvancesController);

    /** @ngInject */
    function SendsAdvancesController(Receivers, sendsAdvancesService, Module, searchsAdvancesService, NotifyService, $state, gettextCatalog) {

        var vm = this;

        //data
        vm.taToolbar = [
            ['bold', 'italics', 'underline', 'ul', 'ol', 'insertLink', 'redo', 'undo', 'clear']
        ];

        vm.mail={};
        vm.receivers = Receivers;

        var config=searchsAdvancesService.getConfig(Module);

        // Methods
        vm.sendMail = sendMail;

        //////////
        /**
         * Envio email
         */
        function sendMail() {
            var filters=config.service[config.param].filtersAdvances;
            var form=angular.copy(vm.mail);
            form.filters=filters;

            return sendsAdvancesService.sendMail(Module,form).then(function(){
                NotifyService.successMessage(gettextCatalog.getString("Email enviado correctamente"));
                $state.go(config.state);
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error al enviar el email. ") + (error.data.non_field_errors || ""));
            });
        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.searchsAdvances')
        .controller('SearchsAdvancesController', SearchsAdvancesController);
    /** @ngInject */
    function SearchsAdvancesController(currentUser, $state, SearchsAdvances, Module, $mdDialog, $document,
                                       reportsService, searchsAdvancesService, $timeout)
    {
        var vm = this;
        // Data
        vm.searchTabs = [{}];
        vm.user = currentUser;
        vm.searchsAdvances=SearchsAdvances;

        var config=searchsAdvancesService.getConfig(Module);

        init();

        // Methods
        vm.addSearch = addSearch;
        vm.closeSearch = closeSearch;
        vm.search = search;
        vm.openReportDialog = openReportDialog;

        //////////

        //inicializamos los campos de búsqueda
        function init(){
            var form=[];
            var filters=config.service[config.param].filtersAdvances;
            for(var i in filters){
                form.push({});
                for(var j in filters[i]){
                    var arr=j.split("__");
                    var option=arr[arr.length-1];
                     //borramos el ultimo elemento que era el que indicaba el option
                    arr.pop();
                    //ahora que tenemos solo el campo field_name volvemos a unir el array
                    var field_name=arr.join("__");
                    form[i][field_name]={};
                    form[i][field_name].option=option;
                    var value=filters[i][j];
                    if(option==='range'){
                        //comprobamos si es una fecha
                        if(moment(value[0], "YYYY-MM-DD", true).isValid()){
                            value[0]=new Date(moment(value[0]).format());
                            value[1]=new Date(moment(value[1]).format());
                        }
                        form[i][field_name].value=value[0];
                        form[i][field_name].value_range=value[1];
                    }else{
                        //comprobamos si es una fecha
                        if(moment(value, "YYYY-MM-DD", true).isValid()){
                            value=new Date(moment(value).format());
                        }
                        form[i][field_name].value=value;
                    }
                }
            }
            if(form.length<1){
                form = [{}];
            }
            vm.searchTabs=form;
        }

        /*
        * Añade otro filtro a la busqueda, esto se traduce a un OR con respecto a los otros filtros
        * */
        function addSearch(){
            vm.searchTabs.push({});
            vm.selectedFilter = vm.searchTabs.length -1;
        }

        function search(){
            var form=[];
            for(var i in vm.searchTabs){
                form.push({});
                for(var j in vm.searchTabs[i]){
                    var value=angular.copy(vm.searchTabs[i][j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.searchTabs[i][j].option==='range'){
                            var value_range=angular.copy(vm.searchTabs[i][j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[i][j + "__" + vm.searchTabs[i][j].option] = [value,value_range];
                        }else {
                            form[i][j + "__" + vm.searchTabs[i][j].option] = value;
                        }
                    }
                }
            }
            config.service[config.param].filtersAdvances=form;
            $state.go(config.state);
        }

        function closeSearch(index){
            vm.searchTabs.splice(index,1);
        }

        /**
         * Abre el dialogo para crear/editar una report
         *
         * @param ev
         */
        function openReportDialog(ev) {
            var form=[];
            for(var i in vm.searchTabs){
                form.push({});
                for(var j in vm.searchTabs[i]){
                    var value=angular.copy(vm.searchTabs[i][j].value);
                    if(value){
                        if(typeof value === 'object'){
                            //es una fecha
                            value=moment(value).format("YYYY-MM-DD");
                        }
                        if(vm.searchTabs[i][j].option==='range'){
                            var value_range=angular.copy(vm.searchTabs[i][j].value_range);
                            if(typeof value_range === 'object'){
                                //es una fecha
                                value_range=moment(value_range).format("YYYY-MM-DD");
                            }
                            form[i][j + "__" + vm.searchTabs[i][j].option] = [value,value_range];
                        }else {
                            form[i][j + "__" + vm.searchTabs[i][j].option] = value;
                        }
                    }
                }
            }

            var data={
                filters:form,
                variables:[]
            };

            var report=reportsService.getEmptyReport(data,Module);

            $mdDialog.show({
                controller: 'ReportDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reports/dialogs/report/report-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Report:report,
                    SearchsAdvances:SearchsAdvances,
                    event: ev
                }
            });
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances')
        .filter('filterOptions', filterOptions)
        .filter('filterOptionsIcons', filterOptionsIcons);

    function filterOptions(gettextCatalog) {
        return function(option) {
            var o={
              'exact':gettextCatalog.getString('Igual a (Distingue mayúsculas)'),
              'iexact':gettextCatalog.getString('Igual a'),
              'contains':gettextCatalog.getString('Contiene (Distingue mayúsculas)'),
              'icontains':gettextCatalog.getString('Contiene'),
              'lte':gettextCatalog.getString('Menor o igual a'),
              'gte':gettextCatalog.getString('Mayor o igual a'),
              'range':gettextCatalog.getString('Rango')
            };
            if(o[option]){
                return o[option];
            }
            return option;
        };
    }
    
    function filterOptionsIcons() {
        return function(option) {
            var o={
              'exact':"=",
              'iexact':"=",
              'contains':"<>",
              'icontains':"<>",
              'lte':"<=",
              'gte':">=",
              'range':"[x,y]"
            };
            if(o[option]){
                return o[option];
            }
            return option;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.searchsAdvances')
        .directive('filterDependsOn', filterDependsOnDirective);

    /**
     * Dependencia declarativa entre filtros del framework genérico de búsquedas.
     *
     * Se aplica al contenedor de un filtro en las plantillas genéricas (barra básica y búsqueda avanzada) y
     * lee la declaración `depends_on` que sirve el backend en get_filter_fields:
     *   {field: <filtro dominante>, value: <valor serializado requerido>}
     *
     * - Oculta el control mientras el filtro dominante no tenga el valor requerido.
     * - Limpia el valor del filtro dependiente cuando la condición deja de cumplirse (también al montar
     *   la plantilla con valores rehidratados), de modo que los controladores, que construyen la búsqueda
     *   leyendo el mismo objeto de valores, nunca envían un valor huérfano.
     *
     * Sin `depends_on` la directiva no hace nada: los listados sin dependencias no cambian.
     *
     * Atributos:
     *   filter-depends-on        expresión con la declaración `depends_on` del campo
     *   filter-depends-on-field  expresión con el `field_name` del campo dependiente
     *   filter-depends-on-values expresión con el objeto de valores del contexto
     *                            (vm.filterBasic en la barra, `filter` en cada pestaña de la avanzada)
     *
     * @ngInject
     */
    function filterDependsOnDirective() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var dependsOn = scope.$eval(attrs.filterDependsOn);
                if (!dependsOn || !dependsOn.field) {
                    return;
                }
                var fieldName = scope.$eval(attrs.filterDependsOnField);
                var requiredValue = String(dependsOn.value);

                function values() {
                    return scope.$eval(attrs.filterDependsOnValues);
                }

                function dominantValue() {
                    var current = values();
                    var dominant = current && current[dependsOn.field];
                    return dominant ? dominant.value : undefined;
                }

                function isSatisfied() {
                    var value = dominantValue();
                    return value !== undefined && value !== null && value !== '' && String(value) === requiredValue;
                }

                function clearDependent() {
                    var current = values();
                    var dependent = current && fieldName && current[fieldName];
                    if (dependent) {
                        dependent.value = undefined;
                        dependent.value_range = undefined;
                    }
                }

                scope.$watch(dominantValue, function () {
                    var satisfied = isSatisfied();
                    element.toggleClass('ng-hide', !satisfied);
                    if (!satisfied) {
                        clearDependent();
                    }
                });
            }
        };
    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.reports')
        .controller('ReportsController', ReportsController);
    /** @ngInject */
    function ReportsController($scope, currentUser, reportsService, Reports, NotifyService, $mdDialog, $document,
                               $state, searchsAdvancesService, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.reports=Reports;

        // Watchers
        $scope.$watch('vm.reports.filters', DebounceService(reportsService.getReports, 300), true);

        // Methods
        vm.openReportDialog = openReportDialog;
        vm.removeReport = removeReport;
        vm.search = search;

        //////////

        function search(ev, report, action){
            var config=searchsAdvancesService.getConfig(report.endpoint);
            var data=JSON.parse(report.data);
            config.service[config.param].filtersAdvances=data.filters;
            config.service[config.param].exportFields=data.exportFields;

            if(data.variables.length){
                //Pedimos las variables que cambian
                openSearchsAdvanceDialog(ev, report, action);
            }else{
                //No cambia ninguna variable, lo enviamos directamente
                if(action==="export"){
                    $state.go("app.export",{module:report.endpoint});
                }else{
                    $state.go(config.state);
                }
            }
        }

        /**
         * Abre el dialogo para crear/editar una report
         *
         * @param ev
         * @param report
         */
        function openReportDialog(ev, report) {
            $mdDialog.show({
                controller: 'ReportDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reports/dialogs/report/report-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Report:report,
                    SearchsAdvances:searchsAdvancesService.getSearchsAdvances(report.endpoint),
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una report
         *
         * @param ev
         * @param report
         */
        function removeReport(ev, report) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar informe')+' "'+report.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el informe?'))
                .ariaLabel(gettextCatalog.getString('Eliminar informe'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar informe'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                reportsService.removeReport(report).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Informe borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el informe. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Abre el dialogo completar la busqueda del informe con los campos que son variables
         *
         * @param ev
         * @param report
         * @param action
         */
        function openSearchsAdvanceDialog(ev, report, action) {
            $mdDialog.show({
                controller: 'SearchsAdvanceDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/searchsAdvances/dialogs/searchsAdvance/searchsAdvance-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Report:report,
                    Action:action,
                    SearchsAdvances:searchsAdvancesService.getSearchsAdvances(report.endpoint),
                    event: ev
                }
            });
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.pyconfrests')
        .controller('PyconfrestsController', PyconfrestsController);
    /** @ngInject */
    function PyconfrestsController(Categories, Pyconfrests, cloneAcademicYearsService, $stateParams, $mdDialog, $document,
                                   $state, $mdSidenav, CloneAcademicYear, NotifyService, $q, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.pyconfrests=Pyconfrests;
        vm.categories=Categories;
        vm.category=$stateParams.category;
        vm.cloneAcademicYear=CloneAcademicYear;

        // Methods
        vm.changeYear = changeYear;
        vm.selectCategory = selectCategory;
        vm.openPyconfrestDialog = openPyconfrestDialog;
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Clona las demandas,horararios y ofertas del nuevo curso academico
         */
        function changeYear() {
            var deferred = $q.defer();

            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Avanzar año académico'))
                .textContent(gettextCatalog.getString('¿Seguro que quieres cambiar el año académico? Los cambios no se podrán revertir'))
                .ariaLabel(gettextCatalog.getString('Avanzar año académico'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Avanzar año académico'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                var obj={run:true};
                cloneAcademicYearsService.saveCloneAcademicYear(obj).then(function(res){
                    deferred.resolve(res);
                    vm.cloneAcademicYear=false;
                    NotifyService.successMessage(gettextCatalog.getString("Año académico avanzado correctamente."));
                },function (error) {
                    deferred.reject(error);
                    NotifyService.errorMessage(gettextCatalog.getString("Error al avanzar año académico. ") + (error.data.msg || ""));
                });
            },function () {
                deferred.resolve(false);
            });

            return deferred.promise;
        }

        /**
         * Muestra las variables de una categoria
         *
         * @param category
         */
        function selectCategory(category) {
            $state.go("app.pyconfrests",{"category":category.pk});
        }
        
        /**
         * Abre el dialogo para crear/editar una pyconfrest
         *
         * @param ev
         * @param pyconfrest
         * @param key
         */
        function openPyconfrestDialog(ev, pyconfrest ,key) {
            pyconfrest.key=key;
            pyconfrest.id=$stateParams.category;
            $mdDialog.show({
                controller: 'PyconfrestDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/pyconfrests/dialogs/pyconfrest/pyconfrest-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Pyconfrest:pyconfrest,
                    event: ev
                }
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.programs')
        .controller('ProgramsController', ProgramsController);
    /** @ngInject */
    function ProgramsController($scope, currentUser, programsService, Programs, NotifyService, $mdDialog, $document,
                                programManagersService, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.programs=Programs;
        vm.now=moment(new Date()).format("YYYY-MM-DD");

        // Watchers
        $scope.$watch('vm.programs.filters', DebounceService(programsService.getPrograms, 300), true);

        // Methods
        vm.openProgramDialog = openProgramDialog;
        vm.openProgramXlsDialog = openProgramXlsDialog;
        vm.removeProgram = removeProgram;
        vm.isActive = isActive;
        vm.openProgramManagerDialog = openProgramManagerDialog;

        //////////
        /**
         * Abre el dialogo para crear/editar una program
         *
         * @param ev
         * @param program
         */
        function openProgramDialog(ev, program) {
            $mdDialog.show({
                controller: 'ProgramDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/programs/dialogs/program/program-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Program:program,
                    event: ev
                }
            });
        }

        /**
         * Abre el dialogo para crear/editar una program
         *
         * @param ev
         * @param program
         * @param type
         */
        function openProgramXlsDialog(ev, program, type) {
            $mdDialog.show({
                controller: 'ProgramXlsDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/programs/dialogs/programXls/programXls-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Program:program,
                    type:type,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una program
         *
         * @param ev
         * @param program
         */
        function removeProgram(ev, program) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar programa')+' "'+program.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar el programa?'))
                .ariaLabel(gettextCatalog.getString('Eliminar programa'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar programa'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                programsService.removeProgram(program).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Programa borrado correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar el programa. " + (error.data.detail || ""));
                });
            });

        }

        /**
         * Indica si el programa está activo
         *
         * @param program
         */
        function isActive(program){
            return (moment(program.end_date).format("YYYY-MM-DD")>=vm.now);
        }


        /**
         * Abre el dialogo para crear/editar un gestor de programa
         *
         * @param ev
         * @param program
         */
        function openProgramManagerDialog(ev, program) {
            programManagersService.programManagers.filters={};
            programManagersService.programManagers.filters.page="all";
            programManagersService.programManagers.filters.program__id=program.id;
            $mdDialog.show({
                controller: 'ProgramManagerDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/programs/dialogs/programManagers/programManagers-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Program:program,
                    ProgramManagers:programManagersService.getProgramManagers(),
                    event: ev
                }
            });
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.offersTemplates')
        .controller('OffersTemplatesController', OffersTemplatesController);
    /** @ngInject */
    function OffersTemplatesController($scope, currentUser, Offer, offersTemplatesService, OffersTemplates, $rootScope,
                                      $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.offer = Offer;
        vm.offersTemplates=OffersTemplates;

        // Watchers
        $scope.$watch('vm.offersTemplates.filters', DebounceService(offersTemplatesService.getOffersTemplates, 300), true);

        // Methods
        vm.openOffersStudentDialog = openOffersStudentDialog;

        //////////
        /**
         * Abre la ficha de un alumno con relación a la oferta
         *
         * @param ev
         * @param offersStudent
         */
        function openOffersStudentDialog(ev, offersStudent) {
            if($rootScope.hasPermission('offersTemplates','PATCH')) {
                $mdDialog.show({
                    controller: 'OffersStudentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/offersTemplates/dialogs/offersStudent/offersStudent-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        OffersStudent: offersStudent,
                        event: ev
                    }
                });
            }
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.offersRequests')
        .controller('OffersRequestsController', OffersRequestsController);
    /** @ngInject */
    function OffersRequestsController($scope, currentUser, Offer, offersRequestsService, OffersRequests, $rootScope,
                                      $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.offer = Offer;
        vm.offersRequests=OffersRequests;

        // Watchers
        $scope.$watch('vm.offersRequests.filters', DebounceService(offersRequestsService.getOffersRequests, 300), true);

        // Methods
        vm.openOffersStudentDialog = openOffersStudentDialog;

        //////////
        /**
         * Abre la ficha de un alumno con relación a la oferta
         *
         * @param ev
         * @param offersStudent
         */
        function openOffersStudentDialog(ev, offersStudent) {
            if($rootScope.hasPermission('offersRequests','PATCH') || $rootScope.hasPermission('confirmRequest','POST')) {
                $mdDialog.show({
                    controller: 'OffersStudentDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/offersRequests/dialogs/offersStudent/offersStudent-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        OffersStudent: offersStudent,
                        event: ev
                    }
                });
            }
        }



    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notifications')
        .controller('NotificationsController', NotificationsController);

    /** @ngInject */
    function NotificationsController($scope, $mdMedia, $state, currentUser, Categories, eventsService,
                            Notifications, notificationsService, DebounceService, gettextCatalog)
    {
        var vm = this;

        // Data
        vm.user=currentUser;
        vm.threads=Notifications;
        vm.categories=Categories.data;
        vm.events=[];

        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.loadingThreads = true;

        vm.currentFilter =$state.params.filter;

        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/notifications/views/classic/classic-view.html',
            outlook: 'app/main/notifications/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';
        // vm.defaultView = 'classic';
        // vm.currentView = 'classic';

        // Watchers
        $scope.$watch('vm.threads.filters', DebounceService(notificationsService.getNotifications, 300), true);

        // Methods
        vm.openThread = openThread;
        vm.changeView = changeView;
        vm.changeCategory = changeCategory;
        vm.toggleImportant = toggleImportant;
        vm.filterFiles = filterFiles;
        vm.closeThread = closeThread;
        //////////

        $scope.$watch('vm.threads.data', function(){
            vm.currentFilter =  $state.params.filter;

            // Open the thread if needed
            if ( $state.params.threadId )
            {
                for ( var i = 0; i < vm.threads.data.length; i++ )
                {
                    if ( vm.threads.data[i].id == $state.params.threadId)
                    {
                        vm.openThread(vm.threads.data[i]);
                        break;
                    }
                }
            }
        }, true);


        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });


        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread)
        {
            // Assign thread as the current thread
            vm.currentThread = thread;

            notificationsService.getNotification(thread.id).then(function(){
                if(!thread.is_read){
                    notificationsService.notifications.unread_messages--;
                }
                thread.is_read=true;
            });

            // Update the state without reloading the controller
            $state.go('app.notifications.detail', {threadId: thread.id}, {notify:false});
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function toggleImportant(thread)
        {
            notificationsService.toggleImportant(thread.id).then(function(response){
                thread.is_important=response.is_important;
            });
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Close thread
         */
        function closeThread()
        {
            vm.currentThread = null;
            // Update the state without reloading the controller
            $state.go('app.notifications', {}, {notify:false});
        }

        function changeCategory(){
            return eventsService.getEvents(vm.threads.filters.notification__event_notification__event__category_id).then(function(response){
                vm.events=response.data;
            });
        }

        function filterFiles(file){
            if (file && file.document) {
                return true;
            } else {
                return false;
            }
        }

    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.managerDegrees')
        .controller('ManagerDegreesController', ManagerDegreesController);
    /** @ngInject */
    function ManagerDegreesController($scope, currentUser, managerDegreesService, ManagerDegrees, NotifyService, $mdDialog, $document,
                              DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.managerDegrees=ManagerDegrees;

        // Watchers
        $scope.$watch('vm.managerDegrees.filters', DebounceService(managerDegreesService.getManagerDegrees, 300), true);

        // Methods
        vm.openManagerDegreeDialog = openManagerDegreeDialog;

        //////////
        /**
         * Abre el dialogo para crear un titulación
         *
         * @param ev
         * @param managerDegree
         */
        function openManagerDegreeDialog(ev, managerDegree) {
            $mdDialog.show({
                controller: 'ManagerDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/managerDegrees/dialogs/managerDegree/managerDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: {},
                    event: ev,
                    ManagerDegree: managerDegree
                }
            });
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.impersonates')
        .controller('ImpersonatesController', ImpersonatesController);
    /** @ngInject */
    function ImpersonatesController($rootScope, authSettings, currentUser, impersonatesService, NotifyService,
                                    $timeout, localStorageService, AuthService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.form={};

        // Methods
        vm.loginImpersonate=loginImpersonate;

        //////////
        
        /**
         * Login impersonate
         */
        function loginImpersonate() {
            var obj={
                id:vm.form.identification
            };
            return impersonatesService.getImpersonate(vm.form.identification).then(function(response){
                NotifyService.successMessage(gettextCatalog.getString("Login simulado correcto"));

                localStorageService.set('tokenImpersonate', localStorageService.get('token'));
                localStorageService.set('token', response.token);

                AuthService.checkStatus().then(function(){
                    $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, response);
                    $timeout(function(){
                        location.reload();
                    },500);
                });
            }, function(error){
                vm.serverErrors = error.data;
                NotifyService.errorMessage(gettextCatalog.getString("Error. ") + (error.data.detail || ""));
            });
        }
        


    }
})();
(function () {
    'use strict';

    angular
        .module('app.home',
            [

            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        // State
        $stateProvider.state('app.home', {
            url      : '/home',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.home': {
                    templateUrl: 'app/main/home/home.html',
                    controller : 'HomeController as vm'
                }
            },
            bodyClass: 'todo'
        });


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.home')
        .controller('HomeController', HomeController);
    /** @ngInject */
    function HomeController()
    {
        var vm = this;
        // Data


        // Methods


        //////////




    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.gadesDegrees')
        .controller('GadesDegreesController', GadesDegreesController);
    /** @ngInject */
    function GadesDegreesController($scope, gadesDegreesService, GadesDegrees,
                               NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.gadesDegrees=GadesDegrees;

        // Methods
        vm.openGadesDegreeDialog = openGadesDegreeDialog;
        vm.removeGadesDegree = removeGadesDegree;

        // Watchers
        $scope.$watch('vm.gadesDegrees.filters', DebounceService(gadesDegreesService.getGadesDegrees, 300), true);

        //////////
        /**
         * Abre el dialogo para crear/editar una gadesDegree
         *
         * @param ev
         * @param gadesDegree
         */
        function openGadesDegreeDialog(ev, gadesDegree) {
            $mdDialog.show({
                controller: 'GadesDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/gadesDegrees/dialogs/gadesDegree/gadesDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    GadesDegree:gadesDegree,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una titulación
         *
         * @param ev
         * @param gadesDegree
         */
        function removeGadesDegree(ev, gadesDegree) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar titulación')+' "'+gadesDegree.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la titulación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar titulación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar titulación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                gadesDegreesService.removeGadesDegree(gadesDegree).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Titulación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage(gettextCatalog.getString("Error al borrar la titulación. ") + (error.data.detail || "") + (error.data.error || ""));
                });
            });
        }


    }
})();
(function () {
    'use strict';

    angular
        .module('app.export')
        .controller('ExportController', ExportController);

    /** @ngInject */
    function ExportController(Fields, exportService, Module, searchsAdvancesService, reportsService, NotifyService,
                              downloadService, $document, $mdDialog, gettextCatalog, $timeout, $state) {
        var vm = this;

        // Data
        var config=searchsAdvancesService.getConfig(Module);
        init();
        vm.fields = Fields;

        var table = null;

        var columns = [];
        var data = [];
        // Ids de las filas listadas (el endpoint de export siempre incluye id):
        // en Cotizaciones se usan para marcar como descargado lo exportado
        var rowIds = [];

        // Methods
        vm.generateTable = generateTable;
        vm.back = back;
        vm.backToModule = backToModule;
        vm.selectAllColumns = selectAllColumns;
        vm.noColumnSelected = noColumnSelected;
        vm.openReportDialog = openReportDialog;

        //////////
        function generateTable() {
            vm.showTable = true;
            columns = [];
            data = [];
            composeColumns();
            //pasar parámetros haciendo peticion
            var form=config.service[config.param].filtersAdvances;
            var extraParams=config.service[config.param].extraParams;
            var fields=generateExportFields(Fields);

            exportService.getDatatable(Module,fields,form,extraParams).then(function(data){
                rowIds = (data.data || []).map(function (row) { return row.id; });
                composeData(data);
                initDatatables();
            }, function(){
                composeData([]);
                initDatatables();
                NotifyService.errorMessage(gettextCatalog.getString("Error al generar la exportación. "));
            });
        }

        function back(){
            vm.showTable = false;
            table.destroy();
            config.service[config.param].exportFields={};
            $('#data').empty();
        }

        /**
         * Vuelve a la pantalla del módulo desde el que se abrió la exportación
         * (p. ej. Seguridad Social > Cotizaciones tras «Ver listado»).
         */
        function backToModule(){
            $state.go(config.state, config.params || {});
        }

        /**
         * Botones del datatable. El Excel de DataTables es la vía de descarga
         * de todos los módulos; en Cotizaciones, tras generar el fichero se
         * marcan en servidor las filas listadas como descargadas (las ya
         * descargadas conservan su fecha) y se recarga el listado.
         */
        function composeButtons() {
            var excelButton = {extend: 'excel', text: 'Excel', title: 'informe-' + Module};
            if (Module === 'Cotizaciones') {
                excelButton.action = function (e, dt, node, buttonConfig) {
                    $.fn.dataTable.ext.buttons.excelHtml5.action.call(this, e, dt, node, buttonConfig);
                    downloadService.markQuotesDownloaded(rowIds).then(refreshTable, function () {
                        NotifyService.errorMessage(gettextCatalog.getString(
                            "El Excel se ha generado pero no se pudieron marcar las cotizaciones como descargadas. Recargue el listado y descargue de nuevo."));
                    });
                };
            }
            return [
                {extend: 'copy', text: 'Copiar al portapapeles'},
                excelButton
            ];
        }

        /**
         * Regenera el datatable con los mismos parámetros de consulta (tras
         * marcar descargas, para que se vean las fechas recién estampadas).
         */
        function refreshTable() {
            if (table) {
                table.destroy();
                $('#data').empty();
            }
            generateTable();
        }

        function selectAllColumns(){
            angular.forEach(vm.fields, function(f){
                f.enabled = true;
            });
        }

        function noColumnSelected(){
            var unselected = true;
            angular.forEach(vm.fields, function(f){
                if (f.enabled){
                    unselected = false;
                }
            });
            return unselected;
        }

        function composeColumns() {
            angular.forEach(Fields, function (field) {
                if (field.enabled) {
                    columns.push({title: field.title});
                }
            });
        }

        function composeData(Data) {
            angular.forEach(Data.data, function (row) {
                var r = [];
                angular.forEach(Fields, function (field) {
                    if (field.enabled){
                        if (field.render) {
                            r.push(field.render(row));
                        } else {
                            if (row[field.name]!==null){
                                r.push(row[field.name]);
                            } else {
                                r.push("-");
                            }
                        }
                    }
                });
                data.push(r);
            });
        }

        function initDatatables() {
            table = $('#data').DataTable({
                data: data,
                order: [],
                searching: false,
                lengthChange: false,
                dom: 'Bfrtip',
                sFileName: 'informe-universidad-de-cadiz',
                buttons: composeButtons(),
                columns: columns,
                language: {
                    "sProcessing":     "Procesando...",
                    "sLengthMenu":     "Mostrar _MENU_ registros",
                    "sZeroRecords":    "No se encontraron resultados",
                    "sEmptyTable":     "Ningún dato disponible en esta tabla",
                    "sInfo":           "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty":      "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "sInfoFiltered":   "(filtrado de un total de _MAX_ registros)",
                    "sInfoPostFix":    "",
                    "sSearch":         "Buscar:",
                    "sUrl":            "",
                    "sInfoThousands":  ",",
                    "sLoadingRecords": "Cargando...",
                    "oPaginate": {
                        "sFirst":    "Primero",
                        "sLast":     "Último",
                        "sNext":     "Siguiente",
                        "sPrevious": "Anterior"
                    },
                    "oAria": {
                        "sSortAscending":  ": Activar para ordenar la columna de manera ascendente",
                        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
                    }
                }
            });
        }

        /**
         * Abre el dialogo para crear/editar una report
         *
         * @param ev
         */
        function openReportDialog(ev) {
            var fields=generateExportFields(Fields);

            var data={
                filters:config.service[config.param].filtersAdvances,
                variables:[],
                exportFields:fields
            };

            var report=reportsService.getEmptyReport(data,Module);

            $mdDialog.show({
                controller: 'ReportDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/reports/dialogs/report/report-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Report:report,
                    SearchsAdvances:searchsAdvancesService.getSearchsAdvances(Module),
                    event: ev
                }
            });
        }

        function init(){
            var fields=config.service[config.param].exportFields || {};
            angular.forEach(Fields, function (field) {
                if(fields[field.name]){
                    field.enabled=true;
                    field.customFilters={};

                    for(var j in fields[field.name]){
                        field.showConfig=true;

                        var arr=j.split("__");
                        var option=arr[arr.length-1];
                         //borramos el ultimo elemento que era el que indicaba el option
                        arr.pop();
                        //ahora que tenemos solo el campo field_name volvemos a unir el array
                        var field_name=arr.join("__");
                        field.customFilters[field_name]={};
                        field.customFilters[field_name].option=option;

                        var value=fields[field.name][j];
                        if(option==='range'){
                            //comprobamos si es una fecha
                            if(moment(value[0], "YYYY-MM-DD", true).isValid()){
                                value[0]=new Date(moment(value[0]).format());
                                value[1]=new Date(moment(value[1]).format());
                            }
                            field.customFilters[field_name].value=value[0];
                            field.customFilters[field_name].value_range=value[1];
                        }else{
                            //comprobamos si es una fecha
                            if(moment(value, "YYYY-MM-DD", true).isValid()){
                                value=new Date(moment(value).format());
                            }
                            field.customFilters[field_name].value=value;
                        }
                    }
                }
            });
            if(config.service[config.param].exportFields && Object.keys(config.service[config.param].exportFields).length>0){
                $timeout(function(){
                    generateTable();
                });
            }
        }


        function generateExportFields(Fields){
            var fields={};
            angular.forEach(Fields, function (field) {
                if (field.enabled) {
                    fields[field.name]={};

                    if(field.filters){
                        for(var j in field.customFilters){
                            var value=angular.copy(field.customFilters[j].value);
                            if(value){
                                if(typeof value === 'object'){
                                    //es una fecha
                                    value=moment(value).format("YYYY-MM-DD");
                                }
                                if(field.customFilters[j].option==='range'){
                                    var value_range=angular.copy(field.customFilters[j].value_range);
                                    if(typeof value_range === 'object'){
                                        //es una fecha
                                        value_range=moment(value_range).format("YYYY-MM-DD");
                                    }
                                    fields[field.name][j + "__" + field.customFilters[j].option] = [value,value_range];
                                }else {
                                    fields[field.name][j + "__" + field.customFilters[j].option] = value;
                                }
                            }
                        }
                    }

                }
            });
            return fields;
        }


    }
})();

(function ()
{
    'use strict';
    angular
        .module('app.events')
        .controller('EventsController', EventsController);
    /** @ngInject */
    function EventsController(Categories, Events, $stateParams, $state, $mdSidenav)
    {
        var vm = this;
        // Data
        vm.events=Events;
        vm.categories=Categories;
        vm.category=$stateParams.category;

        // Methods
        vm.selectCategory = selectCategory;
        vm.toggleSidenav = toggleSidenav;

        //////////


        /**
         * Muestra los eventos de una categoria
         *
         * @param category
         */
        function selectCategory(category) {
            $state.go("app.events",{"category":category.id});

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.eventNotifications')
        .controller('EventNotificationsController', EventNotificationsController);
    /** @ngInject */
    function EventNotificationsController($scope, Event, Parameters, eventNotificationsService, EventNotifications, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.eventNotifications=EventNotifications;
        vm.event=Event;

        // Watchers
        $scope.$watch('vm.eventNotifications.filters', DebounceService(eventNotificationsService.getEventNotifications, 300), true);

        // Methods
        vm.openEventNotificationDialog = openEventNotificationDialog;
        vm.removeEventNotification = removeEventNotification;

        //////////
        /**
         * Abre el dialogo para crear/editar una eventNotification
         *
         * @param ev
         * @param eventNotification
         */
        function openEventNotificationDialog(ev, eventNotification) {
            var id=(eventNotification)? eventNotification.id:null;
            return eventNotificationsService.getEventNotification(id).then(function(response){
                $mdDialog.show({
                    controller: 'EventNotificationDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/eventNotifications/dialogs/eventNotification/eventNotification-dialog.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        EventNotification:response,
                        Parameters:Parameters,
                        Event:Event,
                        event: ev
                    }
                });
            })
        }
        
        /**
         * Abre el dialogo para eliminar una eventNotification
         *
         * @param ev
         * @param eventNotification
         */
        function removeEventNotification(ev, eventNotification) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar notificación')+' "'+eventNotification.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la notificación?'))
                .ariaLabel(gettextCatalog.getString('Eliminar notificación'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar notificación'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                eventNotificationsService.removeEventNotification(eventNotification).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Notificación borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la notificación. " + (error.data.detail || ""));
                });
            });

        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);
    /** @ngInject */
    function DashboardController($scope, dashboardService, NotifyService, $mdDialog, $document)
    {
        var vm = this;
        // Data
        //vm.user = currentUser;

        // Methods
        vm.openFansDialog = openFansDialog;

        //////////

        /**
         * Abre el dialogo con los fans que te siguen
         *
         * @param ev
         */
        function openFansDialog(ev) {
            $mdDialog.show({

                controller: 'FansDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/dashboard/dialogs/fans/fans-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Fans:[],
                    event: ev
                }
            });
        }


    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.coordinators')
        .controller('CoordinatorsController', CoordinatorsController);
    /** @ngInject */
    function CoordinatorsController($scope, currentUser, coordinatorsService, Coordinators, NotifyService, $mdDialog, $document,
                              SearchsBasics, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.coordinators=Coordinators;
        vm.searchsBasics=SearchsBasics;

        // Watchers
        $scope.$watch('vm.coordinators.filters', DebounceService(coordinatorsService.getCoordinators, 300), true);

        // Methods
        vm.openTeachersDegreeDialog = openTeachersDegreeDialog;
        vm.removeCoordinator = removeCoordinator;
        vm.search = search;

        //////////

        /**
         * Abre el dialogo para coordinar una titulación
         *
         * @param ev
         * @param teachersCoordinatorDegree
         */
        function openTeachersDegreeDialog(ev, teachersCoordinatorDegree) {
            $mdDialog.show({
                controller: 'TeachersCoordinatorDegreeDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/teachers/dialogs/teachersCoordinatorDegree/teachersCoordinatorDegree-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Teacher: {},
                    event: ev,
                    TeachersCoordinatorDegree: teachersCoordinatorDegree
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una coordinator
         *
         * @param ev
         * @param coordinator
         */
        function removeCoordinator(ev, coordinator) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula')+' "'+coordinator.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                coordinatorsService.removeCoordinator(coordinator).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la cláusula. " + (error.data.detail || ""));
                });
            });

        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.coordinators.filtersAdvances=form;
            vm.coordinators.filters={};
            vm.coordinators.filters.page=1;
            return coordinatorsService.getCoordinators();
        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.conditionsTemplates')
        .controller('ConditionsTemplatesController', ConditionsTemplatesController);
    /** @ngInject */
    function ConditionsTemplatesController($scope, currentUser, conditionsTemplatesService, ConditionsTemplates, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.conditionsTemplates=ConditionsTemplates;

        // Watchers
        $scope.$watch('vm.conditionsTemplates.filters', DebounceService(conditionsTemplatesService.getConditionsTemplates, 300), true);

        // Methods
        vm.openConditionsTemplateDialog = openConditionsTemplateDialog;
        vm.removeConditionsTemplate = removeConditionsTemplate;

        //////////
        /**
         * Abre el dialogo para crear/editar una conditionsTemplate
         *
         * @param ev
         * @param conditionsTemplate
         */
        function openConditionsTemplateDialog(ev, conditionsTemplate) {
            $mdDialog.show({
                controller: 'ConditionsTemplateDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/conditionsTemplates/dialogs/conditionsTemplate/conditionsTemplate-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    ConditionsTemplate:conditionsTemplate,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una conditionsTemplate
         *
         * @param ev
         * @param conditionsTemplate
         */
        function removeConditionsTemplate(ev, conditionsTemplate) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar cláusula')+' "'+conditionsTemplate.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la cláusula?'))
                .ariaLabel(gettextCatalog.getString('Eliminar cláusula'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar cláusula'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                conditionsTemplatesService.removeConditionsTemplate(conditionsTemplate).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Cláusula borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la cláusula. " + (error.data.detail || ""));
                });
            });

        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.activities')
        .controller('ActivitiesController', ActivitiesController);
    /** @ngInject */
    function ActivitiesController($scope, currentUser, activitiesService, Activities, NotifyService, $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser.active_profile_data;
        vm.activities=Activities;

        // Watchers
        $scope.$watch('vm.activities.filters', DebounceService(activitiesService.getActivities, 300), true);

        // Methods
        vm.openActivityDialog = openActivityDialog;
        vm.removeActivity = removeActivity;

        //////////
        /**
         * Abre el dialogo para crear/editar una activity
         *
         * @param ev
         * @param activity
         */
        function openActivityDialog(ev, activity) {
            $mdDialog.show({
                controller: 'ActivityDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/activities/dialogs/activity/activity-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Activity:activity,
                    event: ev
                }
            });
        }
        
        /**
         * Abre el dialogo para eliminar una activity
         *
         * @param ev
         * @param activity
         */
        function removeActivity(ev, activity) {
            var confirm = $mdDialog.confirm()
                .title(gettextCatalog.getString('Eliminar actividad')+' "'+activity.name+'"')
                .textContent(gettextCatalog.getString('¿Seguro que quieres eliminar la actividad?'))
                .ariaLabel(gettextCatalog.getString('Eliminar actividad'))
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .ok(gettextCatalog.getString('Borrar actividad'))
                .cancel(gettextCatalog.getString('Cancelar'));

            $mdDialog.show(confirm).then(function() {
                activitiesService.removeActivity(activity).then(function(){
                    NotifyService.successMessage(gettextCatalog.getString("Actividad borrada correctamente."));
                }, function(error){
                    NotifyService.errorMessage("Error al borrar la actividad. " + (error.data.detail || ""));
                });
            });

        }



    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.actionloggings')
        .controller('ActionloggingsController', ActionloggingsController);
    /** @ngInject */
    function ActionloggingsController($scope, currentUser, actionloggingsService, Actionloggings, SearchsBasics,
                                      $mdDialog, $document, DebounceService, gettextCatalog)
    {
        var vm = this;
        // Data
        vm.user = currentUser;
        vm.actionloggings=Actionloggings;
        vm.searchsBasics=SearchsBasics;

        // Watchers
        $scope.$watch('vm.actionloggings.filters', DebounceService(actionloggingsService.getActionloggings, 300), true);

        // Methods
        vm.openActionloggingDialog = openActionloggingDialog;
        vm.search = search;

        //////////
        /**
         * Abre el dialogo detalle de una acción
         *
         * @param ev
         * @param actionlogging
         */
        function openActionloggingDialog(ev, actionlogging) {
            $mdDialog.show({
                controller: 'ActionloggingDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/actionloggings/dialogs/actionlogging/actionlogging-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    Actionlogging:actionloggingsService.getActionlogging(actionlogging.id),
                    event: ev
                }
            });
        }

        function search(){
            var form=[{}];
            for(var j in vm.filterBasic){
                var value=angular.copy(vm.filterBasic[j].value);
                if(value){
                    if(typeof value === 'object'){
                        //es una fecha
                        value=moment(value).format("YYYY-MM-DD");
                    }
                    if(vm.filterBasic[j].option==='range'){
                        var value_range=angular.copy(vm.filterBasic[j].value_range);
                        if(typeof value_range === 'object'){
                            //es una fecha
                            value_range=moment(value_range).format("YYYY-MM-DD");
                        }
                        form[0][j+"__"+vm.filterBasic[j].option] = [value,value_range];
                    }else {
                        form[0][j+"__"+vm.filterBasic[j].option]=value;
                    }
                }
            }

            vm.actionloggings.filtersAdvances=form;
            vm.actionloggings.filters={};
            vm.actionloggings.filters.page=1;
            return actionloggingsService.getActionloggings();
        }



    }
})();

if (document.all && !window.setTimeout.isPolyfill) {
	var __nativeST__ = window.setTimeout;
	window.setTimeout = function (vCallback, nDelay /*, argumentToPass1, argumentToPass2, etc. */) {
		var aArgs = Array.prototype.slice.call(arguments, 2);
		return __nativeST__(vCallback instanceof Function ? function () {
			vCallback.apply(null, aArgs);
		} : vCallback, nDelay);
	};
	window.setTimeout.isPolyfill = true;
}

var originalXMLHttpRequest = window.XMLHttpRequest;

var MiniApplet = ( function ( window, undefined ) {

		var VERSION = "1.5";

		var JAR_NAME = 'miniapplet-full_1_5.jar';

		var JAVA_ARGUMENTS = '-Xms512M -Xmx512M ';

		var SYSTEM_PROPERTIES = null;

		var clienteFirma = null;

		var codeBase = null;

		var storageServletAddress = null;

		var retrieverServletAddress = null;

		var jnlpServiceAddress = "";

		var clientType = null;

		var severeTimeDelay = false;

		var selectedLocale = null;
		
		var stickySignatory = false;

		var LOCALIZED_STRINGS = new Array();
		LOCALIZED_STRINGS["es_ES"] = {
				checktime_warn: "Se ha detectado un desfase horario entre su sistema y el servidor. Se recomienda que se corrija antes de pulsar Aceptar para continuar.",
				checktime_err: "Se ha detectado un desfase horario entre su sistema y el servidor. Debe corregir la hora de su sistema antes de continuar.",
				checktime_local_time: "Hora de su sistema",
				checktime_server_time: "Hora del servidor"
		};
		LOCALIZED_STRINGS["gl_ES"] = {
				checktime_warn: "Destectouse un desfase horario entre o seu sistema e o servidor. Recoméndase corrixilo antes de pulsar Aceptar para continuar.",
				checktime_err: "Destectouse un desfase horario entre o seu sistema e o servidor. Debe corrixir a hora do seu sistema antes de continuar.",
				checktime_local_time: "Hora do seu sistema",
				checktime_server_time: "Hora do servidor"
		};

		var DEFAULT_LOCALE = LOCALIZED_STRINGS["es_ES"];

		var currentLocale = DEFAULT_LOCALE;

		var defaultKeyStore = null;

		/* ------------------------------------------------ */
		/* Constantes para la operacion interna del Cliente */
		/* ------------------------------------------------ */

		/* Tamano del buffer con el que se pasa informacion al applet */
		var BUFFER_SIZE = 2 * 1024 * 1024;

		/* Cadena que determina el fin de una respuesta */
		var EOF = "%%EOF%%";

		/* Identifica que se utilizara el MiniApplet. */
		var TYPE_APPLET = "APPLET";

		/* Identifica que se utilizara una aplicacion nativa de firma. */
		var TYPE_JAVASCRIPT_WEB_SERVICE = "JAVASCRIPT_WEB_SERVICE";
		var TYPE_JAVASCRIPT_SOCKET = "JAVASCRIPT_SOCKET";

		/* --------------------------------- */
		/* Constantes publicas		         */
		/* --------------------------------- */

		/* Almacenes de certificados */

		var KEYSTORE_WINDOWS = "WINDOWS";

		var KEYSTORE_APPLE = "APPLE";

		var KEYSTORE_PKCS12 = "PKCS12";

		var KEYSTORE_PKCS11 = "PKCS11";

		var KEYSTORE_MOZILLA = "MOZ_UNI";

		var KEYSTORE_SHARED_NSS = "SHARED_NSS";

		var KEYSTORE_JAVA = "JAVA";

		var KEYSTORE_JCEKS = "JCEKS";

		var KEYSTORE_JAVACE = "JAVACE";

		var KEYSTORE_DNIE = "DNIEJAVA";

		/* Valores para la configuracion de la comprobacion de tiempo */

		var CHECKTIME_NO = "CT_NO";

		var CHECKTIME_RECOMMENDED = "CT_RECOMMENDED";

		var CHECKTIME_OBLIGATORY = "CT_OBLIGATORY";

		// Tiempo de espera entre los intentos de conexion con autofirma por socket
		var AUTOFIRMA_LAUNCHING_TIME = 2000;

		// Reintentos de conexion totales para detectar que esta instalado AutoFirma por socket
		var AUTOFIRMA_CONNECTION_RETRIES = 15;

		// Variable que se puede configurar para forzar el uso del modo de comunicacion por servidor intermedio
		// entre la pagina web y AutoFirma
		var forceWSMode = false;

		// Variable que se puede configurar para forzar el uso de la aplicacion
		// nativa instalada a traves del protocolo afirma://
		var forceAFirma = false;

		// Variable que devuelve si funciona el modo JNLP
		var bJNLP = true;	
																	 
		/* ------------------------------------ */
		/* Funciones de comprobacion de entorno */
		/* ------------------------------------ */

		/**
		 * Determina con un boolean si nuestro cliente es Android
		 */
		function isAndroid() {
			return navigator.userAgent.toUpperCase().indexOf("ANDROID") != -1 ||
				navigator.appVersion.toUpperCase().indexOf("ANDROID") != -1 ||
				// Para la deteccion de los Kindle Fire
				navigator.userAgent.toUpperCase().indexOf("SILK/") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("KFJWI") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("KFJWA") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("KFTT") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("KFOT") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("KINDLE FIRE") != -1
				;
		}

		/**
		 * Determina con un boolean si nuestro cliente es iOS.
		 */
		function isIOS() {
			return (navigator.userAgent.toUpperCase().indexOf("IPAD") != -1) ||
			(navigator.userAgent.toUpperCase().indexOf("IPOD") != -1) ||
			(navigator.userAgent.toUpperCase().indexOf("IPHONE") != -1);
		}

		/** Determina con un boolean si nos encontramos en Windows 8/8.1 */
		function isWindows8() {
			return navigator.userAgent.indexOf("Windows NT 6.2") != -1 ||	/* Windows 8 */
				navigator.userAgent.indexOf("Windows NT 6.3") != -1;		/* Windows 8.1 */
		}

		/** Determina con un boolean si nos encontramos en Windows RT */
		function isWindowsRT() {
			return isWindows8() && navigator.userAgent.indexOf("ARM;") != -1;
		}

		/** Determina con un boolean si nos encontramos en un sistema Linux. */
		function isLinux() {
			return getOSName() == "linux";
		}

		/**
		 * Identifica el sistema operativo del usuario para notificarselo al servicio
		 * de generacion del fichero de despliegue JNLP.
		 * @returns Codigo del sistema operativo o "unknown" si no se conoce.
		 */
		function getOSName() {
			var osName="unknown";
			if (navigator.appVersion.indexOf("Win")!=-1) osName="windows";
			if (navigator.appVersion.indexOf("Mac")!=-1) osName="mac";
			if (navigator.appVersion.indexOf("Linux")!=-1) osName="linux";
			return osName;
		}

		/** Determina con un boolean si estamos en Internet Explorer */
		function isInternetExplorer() {
			return !!(navigator.userAgent.match(/MSIE/))	/* Internet Explorer 10 o inferior */
					|| !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv:11/)) /* Internet Explorer 11 o superior (Opcion 1) */
					|| !!navigator.userAgent.match(/Trident.*rv[ :]*11\./); /* Internet Explorer 11 o superior (Opcion 2) */
		}

		/** Indica si el navegador es Internet Explorer 10 o inferior. */
		function isOldInternetExplorer() {
			return !!(navigator.userAgent.match(/MSIE/));
		}

		function isFirefoxUAM() {
		    return navigator.userAgent.indexOf("UAM") > 0;
		}

		/**
		 * Determina con un boolean si se accede a la web con Firefox
		 */
		function isFirefox(){
			return navigator.userAgent.toUpperCase().indexOf("FIREFOX") != -1
		}

		/**
		 * Determina con un boolean si se accede a la web con Chrome
		 */
		function isChrome() {
			return navigator.userAgent.toUpperCase().indexOf("CHROME/") != -1 ||
				navigator.userAgent.toUpperCase().indexOf("CHROMIUM") != -1;
		}

		/**
		 * Determina con un boolean si se accede a la web con Safari 10. Esta version no
		 * funciona bien con la comunicacion con sockets de AutoFirma.
		 */
		function isSafari10() {
			navigator.sayswho= (function(){
			    var ua= navigator.userAgent, tem, 
			    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
			    if(/trident/i.test(M[1])){
			        tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
			        return 'IE '+(tem[1] || '');
			    }
			    if(M[1]=== 'Chrome'){
			        tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
			        if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
			    }
			    M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
			    if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
			    return M.join(' ');
			})();
			return navigator.sayswho == 'Safari 10';
		}

        /**
         * Determina con un boolean si el navegador es Microsoft Edge
         */
        function isEdge() {
        	return !!navigator.userAgent.match(/Edge\/\d+/);
        }

        /**
         * Informa si el usuario necesitar&aacute; instalar AutoFirma para
         * completar el proceso de firma.
         */
        function needNativeAppInstalled() {
        	return forceAFirma || isLinux() || isFirefox() || isAndroid() || isIOS();
        }

        /**
         * Determina con un boolean si se ejecuta mediante JNLP
         */
        function isJNLP() {
        	return bJNLP;
        }

		/** Indica si el navegador detecta Java. Este valor no es completamente fiable, ya que
		 * Internet Explorer siempre indica que si esta activado. */
		function isJavaEnabled() {
			return navigator.javaEnabled();
		}

		/** Comprueba si una cadena de texto es una URL (http/https). La alternativa implicaria ser un Base64. */ 
		function isValidUrl(data) { 
			return data != null && data.length > "https://".length &&
				("http:" == data.substr(0, 5) || "https:" == data.substr(0, 6));
		}

		var downloadSuccessFunction = null;
		var downloadErrorFunction = null;
		var downloadTypeData = null;
		
		/**
		 * Realiza la descarga de datos de una URL y, una vez termina, llama al metodo
		 * successFunction pasandole los datos descargados en base 64, o errorFunction,
		 * si fallo en la descarga, al que se pasa el error que produjo el problema.
		 */
		function downloadRemoteData(url, successFunction, errorFunction) {
			
			downloadSuccessFunction = successFunction;
			downloadErrorFunction = errorFunction;
			
			var httpRequest = getHttpRequest();
			httpRequest.open("GET", url, true);
			
			// new browsers (XMLHttpRequest2-compliant)
			if ('responseType' in httpRequest && !!Uint8Array) {
				httpRequest.responseType = 'arraybuffer';
				downloadTypeData = 'arraybuffer';
			}
			// old browsers (XMLHttpRequest-compliant)
			else
				if ('overrideMimeType' in httpRequest) {
				httpRequest.overrideMimeType('text\/plain; charset=x-user-defined');
				downloadTypeData = 'string';
			}
			// IE9 (Microsoft.XMLHTTP-compliant)
			else {
				httpRequest.setRequestHeader('Accept-Charset', 'x-user-defined');
				downloadTypeData = 'bytearray';
			}
			
			// shim for onload for old IE
			if (!('onload' in httpRequest)) {
				httpRequest.onreadystatechange = function () {
					if (this.readyState === 4) {
						this.onload();
					}
				};
			}

			httpRequest.onload = function (evt) {
				if (httpRequest.readyState == 4 && httpRequest.status == 200) {
					if (downloadSuccessFunction) {

						// emulating response field for IE9
						if (!('response' in this)) {
							this.response = new VBArray(this.responseBody).toArray();
						}

						var b64;
						if (downloadTypeData == 'arraybuffer') {
							b64 = Base64.encodeArrayBuffer(this.response);
						}
						else if (downloadTypeData == 'bytearray') { 
							b64 = Base64.encodeByteArray(this.response);
						}
						else if (downloadTypeData == 'string') {
							b64 = Base64.encode(this.response);
						}
						else {
							this.onerror(new Error("No se conoce el modo usado para la descarga de los datos"));
						}
						downloadSuccessFunction(b64);
					}
//					else {
//						console.log("Se termino la descarga de los datos. No se invoca a ninguna funcion.");
//					}
				}
			}
			httpRequest.onerror = function(e) {
				if (downloadErrorFunction) {
					downloadErrorFunction(e);
				}
//				else {
//					console.log("Error en la descarga de los datos. No se invoca a ninguna funcion.");
//				}
			}
			httpRequest.send();
		}

		function getHttpRequest() {
            var xmlHttp = null;
            
        	/* Si se cargo Ajax, puede haber modificado el funcionamiento de la clase XMLHttpRequest,
        	 * asi que vemos si el propio Ajax (Sarissa) guarda la implementacion original; si no,
        	 * usamos la implementacion por defecto que la habremos guardado al principio del script
        	 * en la variable originalXMLHttpRequest. Es importante que se haya cargado este script
        	 * antes que el de Ajax o esta opcion no tendra resultado */
            if (typeof XMLHttpRequest != "undefined") {	// Navegadores actuales
                if (typeof Sarissa !== 'undefined' && Sarissa.originalXMLHttpRequest) {
                	xmlHttp = new Sarissa.originalXMLHttpRequest();
                } else {
                	xmlHttp = new originalXMLHttpRequest();
                }
            } else if (typeof window.ActiveXObject != "undefined") {	// Internet Explorer antiguos
                try {
                    xmlHttp = new ActiveXObject("Msxml2.XMLHTTP.4.0");
                } catch (e) {
                    try {
                        xmlHttp = new ActiveXObject("MSXML2.XMLHTTP");
                    } catch (e) {
                        try {
                            xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
                        } catch (e) {
                            xmlHttp = null;
                        }
                    }
                }
            }
            return xmlHttp;
		}

		/** Permite establecer que la comunicacion con AutoFirma sea a traves
		 * del servidor intermedio. */
		var setForceWSMode = function (force) {
			forceWSMode = force;
		}
		
		/** Permite establecer que la invocacion con AutoFirma sea a traves
		 * del protocolo afirma:// */
		var setForceAFirma = function (force) {
			forceAFirma = force;
		}

		/** Establece la direccion servicio para la generacion del JNLP de
		 * carga de AutoFirma. */
		var setJnlpService = function (jnlp){
			jnlpServiceAddress = jnlp;
		}

		/** Permite habilitar la comprobacion de la hora local contra la hora del servidor y
		 * establecer un tiempo maximo permitido y el comportamiento si se supera.
		 * Parametros:
		 *  - checkType:	Tipo de comprobacion. Admite los valores CT_NO, CT_RECOMMENDED y CT_OBLIGATORY.
		 *  - maxMillis:	Tiempo maximo de desfase en milisegundos.
		 *  - checkURL:		URL contra la que se realizara la peticion para obtener la hora. Si no se
		 *  				indica, se usara una pagina web aleatoria dentro del propio dominio.
		 * Cuando el HTML es local, no se realiza ningun tipo de comprobacion.
		 */
		var checkTime = function (checkType, maxMillis, checkURL) {
			try {

				if (checkType == undefined || checkType == null || checkType == CHECKTIME_NO
						|| maxMillis == undefined || maxMillis == null || maxMillis <= 0) {
					return;
				}

				// Si checkURL existe mandamos la peticion ahi, en caso contrario nos inventamos una url.
				var URL;
				if (checkURL) {
					URL = checkURL;
				}
				else {
					URL = document.URL + '/' + Math.random();
				}
				// Hacemos una llamada al servidor para conocer su hora
				var xhr = getHttpRequest(); 
				xhr.open('GET', URL, false); 
				xhr.send();
	
				// Recogemos la hora local, nada mas obtener la respuesta del servidor
				var clientDate = new Date();

				// Tomamos la hora a partir de la respuesta del servidor. Si esta es 0, estamos en local
				var serverDate = new Date(xhr.getResponseHeader("Date"));
				if (serverDate == null || serverDate.getTime() == 0) {
					// No hacemos nada si estamos en local 
					return;
				}
	
				// Evaluamos la desincronizacion 
				var delay =  Math.abs(clientDate.getTime() - serverDate.getTime());
				if (delay > maxMillis) {
					 if (checkType == CHECKTIME_RECOMMENDED) {
						 alert(currentLocale.checktime_warn +
								 "\n" + currentLocale.checktime_local_time + ": " + clientDate.toLocaleString() +
								 "\n" + currentLocale.checktime_server_time + ": " + serverDate.toLocaleString());
					 }
					 else if (checkType == CHECKTIME_OBLIGATORY) {
						 severeTimeDelay = true;
						 alert(currentLocale.checktime_err +
								 "\n" + currentLocale.checktime_local_time + ": " + clientDate.toLocaleString() +
								 "\n" + currentLocale.checktime_server_time + ": " + serverDate.toLocaleString());
					 }
				}
			}
			catch (e) {
				// No hacemos nada si estamos en local 
				//console.log("Error en la obtencion de la hora del servidor: " + e);
				return;
			}
		}
		/** Carga el MiniApplet. */
		var cargarMiniApplet = function (base, keystore) {

			// Antes que nada, comprobamos que no haya un desfase horario declarado como
			// grave.
			if (severeTimeDelay) {
				return;
			}

			// Sincronizamos las variables que puedan haberse establecido de forma externa
			// antes de la llamada al metodo de carga
			JAVA_ARGUMENTS = MiniApplet.JAVA_ARGUMENTS;
			SYSTEM_PROPERTIES = MiniApplet.SYSTEM_PROPERTIES;

			// Establecemos cual sera el keystore por defecto 
			defaultKeyStore = keystore;
			if (!defaultKeyStore) {
				defaultKeyStore = getDefaultKeystore();
			}

			// Configuramos los argumentos para la seleccion de almacen
			configureKeyStore();

			// Si estamos claramente en un sistema movil o que no permite la ejecucion de Java,
			// cargamos directamente el Cliente JavaScript
			if (isAndroid() || isIOS() || isWindowsRT() || isChrome() || isEdge()) {
				cargarAppAfirma(base, defaultKeyStore);
				return;
			}

			// Si estamos en un entorno que permite Java, comprobamos si esta disponible
			// y en caso de no estarlo, tambien cargamos el Cliente JavaScript.
			if (!isJavaEnabled()) {
				cargarAppAfirma(base, defaultKeyStore);
				return;
			}

			// Incluso si el navegador informa que hay Java, puede no haberlo (Internet Explorer
			// siempre dice que hay), asi que cargamos el applet, pero tenemos en cuenta que en
			// caso de error debemos cargar el cliente JavaScript
			codeBase = (base != undefined && base != null) ? base : './';

			var attributes = {
					'id': 'miniApplet',
					'name': 'MiniApplet @firma (Gobierno de Espa\u00F1a)',
					'type': 'application/x-java-applet',
					'width': 1,
					'height': 1
			};

			// Los argumentos de java no llegan al propio applet en las pruebas con Java 6 y 7,
			// asi que (salvo los argumentos de carga) vamos a pasarlos como un parametro mas al
			// applet para luego establecerlos internamente.
			var parameters = {
					'keystore': defaultKeyStore,
					'userAgent': window.navigator.userAgent,
					'archive': codeBase + '/' + JAR_NAME,
					'code': 'es.gob.afirma.miniapplet.MiniAfirmaApplet',
					'java-vm-args': JAVA_ARGUMENTS,
					'java_arguments': JAVA_ARGUMENTS,
					'system_properties': SYSTEM_PROPERTIES,
					'codebase_lookup': false,
					'separate_jvm': true,
					'locale': selectedLocale
			};

			loadMiniApplet(attributes, parameters);

			clienteFirma = document.getElementById("miniApplet");

			// Si no esta definido el cliente es porque se ha intentado cargar el applet
			// y no se ha podido, asi que se usara la aplicacion nativa
			if (clienteFirma == null) {
				cargarAppAfirma(codeBase, defaultKeyStore);
			}
		}

		/** Obtiene el nombre del almacen que corresponde al presente navegador o, si se debe acceder
		 * al almacen del sistema, se devuelve null. */
		function getDefaultKeystore() {
			if(isFirefox()){
				return KEYSTORE_MOZILLA;
			}
			return null;
		}
		
		/** Establece los parametros de configuracion para la correcta seleccion del almacen
		 * de claves que se debe cargar. */
		function configureKeyStore() {
			if (isFirefoxUAM()) {
				if (SYSTEM_PROPERTIES == null) {
					SYSTEM_PROPERTIES = "";
				}
				SYSTEM_PROPERTIES += " -Des.gob.afirma.keystores.mozilla.UseEnvironmentVariables=true ";
			}
		}

		/** Carga el MiniApplet. */
		var setKeyStore = function (ksType) {
			
			forceLoad();
			
			clienteFirma.setKeyStore(ksType != null ? ksType : defaultKeyStore);
			
			// Al haber cambiado el almacen, no tiene sentido que la variable sticky este a true
			setStickySignatory(false);
		}
		
		var selectCertificate = function (params, successCallback, errorCallback) {
			
			forceLoad();

			if (clientType == TYPE_APPLET) {
				try {
					var certificate = clienteFirma.selectCertificate(params);
					if (successCallback == undefined || successCallback == null) {
						return certificate;
					}
					successCallback(certificate);
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.selectCertificate(params, successCallback, errorCallback);
			}
		}
			
		var sign = function (dataB64, algorithm, format, params, successCallback, errorCallback) {

			forceLoad();
			
			if (clientType == TYPE_APPLET) {
				try {
					setData(dataB64);
					var certSignaturePair = buildData(clienteFirma.sign(algorithm, format, params));
					var sepPos = certSignaturePair.indexOf('|');
					if (successCallback == undefined || successCallback == null) {
						return certSignaturePair.substring(sepPos + 1);
					}
					successCallback(certSignaturePair.substring(sepPos + 1), certSignaturePair.substring(0, sepPos));
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.sign(dataB64, algorithm, format, params, successCallback, errorCallback);
			}
		}

		var coSign = function (signB64, dataB64, algorithm, format, params, successCallback, errorCallback) {

			forceLoad();

			if (clientType == TYPE_APPLET) {
				try {
					setData(signB64);
					var certSignaturePair = buildData(clienteFirma.coSign(dataB64, algorithm, format, params));
					var sepPos = certSignaturePair.indexOf('|');
					if (successCallback == undefined || successCallback == null) {
						return certSignaturePair.substring(sepPos + 1);
					}
					successCallback(certSignaturePair.substring(sepPos + 1), certSignaturePair.substring(0, sepPos));
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.coSign(signB64, dataB64, algorithm, format, params, successCallback, errorCallback);
			}
		}

		
		var counterSign = function (signB64, algorithm, format, params, successCallback, errorCallback) {

			forceLoad();

			if (clientType == TYPE_APPLET) {
				try {
					setData(signB64);
					var certSignaturePair = buildData(clienteFirma.counterSign(algorithm, format, params));
					var sepPos = certSignaturePair.indexOf('|');
					if (successCallback == undefined || successCallback == null) {
						return certSignaturePair.substring(sepPos + 1);
					}
					successCallback(certSignaturePair.substring(sepPos + 1), certSignaturePair.substring(0, sepPos));
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.counterSign(signB64, algorithm, format, params, successCallback, errorCallback);
			}
		}

		var signAndSaveToFile = function (operationId, dataB64, algorithm, format, params, outputFileName, successCallback, errorCallback) {
			
			forceLoad();
			
			if (clientType == TYPE_APPLET) {
				try {
					setData(dataB64);
					var certSignaturePair = buildData(clienteFirma.signAndSaveToFile(operationId, algorithm, format, params, outputFileName));
					var sepPos = certSignaturePair.indexOf('|');
					if (successCallback == undefined || successCallback == null) {
						return certSignaturePair.substring(sepPos + 1);
					}
					successCallback(certSignaturePair.substring(sepPos + 1), certSignaturePair.substring(0, sepPos));
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.signAndSaveToFile(operationId, dataB64, algorithm, format, params, outputFileName, successCallback, errorCallback);
			}
		}

		var signBatch = function (batchB64, batchPreSignerUrl, batchPostSignerUrl, params, successCallback, errorCallback) {

			forceLoad();

			if (clientType == TYPE_APPLET) {
				try {
					if (successCallback == undefined || successCallback == null) {
						return clienteFirma.signBatch(batchB64, batchPreSignerUrl, batchPostSignerUrl, params);
					}
					successCallback(clienteFirma.signBatch(batchB64, batchPreSignerUrl, batchPostSignerUrl, params));
				}
				catch (e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
					return;
				}
			}
			else {
				clienteFirma.signBatch(batchB64, batchPreSignerUrl, batchPostSignerUrl, params, successCallback, errorCallback);
			}
		}
		
		var getBase64FromText = function (plainText, charset) {
			forceLoad();
			return clienteFirma.getBase64FromText(plainText, charset);
		}

		var getTextFromBase64 = function (dataB64, charset) {
			forceLoad();
			return clienteFirma.getTextFromBase64(dataB64, charset);
		}

		var saveDataToFile = function (dataB64, title, fileName, extension, description, successCallback, errorCallback) {
			forceLoad();
			if (clientType == TYPE_APPLET) {
				setData(dataB64);
				return clienteFirma.saveDataToFile(title, fileName, extension, description);
			}
			else {
				clienteFirma.saveDataToFile(dataB64, title, fileName, extension, description, successCallback, errorCallback);
			}
		}

		/**
		 * Inicia el proceso de carga de un fichero.
		 * Implementada tambien en el applet Java de firma
		 * @param title Titulo de la ventana de dialogo
		 * @param extensions Extensiones permitidas
		 * @param description Descripcion del tipo de archivo a cargar
		 * @param filePath Ruta del archivo por defecto
		 * @param successCallback Funcion de callback tras exito
		 * @param errorCallback Funcion de callback tras error
		 */
		var getFileNameContentBase64 = function (title, extensions, description, filePath, successCallback, errorCallback) {
			forceLoad();
			
			if (clientType == TYPE_APPLET) {
				try {
					
					var filenameDataBase64Pair = buildData(clienteFirma.getFileNameContentBase64(title, extensions, description, filePath));
					var sepPos = filenameDataBase64Pair.indexOf('|');
					if (successCallback == undefined || successCallback == null) {
						return filenameDataBase64Pair.substring(sepPos + 1);
					}
					successCallback(filenameDataBase64Pair.substring(0, sepPos), filenameDataBase64Pair.substring(sepPos + 1));
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.getFileNameContentBase64(title, extensions, description, filePath, successCallback, errorCallback)
			}
			
		}

		/**
		 * Inicia el proceso de carga de uno o varios ficheros.
		 * Implementada tambien en el applet Java de firma
		 * @param title Titulo de la ventana de dialogo
		 * @param extensions Extensiones permitidas
		 * @param description Descripcion del tipo de archivo a cargar
		 * @param filePath Ruta del archivo por defecto
		 * @param successCallbackFunction Funcion de callback tras exito
		 * @param errorCallbackFunction Funcion de callback tras error
		 */
		var getMultiFileNameContentBase64 = function (title, extensions, description, filePath, successCallback, errorCallback) {
			forceLoad();
			
			if (clientType == TYPE_APPLET) {
				
				try {
					var filenameDataBase64Pairs = buildData(clienteFirma.getMultiFileNameContentBase64(title, extensions, description, filePath));
					if (successCallback == undefined || successCallback == null) {
						return filenameDataBase64Pairs;
					}

					var fileNameArray = new Array();
					var dataB64Array = new Array();
					for (i = 0; i < filenameDataBase64Pairs.length; i++) {
						var sepPos = filenameDataBase64Pairs[i].indexOf("|");
						if (sepPos == -1) {
							fileNameArray.push(filenameDataBase64Pairs[i]);
							dataB64Array.push("");
						}
						else {
							fileNameArray.push(filenameDataBase64Pairs[i].substring(0, sepPos));
							dataB64Array.push(filenameDataBase64Pairs[i].substring(sepPos + 1));
						}
					}
					successCallback(fileNameArray, dataB64Array);
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
				}
			}
			else {
				clienteFirma.getMultiFileNameContentBase64(title, extensions, description, filePath, successCallback, errorCallback)
			}
		}
		
		var getCurrentLog = function (successCallback, errorCallback) {
			forceLoad();
						
			if (clientType == TYPE_APPLET) {
				var log = " === JAVASCRIPT INFORMATION === " +
				"\nnavigator.appCodeName: " + navigator.appCodeName +
				"\nnavigator.appName: " +  navigator.appName +
				"\nnavigator.appVersion: " + navigator.appVersion +
				"\nnavigator.platform: " + navigator.platform +
				"\nnavigator.userAgent: " + navigator.userAgent+
				"\nnavigator.javaEnabled(): " + navigator.javaEnabled() +
				"\nscreen.width: " + (window.screen ? screen.width : 0) +
				"\nscreen.height: " + (window.screen ? screen.height : 0) +
				"\n\n   === CLIENTE LOG === \n";
				try {
					log += buildData(clienteFirma.getCurrentLog());
				} catch(e) {
					if (errorCallback == undefined || errorCallback == null) {
						throw e;
					}
					errorCallback(clienteFirma.getErrorType(), clienteFirma.getErrorMessage());
					return;
				}
				
				if (successCallback == undefined || successCallback == null) {
					return log;
				}
				successCallback(log);
			}
			else {
				clienteFirma.getCurrentLog(successCallback, errorCallback)
			}			
		
		}

		var echo = function () {
			forceLoad();
			return clienteFirma.echo();
		}

		/**
		 * Establece el valor de la variable "stickySignatory" que permite fijar
		 * un certicado seleccionado para futuras invocaciones, de modo que no
		 * sea necesario volver a seleccionarlo mientras el valor sea true o
		 * caduque la conexion en caso de invocacion por protocolo/socket
		 */
		var setStickySignatory = function(sticky) {
			forceLoad();
	
			if (clientType == TYPE_APPLET) {

				clienteFirma.setStickySignatory(sticky);
	
			} else {
				// En caso de no cargar el applet y utilizar autofirma, se
				// establecera la variable con el valor seleccionado para su
				// posterior uso en cada invocacion por protocolo
				stickySignatory = sticky;
			}

		}

		var setLocale = function (locale) {
			selectedLocale = locale;
			currentLocale = (locale == null || LOCALIZED_STRINGS[locale] == null ? DEFAULT_LOCALE : LOCALIZED_STRINGS[locale]); 
		}

		var getErrorMessage = function () {
			forceLoad();
			return clienteFirma.getErrorMessage();
		}

		var getErrorType = function () {
			forceLoad();
			return clienteFirma.getErrorType();
		}
		

		var setServlets = function (storageServlet,  retrieverServlet) {
			
			storageServletAddress = storageServlet;
			retrieverServletAddress = retrieverServlet;

			if (clienteFirma && clienteFirma.setServlets) {
				clienteFirma.setServlets(storageServlet,  retrieverServlet);
			}
		}

		/*************************************************************
		 *  FUNCIONES PARA EL DESPLIEGUE DEL APPLET					 *
		 **************************************************************/

		function loadMiniApplet(attributes, parameters) {
			// Internet Explorer se carga mediante un
			// elemento <object>. El resto con un <embed>.
			if (isInternetExplorer()) {
				
				var appletTag = "<object classid='clsid:8AD9C840-044E-11D1-B3E9-00805F499D93' width='" + attributes["width"] + "' height='" + attributes["height"] + "' id='" + attributes["id"] + "'>";

				if (attributes != undefined && attributes != null) {
					for (var attribute in attributes) {
						appletTag += "<param name='" + attribute + "' value='" + attributes[attribute] + "' />";
					}
				}

				if (parameters != undefined && parameters != null) {
					for (var parameter in parameters) {
						appletTag += "<param name='" + parameter + "' value='" + parameters[parameter] + "' />";
					}
				}

				appletTag += "</object>";

				// Al agregar estos nodos con append() no se carga automaticamente el applet en IE10 e inferiores, asi que
				// hay que usar document.write() o innerHTML. Para asegurarnos de no pisar HTML previo, crearemos un <div>
				// en la pagina, lo recogeremos e insertaremos dentro suyo el codigo del applet.
				var divElem = document.createElement("div");
				var idAtt = document.createAttribute("id");
				idAtt.value = 'divAfirmaApplet';
				divElem.setAttributeNode(idAtt);

				document.body.appendChild(divElem);
				
				document.getElementById("divAfirmaApplet").innerHTML = appletTag;
			}
			else {
				var embed = document.createElement("embed");

				if (attributes != undefined && attributes != null) {
					for (var attribute in attributes) {
						var att = document.createAttribute(attribute);
						att.value = attributes[attribute];
						try {
							embed.setAttributeNode(att);
						}
						catch (e) {
							// Probamos este como alternativa en caso de error. Caso detectado en:
							// - IE10 sin modo de compabilidad con el Document Mode de IE7.
							// - Firefox en Mac OS X
							// Este intento no soluciona el error, pero evita que se propague 
							embed.setAttribute(attribute, attributes[attribute]);
						}
					}
				}

				if (parameters != undefined && parameters != null) {
					for (var parameter in parameters) {
						var att = document.createAttribute(parameter);
						att.value = parameters[parameter];
						embed.setAttributeNode(att);
					}
				}

				document.body.appendChild(embed);
			}
		}
		
		/**
		 * Establece los datos que debera procesar el applet MiniApplet. 
		 */
		function forceLoad() {

			// Antes que nada, comprobamos que no haya un desfase horario declarado como
			// grave.
			if (severeTimeDelay) {
				return;
			}
			if (clientType == null || clientType == TYPE_JAVASCRIPT_WEB_SERVICE || clientType == TYPE_JAVASCRIPT_SOCKET ) {
				
				var tempCliente = document.getElementById("miniApplet");
				var appletLoaded;
				try {
					appletLoaded = tempCliente != null && tempCliente.echo() != "Cliente JavaScript"; 
				}
				catch (e) {
					appletLoaded = false;
				}
				if (appletLoaded) {
					clienteFirma = tempCliente;
					clientType = TYPE_APPLET;
				}
				else if (clientType == null) {
					// Inicializamos la carga de la aplicacion nativa, indicando que no se
					// haga una precarga con JNLP, ya que ahora estamos en medio de una operacion
					cargarAppAfirma(codeBase, defaultKeyStore, true);
				}
				setServlets(storageServletAddress, retrieverServletAddress);
			}
		}

		/**
		 * Establece los datos que debera procesar el applet MiniApplet. Los datos se le
		 * pasan al applet en fragmentos porque el JavaPlugin no permite recibir o enviar
		 * mas de 4Mb de datos de una sola vez desde JavaScript.
		 */
		function setData(dataB64) {

			if (dataB64 == null) {
				return;
			}
			else if (dataB64.length <= BUFFER_SIZE) {
				clienteFirma.addData(dataB64);	
			}
			else {
				clienteFirma.addData(dataB64.substring(0, BUFFER_SIZE));
				setData(dataB64.substring(BUFFER_SIZE));
			}
		}

		/**
		 * Construye el resultado de una funcion a partir de los trozos en la que esta los divide. 
		 */
		function buildData(dataB64) {
			var buffer = dataB64;
			var chunk = clienteFirma.getRemainingData();
			while(chunk != EOF) {
				buffer += chunk;
				chunk = clienteFirma.getRemainingData();
			}
			return buffer;
		}

		/**
		 * Abre una URL en el navegador.
		 * @param url URL que se desea abrir.
		 */
		function openUrl (url) {
			
			// Usamos el modo de invocacion mas apropiado segun el entorno
			if (isChrome() || isIOS()) {
				// Usamos document.location porque tiene mejor soporte por los navegadores que
				// window.location que es el mecanismo estandar
				document.location = url;
			}
			else {

				// Si ya existe el iframe, lo eliminamos para despues volverlo a crear 
				if (document.getElementById("iframeAfirma") != null) {
					try {
						var element = document.getElementById("iframeAfirma");
						element.outerHTML = "";
						delete element;
					}
					catch (e) {
						// No hacemos nada
					}
				}

				// En el caso de ser una version de internet Explorer que soportase la deteccion de aplicacion
				// capaces de manejar el protocolo, aprovechamos esta caracteristica (Internet Explorer para Windows 8 Modern UI)

				if (navigator.msLaunchUri) {
					navigator.msLaunchUri(
							url,
							null,
							function() {
								// Bloqueamos la conexion para evitar que se sigan haciendo comprobaciones
								wrongInstallation = true;
							}
					);
				}
				else {
					// Abrimos la URL por medio de un iframe
					openUrlWithIframe(url);
				}
			}
		}

		/**
		 * Llama a la aplicacion de firma por medio de un iframe.
		 * @param url URL de invocacion.
		 */
		function openUrlWithIframe (url) {
			var iframeElem = document.createElement("iframe");

			var idAttr = document.createAttribute("id");
			idAttr.value = "iframeAfirma";
			iframeElem.setAttributeNode(idAttr);

			var srcAttr = document.createAttribute("src");
			srcAttr.value = url;
			iframeElem.setAttributeNode(srcAttr);

			var heightAttr = document.createAttribute("height");
			heightAttr.value = 1;
			iframeElem.setAttributeNode(heightAttr);

			var widthAttr = document.createAttribute("width");
			widthAttr.value = 1;
			iframeElem.setAttributeNode(widthAttr);
			
			var styleAttr = document.createAttribute("style");
			styleAttr.value = "display: none;";
			iframeElem.setAttributeNode(styleAttr);

			document.body.appendChild(iframeElem);				
		}
		
		/**************************************************************
		 **************************************************************
		 **************************************************************
		 **************************************************************
		 *  FUNCIONES DEL CLIENTE JAVASCRIPT						  *
		 **************************************************************
		 **************************************************************
		 **************************************************************
		 **************************************************************/

		/**
		 * Establece el objeto que simula ser el Applet de firma en sistemas en los que no se
		 * soportan los applets. Se usara comunicacion mediante socket cuando:
		 *  - El sistema operativo no sea Android.
		 *  - El sistema operativo no sea iOS.
		 *  - El navegador web no sea Intenet Explorer 10 o inferior (o 11 con modo de compatibilidad)
		 *  - No se fuerce el uso del servidor intermedio.
		 * En caso contrario, la comunicacion se realizara mediante un servidor intermedio.
		 */
		function cargarAppAfirma(clientAddress, keystore, avoidJnlpLoad) {
			
			if (!keystore) {
				keystore = getDefaultKeystore();
			}
			
			if (!forceWSMode && !isIOS() && !isAndroid() && !isOldInternetExplorer() && !isEdge() && !isSafari10()){
				clienteFirma = new AppAfirmaJSSocket(clientAddress, window, undefined);
				clienteFirma.setKeyStore(keystore);
				clientType = TYPE_JAVASCRIPT_SOCKET;
			}
			else {
				clienteFirma = new AppAfirmaJSWebService(clientAddress, window, undefined);
				clienteFirma.setKeyStore(keystore);
				clientType = TYPE_JAVASCRIPT_WEB_SERVICE;
			}

			// Si se dan las condiciones que requieren el uso de la aplicacion nativa,
			// por entorno o porque se haya configurado para su uso, se intenta cargar
			// esta version
			if (!avoidJnlpLoad && !needNativeAppInstalled() && !!jnlpServiceAddress) {
				// Aplicamos un retardo en la carga de la aplicacion WebStart para dar tiempo a cargar la pagina
				var jnlpUrl = "jnlp" + jnlpServiceAddress.substring(4) + "?os=" + getOSName() + "&arg=" + Base64.encode("afirma://service?op=install", true);
				setTimeout(openUrl, 2000, jnlpUrl);
			}
		}

		var AppAfirmaJSSocket = ( function (clientAddress, window, undefined) {

			var UnsupportedOperationException = "java.lang.UnsupportedOperationException";

			/**
			 *  Atributos para la configuracion del objeto sustituto del applet Java de firma
			 */
			var errorMessage = '';
			var errorType = '';

			/** Puerto a traves del que se ha conectado con la aplicacion nativa. */
			var port = "";
			
			var idSession;
			
			var PROTOCOL_VERSION = 1;
			
			/* Tiempo de retardo para peticiones */
			var WAITING_TIME = 500;
			
			var URL_REQUEST = "https://127.0.0.1:";
			
			/* Respuesta del socket a la peticion realizada */
			var totalResponseRequest = "";
			
			/* Numero de fragmentos recibidos del socket */
			var recibidos = 0;
			
			/* Variable de control para la operacion seleccion de certificado */ 
			var isSelectCertOperation = false;
			
			/* Variable de control para la operacion guardar */
			var isSaveOperation = false;
			
			/* Variable de control para la operacion de ejecutar operacion criptografica y guardar */
			var isOpAndSaveOperation = false;
			
			/* Variable de control para la operacion batch */
			var isBatchOperation = false;
			
			/* URL de la peticion HTTPS */
			var urlHttpRequest = "";
			
			/* Maxima longitud permitida para una URL. Si la url se excede se divide
			 * la peticion en fragmentos. Con Internet Explorer y Firefox a partir de
			 * la version 49 se producen corrupciones de datos con el valor original
			 * de 1Mb, asi que se reduce este a un valor seguro para ese navegador. */
			var URL_MAX_SIZE = isInternetExplorer() ? 12000 : isFirefox() ? 458752 : 1048576;
			
			/* Indica si se ha establecido la conexion o no */
			var connection = false;
		
			/* Dominio desde el que se realiza la llamada al servicio */
			var baseUri = clientAddress;

			/* Almacen de claves cargado por defecto */
			var defaultKeyStore = null;

			/* Funcion callback que se lanza al obtener un resultado */ 
			var successCallback = null;
			
			/* Funcion error callback */
			var errorCallback = null;
			
			/* Mayor entero */
			var MAX_NUMBER = 2147483648;

			/* Caracteres validos para los ID de sesion */
			var VALID_CHARS_TO_ID = "1234567890abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

			/* Genera un identificador de sesion. */
			function generateNewIdSession () {
				var ID_LENGTH = 20;
				var random = "";
				var randomInts;
				if (typeof window.crypto != "undefined" && typeof window.crypto.getRandomValues != "undefined") {
					randomInts = new Uint32Array(ID_LENGTH);
					window.crypto.getRandomValues(randomInts);
				}
				else {
					randomInts = new Array(ID_LENGTH);
					for (var i = 0; i < ID_LENGTH; i++) {
						randomInts[i] = rnd() * MAX_NUMBER;
					}
				}

				for (var i = 0; i < ID_LENGTH; i++) {
					random += VALID_CHARS_TO_ID.charAt(Math.floor(randomInts[i] % VALID_CHARS_TO_ID.length));
				}

				return random;
			}
			
			/**
			 * Genera numeros aleatorios con una distribucion homogenea.
			 */
			var seed;
			function rnd () {
				if (seed == undefined) {
					seed = new Date().getMilliseconds() * 1000 * Math.random();
				}
			    seed = (seed * 9301 + 49297) % 233280;
			    return seed / 233280;
			}
			
			/**
			 * Establece el almacen de certificados de que se debe utilizar por defecto.
			 */
			function setKeyStore (keystore) {
				defaultKeyStore = keystore;
			}
			
			/**
			 * Inicia el proceso de seleccion de certificado.
			 */
			function selectCertificate (extraParams, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				selectCertByService(extraParams);
			}

			function selectCertByService (extraParams) {
				
				var data = new Object();
				data.op = generateDataKeyValue ("op", "selectcert");
				data.properties = generateDataKeyValue ("properties", extraParams != null ? Base64.encode(extraParams) : null);
				data.keystore = generateDataKeyValue ("keystore", defaultKeyStore != null ? defaultKeyStore : null);
				data.ksb64 = generateDataKeyValue ("ksb64", defaultKeyStore != null ? Base64.encode(defaultKeyStore) : null);
				data.sticky = generateDataKeyValue ("sticky", stickySignatory);
				
				execAppIntent(buildUrl(data));
			}
			
			/**
			 * Inicia el proceso de firma electronica.
			 * Implementada en el applet Java de firma
			 */
			function sign (dataB64, algorithm, format, extraParams, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				signByService("sign", dataB64, algorithm, format, extraParams);
			}

			/**
			 * Inicia el proceso de cofirma de una firma electr&oacute;nica. 
			 * Implementada en el applet Java de firma.
			 */
			function coSign (signB64, dataB64, algorithm, format, extraParams, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				signByService("cosign", signB64, algorithm, format, extraParams);
			}

			/**
			 * Inicia el proceso de contrafirma de una firma electr&oacute;nica.
			 * Implementada en el applet Java de firma. 
			 */
			function counterSign (signB64, algorithm, format, extraParams, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				signByService("countersign", signB64, algorithm, format, extraParams);
			}

			/**
			 * Realiza una operacion de firma/multifirma comunicandose con la aplicacion nativa por socket.
			 * @param signId Identificador de la operacion a realizar (sign, cosign y countersign).
			 * @param dataB64 Datos o firma en base 64.
			 * @param algorithm Algoritmo de firma.
			 * @param format Formato de firma.
			 * @param extraParams Par&aacute;metros para la configuraci&oacute;n de la operaci&oacute;n.
			 */
			function signByService (signId, dataB64, algorithm, format, extraParams) {

				if (dataB64 == undefined || dataB64 == "") {
					dataB64 = null;
				}

				if (dataB64 != null && !isValidUrl(dataB64)) {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
				}

				var data = generateDataToSign(signId, algorithm, format, extraParams, dataB64, defaultKeyStore);
				
				execAppIntent(buildUrl(data));
			}

			/**
			 * Inicia el proceso de firma por lotes.
			 */
			function signAndSaveToFile (opId, dataB64, algorithm, format, extraParams, outputFileName, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				signAndSaveFileByService(opId, dataB64, algorithm, format, extraParams, outputFileName);
			}

			/**
			 * Realiza una operacion de firma/multifirma seguida del guardado del resultado comunicandose
			 * con la aplicacion nativa por socket.
			 * @param signId Identificador de la operacion a realizar (sign, cosign y countersign).
			 * @param dataB64 Datos o firma en base 64.
			 * @param algorithm Algoritmo de firma.
			 * @param format Formato de firma.
			 * @param extraParams Parametros para la configuraci&oacute;n de la operaci&oacute;n.
			 */
			function signAndSaveFileByService (signId, dataB64, algorithm, format, extraParams, outputFileName) {

				if (dataB64 == undefined || dataB64 == "") {
					dataB64 = null;
				}

				if (dataB64 != null && !isValidUrl(dataB64)) {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
				}

				var data = generateDataToSignAndSave(signId, algorithm, format, extraParams, outputFileName, dataB64, defaultKeyStore);

				execAppIntent(buildUrl(data));
			}

			/**
			 * Inicia el proceso de firma por lotes.
			 */
			function signBatch (batchB64, batchPreSignerUrl, batchPostSignerUrl, extraParams, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				signBatchByService(batchB64, batchPreSignerUrl, batchPostSignerUrl, extraParams);
			}
			
			function signBatchByService (batchB64, batchPreSignerUrl, batchPostSignerUrl, extraParams) {
				
				if (batchB64 == undefined || batchB64 == "") {
					batchB64 = null;
				}
				
				if (batchB64 != null) {
					batchB64 = batchB64.replace(/\+/g, "-").replace(/\//g, "_");
				}
				
				var data = generateDataToBatch(defaultKeyStore, batchPreSignerUrl, batchPostSignerUrl, extraParams, batchB64);
				execAppIntent(buildUrl(data));
			}
			
			/**
			 * Genera el objeto con los datos de la transaccion para la firma
			 */
			function generateDataToBatch(keystore, batchPreSignerUrl, batchPostSignerUrl, extraParams, batchB64) {
				var data = new Object();
				data.op = generateDataKeyValue("op","batch");
				data.keystore = generateDataKeyValue("keystore", keystore != null ? keystore : null);
				data.ksb64 = generateDataKeyValue ("ksb64", keystore != null ? Base64.encode(keystore) : null);
				data.batchpresignerurl = generateDataKeyValue("batchpresignerurl", batchPreSignerUrl);
				data.batchpostsignerurl = generateDataKeyValue("batchpostsignerurl", batchPostSignerUrl);
				data.properties = generateDataKeyValue ("properties", extraParams != null ? Base64.encode(extraParams) : null);
				data.dat = generateDataKeyValue ("dat",  batchB64 == "" ? null : batchB64);
				data.sticky = generateDataKeyValue ("sticky", stickySignatory);

				return data;
			}

			/**
			 * Construye una URL para la invocaci&oacute;n del Cliente @firma nativo.
			 * params: Par\u00E1metros para la configuraci\u00F3n de la operaci\u00F3n.
			 */
			function buildUrl (arr) {

				// Operacion seleccionada
				var intentURL;
				var params = [];
				// Convertimos el objeto con los datos en un array del tipo key value
				for(var x in arr){
				  params.push(arr[x]);
				}

				if (params != null && params != undefined && params.length > 0) {
					intentURL = 'afirma://' + encodeURIComponent(arr.op.value) + '?';	// Agregamos como dominio el identificador del tipo de operacion
					for (var i = 0; i < params.length; i++) {
						if (params[i].value != null && params[i].value != "null") {
							intentURL += (i != 0 ? '&' : '') + params[i].key + '=' + encodeURIComponent(params[i].value); 
						}
					}
				}
				return intentURL;
			}
			
			function execAppIntent (url) {
				
				// Primera ejecucion, no hay puerto definido
				if (port == "") {
					// Calculamos los puertos
					var ports = getRandomPorts();
					// Invocamos a la aplicacion nativa
					openNativeApp(ports);
					// Enviamos la peticion a la app despues de esperar un tiempo prudencial
					setTimeout(executeEchoByServiceByPort, MiniApplet.AUTOFIRMA_LAUNCHING_TIME, ports, url);
				}
				// Se ha ejecutado anteriormente y tenemos un puerto calculado.
				else {
					connection = false;
					executeEchoByService (port, url, MiniApplet.AUTOFIRMA_CONNECTION_RETRIES)
				}
			}
			
			/**
			 * Obtiene un puerto aleatorio para la comunicaci\u00F3n con la aplicaci\u00F3n nativa.
			 */
			function getRandomPorts () {
				var MIN_PORT = 49152;
				var MAX_PORT = 65535;
				var ports = new Array();
				ports[0] = Math.floor((Math.random() * (MAX_PORT - MIN_PORT))) + MIN_PORT;
				ports[1] = Math.floor((Math.random() * (MAX_PORT - MIN_PORT))) + MIN_PORT;
				ports[2] = Math.floor((Math.random() * (MAX_PORT - MIN_PORT))) + MIN_PORT;
				return ports;
			}
		
		
			function openNativeApp (ports) {
			
				var portsLine = "";
				for (var i = 0; i < ports.length; i++) {
					portsLine += ports[i];
					if (i < (ports.length - 1)) {
						portsLine += ",";
					}
				}
				idSession = generateNewIdSession();
				
				// Si no se dan las condiciones que requieren el uso de la aplicacion nativa,
				// por entorno y si se ha configurado la URL del servicio, cargamos la version JNLP
				if (!needNativeAppInstalled() && !!jnlpServiceAddress) {
					openUrl("jnlp" + jnlpServiceAddress.substring(4) + "?os=" + getOSName() + "&arg=" + Base64.encode("afirma://service?ports=" + portsLine + "&amp;v=" + PROTOCOL_VERSION + "&amp;idsession=" + idSession, true));
				}
				// En caso contrario, cargamos la version nativa
				else {
					bJNLP = false;
					openUrl("afirma://service?ports=" + portsLine + "&v=" + PROTOCOL_VERSION + "&idsession=" + idSession);
				}
			}

			/**
			 * Genera el objeto con los datos de la transaccion para la operacion
			 * de firma/multifirma
			 */
			function generateDataToSign(signId, algorithm, format, extraParams, dataB64, keystore) {
				var data = new Object();
				data.op = generateDataKeyValue("op", signId);
				data.keystore = generateDataKeyValue ("keystore", keystore != null ? keystore : null);
				data.ksb64 = generateDataKeyValue ("ksb64", keystore != null ? Base64.encode(keystore) : null);
				data.algorithm = generateDataKeyValue ("algorithm", algorithm);
				data.format = generateDataKeyValue ("format", format); 
				data.properties = generateDataKeyValue ("properties", extraParams != null ? Base64.encode(extraParams) : null);
				data.dat = generateDataKeyValue ("dat", dataB64 == "" ? null : dataB64);
				data.sticky = generateDataKeyValue ("sticky", stickySignatory);

				return data;
			}

			/**
			 * Genera el objeto con los datos de la transaccion para la operacion
			 * de firma/multifirma seguida del guardado del resultado
			 */
			function generateDataToSignAndSave(signId, algorithm, format, extraParams, outputFileName, dataB64, keystore) {
				var data = new Object();
				data.op = generateDataKeyValue("op", "signandsave");
				data.cryptoOp = generateDataKeyValue("cop", signId);
				data.keystore = generateDataKeyValue ("keystore", keystore != null ? keystore : null);
				data.ksb64 = generateDataKeyValue ("ksb64", keystore != null ? Base64.encode(keystore) : null);
				data.algorithm = generateDataKeyValue ("algorithm", algorithm);
				data.format = generateDataKeyValue ("format", format);
				data.properties = generateDataKeyValue ("properties", extraParams != null ? Base64.encode(extraParams) : null);
				data.filename = generateDataKeyValue ("filename", outputFileName);
				data.dat = generateDataKeyValue ("dat", dataB64 == "" ? null : dataB64);
				data.sticky = generateDataKeyValue ("sticky", stickySignatory);

				return data;
			}
			
			/**
			 * Genera el objeto con los datos de la transaccion para la operacion
			 * de carga/multicarga
			 */
			function generateDataToLoad(loadId, title, extensions, description, filePath, multiload) {
				var data = new Object();
				data.op = generateDataKeyValue("op", loadId);
				data.title = generateDataKeyValue("title", title);
				data.extensions = generateDataKeyValue("extensions", extensions);
				data.description = generateDataKeyValue("description", description);
				data.filePath = generateDataKeyValue("filePath", filePath);
				data.multiload = generateDataKeyValue("multiload", multiload);
				return data;
			}
			
			function executeEchoByServiceByPort (ports, url) {
				connection = false;
				var semaphore = new Object();
				semaphore.locked = false;
				executeEchoByService (ports[0], url, MiniApplet.AUTOFIRMA_CONNECTION_RETRIES, semaphore);
				executeEchoByService (ports[1], url, MiniApplet.AUTOFIRMA_CONNECTION_RETRIES, semaphore);
				executeEchoByService (ports[2], url, MiniApplet.AUTOFIRMA_CONNECTION_RETRIES, semaphore);
			}

			/**
			* Intenta conectar con la aplicacion nativa mandando una peticion echo al puerto.
			* Si la aplicacion responde lanzamos la ejecucion del servicio.
			* Si la aplicacion no responde volvemos a lanzar cada 2 segundos otra peticion echo hasta que una
			* peticion sea aceptada.
			*/
			function executeEchoByService (currentPort, url, timeoutResetCounter, semaphore) {
				var httpRequest = getHttpRequest();
				httpRequest.open("POST", URL_REQUEST + currentPort + "/afirma", true);
				httpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
				httpRequest.onreadystatechange = function() {
					if (httpRequest.readyState == 4 && httpRequest.status == 200 && Base64.decode(httpRequest.responseText, true) == "OK" && !connection) {
						//console.log("puerto asignado puerto:" + currentPort);
						port = currentPort;
						urlHttpRequest = URL_REQUEST + port + "/afirma";
						connection = true;
						if (semaphore) {
							semaphore.locked = true;
						}
						// Comprobamos si es una operacion de seleccion de certificado
						isSelectCertOperation = url.indexOf("afirma://selectcert") > -1;
						// Comprobamos si es una operacion de guardado.
						isSaveOperation = url.indexOf("afirma://save") > -1;
						// Comprobamos si es una operacion de firma por lotes
						isBatchOperation = url.indexOf("afirma://batch") > -1;
						// Comprobamos si es una operacion criptografica mas guardado del resultado
						isOpAndSaveOperation = url.indexOf("afirma://signandsave") > -1;
						executeOperationByService(url);
					}
					else if ((!semaphore || !semaphore.locked) && !connection && httpRequest.readyState != 2 && httpRequest.readyState != 3) {
						timeoutResetCounter--;
						//console.log("Quedan " + timeoutResetCounter + " peticiones a " + currentPort)
						
						// Si ya se conecto antes con la aplicacion pero ahora llevamos la mitad de los intentos
						// sin conectar, consideramos que se ha tumbado y hay que relanzarla
						if (port != "" && timeoutResetCounter < MiniApplet.AUTOFIRMA_CONNECTION_RETRIES/2) {
							port = "";
							if (semaphore) {
								semaphore.locked = true;
							}
							timeoutResetCounter = MiniApplet.AUTOFIRMA_CONNECTION_RETRIES;
							execAppIntent(url);							
						}
						// Si hemos agotado todos los reintentos consideramos que la aplicacion no esta instalada
						else if (timeoutResetCounter == 0) {
							if (!semaphore || !semaphore.locked) {
								if (semaphore) {
									semaphore.locked = true;
								}
								errorCallback("es.gob.afirma.standalone.ApplicationNotFoundException", "No se ha podido conectar con AutoFirma.");
							}
							return;
						}
						// Aun quedan reintentos
						else {
							setTimeout(executeEchoByService, MiniApplet.AUTOFIRMA_LAUNCHING_TIME, currentPort, url, timeoutResetCounter, semaphore);
						}
					}
				}
				
				if (!connection) {
					// Mandamos un echo con - por lo que las variables de control se resetearan
					// Se anade EOF para que cuando el socket SSL lea la peticion del buffer sepa
					// que ha llegado al final y no se quede en espera
					httpRequest.send("echo=-idsession=" + idSession + "@EOF");
					//console.log("probamos puerto " +currentPort)
				}
			}
			
			/**
			* Comprueba si hay que dividir los datos que se se mandan a la aplicacion nativa.
			* Si hay que dividirlos se llama a la funcion executeOperationRecursive.
			* Si cabe en un solo envio se manda directamente.
			*/
			function executeOperationByService (url) {
				
				// Si el envio se debe fragmentar, llamamos a una funcion que se encarga
				// de mandar la peticion recursivamente
				if (url.length > URL_MAX_SIZE) {
					executeOperationRecursive(url, 1, Math.ceil(url.length/URL_MAX_SIZE));
					return;
				}
				
				var httpRequest = getHttpRequest();
				httpRequest.open("POST", urlHttpRequest, true);
				httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
				
				// El envio no se fragmenta
				httpRequest.onreadystatechange = function() {
					if (httpRequest.status == 404) {
						errorServiceResponseFunction("java.lang.IOException", httpRequest.responseText);
					}
					// Las operaciones que no requieren respuesta, llaman directamente a la funcion de exito 
					if (isSaveOperation) {
						if (httpRequest.readyState == 4 && Base64.decode(httpRequest.responseText) != "") {
							successServiceResponseFunction(Base64.decode(httpRequest.responseText));
						}
						return;
					}
					// El resto de operaciones deben componer el resultado
					else {
						if (httpRequest.readyState == 4 && httpRequest.status == 200 && httpRequest.responseText != "") {
							if (Base64.decode(httpRequest.responseText) == "MEMORY_ERROR"){
								errorServiceResponseFunction("java.lang.OutOfMemoryError", "Problema de memoria en servidor");
								return;
							}
							// Juntamos los fragmentos
							totalResponseRequest = "";
							addFragmentRequest (1, Base64.decode(httpRequest.responseText, true));
						}
						// Volvemos a mandar la peticion si no manda texto en la respuesta y la peticion esta en estado ready
						else if (httpRequest.responseText == "" && httpRequest.status == 0 && httpRequest.readyState == 0) {
							setTimeout(executeOperationByService, WAITING_TIME, url);
						}
					}
				}
				httpRequest.onerror = function(e) {
					// status error 0 es que no se ha podido comunicar con la aplicacion
					if (e.target.status == 0) {
						errorServiceResponseFunction("java.lang.IOException", "Se ha perdido la conexion con la aplicacion @firma " + e.target.statusText);
					}
					// error desconocido 
					else {
						errorServiceResponseFunction("java.lang.IOException", "Ocurrio un error de red en la llamada al servicio de firma "+e.target.statusText);
					}
				}
				// se anade EOF para que cuando el socket SSL lea la peticion del buffer sepa que ha llegado al final y no se quede en espera
				httpRequest.send("cmd=" + Base64.encode(url, true) + "idsession=" + idSession + "@EOF");
			}
			
			/**
			* Manda los datos a la aplicacion nativa en varios fragmentos porque ha habido que dividir los datos.
			* Se va mandando cada peticion cuando se reciba la anterior.
			*/
			function executeOperationRecursive (url, i, iFinal) {
				
				var httpRequest = getHttpRequest();
				httpRequest.open("POST", urlHttpRequest, true);
				httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
				var urlToSend = url.substring(((i-1) * URL_MAX_SIZE), Math.min(URL_MAX_SIZE * i, url.length));
				httpRequest.onreadystatechange = function (evt) {
					if (httpRequest.status == 404) {
						errorServiceResponseFunction("java.lang.Exception", httpRequest.responseText);
						return;
					}
					// Respuesta afirmativa, hay que mandar mas fragmentos
					if (httpRequest.readyState == 4 && httpRequest.status == 200 && httpRequest.responseText != "" ) {
						recibidos++;
						
						// Faltan mas peticiones por enviar
						if (Base64.decode(httpRequest.responseText, true) == "MORE_DATA_NEED") {
							if (recibidos < iFinal ){
								//console.log("recibido el fragmento "+recibidos + "de "+iFinal)
								executeOperationRecursive(url, i+1, iFinal);
							}
						}
						// Todas las peticiones se han recibido, hay que mandar operacion firma
						// Respuesta es OK
						else if (Base64.decode(httpRequest.responseText, true) == "OK") {
							if(recibidos == iFinal){
								//console.log("recibido todo, realizamos la operacion");
								recibidos = 0;
								doFirm();
							}
						}
						else if(Base64.decode(httpRequest.responseText) == "MEMORY_ERROR"){
							successServiceResponseFunction(Base64.decode(httpRequest.responseText));
						}
					}
					else if (httpRequest.responseText == "" && httpRequest.status == 0 && httpRequest.readyState == 0) {
						setTimeout(executeOperationRecursive, WAITING_TIME, url, i, iFinal);
					}
				}
				httpRequest.onerror = function(e) { 
					// Status error 0 es que no se ha podido comunicar con la aplicacion
					if (e.target.status == 0){
						errorServiceResponseFunction("java.lang.IOException", "Se ha perdido la conexion con la aplicacion @firma " + e.target.statusText);
					}
					// Error desconocido 
					else{
						errorServiceResponseFunction("java.lang.IOException", "Ocurrio un error de red en la llamada al servicio de firma "+e.target.statusText);
					}
				}
				// Se anade EOF para que cuando el socket SSL lea la peticion del buffer sepa que ha llegado al final y no se quede en espera
				httpRequest.send("fragment=@" + i + "@" + iFinal + "@"  + Base64.encode(urlToSend, true) + "idsession=" + idSession +"@EOF");
				//console.log("mandado parte "+i+" de"+iFinal);
	
			}
			
			/**
			 * Realiza una operacion que se ha mandando en varios fragmentos.
			 */
			function doFirm () {
				httpRequest = getHttpRequest();
				httpRequest.open("POST", urlHttpRequest, true);
				httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
				httpRequest.onreadystatechange = function() {

					if (httpRequest.status == 404) {
						errorServiceResponseFunction("java.lang.Exception", httpRequest.responseText);
					}

					// Se ha realizado la operacion save, no controlamos reintentos ni el exito de la peticion
					// porque no requiere respuesta
					if (isSaveOperation) {
						if (httpRequest.readyState == 4 && Base64.decode(httpRequest.responseText) != "") {
							successServiceResponseFunction(Base64.decode(httpRequest.responseText));
						}
						return;
					}
					else {
						if (httpRequest.readyState == 4 && httpRequest.status == 200 && httpRequest.responseText != "") {
							if(Base64.decode(httpRequest.responseText) == "MEMORY_ERROR"){
								successServiceResponseFunction(Base64.decode(httpRequest.responseText));
							}
							totalResponseRequest = "";
							addFragmentRequest (1, Base64.decode(httpRequest.responseText, true));
						}
						// No recibimos la respuesta, volvemos a llamar.
						else {
							if (httpRequest.status == 0 && httpRequest.readyState == 0 ) {
								setTimeout(doFirm, WAITING_TIME);	
							}
						}
					}
				}
				httpRequest.onerror = function(e) { 
					// status error 0 es que no se ha podido comunicar con la aplicacion
					if (e.target.status == 0){
						errorServiceResponseFunction("java.lang.IOException", "Se ha perdido la conexion con la aplicacion @firma " + e.target.statusText);
					}
					// error desconocido 
					else{
						errorServiceResponseFunction("java.lang.IOException", "Ocurrio un error de red en la llamada al servicio de firma "+e.target.statusText);
					}
				}
				httpRequest.send("firm=idsession=" + idSession +"@EOF");
			}

			/**
			 * Se encarga de solicitar y montar la respuesta de la operacion realizada.
			 */
			function addFragmentRequest (part, totalParts){
				httpRequest = getHttpRequest();
				httpRequest.open("POST", urlHttpRequest, true);
				httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
				httpRequest.onreadystatechange = function() {
					if (httpRequest.readyState == 4 && httpRequest.status == 200 && httpRequest.responseText != "") {
						if(Base64.decode(httpRequest.responseText) == "MEMORY_ERROR"){
							errorServiceResponseFunction("java.lang.OutOfMemoryError", "Problema de memoria en servidor");
							return;
						}
						//console.log("recibida la parte " + part);
						totalResponseRequest += Base64.decode(httpRequest.responseText, true);
						// Si estan todas las partes llamamos al successcallback
						if (part == totalParts) {
							// Es una operacion de firma por lotes y tiene un callback propio
							if (isBatchOperation) {
								successBatchResponseFunction(totalResponseRequest);
								isBatchOperation = false;
							}
							// Es una operacion de seleccion de certificados y tiene un callback propio
							else if (isSelectCertOperation) {
								successSelectCertServiceResponseFunction(totalResponseRequest);
								isSelectCertOperation = false;
							}
							// Es cualquier otra operacion que requiere respuesta
							else {
								successServiceResponseFunction(totalResponseRequest);
							}
							totalResponseRequest = "";
						}
						else {
							addFragmentRequest(part + 1, totalParts);
						}
					}
					else {
						if (httpRequest.responseText == "" && httpRequest.status == 0 && httpRequest.readyState == 0){
							setTimeout(addFragmentRequest, WAITING_TIME, part, totalParts);
						}
					}
				}
				httpRequest.onerror = function(e) { 
					// status error 0 es que no se ha podido comunicar con la aplicacion
					if (e.target.status == 0){
						errorServiceResponseFunction("java.lang.IOException", "Se ha perdido la conexion con la aplicacion @firma " + e.target.statusText);
					}
					// error desconocido 
					else{
						errorServiceResponseFunction("java.lang.IOException", "Ocurrio un error de red en la llamada al servicio de firma "+e.target.statusText);
					}
				}
				if (part <= totalParts){
					// se anade EOF para que cuando el socket SSL lea la peticion del buffer sepa que ha llegado al final y no se quede en espera
					httpRequest.send("send=@"+part+"@"+totalParts+"idsession=" + idSession +"@EOF");
					//console.log("solicitarmos la parte "+part+" de "+ totalParts)
				}
			}
			
			/**
			 * Lee el resultado devuelto por el servicio, 'CANCEL' o empieza por 'SAF-', ejecutara el metodo
			 * de error, si es 'OK' o cualquier otra cosa (que se intepretara como el resultado en base 64)
			 * se ejecutara el metodo de exito. En este ultimo caso, se descifrara el resultado. 
			 * @param data Resultado obtenido.
			 */
			function successSelectCertServiceResponseFunction (data) {
				// No se ha obtenido respuesta o se notifica la cancelacion
				if (data == undefined || data == null || data == "CANCEL") {
					errorCallback("es.gob.afirma.core.AOCancelledOperationException", "Operacion cancelada por el usuario");
					return;
				}

				// Se ha producido un error
				if (data.length > 4 && data.substr(0, 4) == "SAF_") {
					errorCallback("java.lang.Exception", data);
					return;
				}

				// Se ha producido un error y no se ha identificado el tipo
				if (data == "NULL") {
					errorCallback("java.lang.Exception", "Error desconocido");
					return;
				}

				successCallback(data.replace(/\-/g, "+").replace(/\_/g, "/"));
			}

			/**
			 * Lee el resultado devuelto por el servicio, 'CANCEL' o empieza por 'SAF-', ejecutara el metodo
			 * de error, si es 'OK' o cualquier otra cosa (que se intepretara como el resultado en base 64)
			 * se ejecutara el metodo de exito. En este ultimo caso, se descifrara el resultado. 
			 * @param data Resultado obtenido.
			 */
			function successServiceResponseFunction (data) {
				// No se ha obtenido respuesta o se notifica la cancelacion
				if (data == undefined || data == null || data == "CANCEL") {
					errorCallback("es.gob.afirma.core.AOCancelledOperationException", "Operacion cancelada por el usuario");
					return;
				}
				
				// Termina bien y no devuelve ningun resultado o es una operacion guardado
				if (data == "OK") {
					successCallback(data, null);
					return;
				}
				
				// Error de memoria
				if (data == "MEMORY_ERROR") {
					errorCallback("es.gob.afirma.core.OutOfMemoryError", "El fichero que se pretende firmar o guardar excede de la memoria disponible para aplicacion");
					return;
				}
				
				// Se ha producido un error
				if (data.length > 4 && data.substr(0, 4) == "SAF_") {
					errorCallback("java.lang.Exception", data);
					return;
				}

				// Se ha producido un error y no se ha identificado el tipo
				if (data == "NULL") {
					errorCallback("java.lang.Exception", "Error desconocido");
					return;
				}
				
				// Operacion guardado con exito
				if (data == "SAVE_OK") {
					if (successCallback) {
						successCallback(data);
					}
					return;
				}
				
				// Vengo de getCurrentLog
				if (data.length > 150 && data.substr(0, 150).indexOf("<log>") != -1) {
					var log = " === JAVASCRIPT INFORMATION === " +
					"\nnavigator.appCodeName: " + navigator.appCodeName +
					"\nnavigator.appName: " +  navigator.appName +
					"\nnavigator.appVersion: " + navigator.appVersion +
					"\nnavigator.platform: " + navigator.platform +
					"\nnavigator.userAgent: " + navigator.userAgent+
					"\nnavigator.javaEnabled(): " + navigator.javaEnabled() +
					"\nscreen.width: " + (window.screen ? screen.width : 0) +
					"\nscreen.height: " + (window.screen ? screen.height : 0) +
					"\n\n   === CLIENTE LOG === \n" + data;
					successCallback(log);
					return;
				}
				
				// Compruebo si se trata de una operacion de carga/multicarga (load).
				// El separador "|"  distingue los pares "filename-1:dataBase64-1|filename-2:dataBase64-2...", uno por cada archivo cargado.
				// Devolveremos un array en el que cada posicion sera uno de estos pares: "filename-n:dataBase64-n".
				// La funcion de callback realizara el tratamiento deseado,
				// pudiendo obtener cada dato del par teniendo en cuenta el
				// separador ":"
				if (data.indexOf(":") > 0) {
					
					var fileNamesDataBase64 = data.split("|");
					
					if (fileNamesDataBase64.length == 1) {
						
						var sepPos = fileNamesDataBase64[0].indexOf(":");
						var fileNameDataBase64 = fileNamesDataBase64[0];
						
						if (sepPos == -1) {
							fileName = Base64.decode(fileNameDataBase64, true);
						}
						else {
							fileName = fileNameDataBase64.substring(0, sepPos);
							dataB64 = fileNameDataBase64.substring(sepPos + 1).replace(/\-/g, "+").replace(/\_/g, "/");
						}
						
						successCallback(fileName,dataB64);
						
						return;
						
					} else if (fileNamesDataBase64.length > 1 ) {
						
						var fileNameArray = new Array();
						var dataB64Array = new Array();
						
						for (i = 0; i < fileNamesDataBase64.length; i++) {
							var sepPos = fileNamesDataBase64[i].indexOf(":");
							
							if (sepPos == -1) {
								fileNameArray.push(fileNamesDataBase64[i]);
								dataB64Array.push("");
							}
							else {
								fileNameArray.push(fileNamesDataBase64[i].substring(0, sepPos));
								dataB64Array.push(fileNamesDataBase64[i].substring(sepPos + 1).replace(/\-/g, "+").replace(/\_/g, "/"));
							}
						}
										
					}
					
					successCallback(fileNameArray,dataB64Array);
					
					return;
				}
				
				// Interpretamos el resultado como un base 64 y el certificado y los datos cifrados
				var signature;
				var certificate = null;
				var sepPos = data.indexOf("|");
				
				if (sepPos == -1) {
					signature = Base64.decode(data, true).replace(/\-/g, "+").replace(/\_/g, "/");
				}
				else {
					certificate = data.substring(0, sepPos).replace(/\-/g, "+").replace(/\_/g, "/");
					signature = data.substring(sepPos + 1).replace(/\-/g, "+").replace(/\_/g, "/");
				}
				successCallback(signature, certificate);
			}
			
			function errorServiceResponseFunction(exception, message){
				errorCallback(exception, message);
			}
			
			function successBatchResponseFunction (data) {
				// No se ha obtenido respuesta o se notifica la cancelacion
				if (data == undefined || data == null || data == "CANCEL") {
					errorCallback("es.gob.afirma.core.AOCancelledOperationException", "Operacion cancelada por el usuario");
					return;
				}
				
				// Se ha producido un error
				if (data.length > 4 && data.substr(0, 4) == "SAF_") {
					errorCallback("java.lang.Exception", data);
					return;
				}

				// Se ha producido un error y no se ha identificado el tipo
				if (data == "NULL") {
					errorCallback("java.lang.Exception", "Error desconocido");
					return;
				}
				successCallback(data);
			}
			
			/**
			 * Inicia el proceso de guardado de una firma.
			 */
			function saveDataToFile (dataB64, title, filename, extension, description, successCallbackSave, errorCallbackSave) {
				successCallback = successCallbackSave;
				errorCallback = errorCallbackSave;
				saveByService(dataB64, title, filename, extension, description);
			}

			function saveByService ( dataB64, title, filename, extension, description) {
				
				if (dataB64 == undefined || dataB64 == "") {
					dataB64 = null;
				}

				if (dataB64 != null && !isValidUrl(dataB64)) {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
				}

				var data = generateDataToSave(dataB64, title, filename, extension, description);
				
				execAppIntent(buildUrl(data));
			}

			/**
			* Genera el objeto de datos para la operacion de guardar
			*/
			function generateDataToSave(dataB64, title, filename, extension, description) {
				var data = new Object();
				data.op = generateDataKeyValue ("op", "save");
				data.title = generateDataKeyValue ("title", title);
				data.filename = generateDataKeyValue ("filename", filename);
				data.extension = generateDataKeyValue ("extension", extension);
				data.description = generateDataKeyValue ("description", description);
				data.dat = generateDataKeyValue ("dat",  dataB64 == "" ? null : dataB64);
				
				return data;
			}

			function generateDataKeyValue(key, value) {
				var data  = new Object();
				data.key = key;
				data.value = value;
				return data;
			}
			
			/**
			 * Convierte texto plano en texto base 64.
			 * Implementada en el applet Java de firma.
			 */
			function getBase64FromText (plainText, charset) {
				return plainText != null ? Base64.encode(plainText) : null;
			}

			/**
			 * Convierte texto base 64 en texto plano.
			 * Implementada en el applet Java de firma.
			 */
			function getTextFromBase64 (base64Text, charset) {
				return base64Text != null ? Base64.decode(base64Text) : null;
			}

			
			/**
			 * Inicia el proceso de carga de un fichero.
			 * Implementada tambien en el applet Java de firma
			 * @param title Titulo de la ventana de dialogo
			 * @param extensions Extensiones permitidasg
			 * @param description Descripcion del tipo de archivo a cargar
			 * @param filePath Ruta del archivo por defecto
			 * @param successCallbackFunction Funcion de callback tras exito
			 * @param errorCallbackFunction Funcion de callback tras error
			 */
			function getFileNameContentBase64 (title, extensions, description, filePath, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				getLoadContentBase64ByService("load", title, extensions, description, filePath, false);
			}

			/**
			 * Inicia el proceso de carga de uno o varios ficheros.
			 * Implementada tambien en el applet Java de firma
			 * @param title Titulo de la ventana de dialogo
			 * @param extensions Extensiones permitidas
			 * @param description Descripcion del tipo de archivo a cargar
			 * @param filePath Ruta del archivo por defecto
			 * @param successCallbackFunction Funcion de callback tras exito
			 * @param errorCallbackFunction Funcion de callback tras error
			 */
			function getMultiFileNameContentBase64 (title, extensions, description, filePath, successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				getLoadContentBase64ByService("load", title, extensions, description, filePath, true);
			}
			
			/**
			 * Inicia el proceso de obtencion del log actual de la aplicacion.
			 * Implementada tambien en el applet Java de firma
			 * @param successCallbackFunction Funcion de callback tras exito
			 * @param errorCallbackFunction Funcion de callback tras error
			 */
			function getCurrentLog (successCallbackFunction, errorCallbackFunction) {
				successCallback = successCallbackFunction;
				errorCallback = errorCallbackFunction;
				getCurrentLogByService("getLog");
			}
			
			/**
			 * Realiza una operacion de carga de fichero comunicandose con la
			 * aplicacion nativa por socket.
			 * @param loadId Identificador de la operacion a realizar (load).
			 * @param title Titulo de la ventana de dialogo
			 * @param extensions Extensiones permitidas
			 * @param description Descripcion del tipo de archivo a cargar
			 * @param filePath Ruta del archivo por defecto
			 * @param multiload true si permite la seleccion de varios ficheros,
			 * false si solo se permite seleccionar un fichero.
			 */
			function getLoadContentBase64ByService (loadId, title, extensions, description, filePath, multiload) {
				
				var data = generateDataToLoad(loadId, title, extensions, description, filePath, multiload);
				
				execAppIntent(buildUrl(data));
			}
			
			/**
			 * Realiza una operacion de obtencion de log actual de la aplicacion
			 */
			function getCurrentLogByService() {
				
				var data = generateDataToLoad("getLog");
				
				execAppIntent(buildUrl(data));
			} 

			/** 
			 * Funcion para la comprobacion de existencia del objeto. No hace nada.
			 * Implementada en el applet Java de firma.
			 */
			function echo () {
				return "Cliente JavaScript";
			}
			
			/**
			 * Recupera el mensaje de error asociado al ultimo error capturado.
			 * Implementada en el applet Java de firma.
			 */
			function getErrorMessage () {
				return errorMessage;
			}

			/**
			 * Recupera el tipo del ultimo error capturado.
			 * Implementada en el applet Java de firma.
			 */
			function getErrorType () {
				return errorType;
			}

			/**
			 * Funcion para identificar el tipo de objeto del Cliente (javascript, applet,...).
			 */
			function getType () {
				return "javascript";
			}

			/**
			 * Establece el error indicado como error interno y lanza una excepcion.
			 */
			function throwException (type, message) {
				errorType = type;
				errorMessage = message;
				throw new Error();
			}

			/* Metodos que publicamos del objeto AppAfirmaJS */
			return {
				echo : echo,
				checkTime : checkTime,
				setKeyStore : setKeyStore,
				sign : sign,
				coSign : coSign,
				counterSign : counterSign,
				signBatch : signBatch,
				selectCertificate : selectCertificate,
				saveDataToFile : saveDataToFile,
				signAndSaveToFile : signAndSaveToFile,
				getFileNameContentBase64: getFileNameContentBase64,
				getMultiFileNameContentBase64 : getMultiFileNameContentBase64,
				getBase64FromText : getBase64FromText,
				getTextFromBase64 : getTextFromBase64,
				setStickySignatory : setStickySignatory,
				setLocale : setLocale,
				getErrorMessage : getErrorMessage,
				getErrorType : getErrorType,
				getCurrentLog : getCurrentLog				
			}
	});
		
		
		/**
		 * Objeto JavaScript que va a reemplazar al cliente de firma en los entornos en los que
		 * no pueden ejecutarse applets.
		 */
		var AppAfirmaJSWebService = ( function (clientAddress, window, undefined) {

			var UnsupportedOperationException = "java.lang.UnsupportedOperationException";

			/* Longitud maxima de una URL en Android para la invocacion de una aplicacion nativa. */
			var MAX_LONG_ANDROID_URL = 2000;
			
			/* Longitud maxima de una URL en iOS para la invocacion de una aplicacion nativa. */
			var MAX_LONG_IOS_URL = 80000;
			
			/* Longitud maxima de una URL en Windows 8 para la invocacion de una aplicacion nativa. */
			var MAX_LONG_WINDOWS8_URL = 2000;
			
			/* Longitud maxima que generalmente se permite a una URL. */
			var MAX_LONG_GENERAL_URL = 2000;
			
			/** Version del protocolo utilizada. */
			var PROTOCOL_VERSION = 1;
			
			/* Indica si ya se ha detectado que la aplicacion no esta instalada  */
			var wrongInstallation = true;
			
			/**
			 *  Atributos para la configuracion del objeto sustituto del applet Java de firma
			 */
			var errorMessage = '';
			var errorType = '';
			var defaultKeyStore = null;
			var retrieverServletAddress = null;
			var storageServletAddress = null;

			if (clientAddress != undefined && clientAddress != null) {
				if (clientAddress.indexOf("://") != -1 && clientAddress.indexOf("/", clientAddress.indexOf("://") + 3) != -1) {
					var servletsBase = clientAddress.substring(0, clientAddress.indexOf("/", clientAddress.indexOf("://") + 3));
					retrieverServletAddress = servletsBase + "/afirma-signature-retriever/RetrieveService";
					storageServletAddress = servletsBase + "/afirma-signature-storage/StorageService";
				} else {
					retrieverServletAddress = clientAddress + "/afirma-signature-retriever/RetrieveService";
					storageServletAddress = clientAddress + "/afirma-signature-storage/StorageService";
				}
			}

			/**
			 * Establece el almacen de certificados de que se debe utilizar por defecto.
			 */
			function setKeyStore (keystore) {
				defaultKeyStore = keystore;
			}

			/**
			 * Inicia el proceso de seleccion de certificado.
			 * Implementada en el applet Java de firma
			 */
			function selectCertificate (extraParams, successCallback, errorCallback) {
				throwException("java.lang.UnsupportedOperationException", "La operacion de seleccion de certificados no esta soportada");
			}
			
			/**
			 * Inicia el proceso de firma electronica.
			 * Implementada en el applet Java de firma
			 */
			function sign (dataB64, algorithm, format, extraParams, successCallback, errorCallback) {
				signOperation("sign", dataB64, algorithm, format, extraParams, successCallback, errorCallback);
			}

			/**
			 * Inicia el proceso de cofirma de una firma electr&oacute;nica. 
			 * Implementada en el applet Java de firma.
			 */
			function coSign (signB64, dataB64, algorithm, format, extraParams, successCallback, errorCallback) {
				signOperation("cosign", signB64, algorithm, format, extraParams, successCallback, errorCallback);
			}

			/**
			 * Inicia el proceso de contrafirma de una firma electr&oacute;nica.
			 * Implementada en el applet Java de firma. 
			 */
			function counterSign (signB64, algorithm, format, extraParams, successCallback, errorCallback) {
				signOperation("countersign", signB64, algorithm, format, extraParams, successCallback, errorCallback);
			}
			
			/**
			 * Realiza una operacion de firma/multifirma.
			 * @param signId Identificador de la operacion a realizar (sign, cosign y countersign).
			 * @param dataB64 Datos o firma en base 64.
			 * @param algorithm Algoritmo de firma.
			 * @param format Formato de firma.
			 * @param extraParams Par&aacute;metros para la configuraci&oacute;n de la operaci&oacute;n.
			 * @param successCallback M&eacute;todo a ejecutar en caso de &eacute;xito.
			 * @param errorCallback M&eacute;todo a ejecutar en caso de error.
			 */
			function signOperation (signId, dataB64, algorithm, format, extraParams, successCallback, errorCallback) {

				if (dataB64 == undefined || dataB64 == "") {
					dataB64 = null;
				}

				if (dataB64 != null && !isValidUrl(dataB64)) {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
					dataB64 = dataB64.replace(/\n/g, "").replace(/\r/g, ""); //eliminamos saltos de carro para que no generen espacios 0x20 al parsear los atributos del XML enviado/recibido (storageServletAddress y retrieverServletAddress) que impiden la firma en AutoFirma
				}

				var idSession = generateNewIdSession();
				var cipherKey = generateCipherKey();

				var i = 0;
				var params = new Array();
				params[i++] = {key:"ver", value:PROTOCOL_VERSION};
				if (signId != null && signId != undefined) {			params[i++] = {key:"op", value:signId}; }
				if (idSession != null && idSession != undefined) {		params[i++] = {key:"id", value:idSession}; }
				if (cipherKey != null && cipherKey != undefined) {		params[i++] = {key:"key", value:cipherKey}; }
				if (defaultKeyStore != null &&
						defaultKeyStore != undefined) {					params[i++] = {key:"keystore", value:defaultKeyStore};
																		params[i++] = {key:"ksb64", value:Base64.encode(defaultKeyStore)}; }
				if (storageServletAddress != null &&
						storageServletAddress != undefined) {			params[i++] = {key:"stservlet", value:storageServletAddress}; }
				if (format != null && format != undefined) {			params[i++] = {key:"format", value:format}; }
				if (algorithm != null && algorithm != undefined) {		params[i++] = {key:"algorithm", value:algorithm}; }
				if (extraParams != null && extraParams != undefined) { 	params[i++] = {key:"properties", value:Base64.encode(extraParams)}; }
				if (dataB64 != null) {									params[i++] = {key:"dat", value:dataB64}; }
			
				var url = buildUrl(signId, params);

				// Si la URL es muy larga, realizamos un preproceso para que los datos se suban al
				// servidor y la aplicacion nativa los descargue, en lugar de pasarlos directamente 
				if (isURLTooLong(url)) {
					if (storageServletAddress == null || storageServletAddress == undefined) {
						throwException("java.lang.IllegalArgumentException", "No se ha indicado la direccion del servlet para el guardado de datos");
						return;
					}

					sendDataAndExecAppIntent(idSession, cipherKey, storageServletAddress, retrieverServletAddress, signId, params, successCallback, errorCallback)
				}
				else {
					execAppIntent(url, idSession, cipherKey, successCallback, errorCallback);
				}
			}

			/**
			 * Realiza una operacion de firma/multifirma y permite guardar el fichero a disco.
			 * @param signId Identificador de la operacion a realizar (sign, cosign y countersign).
			 * @param dataB64 Datos o firma en base 64.
			 * @param algorithm Algoritmo de firma.
			 * @param format Formato de firma.
			 * @param extraParams Par&aacute;metros para la configuraci&oacute;n de la operaci&oacute;n.
			 * @param outputFileName Nombre propuesto para el fichero a guardar.
			 * @param successCallback M&eacute;todo a ejecutar en caso de &eacute;xito.
			 * @param errorCallback M&eacute;todo a ejecutar en caso de error.
			 */
			function signAndSaveToFile (signId, dataB64, algorithm, format, extraParams, outputFileName, successCallback, errorCallback) {

				if (dataB64 == undefined || dataB64 == "") {
					dataB64 = null;
				}

				if (dataB64 != null && !isValidUrl(dataB64)) {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
					dataB64 = dataB64.replace(/\n/g, "").replace(/\r/g, ""); //eliminamos saltos de carro para que no generen espacios 0x20 al parsear los atributos del XML enviado/recibido (storageServletAddress y retrieverServletAddress) que impiden la firma en AutoFirma
				}

				var idSession = generateNewIdSession();
				var cipherKey = generateCipherKey();

				var i = 0;
				var opId = "signandsave";
				var params = new Array();
				
				params[i++] = {key:"ver", value:PROTOCOL_VERSION};
				params[i++] = {key:"op", value:opId};
				if (signId != null && signId != undefined) {			params[i++] = {key:"cop", value:signId}; }
				if (idSession != null && idSession != undefined) {		params[i++] = {key:"id", value:idSession}; }
				if (cipherKey != null && cipherKey != undefined) {		params[i++] = {key:"key", value:cipherKey}; }
				if (defaultKeyStore != null &&
						defaultKeyStore != undefined) {					params[i++] = {key:"keystore", value:defaultKeyStore};
																		params[i++] = {key:"ksb64", value:Base64.encode(defaultKeyStore)}; }
				if (storageServletAddress != null &&
						storageServletAddress != undefined) {			params[i++] = {key:"stservlet", value:storageServletAddress}; }
				if (format != null && format != undefined) {			params[i++] = {key:"format", value:format}; }
				if (algorithm != null && algorithm != undefined) {		params[i++] = {key:"algorithm", value:algorithm}; }
				if (extraParams != null && extraParams != undefined) { 	params[i++] = {key:"properties", value:Base64.encode(extraParams)}; }
				if (outputFileName != null &&
						outputFileName != undefined) {					params[i++] = {key:"filename", value:outputFileName}; }
				if (dataB64 != null) {									params[i++] = {key:"dat", value:dataB64}; }
			
				var url = buildUrl(opId, params);

				// Si la URL es muy larga, realizamos un preproceso para que los datos se suban al
				// servidor y la aplicacion nativa los descargue, en lugar de pasarlos directamente 
				if (isURLTooLong(url)) {
					if (storageServletAddress == null || storageServletAddress == undefined) {
						throwException("java.lang.IllegalArgumentException", "No se ha indicado la direccion del servlet para el guardado de datos");
						return;
					}

					sendDataAndExecAppIntent(idSession, cipherKey, storageServletAddress, retrieverServletAddress, opId, params, successCallback, errorCallback)
				}
				else {
					execAppIntent(url, idSession, cipherKey, successCallback, errorCallback);
				}
			}
			
			/**
			 * Ejecuta una operacion de firma de lote.
			 */
			function signBatch (batchB64, batchPreSignerUrl, batchPostSignerUrl, extraParams, successCallback, errorCallback) {
				
				if (batchB64 == undefined || batchB64 == "") {
					batchB64 = null;
				}

				if (batchB64 != null && !isValidUrl(batchB64)) {
					batchB64 = batchB64.replace(/\+/g, "-").replace(/\//g, "_");
					batchB64 = batchB64.replace(/\n/g, "").replace(/\r/g, ""); //eliminamos saltos de carro para que no generen espacios 0x20 al parsear los atributos del XML enviado/recibido (storageServletAddress y retrieverServletAddress) que impiden la firma en AutoFirma
				}

				var idSession = generateNewIdSession();
				var cipherKey = generateCipherKey();
				
				var opId = "batch";

				var i = 0;
				var params = new Array();
				params[i++] = {key:"ver", value:PROTOCOL_VERSION};
				params[i++] = {key:"op", value:opId};
				if (idSession != null && idSession != undefined) {		params[i++] = {key:"id", value:idSession}; }
				if (cipherKey != null && cipherKey != undefined) {		params[i++] = {key:"key", value:cipherKey}; }
				if (defaultKeyStore != null &&
						defaultKeyStore != undefined) {					params[i++] = {key:"keystore", value:defaultKeyStore};
																		params[i++] = {key:"ksb64", value:Base64.encode(defaultKeyStore)}; }
				if (storageServletAddress != null &&
						storageServletAddress != undefined) {			params[i++] = {key:"stservlet", value:storageServletAddress}; }
				if (batchPreSignerUrl != null &&
						batchPreSignerUrl != undefined) {				params[i++] = {key:"batchpresignerurl", value:batchPreSignerUrl}; }				
				if (batchPostSignerUrl != null &&
						batchPostSignerUrl != undefined) {				params[i++] = {key:"batchpostsignerurl", value:batchPostSignerUrl}; }
				if (extraParams != null && extraParams != undefined) { 	params[i++] = {key:"properties", value:Base64.encode(extraParams)}; }
				if (batchB64 != null) {									params[i++] = {key:"dat", value:batchB64}; }

				var url = buildUrl(opId, params);

				// Si la URL es muy larga, realizamos un preproceso para que los datos se suban al
				// servidor y la aplicacion nativa los descargue, en lugar de pasarlos directamente 
				if (isURLTooLong(url)) {
					if (storageServletAddress == null || storageServletAddress == undefined) {
						throwException("java.lang.IllegalArgumentException", "No se ha indicado la direccion del servlet para el guardado de datos");
						return;
					}

					sendDataAndExecAppIntent(idSession, cipherKey, storageServletAddress, retrieverServletAddress, opId, params, successCallback, errorCallback)
				}
				else {
					execAppIntent(url, idSession, cipherKey, successCallback, errorCallback);
				}
			}
			
			/**
			 * Convierte texto plano en texto base 64.
			 * Implementada en el applet Java de firma.
			 */
			function getBase64FromText (plainText, charset) {
				return plainText != null ? Base64.encode(plainText) : null ;
			}

			/**
			 * Convierte texto base 64 en texto plano.
			 * Implementada en el applet Java de firma.
			 */
			function getTextFromBase64 (base64Text, charset) {
				return Base64.decode(base64Text);
			}
			
			/**
			 * Guardado de datos en disco. Se realiza mediante la invocacion de una app nativa. 
			 */
			function saveDataToFile (dataB64, title, filename, extension, description, successCallback, errorCallback) {

				if (dataB64 != undefined && dataB64 != null && dataB64 != "") {
					dataB64 = dataB64.replace(/\+/g, "-").replace(/\//g, "_");
				}

				var idSession = generateNewIdSession();
				var cipherKey = generateCipherKey();

				var i = 0;
				var opId = "save";
				var params = new Array();
				params[i++] = {key:"ver", value:PROTOCOL_VERSION};
				params[i++] = {key:"op", value:opId};
				if (idSession != null && idSession != undefined) {		params[i++] = {key:"id", value:idSession}; }
				if (cipherKey != null && cipherKey != undefined) {		params[i++] = {key:"key", value:cipherKey}; }
				if (storageServletAddress != null &&
						storageServletAddress != undefined) {			params[i++] = {key:"stservlet", value:storageServletAddress}; }
				if (title != null && title != undefined) {				params[i++] = {key:"title", value:title}; }
				if (filename != null && filename != undefined) {		params[i++] = {key:"filename", value:filename}; }
				if (extension != null && extension != undefined) {		params[i++] = {key:"extension", value:extension}; }
				if (description != null && description != undefined) {	params[i++] = {key:"description", value:description}; }
				if (dataB64 != null && dataB64 != undefined && dataB64 != "") {			params[i++] = {key:"dat", value:dataB64}; }

				var url = buildUrl(opId, params);

				// Si la URL es muy larga, realizamos un preproceso para que los datos se suban al
				// servidor y la aplicacion nativa los descargue, en lugar de pasarlos directamente 
				if (isURLTooLong(url)) {
					if (storageServletAddress == null || storageServletAddress == undefined) {
						throwException("java.lang.IllegalArgumentException", "No se ha indicado la direccion del servlet para el guardado de datos");
						return;
					}

					sendDataAndExecAppIntent(idSession, cipherKey, storageServletAddress, retrieverServletAddress, opId, params, successCallback, errorCallback)
				}
				else {
					execAppIntent(url, idSession, cipherKey, successCallback, errorCallback);
				}
			}

			/** 
			 * Funcion para la comprobacion de existencia del objeto. No hace nada.
			 * Implementada en el applet Java de firma.
			 */
			function echo () {
				return "Cliente JavaScript";
			}

			/**
			 * Recupera el mensaje de error asociado al ultimo error capturado.
			 * Implementada en el applet Java de firma.
			 */
			function getErrorMessage () {
				return errorMessage;
			}

			/**
			 * Recupera el tipo del ultimo error capturado.
			 * Implementada en el applet Java de firma.
			 */
			function getErrorType () {
				return errorType;
			}

			/**
			 * Recupera el log de la aplicacion. Actualmente, el log solo esta
			 * disponible en el applet, no en las aplicacion moviles.
			 */
			function getCurrentLog () {
				return "Applet no cargado";
			}

			/**
			 * Funcion para identificar el tipo de objeto del Cliente (javascript, applet,...).
			 */
			function getType () {
				return "javascript";
			}

			/**
			 * Establece las rutas de los servlets encargados de almacenar y recuperar las firmas de los dispositivos moviles.
			 */
			function setServlets (storageServlet,  retrieverServlet) {
				storageServletAddress = storageServlet;
				retrieverServletAddress = retrieverServlet;
			}

			/**
			 * Establece el error indicado como error interno y lanza una excepcion.
			 */
			function throwException (type, message) {
				errorType = type;
				errorMessage = message;
				throw new Error();
			}


			/**
			 * Comprueba si una URL es demasiado larga para ser usada en una llamada
			 * GET en un Sistema/Navegador concreto.
			 */
			function isURLTooLong(url) {

				// En las llamadas al esquema JNLP, Java soporta una cantidad
				// limitada de caracteres en la URL
				if (bJNLP) {
					return url.length > 500;
				}

				if (isAndroid()) {
					return url.length > MAX_LONG_ANDROID_URL;
				}
				else if (isIOS()) {
					return url.length > MAX_LONG_IOS_URL;
				}
				else if (isWindows8()) {
					return url.length > MAX_LONG_WINDOWS8_URL;
				}
				return url.length > MAX_LONG_GENERAL_URL;
			}
			
			/* Mayor entero. */
			var MAX_NUMBER = 2147483648;

			/* Caracteres validos para los ID de sesion */
			var VALID_CHARS_TO_ID = "1234567890abcdefghijklmnopqrstuwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

			/* Genera un identificador de sesion. */
			function generateNewIdSession () {
				var ID_LENGTH = 20;
				var random = "";
				var randomInts;
				if (typeof window.crypto != "undefined" && typeof window.crypto.getRandomValues != "undefined") {
					randomInts = new Uint32Array(ID_LENGTH);
					window.crypto.getRandomValues(randomInts);
				}
				else {
					randomInts = new Array(ID_LENGTH);
					for (var i = 0; i < ID_LENGTH; i++) {
						randomInts[i] = rnd() * MAX_NUMBER;
					}
				}

				for (var i = 0; i < ID_LENGTH; i++) {
					random += VALID_CHARS_TO_ID.charAt(Math.floor(randomInts[i] % VALID_CHARS_TO_ID.length));
				}

				return random;
			}

			/* Genera un numero aleatorio para utilizar como clave de cifrado. */
			function generateCipherKey() {
				var random;
				if (typeof window.crypto != "undefined" && typeof window.crypto.getRandomValues != "undefined") {
					var randomInts = new Uint32Array(1);
					window.crypto.getRandomValues(randomInts);
					random = zeroFill(randomInts[0] % 100000000, 8);
				}
				else {
					random = zeroFill(Math.floor(((rnd() * MAX_NUMBER) + 1) % 100000000), 8);
				}

				return random;
			}

			/* Completa un numero con ceros a la izquierda. */
			function zeroFill(number, width) {
				width -= number.toString().length;
				if (width > 0) {
					return new Array(width + (/\./.test(number) ? 2 : 1)).join('0')
					+ number;
				}
				return number + "";
			}

			/**
			 * Genera numeros aleatorios con una distribucion homogenea
			 */
			var seed;
			function rnd () {
				if (seed == undefined) {
					seed = new Date().getMilliseconds() * 1000 * Math.random();
				}
			    seed = (seed * 9301 + 49297) % 233280;
			    return seed / 233280;
			}

			/**
			 * Envia los datos al servidor intermedio y luego invoca a la
			 * aplicacion nativa para que los descargue y opere con ellos.
			 * @param idSession Identificador de la operacion con el que se espera recuperar el resultado.
			 * @param cipherKey Clave de cifrado. Si no se indica, no se cifra.
			 * @param storageServletAddress URL del servlet que almacena.
			 * @param retrieverServletAddress URL del servlet que recupera.
			 * @param op Identificador del tipo de operacion (firma, cofirma, guardado,...).
			 * @param params Parametros de configuracion de la operacion.
			 * @param successCallback Funcion callback que debe ejecutarse en caso de exito.
			 * @param errorCallback Funcion callback que debe ejecutarse en caso de error.
			 */
			function sendDataAndExecAppIntent(idSession, cipherKey, storageServletAddress, retrieverServletAddress, op, params, successCallback, errorCallback) {

				// Identificador del fichero (equivalente a un id de sesion) del que deben recuperarse los datos
				var fileId = generateNewIdSession(); 

				// Subimos los datos al servidor intermedio
				var httpRequest = getHttpRequest();
				if (!httpRequest) {
					throwException("java.lang.Exception", "Su navegador no permite preprocesar los datos que desea tratar");
				}
				httpRequest.open("POST", storageServletAddress, true);
				httpRequest.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

				httpRequest.onreadystatechange = function () {
					if (httpRequest.readyState == 4) {
						 if (httpRequest.status == 200) {
	
							url = buildUrlWithoutData(op, fileId, retrieverServletAddress, cipherKey);
							if (isURLTooLong(url)) {
								errorCallback("java.lang.IllegalArgumentException", "La URL de invocacion al servicio de firma es demasiado larga.");
								return;
							}
							execAppIntent(url, idSession, cipherKey, successCallback, errorCallback);
						}
						else {
							errorCallback("java.lang.IOException", "Ocurrio un error al enviar los datos a la aplicacion nativa");
						}
					}
				}
				
				httpRequest.onerror = function(e) {
					errorCallback("java.lang.IOException", "Ocurrio un error al enviar los datos al servicio intermedio para la comunicacion con la aplicacion nativa");
				}

				var requestData =
					"op=put&v=1_0&id=" + fileId + "&dat=" + 
					cipher(buildXML(op, params), cipherKey);

				try {
					httpRequest.send(requestData);
				}
				catch(e) {
					errorCallback("java.lang.IOException", "No se pudo conectar con el servidor remoto");
				}
			}
			
			/**
			 * Invoca un Intent con la operacion seleccionada, la configuraci\u00F3n establecida y las campos del
			 * formulario pasado como parametro. Si se define un callback para tratar el caso de exito o error de
			 * la operacion, se intentara descargar el resultado devuelto por la app del servidor intermedio de
			 * comunicacion. 
			 *
			 * @param intentURL URL para la invocacion del Cliente JavaScript
			 * @param idSession Identificador de la sesi\u00F3n para la recuperaci\u00F3n del resultado.
			 * @param cipherKey Clave de cifrado para la respuesta del servidor.
			 * @param successCallback Actuaci\u00F3n a realizar cuando se recupera el resultado de la operaci&oacute;n.
			 * @param errorCallback Actuaci\u00F3n a realizar cuando ocurre un error al recuperar el resultado.
			 */
			function execAppIntent (intentURL, idSession, cipherKey, successCallback, errorCallback) {

				wrongInstallation = false;
			
				// Invocamos al cliente de firma
				
				// Si no se pide cargar la aplicacion nativa, ni el entorno lo requiere y
				// si se ha configurado el servicio JNLP, cargamos la aplicacion JNLP
				if (!needNativeAppInstalled() && !!jnlpServiceAddress) {
					openUrl("jnlp" + jnlpServiceAddress.substring(4) + "?os=" + getOSName() + '&arg=' + Base64.encode(intentURL, true));
				}
				// En caso contrario, desplegamos la version nativa
				else {
					bJNLP = false;
					openUrl(intentURL);
				}

				// Preguntamos repetidamente por el resultado
				if (successCallback != null || errorCallback != null) {
					if (idSession != null && idSession != undefined && 
							((successCallback != undefined && successCallback != null) ||
									(errorCallback != undefined && errorCallback != null))) {
						getStoredFileFromServlet(idSession, retrieverServletAddress, cipherKey, successCallback, errorCallback);
					}
				}
			}

			/**
			 * Construye una URL para la invocacion del Cliente @firma nativo.
			 * @param op Funcion a invocar en el cliente nativo.
			 * @param params Parametros para la configuracion de la operacion.
			 */
			function buildUrl (op, params) {

				var urlParams = "";
				if (params != null && params != undefined) {
					for (var i = 0; i < params.length; i++) {
						if (params[i].value != null && params[i].value != "null") {
							urlParams += (i != 0 ? '&' : '') + params[i].key + '=' + encodeURIComponent(params[i].value); 
						}
					}
				}

				// En el caso de Chrome en Android, construimos la URL en forma de Intent
				var url;
				if (isChrome() && isAndroid()) {
					url = 'intent://' + op + '?' + urlParams + "#Intent;scheme=afirma;package=es.gob.afirma;end";
				}
				else {
					url = 'afirma://' + op + '?' + urlParams;
				}
				return url;
			}

			/**
			 * Construye un XML con lo valores del array de parametros proporcionado.
			 * @param op Operacion que configuramos
			 * @param params Array con los parametros del array. 
			 * @returns XML.
			 */
			function buildXML (op, params) {
				op = (op == null ? "op" : op);
				var xml = '<' + op +'>';
				if (params != null) {
					for (var i = 0; i < params.length; i++) {
						xml += '<e k="' + params[i].key + '" v="' + params[i].value + '"/>';
					}
				}
				return Base64.encode(xml + '</' + op + '>');
			}

			/**
			 * Crea una URL a partir de los parametros introducidos para la invocaci&oacute;n de
			 * una app nativa para que descargue la configuracion de la operaci&oacute;n a realizar.
			 * @param op Codigo de la operacion a la que tiene que invocar la URL.
			 * @param id Identificador para la descarga.
			 * @param rtServlet Servlet para la descarga de la configuraci&oacute;n.
			 * @param cipherKey Clave para el descifrado.
			 * @returns URL para la llamada a la app con los datos necesarios para que descargue
			 * la configuraci&oacute;n de la operaci&oacute;n a realizar.
			 */
			function buildUrlWithoutData (op, id, rtServlet, cipherKey) {
				var j = 0;
				var newParams = new Array();
				newParams[j++] = {key:"fileid", value:id};
				if (rtServlet != null || rtServlet != undefined) {
					newParams[j++] = {key:"rtservlet", value:rtServlet};
				}
				if (cipherKey != null || cipherKey != undefined) {
					newParams[j++] = {key:"key", value:cipherKey};
				}
				return buildUrl(op, newParams);
			};

			/**
			 * Ejecuta el metodo de error si el html recuperado es tal o el metodo de exito si no lo es,
			 * en cuyo caso previamente descifrara el resultado. 
			 * @param html Resultado obtenido.
			 * @param cipherKey Clave para el descifrado del resultado si no es un error.
			 * @param successCallback Metodo a ejecutar en caso de exito.
			 * @param errorCallback Metodo a ejecutar en caso de error.
			 * @returns Devuelve true si se ha fallado pero se puede volver a reintentar, false en caso de
			 * error determinante o exito.
			 */
			function successResponseFunction (html, cipherKey, successCallback, errorCallback) {
				
				// Si se obtiene el mensaje de  error de que el identificador no existe, seguimos intentandolo
				if (html.substr(0, 6).toLowerCase() == "err-06") {
					return true;
				}

				// Si se obtiene otro mensaje de error, se deja de intentar y se ejecuta la funcion callback de error
				if (html.substr(0, 4).toLowerCase() == "err-" && html.indexOf(":=") != -1) {
					errorMessage = html.substring(html.indexOf(":=") + 2);
					errorType = "java.lang.Exception";
					errorCallback(errorType, errorMessage);
					return false;
				}
				
				// Se ha cancelado la operacion
				if (html == "CANCEL" || html == "CANCEL\r\n") {
					errorCallback("es.gob.afirma.core.AOCancelledOperationException", "Operacion cancelada por el usuario");
					return false;
				}
				
				// La operacion ha finalizado correctamene (Funcion de guardado)
				if (html == "OK" || html == "OK\r\n") {
					successCallback();
					return false;
				}
				
				// Se ha producido un error
				if (html.length > 4 && html.substr(0, 4) == "SAF_") {
					errorCallback("java.lang.Exception", html);
					return false;
				}
				
				// Si no se obtuvo un error, habremos recibido la firma y posiblemente el certificado (que antecederia a la
				// firma y se separaria de ella con '|'). Si se definio una clave de cifrado, consideramos que la firma
				// y el certificado (en caso de estar) llegan cifrados. El cifrado de ambos elementos es independiente
				var certificate;
				var signature;
				var sepPos = html.indexOf('|');
				if (sepPos == -1) {
					if (cipherKey != undefined && cipherKey != null) {
						signature = decipher(html, cipherKey);
					}
					else {
						signature = fromBase64UrlSaveToBase64(html);
					}
				}
				else {
					if (cipherKey != undefined && cipherKey != null) {
						certificate = decipher(html.substring(0, sepPos), cipherKey, true);
						signature = decipher(html.substring(sepPos + 1), cipherKey);
					}
					else {
						certificate = fromBase64UrlSaveToBase64(html.substring(0, sepPos));
						signature = fromBase64UrlSaveToBase64(html.substring(sepPos + 1));
					}
				}

				successCallback(signature, certificate);

				return false;
			}

			function errorResponseFunction (type, message, errorCallback) {

				errorType = (type != null && type.length > 0) ?
						type : "java.lang.Exception";
				errorMessage = (message != null && message.length > 0) ?
						message : "No se ha podido extablecer la comunicaci\u00F3n entre la aplicaci\u00F3n de firma y la p\u00E1gina web";
				if (errorCallback != undefined && errorCallback != null) {
					errorCallback(errorType, errorMessage);
				}
			}

			var NUM_MAX_ITERATIONS = 15;
			var iterations = 0;

			function getStoredFileFromServlet (idDocument, servletAddress, cipherKey, successCallback, errorCallback) {

				var httpRequest = getHttpRequest();
				if (!httpRequest) {
					throwException("java.lang.Exception", "Su navegador no permite obtener el resulado de la operaci\u00F3n");
				}

				iterations = 0;
				setTimeout(retrieveRequest, 4000, httpRequest, servletAddress, "op=get&v=1_0&id=" + idDocument + "&it=0", cipherKey, successCallback, errorCallback);
			}

			function retrieveRequest(httpRequest, url, params, cipherKey, successCallback, errorCallback) {

				if (wrongInstallation) {
					errorResponseFunction("es.gob.afirma.standalone.ApplicationNotFoundException", "AutoFirma no se encuentra instalado en el sistema.", errorCallback);
					return;
				}
			
				// Contamos la nueva llamada al servidor
				if (iterations > NUM_MAX_ITERATIONS) {
					errorResponseFunction("java.util.concurrent.TimeoutException", "El tiempo para la recepcion de la firma por la pagina web ha expirado", errorCallback);
					return;
				}
				iterations++;

				httpRequest.onreadystatechange = function() {
					if (httpRequest.readyState == 4) {
						if (httpRequest.status == 200) {
							var needContinue = successResponseFunction(httpRequest.responseText, cipherKey, successCallback, errorCallback);
							if (needContinue) {
								setTimeout(retrieveRequest, 4000, httpRequest, url, params.replace("&it=" + (iterations-1), "&it=" + iterations), cipherKey, successCallback, errorCallback);
							}
						}
						else {
							errorResponseFunction(null, httpRequest.responseText, errorCallback);
						}
					}					
				}
				
				httpRequest.onerror = function() {
					errorResponseFunction("java.lang.Exception", "No se pudo conectar con el servidor intermedio para la recuperacion del resultado de la operacion", errorCallback);
				}

				httpRequest.open("POST", url, true);
				httpRequest.setRequestHeader("Content-type","application/x-www-form-urlencoded");
				
				try {
					httpRequest.send(params);
				}
				catch(e) {
					// Error en la llamada para al recuperacion del resultado. No lo encuentra o problema
					// de tipo cross-domain
					errorResponseFunction("java.lang.IOException", "Ocurrio un error de red en la llamada al servicio de firma", errorCallback);
					return;
				}
			}

			/**
			 * Realiza un descifrado DES compatible con Java (Algoritmo DES, modo CBC, sin Padding).
			 * Recibe en base 64 la cadena de texto cifrado antecedido por el padding anadido manualmente
			 * a los datos para permitir el cifrado DES (separado por un punto ('.')), ademas de la clave
			 * para descifrar y, opcionalmente, un booleano que indica si se trata de un cifrado intermedio
			 * devuelto por la aplicacion, lo que permite reajustar el padding.
			 * Como resultado devuelve la cadena de texto descifrada en base 64.
			 */
			function decipher(cipheredData, key, intermediate) {
								
				var dotPos = cipheredData.indexOf('.');
				var padding = cipheredData.substr(0, dotPos);
				
				var deciphered = Cipher.des(key, Cipher.base64ToString(fromBase64UrlSaveToBase64(cipheredData.substr(dotPos + 1))), 0, 0, null);
				return Cipher.stringToBase64(deciphered.substr(0, deciphered.length - parseInt(padding) - (intermediate ? 0 : 8)));
			}
			
			/**
			 * Realiza un cifrado DES compatible con Java (Algoritmo DES, modo CBC, sin Padding).
			 * @param dataB64 Cadena de texto base 64.
			 * @param key Clave de cifrado.
			 * @return Base 64 cifrado.
			 */
			function cipher(dataB64, key) {

				var data = Cipher.base64ToString(fromBase64UrlSaveToBase64(dataB64));
				var padding = (8 - (data.length % 8)) % 8;

				// Los datos cifrados los pasamos a base 64 y, antes de devolverlos le anteponemos el padding que
				// le habra agregado el metodo de cifrado separados por un punto ('.').
				return padding  + "." + Cipher.stringToBase64(Cipher.des(key, data, 1, 0, null)).replace(/\+/g, "-").replace(/\//g, "_");
			}

			/**
			 * Convierte de Base64 URL Save a Base64 normal.
			 */
			function fromBase64UrlSaveToBase64(base64UrlSave) {
				if (!base64UrlSave) {
					return base64UrlSave;
				}
				return base64UrlSave.replace(/\-/g, "+").replace(/\_/g, "/")
			}

			/* Metodos que publicamos del objeto AppAfirmaJS */
			return {
				echo : echo,
				checkTime : checkTime,
				setKeyStore : setKeyStore,
				sign : sign,
				coSign : coSign,
				counterSign : counterSign,
				signBatch : signBatch,
				selectCertificate : selectCertificate,
				saveDataToFile : saveDataToFile,
				signAndSaveToFile : signAndSaveToFile,
				getFileNameContentBase64: getFileNameContentBase64,
				getMultiFileNameContentBase64 : getMultiFileNameContentBase64,
				getBase64FromText : getBase64FromText,
				getTextFromBase64 : getTextFromBase64,
				setServlets : setServlets,
				setJnlpService: setJnlpService,
				setStickySignatory : setStickySignatory,
				setLocale : setLocale,
				getErrorMessage : getErrorMessage,
				getErrorType : getErrorType,
				getCurrentLog : getCurrentLog
			}
		});

		/* Metodos que publicamos del objeto MiniApplet */
		return {
			
			VERSION : VERSION,
			
			/* Publicamos las variables para la comprobacion de hora. */		
			CHECKTIME_NO : CHECKTIME_NO,
			CHECKTIME_RECOMMENDED : CHECKTIME_RECOMMENDED,
			CHECKTIME_OBLIGATORY : CHECKTIME_OBLIGATORY,
			
			/* Publicamos las variables para establecer parametros personalizados en la JVM */
			JAVA_ARGUMENTS : JAVA_ARGUMENTS,
			SYSTEM_PROPERTIES : SYSTEM_PROPERTIES,
			
			/* Publicamos las variables para configurar un almacen de certificados concreto. */		
			KEYSTORE_WINDOWS : KEYSTORE_WINDOWS,
			KEYSTORE_APPLE : KEYSTORE_APPLE,
			KEYSTORE_PKCS12 : KEYSTORE_PKCS12,
			KEYSTORE_PKCS11 : KEYSTORE_PKCS11,
			KEYSTORE_MOZILLA : KEYSTORE_MOZILLA,
			KEYSTORE_SHARED_NSS : KEYSTORE_SHARED_NSS,
			KEYSTORE_JAVA : KEYSTORE_JAVA,
			KEYSTORE_JCEKS : KEYSTORE_JCEKS,
			KEYSTORE_JAVACE : KEYSTORE_JAVACE,
			KEYSTORE_DNIE : KEYSTORE_DNIE,

			/* Constantes para la deteccion de la aplicacion de autofirma */
			AUTOFIRMA_LAUNCHING_TIME : AUTOFIRMA_LAUNCHING_TIME,
			AUTOFIRMA_CONNECTION_RETRIES : AUTOFIRMA_CONNECTION_RETRIES,

			/* Variable para forzar el uso del mecanismo de comunicacion por servidor intermedio */
			setForceWSMode : setForceWSMode,
			setForceAFirma : setForceAFirma,
			/* Metodos visibles. */
			cargarMiniApplet : cargarMiniApplet,
			cargarAppAfirma : cargarAppAfirma,
			echo : echo,
			checkTime : checkTime,
			sign : sign,
			coSign : coSign,
			counterSign : counterSign,
			signBatch : signBatch,
			selectCertificate : selectCertificate,
			saveDataToFile : saveDataToFile,
			signAndSaveToFile : signAndSaveToFile,
			getFileNameContentBase64: getFileNameContentBase64,
			getMultiFileNameContentBase64 : getMultiFileNameContentBase64,
			getBase64FromText : getBase64FromText,
			getTextFromBase64 : getTextFromBase64,
			downloadRemoteData : downloadRemoteData,
			setKeyStore : setKeyStore,
			setServlets : setServlets,
			setJnlpService: setJnlpService,
			setStickySignatory : setStickySignatory,
			setLocale : setLocale,
			getErrorMessage : getErrorMessage,
			getErrorType : getErrorType,
			getCurrentLog : getCurrentLog,
			isAndroid : isAndroid,
			isIOS : isIOS,
			isJNLP : isJNLP,
			needNativeAppInstalled : needNativeAppInstalled
		};
})(window, undefined);





/**
 *  Base64 encode / decode
 *  http://www.webtoolkit.info/
 */
var Base64 = {

		// private property
		_keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
		_keyStr_URL_SAFE : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",

		// public method for encoding
		encode : function (input, URL_SAFE) {
			
			var keyStr = (URL_SAFE == true) ? this._keyStr_URL_SAFE : this._keyStr;
			
			var output = "";
			var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
			var i = 0;

			input = Base64._utf8_encode(input);

			while (i < input.length) {

				chr1 = input.charCodeAt(i++);
				chr2 = input.charCodeAt(i++);
				chr3 = input.charCodeAt(i++);

				enc1 = chr1 >> 2;
				enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
				enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
				enc4 = chr3 & 63;

				if (isNaN(chr2)) {
					enc3 = enc4 = 64;
				} else if (isNaN(chr3)) {
					enc4 = 64;
				}

				output = output +
				keyStr.charAt(enc1) + keyStr.charAt(enc2) +
				keyStr.charAt(enc3) + keyStr.charAt(enc4);

			}

			return output;
		},

		/**
		 * Codifica los datos binarios obtenidos en un ArrayBuffer.
		 */
		encodeArrayBuffer : function(input, URL_SAFE) {
			
			var uInt8Array = new Uint8Array(input);
		    var i = uInt8Array.length;
		    var binaryString = new Array(i);
		    while (i--)
		    {
		      binaryString[i] = String.fromCharCode(uInt8Array[i]);
		    }

		    return URL_SAFE ?
		    		window.btoa(binaryString.join('')).replace('+', '-').replace('/', '_') :
		    			window.btoa(binaryString.join(''));
		},
		
		/**
		 * Codifica un array de bytes a Base64.
		 *
		 * @param {Array.<number>|Uint8Array} input An array of bytes (numbers with
		 *     value in [0, 255]) to encode.
		 * @param {boolean=} opt_webSafe Boolean indicating we should use the
		 *     alternative alphabet.
		 * @return {string} The base64 encoded string.
		 */
		encodeByteArray : function(input, URL_SAFE) {

		  var keyStr = (URL_SAFE == true) ? this._keyStr_URL_SAFE : this._keyStr;

		  var output = [];

		  for (var i = 0; i < input.length; i += 3) {
		    var byte1 = input[i];
		    var haveByte2 = i + 1 < input.length;
		    var byte2 = haveByte2 ? input[i + 1] : 0;
		    var haveByte3 = i + 2 < input.length;
		    var byte3 = haveByte3 ? input[i + 2] : 0;

		    var outByte1 = byte1 >> 2;
		    var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
		    var outByte3 = ((byte2 & 0x0F) << 2) | (byte3 >> 6);
		    var outByte4 = byte3 & 0x3F;

		    if (!haveByte3) {
		      outByte4 = 64;

		      if (!haveByte2) {
		        outByte3 = 64;
		      }
		    }

		    output.push(keyStr.charAt(outByte1),
		    			keyStr.charAt(outByte2),
		    			keyStr.charAt(outByte3),
		    			keyStr.charAt(outByte4));
		  }

		  return output.join('');
		},
		
		// public method for decoding
		decode : function (input, URL_SAFE) {
			
			var keyStr = (URL_SAFE == true) ? this._keyStr_URL_SAFE : this._keyStr;
			
			var output = "";
			var chr1, chr2, chr3;
			var enc1, enc2, enc3, enc4;
			var i = 0;

			input = (URL_SAFE == true) ? input.replace(/[^A-Za-z0-9\-\_\=]/g, "") : input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

			while (i < input.length) {

				enc1 = keyStr.indexOf(input.charAt(i++));
				enc2 = keyStr.indexOf(input.charAt(i++));
				enc3 = keyStr.indexOf(input.charAt(i++));
				enc4 = keyStr.indexOf(input.charAt(i++));

				chr1 = (enc1 << 2) | (enc2 >> 4);
				chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
				chr3 = ((enc3 & 3) << 6) | enc4;

				output = output + String.fromCharCode(chr1);

				if (enc3 != 64) {
					output = output + String.fromCharCode(chr2);
				}
				if (enc4 != 64) {
					output = output + String.fromCharCode(chr3);
				}

			}

			output = Base64._utf8_decode(output);

			return output;

		},

		// private method for UTF-8 encoding
		_utf8_encode : function (string) {
			string = string.replace(/\r\n/g,"\n");
			var utftext = "";

			for (var n = 0; n < string.length; n++) {

				var c = string.charCodeAt(n);

				if (c < 128) {
					utftext += String.fromCharCode(c);
				}
				else if((c > 127) && (c < 2048)) {
					utftext += String.fromCharCode((c >> 6) | 192);
					utftext += String.fromCharCode((c & 63) | 128);
				}
				else {
					utftext += String.fromCharCode((c >> 12) | 224);
					utftext += String.fromCharCode(((c >> 6) & 63) | 128);
					utftext += String.fromCharCode((c & 63) | 128);
				}

			}

			return utftext;
		},

		// private method for UTF-8 decoding
		_utf8_decode : function (utftext) {
			var string = "";
			var i = 0;
			var c = 0;
			var c1 = 0;
			var c2 = 0;

			while ( i < utftext.length ) {

				c = utftext.charCodeAt(i);

				if (c < 128) {
					string += String.fromCharCode(c);
					i++;
				}
				else if((c > 191) && (c < 224)) {
					c2 = utftext.charCodeAt(i+1);
					string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
					i += 2;
				}
				else {
					c2 = utftext.charCodeAt(i+1);
					var c3 = utftext.charCodeAt(i+2);
					string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
					i += 3;
				}
			}

			return string;
		}
};

//Paul Tero, July 2001
//http://www.tero.co.uk/des/

//Optimised for performance with large blocks by Michael Hayworth, November 2001
//http://www.netdealing.com

//THIS SOFTWARE IS PROVIDED "AS IS" AND
//ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
//IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
//ARE DISCLAIMED.  IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE
//FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
//DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS
//OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)
//HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
//LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY
//OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
//SUCH DAMAGE.

//des
//this takes the key, the message, and whether to encrypt or decrypt
var Cipher = {
	tableStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
	tableStr_URL_SAFE : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",
	
	des : function  (key, message, encrypt, mode, iv, padding) {
		//declaring this locally speeds things up a bit
		var spfunction1 = new Array (0x1010400,0,0x10000,0x1010404,0x1010004,0x10404,0x4,0x10000,0x400,0x1010400,0x1010404,0x400,0x1000404,0x1010004,0x1000000,0x4,0x404,0x1000400,0x1000400,0x10400,0x10400,0x1010000,0x1010000,0x1000404,0x10004,0x1000004,0x1000004,0x10004,0,0x404,0x10404,0x1000000,0x10000,0x1010404,0x4,0x1010000,0x1010400,0x1000000,0x1000000,0x400,0x1010004,0x10000,0x10400,0x1000004,0x400,0x4,0x1000404,0x10404,0x1010404,0x10004,0x1010000,0x1000404,0x1000004,0x404,0x10404,0x1010400,0x404,0x1000400,0x1000400,0,0x10004,0x10400,0,0x1010004);
		var spfunction2 = new Array (-0x7fef7fe0,-0x7fff8000,0x8000,0x108020,0x100000,0x20,-0x7fefffe0,-0x7fff7fe0,-0x7fffffe0,-0x7fef7fe0,-0x7fef8000,-0x80000000,-0x7fff8000,0x100000,0x20,-0x7fefffe0,0x108000,0x100020,-0x7fff7fe0,0,-0x80000000,0x8000,0x108020,-0x7ff00000,0x100020,-0x7fffffe0,0,0x108000,0x8020,-0x7fef8000,-0x7ff00000,0x8020,0,0x108020,-0x7fefffe0,0x100000,-0x7fff7fe0,-0x7ff00000,-0x7fef8000,0x8000,-0x7ff00000,-0x7fff8000,0x20,-0x7fef7fe0,0x108020,0x20,0x8000,-0x80000000,0x8020,-0x7fef8000,0x100000,-0x7fffffe0,0x100020,-0x7fff7fe0,-0x7fffffe0,0x100020,0x108000,0,-0x7fff8000,0x8020,-0x80000000,-0x7fefffe0,-0x7fef7fe0,0x108000);
		var spfunction3 = new Array (0x208,0x8020200,0,0x8020008,0x8000200,0,0x20208,0x8000200,0x20008,0x8000008,0x8000008,0x20000,0x8020208,0x20008,0x8020000,0x208,0x8000000,0x8,0x8020200,0x200,0x20200,0x8020000,0x8020008,0x20208,0x8000208,0x20200,0x20000,0x8000208,0x8,0x8020208,0x200,0x8000000,0x8020200,0x8000000,0x20008,0x208,0x20000,0x8020200,0x8000200,0,0x200,0x20008,0x8020208,0x8000200,0x8000008,0x200,0,0x8020008,0x8000208,0x20000,0x8000000,0x8020208,0x8,0x20208,0x20200,0x8000008,0x8020000,0x8000208,0x208,0x8020000,0x20208,0x8,0x8020008,0x20200);
		var spfunction4 = new Array (0x802001,0x2081,0x2081,0x80,0x802080,0x800081,0x800001,0x2001,0,0x802000,0x802000,0x802081,0x81,0,0x800080,0x800001,0x1,0x2000,0x800000,0x802001,0x80,0x800000,0x2001,0x2080,0x800081,0x1,0x2080,0x800080,0x2000,0x802080,0x802081,0x81,0x800080,0x800001,0x802000,0x802081,0x81,0,0,0x802000,0x2080,0x800080,0x800081,0x1,0x802001,0x2081,0x2081,0x80,0x802081,0x81,0x1,0x2000,0x800001,0x2001,0x802080,0x800081,0x2001,0x2080,0x800000,0x802001,0x80,0x800000,0x2000,0x802080);
		var spfunction5 = new Array (0x100,0x2080100,0x2080000,0x42000100,0x80000,0x100,0x40000000,0x2080000,0x40080100,0x80000,0x2000100,0x40080100,0x42000100,0x42080000,0x80100,0x40000000,0x2000000,0x40080000,0x40080000,0,0x40000100,0x42080100,0x42080100,0x2000100,0x42080000,0x40000100,0,0x42000000,0x2080100,0x2000000,0x42000000,0x80100,0x80000,0x42000100,0x100,0x2000000,0x40000000,0x2080000,0x42000100,0x40080100,0x2000100,0x40000000,0x42080000,0x2080100,0x40080100,0x100,0x2000000,0x42080000,0x42080100,0x80100,0x42000000,0x42080100,0x2080000,0,0x40080000,0x42000000,0x80100,0x2000100,0x40000100,0x80000,0,0x40080000,0x2080100,0x40000100);
		var spfunction6 = new Array (0x20000010,0x20400000,0x4000,0x20404010,0x20400000,0x10,0x20404010,0x400000,0x20004000,0x404010,0x400000,0x20000010,0x400010,0x20004000,0x20000000,0x4010,0,0x400010,0x20004010,0x4000,0x404000,0x20004010,0x10,0x20400010,0x20400010,0,0x404010,0x20404000,0x4010,0x404000,0x20404000,0x20000000,0x20004000,0x10,0x20400010,0x404000,0x20404010,0x400000,0x4010,0x20000010,0x400000,0x20004000,0x20000000,0x4010,0x20000010,0x20404010,0x404000,0x20400000,0x404010,0x20404000,0,0x20400010,0x10,0x4000,0x20400000,0x404010,0x4000,0x400010,0x20004010,0,0x20404000,0x20000000,0x400010,0x20004010);
		var spfunction7 = new Array (0x200000,0x4200002,0x4000802,0,0x800,0x4000802,0x200802,0x4200800,0x4200802,0x200000,0,0x4000002,0x2,0x4000000,0x4200002,0x802,0x4000800,0x200802,0x200002,0x4000800,0x4000002,0x4200000,0x4200800,0x200002,0x4200000,0x800,0x802,0x4200802,0x200800,0x2,0x4000000,0x200800,0x4000000,0x200800,0x200000,0x4000802,0x4000802,0x4200002,0x4200002,0x2,0x200002,0x4000000,0x4000800,0x200000,0x4200800,0x802,0x200802,0x4200800,0x802,0x4000002,0x4200802,0x4200000,0x200800,0,0x2,0x4200802,0,0x200802,0x4200000,0x800,0x4000002,0x4000800,0x800,0x200002);
		var spfunction8 = new Array (0x10001040,0x1000,0x40000,0x10041040,0x10000000,0x10001040,0x40,0x10000000,0x40040,0x10040000,0x10041040,0x41000,0x10041000,0x41040,0x1000,0x40,0x10040000,0x10000040,0x10001000,0x1040,0x41000,0x40040,0x10040040,0x10041000,0x1040,0,0,0x10040040,0x10000040,0x10001000,0x41040,0x40000,0x41040,0x40000,0x10041000,0x1000,0x40,0x10040040,0x1000,0x41040,0x10001000,0x40,0x10000040,0x10040000,0x10040040,0x10000000,0x40000,0x10001040,0,0x10041040,0x40040,0x10000040,0x10040000,0x10001000,0x10001040,0,0x10041040,0x41000,0x41000,0x1040,0x1040,0x40040,0x10000000,0x10041000);

		//create the 16 or 48 subkeys we will need
		var keys = Cipher.des_createKeys (key);
		var m=0, i, j, temp, right1, right2, left, right, looping;
		var cbcleft, cbcleft2, cbcright, cbcright2;
		var endloop, loopinc;
		var len = message.length;
		var chunk = 0;
		//set up the loops for single and triple des
		var iterations = keys.length == 32 ? 3 : 9; //single or triple des
		if (iterations == 3) {looping = encrypt ? new Array (0, 32, 2) : new Array (30, -2, -2);}
		else {looping = encrypt ? new Array (0, 32, 2, 62, 30, -2, 64, 96, 2) : new Array (94, 62, -2, 32, 64, 2, 30, -2, -2);}

		//pad the message depending on the padding parameter
		if (padding == 2) message += "        "; //pad the message with spaces
		else if (padding == 1) {temp = 8-(len%8); message += String.fromCharCode (temp,temp,temp,temp,temp,temp,temp,temp); if (temp==8) len+=8;} //PKCS7 padding
		else if (!padding) message += "\0\0\0\0\0\0\0\0"; //pad the message out with null bytes

		//store the result here
		var result = "";
		var tempresult = "";

		if (mode == 1) { //CBC mode
			cbcleft = (iv.charCodeAt(m++) << 24) | (iv.charCodeAt(m++) << 16) | (iv.charCodeAt(m++) << 8) | iv.charCodeAt(m++);
			cbcright = (iv.charCodeAt(m++) << 24) | (iv.charCodeAt(m++) << 16) | (iv.charCodeAt(m++) << 8) | iv.charCodeAt(m++);
			m=0;
		}

		 //loop through each 64 bit chunk of the message
		while (m < len) {
			left = (message.charCodeAt(m++) << 24) | (message.charCodeAt(m++) << 16) | (message.charCodeAt(m++) << 8) | message.charCodeAt(m++);
			right = (message.charCodeAt(m++) << 24) | (message.charCodeAt(m++) << 16) | (message.charCodeAt(m++) << 8) | message.charCodeAt(m++);

			//for Cipher Block Chaining mode, xor the message with the previous result
			if (mode == 1) {if (encrypt) {left ^= cbcleft; right ^= cbcright;} else {cbcleft2 = cbcleft; cbcright2 = cbcright; cbcleft = left; cbcright = right;}}

			//first each 64 but chunk of the message must be permuted according to IP
			temp = ((left >>> 4) ^ right) & 0x0f0f0f0f; right ^= temp; left ^= (temp << 4);
			temp = ((left >>> 16) ^ right) & 0x0000ffff; right ^= temp; left ^= (temp << 16);
			temp = ((right >>> 2) ^ left) & 0x33333333; left ^= temp; right ^= (temp << 2);
			temp = ((right >>> 8) ^ left) & 0x00ff00ff; left ^= temp; right ^= (temp << 8);
			temp = ((left >>> 1) ^ right) & 0x55555555; right ^= temp; left ^= (temp << 1);

			left = ((left << 1) | (left >>> 31)); 
			right = ((right << 1) | (right >>> 31)); 

			//do this either 1 or 3 times for each chunk of the message
			for (j=0; j<iterations; j+=3) {
				endloop = looping[j+1];
				loopinc = looping[j+2];
				//now go through and perform the encryption or decryption  
				for (i=looping[j]; i!=endloop; i+=loopinc) { //for efficiency
					right1 = right ^ keys[i]; 
					right2 = ((right >>> 4) | (right << 28)) ^ keys[i+1];
					//the result is attained by passing these bytes through the S selection functions
					temp = left;
					left = right;
					right = temp ^ (spfunction2[(right1 >>> 24) & 0x3f] | spfunction4[(right1 >>> 16) & 0x3f]
						  | spfunction6[(right1 >>>  8) & 0x3f] | spfunction8[right1 & 0x3f]
						  | spfunction1[(right2 >>> 24) & 0x3f] | spfunction3[(right2 >>> 16) & 0x3f]
						  | spfunction5[(right2 >>>  8) & 0x3f] | spfunction7[right2 & 0x3f]);
				}
				temp = left; left = right; right = temp; //unreverse left and right
			} //for either 1 or 3 iterations

			//move then each one bit to the right
			left = ((left >>> 1) | (left << 31)); 
			right = ((right >>> 1) | (right << 31)); 

			//now perform IP-1, which is IP in the opposite direction
			temp = ((left >>> 1) ^ right) & 0x55555555; right ^= temp; left ^= (temp << 1);
			temp = ((right >>> 8) ^ left) & 0x00ff00ff; left ^= temp; right ^= (temp << 8);
			temp = ((right >>> 2) ^ left) & 0x33333333; left ^= temp; right ^= (temp << 2);
			temp = ((left >>> 16) ^ right) & 0x0000ffff; right ^= temp; left ^= (temp << 16);
			temp = ((left >>> 4) ^ right) & 0x0f0f0f0f; right ^= temp; left ^= (temp << 4);

			//for Cipher Block Chaining mode, xor the message with the previous result
			if (mode == 1) {if (encrypt) {cbcleft = left; cbcright = right;} else {left ^= cbcleft2; right ^= cbcright2;}}
			tempresult += String.fromCharCode ((left>>>24), ((left>>>16) & 0xff), ((left>>>8) & 0xff), (left & 0xff), (right>>>24), ((right>>>16) & 0xff), ((right>>>8) & 0xff), (right & 0xff));

			chunk += 8;
			if (chunk == 512) {result += tempresult; tempresult = ""; chunk = 0;}
		  } //for every 8 characters, or 64 bits in the message

		  //return the result as an array
		  return result + tempresult;
	},

	//this takes as input a 64 bit key (even though only 56 bits are used)
	//as an array of 2 integers, and returns 16 48 bit keys
	des_createKeys : function (key) {
		//declaring this locally speeds things up a bit
		var pc2bytes0  = new Array (0,0x4,0x20000000,0x20000004,0x10000,0x10004,0x20010000,0x20010004,0x200,0x204,0x20000200,0x20000204,0x10200,0x10204,0x20010200,0x20010204);
		var pc2bytes1  = new Array (0,0x1,0x100000,0x100001,0x4000000,0x4000001,0x4100000,0x4100001,0x100,0x101,0x100100,0x100101,0x4000100,0x4000101,0x4100100,0x4100101);
		var pc2bytes2  = new Array (0,0x8,0x800,0x808,0x1000000,0x1000008,0x1000800,0x1000808,0,0x8,0x800,0x808,0x1000000,0x1000008,0x1000800,0x1000808);
		var pc2bytes3  = new Array (0,0x200000,0x8000000,0x8200000,0x2000,0x202000,0x8002000,0x8202000,0x20000,0x220000,0x8020000,0x8220000,0x22000,0x222000,0x8022000,0x8222000);
		var pc2bytes4  = new Array (0,0x40000,0x10,0x40010,0,0x40000,0x10,0x40010,0x1000,0x41000,0x1010,0x41010,0x1000,0x41000,0x1010,0x41010);
		var pc2bytes5  = new Array (0,0x400,0x20,0x420,0,0x400,0x20,0x420,0x2000000,0x2000400,0x2000020,0x2000420,0x2000000,0x2000400,0x2000020,0x2000420);
		var pc2bytes6  = new Array (0,0x10000000,0x80000,0x10080000,0x2,0x10000002,0x80002,0x10080002,0,0x10000000,0x80000,0x10080000,0x2,0x10000002,0x80002,0x10080002);
		var pc2bytes7  = new Array (0,0x10000,0x800,0x10800,0x20000000,0x20010000,0x20000800,0x20010800,0x20000,0x30000,0x20800,0x30800,0x20020000,0x20030000,0x20020800,0x20030800);
		var pc2bytes8  = new Array (0,0x40000,0,0x40000,0x2,0x40002,0x2,0x40002,0x2000000,0x2040000,0x2000000,0x2040000,0x2000002,0x2040002,0x2000002,0x2040002);
		var pc2bytes9  = new Array (0,0x10000000,0x8,0x10000008,0,0x10000000,0x8,0x10000008,0x400,0x10000400,0x408,0x10000408,0x400,0x10000400,0x408,0x10000408);
		var pc2bytes10 = new Array (0,0x20,0,0x20,0x100000,0x100020,0x100000,0x100020,0x2000,0x2020,0x2000,0x2020,0x102000,0x102020,0x102000,0x102020);
		var pc2bytes11 = new Array (0,0x1000000,0x200,0x1000200,0x200000,0x1200000,0x200200,0x1200200,0x4000000,0x5000000,0x4000200,0x5000200,0x4200000,0x5200000,0x4200200,0x5200200);
		var pc2bytes12 = new Array (0,0x1000,0x8000000,0x8001000,0x80000,0x81000,0x8080000,0x8081000,0x10,0x1010,0x8000010,0x8001010,0x80010,0x81010,0x8080010,0x8081010);
		var pc2bytes13 = new Array (0,0x4,0x100,0x104,0,0x4,0x100,0x104,0x1,0x5,0x101,0x105,0x1,0x5,0x101,0x105);

		//how many iterations (1 for des, 3 for triple des)
		var iterations = key.length > 8 ? 3 : 1; //changed by Paul 16/6/2007 to use Triple DES for 9+ byte keys
		//stores the return keys
		var keys = new Array (32 * iterations);
		//now define the left shifts which need to be done
		var shifts = new Array (0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0);
		//other variables
		var lefttemp, righttemp, m=0, n=0, temp;

		for (var j=0; j<iterations; j++) { //either 1 or 3 iterations
			var left = (key.charCodeAt(m++) << 24) | (key.charCodeAt(m++) << 16) | (key.charCodeAt(m++) << 8) | key.charCodeAt(m++);
			var right = (key.charCodeAt(m++) << 24) | (key.charCodeAt(m++) << 16) | (key.charCodeAt(m++) << 8) | key.charCodeAt(m++);

			temp = ((left >>> 4) ^ right) & 0x0f0f0f0f; right ^= temp; left ^= (temp << 4);
			temp = ((right >>> -16) ^ left) & 0x0000ffff; left ^= temp; right ^= (temp << -16);
			temp = ((left >>> 2) ^ right) & 0x33333333; right ^= temp; left ^= (temp << 2);
			temp = ((right >>> -16) ^ left) & 0x0000ffff; left ^= temp; right ^= (temp << -16);
			temp = ((left >>> 1) ^ right) & 0x55555555; right ^= temp; left ^= (temp << 1);
			temp = ((right >>> 8) ^ left) & 0x00ff00ff; left ^= temp; right ^= (temp << 8);
			temp = ((left >>> 1) ^ right) & 0x55555555; right ^= temp; left ^= (temp << 1);

			//the right side needs to be shifted and to get the last four bits of the left side
			temp = (left << 8) | ((right >>> 20) & 0x000000f0);
			//left needs to be put upside down
			left = (right << 24) | ((right << 8) & 0xff0000) | ((right >>> 8) & 0xff00) | ((right >>> 24) & 0xf0);
			right = temp;

			//now go through and perform these shifts on the left and right keys
			for (var i=0; i < shifts.length; i++) {
				//shift the keys either one or two bits to the left
				if (shifts[i]) {left = (left << 2) | (left >>> 26); right = (right << 2) | (right >>> 26);}
				else {left = (left << 1) | (left >>> 27); right = (right << 1) | (right >>> 27);}
				left &= -0xf; right &= -0xf;

				//now apply PC-2, in such a way that E is easier when encrypting or decrypting
				//this conversion will look like PC-2 except only the last 6 bits of each byte are used
				//rather than 48 consecutive bits and the order of lines will be according to 
				//how the S selection functions will be applied: S2, S4, S6, S8, S1, S3, S5, S7
				lefttemp = pc2bytes0[left >>> 28] | pc2bytes1[(left >>> 24) & 0xf]
					  | pc2bytes2[(left >>> 20) & 0xf] | pc2bytes3[(left >>> 16) & 0xf]
					  | pc2bytes4[(left >>> 12) & 0xf] | pc2bytes5[(left >>> 8) & 0xf]
					  | pc2bytes6[(left >>> 4) & 0xf];
				righttemp = pc2bytes7[right >>> 28] | pc2bytes8[(right >>> 24) & 0xf]
						| pc2bytes9[(right >>> 20) & 0xf] | pc2bytes10[(right >>> 16) & 0xf]
						| pc2bytes11[(right >>> 12) & 0xf] | pc2bytes12[(right >>> 8) & 0xf]
						| pc2bytes13[(right >>> 4) & 0xf];
				temp = ((righttemp >>> 16) ^ lefttemp) & 0x0000ffff; 
				keys[n++] = lefttemp ^ temp; keys[n++] = righttemp ^ (temp << 16);
			}
		} //for each iterations
		  //return the keys we've created
		return keys;
	},

	//Convierte una cadena a Base 64. Debido a un error en el algoritmo original, pasaremos
	// de cadena a hexadecimal y de hexadecimal a Base64
	stringToBase64 : function  (s) {

		// Para realizar la transformacion, primero debemos convertir a hexadecimal y luego a cadena
		
		// A hexadecimal
		var str = "";
		var hexes = new Array ("0","1","2","3","4","5","6","7","8","9","a","b","c","d","e","f");
		for (var i=0; i<s.length; i++) {str += hexes [s.charCodeAt(i) >> 4] + hexes [s.charCodeAt(i) & 0xf];}
		
		// A cadena
		var byteString;
		var byteArray = str.replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ");
		
		// Vaciamos la cadena por liberar recursos
		str = "";
		
		try {
			byteString = String.fromCharCode.apply(null, byteArray);
		} catch (e) {
			var byteString = "";
			for (var i = 0, len = byteArray.length; i < len; i++) {
				byteString += String.fromCharCode(byteArray[i]);
			}
		}

		return Cipher.btoa(byteString, null);
	},

	//Convert a base64 string into a normal string
	base64ToString : function(s) {
		//the base 64 characters
		var BASE64 = new Array ('A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z','0','1','2','3','4','5','6','7','8','9','+','/');
			
		var decode = new Object();
		for (var i=0; i<BASE64.length; i++) {decode[BASE64[i]] = i;} //inverse of the array
		decode['='] = 0; //add the equals sign as well
		var r = "", c1, c2, c3, c4, len=s.length; //define variables
		s += "===="; //just to make sure it is padded correctly
		for (var i=0; i<len; i+=4) { //4 input characters at a time
			c1 = s.charAt(i); //the 1st base64 input characther
			c2 = s.charAt(i+1);
			c3 = s.charAt(i+2);
			c4 = s.charAt(i+3);
			r += String.fromCharCode (((decode[c1] << 2) & 0xff) | (decode[c2] >> 4)); //reform the string
			if (c3 != '=') r += String.fromCharCode (((decode[c2] << 4) & 0xff) | (decode[c3] >> 2));
			if (c4 != '=') r += String.fromCharCode (((decode[c3] << 6) & 0xff) | decode[c4]);
		}
		return r;
	},

	// --- Funciones para pasar de Hexadecimal a base64

	btoa : function  (bin, urlSafe) {
		var table = (urlSafe == true ? Cipher.tableStr_URL_SAFE : Cipher.tableStr).split("");
			
		for (var i = 0, j = 0, len = bin.length / 3, base64 = []; i < len; ++i) {
			var a = bin.charCodeAt(j++), b = bin.charCodeAt(j++), c = bin.charCodeAt(j++);
			if ((a | b | c) > 255) throw new Error("String contains an invalid character");
			base64[base64.length] = table[a >> 2] + table[((a << 4) & 63) | (b >> 4)] +
			(isNaN(b) ? "=" : table[((b << 2) & 63) | (c >> 6)]) +
			(isNaN(b + c) ? "=" : table[c & 63]);
		}
		return base64.join("");
	}
};
/*
 * Copyright (c) 2006, 2012, Oracle and/or its affiliates. All rights reserved.
 * ORACLE PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions
 * are met:
 *
 *   - Redistributions of source code must retain the above copyright
 *     notice, this list of conditions and the following disclaimer.
 *
 *   - Redistributions in binary form must reproduce the above copyright
 *     notice, this list of conditions and the following disclaimer in the
 *     documentation and/or other materials provided with the distribution.
 *
 *   - Neither the name of Oracle nor the names of its
 *     contributors may be used to endorse or promote products derived
 *     from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
 * IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
 * THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
 * PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
 * EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
 * PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 * PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/*
 * deployJava.js
 *
 * This file is part of the Deployment Toolkit.  It provides functions for web
 * pages to detect the presence of a JRE, install the latest JRE, and easily run
 * applets or Web Start programs.  More Information on usage of the
 * Deployment Toolkit can be found in the Deployment Guide at:
 * http://docs.oracle.com/javase/6/docs/technotes/guides/jweb/index.html
 *
 * The "live" copy of this file may be found at :
 * http://java.com/js/deployJava.js.
 * For web pages provisioned using https, you may want to access the copy at:
 * https://java.com/js/deployJava.js.
 *
 * You are encouraged to link directly to the live copies.
 * The above files are stripped of comments and whitespace for performance,
 * You can access this file w/o the whitespace and comments removed at:
 * http://java.com/js/deployJava.txt.
 *
 */

var deployJava = function() {
    /** HTML attribute filter implementation */
    var hattrs = {
        core: [ 'id', 'class', 'title', 'style' ],
        i18n: [ 'lang', 'dir' ],
        events: [ 'onclick', 'ondblclick', 'onmousedown', 'onmouseup',
            'onmouseover', 'onmousemove', 'onmouseout', 'onkeypress',
            'onkeydown', 'onkeyup' ],
        applet: [ 'codebase', 'code', 'name', 'archive', 'object',
            'width', 'height', 'alt', 'align', 'hspace', 'vspace' ],
        object: [ 'classid', 'codebase', 'codetype', 'data', 'type',
            'archive', 'declare', 'standby', 'height', 'width', 'usemap',
            'name', 'tabindex', 'align', 'border', 'hspace', 'vspace' ]
    };

    var object_valid_attrs = hattrs.object.concat(hattrs.core, hattrs.i18n,
        hattrs.events);
    var applet_valid_attrs = hattrs.applet.concat(hattrs.core);

    // generic log function, use console.log unless it isn't available
    // then revert to alert()
    function log(message) {
        if ( ! rv.debug ) {return};

        if (console.log) {
            console.log(message);
        } else {
            alert(message);
        }
    }

    //checks where given version string matches query
    //
    //NB: assume format is correct. Can add format check later if needed
    // from dtjava.js
    function versionCheckEx(query, version) {
        if (query == null || query.length == 0) return true;

        var c = query.charAt(query.length - 1);

        //if it is not explicit pattern but does not have update version then need to append *
        if (c != '+' && c != '*' && (query.indexOf('_') != -1 && c != '_')) {
            query = query + "*";
            c = '*';
        }

        query = query.substring(0, query.length - 1);
        //if query ends with ".", "_" then we want to strip it to allow match of "1.6.*" to shorter form such as "1.6"
        //TODO: add support for match of "1.7.0*" to "1.7"?
        if (query.length > 0) {
            var z = query.charAt(query.length - 1);
            if (z == '.' || z == '_') {
                query = query.substring(0, query.length - 1);
            }
        }
        if (c == '*') {
            //it is match if version starts from it
            return (version.indexOf(query) == 0);
        } else if (c == '+') {
            //match if query string is lexicographically smaller
            return query <= version;
        }
        return false;
    }

    function getWebStartLaunchIconURL() {
        var imageUrl = '//java.com/js/webstart.png';
        try {
            // for http/https; use protocol less url; use http for all other protocol
            return document.location.protocol.indexOf('http') != -1 ? 
                imageUrl : 'http:' + imageUrl;
        } catch (err) {
            return 'http:' + imageUrl;
        }
    }

     // GetJava page
     function constructGetJavaURL(query) {
	    
	var getJavaURL = 'http://java.com/dt-redirect';

	if (query == null || query.length == 0) return getJavaURL;
	if(query.charAt(0) == '&')
	{
	   query = query.substring(1, query.length);	
	}
	return getJavaURL + '?'+  query;
    }

    function arHas(ar, attr) {
        var len = ar.length;
        for (var i = 0; i < len; i++) {
            if (ar[i] === attr) return true;
        }
        return false;
    }

    function isValidAppletAttr(attr) {
        return arHas(applet_valid_attrs, attr.toLowerCase());
    }

    function isValidObjectAttr(attr) {
        return arHas(object_valid_attrs, attr.toLowerCase());
    }

    /** 
     * returns true if we can enable DT plugin auto-install without chance of
     * deadlock on cert mismatch dialog
     *
     * requestedJREVersion param is optional - if null, it will be
     * treated as installing any JRE version
     * 
     * DT plugin for 6uX only knows about JRE installer signed by SUN cert.
     * If it encounter Oracle signed JRE installer, it will have chance of
     * deadlock when running with IE.  This function is to guard against this.
     */
    function enableWithoutCertMisMatchWorkaround(requestedJREVersion) {

       // Non-IE browser are okay
       if ('MSIE' != deployJava.browserName) return true;

       // if DT plugin is 10.0.0 or above, return true
       // This is because they are aware of both SUN and Oracle signature and
       // will not show cert mismatch dialog that might cause deadlock
       if (deployJava.compareVersionToPattern(deployJava.getPlugin().version, 
                                     ["10", "0", "0"], false, true)) {
          return true;
       }

       // If we got there, DT plugin is 6uX

       if (requestedJREVersion  == null) {
          // if requestedJREVersion is not defined - it means ANY.
          // can not guarantee it is safe to install ANY version because 6uX 
          // DT does not know about Oracle certificates and may deadlock
          return false;
       }

       // 6u32 or earlier JRE installer used Sun certificate
       // 6u33+ uses Oracle's certificate
       // DT in JRE6 does not know about Oracle certificate => can only 
       // install 6u32 or earlier without risk of deadlock
       return !versionCheckEx("1.6.0_33+", requestedJREVersion);
    }

    /* HTML attribute filters */

    var rv = {

    debug: null,

    /* version of deployJava.js */
    version: "20120801",

    firefoxJavaVersion: null,

    myInterval: null,
    preInstallJREList: null,
    returnPage: null,
    brand: null,
    locale: null,
    installType: null,

    EAInstallEnabled: false,
    EarlyAccessURL: null,


    // mime-type of the DeployToolkit plugin object
    oldMimeType: 'application/npruntime-scriptable-plugin;DeploymentToolkit',
    mimeType: 'application/java-deployment-toolkit',

    /* location of the Java Web Start launch button graphic is right next to
     * deployJava.js at: 
     *    http://java.com/js/webstart.png
     *
     * Use protocol less url here for http/https support
     */
    launchButtonPNG: getWebStartLaunchIconURL(),

    browserName: null,
    browserName2: null,

    /**
     * Returns an array of currently-installed JRE version strings.
     * Version strings are of the form #.#[.#[_#]], with the function returning
     * as much version information as it can determine, from just family
     * versions ("1.4.2", "1.5") through the full version ("1.5.0_06").
     *
     * Detection is done on a best-effort basis.  Under some circumstances
     * only the highest installed JRE version will be detected, and
     * JREs older than 1.4.2 will not always be detected.
     */
    getJREs: function() {
        var list = new Array();
        if (this.isPluginInstalled()) {
            var plugin =  this.getPlugin();
            var VMs = plugin.jvms;
            for (var i = 0; i < VMs.getLength(); i++) {
                list[i] = VMs.get(i).version;
            }
        } else {
            var browser = this.getBrowser();

            if (browser == 'MSIE') {
                if (this.testUsingActiveX('1.7.0')) {
                    list[0] = '1.7.0';
                } else if (this.testUsingActiveX('1.6.0')) {
                    list[0] = '1.6.0';
                } else if (this.testUsingActiveX('1.5.0')) {
                    list[0] = '1.5.0';
                } else if (this.testUsingActiveX('1.4.2')) {
                    list[0] = '1.4.2';
                } else if (this.testForMSVM()) {
                    list[0] = '1.1';
                }
            } else if (browser == 'Netscape Family') {
                this.getJPIVersionUsingMimeType();
                if (this.firefoxJavaVersion != null) {
                    list[0] = this.firefoxJavaVersion;
                } else if (this.testUsingMimeTypes('1.7')) {
                    list[0] = '1.7.0';
                } else if (this.testUsingMimeTypes('1.6')) {
                    list[0] = '1.6.0';
                } else if (this.testUsingMimeTypes('1.5')) {
                    list[0] = '1.5.0';
                } else if (this.testUsingMimeTypes('1.4.2')) {
                    list[0] = '1.4.2';
                } else if (this.browserName2 == 'Safari') {
                    if (this.testUsingPluginsArray('1.7.0')) {
                        list[0] = '1.7.0';
                    } else if (this.testUsingPluginsArray('1.6')) {
                        list[0] = '1.6.0';
                    } else if (this.testUsingPluginsArray('1.5')) {
                        list[0] = '1.5.0';
                    } else if (this.testUsingPluginsArray('1.4.2')) {
                        list[0] = '1.4.2';
                    }
                }
            }
        }

        if (this.debug) {
            for (var i = 0; i < list.length; ++i) {
                log('[getJREs()] We claim to have detected Java SE ' + list[i]);
            }
        }

        return list;
    },

    /**
     * Triggers a JRE installation.  The exact effect of triggering an
     * installation varies based on platform, browser, and if the
     * Deployment Toolkit plugin is installed.
     *
     * The requestVersion string is of the form #[.#[.#[_#]]][+|*],
     * which includes strings such as "1.4", "1.5.0*", and "1.6.0_02+".
     * A star (*) means "any version starting within this family" and
     * a plus (+) means "any version greater or equal to this".
     * "1.5.0*" * matches 1.5.0_06 but not 1.6.0_01, whereas
     * "1.5.0+" matches both.
     *
     * installCallback is an optional argument which holds a reference
     * to a javascript callback function for reporting install status.
     *
     * If the Deployment Toolkit plugin is not present, this will just call
     * this.installLatestJRE().
     */
    installJRE: function(requestVersion, installCallback) {
        var ret = false;
        if (this.isPluginInstalled() && 
            this.isAutoInstallEnabled(requestVersion)) {
            var installSucceeded = false;
            if (this.isCallbackSupported()) {
               installSucceeded = 
                  this.getPlugin().installJRE(requestVersion, installCallback);
            } else {
               installSucceeded = this.getPlugin().installJRE(requestVersion);
            }

            if (installSucceeded) {
                this.refresh();
                if (this.returnPage != null) {
                    document.location = this.returnPage;
                }
            }
            return installSucceeded;
        } else {
            return this.installLatestJRE();
        }
    },

    /** 
     * returns true if jre auto install for the requestedJREVersion is enabled 
     * for the local system; false otherwise
     *
     * requestedJREVersion param is optional - if not specified, it will be
     * treated as installing any JRE version
     * 
     * DT plugin for 6uX only knows about JRE installer signed by SUN cert.
     * If it encounter Oracle signed JRE installer, it will have chance of
     * deadlock when running with IE.  This function is to guard against this.
     */
    isAutoInstallEnabled: function(requestedJREVersion) {
       // if no DT plugin, return false
       if (!this.isPluginInstalled()) return false;

       if (typeof requestedJREVersion  == 'undefined') {
           requestedJREVersion = null;
       }

       return enableWithoutCertMisMatchWorkaround(requestedJREVersion);

    },

    /** 
     * returns true if jre install callback is supported
     * callback support is added since dt plugin version 10.2.0 or above
     */
    isCallbackSupported: function() {
       return this.isPluginInstalled() && 
          this.compareVersionToPattern(this.getPlugin().version, 
                                       ["10", "2", "0"], false, true);
    },

    /**
     * Triggers a JRE installation.  The exact effect of triggering an
     * installation varies based on platform, browser, and if the
     * Deployment Toolkit plugin is installed.
     *
     * In the simplest case, the browser window will be redirected to the
     * java.com JRE installation page, and (if possible) a redirect back to
     * the current URL upon successful installation.  The return redirect is
     * not always possible, as the JRE installation may require the browser to
     * be restarted.
     *
     * installCallback is an optional argument which holds a reference
     * to a javascript callback function for reporting install status.
     *
     * In the best case (when the Deployment Toolkit plugin is present), this
     * function will immediately cause a progress dialog to be displayed
     * as the JRE is downloaded and installed.
     */
    installLatestJRE: function(installCallback) {
        if (this.isPluginInstalled() && this.isAutoInstallEnabled()) {
            var installSucceeded = false;
            if (this.isCallbackSupported()) {
               installSucceeded = this.getPlugin().installLatestJRE(installCallback);
            } else {
               installSucceeded = this.getPlugin().installLatestJRE();
            }
            if (installSucceeded) {
                this.refresh();
                if (this.returnPage != null) {
                    document.location = this.returnPage;
                }
            }
            return installSucceeded;
        } else {
            var browser = this.getBrowser();
            var platform = navigator.platform.toLowerCase();
            if ((this.EAInstallEnabled == 'true') &&
                (platform.indexOf('win') != -1) &&
                (this.EarlyAccessURL != null)) {

                this.preInstallJREList = this.getJREs();
                if (this.returnPage != null) {
                    this.myInterval =
                        setInterval("deployJava.poll()", 3000);
                }

                location.href = this.EarlyAccessURL;

                // we have to return false although there may be an install
                // in progress now, when complete it may go to return page
                return false;
            } else {
                if (browser == 'MSIE') {
                    return this.IEInstall();
                } else if ((browser == 'Netscape Family') &&
                           (platform.indexOf('win32') != -1)) {
                    return this.FFInstall();
                } else {
                    location.href = constructGetJavaURL(
                        ((this.returnPage != null) ?
                        ('&returnPage=' + this.returnPage) : '') +
                        ((this.locale != null) ?
                        ('&locale=' + this.locale) : '') +
                        ((this.brand != null) ?
                         ('&brand=' + this.brand) : ''));
                }
                // we have to return false although there may be an install
                // in progress now, when complete it may go to return page
                return false;
            }
        }
    },


    /**
     * Ensures that an appropriate JRE is installed and then runs an applet.
     * minimumVersion is of the form #[.#[.#[_#]]], and is the minimum
     * JRE version necessary to run this applet.  minimumVersion is optional,
     * defaulting to the value "1.1" (which matches any JRE).
     * If an equal or greater JRE is detected, runApplet() will call
     * writeAppletTag(attributes, parameters) to output the applet tag,
     * otherwise it will call installJRE(minimumVersion + '+').
     *
     * After installJRE() is called, the script will attempt to detect that the
     * JRE installation has completed and begin running the applet, but there
     * are circumstances (such as when the JRE installation requires a browser
     * restart) when this cannot be fulfilled.
     *
     * As with writeAppletTag(), this function should only be called prior to
     * the web page being completely rendered.  Note that version wildcards
     * (star (*) and plus (+)) are not supported, and including them in the
     * minimumVersion will result in an error message.
     */
    runApplet: function(attributes, parameters, minimumVersion) {
        if (minimumVersion == 'undefined' || minimumVersion == null) {
            minimumVersion = '1.1';
        }

        var regex = "^(\\d+)(?:\\.(\\d+)(?:\\.(\\d+)(?:_(\\d+))?)?)?$";

        var matchData = minimumVersion.match(regex);

        if (this.returnPage == null) {
            // if there is an install, come back here and run the applet
            this.returnPage = document.location;
        }

        if (matchData != null) {
            var browser = this.getBrowser();
            if (browser != '?') {
                if (this.versionCheck(minimumVersion + '+')) {
                    this.writeAppletTag(attributes, parameters);
                } else if (this.installJRE(minimumVersion + '+')) {
                    // after successful install we need to refresh page to pick
                    // pick up new plugin
                    this.refresh();
                    location.href = document.location;
                    this.writeAppletTag(attributes, parameters);
                }
            } else {
                // for unknown or Safari - just try to show applet
                this.writeAppletTag(attributes, parameters);
            }
        } else {
            log('[runApplet()] Invalid minimumVersion argument to runApplet():' +
                      minimumVersion);
        }
    },


    /**
     * Outputs an applet tag with the specified attributes and parameters, where
     * both attributes and parameters are associative arrays.  Each key/value
     * pair in attributes becomes an attribute of the applet tag itself, while
     * key/value pairs in parameters become <PARAM> tags.  No version checking
     * or other special behaviors are performed; the tag is simply written to
     * the page using document.writeln().
     *
     * As document.writeln() is generally only safe to use while the page is
     * being rendered, you should never call this function after the page
     * has been completed.
     */
    writeAppletTag: function(attributes, parameters) {
        var startApplet = '<' + 'applet ';
        var params = '';
        var endApplet = '<' + '/' + 'applet' + '>';
        var addCodeAttribute = true;

        if (null == parameters || typeof parameters != 'object') {
            parameters = new Object();
        }

        for (var attribute in attributes) {
            if (! isValidAppletAttr(attribute)) {
                parameters[attribute] = attributes[attribute];
            } else {
                startApplet += (' ' +attribute+ '="' +attributes[attribute] + '"');
                if (attribute == 'code') {
                    addCodeAttribute = false;
                }
            }
        }

        var codebaseParam = false;
        for (var parameter in parameters) {
            if (parameter == 'codebase_lookup') {
                codebaseParam = true;
            }
            // Originally, parameter 'object' was used for serialized
            // applets, later, to avoid confusion with object tag in IE
            // the 'java_object' was added.  Plugin supports both.
            if (parameter == 'object' || parameter == 'java_object' ||
                parameter == 'java_code' ) {
                addCodeAttribute = false;
            }
            params += '<param name="' + parameter + '" value="' +
                parameters[parameter] + '"/>';
        }
        if (!codebaseParam) {
            params += '<param name="codebase_lookup" value="false"/>';
        }

        if (addCodeAttribute) {
            startApplet += (' code="dummy"');
        }
        startApplet += '>';

        document.write(startApplet + '\n' + params + '\n' + endApplet);
    },
  

     /**
      * Returns true if there is a matching JRE version currently installed
      * (among those detected by getJREs()).  The versionPattern string is
      * of the form #[.#[.#[_#]]][+|*], which includes strings such as "1.4",
      * "1.5.0*", and "1.6.0_02+".
      * A star (*) means "any version within this family" and a plus (+) means
      * "any version greater or equal to the specified version".  "1.5.0*"
      * matches 1.5.0_06 but not 1.6.0_01, whereas "1.5.0+" matches both.
      *
      * If the versionPattern does not include all four version components
      * but does not end with a star or plus, it will be treated as if it
      * ended with a star.  "1.5" is exactly equivalent to "1.5*", and will
      * match any version number beginning with "1.5".
      *
      * If getJREs() is unable to detect the precise version number, a match
      * could be ambiguous.  For example if getJREs() detects "1.5", there is
      * no way to know whether the JRE matches "1.5.0_06+".  versionCheck()
      * compares only as much of the version information as could be detected,
      * so versionCheck("1.5.0_06+") would return true in in this case.
      *
      * Invalid versionPattern will result in a JavaScript error alert.
      * versionPatterns which are valid but do not match any existing JRE
      * release (e.g. "32.65+") will always return false.
      */
    versionCheck: function(versionPattern)
    {
        var index = 0;
        var regex = "^(\\d+)(?:\\.(\\d+)(?:\\.(\\d+)(?:_(\\d+))?)?)?(\\*|\\+)?$";

        var matchData = versionPattern.match(regex);

        if (matchData != null) {
            // default is exact version match
            // examples:
            //    local machine has 1.7.0_04 only installed
            //    exact match request is "1.7.0_05":  return false
            //    family match request is "1.7.0*":   return true
            //    minimum match request is "1.6+":    return true
            var familyMatch = false;
            var minMatch = false;

            var patternArray = new Array();

            for (var i = 1; i < matchData.length; ++i) {
                // browser dependency here.
                // Fx sets 'undefined', IE sets '' string for unmatched groups
                if ((typeof matchData[i] == 'string') && (matchData[i] != '')) {
                    patternArray[index] = matchData[i];
                    index++;
                }
            }

            if (patternArray[patternArray.length-1] == '+') {
                // + specified in request - doing a minimum match
                minMatch = true;
                familyMatch = false;
                patternArray.length--;
            } else if (patternArray[patternArray.length-1] == '*') {
                // * specified in request - doing a family match
                minMatch = false;
                familyMatch = true;
                patternArray.length--;
            } else if (patternArray.length < 4) {
                // versionPattern does not include all four version components
                // and does not end with a star or plus, it will be treated as 
                // if it ended with a star. (family match)
                minMatch = false;
                familyMatch = true;
            }

            var list = this.getJREs();
            for (var i = 0; i < list.length; ++i) {
                if (this.compareVersionToPattern(list[i], patternArray,
                                                 familyMatch, minMatch)) {
                    return true;
                }
            }

            return false;
        } else {
            var msg = 'Invalid versionPattern passed to versionCheck: ' +
                  versionPattern;
            log('[versionCheck()] ' + msg);
            alert(msg);
            return false;
        }
    },


    /**
     * Returns true if an installation of Java Web Start of the specified
     * minimumVersion can be detected.  minimumVersion is optional, and
     * if not specified, '1.4.2' will be used.
     * (Versions earlier than 1.4.2 may not be detected.)
     */
    isWebStartInstalled: function(minimumVersion) {

        var browser = this.getBrowser();
        if (browser == '?') {
            // we really don't know - better to try to use it than reinstall
            return true;
        }

        if (minimumVersion == 'undefined' || minimumVersion == null) {
            minimumVersion = '1.4.2';
        }

        var retval = false;
        var regex = "^(\\d+)(?:\\.(\\d+)(?:\\.(\\d+)(?:_(\\d+))?)?)?$";
        var matchData = minimumVersion.match(regex);

        if (matchData != null) {
            retval = this.versionCheck(minimumVersion + '+');
        } else {
            log('[isWebStartInstaller()] Invalid minimumVersion argument to isWebStartInstalled(): ' + minimumVersion);
            retval = this.versionCheck('1.4.2+');
        }
        return retval;
    },

    // obtain JPI version using navigator.mimeTypes array
    // if found, set the version to this.firefoxJavaVersion
    getJPIVersionUsingMimeType: function() {
        // Walk through the full list of mime types.
        for (var i = 0; i < navigator.mimeTypes.length; ++i) {
            var s = navigator.mimeTypes[i].type;
            // The jpi-version is the plug-in version.  This is the best
            // version to use.
            var m = s.match(/^application\/x-java-applet;jpi-version=(.*)$/);
            if (m != null) {
                this.firefoxJavaVersion = m[1];
                // Opera puts the latest sun JRE last not first
                if ('Opera' != this.browserName2) {
                    break;
                }
            }
        }
    },

   // launch the specified JNLP application using the passed in jnlp file
   // the jnlp file does not need to have a codebase
   // this requires JRE 7 or above to work
   // if machine has no JRE 7 or above, we will try to auto-install and then launch
   // (function will return false if JRE auto-install failed)
   launchWebStartApplication: function(jnlp) {
	var uaString = navigator.userAgent.toLowerCase();

	this.getJPIVersionUsingMimeType();

	// make sure we are JRE 7 or above
        if (this.isWebStartInstalled('1.7.0') == false) {

		// perform latest JRE auto-install
  		if ((this.installJRE('1.7.0+') == false) ||
                         ((this.isWebStartInstalled('1.7.0') == false))) {
                          return false;
                }
	}

        var jnlpDocbase = null;

        // use document.documentURI for docbase
        if (document.documentURI) {
		jnlpDocbase = document.documentURI;
	}

	// fallback to document.URL if documentURI not available
        if (jnlpDocbase == null) {
		jnlpDocbase = document.URL;
	}

        var browser = this.getBrowser();

        var launchTag;

        if (browser == 'MSIE') {

            launchTag = '<' +
                'object classid="clsid:8AD9C840-044E-11D1-B3E9-00805F499D93" ' +
		'width="0" height="0">' +
		'<' + 'PARAM name="launchjnlp" value="' + jnlp + '"' + '>' +
	        '<' + 'PARAM name="docbase" value="' + jnlpDocbase + '"' + '>' +
                '<' + '/' + 'object' + '>';
        } else if (browser == 'Netscape Family') {

            launchTag = '<' +
		'embed type="application/x-java-applet;jpi-version=' +
		this.firefoxJavaVersion + '" ' +
                'width="0" height="0" ' +
                'launchjnlp="' +  jnlp + '"' +
                'docbase="' +  jnlpDocbase + '"' +
                ' />';
        }

        if (document.body == 'undefined' || document.body == null) {
           document.write(launchTag);
           // go back to original page, otherwise current page becomes blank
           document.location = jnlpDocbase;
        } else {
           var divTag = document.createElement("div");
           divTag.id = "div1";
           divTag.style.position = "relative";
           divTag.style.left = "-10000px";
           divTag.style.margin = "0px auto";
           divTag.className ="dynamicDiv";
           divTag.innerHTML = launchTag;
           document.body.appendChild(divTag);
        }
   },

   createWebStartLaunchButtonEx: function(jnlp, minimumVersion) {

        if (this.returnPage == null) {
            // if there is an install, come back and run the jnlp file
            this.returnPage = jnlp;
        }

        var url = 'javascript:deployJava.launchWebStartApplication(\'' + jnlp +
			'\');';

        document.write('<' + 'a href="' + url +
                       '" onMouseOver="window.status=\'\'; ' +
                       'return true;"><' + 'img ' +
                       'src="' + this.launchButtonPNG + '" ' +
                       'border="0" /><' + '/' + 'a' + '>');
    },


    /**
     * Outputs a launch button for the specified JNLP URL.  When clicked, the
     * button will ensure that an appropriate JRE is installed and then launch
     * the JNLP application.  minimumVersion is of the form #[.#[.#[_#]]], and
     * is the minimum JRE version necessary to run this JNLP application.
     * minimumVersion is optional, and if it is not specified, '1.4.2'
     * will be used.
     * If an appropriate JRE or Web Start installation is detected,
     * the JNLP application will be launched, otherwise installLatestJRE()
     * will be called.
     *
     * After installLatestJRE() is called, the script will attempt to detect
     * that the JRE installation has completed and launch the JNLP application,
     * but there are circumstances (such as when the JRE installation
     * requires a browser restart) when this cannot be fulfilled.
     */
    createWebStartLaunchButton: function(jnlp, minimumVersion) {

        if (this.returnPage == null) {
            // if there is an install, come back and run the jnlp file
            this.returnPage = jnlp;
        }

        var url = 'javascript:' +
                  'if (!deployJava.isWebStartInstalled(&quot;' +
                      minimumVersion + '&quot;)) {' +
                      'if (deployJava.installLatestJRE()) {' +
                        'if (deployJava.launch(&quot;' + jnlp + '&quot;)) {}' +
                      '}' +
                  '} else {' +
                      'if (deployJava.launch(&quot;' + jnlp + '&quot;)) {}' +
                  '}';

        document.write('<' + 'a href="' + url +
                       '" onMouseOver="window.status=\'\'; ' +
                       'return true;"><' + 'img ' +
                       'src="' + this.launchButtonPNG + '" ' +
                       'border="0" /><' + '/' + 'a' + '>');
    },


    /**
     * Launch a JNLP application, (using the plugin if available)
     */
    launch: function(jnlp) {
   /*
    * Using the plugin to launch Java Web Start is disabled for the time being
    */
        document.location=jnlp;
        return true;
    },


    /*
     * returns true if the ActiveX or XPI plugin is installed
     */
    isPluginInstalled: function() {
        var plugin = this.getPlugin();
        if (plugin && plugin.jvms) {
            return true;
        } else {
            return false;
        }
    },

    /*
     * returns true if the plugin is installed and AutoUpdate is enabled
     */
    isAutoUpdateEnabled: function() {
        if (this.isPluginInstalled()) {
            return this.getPlugin().isAutoUpdateEnabled();
        }
        return false;
    },

    /*
     * sets AutoUpdate on if plugin is installed
     */
    setAutoUpdateEnabled: function() {
        if (this.isPluginInstalled()) {
            return this.getPlugin().setAutoUpdateEnabled();
        }
        return false;
    },

    /*
     * sets the preferred install type : null, online, kernel
     */
    setInstallerType: function(type) {
        this.installType = type;
        if (this.isPluginInstalled()) {
            return this.getPlugin().setInstallerType(type);
        }
        return false;
    },

    /*
     * sets additional package list - to be used by kernel installer
     */
    setAdditionalPackages: function(packageList) {
        if (this.isPluginInstalled()) {
            return this.getPlugin().setAdditionalPackages(
                                                     packageList);
        }
        return false;
    },

    /*
     * sets preference to install Early Access versions if available
     */
    setEarlyAccess: function(enabled) {
        this.EAInstallEnabled = enabled;
    },

    /*
     * Determines if the next generation plugin (Plugin II) is default
     */
    isPlugin2: function() {
        if (this.isPluginInstalled()) {
            if (this.versionCheck('1.6.0_10+')) {
                try {
                    return this.getPlugin().isPlugin2();
                } catch (err) {
                    // older plugin w/o isPlugin2() function -
                }
            }
        }
        return false;
    },

    //support native DT plugin?
    allowPlugin: function() {
        this.getBrowser();

        // Safari and Opera browsers find the plugin but it
        // doesn't work, so until we can get it to work - don't use it.
        var ret = ('Safari' != this.browserName2 &&
            'Opera' != this.browserName2);

        return ret;
    },

    getPlugin: function() {
        this.refresh();

        var ret = null;
        if (this.allowPlugin()) {
            ret = document.getElementById('deployJavaPlugin');
        }
        return ret;
    },

    compareVersionToPattern: function(version, patternArray,
                                      familyMatch, minMatch) {
        if (version == undefined || patternArray == undefined) {
           return false;
        }
        var regex = "^(\\d+)(?:\\.(\\d+)(?:\\.(\\d+)(?:_(\\d+))?)?)?$";
        var matchData = version.match(regex);

        if (matchData != null) {
            var index = 0;
            var result = new Array();

            for (var i = 1; i < matchData.length; ++i) {
                if ((typeof matchData[i] == 'string') && (matchData[i] != ''))
                {
                    result[index] = matchData[i];
                    index++;
                }
            }

            var l = Math.min(result.length, patternArray.length);

            // result contains what is installed in local machine
            // patternArray is what is being requested by application
            if (minMatch) {
                // minimum version match, return true if what we have (installed) 
                // is greater or equal to what is requested.  false otherwise. 
                for (var i = 0; i < l; ++i) {
                    if (result[i] < patternArray[i]) {
                        return false;
                    } else if (result[i] > patternArray[i]) {
                        return true;
                    }
                }
                return true;
            } else {
                for (var i = 0; i < l; ++i) {
                    if (result[i] != patternArray[i]) return false;
                }
                if (familyMatch) {
                    // family match - return true as long as what we have
                    // (installed) matches up to the request pattern
                    return true;
                } else { 
                    // exact match
                    // result and patternArray needs to have exact same content
                    return (result.length == patternArray.length);
                }
            }
        } else {
            return false;
        }
    },

    getBrowser: function() {

        if (this.browserName == null) {
            var browser = navigator.userAgent.toLowerCase();

            log('[getBrowser()] navigator.userAgent.toLowerCase() -> ' + browser);


            // order is important here.  Safari userAgent contains mozilla,
            // IE 11 userAgent contains mozilla and netscape, 
            // and Chrome userAgent contains both mozilla and safari.
            if ((browser.indexOf('msie') != -1) && (browser.indexOf('opera') == -1)) {
                this.browserName = 'MSIE';
                this.browserName2 = 'MSIE';
            } else if (browser.indexOf('trident') != -1 || browser.indexOf('Trident') != -1) {
				this.browserName = 'MSIE';
				this.browserName2 = 'MSIE';
			} else if (browser.indexOf('iphone') != -1) {
                // this included both iPhone and iPad
                this.browserName = 'Netscape Family';
                this.browserName2 = 'iPhone';
            } else if ((browser.indexOf('firefox') != -1) && (browser.indexOf('opera') == -1)) {
                this.browserName = 'Netscape Family';
                this.browserName2 = 'Firefox';
            } else if (browser.indexOf('chrome') != -1) {
                this.browserName = 'Netscape Family';
                this.browserName2 = 'Chrome';
            } else if (browser.indexOf('safari') != -1) {
                this.browserName = 'Netscape Family';
                this.browserName2 = 'Safari';
            } else if ((browser.indexOf('mozilla') != -1) && (browser.indexOf('opera') == -1)) {
                this.browserName = 'Netscape Family';
                this.browserName2 = 'Other';
            } else if (browser.indexOf('opera') != -1) {
                this.browserName = 'Netscape Family';
                this.browserName2 = 'Opera';
            } else {
                this.browserName = '?';
                this.browserName2 = 'unknown';
            }

            log('[getBrowser()] Detected browser name:'+ this.browserName +
                       ', ' + this.browserName2);
        }
        return this.browserName;
    },


    testUsingActiveX: function(version) {
        var objectName = 'JavaWebStart.isInstalled.' + version + '.0';

        // we need the typeof check here for this to run on FF/Chrome
        // the check needs to be in place here - cannot even pass ActiveXObject
        // as arg to another function
        if (typeof ActiveXObject == 'undefined' || !ActiveXObject) {
            log('[testUsingActiveX()] Browser claims to be IE, but no ActiveXObject object?');
            return false;
        }

        try {
            return (new ActiveXObject(objectName) != null);
        } catch (exception) {
            return false;
        }
    },


    testForMSVM: function() {
        var clsid = '{08B0E5C0-4FCB-11CF-AAA5-00401C608500}';

        if (typeof oClientCaps != 'undefined') {
            var v = oClientCaps.getComponentVersion(clsid, "ComponentID");
            if ((v == '') || (v == '5,0,5000,0')) {
                return false;
            } else {
                return true;
            }
        } else {
            return false;
        }
    },


    testUsingMimeTypes: function(version) {
        if (!navigator.mimeTypes) {
            log ('[testUsingMimeTypes()] Browser claims to be Netscape family, but no mimeTypes[] array?');
            return false;
        }

        for (var i = 0; i < navigator.mimeTypes.length; ++i) {
            s = navigator.mimeTypes[i].type;
            var m = s.match(/^application\/x-java-applet\x3Bversion=(1\.8|1\.7|1\.6|1\.5|1\.4\.2)$/);
            if (m != null) {
                if (this.compareVersions(m[1], version)) {
                    return true;
                }
            }
        }
        return false;
    },

    testUsingPluginsArray: function(version) {
        if ((!navigator.plugins) || (!navigator.plugins.length)) {
            return false;
        }
        var platform = navigator.platform.toLowerCase();

        for (var i = 0; i < navigator.plugins.length; ++i) {
            s = navigator.plugins[i].description;
            if (s.search(/^Java Switchable Plug-in (Cocoa)/) != -1) {
                // Safari on MAC
                if (this.compareVersions("1.5.0", version)) {
                    return true;
                }
            } else if (s.search(/^Java/) != -1) {
                if (platform.indexOf('win') != -1) {
                    // still can't tell - opera, safari on windows
                    // return true for 1.5.0 and 1.6.0
                    if (this.compareVersions("1.5.0", version) ||
                        this.compareVersions("1.6.0", version)) {
                        return true;
                    }
                }
            }
        }
        // if above dosn't work on Apple or Windows, just allow 1.5.0
        if (this.compareVersions("1.5.0", version)) {
            return true;
        }
        return false;



    },

    IEInstall: function() {

        location.href = constructGetJavaURL(
            ((this.returnPage != null) ?
            ('&returnPage=' + this.returnPage) : '') +
            ((this.locale != null) ?
            ('&locale=' + this.locale) : '') +
            ((this.brand != null) ? ('&brand=' + this.brand) : ''));

         // should not actually get here
         return false;
    },

    done: function (name, result) {
    },

    FFInstall: function() {

        location.href = constructGetJavaURL(
            ((this.returnPage != null) ?
            ('&returnPage=' + this.returnPage) : '') +
            ((this.locale != null) ?
            ('&locale=' + this.locale) : '') +
            ((this.brand != null) ? ('&brand=' + this.brand) : '') +
            ((this.installType != null) ?
                ('&type=' + this.installType) : ''));

         // should not actually get here
         return false;
    },

    // return true if 'installed' (considered as a JRE version string) is
    // greater than or equal to 'required' (again, a JRE version string).
    compareVersions: function(installed, required) {

        var a = installed.split('.');
        var b = required.split('.');

        for (var i = 0; i < a.length; ++i) {
            a[i] = Number(a[i]);
        }
        for (var i = 0; i < b.length; ++i) {
            b[i] = Number(b[i]);
        }
        if (a.length == 2) {
            a[2] = 0;
        }

        if (a[0] > b[0]) return true;
        if (a[0] < b[0]) return false;

        if (a[1] > b[1]) return true;
        if (a[1] < b[1]) return false;

        if (a[2] > b[2]) return true;
        if (a[2] < b[2]) return false;

        return true;
    },

    enableAlerts: function() {
        // reset this so we can show the browser detection
        this.browserName = null;
        this.debug = true;
    },

    poll: function() {

        this.refresh();
        var postInstallJREList = this.getJREs();

        if ((this.preInstallJREList.length == 0) &&
            (postInstallJREList.length != 0)) {
            clearInterval(this.myInterval);
            if (this.returnPage != null) {
                location.href = this.returnPage;
            };
        }

        if ((this.preInstallJREList.length != 0) &&
            (postInstallJREList.length != 0) &&
            (this.preInstallJREList[0] != postInstallJREList[0])) {
            clearInterval(this.myInterval);
            if (this.returnPage != null) {
                location.href = this.returnPage;
            }
        }

    },

    writePluginTag: function() {
        var browser = this.getBrowser();

        if (browser == 'MSIE') {
            document.write('<' +
                'object classid="clsid:CAFEEFAC-DEC7-0000-0001-ABCDEFFEDCBA" ' +
                'id="deployJavaPlugin" width="0" height="0">' +
                '<' + '/' + 'object' + '>');
        } else if (browser == 'Netscape Family' && this.allowPlugin()) {
            this.writeEmbedTag();
        }
    },

    refresh: function() {
        navigator.plugins.refresh(false);

        var browser = this.getBrowser();
        if (browser == 'Netscape Family' && this.allowPlugin()) {
            var plugin = document.getElementById('deployJavaPlugin');
            // only do this again if no plugin
            if (plugin == null) {
                this.writeEmbedTag();
            }
        }
     },

    writeEmbedTag: function() {
        var written = false;
        if (navigator.mimeTypes != null) {
            for (var i=0; i < navigator.mimeTypes.length; i++) {
                if (navigator.mimeTypes[i].type == this.mimeType) {
                    if (navigator.mimeTypes[i].enabledPlugin) {
                        document.write('<' +
                            'embed id="deployJavaPlugin" type="' +
                            this.mimeType + '" hidden="true" />');
                        written = true;
                    }
                }
            }
            // if we ddn't find new mimeType, look for old mimeType
            if (!written) for (var i=0; i < navigator.mimeTypes.length; i++) {
                if (navigator.mimeTypes[i].type == this.oldMimeType) {
                    if (navigator.mimeTypes[i].enabledPlugin) {
                        document.write('<' +
                            'embed id="deployJavaPlugin" type="' +
                            this.oldMimeType + '" hidden="true" />');
                    }
                }
            }
        }
    }
    }; // deployJava object

    rv.writePluginTag();
    if (rv.locale == null) {
        var loc = null;

        if (loc == null) try {
            loc = navigator.userLanguage;
        } catch (err) { }

        if (loc == null) try {
            loc = navigator.systemLanguage;
        } catch (err) { }

        if (loc == null) try {
            loc = navigator.language;
        } catch (err) { }

        if (loc != null) {
            loc.replace("-","_")
            rv.locale = loc;
        }
    }

    return rv;
}();


var TestEnvironment = {
		 
	/** Identifica el entorno de ejecucion (sistema operativo y su version, navegador y su version,
	 * version de Java...) y configura esta informacion en la variable "jscd" de la ventana.
	 *  - window: Ventana actual. */
	identify : function (window) {

        var unknown = '-';

        // screen
        var screenSize = '';
        if (screen.width) {
            width = (screen.width) ? screen.width : '';
            height = (screen.height) ? screen.height : '';
            screenSize += '' + width + " x " + height;
        }

        //browser
       var nVer = navigator.appVersion;
       var nAgt = navigator.userAgent;
       var browser = navigator.appName;
       var version = '' + parseFloat(navigator.appVersion);
       var majorVersion = parseInt(navigator.appVersion, 10);
       var nameOffset, verOffset, ix;

        // Opera
        if ((verOffset = nAgt.indexOf('Opera')) != -1) {
            browser = 'Opera';
            version = nAgt.substring(verOffset + 6);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(verOffset + 5);
        }
		  // Edge
        else if ((verOffset = nAgt.indexOf('Edge/')) != -1) {
            browser = 'Microsoft Edge';
			version = nAgt.substring(verOffset + 5, verOffset + 7);
		}
        // Chrome
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
            browser = 'Chrome';
            version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
            browser = 'Safari';
            version = nAgt.substring(verOffset + 7);
            if ((verOffset = nAgt.indexOf('Version')) != -1) {
                version = nAgt.substring(verOffset + 8);
            }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
            browser = 'Firefox';
            version = nAgt.substring(verOffset + 8);
        }
        // MSIE 11+
        else if (nAgt.indexOf('Trident/') != -1) {
            browser = 'Microsoft Internet Explorer';
            version = nAgt.substring(nAgt.indexOf('rv:') + 3);
        }
		 // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
            browser = nAgt.substring(nameOffset, verOffset);
            version = nAgt.substring(verOffset + 1);
            if (browser.toLowerCase() == browser.toUpperCase()) {
                browser = navigator.appName;
            }
        }
        // trim the version string
        if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

        majorVersion = parseInt('' + version, 10);
        if (isNaN(majorVersion)) {
            version = '' + parseFloat(navigator.appVersion);
            majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        var mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        var cookieEnabled = (navigator.cookieEnabled) ? true : false;

        if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
            document.cookie = 'testcookie';
            cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
        }

        // system
        var os = unknown;
        var clientStrings = [
            {s:'Windows 3.11', r:/Win16/},
            {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
            {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
            {s:'Windows 98', r:/(Windows 98|Win98)/},
            {s:'Windows CE', r:/Windows CE/},
            {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
            {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
            {s:'Windows Server 2003', r:/Windows NT 5.2/},
            {s:'Windows Vista', r:/Windows NT 6.0/},
            {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
            {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
            {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
			{s:'Windows 10', r:/(Windows 10|Windows NT 10.0)/},
            {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
            {s:'Windows ME', r:/Windows ME/},
            {s:'Android', r:/Android/},
            {s:'Open BSD', r:/OpenBSD/},
            {s:'Sun OS', r:/SunOS/},
            {s:'Linux', r:/(Linux|X11)/},
            {s:'iOS', r:/(iPhone|iPad|iPod)/},
            {s:'Mac OS X', r:/Mac OS X/},
            {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
            {s:'QNX', r:/QNX/},
            {s:'UNIX', r:/UNIX/},
            {s:'BeOS', r:/BeOS/},
            {s:'OS/2', r:/OS\/2/},
            {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        var osVersion = unknown;

        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
            os = 'Windows';
        }

        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                break;

            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                break;
        }

        // flash (you'll need to include swfobject)
        /* script src="//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js" */
        var flashVersion = 'no check';
        if (typeof swfobject != 'undefined') {
            var fv = swfobject.getFlashPlayerVersion();
            if (fv.major > 0) {
                flashVersion = fv.major + '.' + fv.minor + ' r' + fv.release;
            }
            else  {
                flashVersion = unknown;
            }
        }

        // Calculamos la version de Java
        var javaVersion = TestEnvironment.getJavaVersionFromPlugin();

	    window.jscd = {
	        screen: screenSize,
	        browser: browser,
	        browserVersion: version,
	        mobile: mobile,
	        os: os,
	        osVersion: osVersion,
	        cookies: cookieEnabled,
	        flashVersion: flashVersion,
	        javaVersion: javaVersion,
	        javaArch: null
	    };
	},
 
	/** Obtiene la version de Java a partir de la biblioteca deployJava que se comunica con el Java Plugin. */
	getJavaVersionFromPlugin : function () {
		try {
			var maxVersion = "0";
			var JREs = deployJava.getJREs();
			if (JREs != undefined && JREs != null) {
				for (var i = 0; i < JREs.length; i++) {
					maxVersion = TestEnvironment.calculateMaxJavaVersion(maxVersion, JREs[i]);
				}
			}
			return maxVersion;
		}
		catch (e) {
			// En caso de no poder extraer la version de Java a traves del plugin, se establece a '0'
			return "0";
		}
	},

	/** Actualiza la version de Java configurada en Obtiene la version de Java configurada en "jscd"
	 *  con la version notificada por el propio applet ya cargado.
	 *  - Informacion devuelta por el metodo echo() del applet. */
	updateJavaInfoFromApplet : function (echo) {
		
		var header = "Java version: ";
		if (echo == undefined || echo == null || echo.indexOf(header) == -1) {
			return null;
		}
		
		var i = echo.indexOf(header);
		var j = echo.indexOf('\n', i);

		jscd.javaVersion = this.trim(echo.substring(i + header.length, j));
		
		i = echo.indexOf(':', j) + 1;
		
		jscd.javaArch = this.trim(echo.substring(i));
	},
	
	/** Funcion trim de cadena, dado que no existe para IE8. */
	trim : function (text) {
		if (text.trim != null) {
			return text.trim();
		}
		var i = 0;
		while (text[i] == ' ' || text[i] == '\t' || text[i] == '\n' || text[i] == '\r') {
			i++;
		}
		var j = text.length;
		while (text[j - 1] == ' ' || text[j - 1] == '\t' || text[j - 1] == '\n' || text[j - 1] == '\r') {
			j--;
		}
		return j <= i ? "" : text.substring(i, j); 
	},
	
	/** Identifica la mayor vesion de Java de entre las proporcionadas. */
	calculateMaxJavaVersion : function (v1, v2) {
		if (v1[0] > v2[0]) {
			return v1;
		}
		else if (v1[0] < v2[0]) {
			return v2;
		}
		if (v1[2] > v2[2]) {
			return v1;
		}
		else if (v1[2] < v2[2]) {
			return v2;
		}
		if (v1[4] > v2[4]) {
			return v1;
		}
		else if (v1[4] < v2[4]) {
			return v2;
		}
		// Si v1 no tiene update, o v2 es mayor o son iguales, asi que devolvemos v2
		if (v1.indexOf('_') == -1) {
			return v2;
		}
		return parseInt(v1.substr(v1.indexOf('_') + 1)) > parseInt(v2.substr(v2.indexOf('_') + 1)) ? v1 : v2;
	}
 };
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-paleblue', //'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService,
                               $scope, authSettings, localStorageService, AuthService, notificationsService,
                               impersonatesService) {
        var vm = this;

        // Data
        vm.authService=AuthService;
        vm.user=AuthService.currentUser;
        AuthService.getCurrentUser().then(function (response) {
            if (response) {
                getReadPending();
            }
        });

        vm.notifications=notificationsService.notifications;

        vm.impersonate=!!localStorageService.get('tokenImpersonate');

        vm.bodyEl = angular.element('body');

        // Watchers
        $scope.$watch('vm.authService', function(){
            vm.user=AuthService.currentUser;
        }, true);

        // Methods
        vm.getFileHelp = getFileHelp;
        vm.downloadHelp = downloadHelp;
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.endImpersonate = endImpersonate;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.getReadPending = getReadPending;
        vm.changeGroup = changeGroup;
        vm.lengthObj = lengthObj;

        //////////

        /**
         * Obtiene el numero de notificaciones pendientes de leer
         */
        function getReadPending() {
            notificationsService.getReadPending();
        }

        /**
         * Descarga la ayuda
         */
        function downloadHelp() {
            var file=getFileHelp();
            if(file){
                window.open(file,'_blank');
            }
        }

        /**
         * Obtiene la ruta a la ayuda correspondiente al usuario logado
         */
        function getFileHelp(){
            var raiz='/static/handbooks/';
            // var file=null;
            var file="dean.pdf";
            if(vm.user){
                if(vm.user.group_type==='manager'){
                    file="manager.pdf"
                }
                if(vm.user.group_type==='curricular_practices_tutor' ||
                    vm.user.group_type==='tutor' ||
                    vm.user.group_type==='professional_tutor'){
                    file="tutor.pdf"
                }
                if(vm.user.group_type==='dean' || vm.user.group_type==='vicedean'){
                    file="dean.pdf"
                }
                if(vm.user.group_type==='student'){
                    file="student.pdf"
                }
                if(vm.user.group_type==='company_manager' ||
                    vm.user.group_type==='responsible_signing_agreement-single' ||
                    vm.user.group_type==='responsible_signing_agreement-joint'){
                    file="company.pdf"
                }
            }

            if(file){
                return $rootScope.server+raiz+file;
            }else{
                return false;
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout() {
            // Do logout here.
            AuthService.logout();
        }

        /**
         * endImpersonate Function
         */
        function endImpersonate() {
            // Avisamos al servidor (refresca la sesión del administrador y deja traza) y,
            // responda lo que responda, restauramos el token del administrador aquí mismo:
            // el fin del simulacro no depende del servidor ni de eventos del navegador.
            impersonatesService.endImpersonate().finally(function(){
                var adminToken = localStorageService.get('tokenImpersonate');
                // Si el servidor respondió 401/403 el interceptor ya borró ambos tokens
                // y la recarga lleva al login.
                if (adminToken) {
                    localStorageService.set('token', adminToken);
                    localStorageService.remove('tokenImpersonate');
                }
                $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, {});
                $timeout(function(){
                    location.reload();
                },500);
            });
        }

        /**
         * Un usuario puede pertecener a varios grupos, con esta función cambiamos de grupo
         */
        function changeGroup(group) {
            AuthService.changeGroup(group).then(function(){
                $rootScope.$broadcast(authSettings.ON_LOGIN_BROADCAST, {});
                //recargamos la página
                $timeout(function(){
                    location.reload();
                },500);
            });
        }

        /**
         * Obtiene el numeró de elementos que tiene un objeto
         */
        function lengthObj(obj) {
            return Object.keys(obj).length;
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function () {
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            //MomentJS
            'angularMoment',

            'LocalStorageModule',

            'datatables',

            'flow',

            'textAngular',

            // Firma digital
            'app.digisigner',

            // Core
            'app.core',

            // home
            'app.home',

            // Breadcrumb
            'app.breadcrumb',

            // Auntenticación
            // Aquí se establece el baseUrl para la API, por lo que debe ser el primer módulo en cargar despues del core
            'app.auth',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Dashboard
            'app.dashboard',

            // Usuarios
            'app.users',

            // Empresa
            'app.company',

            // Condiciones de convenios (originales)
            'app.conditionsTemplates',

            // Eventos
            'app.events',

            // Notificaciones de eventos
            'app.eventNotifications',

            // Notificaciones
            'app.notifications',

            // Competencias
            'app.skills',

            // Programas
            'app.programs',

            // Ofertas extracurriculares
            'app.offers',

            // Plantillas ofertas extracurriculares
            'app.offersTemplates',

            // Cantidatos de ofertas
            'app.offersRequests',

            // Ofertas curriculares
            'app.demands',

            // Profesores
            'app.teachers',

            // Tutores
            'app.tutors',

            // Tutores curriculares
            'app.tutorscurriculars',

            // Tutores extracurriculares
            'app.tutorsextracurriculars',

            // Gestores de titulacion
            'app.managerDegrees',

            // Coordinadores de titulaciones
            'app.coordinators',

            // Alumnos
            'app.students',

            // Expedientes
            'app.dossiers',

            // Documentos
            'app.documents',

            // Variables de configuración
            'app.pyconfrests',

            // Titulaciones
            'app.degrees',

            // Titulaciones GADES
            'app.gadesDegrees',

            // Asignaturas
            'app.subjects',

            // Idiomas
            'app.languages',

            // Actividades de empresa
            'app.activities',

            // Registro de acciones
            'app.actionloggings',

            // Login simulado
            'app.impersonates',

            // Evaluaciones
            'app.evaluations',

            // Servicios para provincias y localidades
            'app.geopostcodes',

            // Búsquedas avanzadas
            'app.searchsAdvances',

            // Informes
            'app.reports',

            // Exportaciones
            'app.export',

            // Envíos avanzados
            'app.sendsAdvances',

            // Roles
            'app.roles',

            // Descargas
            'app.download',

            // Notificaciones
            'app.utils.notify',

            // Filtros
            'app.utils.filters',

            // Directivas
            'app.utils.directives',

            // Servicio para debounce
            'app.utils.debounce',

            'app.utils.factory',

            // Paginacion
            'angularUtils.directives.dirPagination',

            'ngPassword',

            // Traducciones
            'gettext'
        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, msNavigationService, AuthService, localStorageService, gettextCatalog)
    {
        // Data

        var currentUser = null;
        if(AuthService.loggedIn){
            AuthService.getCurrentUser().then(function (response) {
                if (response) {
                    currentUser=response;
                    createMenu();
                }
            });
        }

        function createMenu(){

            // Navigation
            msNavigationService.saveItem('companies', {
                title : gettextCatalog.getString('Empresas'),
                icon  : 'icon-domain',
                state : 'app.companyList',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("companyList","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('company', {
                title : gettextCatalog.getString('Empresa'),
                icon  : 'icon-domain',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("companyDetail","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('company.contact', {
                title : gettextCatalog.getString('Datos básicos'),
                icon  : 'icon-clipboard-text',
                state : 'app.company.detail',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("companyDetail","LIST")||
                        !$rootScope.hasPermission("centers","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('company.centers', {
                title : gettextCatalog.getString('Sedes'),
                icon  : 'icon-city',
                state : 'app.company.centers',
                weight: 2,
                hidden: function(){
                    if (!$rootScope.hasPermission("centers","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('company.contacts', {
                title : gettextCatalog.getString('Contactos'),
                icon  : 'icon-account-multiple',
                state : 'app.company.contacts',
                weight: 3,
                hidden: function(){
                    if (!$rootScope.hasPermission("contacts","LIST") ||
                        !$rootScope.hasPermission("centers","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('company.agreements', {
                title : gettextCatalog.getString('Convenios'),
                icon  : 'icon-table-large',
                state : 'app.company.agreements',
                weight: 4,
                hidden: function(){
                    if (!$rootScope.hasPermission("agreements","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('students', {
                title : gettextCatalog.getString('Alumnos'),
                icon  : 'icon-account',
                state : 'app.studentsList',
                weight: 2,
                hidden: function(){
                    if (!$rootScope.hasPermission("studentsList","LIST")){
                        return true;
                    }
                }
            });

            if($rootScope.hasPermission("teachersDetail","LIST")){
                msNavigationService.saveItem('teacher', {
                    title : gettextCatalog.getString('Mis datos'),
                    icon  : 'icon-account',
                    weight: 2,
                    state : 'app.teacher',
                    hidden: function(){
                        if (!$rootScope.hasPermission("teachersDetail","LIST")){
                            return true;
                        }
                    }
                });
            }

            msNavigationService.saveItem('student', {
                title : gettextCatalog.getString('Mis datos'),
                icon  : 'icon-account',
                weight: 2,
                hidden: function(){
                    if (!$rootScope.hasPermission("studentsDetail","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('student.detail', {
                title : gettextCatalog.getString('Datos básicos'),
                icon  : 'icon-clipboard-text',
                state : 'app.students.detail',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("studentsDetail","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('student.dossiers', {
                title : gettextCatalog.getString('Expedientes'),
                icon  : 'icon-document',
                state : 'app.dossiers.list',
                weight: 2,
                hidden: function(){
                    if (!$rootScope.hasPermission("myDossiers","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('student.offersRequests', {
                title : gettextCatalog.getString('Solicitudes de prácticas'),
                icon  : 'icon-multiplication-box',
                state : 'app.students.myOffersRequests',
                weight: 3,
                hidden: function(){
                    if (!$rootScope.hasPermission("myOffersRequests","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics', {
                title : gettextCatalog.getString('Prácticas'),
                icon  : 'icon-account-multiple',
                weight: 5,
                hidden: function(){
                    if (!$rootScope.hasPermission("offers","LIST") &&
                        !$rootScope.hasPermission("demands","LIST") &&
                        !$rootScope.hasPermission("dossiers","LIST") &&
                        !$rootScope.hasPermission("teachers","LIST") &&
                        !$rootScope.hasPermission("questions","POST") &&
                        !$rootScope.hasPermission("programs","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.mydemands', {
                title : gettextCatalog.getString('Mis ofertas curriculares'),
                icon  : 'icon-multiplication',
                state : 'app.mydemands',
                weight: 0,
                hidden: function(){
                    if (!$rootScope.hasPermission("myDemands","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.demands', {
                title : gettextCatalog.getString('Ofertas curriculares'),
                icon  : 'icon-multiplication',
                state : 'app.demands.list',
                weight: 0,
                hidden: function(){
                    if (!$rootScope.hasPermission("demands","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.offers', {
                title : gettextCatalog.getString('Ofertas extracurriculares'),
                icon  : 'icon-multiplication-box',
                state : 'app.offers',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("offers","LIST")){
                        return true;
                    }
                }
            });

            //Ponemos este if aqui porque si no sobresscribe al del alumno
            if($rootScope.hasPermission("dossiers","LIST")){
                msNavigationService.saveItem('academics.dossiers', {
                    title : gettextCatalog.getString('Expedientes'),
                    icon  : 'icon-document',
                    state : 'app.dossiers.list',
                    weight: 2,
                    hidden: function(){
                        if (!$rootScope.hasPermission("dossiers","LIST")){
                            return true;
                        }
                    }
                });
            }

            msNavigationService.saveItem('academics.programs', {
                title : gettextCatalog.getString('Programas'),
                icon  : 'icon-star',
                state : 'app.programs',
                weight: 3,
                hidden: function(){
                    if (!$rootScope.hasPermission("programs","PATCH") &&
                        !$rootScope.hasPermission("programs","POST") &&
                        !$rootScope.hasPermission("programs","DELETE")){
                        return true;
                    }
                }
            });

            /*msNavigationService.saveItem('academics.tutors', {
                title : gettextCatalog.getString('Tutores académicos'),
                icon  : 'icon-account-box-outline',
                state : 'app.tutors',
                weight: 4,
                hidden: function(){
                    if (!$rootScope.hasPermission("teachers","LIST")){
                        return true;
                    }
                }
            });*/

            msNavigationService.saveItem('academics.tutorscurriculars', {
                title : gettextCatalog.getString('Tutores curriculares'),
                icon  : 'icon-account-box-outline',
                state : 'app.tutorscurriculars',
                weight: 4,
                hidden: function(){
                    if (!$rootScope.hasPermission("teachersCurricular","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.tutorsextracurriculars', {
                title : gettextCatalog.getString('Tutores extracurriculares'),
                icon  : 'icon-account-box-outline',
                state : 'app.tutorsextracurriculars',
                weight: 4,
                hidden: function(){
                    if (!$rootScope.hasPermission("teachersExtracurricular","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.coordinators', {
                title : gettextCatalog.getString('Coordinadores de asignatura'),
                icon  : 'icon-account-box-outline',
                state : 'app.coordinators',
                weight: 5,
                hidden: function(){
                    if (!$rootScope.hasPermission("teachers","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.managerDegrees', {
                title : gettextCatalog.getString('Gestores de titulación'),
                icon  : 'icon-clipboard-account',
                state : 'app.managerDegrees',
                weight: 6,
                hidden: function(){
                    if (!$rootScope.hasPermission("managerDegrees","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('academics.questions', {
                title : gettextCatalog.getString('Cuestionarios'),
                icon  : 'icon-question-mark-circle',
                state : 'app.evaluations.questions',
                weight: 7,
                hidden: function(){
                    if (!$rootScope.hasPermission("questionnaires","LIST") ||
                        !$rootScope.hasPermission("questions","LIST") ||
                        !$rootScope.hasPermission("questions","POST")){
                        return true;
                    }
                }
            });

           msNavigationService.saveItem('documents', {
               title : gettextCatalog.getString('Documentos'),
               icon  : 'icon-file',
               state : 'app.documents.list',
               weight: 6,
               hidden: function(){
                    if (!$rootScope.hasPermission("documents","LIST")){
                        return true;
                    }
                }
           });

           msNavigationService.saveItem('reports', {
               title : gettextCatalog.getString('Informes'),
               icon  : 'icon-file-document',
               state : 'app.reports',
               weight: 7,
               hidden: function(){
                    if (!$rootScope.hasPermission("reports","LIST")){
                        return true;
                    }
                }
           });

           msNavigationService.saveItem('mail', {
               title : gettextCatalog.getString('Notificaciones'),
               icon  : 'icon-bell',
               state : 'app.notifications',
               weight: 8,
               hidden: function(){
                    if (!$rootScope.hasPermission("notifications","LIST")){
                        return true;
                    }
                }
           });

            msNavigationService.saveItem('config', {
                title : gettextCatalog.getString('Configuración'),
                icon  : 'icon-cog',
                weight: 20,
                hidden: function(){
                    if ((!$rootScope.hasPermission("categories","LIST") ||
                        !$rootScope.hasPermission("categories","GET")) &&
                        !$rootScope.hasPermission("conditionsTemplates","LIST") &&
                        !$rootScope.hasPermission("skills","PATCH") &&
                        !$rootScope.hasPermission("skills","POST") &&
                        !$rootScope.hasPermission("skills","DELETE") &&
                        !$rootScope.hasPermission("pyconfrests","LIST") &&
                        !$rootScope.hasPermission("impersonates","POST") &&
                        !$rootScope.hasPermission("actionloggings","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.events', {
                title : gettextCatalog.getString('Notificaciones'),
                icon  : 'icon-bell',
                state : 'app.events',
                weight: 1,
                hidden: function(){
                    if (!$rootScope.hasPermission("categories","LIST") ||
                        !$rootScope.hasPermission("categories","GET")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.agreements', {
                title : gettextCatalog.getString('Cláusulas de convenios'),
                icon  : 'icon-table-large',
                state : 'app.conditionsTemplates',
                weight: 2,
                hidden: function(){
                    if (!$rootScope.hasPermission("conditionsTemplates","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.skills', {
                title : gettextCatalog.getString('Competencias'),
                icon  : 'icon-arrange-bring-forward',
                state : 'app.skills',
                weight: 3,
                hidden: function(){
                    if (!$rootScope.hasPermission("skills","PATCH") &&
                        !$rootScope.hasPermission("skills","POST") &&
                        !$rootScope.hasPermission("skills","DELETE")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.activities', {
                title : gettextCatalog.getString('Actividades de empresa'),
                icon  : 'icon-hexagon-outline',
                state : 'app.activities',
                weight: 4,
                hidden: function(){
                    if (!$rootScope.hasPermission("activities","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.degrees', {
                title : gettextCatalog.getString('Titulaciones GADES'),
                icon  : 'icon-book-open',
                state : 'app.gadesDegrees',
                weight: 5,
                hidden: function(){
                    if (!$rootScope.hasPermission("gadesDegrees","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.pyconfrests', {
                title : gettextCatalog.getString('Variables del sistema'),
                icon  : 'icon-cog',
                state : 'app.pyconfrests',
                weight: 6,
                hidden: function(){
                    if (!$rootScope.hasPermission("pyconfrests","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.actionloggings', {
                title : gettextCatalog.getString('Registro de acciones del sistema'),
                icon  : 'icon-format-list-bulleted',
                state : 'app.actionloggings',
                weight: 7,
                hidden: function(){
                    if (!$rootScope.hasPermission("actionloggings","LIST")){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.impersonates', {
                title : gettextCatalog.getString('Login simulado'),
                icon  : 'icon-account-key',
                state : 'app.impersonates',
                weight: 8,
                hidden: function(){
                    if (!$rootScope.hasPermission("impersonates","POST") ||
                        localStorageService.get('tokenImpersonate')){
                        return true;
                    }
                }
            });

            msNavigationService.saveItem('config.roles', {
                title : gettextCatalog.getString('Roles'),
                icon  : 'icon-account-switch',
                state : 'app.roles',
                weight: 9,
                hidden: function(){
                    if (!$rootScope.hasPermission("role","LIST")){
                        return true;
                    }
                }
            });
            msNavigationService.saveItem('config.download', {
                title : gettextCatalog.getString('Descargas'),
                icon  : 'icon-cog',
                state : 'app.download',
                weight: 10,
                hidden: function(){
                    if (!$rootScope.hasPermission("role","LIST")){
                        return true;
                    }
                }
            });

        }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.digisigner', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.digisigner')
        .directive('digisigner', digisignerDirective);


    /** @ngInject */
    function digisignerDirective()
    {
        return {
            restrict   : 'E',
            controller : 'DigisignerController as vm',
            templateUrl: 'app/digisigner/digisigner.html',
            bindToController: true,
            scope:{
                successCallback: '=',
                errorCallback: '=',
                data: '='
            }
        };
    }




})();
(function ()
{
    'use strict';

    angular
        .module('app.digisigner')
        .controller('DigisignerController', DigisignerController);

    /** @ngInject */
    function DigisignerController(digisignerConstant, $timeout)
    {
        var vm = this;
        vm.loadSign=false;

        TestEnvironment.identify(window);
        vm.so=(window.jscd) ? window.jscd.os + " " + window.jscd.osVersion : null;
        vm.browser=(window.jscd) ? window.jscd.browser + " " + window.jscd.browserVersion : null;
        vm.java=(window.jscd) ? window.jscd.javaVersion + (window.jscd.javaArch != null ? (" (" + window.jscd.javaArch + " bits)") : "") : null;

        // Methods
        vm.sign = sign;
        vm.signAndSave = signAndSave;
        vm.coSignAndSave = coSignAndSave;
        vm.counterSignAndSave = counterSignAndSave;

        /*
        * Comprobación de compatibilidades
        * */
        vm.isOsSupported = isOsSupported;
        vm.isBrowserSupported = isBrowserSupported;
        vm.isJavaPluginSupported = isJavaPluginSupported;

        //////////
        /**
         * Firma un documento
         *
         */
        function sign() {
            vm.loadSign=true;
            var data=null;
            if(isFunction(vm.data)){
                vm.data().then(function(response){
                    var data=response;
                    doSign(data);
                },function () {
                    vm.loadSign=false;
                });
            }else{
                data = vm.data || null;
                doSign(data);
            }

        }

        /**
         * Firma y descarga un documento
         *
         */
        function signAndSave() {
            vm.loadSign=true;
            doSignAndSave("sign");
        }

        /**
         * Cofirma y descarga de un documento
         *
         */
        function coSignAndSave() {
            vm.loadSign=true;
            doSignAndSave("cosign");
        }

        /**
         * Contrafirma y descarga de un documento.
         *
         */
        function counterSignAndSave() {
            vm.loadSign=true;
            doSignAndSave("countersign");
        }

        /**
         * Obtención de parámetros para la firma
         *
         */
        function getParams() {
            var params = "serverUrl=" + digisignerConstant.SERVER_URL + "\n" +
                "signaturePage=" + digisignerConstant.SIGNATURE_PAGE + "\n" +
                "signaturePositionOnPageLowerLeftX=" + digisignerConstant.SIGNATURE_POSITION_ON_PAGE_LOWER_LEFTX + "\n" +
                "signaturePositionOnPageLowerLeftY=" + digisignerConstant.SIGNATURE_POSITION_ON_PAGE_LOWER_LEFTY + "\n" +
                "signaturePositionOnPageUpperRightY=" + digisignerConstant.SIGNATURE_POSITION_ON_PAGE_UPPER_RIGHTY + "\n" +
                "signaturePositionOnPageUpperRightX=" + digisignerConstant.SIGNATURE_POSITION_ON_PAGE_UPPER_RIGHTX + "\n" +
                "layer2Text=" + digisignerConstant.LAYER_2_TEXT + "\n" +
                "layer2FontSize=" + digisignerConstant.LAYER_2_FONT_SIZE;

            return params;
        }

        function isFunction(functionToCheck) {
            return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
        }

        /**
         * Firma del documento y guardado
         *
         * @param cryptoOp
         */
        function doSignAndSave(cryptoOp) {
            var algorithm = digisignerConstant.SIGNATURE_ALGORITHM;
            var format = digisignerConstant.SIGNATURE_FORMAT;
            var params = getParams();
            var data = vm.data || null;

            try {
                MiniApplet.signAndSaveToFile(
                    cryptoOp,
                    data,
                    algorithm,
                    format,
                    params,
                    null,
                    successCallback,
                    errorCallback);

            } catch (e) {
                vm.loadSign=false;
                try {
                    console.log("Type: " + MiniApplet.getErrorType() + "\nMessage: " + MiniApplet.getErrorMessage());
                } catch (ex) {
                    console.log("Error: " + e);
                }
            }
        }

        /**
         * Firma del documento
         *
         */
        function doSign(data) {
            var algorithm = digisignerConstant.SIGNATURE_ALGORITHM;
            var format = digisignerConstant.SIGNATURE_FORMAT;
            var params = getParams();

            try {
                MiniApplet.sign(
                    data,
                    algorithm,
                    format,
                    params,
                    successCallback,
                    errorCallback);
            } catch (e) {
                try {
                    console.log("Type: " + MiniApplet.getErrorType() + "\nMessage: " + MiniApplet.getErrorMessage());
                } catch (ex) {
                    console.log("Error: " + e);
                }
            }
        }

        // CALLBACKS
        ///////////////////////////////////////////////////////////////////////////////////////////////
        /**
         * Callback por defecto cuando se firma con éxito.
         *
         * @param signatureB64
         * @param certificateB64
         */
        function defaultSuccessCallback(signatureB64, certificateB64) {
            console.log("Firma OK");
            console.log(signatureB64);
        }

        /**
         * Callback por defecto cuando la firma da error.
         *
         * @param errorType
         * @param errorMessage
         */
        function defaultErrorCallback(errorType, errorMessage) {
            console.log("Type: " + errorType + "\nMessage: " + errorMessage);
        }

        function successCallback(signatureB64, certificateB64) {
            vm.loadSign=false;
            if (vm.successCallback){
                vm.successCallback(signatureB64, certificateB64);
            } else {
                defaultSuccessCallback(signatureB64, certificateB64);
            }
        }

        function errorCallback(errorType, errorMessage) {
            vm.loadSign=false;
            if (vm.errorCallback){
                vm.errorCallback(errorType, errorMessage);
            } else {
                defaultErrorCallback(errorType, errorMessage);
            }
        }


        //////////
        /*
        * Comprobación de compatibilidades
        * */

        /*
        * Comprueba que sea un sistema operativo compatible
        * */
        function isOsSupported() {
			var supported = false;
			if (window.jscd.os == "Windows") {
				supported = window.jscd.osVersion == "XP" || window.jscd.osVersion == "Vista" ||
							window.jscd.osVersion == "Server 2003" || window.jscd.osVersion == "7" ||
							window.jscd.osVersion == "8" || window.jscd.osVersion == "8.1";
			}
			else if (window.jscd.os == "Linux") {
				supported = true;	// No podemos comprobar la version
			}
			else if (window.jscd.os == "Mac OS X") {
				supported = window.jscd.osVersion >= 9.5;
			}
			return supported;
		}

		/*
        * Comprueba que sea un navegador compatible
        * */
		function isBrowserSupported() {
			var supported = false;
			if (window.jscd.browser == "Microsoft Internet Explorer") {
				supported = window.jscd.browserVersion >= 8;
			}
			else if (window.jscd.browser == "Chrome") {
				supported = window.jscd.browserVersion >= 15 && window.jscd.browserVersion <= 41;
			}
			else if (window.jscd.browser == "Firefox") {
				supported = window.jscd.browserVersion >= 4;
			}
			else if (window.jscd.browser == "Safari") {
				supported = window.jscd.browserVersion >= 6.2;
			}
			return supported;
		}

		/*
        * Comprueba que tenga un java instalado compatible
        * */
		function isJavaPluginSupported() {
			var supported = false;
			if (window.jscd.javaVersion.indexOf("1.8.0") == 0) {
				supported = true;
			}
			else if (window.jscd.javaVersion.indexOf("1.7.0") == 0) {
				var updateSep = window.jscd.javaVersion.indexOf('_');
				supported = updateSep != -1 && window.jscd.javaVersion.subString(updateSep + 1) >= 10;
			}
			else if (window.jscd.javaVersion.indexOf("1.6.0") == 0) {
				var updateSep = window.jscd.javaVersion.indexOf('_');
				supported = updateSep != -1 && window.jscd.javaVersion.substring(updateSep + 1) >= 38 &&
							window.jscd.javaArch == "32";
			}
			return supported;
		}

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.digisigner')
        .constant('digisignerConstant', {
            URL_BASE_APPLET: "http://10.1.46.156:8080/afirma-ui-miniapplet-deploy",
            URL_BASE_SERVICES: "http://10.1.46.156:8080",

            SERVER_URL: "http://10.1.46.156:8080/afirma-server-triphase-signer/SignatureService",

            SIGNATURE_PAGE: "LAST_PAGE",
            SIGNATURE_POSITION_ON_PAGE_LOWER_LEFTX: "10",
            SIGNATURE_POSITION_ON_PAGE_LOWER_LEFTY: "120",
            SIGNATURE_POSITION_ON_PAGE_UPPER_RIGHTY: "180",
            SIGNATURE_POSITION_ON_PAGE_UPPER_RIGHTX: "680",

            //La cadena no admite saltos de linea, no nos queda otra que añadir espacios
            LAYER_2_TEXT: "Firmado por $$SUBJECTCN$$ el día $$SIGNDATE=dd/MM/yyyy$$, con número de serie $$CERTSERIAL$$. " +
                          "                                                                              " +
                          "Para validar la firma use la plataforma «https://valide.redsara.es»",
            LAYER_2_FONT_SIZE: "10",

            // Tipo de firma
            SIGNATURE_ALGORITHM: "SHA1withRSA",  // opciones disponible (SHA1withRSA, SHA512withRSA)
            SIGNATURE_FORMAT: "AUTO" // opciones disponibles
            // (CAdES, CAdEStri, Adobe PDF, PAdEStri, XAdES, XMLdSig, XAdEStri, FacturaE, FacturaEtri, ODF, OOXML, NONE, AUTO)
        });


})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.breadcrumb', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.breadcrumb')
        .directive('msBreadcrumb', msBreadcrumbDirective)
        .directive('bindHtmlCompile', bindHtmlCompile);


    /** @ngInject */
    function msBreadcrumbDirective()
    {
        return {
            restrict   : 'E',
            controller : 'BreadcrumbController as vm',
            templateUrl: 'app/breadcrumb/breadcrumb.html',
            transclude : true
        };
    }

    /** @ngInject */
    function bindHtmlCompile($compile)
    {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    element.html(value);
                    $compile(element.contents())(scope);
                });
            }
        };
    }



})();
(function ()
{
    'use strict';

    angular
        .module('app.breadcrumb')
        .controller('BreadcrumbController', BreadcrumbController);

    /** @ngInject */
    function BreadcrumbController($rootScope, $state,gettextCatalog)
    {
        /*
        * Por defecto vamos a coger los state, les vamos a hacer un split por el "." y vamos a traducir cada elemento del array
        * Si queremos sobreescribir este breadcrumb debemos hacerlo en el resolve del state, puedes ver un ejemplo en company.module
        * en el state "app.company.agreement"
        * */

        var vm = this;
        var state=annotatedStateObject($state.current, $state.$current);
        init(state.name,state.resolve.Breadcrumb);

        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
            toState = annotatedStateObject(toState, $state.$current);
            init(toState.name,toState.resolve.Breadcrumb);
        });

        vm.translate={
            'dashboard':gettextCatalog.getString('Inicio'),
            'companyList':gettextCatalog.getString('Empresas'),
            'company':gettextCatalog.getString('Empresa'),
            'detail':gettextCatalog.getString('Datos básicos'),
            'centers':gettextCatalog.getString('Centros'),
            'contacts':gettextCatalog.getString('Contactos'),
            'agreements':gettextCatalog.getString('Convenios'),
            'agreement':gettextCatalog.getString('Convenio'),
            'demands':gettextCatalog.getString('Ofertas curriculares'),
            'demand':gettextCatalog.getString('Oferta curricular'),
            'offers':gettextCatalog.getString('Ofertas extracurriculares'),
            'offer':gettextCatalog.getString('Oferta extracurricular'),
            'offersRequests':gettextCatalog.getString('Candidatos oferta extracurricular'),
            'myOffersRequests':gettextCatalog.getString('Solicitudes de prácticas'),
            'programs':gettextCatalog.getString('Programas'),
            'tutors':gettextCatalog.getString('Tutores académicos'),
            'managerDegrees':gettextCatalog.getString('Gestores de titulación'),
            'teacher':gettextCatalog.getString('Tutor'),
            'documents':gettextCatalog.getString('Documentos'),
            'list':gettextCatalog.getString('Listado'),
            'notifications':gettextCatalog.getString('Notificaciones'),
            'events':gettextCatalog.getString('Eventos'),
            'eventNotifications':gettextCatalog.getString('Notifiaciones de evento'),
            'conditionsTemplates':gettextCatalog.getString('Cláusulas de convenios'),
            'skills':gettextCatalog.getString('Competencias'),
            'activities':gettextCatalog.getString('Actividades'),
            'studentsList':gettextCatalog.getString('Alumnos'),
            'students':gettextCatalog.getString('Alumno'),
            'dossiers':gettextCatalog.getString('Expedientes'),
            'pyconfrests':gettextCatalog.getString('Variables del sistema'),
            'actionloggings':gettextCatalog.getString('Acciones del sistema'),
            'impersonates':gettextCatalog.getString('Login simulado'),
            'reports':gettextCatalog.getString('Informes'),
            'export':gettextCatalog.getString('Exportaciones'),
            'searchsAdvances':gettextCatalog.getString('Búsqueda avanzada'),
            'sendsAdvances':gettextCatalog.getString('Envío avanzado'),
            'gadesDegrees':gettextCatalog.getString('Titulaciones'),
            'coordinators':gettextCatalog.getString('Coordinadores'),
            'roles':gettextCatalog.getString('Roles')
        };

        function init(state, breadcrumb){
            if(breadcrumb){
                vm.items=breadcrumb;
            }else{
                vm.name=state.replace("app.","");
                vm.items=vm.name.split(".");
            }
        }

        function annotatedStateObject(state, $current) {
            state = angular.extend({}, state);
            var resolveData = $current.locals.resolve.$$values;
            state.params = resolveData.$stateParams;
            state.resolve = omit(resolveData, '$stateParams');
            state.includes = $current.includes;
            return state;
        }

        function omit(obj, arr) {
            arr = Array.isArray(arr) ? arr : [arr];
            arr.forEach(function(key){
                delete(obj[key]);
            });
            return obj;
        }

    }

})();
angular.module('gettext').run(['gettextCatalog', function (gettextCatalog) {
/* jshint -W100 */
    gettextCatalog.setStrings('en', {"Acciones":"Actions","Buscar":"Search","Cambiar contraseña":"Change password","Cerrar":"Close","Configurar":"Set","Contraseña":"User password","Código":"Code","Editar":"Edit","Eliminar":"Remove","Email":"Email","Estado":"Status","Fecha fin":"End date","Fecha inicio":"Start date","Grupos":"Groups","Guardar":"Save","Importar":"Import","Inicio":"Home","Introduzca un año válido":"Please enter a valid year","Nombre":"Name","Nueva contraseña":"New password","Nuevo programa":"New program","Programas":"Programs","Subir imagen":"Upload Image","Teléfono":"Phone number","Tipo":"Type","Usuarios":"Users","Imprimir":"Print","Duración":"Duration","Meses":"Months","Días":"Days","Descargar aceptación":"Download acceptance","Imprimir aceptación":"Print acceptance","Descargar documento de aceptación":"Download acceptance document","Imprimir documento de aceptación":"Print acceptance document","Imprimir convenio":"Print agreement","Imprimir memoria":"Print report","Imprimir CV profesional":"Print professional CV","Imprimir CV investigador":"Print researcher CV","Su navegador no puede mostrar el PDF; descárguelo para imprimirlo.":"Your browser cannot display the PDF; download it to print it.","No se ha podido obtener el documento.":"The document could not be retrieved."});
/* jshint +W100 */
}]);
MimeType={};
MimeType.ez="application/andrew-inset";
MimeType.aw="application/applixware";
MimeType.atom="application/atom+xml";
MimeType.atomcat="application/atomcat+xml";
MimeType.atomsvc="application/atomsvc+xml";
MimeType.ccxml="application/ccxml+xml";
MimeType.cu="application/cu-seeme";
MimeType.davmount="application/davmount+xml";
MimeType.ecma="application/ecmascript";
MimeType.emma="application/emma+xml";
MimeType.epub="application/epub+zip";
MimeType.pfr="application/font-tdpfr";
MimeType.stk="application/hyperstudio";
MimeType.jar="application/java-archive";
MimeType.ser="application/java-serialized-object";
MimeType.class="application/java-vm";
MimeType.js="application/javascript";
MimeType.json="application/json";
MimeType.lostxml="application/lost+xml";
MimeType.hqx="application/mac-binhex40";
MimeType.cpt="application/mac-compactpro";
MimeType.mrc="application/marc";
MimeType.ma="application/mathematica";
MimeType.nb="application/mathematica";
MimeType.mb="application/mathematica";
MimeType.mathml="application/mathml+xml";
MimeType.mbox="application/mbox";
MimeType.mscml="application/mediaservercontrol+xml";
MimeType.mp4s="application/mp4";
MimeType.doc="application/msword";
MimeType.dot="application/msword";
MimeType.mxf="application/mxf";
MimeType.oda="application/oda";
MimeType.opf="application/oebps-package+xml";
MimeType.ogx="application/ogg";
MimeType.xer="application/patch-ops-error+xml";
MimeType.pdf="application/pdf";
MimeType.pgp="application/pgp-encrypted";
MimeType.prf="application/pics-rules";
MimeType.p10="application/pkcs10";
MimeType.p7s="application/pkcs7-signature";
MimeType.cer="application/pkix-cert";
MimeType.crl="application/pkix-crl";
MimeType.pkipath="application/pkix-pkipath";
MimeType.pki="application/pkixcmp";
MimeType.pls="application/pls+xml";
MimeType.cww="application/prs.cww";
MimeType.rdf="application/rdf+xml";
MimeType.rif="application/reginfo+xml";
MimeType.rnc="application/relax-ng-compact-syntax";
MimeType.rl="application/resource-lists+xml";
MimeType.rld="application/resource-lists-diff+xml";
MimeType.rs="application/rls-services+xml";
MimeType.rsd="application/rsd+xml";
MimeType.rss="application/rss+xml";
MimeType.rtf="application/rtf";
MimeType.sbml="application/sbml+xml";
MimeType.scq="application/scvp-cv-request";
MimeType.scs="application/scvp-cv-response";
MimeType.spq="application/scvp-vp-request";
MimeType.spp="application/scvp-vp-response";
MimeType.sdp="application/sdp";
MimeType.setpay="application/set-payment-initiation";
MimeType.setreg="application/set-registration-initiation";
MimeType.shf="application/shf+xml";
MimeType.rq="application/sparql-query";
MimeType.srx="application/sparql-results+xml";
MimeType.gram="application/srgs";
MimeType.grxml="application/srgs+xml";
MimeType.ssml="application/ssml+xml";
MimeType.plb="application/vnd.3gpp.pic-bw-large";
MimeType.psb="application/vnd.3gpp.pic-bw-small";
MimeType.pvb="application/vnd.3gpp.pic-bw-var";
MimeType.tcap="application/vnd.3gpp2.tcap";
MimeType.pwn="application/vnd.3m.post-it-notes";
MimeType.aso="application/vnd.accpac.simply.aso";
MimeType.imp="application/vnd.accpac.simply.imp";
MimeType.acu="application/vnd.acucobol";
MimeType.air="application/vnd.adobe.air-application-installer-package+zip";
MimeType.xdp="application/vnd.adobe.xdp+xml";
MimeType.xfdf="application/vnd.adobe.xfdf";
MimeType.azf="application/vnd.airzip.filesecure.azf";
MimeType.azs="application/vnd.airzip.filesecure.azs";
MimeType.azw="application/vnd.amazon.ebook";
MimeType.acc="application/vnd.americandynamics.acc";
MimeType.ami="application/vnd.amiga.ami";
MimeType.apk="application/vnd.android.package-archive";
MimeType.cii="application/vnd.anser-web-certificate-issue-initiation";
MimeType.fti="application/vnd.anser-web-funds-transfer-initiation";
MimeType.atx="application/vnd.antix.game-component";
MimeType.mpkg="application/vnd.apple.installer+xml";
MimeType.swi="application/vnd.arastra.swi";
MimeType.aep="application/vnd.audiograph";
MimeType.mpm="application/vnd.blueice.multipass";
MimeType.bmi="application/vnd.bmi";
MimeType.rep="application/vnd.businessobjects";
MimeType.cdxml="application/vnd.chemdraw+xml";
MimeType.mmd="application/vnd.chipnuts.karaoke-mmd";
MimeType.cdy="application/vnd.cinderella";
MimeType.cla="application/vnd.claymore";
MimeType.csp="application/vnd.commonspace";
MimeType.cdbcmsg="application/vnd.contact.cmsg";
MimeType.cmc="application/vnd.cosmocaller";
MimeType.clkx="application/vnd.crick.clicker";
MimeType.clkk="application/vnd.crick.clicker.keyboard";
MimeType.clkp="application/vnd.crick.clicker.palette";
MimeType.clkt="application/vnd.crick.clicker.template";
MimeType.clkw="application/vnd.crick.clicker.wordbank";
MimeType.wbs="application/vnd.criticaltools.wbs+xml";
MimeType.pml="application/vnd.ctc-posml";
MimeType.ppd="application/vnd.cups-ppd";
MimeType.car="application/vnd.curl.car";
MimeType.pcurl="application/vnd.curl.pcurl";
MimeType.rdz="application/vnd.data-vision.rdz";
MimeType.fe_launch="application/vnd.denovo.fcselayout-link";
MimeType.dna="application/vnd.dna";
MimeType.mlp="application/vnd.dolby.mlp";
MimeType.dpg="application/vnd.dpgraph";
MimeType.dfac="application/vnd.dreamfactory";
MimeType.geo="application/vnd.dynageo";
MimeType.mag="application/vnd.ecowin.chart";
MimeType.nml="application/vnd.enliven";
MimeType.esf="application/vnd.epson.esf";
MimeType.msf="application/vnd.epson.msf";
MimeType.qam="application/vnd.epson.quickanime";
MimeType.slt="application/vnd.epson.salt";
MimeType.ssf="application/vnd.epson.ssf";
MimeType.ez2="application/vnd.ezpix-album";
MimeType.ez3="application/vnd.ezpix-package";
MimeType.fdf="application/vnd.fdf";
MimeType.mseed="application/vnd.fdsn.mseed";
MimeType.gph="application/vnd.flographit";
MimeType.ftc="application/vnd.fluxtime.clip";
MimeType.fnc="application/vnd.frogans.fnc";
MimeType.ltf="application/vnd.frogans.ltf";
MimeType.fsc="application/vnd.fsc.weblaunch";
MimeType.oas="application/vnd.fujitsu.oasys";
MimeType.oa2="application/vnd.fujitsu.oasys2";
MimeType.oa3="application/vnd.fujitsu.oasys3";
MimeType.fg5="application/vnd.fujitsu.oasysgp";
MimeType.bh2="application/vnd.fujitsu.oasysprs";
MimeType.ddd="application/vnd.fujixerox.ddd";
MimeType.xdw="application/vnd.fujixerox.docuworks";
MimeType.xbd="application/vnd.fujixerox.docuworks.binder";
MimeType.fzs="application/vnd.fuzzysheet";
MimeType.txd="application/vnd.genomatix.tuxedo";
MimeType.ggb="application/vnd.geogebra.file";
MimeType.ggt="application/vnd.geogebra.tool";
MimeType.gmx="application/vnd.gmx";
MimeType.kml="application/vnd.google-earth.kml+xml";
MimeType.kmz="application/vnd.google-earth.kmz";
MimeType.gac="application/vnd.groove-account";
MimeType.ghf="application/vnd.groove-help";
MimeType.gim="application/vnd.groove-identity-message";
MimeType.grv="application/vnd.groove-injector";
MimeType.gtm="application/vnd.groove-tool-message";
MimeType.tpl="application/vnd.groove-tool-template";
MimeType.vcg="application/vnd.groove-vcard";
MimeType.zmm="application/vnd.handheld-entertainment+xml";
MimeType.hbci="application/vnd.hbci";
MimeType.les="application/vnd.hhe.lesson-player";
MimeType.hpgl="application/vnd.hp-hpgl";
MimeType.hpid="application/vnd.hp-hpid";
MimeType.hps="application/vnd.hp-hps";
MimeType.jlt="application/vnd.hp-jlyt";
MimeType.pcl="application/vnd.hp-pcl";
MimeType.pclxl="application/vnd.hp-pclxl";
MimeType.x3d="application/vnd.hzn-3d-crossword";
MimeType.mpy="application/vnd.ibm.minipay";
MimeType.irm="application/vnd.ibm.rights-management";
MimeType.sc="application/vnd.ibm.secure-container";
MimeType.igl="application/vnd.igloader";
MimeType.ivp="application/vnd.immervision-ivp";
MimeType.ivu="application/vnd.immervision-ivu";
MimeType.qbo="application/vnd.intu.qbo";
MimeType.qfx="application/vnd.intu.qfx";
MimeType.rcprofile="application/vnd.ipunplugged.rcprofile";
MimeType.irp="application/vnd.irepository.package+xml";
MimeType.xpr="application/vnd.is-xpr";
MimeType.jam="application/vnd.jam";
MimeType.rms="application/vnd.jcp.javame.midlet-rms";
MimeType.jisp="application/vnd.jisp";
MimeType.joda="application/vnd.joost.joda-archive";
MimeType.karbon="application/vnd.kde.karbon";
MimeType.chrt="application/vnd.kde.kchart";
MimeType.kfo="application/vnd.kde.kformula";
MimeType.flw="application/vnd.kde.kivio";
MimeType.kon="application/vnd.kde.kontour";
MimeType.ksp="application/vnd.kde.kspread";
MimeType.htke="application/vnd.kenameaapp";
MimeType.kia="application/vnd.kidspiration";
MimeType.sse="application/vnd.kodak-descriptor";
MimeType.lbd="application/vnd.llamagraphics.life-balance.desktop";
MimeType.lbe="application/vnd.llamagraphics.life-balance.exchange+xml";
MimeType.apr="application/vnd.lotus-approach";
MimeType.pre="application/vnd.lotus-freelance";
MimeType.nsf="application/vnd.lotus-notes";
MimeType.org="application/vnd.lotus-organizer";
MimeType.scm="application/vnd.lotus-screencam";
MimeType.lwp="application/vnd.lotus-wordpro";
MimeType.portpkg="application/vnd.macports.portpkg";
MimeType.mcd="application/vnd.mcd";
MimeType.mc1="application/vnd.medcalcdata";
MimeType.cdkey="application/vnd.mediastation.cdkey";
MimeType.mwf="application/vnd.mfer";
MimeType.mfm="application/vnd.mfmp";
MimeType.flo="application/vnd.micrografx.flo";
MimeType.igx="application/vnd.micrografx.igx";
MimeType.mif="application/vnd.mif";
MimeType.daf="application/vnd.mobius.daf";
MimeType.dis="application/vnd.mobius.dis";
MimeType.mbk="application/vnd.mobius.mbk";
MimeType.mqy="application/vnd.mobius.mqy";
MimeType.msl="application/vnd.mobius.msl";
MimeType.plc="application/vnd.mobius.plc";
MimeType.txf="application/vnd.mobius.txf";
MimeType.mpn="application/vnd.mophun.application";
MimeType.mpc="application/vnd.mophun.certificate";
MimeType.xul="application/vnd.mozilla.xul+xml";
MimeType.cil="application/vnd.ms-artgalry";
MimeType.cab="application/vnd.ms-cab-compressed";
MimeType.xls="application/vnd.ms-excel";
MimeType.xlm="application/vnd.ms-excel";
MimeType.xla="application/vnd.ms-excel";
MimeType.xlc="application/vnd.ms-excel";
MimeType.xlt="application/vnd.ms-excel";
MimeType.xlw="application/vnd.ms-excel";
MimeType.xlam="application/vnd.ms-excel.addin.macroenabled.12";
MimeType.xlsb="application/vnd.ms-excel.sheet.binary.macroenabled.12";
MimeType.xlsm="application/vnd.ms-excel.sheet.macroenabled.12";
MimeType.xltm="application/vnd.ms-excel.template.macroenabled.12";
MimeType.eot="application/vnd.ms-fontobject";
MimeType.chm="application/vnd.ms-htmlhelp";
MimeType.ims="application/vnd.ms-ims";
MimeType.lrm="application/vnd.ms-lrm";
MimeType.cat="application/vnd.ms-pki.seccat";
MimeType.stl="application/vnd.ms-pki.stl";
MimeType.ppt="application/vnd.ms-powerpoint";
MimeType.pps="application/vnd.ms-powerpoint";
MimeType.pot="application/vnd.ms-powerpoint";
MimeType.ppam="application/vnd.ms-powerpoint.addin.macroenabled.12";
MimeType.pptm="application/vnd.ms-powerpoint.presentation.macroenabled.12";
MimeType.sldm="application/vnd.ms-powerpoint.slide.macroenabled.12";
MimeType.ppsm="application/vnd.ms-powerpoint.slideshow.macroenabled.12";
MimeType.potm="application/vnd.ms-powerpoint.template.macroenabled.12";
MimeType.docm="application/vnd.ms-word.document.macroenabled.12";
MimeType.dotm="application/vnd.ms-word.template.macroenabled.12";
MimeType.wpl="application/vnd.ms-wpl";
MimeType.xps="application/vnd.ms-xpsdocument";
MimeType.mseq="application/vnd.mseq";
MimeType.mus="application/vnd.musician";
MimeType.msty="application/vnd.muvee.style";
MimeType.nlu="application/vnd.neurolanguage.nlu";
MimeType.nnd="application/vnd.noblenet-directory";
MimeType.nns="application/vnd.noblenet-sealer";
MimeType.nnw="application/vnd.noblenet-web";
MimeType.ngdat="application/vnd.nokia.n-gage.data";
MimeType.rpst="application/vnd.nokia.radio-preset";
MimeType.rpss="application/vnd.nokia.radio-presets";
MimeType.edm="application/vnd.novadigm.edm";
MimeType.edx="application/vnd.novadigm.edx";
MimeType.ext="application/vnd.novadigm.ext";
MimeType.odc="application/vnd.oasis.opendocument.chart";
MimeType.otc="application/vnd.oasis.opendocument.chart-template";
MimeType.odb="application/vnd.oasis.opendocument.database";
MimeType.odf="application/vnd.oasis.opendocument.formula";
MimeType.odft="application/vnd.oasis.opendocument.formula-template";
MimeType.odg="application/vnd.oasis.opendocument.graphics";
MimeType.otg="application/vnd.oasis.opendocument.graphics-template";
MimeType.odi="application/vnd.oasis.opendocument.image";
MimeType.oti="application/vnd.oasis.opendocument.image-template";
MimeType.odp="application/vnd.oasis.opendocument.presentation";
MimeType.ods="application/vnd.oasis.opendocument.spreadsheet";
MimeType.ots="application/vnd.oasis.opendocument.spreadsheet-template";
MimeType.odt="application/vnd.oasis.opendocument.text";
MimeType.otm="application/vnd.oasis.opendocument.text-master";
MimeType.ott="application/vnd.oasis.opendocument.text-template";
MimeType.oth="application/vnd.oasis.opendocument.text-web";
MimeType.xo="application/vnd.olpc-sugar";
MimeType.dd2="application/vnd.oma.dd2+xml";
MimeType.oxt="application/vnd.openofficeorg.extension";
MimeType.pptx="application/vnd.openxmlformats-officedocument.presentationml.presentation";
MimeType.sldx="application/vnd.openxmlformats-officedocument.presentationml.slide";
MimeType.ppsx="application/vnd.openxmlformats-officedocument.presentationml.slideshow";
MimeType.potx="application/vnd.openxmlformats-officedocument.presentationml.template";
MimeType.xlsx="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
MimeType.xltx="application/vnd.openxmlformats-officedocument.spreadsheetml.template";
MimeType.docx="application/vnd.openxmlformats-officedocument.wordprocessingml.document";
MimeType.dotx="application/vnd.openxmlformats-officedocument.wordprocessingml.template";
MimeType.dp="application/vnd.osgi.dp";
MimeType.str="application/vnd.pg.format";
MimeType.ei6="application/vnd.pg.osasli";
MimeType.efif="application/vnd.picsel";
MimeType.plf="application/vnd.pocketlearn";
MimeType.pbd="application/vnd.powerbuilder6";
MimeType.box="application/vnd.previewsystems.box";
MimeType.mgz="application/vnd.proteus.magazine";
MimeType.qps="application/vnd.publishare-delta-tree";
MimeType.ptid="application/vnd.pvi.ptid1";
MimeType.mxl="application/vnd.recordare.musicxml";
MimeType.musicxml="application/vnd.recordare.musicxml+xml";
MimeType.cod="application/vnd.rim.cod";
MimeType.rm="application/vnd.rn-realmedia";
MimeType.link66="application/vnd.route66.link66+xml";
MimeType.see="application/vnd.seemail";
MimeType.sema="application/vnd.sema";
MimeType.semd="application/vnd.semd";
MimeType.semf="application/vnd.semf";
MimeType.ifm="application/vnd.shana.informed.formdata";
MimeType.itp="application/vnd.shana.informed.formtemplate";
MimeType.iif="application/vnd.shana.informed.interchange";
MimeType.ipk="application/vnd.shana.informed.package";
MimeType.mmf="application/vnd.smaf";
MimeType.teacher="application/vnd.smart.teacher";
MimeType.dxp="application/vnd.spotfire.dxp";
MimeType.sfs="application/vnd.spotfire.sfs";
MimeType.sdc="application/vnd.stardivision.calc";
MimeType.sda="application/vnd.stardivision.draw";
MimeType.sdd="application/vnd.stardivision.impress";
MimeType.smf="application/vnd.stardivision.math";
MimeType.sdw="application/vnd.stardivision.writer";
MimeType.vor="application/vnd.stardivision.writer";
MimeType.sgl="application/vnd.stardivision.writer-global";
MimeType.sxc="application/vnd.sun.xml.calc";
MimeType.stc="application/vnd.sun.xml.calc.template";
MimeType.sxd="application/vnd.sun.xml.draw";
MimeType.std="application/vnd.sun.xml.draw.template";
MimeType.sxi="application/vnd.sun.xml.impress";
MimeType.sti="application/vnd.sun.xml.impress.template";
MimeType.sxm="application/vnd.sun.xml.math";
MimeType.sxw="application/vnd.sun.xml.writer";
MimeType.sxg="application/vnd.sun.xml.writer.global";
MimeType.stw="application/vnd.sun.xml.writer.template";
MimeType.svd="application/vnd.svd";
MimeType.xsm="application/vnd.syncml+xml";
MimeType.bdm="application/vnd.syncml.dm+wbxml";
MimeType.xdm="application/vnd.syncml.dm+xml";
MimeType.tao="application/vnd.tao.intent-module-archive";
MimeType.tmo="application/vnd.tmobile-livetv";
MimeType.tpt="application/vnd.trid.tpt";
MimeType.mxs="application/vnd.triscape.mxs";
MimeType.tra="application/vnd.trueapp";
MimeType.utz="application/vnd.uiq.theme";
MimeType.umj="application/vnd.umajin";
MimeType.unityweb="application/vnd.unity";
MimeType.uoml="application/vnd.uoml+xml";
MimeType.vcx="application/vnd.vcx";
MimeType.vis="application/vnd.visionary";
MimeType.vsf="application/vnd.vsf";
MimeType.wbxml="application/vnd.wap.wbxml";
MimeType.wmlc="application/vnd.wap.wmlc";
MimeType.wmlsc="application/vnd.wap.wmlscriptc";
MimeType.wtb="application/vnd.webturbo";
MimeType.wpd="application/vnd.wordperfect";
MimeType.wqd="application/vnd.wqd";
MimeType.stf="application/vnd.wt.stf";
MimeType.xar="application/vnd.xara";
MimeType.xfdl="application/vnd.xfdl";
MimeType.hvd="application/vnd.yamaha.hv-dic";
MimeType.hvs="application/vnd.yamaha.hv-script";
MimeType.hvp="application/vnd.yamaha.hv-voice";
MimeType.osf="application/vnd.yamaha.openscoreformat";
MimeType.osfpvg="application/vnd.yamaha.openscoreformat.osfpvg+xml";
MimeType.saf="application/vnd.yamaha.smaf-audio";
MimeType.spf="application/vnd.yamaha.smaf-phrase";
MimeType.cmp="application/vnd.yellowriver-custom-menu";
MimeType.zaz="application/vnd.zzazz.deck+xml";
MimeType.vxml="application/voicexml+xml";
MimeType.hlp="application/winhlp";
MimeType.wsdl="application/wsdl+xml";
MimeType.wspolicy="application/wspolicy+xml";
MimeType.abw="application/x-abiword";
MimeType.ace="application/x-ace-compressed";
MimeType.aam="application/x-authorware-map";
MimeType.aas="application/x-authorware-seg";
MimeType.bcpio="application/x-bcpio";
MimeType.torrent="application/x-bittorrent";
MimeType.bz="application/x-bzip";
MimeType.vcd="application/x-cdlink";
MimeType.chat="application/x-chat";
MimeType.pgn="application/x-chess-pgn";
MimeType.cpio="application/x-cpio";
MimeType.csh="application/x-csh";
MimeType.wad="application/x-doom";
MimeType.ncx="application/x-dtbncx+xml";
MimeType.dtb="application/x-dtbook+xml";
MimeType.res="application/x-dtbresource+xml";
MimeType.dvi="application/x-dvi";
MimeType.bdf="application/x-font-bdf";
MimeType.gsf="application/x-font-ghostscript";
MimeType.psf="application/x-font-linux-psf";
MimeType.otf="application/x-font-otf";
MimeType.pcf="application/x-font-pcf";
MimeType.snf="application/x-font-snf";
MimeType.ttf="application/x-font-ttf";
MimeType.ttc="application/x-font-ttf";
MimeType.woff="application/font-woff";
MimeType.spl="application/x-futuresplash";
MimeType.gnumeric="application/x-gnumeric";
MimeType.gtar="application/x-gtar";
MimeType.hdf="application/x-hdf";
MimeType.jnlp="application/x-java-jnlp-file";
MimeType.latex="application/x-latex";
MimeType.application="application/x-ms-application";
MimeType.wmd="application/x-ms-wmd";
MimeType.wmz="application/x-ms-wmz";
MimeType.xbap="application/x-ms-xbap";
MimeType.mdb="application/x-msaccess";
MimeType.obd="application/x-msbinder";
MimeType.crd="application/x-mscardfile";
MimeType.clp="application/x-msclip";
MimeType.exe="application/x-msdownload";
MimeType.dll="application/x-msdownload";
MimeType.com="application/x-msdownload";
MimeType.bat="application/x-msdownload";
MimeType.msi="application/x-msdownload";
MimeType.wmf="application/x-msmetafile";
MimeType.mny="application/x-msmoney";
MimeType.pub="application/x-mspublisher";
MimeType.scd="application/x-msschedule";
MimeType.trm="application/x-msterminal";
MimeType.wri="application/x-mswrite";
MimeType.p7r="application/x-pkcs7-certreqresp";
MimeType.rar="application/x-rar-compressed";
MimeType.sh="application/x-sh";
MimeType.shar="application/x-shar";
MimeType.swf="application/x-shockwave-flash";
MimeType.xap="application/x-silverlight-app";
MimeType.sit="application/x-stuffit";
MimeType.sitx="application/x-stuffitx";
MimeType.sv4cpio="application/x-sv4cpio";
MimeType.sv4crc="application/x-sv4crc";
MimeType.tar="application/x-tar";
MimeType.tcl="application/x-tcl";
MimeType.tex="application/x-tex";
MimeType.tfm="application/x-tex-tfm";
MimeType.texinfo="application/x-texinfo";
MimeType.texi="application/x-texinfo";
MimeType.ustar="application/x-ustar";
MimeType.src="application/x-wais-source";
MimeType.fig="application/x-xfig";
MimeType.xpi="application/x-xpinstall";
MimeType.xenc="application/xenc+xml";
MimeType.xhtml="application/xhtml+xml";
MimeType.xht="application/xhtml+xml";
MimeType.xml="application/xml";
MimeType.xsl="application/xml";
MimeType.dtd="application/xml-dtd";
MimeType.xop="application/xop+xml";
MimeType.xslt="application/xslt+xml";
MimeType.xspf="application/xspf+xml";
MimeType.zip="application/zip";
MimeType.adp="audio/adpcm";
MimeType.mp4a="audio/mp4";
MimeType.m4a="audio/mp4a-latm";
MimeType.m4p="audio/mp4a-latm";
MimeType.mpga="audio/mpeg";
MimeType.mp2="audio/mpeg";
MimeType.mp2a="audio/mpeg";
MimeType.mp3="audio/mpeg";
MimeType.m2a="audio/mpeg";
MimeType.m3a="audio/mpeg";
MimeType.oga="audio/ogg";
MimeType.ogg="audio/ogg";
MimeType.spx="audio/ogg";
MimeType.eol="audio/vnd.digital-winds";
MimeType.dts="audio/vnd.dts";
MimeType.dtshd="audio/vnd.dts.hd";
MimeType.lvp="audio/vnd.lucent.voice";
MimeType.pya="audio/vnd.ms-playready.media.pya";
MimeType.ecelp4800="audio/vnd.nuera.ecelp4800";
MimeType.ecelp7470="audio/vnd.nuera.ecelp7470";
MimeType.ecelp9600="audio/vnd.nuera.ecelp9600";
MimeType.aac="audio/x-aac";
MimeType.m3u="audio/x-mpegurl";
MimeType.wax="audio/x-ms-wax";
MimeType.wma="audio/x-ms-wma";
MimeType.rmp="audio/x-pn-realaudio-plugin";
MimeType.wav="audio/x-wav";
MimeType.cdx="chemical/x-cdx";
MimeType.cif="chemical/x-cif";
MimeType.cmdf="chemical/x-cmdf";
MimeType.cml="chemical/x-cml";
MimeType.csml="chemical/x-csml";
MimeType.xyz="chemical/x-xyz";
MimeType.bmp="image/bmp";
MimeType.cgm="image/cgm";
MimeType.g3="image/g3fax";
MimeType.gif="image/gif";
MimeType.ief="image/ief";
MimeType.jp2="image/jp2";
MimeType.jpeg="image/jpeg";
MimeType.jpg="image/jpeg";
MimeType.jpe="image/jpeg";
MimeType.png="image/png";
MimeType.btif="image/prs.btif";
MimeType.svg="image/svg+xml";
MimeType.svgz="image/svg+xml";
MimeType.tiff="image/tiff";
MimeType.tif="image/tiff";
MimeType.psd="image/vnd.adobe.photoshop";
MimeType.dwg="image/vnd.dwg";
MimeType.dxf="image/vnd.dxf";
MimeType.fbs="image/vnd.fastbidsheet";
MimeType.fpx="image/vnd.fpx";
MimeType.fst="image/vnd.fst";
MimeType.mmr="image/vnd.fujixerox.edmics-mmr";
MimeType.rlc="image/vnd.fujixerox.edmics-rlc";
MimeType.mdi="image/vnd.ms-modi";
MimeType.npx="image/vnd.net-fpx";
MimeType.wbmp="image/vnd.wap.wbmp";
MimeType.xif="image/vnd.xiff";
MimeType.ras="image/x-cmu-raster";
MimeType.cmx="image/x-cmx";
MimeType.ico="image/x-icon";
MimeType.pcx="image/x-pcx";
//MimeType.pic,.pct="image/x-pict";
MimeType.pnm="image/x-portable-anymap";
MimeType.pbm="image/x-portable-bitmap";
MimeType.pgm="image/x-portable-graymap";
MimeType.ppm="image/x-portable-pixmap";
MimeType.rgb="image/x-rgb";
MimeType.xbm="image/x-xbitmap";
MimeType.xpm="image/x-xpixmap";
MimeType.xwd="image/x-xwindowdump";
MimeType.dwf="model/vnd.dwf";
MimeType.gdl="model/vnd.gdl";
MimeType.gtw="model/vnd.gtw";
MimeType.mts="model/vnd.mts";
MimeType.vtu="model/vnd.vtu";
MimeType.css="text/css";
MimeType.csv="text/csv";
MimeType.html="text/html";
MimeType.htm="text/html";
MimeType.txt="text/plain";
MimeType.text="text/plain";
MimeType.dsc="text/prs.lines.tag";
MimeType.rtx="text/richtext";
MimeType.tsv="text/tab-separated-values";
MimeType.curl="text/vnd.curl";
MimeType.dcurl="text/vnd.curl.dcurl";
MimeType.scurl="text/vnd.curl.scurl";
MimeType.mcurl="text/vnd.curl.mcurl";
MimeType.fly="text/vnd.fly";
MimeType.flx="text/vnd.fmi.flexstor";
MimeType.gv="text/vnd.graphviz";
MimeType.spot="text/vnd.in3d.spot";
MimeType.jad="text/vnd.sun.j2me.app-descriptor";
MimeType.wml="text/vnd.wap.wml";
MimeType.wmls="text/vnd.wap.wmlscript";
MimeType.java="text/x-java-source";
MimeType.etx="text/x-setext";
MimeType.uu="text/x-uuencode";
MimeType.vcs="text/x-vcalendar";
MimeType.vcf="text/x-vcard";
MimeType['3gp']="video/3gpp";
MimeType['3g2']="video/3gpp2";
MimeType.h261="video/h261";
MimeType.h263="video/h263";
MimeType.h264="video/h264";
MimeType.jpgv="video/jpeg";
MimeType.mp4="video/mp4";
MimeType.mp4v="video/mp4";
MimeType.mpg4="video/mp4";
MimeType.m4v="video/mp4";
MimeType.webm="video/webm";
MimeType.mpeg="video/mpeg";
MimeType.mpg="video/mpeg";
MimeType.mpe="video/mpeg";
MimeType.m1v="video/mpeg";
MimeType.m2v="video/mpeg";
MimeType.ogv="video/ogg";
MimeType.qt="video/quicktime";
MimeType.mov="video/quicktime";
MimeType.fvt="video/vnd.fvt";
MimeType.pyv="video/vnd.ms-playready.media.pyv";
MimeType.viv="video/vnd.vivo";
MimeType.f4v="video/x-f4v";
MimeType.fli="video/x-fli";
MimeType.flv="video/x-flv";
//MimeType.m4v="video/x-m4v";
MimeType.wm="video/x-ms-wm";
MimeType.wmv="video/x-ms-wmv";
MimeType.wmx="video/x-ms-wmx";
MimeType.wvx="video/x-ms-wvx";
MimeType.avi="video/x-msvideo";
MimeType.movie="video/x-sgi-movie";
MimeType.ice="x-conference/x-cooltalk";
MimeType.indd="application/x-indesign";
MimeType.dat="application/octet-stream";

// Compressed files
// Based on notes at http://en.wikipedia.org/wiki/List_of_archive_formats
MimeType.gz="application/x-gzip";
MimeType.tgz="application/x-tar";
MimeType.tar="application/x-tar";
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, authSettings, AuthService, gettextCatalog, usersService, msNavigationService,
                      NotifyService, documentsService, searchsAdvancesService, api, localStorageService, $mdDialog, $document)
    {
        var ln = localStorage.language||window.navigator.language||navigator.browserLanguage;
        $rootScope.languageDefault="es";
        gettextCatalog.currentLanguage = ln || $rootScope.languageDefault;
        $rootScope.languageSelected= ln || $rootScope.languageDefault;
        //por si viene con la sintaxis es-ES cogemos la primera parte solo
        $rootScope.languageSelected=$rootScope.languageSelected.split("-")[0];

        $rootScope.UCA_COMPANY_CIF = 'Q1132001G'

        $rootScope.server = "";
        if(window.location.host.includes("localhost") || window.location.host.includes("192.168.2.")){
            $rootScope.server = "http://localhost:8000";
        }

        $rootScope.imageDebug="";
        if(!window.location.host.includes("gades.uca.es")){
            // $("body").addClass("debug")
            $rootScope.imageDebug="-pruebas";
        }

        /*
         *
         *   LANGUAGES
         *
         */
        $rootScope.languages = [
            {
                code:'es',
                name:gettextCatalog.getString('Español')
            },
            {
                code:'en',
                name:gettextCatalog.getString('Inglés')
            }
        ];

        // AuthService.getCurrentUser().then(function(response){

        // });

        /*
         *  Esta función nos permitirá llevar el control de permisos mediante URLs
         *
         * @param module
         * @param action
         */
        $rootScope.hasPermission=function(module,action){
            if(AuthService.currentUser && AuthService.currentUser.urlPermissions){
                var url=api.URLs[module];
                var method=action;
                if(action==="LIST" || action==="POST"){
                    url = url.replace(/:([^\/]*)[\/]$/g, "");
                    if(action==="LIST"){
                        method="GET";
                    }
                }
                url = url.replace(/:([^\/]*)[\/]/g, ":/");


                var urlPermission="/"+url+"["+method.toLowerCase()+"]"; //Ya tenemos formada la url para compararla con la de los permisos que nos da el backend

                // return true;
                // if(module==="offersPublished" && action==="POST"){
                //     console.log(urlPermission);
                // }
                return !!AuthService.currentUser.urlPermissions[urlPermission];
            }
            return false;
        };

        /*
         *  Esta función nos permitirá llevar el control de permisos mediante módulos/urls para las exportaciones
         *
         * @param module
         */
        $rootScope.hasPermissionExport=function(module){
            if(AuthService.currentUser){
                var url=api.URLs.export;
                var method='POST';
                url = url.replace(/:([^\/]*)[\/]/g, api.exportModules[module]+"/");
                var urlPermission="/"+url+"["+method.toLowerCase()+"]"; //Ya tenemos formada la url para compararla con la de los permisos que nos da el backend

                return !!AuthService.currentUser.urlPermissions[urlPermission];
            }
            return false;
        };

        /*
         *  Esta función nos permitirá llevar el control de permisos mediante módulos/urls para los envíos avanzados
         *
         * @param module
         */
        $rootScope.hasPermissionSendsAdvances=function(module){
            return(module==='dossiers');

            if(AuthService.currentUser){
                var url=api.URLs.sendsAdvances;
                var method='POST';
                url = url.replace(/:([^\/]*)[\/]/g, api.exportModules[module]+"/");
                var urlPermission="/"+url+"["+method.toLowerCase()+"]"; //Ya tenemos formada la url para compararla con la de los permisos que nos da el backend

                return !!AuthService.currentUser.urlPermissions[urlPermission];
            }
            return false;
        };

        //Cambia el idioma y lo guarda en localstorage para que lo recuerde la próxima vez.
        $rootScope.changeLanguage=function(language){
            localStorage.language=language;
            var lang={fav_lang:language};
            return usersService.saveUser(lang).then(function(){
                window.location.reload();
            }, function(error){
                NotifyService.errorMessage(gettextCatalog.getString("Error al cambiar el idioma. ") + (error.data.non_field_errors || ""));
            });
        };

        //obtiene el mimetype de un fichero por su extesión
        $rootScope.getMimetype=function(file){
            if(file){
                var arr=file.split(".");
                var ext=arr[arr.length-1];
                //MImetype es una variable global que se consigue del archivo mimetypes.js
                if (MimeType.hasOwnProperty(ext)) {
                   return MimeType[ext];
                }
            }
            return 'application/pdf';
        };

        //descagar en general de documentos
        $rootScope.getDocument=function(file){
            documentsService.getDocument(file.id).then(function(response){
                downloadFile(response,file.name,$rootScope.getMimetype(file.document));
            });
        };

        //¿Se puede previsualizar e imprimir el documento en la aplicación? Solo PDF, decidido por la
        //extensión del fichero (misma heurística que getMimetype). Sin extensión reconocible: no.
        $rootScope.isPrintable=function(file){
            if(!file){
                return false;
            }
            var path = angular.isString(file.document) ? file.document : (angular.isString(file.name) ? file.name : '');
            var clean = path.split(/[?#]/)[0];
            var arr = clean.split(".");
            return arr.length > 1 && arr[arr.length-1].toLowerCase() === 'pdf';
        };

        //Vista previa e impresión de un documento PDF sin salir de la aplicación:
        //mismo endpoint (y mismos permisos) que la descarga, pero el blob se muestra en un diálogo.
        $rootScope.printDocument=function(file, ev){
            return documentsService.getDocument(file.id).then(function(response){
                $rootScope.openDocumentPreview(ev, file.name, new Blob([response], {type: 'application/pdf'}));
            }, function(){
                NotifyService.errorMessage(gettextCatalog.getString("No se ha podido obtener el documento."));
            });
        };

        //Abre el diálogo de vista previa con un blob ya obtenido (documentos, convenio...)
        $rootScope.openDocumentPreview=function(ev, name, blob){
            return $mdDialog.show({
                controller: 'DocumentPreviewDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/documents/dialogs/documentPreview/documentPreview-dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: {
                    FileName: name,
                    FileBlob: blob
                }
            });
        };

        //Descarga cualquier tipo de fichero a partir de la respuesta (arraybuffer) del servidor
        function downloadFile(response, name, type) {
            downloadBlob(new Blob([response], {type: type}), name);
        }

        //Descarga un blob ya construido
        function downloadBlob(blob, name) {
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, name);
            }
            else {
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = name;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }

        //Expuestas para que otros controladores (convenio, diálogo de vista previa) no dupliquen la descarga
        $rootScope.downloadFile = downloadFile;
        $rootScope.downloadBlob = downloadBlob;

        $rootScope.getPhoto=function(id, vm){
            var defaulUrl='assets/images/avatars/profile.jpg';
            vm.photo=defaulUrl;
            if($rootScope.hasPermission('studentsAvatar','GET')){
                api.studentsAvatar.get({id:id}, function(res){
                    vm.photo=res.avatar_url || defaulUrl;
                });
            }
        };

        //Muestra mensaje de error
        $rootScope.showError=function(msg){
            NotifyService.errorMessage(msg);
        };

        /*$rootScope.showButtonAll=function(Module){
            var config=searchsAdvancesService.getConfig(Module);
            var filters=config.service[config.param].filtersAdvances;

            for(var i in filters){
                for(var j in filters[i]){
                    if(filters[i][j]){
                        return true;
                    }
                }
            }
            return false;
        };*/

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState)
        {
            //Borramos los filtros avanzados si no venimos de la busqueda de filtros avanzados o si no nos dirigimos a la búsqueda avanzada
            //Ademas añadimos la exportación
            if(fromState.name!=='app.searchsAdvances' && toState.name!=='app.searchsAdvances' &&
                fromState.name!=='app.export' && toState.name!=='app.export'){
                var config=searchsAdvancesService.getAllConfig();
                for(var i in config){
                    config[i].service[config[i].param].filtersAdvances=[];
                }
            }

            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
            $timeout(function ()
            {
                if(msNavigationService.getActiveItem()){
                    var node=msNavigationService.getActiveItem().node;
                    if(node.hidden()){
                        $rootScope.$broadcast(authSettings.ON_UNAUTHORIZED_REQUEST, AuthService.currentUser);
                    }
                }
            },500);
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        // Si se detecta una petición no autorizada redirigir al login
        $rootScope.$on(authSettings.ON_UNAUTHORIZED_REQUEST, function (event, currentUser) {
            if (authSettings.LOGIN_STATE) {
                if(currentUser){
                    $state.go(authSettings.LOGIN_STATE_SUCCESS);
                }else{
                    $state.go(authSettings.LOGIN_STATE);
                }
            } else {
                console.warn("No ha definido una ruta para el formulario de login");
            }
        });

        // Si se detecta un logout, redirigir al login
        $rootScope.$on(authSettings.ON_LOGOUT_BROADCAST, function () {
            if (authSettings.LOGIN_STATE) {
                $state.go(authSettings.LOGIN_STATE);
                window.location.reload();
            } else {
                console.warn("No ha definido una ruta para el formulario de login");
            }
        });

        //creacion de eventos relacionados con las acciones login y logout
        $rootScope.$on(authSettings.ON_LOGIN_BROADCAST, function(event, currentUser){
            if (authSettings.LOGIN_STATE_SUCCESS) {
                /*$rootScope.$broadcast('msSplashScreen::remove');
                $state.go(authSettings.LOGIN_STATE_SUCCESS);*/
                location.href="/";
            } else {
                console.warn("No ha definido una ruta para la redirección despues del login");
            }
        });

    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        /*$urlRouterProvider
                .otherwise(function ($injector) {
                    if($injector.get('localStorageService').get('token') && $injector.get('AuthService').getCurrentUser()){
                        $injector.get('$state').go('app.jobs.list');
                    }else{
                        $injector.get('$state').go('app.auth.login');
                    }
                });/*/

        $urlRouterProvider
                .otherwise(function ($injector) {
                        $injector.get('$state').go('app.notifications');
                });


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'horizontalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $resourceProvider, $mdThemingProvider, $provide, $mdDateLocaleProvider, moment,
                  paginationTemplateProvider, localStorageServiceProvider, flowFactoryProvider, NotifyServiceProvider) {

    // Configura el CSRF_TOKEN
    $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
    $httpProvider.defaults.xsrfCookieName = 'csrftoken';

    localStorageServiceProvider.setPrefix('gades');

    // Don't strip trailing slashes from calculated URLs
    $resourceProvider.defaults.stripTrailingSlashes = false;

    $mdThemingProvider.theme('toast-error');
    $mdThemingProvider.theme('toast-success');

    // Configuración del datepicker en español
    $mdDateLocaleProvider.months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    $mdDateLocaleProvider.shortMonths = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
      'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    $mdDateLocaleProvider.days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
    $mdDateLocaleProvider.shortDays = ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'];
    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1;
    // Optional.
    //$mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, 7,8,9,10,11,12,13,14,15,16,17,18,19,
    //                               20,21,22,23,24,25,26,27,28,29,30,31];
    // In addition to date display, date components also need localized messages
    // for aria-labels for screen-reader users.
    $mdDateLocaleProvider.weekNumberFormatter = function (weekNumber) {
      return 'Semana ' + weekNumber;
    };
    $mdDateLocaleProvider.msgCalendar = 'Calendario';
    $mdDateLocaleProvider.msgOpenCalendar = 'Abrir calendario';

    $mdDateLocaleProvider.parseDate = function (dateString) {
      var m = moment(dateString, 'D/M/YYYY', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format('D/M/YYYY') : '';
    };

    paginationTemplateProvider.setPath('app/utils/templates/dirPagination.tpl.html');



    // Modifica la directiva md-button para permitir hacer un debouce
    // automático del click
    $provide.decorator('mdButtonDirective', function ($delegate) {
      var directive = $delegate[0];
      var oldTemplate = directive.template;   // Guarda el antiguo template
      var i = 0;                              // Contador para nombrar de forma automática la variable del estado de la promesa
      var varName = "__promiseStatusVar";     // Nombre de la variable que contiene el estado de la promesa

      directive.template = getTemplate;       // Asigna el nuevo template

      function getTemplate(element, attr) {
        if (angular.isUndefined(attr.debouceClick)) {
          return oldTemplate(element, attr);
        }

        // El atributo debouce-click permite definir el nombre de la variable que se usará para
        // guardar el estado de la promesa
        if (attr.debouceClick !== "") {
          varName = attr.debouceClick;
        }

        // Aumentamos el contador en cada instancia de la directiva
        i++;

        // Modifica el atributo ng-click para guardar el estado de la promesa
        attr.ngClick = varName + i + ' = (' + attr.ngClick + ' | promiseStatus)';

        // Modifica el atributo ng-disabled para incluir el estado de la promesa
        var ngDisabledString = "";
        if (attr.ngDisabled === undefined) {
          ngDisabledString = 'ng-disabled="' + varName + i + '.inProgress"';
        } else {
          attr.ngDisabled = "(" + attr.ngDisabled + ") || (" + varName + i + ".inProgress )";
        }

        // Modificaciones del template
        var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
        var layout = (typeof attr.layout === 'undefined') ? 'row' : attr.layout;
        var layoutAlign = (typeof attr.layoutAlign === 'undefined') ? 'center center' : attr.layoutAlign;
        return '<button ' + ngDisabledString + ' class="md-button" type="' + btnType + '"><ng-transclude layout="' + layout + '" layout-align="' + layoutAlign + '"></ng-transclude><md-progress-circular ng-show="' + varName + i + '.inProgress" class="for-button" md-diameter="16" md-mode="indeterminate"></md-progress-circular> </button>';
      }

      return $delegate;
    });

    // Modifica la directiva input para eliminar os errores de servidor cuando el usuario modifica el contenido
    $provide.decorator('inputDirective', function ($delegate) {
      var directive = $delegate[0];

      // Override del link
      directive.compile = function () {
        return function (scope, element, attrs, ctrl) {
          directive.link.pre.apply(this, arguments);
          element.on('change', function () {
            if (ctrl[0]) {
              scope.$apply(function () {
                ctrl[0].$setValidity('serverError', true);
              });
            }
          });
          element.on('focus', function () {
            if (ctrl[0]) {
              ctrl[0].$setValidity('serverError', true);
            }
          });
          element.on('keydown', function () {
            if (ctrl[1]) {
              scope.$apply(function () {
                ctrl[1].$setValidity('serverError', true);
              });
            }
          });

        };
      };

      return $delegate;
    });

    // Modifica la directiva input para eliminar os errores de servidor cuando el usuario modifica el contenido
    $provide.decorator('textareaDirective', function ($delegate) {
      var directive = $delegate[0];

      // Override del link
      directive.compile = function () {
        return function (scope, element, attrs, ctrl) {
          directive.link.pre.apply(this, arguments);
          element.on('change', function () {
            if (ctrl[0]) {
              scope.$apply(function () {
                ctrl[0].$setValidity('serverError', true);
              });
            }
          });
          element.on('focus', function () {
            if (ctrl[0]) {
              ctrl[0].$setValidity('serverError', true);
            }
          });
          element.on('keydown', function () {
            if (ctrl[1]) {
              scope.$apply(function () {
                ctrl[1].$setValidity('serverError', true);
              });
            }
          });

        };
      };

      return $delegate;
    });

    // Modifica la directiva select para eliminar os errores de servidor cuando el usuario modifica el contenido
    $provide.decorator('selectDirective', function ($delegate) {
      var directive = $delegate[0];

      // Override del link
      directive.compile = function () {
        return function (scope, element, attrs, ctrl) {
          var $directiveElement=element.parent().find("md-select");
          var form=element.closest("form").attr("name");
          var name=$directiveElement.attr("name");
          directive.link.pre.apply(this, arguments);
          $directiveElement.on('focus', function () {
            if (scope[form][name]) {
                scope[form][name].$setValidity('serverError', true);
            }
          });

        };
      };

      return $delegate;
    });

    // Text Angular options
    $provide.decorator('taOptions', [
      '$delegate', function (taOptions) {
        taOptions.toolbar = [
          ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
        ];

        taOptions.classes = {
          focussed: 'focussed',
          toolbar: 'ta-toolbar',
          toolbarGroup: 'ta-group',
          toolbarButton: 'md-button',
          toolbarButtonActive: 'active',
          disabled: '',
          textEditor: 'form-control',
          htmlEditor: 'form-control'
        };

        return taOptions;
      }
    ]);

    // Text Angular tools
    $provide.decorator('taTools', [
      '$delegate', function (taTools) {
        taTools.quote.iconclass = 'icon-format-quote';
        taTools.bold.iconclass = 'icon-format-bold';
        taTools.italics.iconclass = 'icon-format-italic';
        taTools.underline.iconclass = 'icon-format-underline';
        taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
        taTools.ul.iconclass = 'icon-format-list-bulleted';
        taTools.ol.iconclass = 'icon-format-list-numbers';
        taTools.redo.iconclass = 'icon-redo';
        taTools.undo.iconclass = 'icon-undo';
        taTools.clear.iconclass = 'icon-close-circle-outline';
        taTools.justifyLeft.iconclass = 'icon-format-align-left';
        taTools.justifyCenter.iconclass = 'icon-format-align-center';
        taTools.justifyRight.iconclass = 'icon-format-align-right';
        taTools.justifyFull.iconclass = 'icon-format-align-justify';
        taTools.indent.iconclass = 'icon-format-indent-increase';
        taTools.outdent.iconclass = 'icon-format-indent-decrease';
        taTools.html.iconclass = 'icon-code-tags';
        taTools.insertImage.iconclass = 'icon-file-image-box';
        taTools.insertLink.iconclass = 'icon-link';
        taTools.insertVideo.iconclass = 'icon-filmstrip';

        return taTools;
      }
    ]);

    // Modifica la directiva radio-group para eliminar os errores de servidor cuando el usuario modifica el valor
    $provide.decorator('mdRadioGroupDirective', function ($delegate) {
      var directive = $delegate[0];

      // Override del link
      directive.compile = function () {
        return function (scope, element, attrs, ctrl) {
          directive.link.pre.apply(this, arguments);
          element.on('mousedown', function () {
            if (ctrl[1]) {
              scope.$apply(function () {
                ctrl[1].$setValidity('serverError', true);
              });
            }
          });
          element.on('keydown', function () {
            if (ctrl[1]) {
              scope.$apply(function () {
                ctrl[1].$setValidity('serverError', true);
              });
            }
          });

        };
      };

      return $delegate;

    });

    function utf8Encode(unicodeString) {
        if (typeof unicodeString != 'string') throw new TypeError('parameter ‘unicodeString’ is not a string');
        const utf8String = unicodeString.replace(
            /[\u0080-\u07ff]/g,  // U+0080 - U+07FF => 2 bytes 110yyyyy, 10zzzzzz
            function(c) {
                var cc = c.charCodeAt(0);
                return String.fromCharCode(0xc0 | cc>>6, 0x80 | cc&0x3f); }
        ).replace(
            /[\u0800-\uffff]/g,  // U+0800 - U+FFFF => 3 bytes 1110xxxx, 10yyyyyy, 10zzzzzz
            function(c) {
                var cc = c.charCodeAt(0);
                return String.fromCharCode(0xe0 | cc>>12, 0x80 | cc>>6&0x3F, 0x80 | cc&0x3f); }
        );
        return utf8String;
    }

    flowFactoryProvider.defaults = {
        target: "/api/documents/",
        headers: function (file, chunk, isTest) {
            return {
                'Authorization': 'Token ' + ((localStorage['gades.token']) ? localStorage['gades.token'].split('"')[1] : '')
            };
        },
        testChunks: false,
        chunkSize: 1024*1024*1024*1024*1024,
        fileParameterName: "document",
        query:function(file){
            return {name:utf8Encode(file.name)};
        }
    };

    flowFactoryProvider.on('catchAll', function (event,e) {
      if(event==="error"){
        var error = JSON.parse(e);
        NotifyServiceProvider.$get().errorMessage(error.detail);

      }
    });

  }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        var api = {};
        var queryAll = {
            method: 'GET',
            params: {
                page: 'all'
            },
            isArray: true
        };

        var queryAllObj = {
            method: 'GET',
            params: {
                page: 'all'
            }
        };

        var defaultObj={
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'}
        };

        // Base Url
        api.baseUrl = 'api/';

        api.URLs={};
        api.URLs.users=api.baseUrl + 'roles/:id/';
        api.URLs.contact=api.baseUrl + 'roles/:id/';
        api.URLs.changeGroup=api.baseUrl + 'roles/change_group/';
        api.URLs.companyList=api.baseUrl + 'companies/:id/';
        api.URLs.companyDetail=api.baseUrl + 'companies/current/:id/';
        api.URLs.companyValidate=api.baseUrl + 'companies/:id/validate/';
        api.URLs.companyBlock=api.baseUrl + 'companies/:id/block/';
        api.URLs.privacyPolicy=api.baseUrl + 'public_values/privacy_policy/';
        api.URLs.centers=api.baseUrl + 'companies/centers/:id/';
        api.URLs.contacts=api.baseUrl + 'companies/contacts/:id/';
        api.URLs.rolesContacts=api.baseUrl + 'roles/contacts/:id/';
        api.URLs.agreements=api.baseUrl + 'agreements/:id/';
        api.URLs.agreementsBase64=api.baseUrl + 'agreements/:id/pdf_base64/';
        api.URLs.agreementsDownload=api.baseUrl + 'agreements/:id/download_pdf/';
        api.URLs.agreements_sign=api.baseUrl + 'agreements/:id/sign/';
        api.URLs.agreements_editable=api.baseUrl + 'agreements/:id/editable/';
        api.URLs.agreementsConditions=api.baseUrl + 'agreements/conditions/:id/';
        api.URLs.agreementsConditions_setStatus=api.baseUrl + 'agreements/conditions/:id/set_status/';
        api.URLs.agreementsDocuments=api.baseUrl + 'documents/signature/';
        api.URLs.agreementsUpload=api.baseUrl + 'agreements/:id/update_pdf/';
        api.URLs.conditionsTemplates=api.baseUrl + 'agreements/conditions-templates/:id/';
        api.URLs.skills=api.baseUrl + 'academics/skills/:id/';
        api.URLs.categorySkills=api.baseUrl + 'academics/category-skills/:id/';
        api.URLs.programs=api.baseUrl + 'programs/:id/';
        api.URLs.programsXLS=api.baseUrl + 'programs/:id/load_xls/';
        api.URLs.programManagers=api.baseUrl + 'programs/managers/:id/';
        api.URLs.offers=api.baseUrl + 'offers/:id/';
        api.URLs.offersCreateFromTemplate=api.baseUrl + 'offers/create_from_template/';
        api.URLs.offersCurricular=api.baseUrl + 'offers/curricular/:id/';
        api.URLs.offersPublished=api.baseUrl + 'offers/:id/request_published/';
        api.URLs.offersConfirmed=api.baseUrl + 'offers/:id/confirm_pending_offer/';
        api.URLs.editOffersPublished=api.baseUrl + 'offers/:id/edit/';
        api.URLs.offersSkills=api.baseUrl + 'offers/skills/:id/';
        api.URLs.offersDegrees=api.baseUrl + 'offers/degrees/:id/';
        api.URLs.offersLanguages=api.baseUrl + 'offers/languages/:id/';
        api.URLs.offersRequests=api.baseUrl + 'offers/requests/:id/';
        api.URLs.offersCurricularRequests=api.baseUrl + 'offers/curricular-requests/:id/';
        api.URLs.confirmRequest=api.baseUrl + 'offers/requests/:id/confirm_pre_signed_up/';
        api.URLs.offersPostulates=api.baseUrl + 'offers/curricular/postulate/:id/';
        api.URLs.myOffersRequests=api.baseUrl + 'offers/requests/my_requests/:id/';
        api.URLs.offerCofinancingCalculate=api.baseUrl + 'offers/:id/cofinancing_calculate/';
        api.URLs.offerTotalHours=api.baseUrl + 'offers/:id/total_hours/';
        api.URLs.offersTemplates=api.baseUrl + 'offers/templates/:id/';
        api.URLs.offersTemplatesCreate=api.baseUrl + 'offers/templates/create_from_offer/';
        api.URLs.demands=api.baseUrl + 'demands/:id/';
        api.URLs.myDemands=api.baseUrl + 'demands/my_demands/:id/';
        api.URLs.demandsDegreeCoordinator=api.baseUrl + 'demands/:id/degree_coordinators/';
        api.URLs.demandsPublished=api.baseUrl + 'demands/:id/published/';
        api.URLs.demandsSchedules=api.baseUrl + 'demands/schedules/:id/';
        api.URLs.demandsProfiles=api.baseUrl + 'demands/profiles/:id/';
        api.URLs.demandsRequests=api.baseUrl + 'offers/curricular-requests/:id/';
        api.URLs.demandsCompanies=api.baseUrl + 'offers/curricular/companies/:id/';
        api.URLs.demandsRequestsCreateDossier=api.baseUrl + 'offers/curricular-requests/:id/save/';
        api.URLs.demandsRequestsCreateDossiers=api.baseUrl + 'offers/curricular-requests/save_all/';
        api.URLs.demandsRequestsDiscarded=api.baseUrl + 'offers/curricular/:id/discarded/';
        api.URLs.demandsRequestsDiscardedAll=api.baseUrl + 'offers/curricular/discarded_all/';
        api.URLs.categories=api.baseUrl + 'notifications/categories/:id/';
        api.URLs.events=api.baseUrl + 'notifications/events/:id/';
        api.URLs.eventNotifications=api.baseUrl + 'notifications/eventnotifications/:id/';
        api.URLs.notifications=api.baseUrl + 'notifications/notifications/:id/';
        api.URLs.notificationsReadPending=api.baseUrl + 'notifications/notifications/read_pending/';
        api.URLs.notificationsToggleImportant=api.baseUrl + 'notifications/notifications/:id/important/';
        api.URLs.degrees=api.baseUrl + 'academics/degrees/:id/';
        api.URLs.gadesDegrees=api.baseUrl + 'academics/degrees_gades/:id/';
        api.URLs.pyconfrests=api.baseUrl + 'pyconfrest/pyconfrest/:id/';
        api.URLs.cloneAcademicYears=api.baseUrl + 'demands/clone_new_academic_year/:id/';
        api.URLs.languages=api.baseUrl + 'academics/languages/:id/';
        api.URLs.subjects=api.baseUrl + 'academics/subjects/:id/';
        api.URLs.subjectsTeachers=api.baseUrl + 'academics/subjects/:id/teachers/';
        api.URLs.documents=api.baseUrl + 'documents/:id/';
        api.URLs.documentPermissions=api.baseUrl + 'documents/:id/change_permission/';
        api.URLs.reports=api.baseUrl + 'pydjangofilterrest/exports/:id/';
        api.URLs.activities=api.baseUrl + 'companies/activities/:id/';
        api.URLs.teachers=api.baseUrl + 'academics/teachers/:id/';
        api.URLs.teachersDetail=api.baseUrl + 'academics/teachers/current/';
        api.URLs.teachersDegrees=api.baseUrl + 'academics/tutors/:id/';
        api.URLs.teachersCurricular=api.baseUrl + 'academics/curricular-tutors/:id/';
        api.URLs.teachersExtracurricular=api.baseUrl + 'academics/extracurricular-tutors/:id/';
        api.URLs.managerDegrees=api.baseUrl + 'academics/manager-degree/:id/';
        api.URLs.teachersCoordinatorDegrees=api.baseUrl + 'academics/coordinators/:id/';
        api.URLs.studentsList=api.baseUrl + 'academics/students/:id/';
        api.URLs.studentsDetail=api.baseUrl + 'academics/students/current/:id/';
        api.URLs.studentsAvatar=api.baseUrl + 'academics/students/:id/avatar_url/';
        api.URLs.gadesStudents=api.baseUrl + 'academics/contact-students/:id/';
        api.URLs.gadesStudentsCollisions=api.baseUrl + 'academics/contact-students/collisions/';
        api.URLs.studentsSkills=api.baseUrl + 'academics/student-skills/:id/';
        api.URLs.studentsLanguages=api.baseUrl + 'academics/student-languages/:id/';
        api.URLs.studentsDegrees=api.baseUrl + 'academics/registrations/:id/';
        api.URLs.dossiers=api.baseUrl + 'dossiers/:id/';
        api.URLs.dossiersSign=api.baseUrl + 'dossiers/:id/sign/';
        api.URLs.dossiersConfirm=api.baseUrl + 'dossiers/:id/confirmed/';
        api.URLs.dossiersConfirmProfesionalTutor=api.baseUrl + 'dossiers/:id/confirmed_profesional_tutor/';
        api.URLs.dossiersConfirmAcademicTutor=api.baseUrl + 'dossiers/:id/confirmed_academic_tutor/';
        api.URLs.dossiersDocuments=api.baseUrl + 'dossiers/:id/upload_files/';
        api.URLs.myDossiers=api.baseUrl + 'dossiers/my_dossiers/:id/';
        api.URLs.dossiersAccept=api.baseUrl + 'dossiers/:id/accept/';
        api.URLs.dossierInterruptions=api.baseUrl + 'dossiers/interruption-requests/:id/';
        api.URLs.dossierInterruptionsAccept=api.baseUrl + 'dossiers/interruption-requests/:id/accept/';
        api.URLs.dossierInterruptionsReject=api.baseUrl + 'dossiers/interruption-requests/:id/reject/';
        api.URLs.dossierExtensions=api.baseUrl + 'dossiers/extension-requests/:id/';
        api.URLs.dossierExtensionsAccept=api.baseUrl + 'dossiers/extension-requests/:id/accept/';
        api.URLs.dossierExtensionsReject=api.baseUrl + 'dossiers/extension-requests/:id/reject/';
        api.URLs.dossierExtensionsSendAdjudicationResolution=api.baseUrl + 'dossiers/extension-requests/:id/send_adjudication_resolution/';
        api.URLs.dossierCofinancingCalculate=api.baseUrl + 'dossiers/:id/cofinancing_calculate/';
        api.URLs.dossierResignations=api.baseUrl + 'dossiers/resignation-requests/:id/';
        api.URLs.dossierResignationsAccept=api.baseUrl + 'dossiers/resignation-requests/:id/accept/';
        api.URLs.dossierResignationsReject=api.baseUrl + 'dossiers/resignation-requests/:id/reject/';
        api.URLs.dossierReportRequests=api.baseUrl + 'dossiers/report-requests/:id/';
        api.URLs.dossierDocuments=api.baseUrl + 'dossiers/:id/documents/';
        api.URLs.dossierQuotes=api.baseUrl + 'pfnr_export/monthly_reports/';
        api.URLs.dossierQuotesSave=api.baseUrl + 'pfnr_export/monthly_reports/:id/';
        api.URLs.actionloggings=api.baseUrl + 'actionlogging/:id/';
        api.URLs.impersonates=api.baseUrl + 'roles/impersonate/start/';
        // Recurso aparte: hasPermission() deriva la URL del permiso de api.URLs.impersonates,
        // así que esa no puede parametrizarse sin ocultar el menú «Login simulado»
        api.URLs.impersonatesEnd=api.baseUrl + 'roles/impersonate/end/';
        api.URLs.questionnaires=api.baseUrl + 'evaluations/questionnaires/:id/';
        api.URLs.questions=api.baseUrl + 'evaluations/questions/:id/';
        api.URLs.questionOptions=api.baseUrl + 'evaluations/question-options/:id/';
        api.URLs.evaluations=api.baseUrl + 'evaluations/:id/';
        api.URLs.evaluationsAcademicTutors=api.baseUrl + 'evaluations/:id/update_academic_tutor/';
        api.URLs.evaluationsProfessionalTutors=api.baseUrl + 'evaluations/:id/update_professional_tutor/';
        api.URLs.evaluationsStudents=api.baseUrl + 'evaluations/:id/update_student/';
        api.URLs.evaluationsFinalize=api.baseUrl + 'evaluations/:id/finalize/';
        api.URLs.evaluationsPoints=api.baseUrl + 'evaluations/points/:id/';
        api.URLs.evaluationsPointsEvaluate=api.baseUrl + 'evaluations/points/:id/evaluate/';
        api.URLs.answers=api.baseUrl + 'evaluations/answers/:id/';
        api.URLs.provinces=api.baseUrl + 'locations/provinces/:id/';
        api.URLs.localities=api.baseUrl + 'locations/towns/:id/';
        api.URLs.role=api.baseUrl + 'roles/groups/:id/';
        api.URLs.downloadDocumentHight=api.baseUrl + 'pfnr_export/inscriptions/download/';
        api.URLs.downloadDocumentQuotes=api.baseUrl + 'pfnr_export/timesheets/download/';
        api.URLs.markQuotesDownloaded=api.baseUrl + 'pfnr_export/pfnr_timesheets/mark_downloaded/';
        api.URLs.rolePermissions=api.baseUrl + 'roles/groups/:id/update_permissions_group/';
        api.URLs.contentType=api.baseUrl + 'roles/custom-permissions/:id/';
        api.URLs.getFilterFields=api.baseUrl + ':id/get_filter_fields/';
        api.URLs.searchsAdvances=api.baseUrl + ':id/advanced_search/';
        api.URLs.getReceivers=api.baseUrl + ':id/get_receivers/';
        api.URLs.sendsAdvances=api.baseUrl + ':id/advanced_send/';
        api.URLs.export=api.baseUrl + ':id/export/';

        /*
        * Parámetros para búsquedas avanzadas
        * */
        api.searchsAdvancesModules={};
        api.searchsAdvancesModules.companies="companies";
        api.searchsAdvancesModules.offers="offers";
        api.searchsAdvancesModules.students="academics/students";
        api.searchsAdvancesModules.Altas="pfnr_export/pfnr_inscriptions";
        api.searchsAdvancesModules.Cotizaciones="pfnr_export/pfnr_timesheets";
        api.searchsAdvancesModules.dossiers="dossiers";
        api.searchsAdvancesModules.tutors="academics/teachers";
        api.searchsAdvancesModules.tutorscurriculars="academics/curricular-tutors";
        api.searchsAdvancesModules.tutorsextracurriculars="academics/extracurricular-tutors";
        api.searchsAdvancesModules.coordinators="academics/teachers";
        api.searchsAdvancesModules.demands="demands";
        api.searchsAdvancesModules.actionloggings="actionlogging";
        /*
        * Fin de parámetros para búsquedas avanzadas
        * */

        /*
        * Parámetros para exportaciones (va a ser igual o muy similar al de searchsAdvancesModules)
        * */
        api.exportModules=api.searchsAdvancesModules;
        //incluir aquí el que cambie, por ejemplo:
        // api.exportModules.companies="OTHERcompanies";
        /*
        * Fin de parámetros para exportaciones
        * */

        /*
        * Parámetros para envíos avanzandos (va a ser igual o muy similar al de searchsAdvancesModules)
        * */
        api.sendsAdvancesModules=api.searchsAdvancesModules;
        //incluir aquí el que cambie, por ejemplo:
        // api.sendsAdvancesModules.companies="OTHERcompanies";
        /*
        * Fin de parámetros para envíos avanzandos
        * */

        api.users = $resource(api.URLs.users, {id: '@id'}, defaultObj);
        api.contact = $resource(api.URLs.contact, {id: '@id'}, defaultObj);

        api.changeGroup=$resource(api.URLs.changeGroup, {}, defaultObj);

        api.companyList = $resource(api.URLs.companyList, {id: '@id'}, defaultObj);
        api.companyDetail = $resource(api.URLs.companyDetail, {id: '@id'}, defaultObj);
        api.companyValidate = $resource(api.URLs.companyValidate, {id: '@id'}, defaultObj);
        api.companyBlock = $resource(api.URLs.companyBlock, {id: '@id'}, defaultObj);
        api.privacyPolicy = $resource(api.URLs.privacyPolicy, {id: '@id'}, defaultObj);

        api.centers = $resource(api.URLs.centers, {id: '@id'}, defaultObj);

        api.contacts = $resource(api.URLs.contacts, {id: '@id'}, defaultObj);
        api.rolesContacts = $resource(api.URLs.rolesContacts, {id: '@id'}, defaultObj);


        api.agreements = $resource(api.URLs.agreements, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            sign: {
                method: 'POST',
                url:api.URLs.agreements_sign
            },
            editable: {
                method: 'PATCH',
                url:api.URLs.agreements_editable
            },
            upload: {
                method: 'PATCH',
                url:api.URLs.agreementsUpload
            },
            base64:{
                method: 'GET',
                url:api.URLs.agreementsBase64
            },
            download:{
                method: 'GET',
                url:api.URLs.agreementsDownload
            }
        });
        api.agreementsConditions = $resource(api.URLs.agreementsConditions, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            setStatus: {
                url: api.URLs.agreementsConditions_setStatus,
                method: 'PATCH'
            }
        });

        api.conditionsTemplates = $resource(api.URLs.conditionsTemplates, {id: '@id'}, defaultObj);

        api.skills = $resource(api.URLs.skills, {id: '@id'}, defaultObj);
        api.downloadDocumentHight = $resource(api.URLs.downloadDocumentHight, {}, defaultObj);
        api.downloadDocumentQuotes = $resource(api.URLs.downloadDocumentQuotes, {}, defaultObj);
        api.categorySkills = $resource(api.URLs.categorySkills, {id: '@id'}, defaultObj);

        api.programs = $resource(api.URLs.programs, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            xls: {
                url: api.URLs.programsXLS,
                method: 'POST',
                transformRequest: function (form) {
                    var formData = new FormData();
                    angular.forEach(form, function(value, key){
                        if(Array.isArray(value) && value.length){
                            angular.forEach(value, function(v, k){
                                formData.append(key, v);
                            });
                        }else{
                            formData.append(key, value);
                        }
                    });
                    return formData;
                },
                headers: {'Content-Type': undefined}
            }
        });

        api.programManagers = $resource(api.URLs.programManagers, {id: '@id'}, defaultObj);

        api.offers = $resource(api.URLs.offers, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            createFromTemplate: {
                url: api.URLs.offersCreateFromTemplate,
                method: 'POST'
            },
            update: {method: 'PATCH'},
            published: {
                url: api.URLs.offersPublished,
                method: 'POST'
            },
            confirmed: {
                url: api.URLs.offersConfirmed,
                method: 'POST'
            },
            editPublished: {
                url: api.URLs.editOffersPublished,
                method: 'POST'
            },
            cofinancingCalculate: {
                url: api.URLs.offerCofinancingCalculate,
                method: 'GET'
            },
            totalHours: {
                url: api.URLs.offerTotalHours,
                method: 'GET'
            }
        });

        api.offersSkills = $resource(api.URLs.offersSkills, {id: '@id'}, defaultObj);

        api.offersDegrees = $resource(api.URLs.offersDegrees, {id: '@id'}, defaultObj);

        api.offersLanguages = $resource(api.URLs.offersLanguages, {id: '@id'}, defaultObj);

        api.offersCurricularRequests = $resource(api.URLs.offersCurricularRequests, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            confirm:{
                url: api.URLs.confirmRequest,
                method: 'POST'
            }
        });

        api.offersRequests = $resource(api.URLs.offersRequests, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            confirm:{
                url: api.URLs.confirmRequest,
                method: 'POST'
            }
        });

        api.myOffersRequests = $resource(api.URLs.myOffersRequests, {id: '@id'}, defaultObj);

        api.offersPostulates = $resource(api.URLs.offersCurricular, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {
                url: api.URLs.offersPostulates,
                method: 'POST'
            },
            update: {method: 'PATCH'},
            discarded: {
                url: api.URLs.demandsRequestsDiscarded,
                method: 'POST'
            },
            discardedAll: {
                url: api.URLs.demandsRequestsDiscardedAll,
                method: 'POST'
            }
        });

        api.offersTemplates = $resource(api.URLs.offersTemplates, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {
                url: api.URLs.offersTemplatesCreate,
                method: 'POST'
            },
            update: {method: 'PATCH'}
        });

        api.demands = $resource(api.URLs.demands, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            published: {
                url: api.URLs.demandsPublished,
                method: 'POST'
            },
            degreeCoordinator: {
                url: api.URLs.demandsDegreeCoordinator,
                method: 'GET'
            }
        });

        api.myDemands = $resource(api.URLs.myDemands, {id: '@id'}, defaultObj);

        api.demandsSchedules = $resource(api.URLs.demandsSchedules, {id: '@id'}, defaultObj);

        api.demandsProfiles = $resource(api.URLs.demandsProfiles, {id: '@id'}, defaultObj);

        api.demandsRequests = $resource(api.URLs.demandsRequests, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            createDossier: {
                url: api.URLs.demandsRequestsCreateDossier,
                method: 'POST'
            },
            createDossiers: {
                url: api.URLs.demandsRequestsCreateDossiers,
                method: 'POST'
            }
        });

        api.demandsCompanies = $resource(api.URLs.demandsCompanies, {id: '@id'}, defaultObj);

        api.categories = $resource(api.URLs.categories, {id: '@id'}, defaultObj);

        api.events = $resource(api.URLs.events, {id: '@id'}, defaultObj);

        api.eventNotifications = $resource(api.URLs.eventNotifications, {id: '@id'}, defaultObj);

        api.notifications = $resource(api.URLs.notifications, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            readPending: {
                url: api.URLs.notificationsReadPending,
                method: 'GET'
            },
            toggleImportant: {
                url: api.URLs.notificationsToggleImportant,
                method: 'PATCH'
            }
        });

        api.degrees = $resource(api.URLs.degrees, {id: '@id'}, defaultObj);

        api.gadesDegrees = $resource(api.URLs.gadesDegrees, {id: '@id'}, defaultObj);

        api.pyconfrests = $resource(api.URLs.pyconfrests, {id: '@id'}, defaultObj);

        api.cloneAcademicYears = $resource(api.URLs.cloneAcademicYears, {id: '@id'}, defaultObj);

        api.languages = $resource(api.URLs.languages, {id: '@id'}, defaultObj);

        api.subjects = $resource(api.URLs.subjects, {id: '@id'}, defaultObj);
        api.subjectsTeachers = $resource(api.URLs.subjectsTeachers, {id: '@id'}, defaultObj);

        api.documents = $resource(api.URLs.documents, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {
                method: 'POST',
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            },
            update: {
                method: 'PATCH',
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined}
            },
            changePermission:{
                method: 'PATCH',
                url:api.URLs.documentPermissions
            }
        });

        api.reports = $resource(api.URLs.reports, {id: '@id'}, defaultObj);

        api.activities = $resource(api.URLs.activities, {id: '@id'}, defaultObj);

        api.teachers = $resource(api.URLs.teachers, {id: '@id'}, defaultObj);
        api.teachersDetail = $resource(api.URLs.teachersDetail, {}, defaultObj);
        api.teachersDegrees = $resource(api.URLs.teachersDegrees, {id: '@id'}, defaultObj);

        api.managerDegrees = $resource(api.URLs.managerDegrees, {id: '@id'}, {
            get:{
                url:api.URLs.users,
                method:'GET',
                params:{manager_degree:'1'}
            },
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'}
        });

        api.teachersCoordinatorDegrees = $resource(api.URLs.teachersCoordinatorDegrees, {id: '@id'}, defaultObj);

        api.studentsList = $resource(api.URLs.studentsList, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            createGades: {
                url: api.URLs.gadesStudents,
                method: 'POST'
            },
            updateGades: {
                url: api.URLs.gadesStudents,
                method: 'PATCH'
            },
            remove: {
                url: api.URLs.gadesStudents,
                method: 'DELETE'
            },
            update: {method: 'PATCH'},
            collisions: {
                url: api.URLs.gadesStudentsCollisions,
                method: 'POST'
            }
        });
        api.studentsDetail = $resource(api.URLs.studentsDetail, {id: '@id'}, defaultObj);

        api.studentsAvatar = $resource(api.URLs.studentsAvatar, {id: '@id'}, defaultObj);

        api.studentsSkills = $resource(api.URLs.studentsSkills, {id: '@id'}, defaultObj);

        api.studentsLanguages = $resource(api.URLs.studentsLanguages, {id: '@id'}, defaultObj);

        api.studentsDegrees = $resource(api.URLs.studentsDegrees, {id: '@id'}, defaultObj);

        api.dossiers = $resource(api.URLs.dossiers, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            accept: {
                url: api.URLs.dossiersAccept,
                method: 'POST'
            },
            reportRequest: {
                url: api.URLs.dossierReportRequests,
                method: 'POST'
            },
            sign:{
                url:api.URLs.dossiersSign,
                method: 'POST'
            },
            confirm:{
                url:api.URLs.dossiersConfirm,
                method: 'POST'
            },
            confirmProfesionalTutor:{
                url:api.URLs.dossiersConfirmProfesionalTutor,
                method: 'POST'
            },
            confirmAcademicTutor:{
                url:api.URLs.dossiersConfirmAcademicTutor,
                method: 'POST'
            },
            documents:{
                url:api.URLs.dossiersDocuments,
                method: 'POST'
            }
        });

        api.myDossiers = $resource(api.URLs.myDossiers, {id: '@id'}, defaultObj);

        api.dossierInterruptions = $resource(api.URLs.dossierInterruptions, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            accept: {
                url: api.URLs.dossierInterruptionsAccept,
                method: 'POST'
            },
            reject: {
                url: api.URLs.dossierInterruptionsReject,
                method: 'POST'
            }
        });

        api.dossierExtensions = $resource(api.URLs.dossierExtensions, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            accept: {
                url: api.URLs.dossierExtensionsAccept,
                method: 'POST'
            },
            reject: {
                url: api.URLs.dossierExtensionsReject,
                method: 'POST'
            },
            sendAdjudicationResolution: {
                url: api.URLs.dossierExtensionsSendAdjudicationResolution,
                method: 'POST'
            },
            cofinancingCalculate: {
                url: api.URLs.dossierCofinancingCalculate,
                method: 'GET'
            }
        });

        api.dossierResignations = $resource(api.URLs.dossierResignations, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            accept: {
                url: api.URLs.dossierResignationsAccept,
                method: 'POST'
            },
            reject: {
                url: api.URLs.dossierResignationsReject,
                method: 'POST'
            }
        });

        api.dossierDocuments = $resource(api.URLs.dossierDocuments, {id: '@id'}, defaultObj);

        api.dossierQuotes = $resource(api.URLs.dossierQuotes, {}, defaultObj);

        api.dossierQuotesSave = $resource(api.URLs.dossierQuotesSave, {id: '@id'}, defaultObj);
        api.actionloggings = $resource(api.URLs.actionloggings, {id: '@id'}, defaultObj);

        api.impersonates = $resource(api.URLs.impersonates, {id: '@id'}, defaultObj);

        api.impersonatesEnd = $resource(api.URLs.impersonatesEnd, {}, defaultObj);

        api.questionnaires = $resource(api.URLs.questionnaires, {id: '@id'}, defaultObj);

        api.questions = $resource(api.URLs.questions, {id: '@id'}, defaultObj);

        api.questionOptions = $resource(api.URLs.questionOptions, {id: '@id'}, defaultObj);

        api.evaluations = $resource(api.URLs.evaluations, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            finalize:{
                method:'GET',
                url:api.URLs.evaluationsFinalize
            }
        });

        api.evaluationsPoints = $resource(api.URLs.evaluationsPoints, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            evaluate:{
                method:'POST',
                url:api.URLs.evaluationsPointsEvaluate
            }
        });

        api.answers = $resource(api.URLs.answers, {id: '@id'}, defaultObj);

        api.provinces = $resource(api.URLs.provinces, {id: '@id'}, defaultObj);

        api.localities = $resource(api.URLs.localities, {id: '@id'}, defaultObj);

        api.role = $resource(api.URLs.role, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            create: {method: 'POST'},
            update: {method: 'PATCH'},
            permissions: {
                url:api.URLs.rolePermissions,
                method: 'POST'
            }
        });
        api.contentType = $resource(api.URLs.contentType, {id: '@id'}, defaultObj);

        //Busquedas avanzadas
        api.searchsAdvances = $resource(api.URLs.getFilterFields, {id: '@id'}, {
            get:{
                isArray: true
            },
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            search: {
                url: api.URLs.searchsAdvances,
                method: 'POST',
                params:{page:'@page',tutors:'@tutors',coordinators:'@coordinators'}
            }
        });

        //Exportaciones
        api.export = $resource(api.URLs.export, {id: '@id'}, {
            get:{
                method: 'POST'
            }
        });

        //Exportaciones
        api.sendsAdvances= $resource(api.URLs.getReceivers, {id: '@id'}, {
            queryAll: queryAll,
            queryAllObj: queryAllObj,
            send: {
                url: api.URLs.sendsAdvances,
                method: 'POST',
                isArray: true
            }
        });

        return api;
    }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/breadcrumb/breadcrumb.html","<div layout=\"row\" layout-align=\"start center\"><div class=\"breadcrumb layout-align-start-center layout-row\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" ng-repeat-start=\"item in vm.items\" class=\"s16 separator\" role=\"img\" \naria-label=\"icon-chevron-right\"></md-icon><span ng-repeat-end bind-html-compile=\"vm.translate[item] || item\"></span>\n</div></div>");
$templateCache.put("app/digisigner/digisigner.html","<div class=\"digisigner\"><div layout=\"row\"><div class=\"requirements\" ng-init=\"showMore=false\" \nng-show=\"!vm.isOsSupported() || !vm.isBrowserSupported() || !vm.isJavaPluginSupported()\"><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" ng-click=\"showMore=!showMore\"><md-icon ng-show=\"showMore\" \nclass=\"pt-5\" title=\"{{\'Ver\' | translate}}\" md-font-icon=\"icon-eye-off\"></md-icon><md-icon ng-show=\"!showMore\" \nclass=\"pt-5\" title=\"{{\'Ver\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>\nRequisitos para firma</span></md-button><table ng-show=\"showMore\"><tr ng-show=\"!vm.isOsSupported()\"><td valign=\"top\">\n<strong>Sistema operativo utilizado:</strong><div>{{vm.so || \'No detectado\'}}</div></td><td valign=\"top\"><strong>\nRequisitos:</strong><div>Windows XP SP3</div><div>Linux 2.6</div><div>Apple OS X Mavericks (10.9.5)</div></td></tr><tr \nng-show=\"!vm.isBrowserSupported()\"><td valign=\"top\"><strong>Navegador utilizado:</strong><div>\n{{vm.browser || \'No detectado\'}}</div></td><td valign=\"top\"><strong>Requisitos:</strong><div>- Internet Explorer 8\n</div><div>- Mozilla Firefox 4</div><div>- Google Chrome (v15-41)</div><div>- Apple Safari 6.2</div></td></tr><tr \nng-show=\"!vm.isJavaPluginSupported()\"><td valign=\"top\"><strong>Plugin de Java utilizado:</strong><div>\n{{vm.java || \'No detectado\'}}</div></td><td valign=\"top\"><strong>Requisitos:</strong><div>Java SE 6 Update 38 (32 bits)\n</div><div>Java SE 7 Update 10 (32/64 bits)</div><div>Java SE 8 (32/64 bits)</div></td></tr></table></div><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" ng-click=\"vm.sign()\" ng-disabled=\"vm.loadSign\">\n<md-progress-circular ng-show=\"vm.loadSign\" md-mode=\"indeterminate\" md-diameter=\"20\"></md-progress-circular><md-icon \nng-show=\"!vm.loadSign\" class=\"pt-5\" title=\"{{\'Firmar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span \nclass=\"pt-5\" data-translate>Firmar</span></md-button></div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div><ms-breadcrumb \nid=\"breadcrumb\" hide-xs hide-sm></ms-breadcrumb></div><ms-breadcrumb id=\"breadcrumb\" hide-gt-sm></ms-breadcrumb><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"md-hue-2\" ms-scroll ui-view=\"content\" flex>\n</md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" data-layout=\"row\" data-flex><md-sidenav \nid=\"vertical-navigation\" class=\"md-primary-bg\" data-md-is-locked-open=\"$mdMedia(\'gt-sm\')\" \ndata-md-component-id=\"navigation\" data-ms-scroll data-ui-view=\"navigation\"></md-sidenav><div id=\"content-container\" \ndata-flex data-layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \ndata-ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" data-ms-scroll \ndata-ui-view=\"content\" data-flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" data-md-component-id=\"quick-panel\" data-ms-scroll data-ui-view=\"quickPanel\">\n</md-sidenav></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/actionloggings/actionloggings.html","<div id=\"actionloggings\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-format-list-bulleted\"></md-icon><span>\nAcciones del sistema</span></div><div class=\"count secondary-text\"><span data-translate>Número de acciones del sistema:\n</span> <span>{{vm.actionloggings.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"end start\" \ndata-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'actionloggings\'\"></ng-include></div></div><div \nclass=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.actionloggings.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-format-list-bulleted\"></md-icon><div class=\"message-text\" translate>Sin acciones del sistema</div>\n</div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"actionlogging in vm.actionloggings.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.actionloggings.count\" data-current-page=\"vm.actionloggings.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<span>[{{actionlogging.action}}] {{actionlogging.url}}</span></div><div class=\"tags\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\">\n{{actionlogging.creation_datetime | date:\'dd/MM/yyyy HH:mm\'}}</div></div><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" data-ng-if=\"actionlogging.executor_user\"><md-icon md-font-icon=\"icon-account\" class=\"s16\">\n</md-icon><div class=\"ml-10 tag-label\">{{actionlogging.executor_user}}</div></div><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" data-ng-if=\"actionlogging.impersonate_user\"><md-icon md-font-icon=\"icon-account-key\" \nclass=\"s16\"></md-icon><div class=\"ml-10 tag-label\">{{actionlogging.impersonate_user}}</div></div></div></div></div><div\n layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'actionloggings\',\'GET\')\" \ndata-ng-click=\"vm.openActionloggingDialog($event, actionlogging)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Ver detalle\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>Ver detalle\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/activities/activities.html","<div id=\"activities\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-hexagon-outline\"></md-icon><span>Actividades</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de actividades:</span> <span>{{vm.activities.count}}</span>\n</div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'activities\',\'POST\')\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Nueva actividad\' | translate}}\" data-ng-click=\"vm.openActivityDialog($event)\"><md-icon\n md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva actividad</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.activities.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-hexagon-outline\"></md-icon><div class=\"message-text\" translate>Sin actividades</div></div></div><div\n class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"activity in vm.activities.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.activities.count\" data-current-page=\"vm.activities.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{activity.name}}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'activities\',\'PATCH\')\" \ndata-ng-click=\"vm.openActivityDialog($event, activity)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'activities\',\'DELETE\')\" data-ng-click=\"vm.removeActivity($event, activity)\"><md-icon \nclass=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>\nEliminar</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/conditionsTemplates/conditionsTemplates.html","<div id=\"conditionsTemplates\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-table-large\"></md-icon><span>\nCláusulas de convenios</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de cláusulas de convenios:</span> <span>{{vm.conditionsTemplates.count}}</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'conditionsTemplates\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nueva cláusula de convenio\' | translate}}\" data-ng-click=\"vm.openConditionsTemplateDialog($event)\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva cláusula de convenio</span>\n</md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content \nclass=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div \nclass=\"no-results text-center\" ng-if=\"vm.conditionsTemplates.count == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-table-large\"></md-icon><div class=\"message-text\" translate>\nSin cláusulas de convenios</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"conditionsTemplate in vm.conditionsTemplates.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.conditionsTemplates.count\" data-current-page=\"vm.conditionsTemplates.filters.page\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{conditionsTemplate.name}}</div></div><span class=\"text-boxed m-0 white-fg indigo-bg ml-10\" \ndata-ng-if=\"conditionsTemplate.curricular\" data-translate>Curricular </span><span \nclass=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"conditionsTemplate.extracurricular\" data-translate>\nExtracurricular</span></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'conditionsTemplates\',\'PATCH\')\" \ndata-ng-click=\"vm.openConditionsTemplateDialog($event, conditionsTemplate)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'conditionsTemplates\',\'DELETE\')\" \ndata-ng-click=\"vm.removeConditionsTemplate($event, conditionsTemplate)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/coordinators/coordinators.html","<div id=\"coordinators\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box-outline\"></md-icon><span \ndata-translate>Coordinadores de asignatura</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de coordinadores académicos:</span> <span>{{vm.coordinators.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'coordinators\'\"></ng-include><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'teachersDegrees\',\'POST\')\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Nuevo coordinador\' | translate}}\" data-ng-click=\"vm.openTeachersDegreeDialog($event)\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo coordinador</span></md-button>\n</div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.coordinators.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account-box-outline\"></md-icon><div class=\"message-text\" translate>Sin coordinadores académicos\n</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"coordinator in vm.coordinators.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.coordinators.count\" data-current-page=\"vm.coordinators.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{coordinator.name}} {{coordinator.surname}} {{coordinator.second_surname}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-book-open\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><ng-pluralize \ncount=\"coordinator.coordinator_subjects.length\" \nwhen=\"{\'0\': \'0 titulaciones vinculadas\',\n                                                                             \'one\': \'Una titulación vinculada\',\n                                                                             \'other\': \'{} Titulaciones vinculadas\'}\">\n</ng-pluralize></div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'teachers\',\'GET\')\" \ndata-ui-sref=\"app.teacher({\'id\':\'{{coordinator.id}}\'})\"><md-icon class=\"pt-5\" title=\"{{\'Ver detalle\' | translate}}\" \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>Ver detalle</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/dashboard/dashboard.html","<div id=\"dashboard\"></div>");
$templateCache.put("app/main/eventNotifications/eventNotifications.html","<div id=\"eventNotifications\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\"></md-icon><span>Notificaciones</span></div>\n<div class=\"count secondary-text\"><span data-translate>Número de notificaciones:</span> <span>\n{{vm.eventNotifications.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-layout-wrap><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'eventNotifications\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nueva notificación\' | translate}}\" data-ng-click=\"vm.openEventNotificationDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva notificación</span></md-button></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><strong>{{vm.event.name}}</strong></div><md-content class=\"content p-20\" flex ms-scroll><p \nclass=\"mt-0 mb-20\">{{vm.event.description}}</p><md-divider></md-divider><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.eventNotifications.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div class=\"message-text\" \ntranslate>Este evento aún no tiene notificaciones</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"eventNotification in vm.eventNotifications.data\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{eventNotification.name}}</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-debouce-click \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'eventNotifications\',\'PATCH\')\" \ndata-ng-click=\"vm.openEventNotificationDialog($event, eventNotification)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'eventNotifications\',\'DELETE\')\" \ndata-ng-click=\"vm.removeEventNotification($event, eventNotification)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/events/events.html","<div id=\"events\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/events/sidenavs/categories-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" data-layout=\"column\" flex><div class=\"header\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div class=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\">\n<div class=\"h1\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\"></md-icon><span>\nEventos</span></div><div class=\"count secondary-text\"><span data-translate>Número de eventos:</span> <span>\n{{vm.events.count}}</span></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Listado de eventos</p></div><md-content \nclass=\"content p-20\" flex ms-scroll><div data-layout=\"column\" data-layout-align=\"space-between start\"><div \nclass=\"no-results text-center\" ng-if=\"vm.events.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-bell\"></md-icon><div class=\"message-text\" data-translate>Esta categoría aún no tiene eventos</div>\n</div></div><div class=\"todo-item\" data-layout=\"row\" data-layout-align=\"start center\" \nng-repeat=\"event in vm.events.data\"><div data-layout=\"row\" data-layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div data-layout=\"row\" data-layout-xs=\"column\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"space-between center\"><div><div class=\"title\">{{event.name}}</div><span>\n{{event.description | limitTo:90}}{{event.description.length > 90 ? \'...\' : \'\'}}</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'events\',\'GET\')\" \ndata-ui-sref=\"app.eventNotifications({\'category\':\'{{vm.category}}\',\'event\':\'{{event.id}}\'})\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Notificaciones\' | translate}}\" md-font-icon=\"icon-bell\"></md-icon><span class=\"pt-5\" data-translate>\nNotificaciones</span></md-button></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/export/export.html","<div id=\"export\"><div ng-hide=\"vm.showTable\" class=\"field-selector\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\"><h1>Exportar</h1><p>\nSelecciona las columnas a exportar y pulsa \"Generar tabla\" para ver el resultado.</p></div><div><md-button \nng-click=\"vm.backToModule()\" class=\"md-raised\" data-translate>Volver</md-button><md-button \nng-click=\"vm.selectAllColumns()\" class=\"select-all md-raised\">Seleccionar todos</md-button></div></div><div><div \nclass=\"field pr-20\" ng-repeat=\"column in vm.fields | orderBy:\'order\'\"><md-checkbox ng-model=\"column.enabled\">\n{{column.title}}</md-checkbox><md-icon ng-if=\"column.filters\" ng-click=\"column.showConfig=!column.showConfig\" \nmd-font-icon=\"icon-cog\" class=\"pointer\"></md-icon><div ng-if=\"column.filters\" ng-show=\"column.showConfig\" \nng-init=\"column.customFilters=column.customFilters || {}\"><div \nclass=\"container md-background-bg md-whiteframe-1dp p-20 mb-20\" layout=\"column\" data-layout-align=\"start start\" \nflex=\"100\" layout-wrap><div layout=\"row\" data-ng-repeat=\"(key,field) in column.filters\" flex=\"100\" \nng-init=\"column.customFilters[key].option=column.customFilters[key].option||field.filters[0]\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label ng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} \n<span data-ng-if=\"column.customFilters[key].option===\'range\'\" data-translate>(desde)</span></label><input \nng-model=\"column.customFilters[key].value\" ng-if=\"!field.options && (field.type===\'text\' || !field.type)\">\n<md-datepicker ng-model=\"column.customFilters[key].value\" \nng-init=\"column.customFilters[key].value=column.customFilters[key].value||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"column.customFilters[key].value\" aria-label=\"filtro\"><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" data-ng-if=\"column.customFilters[key].option===\'range\'\"><label \nng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} <span \ndata-ng-if=\"column.customFilters[key].option===\'range\'\" data-translate>(hasta)</span></label><input \nng-model=\"column.customFilters[key].value_range\" ng-if=\"!field.options && (field.type===\'text\' || !field.type)\">\n<md-datepicker ng-model=\"column.customFilters[key].value_range\" \nng-init=\"column.customFilters[key].value_range=column.customFilters[key].value_range||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"filter[key].value_range\" aria-label=\"filtro\"><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-select ng-if=\"field.filters.length>1\" ng-model=\"column.customFilters[key].option\" class=\"filterOptions\" \naria-label=\"filtro\"><md-option ng-repeat=\"filter in field.filters\" title=\"{{filter | filterOptions}}\" \nng-value=\"filter\">{{filter | filterOptionsIcons}}</md-option></md-select></div></div></div></div></div><div \nclass=\"text-center\"><md-button ng-disabled=\"vm.noColumnSelected()\" class=\"md-button md-primary md-raised\" \nng-click=\"vm.generateTable()\">Generar tabla</md-button></div></div><div class=\"data\" ng-show=\"vm.showTable\"><md-button \nng-show=\"vm.showTable\" ng-click=\"vm.back()\">Volver</md-button><md-button class=\"save-report\" ng-show=\"vm.showTable\" \nng-click=\"vm.openReportDialog()\" data-ng-if=\"hasPermission(\'reports\',\'POST\')\">Guardar como informe</md-button><table \nid=\"data\" class=\"display pt-30\" width=\"100%\"></table></div></div>");
$templateCache.put("app/main/gadesDegrees/gadesDegrees.html","<div id=\"gadesDegrees\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-book-open\"></md-icon><span>Titulaciones</span>\n</div><div class=\"count secondary-text\"><span data-translate>Número de titulaciones:</span> <span>\n{{vm.gadesDegrees.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-layout-wrap><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'gadesDegrees\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nueva titulación\' | translate}}\" data-ng-click=\"vm.openGadesDegreeDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva titulación</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.gadesDegrees.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-book-open\"></md-icon><div class=\"message-text\" translate>Sin titulaciones</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"gadesDegree in vm.gadesDegrees.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.gadesDegrees.count\" data-current-page=\"vm.gadesDegrees.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<span>{{gadesDegree.name}}</span></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'gadesDegrees\',\'PATCH\')\" data-ng-click=\"vm.openGadesDegreeDialog($event, gadesDegree)\">\n<md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" \ndata-translate>Editar</span></md-button><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'gadesDegrees\',\'DELETE\')\" \ndata-ng-click=\"vm.removeGadesDegree($event, gadesDegree)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/home/home.html","<div id=\"home\" class=\"home blog uca_default uca_ent_vicer uca_cat\"><link \nhref=\"//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css\" rel=\"stylesheet\"><header \nclass=\"main clearfix\"><nav class=\"auxiliary hidden-xs\"><div class=\"container\"><ul \nclass=\"navTopUCA unstyled list-inline pull-left\"><a href=\"https://vrteit.uca.es/wp-admin/\" class=\"icon-link\" \ntitle=\"Administración del sitio \"><i class=\"fa fa-sign-in\" aria-hidden=\"true\"></i></a><li class=\"\"><a \nhref=\"http://www.uca.es/estudiantes/\" title=\"\">Estudiantes</a></li><li class=\"\"><a href=\"http://www.uca.es/empresas/\" \ntitle=\"\">Empresas</a></li><li class=\"\"><a href=\"http://www.uca.es/wp_personal/\" title=\"\">Personal</a></li></ul><ul \nclass=\"navTopUCA unstyled list-inline pull-right\"><li class=\"\"><a href=\"http://bouca.uca.es/\" title=\"\">BOUCA</a></li>\n<li class=\"\"><a href=\"http://webmerlin.uca.es/\" title=\"Theme UCA\nversion 1.0.85\">Correo</a></li><li class=\"\"><a \nhref=\"http://directorio.uca.es/cau/directorio.do\" title=\"\">Directorio</a></li><li class=\"\"><a \nhref=\"https://cau.uca.es/cau/indiceGlobal.do\" title=\"\">CAU</a></li><li class=\"\"><a \nhref=\"https://campusvirtual.uca.es/\" title=\"\">Campus Virtual</a></li><li class=\"\"><a href=\"http://biblioteca.uca.es/\" \ntitle=\"\">Biblioteca</a></li><li class=\"\"><a href=\"https://agora.uca.es/\" title=\"\">Videoconferencia</a></li></ul></div>\n</nav><div class=\"header-top hidden-xs\"><div class=\"container\"><div class=\"row\" style=\"font-size: 0\"><h1 \nclass=\"header-brand\"><a href=\"http://www.uca.es/\">Universidad<span class=\"header-brand-small\">de</span>Cádiz</a></h1>\n<div class=\"ceimar hidden-xs\"><a href=\"http://www.campusdelmar.com/es/\"><div class=\"ceimar-title\">CEI·MAR</div><div \nclass=\"ceimar-sub\">Campus de Excelencia Internacional Global del Mar</div></a></div></div></div></div><div \nclass=\"header-banner hidden-xs\"><img class=\"img-responsive\" \nsrc=\"https://vrteit.uca.es/wp-content/themes/theme_main_uca/images/fondos/fondo.uca_ent_vicer.uca_cat_vr_transf.jpg\" \nalt=\"Fondo Cabecera General\"></div><div><div class=\"header-gades\"><div class=\"container\"><h1>Bienvenido a <strong>GADES\n</strong> <span class=\"ml-10 red-700-fg\" ng-if=\"imageDebug\">PRUEBAS</span></h1><h2>\nPortal de Gestión de prácticas en empresas de la Universidad de Cádiz</h2></div></div><div class=\"content-gades\"><div \nclass=\"container\"><div layout=\"row\" layout-align=\"space-around center\" class=\"pt-65 pb-65\" layout-wrap><md-button \ndata-ui-sref=\"app.auth.login({action:\'students\'})\" layout=\"row\" layout-align=\"center center\" layout-wrap><md-icon \nmd-font-icon=\"icon-account\" md-font-set=\"s60\" class=\"mr-20\"></md-icon><p data-translate>Acceso alumnado</p></md-button>\n<md-button data-ui-sref=\"app.auth.login({action:\'companies\'})\" layout=\"row\" layout-align=\"center center\" layout-wrap>\n<md-icon md-font-icon=\"icon-domain\" md-font-set=\"s60\" class=\"mr-20\"></md-icon><p data-translate>Acceso empresas</p>\n</md-button><md-button data-ui-sref=\"app.auth.login({action:\'university\'})\" layout=\"row\" layout-align=\"center center\" \nlayout-wrap><md-icon md-font-icon=\"icon-bank\" md-font-set=\"s60\" class=\"mr-20\"></md-icon><p data-translate>\nAcceso Universidad</p></md-button></div></div></div></div></header><footer class=\"main\"><div class=\"container\"><div \nclass=\"col-sm-15 col-xs-12\"><img class=\"ft_logo\" \nsrc=\"https://vrteit.uca.es/wp-content/themes/theme_main_uca/images/logoFooterUCA_05.png\" alt=\"Universidad de Cádiz\">\n</div><div class=\"col-sm-15 col-xs-12\"><ul class=\"list-unstyled ft_contact_links\"><li class=\"\"><a \nhref=\"mailto:informacion.dge@uca.es\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i> informacion.dge@uca.es</a></li>\n<li class=\"\"><a href=\"mailto:oferta.empleo@uca.es\"><i class=\"fa fa-envelope\" aria-hidden=\"true\"></i>\n oferta.empleo@uca.es</a></li><li class=\"\"><a href=\"mailto:pife.practicas@uca.es\"><i class=\"fa fa-envelope\" \naria-hidden=\"true\"></i> pife.practicas@uca.es</a></li><li class=\"\"><i class=\"fa fa-phone\" aria-hidden=\"true\"></i>\n 956 015 340 / 956 015 498 / 956 015 692</li><li class=\"hidden\"><i class=\"fa fa-fax\" aria-hidden=\"true\"></i> (FAX)</li>\n<li class=\"\"><i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i> Edificio Hospital Real<br>Plaza Falla, 8<br>\n11003, Cádiz<br>CÁDIZ</li></ul></div><div class=\"col-sm-15 col-xs-12\"><ul class=\"list-unstyled\"><li><a \nhref=\"http://serprevencion.uca.es\">Servicio de Prevención</a></li><li><a href=\"http://oficinadefensor.uca.es\">\nDefensoría Universitaria</a></li><li><a href=\"http://inspeccion.uca.es\">Inspección General de Servicios</a></li><li><a \nhref=\"http://igualdad.uca.es\">Unidad de Igualdad</a></li><br><li><a href=\"http://www.uca.es/aviso-legal\">Aviso legal\n</a></li><li><a href=\"http://www.uca.es/accesibilidad\">Accesibilidad</a></li><li><a href=\"http://www.uca.es/cookies\">\nCookies</a></li></ul></div><div class=\"col-sm-15 col-xs-12\"><ul class=\"social-links list-unstyled list-inline\"><li \nclass=\"\"><a href=\"http://www.facebook.com/universidaddecadiz\" target=\"_blank\" class=\"btn btn-icon\" \naria-label=\"Facebook\" title=\"Facebook\"><i class=\"fa fa-fw fa-2x fa-facebook\" title=\"Facebook\"></i><span \nclass=\"text-hide\">Facebook</span></a></li><li class=\"\"><a href=\"http://twitter.com/univcadiz\" target=\"_blank\" \nclass=\"btn btn-icon\" aria-label=\"Twitter\" title=\"Twitter\"><i class=\"fa fa-fw fa-2x fa-twitter\" title=\"Twitter\"></i>\n<span class=\"text-hide\">Twitter</span></a></li><li class=\"\"><a href=\"https://www.instagram.com/univcadiz/\" \ntarget=\"_blank\" class=\"btn btn-icon\" aria-label=\"Instagram\" title=\"Instagram\"><i class=\"fa fa-fw fa-2x fa-instagram\" \ntitle=\"Instagram\"></i><span class=\"text-hide\">Instagram</span></a></li><li class=\"\"><a \nhref=\"http://www.youtube.com/videosUCA\" target=\"_blank\" class=\"btn btn-icon\" aria-label=\"Youtube\" title=\"Youtube\"><i \nclass=\"fa fa-fw fa-2x fa-youtube\" title=\"Youtube\"></i><span class=\"text-hide\">Youtube</span></a></li><li class=\"\"><a \nhref=\"https://www.flickr.com/photos/147802205@N03/albums\" target=\"_blank\" class=\"btn btn-icon\" aria-label=\"Flickr\" \ntitle=\"Flickr\"><i class=\"fa fa-fw fa-2x fa-flickr\" title=\"Flickr\"></i><span class=\"text-hide\">Flickr</span></a></li>\n</ul></div></div></footer></div>");
$templateCache.put("app/main/impersonates/impersonates.html","<div id=\"impersonates\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-key\"></md-icon><span>\nAcceder como otro usuario</span></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content \nclass=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-align=\"space-between start\"><form \nname=\"impersonateForm\" class=\"md-inline-form ms-form-wizard-form full-width\" novalidate><div data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"identification\"><label data-translate>\nEscriba el usuario con el que quiere hacer login</label><input name=\"identification\" \ndata-ng-model=\"vm.form.identification\" required><error-messages field=\"impersonateForm.identification\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.loginImpersonate()\" \nclass=\"send-button md-accent md-raised\" data-ng-if=\"hasPermission(\'impersonates\',\'POST\')\" \nng-disabled=\"userForm.$invalid || userForm.$pristine\" aria-label=\"{{\'Acceder\' | translate}}\"><span data-translate>\nAcceder</span></md-button></div></form></div></md-content></div></div></div>");
$templateCache.put("app/main/managerDegrees/managerDegrees.html","<div id=\"managerDegrees\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clipboard-account\"></md-icon><span data-translate>\nGestores de titulación</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de gestores de titulación:</span> <span>{{vm.managerDegrees.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"end start\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'teachersDegrees\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nuevo gestor de titulación\' | translate}}\" data-ng-click=\"vm.openManagerDegreeDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo gestor de titulación</span></md-button>\n</div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.managerDegrees.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-clipboard-account\"></md-icon><div class=\"message-text\" translate>Sin gestores de titulación</div>\n</div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"managerDegree in vm.managerDegrees.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.managerDegrees.count\" data-current-page=\"vm.managerDegrees.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{managerDegree.uca_user.identification}} - {{managerDegree.uca_user.name}} {{managerDegree.uca_user.first_surname}} {{managerDegree.uca_user.second_surname}}\n</div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-book-open\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\">\n<ng-pluralize count=\"managerDegree.degrees_managed.length\" \nwhen=\"{\'0\': \'0 titulaciones vinculadas\',\n                                                                             \'one\': \'Una titulación vinculada\',\n                                                                             \'other\': \'{} Titulaciones vinculadas\'}\">\n</ng-pluralize></div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'teachersDegrees\',\'POST\')\" data-ng-click=\"vm.openManagerDegreeDialog($event, managerDegree)\">\n<md-icon class=\"pt-5\" title=\"{{\'Ver detalle\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" \ndata-translate>Ver detalle</span></md-button></div></div></div></div></div><dir-pagination-controls \nclass=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/notifications/notifications.html","<div id=\"notifications\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-bell\"></md-icon><span>Notificaciones</span></div><div class=\"count secondary-text\"><span \ndata-translate>Número de notificaciones:</span> <span>{{vm.threads.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"space-between center\" data-layout-wrap><div data-layout=\"row\" data-layout-xs=\"column\" \ndata-layout-align=\"space-between start\" data-layout-wrap><label class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\"><span data-hide-xs data-hide-gt-xs data-translate>Buscar</span><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'Buscar\' | translate }}\" data-ng-model=\"vm.threads.filters.search\" data-flex></label><div \nclass=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" \nclass=\"white-text icon\"></md-icon><md-select class=\"simplified\" data-ng-model=\"vm.threads.filters.is_read\" \ndata-placeholder=\"{{\'Filtrar\' | translate }}\" aria-label=\"{{\'Filtrar\' | translate }}\"><md-option data-ng-value=\"\">\nLimpiar filtro</md-option><md-option data-ng-value=\"1\" data-translate>Leidos</md-option><md-option data-ng-value=\"0\" \ndata-translate>No leidos</md-option></md-select></div><div class=\"search pt-10\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"white-text icon\"></md-icon><md-select \nclass=\"simplified\" data-ng-model=\"vm.threads.filters.is_important\" data-placeholder=\"{{\'Filtrar\' | translate }}\" \naria-label=\"{{\'Filtrar\' | translate }}\"><md-option data-ng-value=\"\">Limpiar filtro</md-option><md-option \ndata-ng-value=\"1\" data-translate>Importantes</md-option><md-option data-ng-value=\"0\" data-translate>No importantes\n</md-option></md-select></div><div class=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\" \nng-if=\"vm.categories\"><md-icon md-font-icon=\"icon-tag\" class=\"white-text icon\"></md-icon><md-select class=\"simplified\" \ndata-ng-model=\"vm.threads.filters.notification__event_notification__event__category_id\" \nng-change=\"vm.changeCategory()\" data-placeholder=\"{{\'Categoría\' | translate }}\" \naria-label=\"{{\'Categoría\' | translate }}\"><md-option data-ng-value=\"\">Limpiar filtro</md-option><md-option \ndata-ng-repeat=\"category in vm.categories\" data-ng-value=\"category.id\">{{category.name}}</md-option></md-select></div>\n<div class=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\" ng-if=\"vm.categories\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"white-text icon\"></md-icon><md-select class=\"simplified\" \ndata-ng-model=\"vm.threads.filters.notification__event_notification__event_id\" \nng-disabled=\"!vm.threads.filters.notification__event_notification__event__category_id\" \ndata-placeholder=\"{{\'Evento\' | translate }}\" aria-label=\"{{\'Evento\' | translate }}\"><md-option data-ng-value=\"\">\nLimpiar filtro</md-option><md-option data-ng-repeat=\"event in vm.events\" data-ng-value=\"event.id\">{{event.name}}\n</md-option></md-select></div></div></div></div><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" \nflex ng-include=\"vm.views[vm.currentView]\"></div></div></div>");
$templateCache.put("app/main/offersRequests/offersRequests.html","<div id=\"offersRequests\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/offers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>Candidatos\n</span></div><div class=\"count secondary-text\"><span data-translate>Número de candidatos:</span> <span>\n{{vm.offersRequests.count}}</span></div></div><div data-layout=\"column\" data-layout-align=\"space-between end\"><div \nclass=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"column\" \nlayout-align=\"end end\"><span><span data-translate>Oferta:</span> <span>{{vm.offer.code}}</span> </span><span><span \ndata-translate>Programa:</span> <span>{{vm.offer.program_data.name}}</span></span></div></div><div data-layout=\"row\" \ndata-layout-align=\"space-between center\" data-layout-wrap><div class=\"search pt-10\" data-layout=\"row\" \ndata-layout-align=\"start center\"><label class=\"search\" data-layout=\"row\" data-layout-align=\"start center\" data-flex>\n<input class=\"search-input no-margin\" type=\"text\" placeholder=\"{{ \'Buscar\' | translate}}\" \ndata-ng-model=\"vm.offersRequests.filters.search\" data-flex></label></div></div></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.offersRequests.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-account\"></md-icon><div class=\"message-text\" \ntranslate>Sin candidatos</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \nmd-ink-ripple ng-class=\"{\'pointer\':hasPermission(\'offersRequests\',\'PATCH\') || hasPermission(\'confirmRequest\',\'POST\')}\" \ndata-ng-click=\"vm.openOffersStudentDialog($event, offersRequest)\" \ndata-dir-paginate=\"offersRequest in vm.offersRequests.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.offersRequests.count\" data-current-page=\"vm.offersRequests.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>\n{{offersRequest.student_data.contact_student_data.identification}} </span><span ng-if=\"offersRequest.visible\">- </span>\n<span ng-if=\"offersRequest.visible\">\n{{offersRequest.student_data.contact_student_data.name}} {{offersRequest.student_data.contact_student_data.surname}} {{offersRequest.student_data.contact_student_data.second_surname}}\n</span></div><div class=\"tags\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"offersRequest.visible\"><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{offersRequest.student_data.contact_student_data.email}}</div></div><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-phone\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{offersRequest.student_data.contact_student_data.phone}}</div></div></div><div class=\"mt-8\">\n<span class=\"text-boxed m-0 white-fg orange-bg\" data-ng-if=\"offersRequest.status === \'pre-signed up\'\">\nPendiente de validación UCA </span><span class=\"text-boxed m-0 white-fg orange-bg\" \ndata-ng-if=\"offersRequest.status === \'signed up\'\">Solicitud </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"offersRequest.status === \'selected\'\">Seleccionado </span><span \nclass=\"text-boxed m-0 white-fg orange-300-bg\" data-ng-if=\"offersRequest.status === \'pre-selected\'\">Preseleccionado \n</span><span class=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"offersRequest.status === \'discarded\'\">Descartado \n</span><span class=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"offersRequest.status === \'accepted\'\">Alumno acepta \n</span><span class=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"offersRequest.status === \'rejected\'\">Alumno no acepta\n</span></div></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/offersTemplates/offersTemplates.html","<div id=\"offersTemplates\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/offers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>Candidatos</span></div>\n<div class=\"count secondary-text\"><span data-translate>Número de candidatos:</span> <span>{{vm.offersTemplates.count}}\n</span></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" \nflex ms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.offersTemplates.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account\"></md-icon><div class=\"message-text\" translate>Sin candidatos</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" md-ink-ripple \nng-class=\"{\'pointer\':hasPermission(\'offersTemplates\',\'PATCH\')}\" \ndata-ng-click=\"vm.openOffersStudentDialog($event, offersTemplate)\" \ndata-dir-paginate=\"offersTemplate in vm.offersTemplates.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.offersTemplates.count\" data-current-page=\"vm.offersTemplates.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>\n{{offersTemplate.student_data.contact_student_data.identification}} </span><span ng-if=\"offersTemplate.visible\">- \n</span><span ng-if=\"offersTemplate.visible\">\n{{offersTemplate.student_data.contact_student_data.name}} {{offersTemplate.student_data.contact_student_data.surname}} {{offersTemplate.student_data.contact_student_data.second_surname}}\n</span></div><div class=\"tags\" layout=\"row\" layout-align=\"start start\" layout-wrap ng-if=\"offersTemplate.visible\"><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{offersTemplate.student_data.contact_student_data.email}}</div></div><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-phone\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{offersTemplate.student_data.contact_student_data.phone}}</div></div></div><div class=\"mt-8\">\n<span class=\"text-boxed m-0 white-fg orange-bg\" data-ng-if=\"offersRequest.status === \'pre-signed up\'\">\nPendiente de validación UCA </span><span class=\"text-boxed m-0 white-fg orange-bg\" \ndata-ng-if=\"offersTemplate.status === \'signed up\'\">Solicitud </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"offersTemplate.status === \'selected\'\">Seleccionado </span><span \nclass=\"text-boxed m-0 white-fg orange-300-bg\" data-ng-if=\"offersTemplate.status === \'pre-selected\'\">Preseleccionado \n</span><span class=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"offersTemplate.status === \'discarded\'\">Descartado \n</span><span class=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"offersTemplate.status === \'accepted\'\">Alumno acepta \n</span><span class=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"offersTemplate.status === \'rejected\'\">Alumno no acepta\n</span></div></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/parameters/parameters.html","<md-menu ng-if=\"Parameters.showMenu(Parameters.parameters)\"><md-button class=\"md-icon-button\" aria-label=\"parámetros\">\n<md-icon md-font-icon=\"{{Parameters.icon || \'icon-dots-vertical\'}}\" \nng-click=\"$mdMenu.open($event);Parameters.resetParameters()\"></md-icon></md-button><md-menu-content class=\"paremeters\" \nng-show=\"!Parameters.load\"><div ng-if=\"!Parameters.selectedParameter\"><md-menu-item \nng-repeat=\"parameter in Parameters.parameters\" ng-init=\"parameter.show=false;\" \nng-if=\"Parameters.notEmpty(parameter[Parameters.filter])\"><md-button layout=\"row\" layout-align=\"space-between center\" \naria-label=\"addToBreadcrumb\" ng-click=\"Parameters.addToBreadcrumb(parameter.name, parameter)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\"><span>{{parameter.human_name}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"icon\"></md-icon></md-button></md-menu-item></div><div \nng-if=\"Parameters.selectedParameter && Parameters.selectedParameter.human_name\" \nng-init=\"p=Parameters.selectedParameter[Parameters.filter]\"><md-menu-item class=\"md-blue-300-bg\"><md-button \nng-click=\"Parameters.addToBreadcrumb(null)\" md-prevent-menu-close=\"md-prevent-menu-close\" aria-label=\"addToBreadcrumb\">\n<md-icon md-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon><span><span ng-repeat=\"b in Parameters.breadcrumb\">\n{{b.value}} <span ng-if=\"!$last\">.</span></span></span></md-button></md-menu-item><md-menu-item \nng-repeat-start=\"(key, value) in p\"><md-button layout=\"row\" layout-align=\"space-between center\" \naria-label=\"addToBreadcrumb\" md-prevent-menu-close=\"md-prevent-menu-close\" ng-if=\"value.data\" \nng-click=\"Parameters.addToBreadcrumb(key, value)\"><span>{{value.human_name}}</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"icon\"></md-icon></md-button><md-button ng-if=\"!value.data\" \nng-click=\"Parameters.addValueParemeter(key)\"><span>{{value.human_name}}</span></md-button></md-menu-item><md-divider \nng-repeat-end></md-divider></div><div ng-if=\"Parameters.selectedParameter && !Parameters.selectedParameter.human_name\">\n<md-menu-item class=\"md-blue-300-bg\"><md-button ng-click=\"Parameters.addToBreadcrumb(null)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" aria-label=\"addToBreadcrumb\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon><span><span ng-repeat=\"b in Parameters.breadcrumb\">{{b.value}} <span ng-if=\"!$last\">.</span>\n</span></span></md-button></md-menu-item><md-menu-item ng-repeat-start=\"(key, value) in Parameters.selectedParameter\">\n<md-button layout=\"row\" layout-align=\"space-between center\" aria-label=\"addToBreadcrumb\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-if=\"value.data\" ng-click=\"Parameters.addToBreadcrumb(key, value)\">\n<span>{{value.human_name}}</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"icon\"></md-icon></md-button>\n<md-button ng-if=\"!value.data\" ng-click=\"Parameters.addValueParemeter(key)\"><span>{{value.human_name}}</span>\n</md-button></md-menu-item><md-divider ng-repeat-end></md-divider></div></md-menu-content></md-menu>");
$templateCache.put("app/main/programs/programs.html","<div id=\"programs\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-star\"></md-icon><span>Programas</span></div><div class=\"count secondary-text\"><span \ndata-translate>Número de programas:</span> <span>{{vm.programs.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'programs\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nuevo programa\' | translate}}\" data-ng-click=\"vm.openProgramDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo programa</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.programs.count == 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-star\"></md-icon><div class=\"message-text\" \ntranslate>Sin programas</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"program in vm.programs.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.programs.count\" data-current-page=\"vm.programs.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<span>{{program.name}}</span></div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{program.start_date | date:\'dd/MM/yyyy\'}} - {{program.end_date | date:\'dd/MM/yyyy\'}}</div>\n</div><span class=\"text-boxed white-fg green-bg\" data-ng-if=\"vm.isActive(program)\" data-translate>Activo </span><span \nclass=\"text-boxed white-fg red-bg\" data-ng-if=\"!vm.isActive(program)\" data-translate>Finalizado</span></div></div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'programManagers\',\'POST\')\" \ndata-ng-click=\"vm.openProgramManagerDialog($event, program)\"><md-icon class=\"pt-5 teal-fg\" \ntitle=\"{{\'Gestores\' | translate}}\" md-font-icon=\"icon-account\"></md-icon><span class=\"pt-5 teal-fg\" data-translate>\nGestores</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'programsXLS\',\'POST\')\" data-ng-click=\"vm.openProgramXlsDialog($event, program, \'student\')\">\n<md-icon class=\"pt-5 green-700-fg\" title=\"{{\'Alumnos\' | translate}}\" md-font-icon=\"icon-file-excel\"></md-icon><span \nclass=\"pt-5 green-700-fg\" data-translate>Alumnos</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'programsXLS\',\'POST\')\" \ndata-ng-click=\"vm.openProgramXlsDialog($event, program, \'company\')\"><md-icon class=\"pt-5 orange-700-fg\" \ntitle=\"{{\'Empresas\' | translate}}\" md-font-icon=\"icon-file-excel\"></md-icon><span class=\"pt-5 orange-700-fg\" \ndata-translate>Empresas</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'programs\',\'PATCH\')\" \ndata-ng-click=\"vm.openProgramDialog($event, program)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'programs\',\'DELETE\')\" \ndata-ng-click=\"vm.removeProgram($event, program)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/pyconfrests/pyconfrests.html","<div id=\"pyconfrests\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/pyconfrests/sidenavs/categories-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" data-layout=\"column\" flex><div class=\"header\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div class=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\">\n<div class=\"h1\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\"></md-icon><span>\nVariables del sistema</span></div><div class=\"count secondary-text\"><span data-translate>Número de variables:</span> \n<span>{{vm.pyconfrests.count}}</span></div></div><div><md-button class=\"md-raised md-background md-warn\" \nng-click=\"vm.changeYear()\" ng-if=\"vm.cloneAcademicYear\" data-debouce-click><span data-translate>Avanzar año académico\n</span></md-button></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>Listado de variables</p></div><md-content \nclass=\"content p-20\" flex ms-scroll><div data-layout=\"column\" data-layout-align=\"space-between start\"><div \nclass=\"no-results text-center\" ng-if=\"vm.pyconfrests.count == 0\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div class=\"message-text\" data-translate>\nEsta categoría aún no tiene variables</div></div></div><div class=\"todo-item\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ng-repeat=\"(key, pyconfrest) in vm.pyconfrests.data\"><div data-layout=\"row\" \ndata-layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div data-layout=\"row\" data-layout-xs=\"column\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"space-between center\"><div><div \nclass=\"title\">{{pyconfrest.verbose_name}}</div><div><md-icon md-font-icon=\"icon-note-text\"></md-icon>\n{{pyconfrest.value | findBodyHtml | htmlToPlaintext | limitTo:90 }} {{(pyconfrest.value | findBodyHtml | htmlToPlaintext).length > 90 ? \'...\' : \'\'}}\n</div></div></div><div data-layout=\"row\" data-layout-align=\"end center\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'pyconfrests\',\'PATCH\')\" \ndata-ng-click=\"vm.openPyconfrestDialog($event, pyconfrest ,key)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/reports/reports.html","<div id=\"reports\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file-document\"></md-icon><span>Informes</span></div><div class=\"count secondary-text\"><span\n data-translate>Número de informes:</span> <span>{{vm.reports.count}}</span></div></div></div><div \nclass=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.reports.count == 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-file-document\"></md-icon><div \nclass=\"message-text\" translate>Sin informes</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-dir-paginate=\"report in vm.reports.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.reports.count\" data-current-page=\"vm.reports.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<span>{{report.name}}</span></div><div><md-icon md-font-icon=\"icon-note-text\"></md-icon>\n{{report.description | limitTo:90 }} {{report.description.length > 90 ? \'...\' : \'\'}}</div></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'reports\',\'GET\')\" data-ng-click=\"vm.search($event, report)\">\n<md-icon class=\"pt-5 green-700-fg\" title=\"{{\'Ver\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span \nclass=\"pt-5 green-700-fg\" data-translate>Ver</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'reports\',\'GET\')\" \ndata-ng-click=\"vm.search($event, report, \'export\')\"><md-icon class=\"pt-5 indigo-700-fg\" \ntitle=\"{{\'Exportar\' | translate}}\" md-font-icon=\"icon-export\"></md-icon><span class=\"pt-5 indigo-700-fg\" \ndata-translate>Exportar</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'reports\',\'PATCH\')\" \ndata-ng-click=\"vm.openReportDialog($event, report)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'reports\',\'DELETE\')\" \ndata-ng-click=\"vm.removeReport($event, report)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/searchsAdvances/searchsAdvances.html","<div id=\"searchsAdvances\" class=\"page-layout fullwidth tabbed\" data-layout=\"row\"><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"md-accent-bg p-30\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"s48 mr-15\" md-font-icon=\"icon-magnify-plus\"></md-icon><span>Buscador avanzado</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\"><md-button class=\"md-raised md-background\" ng-click=\"vm.addSearch()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><span>Añadir filtro</span></md-button><md-button class=\"md-raised md-background\" \nng-click=\"vm.search()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><span>Lanzar búsqueda</span></md-button></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content\" style=\"height:100%\">\n<md-tabs md-selected=\"vm.selectedFilter\" class=\"icontab\"><md-tab ng-repeat=\"filter in vm.searchTabs | orderBy:\'order\'\">\n<md-tab-label><span>Filtro {{$index + 1}}</span><md-icon ng-click=\"vm.closeSearch($index)\" class=\"s16\" \nmd-font-icon=\"icon-close\"></md-icon></md-tab-label><md-tab-body><form name=\"contactForm[$index]\" class=\"p-20\"><div \nclass=\"container md-background-bg md-whiteframe-1dp p-20 mb-20\" layout=\"row\" data-layout-align=\"space-between center\" \nflex=\"100\" layout-wrap><div layout=\"row\" data-ng-repeat=\"field in vm.searchsAdvances\" flex=\"40\" flex-xs=\"100\" \nng-init=\"filter[field.field_name].option=filter[field.field_name].option||field.filters[0]\" \nfilter-depends-on=\"field.depends_on\" filter-depends-on-field=\"field.field_name\" filter-depends-on-values=\"filter\">\n<md-input-container class=\"md-block\" flex=\"100\"><label \nng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} <span \ndata-ng-if=\"filter[field.field_name].option===\'range\'\" data-translate>(desde)</span></label><input \nng-model=\"filter[field.field_name].value\" ng-if=\"!field.options && field.type===\'text\'\"><md-datepicker \nng-model=\"filter[field.field_name].value\" \nng-init=\"filter[field.field_name].value=filter[field.field_name].value||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"filter[field.field_name].value\" aria-label=\"filtro\"><span \nng-if=\"field.type===\'boolean\'\" ng-init=\"filter[field.field_name].option=\'boolean\'\"></span><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" data-ng-if=\"filter[field.field_name].option===\'range\'\"><label \nng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} <span \ndata-ng-if=\"filter[field.field_name].option===\'range\'\" data-translate>(hasta)</span></label><input \nng-model=\"filter[field.field_name].value_range\" ng-if=\"!field.options && field.type===\'text\'\"><md-datepicker \nng-model=\"filter[field.field_name].value_range\" \nng-init=\"filter[field.field_name].value_range=filter[field.field_name].value_range||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"filter[field.field_name].value_range\" aria-label=\"filtro\"><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-select ng-if=\"field.filters.length>1\" ng-model=\"filter[field.field_name].option\" class=\"filterOptions\" \naria-label=\"filtro\"><md-option ng-repeat=\"filter in field.filters\" title=\"{{filter | filterOptions}}\" \nng-value=\"filter\">{{filter | filterOptionsIcons}}</md-option></md-select></div></div></form></md-tab-body></md-tab>\n</md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/searchsAdvances/searchsBasics.html","<div data-layout=\"row\" data-layout-xs=\"column\" data-layout-align=\"start start\" flex=\"85\" flex-xs=\"100\" layout-wrap \nclass=\"ml-50 mb-20 basicFilters\" ng-init=\"vm.hasBasic=false;vm.hasAdvance=false\"><div \ndata-ng-repeat=\"field in vm.searchsBasics\" ng-init=\"vm.hasAdvance=true\" ng-if=\"!field.basic\"></div><div layout=\"row\" \ndata-ng-repeat=\"field in vm.searchsBasics\" \nng-init=\"vm.filterBasic[field.field_name].option=field.filters[0];vm.hasBasic=true\" ng-if=\"field.basic\" class=\"mr-20\" \nfilter-depends-on=\"field.depends_on\" filter-depends-on-field=\"field.field_name\" \nfilter-depends-on-values=\"vm.filterBasic\"><div><label class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-flex ng-if=\"!field.options && field.type===\'text\'\"><input \nclass=\"search-input no-margin\" type=\"text\" placeholder=\"{{field.title}}\" \ndata-ng-model=\"vm.filterBasic[field.field_name].value\" ng-if=\"!field.options && field.type===\'text\'\" data-flex></label>\n<md-datepicker data-ng-model=\"vm.filterBasic[field.field_name].value\" \nng-init=\"vm.filterBasic[field.field_name].value=vm.filterBasic[field.field_name].value||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"{{field.title}}\"></md-datepicker><div \nclass=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\" ng-if=\"field.options\"><span \nng-if=\"field.type===\'boolean\'\" ng-init=\"vm.filterBasic[field.field_name].option=\'boolean\'\"></span><md-select \nng-if=\"field.options\" ng-model=\"vm.filterBasic[field.field_name].value\" placeholder=\"{{field.title}}\" \nclass=\"simplified no-margin\" aria-label=\"filtro\"><md-option value=\"\" data-translate>Limpiar filtro</md-option>\n<md-option ng-repeat=\"(value,text) in field.options\" ng-value=\"\'{{value}}\'\">{{text}}</md-option></md-select></div>\n</div><div data-ng-if=\"vm.filterBasic[field.field_name].option===\'range\'\"><label class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-flex ng-if=\"!field.options && field.type===\'text\'\"><input \nclass=\"search-input no-margin\" type=\"text\" placeholder=\"{{field.title}}\" \ndata-ng-model=\"vm.filterBasic[field.field_name].value_range\" ng-if=\"!field.options && field.type===\'text\'\" data-flex>\n</label><md-datepicker ng-model=\"vm.filterBasic[field.field_name].value_range\" \nng-init=\"vm.filterBasic[field.field_name].value_range=vm.filterBasic[field.field_name].value_range||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"{{field.title}}\"></md-datepicker><div \nclass=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\" ng-if=\"field.options\"><md-select \nng-if=\"field.options\" ng-model=\"vm.filterBasic[field.field_name].value_range\" placeholder=\"{{field.title}}\" \nclass=\"simplified no-margin\" aria-label=\"filtro\"><md-option value=\"\" data-translate>Limpiar filtro</md-option>\n<md-option ng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></div></div><div \nclass=\"search mt-10 mr-10 no-padding\" data-layout=\"row\" data-layout-align=\"start center\" \nng-if=\"field.filters.length>1\"><md-select ng-model=\"vm.filterBasic[field.field_name].option\" aria-label=\"filtro\" \nclass=\"mr-20 simplified filterOptions no-margin\"><md-option ng-repeat=\"filter in field.filters\" \ntitle=\"{{filter | filterOptions}}\" ng-value=\"filter\">{{filter | filterOptionsIcons}}</md-option></md-select></div>\n</div></div><div class=\"actions ml-50\" data-layout=\"row\" data-layout-align=\"end center\" layout-wrap flex=\"5\" \nflex-xs=\"100\"><md-button data-debouce-click class=\"md-raised md-background\" ng-click=\"vm.search()\" ng-if=\"vm.hasBasic\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><span>Buscar</span></md-button><div class=\"lock-size\" layout=\"row\" \nlayout-align=\"center center\"><md-fab-speed-dial ng-cloak md-open=\"vm.isOpen\" md-direction=\"up\" \nclass=\"md-scale md-fab-bottom-right\"><md-fab-trigger><md-button aria-label=\"menu\" class=\"md-fab md-accent\"><md-icon \nmd-font-icon=\"icon-cog\"></md-icon></md-button></md-fab-trigger><md-fab-actions><md-button aria-label=\"Exportar\" \nclass=\"md-fab md-raised md-mini\" data-ng-if=\"hasPermissionExport(module)\" \ndata-ui-sref=\"app.export({module:\'{{module}}\'})\"><md-tooltip md-direction=\"left\">Exportar resultado de búsqueda\n</md-tooltip><md-icon md-font-icon=\"icon-export\"></md-icon></md-button><md-button aria-label=\"Envío avanzado\" \nclass=\"md-fab md-raised md-mini\" data-ng-if=\"hasPermissionSendsAdvances(module)\" \ndata-ui-sref=\"app.sendsAdvances({module:\'{{module}}\'})\"><md-tooltip md-direction=\"left\">\nEnviar email a la búsqueda resultante</md-tooltip><md-icon md-font-icon=\"icon-email\"></md-icon></md-button><md-button \naria-label=\"Envío avanzado\" class=\"md-fab md-raised md-mini\" ng-if=\"vm.hasAdvance\" \ndata-ui-sref=\"app.searchsAdvances({module:\'{{module}}\'})\"><md-tooltip md-direction=\"left\">Búsqueda avanzada\n</md-tooltip><md-icon md-font-icon=\"icon-magnify-plus\"></md-icon></md-button></md-fab-actions></md-fab-speed-dial>\n</div></div>");
$templateCache.put("app/main/sendsAdvances/sendsAdvances.html","<div id=\"sendsAdvances\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-email\"></md-icon><span>Envío avanzado</span></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll>\n<form name=\"mailForm\" class=\"md-inline-form\" novalidate><md-input-container flex=\"100\" \nclass=\"md-icon-float md-icon-right md-block\"><label data-translate>Destinatarios</label><md-select \nng-model=\"vm.mail.receivers\" multiple=\"multiple\" required class=\"simplified no-margin\" aria-label=\"destinatarios\">\n<md-option ng-repeat=\"(value,text) in vm.receivers\" ng-value=\"value\">{{text[0]}}</md-option></md-select><error-messages\n field=\"mailForm.receivers\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container \nflex=\"100\" class=\"md-icon-float md-icon-right md-block\"><input type=\"text\" name=\"subject\" \ndata-ng-model=\"vm.mail.subject\" placeholder=\"{{\'Titulo\' | translate}}\" required><error-messages \nfield=\"mailForm.subject\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div \nclass=\"md-input-container\"><div><label data-translate>Mensaje:</label></div><text-angular name=\"message\" \nta-toolbar=\"vm.taToolbar\" data-ng-model=\"vm.mail.message\" class=\"pb-32\" required></text-angular></div>\n<md-input-container flex=\"100\"><error-messages field=\"mailForm.message\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container><div class=\"text-center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.sendMail()\" class=\"md-button md-primary md-raised\" \ndata-ng-disabled=\"mailForm.$invalid || mailForm.$pristine\" aria-label=\"{{\'Enviar\' | translate}}\"><span data-translate>\nEnviar</span></md-button></div></form></md-content></div></div></div>");
$templateCache.put("app/main/skills/skills.html","<div id=\"skills\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-arrange-bring-forward\"></md-icon><span>Competencias</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de competencias:</span> <span>{{vm.skills.count}}</span></div>\n</div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"search pt-10 mr-40\" \ndata-layout=\"row\" data-layout-align=\"start center\"><label class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-flex><input class=\"search-input no-margin\" type=\"text\" \nplaceholder=\"{{ \'Buscar\' | translate}}\" data-ng-model=\"vm.skills.filters.search\" data-flex></label></div><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'skills\',\'POST\')\"><md-button\n class=\"md-raised\" aria-label=\"{{\'Nueva competencia\' | translate}}\" data-ng-click=\"vm.openSkillDialog($event)\"><md-icon\n md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva competencia</span></md-button></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll>\n<div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.skills.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-arrange-bring-forward\"></md-icon><div class=\"message-text\" translate>Sin competencias</div></div>\n</div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"skill in vm.skills.data | itemsPerPage: 10 | orderBy:\'order\'\" data-total-items=\"vm.skills.count\" \ndata-current-page=\"vm.skills.filters.page\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\">{{skill.name}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-arrange-bring-forward\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\" \nng-repeat=\"skillsType in vm.skillsTypes\" ng-if=\"skillsType.id===skill.category\">{{skillsType.name}}</div></div></div>\n</div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'skills\',\'PATCH\')\" \ndata-ng-click=\"vm.openSkillDialog($event, skill)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'skills\',\'DELETE\')\" \ndata-ng-click=\"vm.removeSkill($event, skill)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/tutors/tutors.html","<div id=\"tutors\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-box-outline\"></md-icon><span data-translate>Tutores académicos</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de tutores académicos:</span> <span>{{vm.tutors.count}}</span>\n</div></div><div data-layout=\"row\" data-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" \ndata-layout-align=\"end start\" src=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'tutors\'\">\n</ng-include><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'teachersDegrees\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nuevo tutor\' | translate}}\" data-ng-click=\"vm.openTeachersDegreeDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo tutor</span></md-button></div></div></div>\n<div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.tutors.count == 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-account-box-outline\"></md-icon><div \nclass=\"message-text\" translate>Sin tutores académicos</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-dir-paginate=\"tutor in vm.tutors.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.tutors.count\" data-current-page=\"vm.tutors.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-book-open\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><ng-pluralize \ncount=\"tutor.tutor_degrees.length\" \nwhen=\"{\'0\': \'Titulaciones vinculadas\',\n                                                                             \'one\': \'Una titulación vinculada\',\n                                                                             \'other\': \'{} Titulaciones vinculadas\'}\">\n</ng-pluralize></div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'teachers\',\'GET\')\" \ndata-ui-sref=\"app.teacher({\'id\':\'{{tutor.id}}\'})\"><md-icon class=\"pt-5\" title=\"{{\'Ver detalle\' | translate}}\" \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>Ver detalle</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/tutorscurriculars/tutorscurriculars.html","<div id=\"tutorscurriculars\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box-outline\"></md-icon><span \ndata-translate>Tutores curriculares</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de tutores curriculares:</span> <span>{{vm.tutorscurriculars.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'tutorscurriculars\'\"></ng-include></div></div><div \nclass=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.tutorscurriculars.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account-box-outline\"></md-icon><div class=\"message-text\" translate>Sin tutores curriculares</div>\n</div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"tutor in vm.tutorscurriculars.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.tutorscurriculars.count\" data-current-page=\"vm.tutorscurriculars.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-book-open\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><ng-pluralize \ncount=\"tutor.tutor_degrees.length\" \nwhen=\"{\'0\': \'Titulaciones vinculadas\',\n                                                                             \'one\': \'Una titulación vinculada\',\n                                                                             \'other\': \'{} Titulaciones vinculadas\'}\">\n</ng-pluralize></div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'teachers\',\'GET\')\" \ndata-ui-sref=\"app.teacher({\'id\':\'{{tutor.id}}\'})\"><md-icon class=\"pt-5\" title=\"{{\'Ver detalle\' | translate}}\" \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>Ver detalle</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/tutorsextracurriculars/tutorsextracurriculars.html","<div id=\"tutorsextracurriculars\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box-outline\"></md-icon><span \ndata-translate>Tutores extracurriculares</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de tutores extracurriculares:</span> <span>{{vm.tutorsextracurriculars.count}}</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" \ndata-layout-align=\"end start\" src=\"\'app/main/searchsAdvances/searchsBasics.html\'\" \nng-init=\"module=\'tutorsextracurriculars\'\"></ng-include><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'teachersDegrees\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nuevo tutor\' | translate}}\" data-ng-click=\"vm.openTeachersDegreeDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo tutor</span></md-button></div></div></div>\n<div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.tutorsextracurriculars.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account-box-outline\"></md-icon><div class=\"message-text\" translate>Sin tutores extracurriculares\n</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"tutor in vm.tutorsextracurriculars.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.tutorsextracurriculars.count\" data-current-page=\"vm.tutorsextracurriculars.filters.page\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-book-open\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><ng-pluralize \ncount=\"tutor.tutor_degrees.length\" \nwhen=\"{\'0\': \'Titulaciones vinculadas\',\n                                                                             \'one\': \'Una titulación vinculada\',\n                                                                             \'other\': \'{} Titulaciones vinculadas\'}\">\n</ng-pluralize></div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'teachers\',\'GET\')\" \ndata-ui-sref=\"app.teacher({\'id\':\'{{tutor.id}}\'})\"><md-icon class=\"pt-5\" title=\"{{\'Ver detalle\' | translate}}\" \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>Ver detalle</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/utils/templates/dirPagination.tpl.html","<div class=\"pagination\" ng-if=\"1 < pages.length || !autoHide\"><md-button class=\"md-icon-button\" ng-if=\"boundaryLinks\" \nng-disabled=\"pagination.current == 1\" ng-click=\"setCurrent(1)\" aria-label=\"Ir al inicio\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-if=\"directionLinks\" \nng-disabled=\"pagination.current == 1\" ng-click=\"setCurrent(pagination.current - 1)\" aria-label=\"Anterior\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" \nng-class=\"{ \'md-accent\' : pagination.current == pageNumber, \'md-disabled\' : pageNumber == \'...\'}\" \nng-click=\"setCurrent(pageNumber)\">{{pageNumber}}</md-button><md-button class=\"md-icon-button\" ng-if=\"directionLinks\" \nng-disabled=\"pagination.current == pagination.last\" ng-click=\"setCurrent(pagination.current + 1)\" \naria-label=\"Siguiente\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"boundaryLinks\" ng-disabled=\"pagination.current == pagination.last\" \nng-click=\"setCurrent(pagination.last)\" aria-label=\"Último\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon>\n</md-button></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" data-layout=\"row\" data-layout-align=\"space-between center\"><a \ndata-ui-sref=\"app.notifications\" class=\"logo\" data-layout=\"row\" data-layout-align=\"start center\"><h1 data-hide-xs \ndata-hide-gt-xs data-translate>Universidad de Cadiz</h1><img class=\"open-navigation\" src=\"assets/logo/logo.png\" \nalt=\"{{\'Universidad de Cadiz\' | translate}}\" title=\"{{\'Inicio\' | translate}}\"> <img class=\"close-navigation\" \nsrc=\"assets/logo/logowhite.png\" alt=\"{{\'Logo Universidad de Cadiz\' | translate}}\" title=\"{{\'Inicio\' | translate}}\"></a>\n<md-icon class=\"fold-toggle s18\" data-md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-sm>{{ vm.user.first_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.users\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Mi perfil</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Cerrar sesión</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span>{{lang.title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img class=\"open-navigation\" \nng-src=\"assets/logo/logo-horizontal{{imageDebug}}.jpg\" alt=\"{{\'Universidad de Cadiz\' | translate}}\" \ntitle=\"{{\'Inicio\' | translate}}\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><md-button aria-label=\"help\" ui-sref=\"app.notifications\" hide-xs ng-if=\"vm.getFileHelp()\" \nng-click=\"vm.downloadHelp()\"><md-icon md-font-icon=\"icon-help\" class=\"icon blue-700-fg\"></md-icon><md-tooltip><span \ndata-translate>Manual de ayuda</span></md-tooltip></md-button><div class=\"toolbar-separator\"></div><md-button \naria-label=\"Emails\" ui-sref=\"app.notifications\"><span class=\"badge\" style=\"background: {{getEmailsBadge().color}}\">\n{{vm.notifications.unread_messages}}</span><md-icon md-font-icon=\"icon-bell\" class=\"icon\"></md-icon></md-button><div \nclass=\"toolbar-separator\"></div><md-menu-bar ng-if=\"vm.impersonate\" class=\"no-padding md-orange-500-bg impersonate\">\n<md-menu data-md-position-mode=\"left bottom\"><md-button aria-label=\"impersonate\" data-ng-click=\"$mdOpenMenu()\" \nclass=\"no-margin\"><md-icon md-font-icon=\"icon-account-key\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ndata-ng-click=\"vm.endImpersonate()\" data-translate>Finalizar login simulado</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \ndata-md-position-mode=\"left bottom\"><md-button class=\"user-button\" data-ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\"><span data-layout=\"row\" data-layout-align=\"space-between center\"><span \nclass=\"avatar-wrapper\"><img data-md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" \nalt=\"Imágen de perfil\"> </span><span class=\"username\" data-hide data-show-gt-sm><span>{{ vm.user.name }}</span> <span \nng-repeat=\"(group,groupName) in vm.user.list_groups\" data-ng-if=\"group===vm.user.group_type\">({{groupName}})</span>\n</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" data-hide-xs></md-icon></span></md-button>\n<md-menu-content width=\"3\"><div \ndata-ng-if-start=\"vm.lengthObj(vm.user.list_groups)>1 || (vm.lengthObj(vm.user.list_groups)===1 && !vm.user.list_groups[vm.user.group_type])\" \nclass=\"pl-15\" data-translate>Selecciona un perfil</div><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\" ng-repeat=\"(group,groupName) in vm.user.list_groups\" data-ng-if=\"group!==vm.user.group_type\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"icon\"></md-icon><md-button ng-click=\"vm.changeGroup(group)\">{{groupName}}\n</md-button></md-menu-item><md-menu-divider data-ng-if-end></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button data-ng-click=\"vm.logout()\" data-translate>Cerrar sesión\n</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div data-layout=\"row\" data-layout-align=\"start center\"><div data-layout=\"row\" data-layout-align=\"start center\" \ndata-flex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" data-ng-click=\"vm.toggleSidenav(\'navigation\')\" \ndata-hide-gt-sm aria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"toolbar-separator\"></div></div><div data-layout=\"row\" data-layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" data-ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" \ndata-md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \ndata-md-position-mode=\"left bottom\"><md-button class=\"user-button\" data-ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\"><span data-layout=\"row\" data-layout-align=\"space-between center\"><span \nclass=\"avatar-wrapper\"><img data-md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\" \nalt=\"Imágen de perfil\"> </span><span class=\"username\" data-hide data-show-gt-sm>{{ vm.user.email }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" data-hide-xs></md-icon></span></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \ndata-ng-click=\"vm.logout()\">Cerrar sesión</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div>\n</div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide-sm>{{ vm.user.first_name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ui-sref=\"app.users\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon>\n<md-button>Mi perfil</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Cerrar sesión</md-button>\n</md-menu-item></md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu \nid=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span>{{lang.title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" ng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" \nmd-font-icon=\"icon-backburger\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"></div><span \nclass=\"username\" hide-sm>{{ vm.user.first_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.users\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Mi perfil</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\">\n</md-icon><md-button ng-click=\"vm.logout()\">Cerrar sesión</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span>{{lang.title}}</span></span></md-button></md-menu-item>\n</md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/company/agreementsConditions/agreementsConditions.html","<div layout=\"column\" layout-align=\"start start\" class=\"fullwidth mt-20\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"fullwidth\"><h2 data-translate>Cláusulas de convenio</h2></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"fullwidth\" layout-wrap><div data-layout=\"row\" \ndata-layout-align=\"start center\" data-layout-wrap><md-button data-ng-click=\"vm.getDocument(vm.agreement)\" \nclass=\"send-button md-accent md-raised\" layout=\"row\" aria-label=\"{{\'Descargar en formato PDF\' | translate}}\"><span \ndata-translate>Descargar convenio</span></md-button><md-button data-ng-click=\"vm.printAgreement(vm.agreement, $event)\" \nclass=\"send-button md-accent md-raised\" layout=\"row\" aria-label=\"{{\'Imprimir convenio\' | translate}}\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><span data-translate>Imprimir convenio</span></md-button></div><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \nng-if=\"vm.user.group_type===\'manager\' && vm.agreement.signature_status!==\'signed\' &&\n                    !vm.agreement.document_data && !vm.agreement.agreement_renewal\">\n<md-button ng-click=\"vm.toggleEditable()\" class=\"md-raised md-warn\" \naria-label=\"{{\'Activar edición de cláusulas\' | translate}}\"><span data-ng-if=\"!vm.agreement.editable\" data-translate>\nActivar edición de cláusulas</span> <span data-ng-if=\"vm.agreement.editable\" data-translate>\nVolver a cláusulas originales</span></md-button></div><md-button data-debouce-click ng-click=\"vm.deleteFile()\" \nclass=\"send-button md-warn md-raised\" \ndata-ng-if=\"vm.user.group_type===\'manager\' &&\n                   vm.agreement.document_data &&\n                   vm.agreement.signature_status!==\'signed\' &&\n                   !vm.agreement.agreement_renewal\" \naria-label=\"{{\'Eliminar documento del convenio\' | translate}}\"><span data-translate>Eliminar documento del convenio\n</span></md-button><div id=\"agreement-document-uploader\" \ndata-ng-if=\"hasPermission(\'agreementsDocuments\',\'POST\') && !vm.agreement.agreement_renewal && vm.agreement.signature_status!==\'signed\'\" \ndata-flow-init=\"vm.ngFlowOptions\" data-flow-name=\"vm.agreement.documentsFile\" \ndata-flow-files-submitted=\"$flow.upload()\" flow-file-success=\"vm.uploadFile( $file, $message, $flow )\" data-flow-drop \ndata-flow-drag-enter=\"vm.dropping=true\" data-flow-drag-leave=\"vm.dropping=false\" \ndata-ng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" data-layout=\"column\" \ndata-layout-align=\"center center\"><md-button class=\"md-accent md-raised\" data-layout=\"row\" \naria-label=\"{{\'Subir un nuevo convenio\' | translate}}\" data-flow-btn><md-progress-circular \ndata-ng-repeat=\"file in $flow.files\" data-ng-hide=\"file.isComplete()\" class=\"for-button mr-10\" md-diameter=\"16\" \nmd-mode=\"indeterminate\"></md-progress-circular><span data-translate>Subir un nuevo convenio</span></md-button></div>\n</div></div></div><div class=\"todo-list-pane\" data-ng-if=\"vm.agreement.editable\"><div class=\"todo-items\" \nng-sortable=\"vm.sortableOptions\" ng-model=\"vm.agreementsConditions.data\" \nng-class=\"{\'sortable\': vm.user.group_type===\'manager\' && hasPermission(\'agreementsConditions\',\'PATCH\') && vm.agreement.editable}\">\n<div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-ng-repeat=\"agreementsCondition in vm.agreementsConditions.data | orderBy:\'order\'\" \nng-class=\"{\'orange-100-bg\': agreementsCondition.status == \'pending\',\n                        \'red-100-bg\': (agreementsCondition.status == \'done\' && agreementsCondition.description===\'\') ||\n                                        (agreementsCondition.status == \'pending\' && agreementsCondition.previous_version===\'\') ||\n                                        (agreementsCondition.status == \'rejected\' && agreementsCondition.previous_version===\'\')}\">\n<div class=\"handle\" ng-if=\"!vm.loadOrder\"><md-icon md-font-icon=\"icon-drag-vertical\" class=\"icon\"></md-icon></div><div \nclass=\"handle-load\" data-ng-if=\"agreementsCondition.load\"><md-progress-circular md-diameter=\"20\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"mr-10\" \ndata-ng-if=\"(agreementsCondition.status == \'done\' && agreementsCondition.description===\'\') ||\n                                        (agreementsCondition.status == \'pending\' && agreementsCondition.previous_version===\'\') ||\n                                        (agreementsCondition.status == \'rejected\' && agreementsCondition.previous_version===\'\')\">\n<md-icon md-font-icon=\"icon-close-circle\" class=\"s24 red-fg\"></md-icon><md-tooltip md-direction=\"bottom\"><span \ndata-translate>No aparecerá en el convenio</span></md-tooltip></div><div><div class=\"title\">\n{{agreementsCondition.name}}</div><span class=\"text-boxed m-0 white-fg red-bg\" \ndata-ng-if=\"agreementsCondition.status == \'rejected\'\">Rechazada</span></div></div><div layout=\"row\" \nlayout-align=\"end center\" data-ng-if=\"vm.agreement.editable && hasPermission(\'agreementsConditions\',\'PATCH\')\">\n<md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"agreementsCondition.status!==\'done\' && vm.user.group_type===\'manager\'\" data-debouce-click \ndata-ng-click=\"vm.acceptAgreementsCondition($event, agreementsCondition)\"><md-icon class=\"pt-5 green-900-fg\" \ntitle=\"{{\'Aceptar\' | translate}}\" md-font-icon=\"icon-check\"></md-icon><span class=\"pt-5 green-900-fg\" data-translate>\nAceptar</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"agreementsCondition.status===\'pending\' && vm.user.group_type===\'manager\'\" data-debouce-click \ndata-ng-click=\"vm.rejectAgreementsCondition($event, agreementsCondition)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Rechazar\' | translate}}\" md-font-icon=\"icon-close\"></md-icon><span class=\"pt-5\" data-translate>Rechazar\n</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-click=\"vm.openAgreementsConditionDialog($event, agreementsCondition)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"agreementsCondition.description!==\'\'\" \ndata-ng-click=\"vm.removeAgreementsCondition($event, agreementsCondition)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-trash\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"fullwidth mt-20 mb-20\" layout-wrap \ndata-ng-if=\"vm.agreement.editable && !vm.agreement.document_data && hasPermission(\'agreementsConditions\',\'POST\')\">\n<md-button ng-click=\"vm.openAgreementsConditionDialog()\" class=\"send-button md-accent md-raised\" \naria-label=\"{{\'Añadir cláusula\' | translate}}\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ndata-translate>Añadir cláusula</span></md-button></div>");
$templateCache.put("app/main/company/centers/centers.html","<div id=\"centers\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/company/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-city\"></md-icon><span ng-if=\"UCA_COMPANY_CIF!==vm.form.identification\">Sedes</span> <span \nng-if=\"UCA_COMPANY_CIF===vm.form.identification\">Sede de la UCA</span> <span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\')\" class=\"ml-10\">({{vm.form.business_name}})</span></div><div \nclass=\"count secondary-text\"><span ng-if=\"UCA_COMPANY_CIF!==vm.form.identification\" data-translate>Número de sedes:\n</span> <span ng-if=\"UCA_COMPANY_CIF===vm.form.identification\" data-translate>Número de organismos:</span> <span>\n{{vm.centers.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-layout-wrap><div data-layout=\"row\" data-layout-xs=\"column\" data-layout-align=\"space-between start\" \ndata-layout-wrap data-flex=\"40\"><label class=\"search\" data-layout=\"row\" data-layout-align=\"start center\" data-flex>\n<span data-hide-xs data-hide-gt-xs data-translate>Buscar</span><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nplaceholder=\"{{\'Buscar\' | translate }}\" data-ng-model=\"vm.centers.filters.search\" data-flex></label></div><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'centers\',\'POST\') && \n                                (UCA_COMPANY_CIF!==vm.form.identification || (UCA_COMPANY_CIF==vm.form.identification &&\n                                    vm.user.group_type!==\'company_manager\' && vm.user.group_type!==\'human_resource_manager\'))\">\n<md-button class=\"md-raised\" aria-label=\"{{\'Nueva sede\' | translate}}\" data-ng-click=\"vm.openCenterDialog($event)\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva sede</span></md-button></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.centers.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-city\"></md-icon><div class=\"message-text\" \ntranslate>Sin sedes</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"center in vm.centers.data | itemsPerPage: 10 | orderBy:\'order\'\" data-total-items=\"vm.centers.count\" \ndata-current-page=\"vm.centers.filters.page\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\" ng-if=\"center.name\">{{center.name}}</div><div \nclass=\"title\" ng-if=\"!center.name\" data-translate>Nombre del centro sin definir</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap data-ng-if=\"center.address\"><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"location\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s16\">\n</md-icon><div class=\"tag-label\">{{center.town_data.province_data.name}}</div></div><div class=\"location\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"tag-label\">{{center.town_data.name}}</div></div><div class=\"location\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"tag-label\">{{center.address}}</div></div></div></div></div></div>\n<div layout=\"row\" layout-align=\"center center\" layout-wrap><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'contacts\',\'LIST\') && hasPermission(\'centers\',\'LIST\')\" \ndata-ui-sref=\"app.company.contacts({center:\'{{center.id}}\'})\"><md-icon class=\"pt-5 green-900-fg\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-account-multiple\"></md-icon><span class=\"pt-5 green-900-fg\" \ndata-translate>Contactos</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'centers\',\'PATCH\')\" \ndata-ng-click=\"vm.openCenterDialog($event, center)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'centers\',\'DELETE\')\" \ndata-ng-click=\"vm.removeCenter($event, center)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/company/companyDetail/companyDetail.html","<div id=\"companyDetail-list\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/company/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start start\"><div \nflow-init=\"vm.ngFlowOptionsLogo\" flow-name=\"vm.formFlow.logoFlow\" flow-drop \nflow-file-error=\"vm.imageError($file, $message, $flow)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"content-img\"><md-button flow-btn class=\"md-fab md-mini edit-image md-green-700-bg\" \naria-label=\"{{\'Editar logo de empresa\' | translate }}\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Editar logo de empresa</span></md-tooltip></md-button></div><div><img \nng-if=\"$flow.files[0]\" flow-img=\"$flow.files[0]\" width=\"200px\" class=\"profile-image avatar huge\"> <img \nng-if=\"vm.form.logo && !$flow.files[0]\" class=\"profile-image avatar huge\" ng-src=\"{{vm.form.logo}}\"> <img \nng-if=\"!vm.form.logo && !$flow.files[0]\" src=\"assets/images/avatars/profile.jpg\" \nalt=\"{{\'Logo de empresa\' | translate }}\" class=\"profile-image avatar huge\"></div></div><div class=\"h1 ml-20\" \nlayout=\"column\" layout-align=\"start start\" layout-wrap><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-icon md-font-icon=\"icon-clipboard-text ml-0\"></md-icon><span data-translate>Datos básicos</span> <span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\') && vm.form.agreement_has_expired && vm.form.agreement_signed_only_by ===\'\'\" \nclass=\"ml-10\">{{vm.form.business_name}} (Convenio caducado) </span><span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\') && !vm.form.agreement_has_expired && vm.form.agreement_signed_only_by ===\'\'\" \nclass=\"ml-10\">{{vm.form.business_name}} </span><span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\') && vm.form.agreement_signed_only_by ===\'company\'\" class=\"ml-10\">\n{{vm.form.business_name}} (Firmado por la empresa) </span><span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\') && vm.form.agreement_signed_only_by ===\'uca\'\" class=\"ml-10\">\n{{vm.form.business_name}} (Firmado por la UCA)</span></div><div class=\"red-500-bg mt-10 font-size-16 p-10\" \nng-if=\"vm.form.status===\'not-validated\' || vm.form.status===\'validation-candidate\' || vm.serverErrors.responsible_signing_agreement\" \nlayout=\"column\" layout-align=\"start start\" layout-wrap><div layout=\"row\" layout-align=\"start center\" layout-wrap>\n<md-icon md-font-icon=\"icon-alert ml-0\"></md-icon><span data-translate>Empresa pendiente de validación</span></div>\n<span class=\"ml-35\" ng-if=\"vm.serverErrors.responsible_signing_agreement\">\n{{vm.serverErrors.responsible_signing_agreement[0]}}</span></div><div class=\"red-500-bg mt-10 font-size-16 p-10\" \nng-if=\"vm.form.blocked_up\" layout=\"column\" layout-align=\"start start\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><md-icon md-font-icon=\"icon-alert ml-0\"></md-icon><span data-translate>\nEmpresa bloqueada</span></div><span class=\"ml-35\" ng-if=\"vm.form.block_reason\">{{vm.form.block_reason}}</span></div>\n</div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\"><md-button class=\"md-raised md-primary\" \naria-label=\"{{\'Validar empresa\' | translate}}\" ng-click=\"vm.setValid()\" \nng-if=\"vm.form.status===\'validation-candidate\' &&\n                                    vm.user.group_type===\'manager\' &&\n                                    hasPermission(\'companyList\',\'PATCH\')\">\n<span data-translate>Validar empresa</span></md-button></div><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\"><md-button class=\"md-raised md-warn\" aria-label=\"{{\'Bloquear empresa\' | translate}}\" \ndata-ng-if=\"hasPermission(\'companyBlock\',\'POST\')\" ng-click=\"vm.toggleCompanyBlock()\"><span data-translate \nng-if=\"!vm.form.blocked_up\">Bloquear empresa</span> <span data-translate ng-if=\"vm.form.blocked_up\">Desbloquear empresa\n</span></md-button></div></div></div><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"space-between start\" flex><form name=\"companyDetailForm\" \nclass=\"md-inline-form ms-form-wizard-form full-width\" novalidate><div data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"identification_type\"><label data-translate>\nTipo de identificación</label><md-select data-ng-model=\"vm.form.identification_type\" name=\"identification_type\" \nrequired><md-option data-ng-repeat=\"identification_type in vm.identification_types\" \ndata-ng-value=\"identification_type.id\">{{identification_type.value}}</md-option></md-select><error-messages \nfield=\"companyDetailForm.identification_type\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"identification\"><label data-translate>Identificación</label><input \nname=\"identification\" data-ng-model=\"vm.form.identification\" required><error-messages \nfield=\"companyDetailForm.identification\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container data-ng-if=\"vm.user.group_type===\'manager\'\"><md-checkbox \nng-model=\"vm.form.repeated_id\" aria-label=\"{{\'Id repetido\' | translate}}\" class=\"md-align-top-left\" flex><span \ndata-translate>Id repetido</span></md-checkbox></md-input-container><md-input-container><label data-translate>\nRazón social</label><input name=\"business_name\" data-ng-model=\"vm.form.business_name\" required><error-messages \nfield=\"companyDetailForm.business_name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container><label data-translate>Nombre comercial</label><input name=\"tradename\" \ndata-ng-model=\"vm.form.tradename\"><error-messages field=\"companyDetailForm.tradename\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container></div><div data-layout=\"row\" data-layout-align=\"start center\" layout-wrap>\n<md-input-container><label data-translate>Titularidad</label><md-select data-ng-model=\"vm.form.ownership\" \nname=\"ownership\" required><md-option data-ng-repeat=\"ownership in vm.ownerships\" data-ng-value=\"ownership.id\">\n{{ownership.value}}</md-option></md-select><error-messages field=\"companyDetailForm.ownership\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container><label \ndata-translate>Tipo de empresa</label><md-select data-ng-model=\"vm.form.type\" name=\"type\" required><md-option \ndata-ng-repeat=\"type in vm.types_company\" data-ng-value=\"type.id\">{{type.value}}</md-option></md-select><error-messages\n field=\"companyDetailForm.type\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container><label data-translate>Actividad</label><md-select data-ng-model=\"vm.form.activity\" name=\"activity\" \nmd-on-close=\"vm.searchActivity=\'\'\"><md-select-header class=\"demo-select-header\"><input ng-model=\"vm.searchActivity\" \ntype=\"search\" placeholder=\"{{\'Buscar actividad\' | translate}}\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option data-ng-repeat=\"activity in vm.activities_company | filter:vm.searchActivity\" \ndata-ng-value=\"activity.id\">{{activity.name}}</md-option></md-select><error-messages \nfield=\"companyDetailForm.activity\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div \ndata-layout=\"row\" data-layout-align=\"start center\" layout-wrap><md-input-container><label data-translate>\nCorreo electrónico</label><input name=\"email\" data-ng-model=\"vm.form.email\"><error-messages \nfield=\"companyDetailForm.email\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container><label data-translate>Teléfono</label><input name=\"phone\" data-ng-model=\"vm.form.phone\">\n<error-messages field=\"companyDetailForm.phone\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container><label data-translate>Móvil</label><input name=\"mobile\" data-ng-model=\"vm.form.mobile\">\n<error-messages field=\"companyDetailForm.mobile\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container><label data-translate>Fax</label><input name=\"fax\" data-ng-model=\"vm.form.fax\"><error-messages \nfield=\"companyDetailForm.fax\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div \ndata-layout=\"row\" data-layout-align=\"start center\" layout-wrap><md-input-container class=\"md-block\" flex=\"50\" \nflex-xs=\"100\"><label data-translate>Linea de trabajo</label><textarea ng-model=\"vm.form.work_line\" max-rows=\"5\">\n</textarea><error-messages field=\"companyDetailForm.work_line\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap><h2 data-translate>\nDomicilio social</h2><md-input-container class=\"sede\" ng-if=\"vm.centers.length>0\"><label data-translate>Sede social\n</label><md-select data-ng-model=\"vm.form.business_place_data.id\" name=\"business_place\"><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name}} {{center.address}}</md-option>\n</md-select></md-input-container><md-autocomplete md-floating-label=\"{{\'Sede social\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"business_place\" md-min-length=\"3\" md-selected-item=\"vm.form.business_place_data\" \nmd-search-text=\"searchTextCenter\" ng-if=\"vm.centers.length<1\" md-items=\"center in vm.getCenters(searchTextCenter)\" \nclass=\"fullwidth\" md-item-text=\"vm.getFullNameCenter(center)\" placeholder=\"{{\'Sede social\' | translate}}\">\n<md-item-template><span md-highlight-text=\"searchTextCenter\">{{vm.getFullNameCenter(center)}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ningún centro con ese nombre</span></md-not-found></md-autocomplete>\n<md-input-container class=\"no-margin\"><error-messages field=\"companyDetailForm.business_place\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap><h2 data-translate>Domicilio para notificaciones</h2><md-input-container \nclass=\"sede\" ng-if=\"vm.centers.length>0\"><label data-translate>Sede para notificaciones</label><md-select \ndata-ng-model=\"vm.form.notifications_place_data.id\" name=\"notifications_place\"><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name}} {{center.address}}</md-option>\n</md-select></md-input-container><md-autocomplete md-floating-label=\"{{\'Sede para notificaciones\' | translate}}\" \nmd-delay=\"300\" md-input-name=\"notifications_place\" md-min-length=\"3\" \nmd-selected-item=\"vm.form.notifications_place_data\" md-search-text=\"searchTextCenter\" ng-if=\"vm.centers.length<1\" \nmd-items=\"center in vm.getCenters(searchTextCenter)\" class=\"fullwidth\" md-item-text=\"vm.getFullNameCenter(center)\" \nplaceholder=\"{{\'Sede para notificaciones\' | translate}}\"><md-item-template><span md-highlight-text=\"searchTextCenter\">\n{{vm.getFullNameCenter(center)}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ningún centro con ese nombre</span></md-not-found></md-autocomplete><md-input-container class=\"no-margin\">\n<error-messages field=\"companyDetailForm.notifications_place\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div><md-input-container data-ng-if=\"vm.user.group_type===\'manager\'\"><md-checkbox \nng-model=\"vm.form.annual_offer\" \naria-label=\"{{\'Su oferta de prácticas curriculares pasan de un año al siguiente\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>Su oferta de prácticas curriculares pasan de un año al siguiente\n</span></md-checkbox></md-input-container><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveCompanyDetail()\" class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'companyList\',\'PATCH\')\" ng-disabled=\"userForm.$invalid || userForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></form></div></md-content>\n</div></div></div><script type=\"text/ng-template\" id=\"prompt.html\">\n<md-dialog aria-label=\"prompt\" class=\"task-dialog\">\n        <md-toolbar class=\"md-accent md-hue-2\">\n            <div class=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\">\n                <span class=\"title\">{{vm.prompt.title}}</span>\n                <md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\">\n                    <md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content ms-scroll>\n            <form layout-padding layout=\"column\">\n                <md-input-container>\n                    <label>{{vm.prompt.textContent}}</label>\n                    <textarea name=\"result\" ng-model=\"vm.prompt.result\" max-rows=\"5\"></textarea>\n                </md-input-container>\n            </form>\n        </md-dialog-content>\n        <md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\">\n            <div data-layout=\"row\" data-layout-align=\"start center\">\n                <md-button data-ng-click=\"vm.prompt.save(vm.prompt.result)\" class=\"send-button md-accent md-raised\"\n                           aria-label=\"{{vm.prompt.ok}}\">\n                    <span>{{vm.prompt.ok}}</span>\n                </md-button>\n            </div>\n        </md-dialog-actions>\n    </md-dialog>\n</script>");
$templateCache.put("app/main/company/companyList/companyList.html","<div id=\"companyList\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div class=\"white-fg mb-20\" layout=\"column\" layout-align=\"start start\">\n<div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span>Empresas\n</span></div><div class=\"count secondary-text\"><span data-translate>Número de empresas:</span> <span>\n{{vm.companyList.count}}</span></div></div><div data-layout=\"row\" flex=\"80\" flex-xs=\"100\" \ndata-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'companies\'\"></ng-include></div></div><div \nclass=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.companyList.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-domain\">\n</md-icon><div class=\"message-text\" translate>Sin empresas</div></div></div><div class=\"todo-item\" md-ink-ripple \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.company.detail({id:\'{{company.id}}\'})\" \ndata-dir-paginate=\"company in vm.companyList.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.companyList.count\" data-current-page=\"vm.companyList.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between start\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\" \nng-if=\"company.agreement_has_expired && company.agreement_signed_only_by ===\'\'\">\n{{company.business_name}} (Convenio caducado)</div><div class=\"title\" \nng-if=\"!company.agreement_has_expired  && company.agreement_signed_only_by ===\'\'\">{{company.business_name}}</div><div \nclass=\"title\" ng-if=\"company.agreement_signed_only_by ===\'company\'\">{{company.business_name}} (Firmado por la empresa)\n</div><div class=\"title\" ng-if=\"company.agreement_signed_only_by ===\'uca\'\">\n{{company.business_name}} (Firmado por la UCA)</div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" \nlayout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-table-large\" \nclass=\"s16\"></md-icon><div class=\"ml-10 tag-label\" ng-repeat=\"status in vm.status\" ng-if=\"status.id===company.status\">\n{{status.value}}</div></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'companyList\',\'DELETE\')\" \ndata-ng-click=\"vm.removeCompany($event, company); $event.stopPropagation()\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/company/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/company/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\"></md-icon><span>Contactos</span> <span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\')\" class=\"ml-10\">({{vm.form.business_name}})</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de contactos:</span> <span>{{vm.contacts.count}}</span></div>\n</div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div data-layout=\"row\" \ndata-layout-xs=\"column\" data-layout-align=\"space-between start\" data-layout-wrap><label class=\"search pt-20\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-flex><span data-hide-xs data-hide-gt-xs data-translate>Buscar\n</span><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" \ntype=\"text\" placeholder=\"{{\'Buscar\' | translate }}\" data-ng-model=\"vm.contacts.filters.search\" data-flex></label><div \nclass=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-city\" \nclass=\"white-text icon\"></md-icon><md-select class=\"simplified\" data-ng-model=\"vm.contacts.filters.centers_data.id\" \nng-change=\"vm.centerChange()\" ng-if=\"vm.centers.length>0\" data-placeholder=\"{{\'Seleccione sede\' | translate }}\" \naria-label=\"{{\'Seleccione sede\' | translate }}\"><md-option data-ng-value=\"\">Limpiar filtro</md-option><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name}} {{center.address}}</md-option>\n</md-select><md-autocomplete md-floating-label=\"{{\'Seleccione sede\' | translate}}\" md-delay=\"300\" md-min-length=\"3\" \nmd-selected-item=\"vm.contacts.filters.centers_data\" md-search-text=\"searchTextCenter\" ng-if=\"vm.centers.length<1\" \nmd-items=\"center in vm.getCenters(searchTextCenter)\" class=\"fullwidth\" md-item-text=\"vm.getFullNameCenter(center)\" \nplaceholder=\"{{\'Seleccione sede\' | translate}}\"><md-item-template><span md-highlight-text=\"searchTextCenter\">\n{{vm.getFullNameCenter(center)}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ningún centro con ese nombre</span></md-not-found></md-autocomplete></div></div><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'contacts\',\'POST\') && \n                        (UCA_COMPANY_CIF!==vm.form.identification || (UCA_COMPANY_CIF==vm.form.identification &&\n                         vm.user.group_type!==\'company_manager\' && vm.user.group_type!==\'human_resource_manager\'))\">\n<md-button class=\"md-raised\" aria-label=\"{{\'Nuevo contacto\' | translate}}\" \ndata-ng-click=\"vm.openContactDialog($event)\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ndata-translate>Nuevo contacto</span></md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" \ndata-flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.contacts.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account-multiple\"></md-icon><div class=\"message-text\" translate>Sin contactos</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"contact in vm.contacts.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.contacts.count\" data-current-page=\"vm.contacts.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{contact.name}} {{contact.surname}} {{contact.second_surname}}<div class=\"contact-email\" ng-if=\"contact.user.email\">\n({{contact.user.email}})</div></div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"contact.center.name\"><div class=\"location\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-city\" class=\"s16\"></md-icon><div class=\"tag-label\">\n{{contact.center.name}}</div></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"contact.responsible_signing_agreement==\'single\'\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s16\"></md-icon><div class=\"tag-label\" data-translate>\nResponsable de la empresa con capacidad de firmar el Convenio de Colaboración</div></div><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"contact.responsible_signing_agreement==\'joint\'\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s16\"></md-icon><div class=\"tag-label\" data-translate>\nResponsable de la empresa con capacidad de firmar el Convenio de Colaboración de forma Macomunada</div></div><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\" ng-if=\"contact.company_manager\"><md-icon \nmd-font-icon=\"icon-account\" class=\"s16\"></md-icon><div class=\"tag-label\" data-translate \nng-if=\"UCA_COMPANY_CIF===vm.form.identification\">Gestor de sede</div><div class=\"tag-label\" data-translate \nng-if=\"UCA_COMPANY_CIF!==vm.form.identification\">Gestor administrativo</div></div><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"contact.human_resource_manager\"><md-icon md-font-icon=\"icon-account\" class=\"s16\">\n</md-icon><div class=\"tag-label\" data-translate ng-if=\"UCA_COMPANY_CIF===vm.form.identification\">\nResponsable de orgánica</div><div class=\"tag-label\" data-translate ng-if=\"UCA_COMPANY_CIF!==vm.form.identification\">\nResponsable de recursos humanos</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\" \nng-if=\"contact.professional_tutor\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><div class=\"tag-label\" \ndata-translate>Tutor/a de prácticas</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\" \nng-if=\"contact.agreement_monitoring\"><md-icon md-font-icon=\"icon-account\" class=\"s16\"></md-icon><div class=\"tag-label\" \ndata-translate>Miembro de la comisión de seguimiento del convenio</div></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-debouce-click data-ng-if=\"hasPermission(\'contacts\',\'PATCH\')\" \ndata-ng-click=\"vm.openContactDialog($event, contact)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"vm.user.id!==contact.user.id && hasPermission(\'contacts\',\'DELETE\')\" \ndata-ng-click=\"vm.removeContact($event, contact)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/company/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ui-sref=\"app.company.detail({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"(hasPermission(\'companyDetail\',\'LIST\') ||\n                               hasPermission(\'companyList\',\'GET\')) &&\n                               hasPermission(\'centers\',\'LIST\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.company.centers({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'centers\',\'LIST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" ng-if=\"UCA_COMPANY_CIF===vm.form.identification\" data-translate>\nSedes</span> <span class=\"title\" ng-if=\"UCA_COMPANY_CIF!==vm.form.identification\" data-translate>Sedes</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.company.contacts({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'contacts\',\'LIST\') && hasPermission(\'centers\',\'LIST\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Contactos</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.company.agreements({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'agreements\',\'LIST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Convenios</span></div></md-button><md-divider \ndata-ng-if-end></md-divider></div></md-content>");
$templateCache.put("app/main/demands/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ui-sref=\"app.demands.get.detail({demand:\'{{vm.demand.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'demands\',\'GET\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.demands.get.offersPostulates({demand:\'{{vm.demand.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'offersPostulates\',\'POST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Mis plazas</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.demands.get.demandsCompanies({demand:\'{{vm.demand.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'demandsCompanies\',\'LIST\') && vm.demand.status!==\'draft\'\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Empresas con ofertas</span></div></md-button>\n<md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.list({demand:\'{{vm.demand.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'dossiers\',\'LIST\') && vm.demand.status!==\'draft\'\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Expedientes</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.demands.get.pendingAssignments({demand:\'{{vm.demand.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-show=\"vm.demand.subject_data.students.length>0\" \ndata-ng-if-start=\"hasPermission(\'demandsRequests\',\'POST\') && vm.demand.status!==\'draft\'\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Asignaciones</span></div></md-button><md-divider \ndata-ng-if-end></md-divider></div></md-content>");
$templateCache.put("app/main/dossiers/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.edit({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'dossiers\',\'PATCH\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.detail({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossiers\',\'GET\') && !hasPermission(\'dossiers\',\'PATCH\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.dossierInterruptions({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossierInterruptions\',\'LIST\') && (vm.dossier.status === \'in progress\' ||\n                                                                                    vm.dossier.status === \'closed-without-certificate\' ||\n                                                                                    vm.dossier.status === \'filed\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Interrupciones</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.dossierExtensions({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossierExtensions\',\'LIST\') && !vm.dossier.curricular && (vm.dossier.status === \'in progress\' ||\n                                                                                    vm.dossier.status === \'closed-without-certificate\' ||\n                                                                                    vm.dossier.status === \'filed\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Prórrogas</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.dossierResignations({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossierResignations\',\'LIST\') && (vm.dossier.status === \'in progress\' ||\n                                                                                    vm.dossier.status === \'closed-without-certificate\' ||\n                                                                                    vm.dossier.status === \'filed\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Cancelaciones</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" \ndata-ui-sref=\"app.dossiers.get.answers.questionnaire({dossier:\'{{vm.dossier.id}}\',point:\'{{point.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-repeat-start=\"point in vm.dossier.evaluations_points\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Evaluación</span> <span class=\"title ml-5\" \ndata-ng-if=\"point.final\" data-translate>final</span> <span class=\"title ml-5\" data-ng-if=\"!point.final\" data-translate>\nintermedia</span></div></md-button><div class=\"pl-20 subitems\" ng-if=\"point.evaluations.length>1\"><md-divider \ndata-ng-repeat-start=\"evaluation in point.evaluations\"></md-divider><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" \ndata-ui-sref=\"app.dossiers.get.answers.questionnaire({dossier:\'{{vm.dossier.id}}\',point:\'{{point.id}}\',questionnaire:\'{{evaluation.questionnaire}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-repeat-end><div data-layout=\"row\" data-layout-align=\"start center\"><span \nclass=\"title\" data-translate>{{evaluation.questionnaire_data.name}}</span></div></md-button></div><md-divider \ndata-ng-repeat-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.dossierDocuments({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'dossierDocuments\',\'LIST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Documentación</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.get.dossierQuotes({dossier:\'{{vm.dossier.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'dossierQuotes\',\'LIST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Cotizaciones</span></div></md-button><md-divider \ndata-ng-if-end></md-divider></div></md-content>");
$templateCache.put("app/main/download/sidenavs/download-sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"><div class=\"h1\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-tag\"></md-icon><span>Secciones</span></div></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" \naria-label=\"inbox\" data-ng-repeat-start=\"category in vm.categoriesDownload\" \nng-click=\"vm.selectCategoryDownload(category)\" data-ng-class=\"{\'selected\':vm.categoryDownload==category.pk}\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\">{{category.name}}</span></div></md-button>\n<md-divider data-ng-repeat-end></md-divider></div></md-content>");
$templateCache.put("app/main/evaluations/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ng-repeat-start=\"questionnaire in vm.questionnaires.data\" \ndata-ui-sref=\"app.evaluations.questions({questionnaire:\'{{questionnaire.id}}\'})\" data-ui-sref-active=\"selected\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>{{questionnaire.name}}</span>\n</div></md-button><md-divider data-ng-repeat-end></md-divider></div></md-content>");
$templateCache.put("app/main/events/sidenavs/categories-sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"><div class=\"h1\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-tag\"></md-icon><span>Categorias</span></div></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" \naria-label=\"inbox\" data-ng-repeat-start=\"category in vm.categories.data\" ng-click=\"vm.selectCategory(category)\" \ndata-ng-class=\"{\'selected\':vm.category==category.id}\"><div data-layout=\"row\" data-layout-align=\"start center\"><span \nclass=\"title\">{{category.name}}</span></div></md-button><md-divider data-ng-repeat-end></md-divider></div></md-content>");
$templateCache.put("app/main/offers/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ui-sref=\"app.offer({id:\'{{vm.offer.id}}\'})\" \ndata-ui-sref-active=\"selected\" data-ng-if-start=\"hasPermission(\'offers\',\'GET\') && !hasPermission(\'offers\',\'PATCH\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.offerEdit({id:\'{{vm.offer.id}}\'})\" data-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'offers\',\'PATCH\')\"><div data-layout=\"row\" data-layout-align=\"start center\"><span \nclass=\"title\" data-translate>Datos básicos</span></div></md-button><md-divider data-ng-if-end></md-divider><md-button \nclass=\"item\" aria-label=\"inbox\" data-layout=\"row\" data-layout-align=\"start center\" \ndata-ui-sref=\"app.offersRequests({offer:\'{{vm.offer.id}}\'})\" data-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'offersRequests\',\'LIST\')\"><div data-layout=\"row\" data-layout-align=\"start center\"><span\n class=\"title\" data-translate>Candidatos</span></div></md-button><md-divider data-ng-if-end></md-divider><md-button \nclass=\"item\" aria-label=\"inbox\" data-layout=\"row\" data-layout-align=\"start center\" \ndata-ui-sref=\"app.dossiers.list({offer:\'{{vm.offer.id}}\'})\" data-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossiers\',\'LIST\')\"><div data-layout=\"row\" data-layout-align=\"start center\"><span \nclass=\"title\" data-translate>Expedientes</span></div></md-button><md-divider data-ng-if-end></md-divider></div>\n</md-content>");
$templateCache.put("app/main/pyconfrests/sidenavs/categories-sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"><div class=\"h1\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-tag\"></md-icon><span>Categorias</span></div></div></div>\n<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" \naria-label=\"inbox\" data-ng-repeat-start=\"category in vm.categories.data\" ng-click=\"vm.selectCategory(category)\" \ndata-ng-class=\"{\'selected\':vm.category==category.pk}\"><div data-layout=\"row\" data-layout-align=\"start center\"><span \nclass=\"title\">{{category.name}}</span></div></md-button><md-divider data-ng-repeat-end></md-divider></div></md-content>");
$templateCache.put("app/main/students/myOffersRequests/myOffersRequests.html","<div id=\"myOffersRequests\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"students-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/students/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-multiplication-box\"></md-icon><span>\nSolicitudes de prácticas</span> <span data-ng-if=\"vm.user.group_type===\'manager\'\" class=\"ml-10\">\n({{vm.form.contact_student_data.identification}})</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de solicitudes:</span> <span>{{vm.myOffersRequests.count}}</span></div></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.myOffersRequests.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-multiplication-box\"></md-icon><div \nclass=\"message-text\" translate>Sin solicitudes</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-ng-click=\"vm.go(offer,vm.form, myOffersRequest)\" md-ink-ripple \ndata-dir-paginate=\"myOffersRequest in vm.myOffersRequests.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.myOffersRequests.count\" data-current-page=\"vm.myOffersRequests.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex ng-init=\"offer=myOffersRequest.offer_data\"><div class=\"info\" flex=\"auto\"><div \nlayout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\">{{offer.company.business_name}} -<ng-pluralize \ncount=\"offer.seats\" \nwhen=\"{\'0\': \'Plazas\',\n                                                                     \'one\': \'1 Plaza\',\n                                                                     \'other\': \'{} Plazas\'}\">\n</ng-pluralize></div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-multiplication-box\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span data-translate>Oferta:\n</span> <span>{{offer.id}}</span> <span>{{offer.start_date | date:\'/yyyy\'}}</span></div></div><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\"><span>{{offer.start_date | date:\'dd/MM/yyyy\'}}</span></div></div></div><div class=\"mt-8\"><span \nclass=\"text-boxed m-0 white-fg orange-bg\" \ndata-ng-if=\"myOffersRequest.status === \'signed up\' ||\n                                                                                                                myOffersRequest.status === \'pre-signed up\' ||\n                                                                                                                myOffersRequest.status === \'pre-selected\' ||\n                                                                                                                myOffersRequest.status === \'discarded\'\">\nSolicitud enviada </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"myOffersRequest.status === \'selected\'\">Seleccionado </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"myOffersRequest.status === \'accepted\'\">Has aceptado la oferta </span><span \nclass=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"myOffersRequest.status === \'rejected\'\">Has rechazado la oferta\n</span></div></div></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/students/sidenavs/sidenav.html","<div class=\"header\" data-layout=\"row\" data-layout-align=\"space-between end\" hide-xs hide-sm hide-md><div \nclass=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\"></div></div><md-content ms-scroll \nclass=\"content\" flex><div class=\"navigation-simple\" data-layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-ui-sref=\"app.students.detail({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'studentsDetail\',\'LIST\') ||\n                               hasPermission(\'studentsList\',\'GET\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Datos básicos</span></div>\n</md-button><md-divider data-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.dossiers.list({student:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'dossiers\',\'LIST\') || hasPermission(\'myDossiers\',\'LIST\')\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><span class=\"title\" data-translate>Expedientes</span></div></md-button><md-divider \ndata-ng-if-end></md-divider><md-button class=\"item\" aria-label=\"inbox\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ui-sref=\"app.students.myOffersRequests({id:\'{{vm.form.id}}\'})\" \ndata-ui-sref-active=\"selected\" \ndata-ng-if-start=\"hasPermission(\'myOffersRequests\',\'LIST\') ||\n                                hasPermission(\'offersRequests\',\'LIST\')\">\n<div data-layout=\"row\" data-layout-align=\"start center\"><span class=\"title\" data-translate>Solicitudes de prácticas\n</span></div></md-button><md-divider data-ng-if-end></md-divider></div></md-content>");
$templateCache.put("app/main/students/studentsDetail/student-degrees.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Titulaciones</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openStudentsDegreeDialog($event)\" data-ng-if=\"hasPermission(\'studentsDegrees\',\'POST\')\" \naria-label=\"{{\'Añadir titulación\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.studentsDegrees.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>\nNo hay titulaciones seleccionados</div></div></div></div></div></div></div><div \ndata-ng-repeat=\"studentsDegree in vm.studentsDegrees.data\" class=\"todo-item\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div \nclass=\"mr-50\"><div class=\"title\">{{studentsDegree.id}} - {{studentsDegree.name}}</div><div><span \nclass=\"text-boxed m-0 white-fg indigo-bg\"><span data-translate>Calificación:</span> <span>\n{{studentsDegree.qualification || \"?\"}}</span></span></div></div></div><div layout=\"row\" layout-align=\"end center\">\n<md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'studentsDegrees\',\'DELETE\') && studentsDegree.ste_codalf===\'gades\' \" \ndata-ng-click=\"vm.removeStudentsDegree($event, studentsDegree)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/students/studentsDetail/student-languages.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Idiomas</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openStudentsLanguageDialog($event)\" data-ng-if=\"hasPermission(\'studentsLanguages\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.studentsLanguages.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>No hay idiomas seleccionados\n</div></div></div></div></div></div></div><div data-ng-repeat=\"studentLanguage in vm.studentsLanguages.data\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\">{{studentLanguage.language_data.name}}</div>\n</div><div class=\"tasktable\" flex=\"auto\"><table class=\"simple small\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><md-icon title=\"Lectura\" md-font-icon=\"icon-book-open\"></md-icon></th><th class=\"text-center\">\n<md-icon title=\"Conversación\" md-font-icon=\"icon-account-multiple-outline\"></md-icon></th><th class=\"text-center\">\n<md-icon title=\"Escritura\" md-font-icon=\"icon-pencil\"></md-icon></th></tr></thead><tbody><tr><td class=\"text-center\">\n{{studentLanguage.reading_level | level}}</td><td class=\"text-center\">{{studentLanguage.speaking_level | level}}</td>\n<td class=\"text-center\">{{studentLanguage.writing_level | level}}</td></tr></tbody></table></div></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'studentsLanguages\',\'PATCH\')\" \ndata-ng-click=\"vm.openStudentsLanguageDialog($event, studentLanguage)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'studentsLanguages\',\'DELETE\')\" \ndata-ng-click=\"vm.removeStudentsLanguage($event, studentLanguage)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/students/studentsDetail/student-qualifications.html","<div class=\"mb-20 detail-company\"><md-icon md-font-icon=\"icon-book-open\"></md-icon><span class=\"ml-20\">\n{{qualification.degree.name}}</span></div><div class=\"border-bottom\"><h4 data-translate>Créditos:</h4><span>\n{{qualification.credits_earned*100/qualification.credits_requiered | number:0 }}% ({{qualification.credits_earned}}/{{qualification.credits_requiered}})\n</span></div><div class=\"border-bottom\"><h4 data-translate>Media del expediente:</h4><span>{{qualification.average}}\n</span></div>");
$templateCache.put("app/main/students/studentsDetail/student-skills.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Competencias</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openStudentsSkillDialog($event)\" data-ng-if=\"hasPermission(\'studentsSkills\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.studentsSkills.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>\nNo hay competencias seleccionadas</div></div></div></div></div></div></div><div \nng-repeat=\"studentSkill in vm.studentsSkills.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">{{studentSkill.skill_data.name}}</div><div \nclass=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><strong data-translate>Categoria:</strong><div class=\"ml-10 tag-label\">\n{{studentSkill.skill_data.category_data.name}}</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<strong data-translate>Nivel:</strong><div class=\"ml-10 tag-label\">{{studentSkill.level | level}}</div></div></div>\n</div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'studentsSkills\',\'PATCH\')\" \ndata-ng-click=\"vm.openStudentsSkillDialog($event, studentSkill)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'studentsSkills\',\'DELETE\')\" data-ng-click=\"vm.removeStudentsSkill($event, studentSkill)\">\n<md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" \ndata-translate>Eliminar</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/students/studentsDetail/studentsDetail.html","<div id=\"studentsDetail-list\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"students-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/students/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><div class=\"content-avantar-fotuca\"><img ng-src=\"{{vm.photo}}\" \nalt=\"avatar\" class=\"avatar-fotuca\"></div><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\"><span>\n{{vm.form.contact_student_data.name}} {{vm.form.contact_student_data.surname}} {{vm.form.contact_student_data.second_surname}}\n</span></div><div class=\"count secondary-text\"><md-icon md-font-icon=\"icon-folder-account\" class=\"icon\"></md-icon>\n<span>{{vm.form.contact_student_data.identification}}</span></div><div class=\"count secondary-text\" \nng-if=\"vm.form.contact_student_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.form.contact_student_data.email}}</span></div><div class=\"count secondary-text\" \nng-if=\"vm.form.contact_student_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.form.contact_student_data.phone}}</span></div></div></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" flex><form name=\"studentsDetailForm\" \nclass=\"md-inline-form ms-form-wizard-form full-width\" novalidate><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"space-between start\" layout-wrap><div data-layout=\"column\" data-layout-align=\"start start\" \nlayout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap \nclass=\"fullwidth md-whiteframe-z1 mb-30\" ng-include=\"\'app/main/students/studentsDetail/student-skills.html\'\"></div><div\n data-layout=\"column\" data-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/students/studentsDetail/student-languages.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/students/studentsDetail/student-degrees.html\'\"></div></div><div flex=\"35\" flex-xs=\"100\"><div \nclass=\"md-whiteframe-z1 p-20 mb-40\" ng-repeat=\"qualification in vm.form.contact_student_data.qualifications\" \nng-include=\"\'app/main/students/studentsDetail/student-qualifications.html\'\"></div><div data-layout=\"row\" \ndata-layout-xs=\"column\" class=\"todo-item mb-20\" \nng-show=\"hasPermission(\'studentsList\',\'PATCH\') || vm.form.professional_cv_data\"><div class=\"mr-20\"><p>CV profesional\n</p></div><div data-ng-if=\"hasPermission(\'studentsList\',\'PATCH\')\" flow-init=\"vm.ngFlowOptionsProfessional\" \nflow-name=\"vm.formFlow.logoFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileProfessionalSuccess($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-fab md-mini edit-image\" aria-label=\"{{\'Subir CV profesional\' | translate }}\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><md-tooltip md-direction=\"right\"><span translate>Subir CV profesional</span>\n</md-tooltip></md-button></div></div><div><md-button data-ng-click=\"getDocument(vm.form.professional_cv_data)\" \nclass=\"md-fab md-mini edit-image md-green-700-bg\" ng-if=\"vm.form.professional_cv_data\" \naria-label=\"{{\'Descargar CV profesional\' | translate }}\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Descargar CV profesional</span></md-tooltip></md-button><md-button \ndata-ng-click=\"printDocument(vm.form.professional_cv_data, $event)\" class=\"md-fab md-mini edit-image md-green-700-bg\" \nng-if=\"vm.form.professional_cv_data && isPrintable(vm.form.professional_cv_data)\" \naria-label=\"{{\'Imprimir CV profesional\' | translate }}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Imprimir CV profesional</span></md-tooltip></md-button></div></div><div \ndata-layout=\"row\" data-layout-xs=\"column\" class=\"todo-item mb-20\" \nng-show=\"hasPermission(\'studentsList\',\'PATCH\') || vm.form.researcher_cv_data\"><div class=\"mr-20\"><p>CV investigador</p>\n</div><div data-ng-if=\"hasPermission(\'studentsList\',\'PATCH\')\" flow-init=\"vm.ngFlowOptionsResearcher\" \nflow-name=\"vm.formFlow.logoFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileResearcherSuccess($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-fab md-mini edit-image\" aria-label=\"{{\'Subir CV profesional\' | translate }}\"><md-icon \nmd-font-icon=\"icon-upload\"></md-icon><md-tooltip md-direction=\"right\"><span translate>Subir CV investigador</span>\n</md-tooltip></md-button></div></div><div><md-button data-ng-click=\"getDocument(vm.form.researcher_cv_data)\" \nclass=\"md-fab md-mini edit-image md-green-700-bg\" ng-if=\"vm.form.researcher_cv_data\" \naria-label=\"{{\'Descargar CV investigador\' | translate }}\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Descargar CV investigador</span></md-tooltip></md-button><md-button \ndata-ng-click=\"printDocument(vm.form.researcher_cv_data, $event)\" class=\"md-fab md-mini edit-image md-green-700-bg\" \nng-if=\"vm.form.researcher_cv_data && isPrintable(vm.form.researcher_cv_data)\" \naria-label=\"{{\'Imprimir CV investigador\' | translate }}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Imprimir CV investigador</span></md-tooltip></md-button></div></div><div \ndata-layout=\"column\" data-layout-xs=\"column\" class=\"todo-item mb-20\"><div data-layout=\"row\" \ndata-layout-align=\"space-between start\"><md-input-container flex=\"100\"><label data-translate>Número seguridad social\n</label><input name=\"profile_social_security_number\" type=\"text\" \ndata-ng-model=\"vm.form.profile_social_security_number\"><div class=\"hint\" \ndata-ng-if=\"vm.form.uxxi_social_security_number && vm.form.uxxi_social_security_number !== vm.form.profile_social_security_number\">\n<span data-translate>NAF en UXXI:</span> <span>{{vm.form.uxxi_social_security_number}}</span></div>\n</md-input-container></div><error-messages field=\"studentsDetailForm.profile_social_security_number\" \nserver-errors=\"vm.serverErrors\"></error-messages></div><md-input-container><md-checkbox \nng-model=\"vm.form.active_search\" name=\"active_search\" ng-disabled=\"!hasPermission(\'studentsList\',\'PATCH\')\" \naria-label=\"{{\'Quiero hacer prácticas curriculares\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nQuiero hacer prácticas extracurriculares</span><div class=\"hint\" \nng-show=\"vm.form.active_search && vm.form.active_search_date\" layout=\"row\"><span data-translate>\nBúsqueda activa hasta el</span> <span>{{vm.form.active_search_date | date:\' dd-MM-yyyy\'}}</span></div></md-checkbox>\n<error-messages field=\"studentsDetailForm.active_search\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.saveStudentsDetail()\" class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'studentsList\',\'PATCH\')\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar\n</span></md-button></div></div></div></form></div></md-content></div></div></div>");
$templateCache.put("app/main/students/studentsList/studentsList.html","<div id=\"studentsList\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>Alumnos</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de alumnos:</span> <span>{{vm.studentsList.count}}</span>\n</div></div><div data-layout=\"row\" data-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" \ndata-layout-align=\"end start\" src=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'students\'\">\n</ng-include><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'gadesStudents\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nuevo estudiante\' | translate}}\" data-ng-click=\"vm.openStudentDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo estudiante</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.studentsList.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-account\">\n</md-icon><div class=\"message-text\" translate>Sin alumnos</div></div></div><div class=\"todo-item\" md-ink-ripple \nlayout=\"row\" layout-align=\"start center\" ui-sref=\"app.students.detail({id:\'{{students.id}}\'})\" \ndata-dir-paginate=\"students in vm.studentsList.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.studentsList.count\" data-current-page=\"vm.studentsList.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span>{{students.contact_student_data.identification}} </span><span>- \n</span><span>\n{{students.contact_student_data.name}} {{students.contact_student_data.surname}} {{students.contact_student_data.second_surname}}\n</span></div><div class=\"tags\" layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" data-ng-if=\"students.contact_student_data.email\"><md-icon md-font-icon=\"icon-email\" \nclass=\"s16\"></md-icon><div class=\"ml-10 tag-label\">{{students.contact_student_data.email}}</div></div><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\" data-ng-if=\"students.contact_student_data.phone\"><md-icon \nmd-font-icon=\"icon-phone\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\">{{students.contact_student_data.phone}}\n</div></div></div></div></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"students.contact_student_data.source===\'gades\'\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'gadesStudents\',\'PATCH\')\" \ndata-ng-click=\"vm.openStudentDialog($event, students); $event.stopPropagation()\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'gadesStudents\',\'DELETE\')\" \ndata-ng-click=\"vm.removeStudent($event, students); $event.stopPropagation()\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li data-ng-repeat=\"node in vm.navigation\" data-ms-navigation-node=\"node\" \ndata-ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" data-ng-include=\"\'navigation-nested.html\'\">\n</li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div data-ms-navigation-item data-layout=\"row\" data-ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" data-ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" data-ng-if=\"node.icon\"></i>\n            <span class=\"title\" data-flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" data-ng-style=\"{\'background\': node.badge.color}\" data-ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" data-ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" data-ui-sref=\"{{node.uisref}}\" data-ui-sref-active=\"active md-accent-bg\"\n           data-ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" data-ng-if=\"node.icon\"></i>\n            <span class=\"title\" data-flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" data-ng-style=\"{\'background\': node.badge.color}\" data-ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" data-ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul data-ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li data-ng-repeat=\"node in node.children\" data-ms-navigation-node=\"node\"\n            data-ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            data-ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/actionloggings/dialogs/actionlogging/actionlogging-dialog.html","<md-dialog id=\"actionloggingForm\" class=\"task-dialog\" aria-label=\"New Task\"><form name=\"actionloggingForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \ndata-layout=\"row\" data-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div \nng-repeat=\"(key,value) in vm.actionlogging\"><strong>{{key}}:</strong><pre ng-bind-html=\"value | syntaxHighlight\"></pre>\n</div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-ng-click=\"vm.closeDialog()\" \nclass=\"md-accent md-raised\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Cerrar</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/activities/dialogs/activity/activity-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"activityForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"name\" data-ng-model=\"vm.activity.name\" placeholder=\"{{\'Título de la actividad\' | translate}}\" \nrequired md-autofocus><error-messages field=\"activityForm.name\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveActivity()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"activityForm.$invalid || activityForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/auth/views/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" data-layout=\"column\" ms-scroll><div \nid=\"forgot-password-form-wrapper\" data-layout=\"column\" data-layout-align=\"center center\"><div \nid=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><img ng-src=\"assets/logo/logo-color{{imageDebug}}.png\" \nalt=\"Universidad de Cadiz\"><h1 class=\"title\" data-translate>Recupera tu contraseña</h1><form name=\"forgotPasswordForm\" \nnovalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \ndata-ng-model=\"vm.form.email\" placeholder=\"{{\'Email\' | translate}}\" data-ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ndata-translate>Este campo es obligatorio</span></div><div ng-message=\"pattern\"><span data-translate>\nDebe ser un email válido</span></div></div></md-input-container><md-button data-debouce-click \ndata-ng-click=\"vm.reset()\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \ndata-ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\"><span data-translate>RECUPERAR</span>\n</md-button></form><div class=\"login\" data-layout=\"row\" data-layout-align=\"center center\"><a class=\"link\" \ndata-ui-sref=\"app.auth.login\" data-translate>Volver</a></div></div></div></div>");
$templateCache.put("app/main/auth/views/login/login.html","<div id=\"login\" class=\"flex-scrollable\" data-layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" \ndata-layout=\"column\" data-layout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><img \nng-src=\"assets/logo/logo-color{{imageDebug}}.png\" alt=\"Universidad de Cadiz\"><div layout=\"row\" \nlayout-align=\"space-between center\"><md-button ng-class=\"{\'md-accent\':vm.loginSelected===\'students\'}\" \nng-click=\"vm.loginSelected=\'students\'\"><md-icon md-font-icon=\"icon-account\" md-font-set=\"s60\"></md-icon><p \ndata-translate>Alumnos</p></md-button><md-button ng-class=\"{\'md-accent\':vm.loginSelected===\'companies\'}\" \nng-click=\"vm.loginSelected=\'companies\'\"><md-icon md-font-icon=\"icon-domain\" md-font-set=\"s60\"></md-icon><p \ndata-translate>Empresas</p></md-button><md-button ng-class=\"{\'md-accent\':vm.loginSelected===\'university\'}\" \nng-click=\"vm.loginSelected=\'university\'\"><md-icon md-font-icon=\"icon-bank\" md-font-set=\"s60\"></md-icon><p \ndata-translate>Universidad</p></md-button></div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" \nmd-no-float><input name=\"username\" data-ng-model=\"vm.username\" \nplaceholder=\"{{\'Email o nombre de usuario\' | translate}}\" required><div ng-messages=\"loginForm.username.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span data-translate>Este campo es obligatorio</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \ndata-ng-model=\"vm.password\" placeholder=\"{{\'Contraseña\' | translate}}\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span data-translate>\nEste campo es obligatorio</span></div></div></md-input-container><div class=\"remember-forgot-password\" \ndata-layout=\"column\" data-layout-xs=\"column\" data-layout-align=\"center end\"><a \ndata-ng-if=\"vm.loginSelected===\'companies\' || vm.loginSelected===\'students\'\" data-ui-sref=\"app.auth.forgot\" \nclass=\"forgot-password md-accent-color\" data-translate>¿Olvidaste tu contraseña?</a></div><md-button \ndata-debouce-click data-ng-click=\"vm.login()\" type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"LOG IN\" data-ng-disabled=\"loginForm.$invalid || loginForm.$pristine\"><span data-translate>Entrar</span>\n</md-button><div data-ng-if=\"vm.loginSelected===\'companies\'\"><p data-translate class=\"text-center\">\nAún no estoy registrado como empresa</p><md-button data-ui-sref=\"app.auth.register\" type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Nueva empresa\"><span data-translate>Nueva empresa</span>\n</md-button></div></form></div></div></div>");
$templateCache.put("app/main/auth/views/register/register.html","<div id=\"register\" class=\"flex-scrollable\" data-layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" \ndata-layout=\"column\" data-layout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><img \nng-src=\"assets/logo/logo-color{{imageDebug}}.png\" alt=\"Universidad de Cadiz\"><h1 class=\"title\" data-translate>\nRegistrar nueva empresa</h1><form name=\"registerForm\" novalidate><div data-layout=\"row\" \ndata-layout-align=\"space-between start\"><md-input-container flex=\"45\"><label data-translate>Tipo de identificación\n</label><md-select data-ng-model=\"vm.form.identification_type\" name=\"identification_type\" required><md-option \ndata-ng-repeat=\"identification_type in vm.identification_types\" data-ng-value=\"identification_type.id\">\n{{identification_type.value}}</md-option></md-select><error-messages field=\"registerForm.identification_type\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container flex=\"45\"><label \ndata-translate>Identificación</label><input name=\"identification\" data-ng-model=\"vm.form.identification\" required>\n<error-messages field=\"registerForm.identification\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div><div data-layout=\"row\" data-layout-align=\"space-between start\"><md-input-container \nflex=\"100\"><label data-translate>Razón social</label><input name=\"business_name\" data-ng-model=\"vm.form.business_name\" \nrequired><error-messages field=\"registerForm.business_name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div><div data-layout=\"row\" data-layout-align=\"space-between start\"><md-input-container \nflex=\"45\"><label data-translate>Titularidad</label><md-select data-ng-model=\"vm.form.ownership\" name=\"ownership\" \nrequired><md-option data-ng-repeat=\"ownership in vm.ownerships\" data-ng-value=\"ownership.id\">{{ownership.value}}\n</md-option></md-select><error-messages field=\"registerForm.ownership\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div><div><md-autocomplete md-floating-label=\"{{\'Provincia\' | translate }}\" \nmd-delay=\"300\" md-input-name=\"province\" md-no-cache=\"true\" md-selected-item=\"vm.form.province_data\" \nmd-search-text=\"searchTextProvince\" md-items=\"province in vm.getProvinces(searchTextProvince)\" md-min-length=\"0\" \nmd-item-text=\"province.name\"><md-item-template><span md-highlight-text=\"searchTextProvince\">{{province.name}}</span>\n</md-item-template><md-not-found><span data-translate>No hay ningun provincia con ese nombre</span></md-not-found>\n</md-autocomplete><md-input-container flex=\"100\" class=\"no-margin\"><error-messages field=\"registerForm.province\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div><md-autocomplete \nmd-floating-label=\"{{\'Localidad\' | translate }}\" md-delay=\"300\" md-input-name=\"town\" md-no-cache=\"true\" \nmd-selected-item=\"vm.form.town_data\" md-search-text=\"searchTextLocality\" \nmd-items=\"locality in vm.getLocalities(searchTextLocality)\" md-min-length=\"0\" md-item-text=\"locality.name\">\n<md-item-template><span md-highlight-text=\"searchTextLocality\">{{locality.name}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ninguna localidad</span></md-not-found></md-autocomplete><md-input-container \nflex=\"100\" class=\"no-margin\"><error-messages field=\"registerForm.town\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div><div data-layout=\"row\" data-layout-align=\"space-between start\">\n<md-input-container flex=\"100\"><label data-translate>Dirección</label><input name=\"address\" \ndata-ng-model=\"vm.form.center.address\"><error-messages field=\"registerForm.address\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container></div><div data-layout=\"row\" data-layout-align=\"space-between start\">\n<md-input-container flex=\"100\"><label data-translate>Email de la persona responsable de prácticas en la empresa</label>\n<input name=\"email\" data-ng-model=\"vm.form.contact.email\" required><error-messages field=\"registerForm.email\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div data-layout=\"row\" \ndata-layout-align=\"space-between start\"><md-input-container flex=\"50\"><label data-translate>Contraseña</label><input \ntype=\"password\" name=\"password\" data-ng-model=\"vm.form.contact.password\" required><error-messages \nfield=\"registerForm.password\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"50\"><input match-password=\"password\" type=\"password\" name=\"password2\" \nng-model=\"vm.form.contact.password2\" placeholder=\"Repite la contraseña\"><error-messages field=\"registerForm.password2\" \nserver-errors=\"vm.serverErrors\" password-match></error-messages></md-input-container></div><md-input-container><pre>\n{{vm.privacyPolicy}}</pre><md-checkbox ng-model=\"vm.form.contact.accept_privacy_policy\" \naria-label=\"{{\'Acepto la política de privacidad\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nAcepto la política de privacidad</span></md-checkbox></md-input-container><md-button data-debouce-click \ndata-ng-click=\"vm.register()\" type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \ndata-ng-disabled=\"registerForm.$invalid || registerForm.$pristine\"><span data-translate>Crear empresa</span>\n</md-button></form><div class=\"login\" data-layout=\"row\" data-layout-align=\"center center\"><a class=\"link\" \ndata-ui-sref=\"app.auth.login\" data-translate>Volver</a></div></div></div></div>");
$templateCache.put("app/main/auth/views/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" data-layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \ndata-layout=\"column\" data-layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><img \nng-src=\"assets/logo/logo-color{{imageDebug}}.png\" alt=\"Universidad de Cadiz\"><h1 class=\"title\" data-translate>\nIntroduce tu nueva contraseña</h1><form name=\"resetPasswordForm\" novalidate><div data-layout=\"row\" \ndata-layout-align=\"space-between start\"><md-input-container flex=\"100\"><label data-translate>Contraseña</label><input \ntype=\"password\" name=\"new_password1\" data-ng-model=\"vm.form.new_password1\" required><error-messages \nfield=\"resetPasswordForm.new_password1\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n</div><div data-layout=\"row\" data-layout-align=\"space-between start\"><md-input-container flex=\"100\"><input \nmatch-password=\"new_password1\" type=\"password\" name=\"new_password2\" ng-model=\"vm.form.new_password2\" \nplaceholder=\"Repite la contraseña\" required><error-messages field=\"resetPasswordForm.new_password2\" \nserver-errors=\"vm.serverErrors\" password-match></error-messages></md-input-container></div><md-button \ndata-debouce-click data-ng-click=\"vm.reset()\" type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" data-ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\"><span \ndata-translate>Guardar</span></md-button></form></div></div></div>");
$templateCache.put("app/main/conditionsTemplates/dialogs/conditionsTemplate/conditionsTemplate-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"conditionsTemplateForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"name\" data-ng-model=\"vm.conditionsTemplate.name\" \nplaceholder=\"{{\'Título de la cláusula\' | translate}}\" required md-autofocus><error-messages \nfield=\"conditionsTemplateForm.name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div\n class=\"md-input-container\"><label data-translate>Contenido:</label><md-input-container flex=\"100\"><error-messages \nfield=\"conditionsTemplateForm.description\" server-errors=\"vm.serverErrors\" forcechange></error-messages>\n</md-input-container><text-angular name=\"description\" ta-toolbar=\"vm.taToolbar\" \ndata-ng-model=\"vm.conditionsTemplate.description\" class=\"pb-32\"></text-angular></div><md-input-container \ndata-layout=\"row\" data-layout-align=\"space-between center\"><md-radio-group ng-model=\"vm.conditionsTemplate.type\" \ndata-layout=\"column\"><md-radio-button value=\"curricular\">Curricular</md-radio-button><md-radio-button value=\"both\">\nCurricular y extracurricular</md-radio-button></md-radio-group></md-input-container><md-input-container \nclass=\"md-block\" ng-if=\"vm.conditionsTemplate.id\"><label translate>Orden en el que aparece la cláusula</label><input \nname=\"order\" ng-model=\"vm.conditionsTemplate.order\"><error-messages field=\"conditionsTemplateForm.order\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions \ndata-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\">\n<md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveConditionsTemplate()\" \nclass=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"conditionsTemplateForm.$invalid || conditionsTemplateForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/demands/dialogs/demand/demand-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"demandForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"degree\" md-min-length=\"3\" \nmd-selected-item=\"vm.demand.degree_data\" md-search-text=\"searchTextDegree\" \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"0\" md-autofocus \nmd-item-text=\"vm.getFullNameDegree(degree)\" placeholder=\"{{\'Titulación\' | translate}}\" required \nmd-autocomplete-translate><md-item-template><span md-highlight-text=\"searchTextDegree\">{{vm.getFullNameDegree(degree)}}\n</span></md-item-template><md-not-found><span data-translate>No hay ninguna titulación con ese nombre</span>\n</md-not-found></md-autocomplete><md-autocomplete md-floating-label=\"{{\'Asignatura\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"subject\" md-min-length=\"0\" ng-disabled=\"!vm.demand.degree_data\" md-no-cache=\"true\" \nmd-selected-item-change=\"vm.demand.practice_credits=vm.demand.subject_data.practice_credits\" \nmd-selected-item=\"vm.demand.subject_data\" md-search-text=\"searchTextSubject\" \nmd-items=\"subject in vm.getSubjects(searchTextSubject)\" md-min-length=\"0\" \nmd-item-text=\"vm.getFullNameSubject(subject)\" placeholder=\"{{\'Asignatura\' | translate}}\" required \nmd-autocomplete-translate><md-item-template><span md-highlight-text=\"searchTextSubject\">\n{{vm.getFullNameSubject(subject)}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ninguna asignatura con ese nombre</span></md-not-found></md-autocomplete><md-input-container flex=\"100\">\n<error-messages field=\"demandForm.subject\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container><label data-translate>Créditos</label><input type=\"number\" min=\"0\" \nmax=\"{{vm.demand.subject_data.practice_credits}}\" name=\"practice_credits\" ng-disabled=\"!vm.demand.subject_data\" \ndata-ng-model=\"vm.demand.practice_credits\" required><error-messages field=\"demandForm.practice_credits\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveDemand()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"demandForm.$invalid || demandForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/demands/dialogs/demandsProfile/demandsProfile-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"demandsProfileForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container><label data-translate>\nNombre</label><input name=\"name\" data-ng-model=\"vm.demandsProfile.name\" required><error-messages \nfield=\"demandsProfileForm.name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container class=\"md-block\"><label data-translate>Objetivos</label><textarea name=\"objectives\" \nng-model=\"vm.demandsProfile.objectives\" max-rows=\"5\" required></textarea><error-messages \nfield=\"demandsProfileForm.objectives\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container class=\"md-block\"><label data-translate>Observaciones</label><textarea name=\"observations\" \nng-model=\"vm.demandsProfile.observations\" max-rows=\"5\"></textarea><error-messages \nfield=\"demandsProfileForm.observations\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveDemandsProfile()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"demandsProfileForm.$invalid || demandsProfileForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/demands/dialogs/demandsSchedule/demandsSchedule-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"demandsScheduleForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div><md-input-container class=\"mr-80\"><h4 \ndata-translate>Periodo para inicio</h4><md-datepicker name=\"start_date_start_practices\" \ndata-ng-model=\"vm.demandsSchedule.start_date_start_practices\" md-placeholder=\"dd/mm/yyyy\" required></md-datepicker>\n<error-messages field=\"demandsScheduleForm.start_date_start_practices\" server-errors=\"vm.serverErrors\" forcechange \nrequired></error-messages></md-input-container><md-input-container class=\"mt-70\"><md-datepicker \nname=\"end_date_start_practices\" data-ng-model=\"vm.demandsSchedule.end_date_start_practices\" \nmd-placeholder=\"dd/mm/yyyy\" required></md-datepicker><error-messages \nfield=\"demandsScheduleForm.end_date_start_practices\" server-errors=\"vm.serverErrors\" forcechange required>\n</error-messages></md-input-container></div><div><md-input-container class=\"mr-50\"><label data-translate>Semanas\n</label><input name=\"duration\" data-ng-model=\"vm.demandsSchedule.duration\"> <span class=\"hint\" \nng-if=\"vm.demandsSchedule.duration\">\n{{vm.demandsSchedule.duration}} semanas = {{vm.demandsSchedule.duration}} créditos = {{vm.demandsSchedule.duration*25}} horas\n</span><error-messages field=\"demandsScheduleForm.duration\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><md-input-container><h4 data-translate>Límite fin de prácticas</h4><md-datepicker \nname=\"end_date_practices\" data-ng-model=\"vm.demandsSchedule.end_date_practices\" md-placeholder=\"dd/mm/yyyy\" required>\n</md-datepicker><error-messages field=\"demandsScheduleForm.end_date_practices\" server-errors=\"vm.serverErrors\" \nforcechange required></error-messages></md-input-container></div><md-input-container><label data-translate>Jornada\n</label><md-select data-ng-model=\"vm.demandsSchedule.working_day\" name=\"working_day\" required><md-option \nng-repeat=\"workingday in vm.workingdays\" value=\"{{workingday.id}}\"><span data-translate>{{workingday.value}}</span>\n</md-option></md-select><error-messages field=\"demandsScheduleForm.working_day\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDemandsSchedule()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"demandsScheduleForm.$invalid || demandsScheduleForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/demands/views/detail/demand-profiles.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Perfiles</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openDemandsProfileDialog($event)\" \ndata-ng-if=\"hasPermission(\'demandsProfiles\',\'POST\') && vm.demand.status!==\'filed\'\" \naria-label=\"{{\'Añadir perfil\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.demandsProfiles.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div class=\"title\" \ndata-translate>No hay perfiles añadidos</div></div></div></div><div \nng-repeat=\"demandProfile in vm.demandsProfiles.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between start\" layout-wrap><div class=\"mr-40 mb-10\"><div \nclass=\"title mt-10\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>{{demandProfile.name}}</span></div></div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsProfiles\',\'LIST\') && !hasPermission(\'demandsProfiles\',\'PATCH\')\" \ndata-ng-click=\"vm.openDemandsProfileDialog($event, demandProfile)\"><md-icon class=\"pt-5\" title=\"{{\'Ver\' | translate}}\" \nmd-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>VER</span></md-button><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsProfiles\',\'PATCH\') && vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.openDemandsProfileDialog($event, demandProfile)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsProfiles\',\'DELETE\') && vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.removeDemandsProfile($event, demandProfile)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/demands/views/detail/demand-schedules.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Periodos</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openDemandsScheduleDialog($event)\" \ndata-ng-if=\"hasPermission(\'demandsSchedules\',\'POST\') && vm.demand.status!==\'filed\'\" \naria-label=\"{{\'Añadir periodo\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.demandsSchedules.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div class=\"title\" \ndata-translate>No hay periodos añadidos</div></div></div></div><div \nng-repeat=\"demandSchedule in vm.demandsSchedules.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between start\"><div \nlayout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between start\" layout-wrap><div class=\"mr-40 mb-10\"><span \ndata-translate>Periodo de inicio</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><span>\n{{demandSchedule.start_date_start_practices | date:\'dd/MM/yyyy\'}}</span> <span>-</span> <span>\n{{demandSchedule.end_date_start_practices | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"mr-40 mb-10\"><span \ndata-translate>Semanas</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><span>\n{{demandSchedule.duration}}</span></div></div><div class=\"mr-40 mb-10\"><span data-translate>Límite fin de prácticas\n</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><span>\n{{demandSchedule.end_date_practices | date:\'dd/MM/yyyy\'}}</span></div></div><div><span data-translate>Jornada</span>\n<div class=\"title mt-10\" data-layout=\"row\" data-layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\">\n</md-icon><span ng-repeat=\"workingday in vm.workingdays\" class=\"workingDays ml-10\" \nng-if=\"workingday.id===demandSchedule.working_day\">{{workingday.value}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsSchedules\',\'PATCH\') && vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.openDemandsScheduleDialog($event, demandSchedule)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsSchedules\',\'DELETE\') && vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.removeDemandsSchedule($event, demandSchedule)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/demands/views/detail/demand.html","<div id=\"demand-detail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/demands/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><md-icon \nmd-font-icon=\"icon-multiplication\"></md-icon><span data-translate>Datos básicos</span></div><div \nclass=\"count secondary-text\"><span data-translate>Oferta:</span> <span>{{vm.demand.code}}</span></div></div><div \ndata-layout=\"column\" data-layout-align=\"space-between end\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\"><md-button \ndata-ng-if=\"hasPermission(\'demandsPublished\',\'POST\') && vm.demand.status===\'draft\'\" class=\"md-raised md-primary\" \naria-label=\"{{\'Publicar oferta\' | translate}}\" data-debouce-click ng-click=\"vm.publishDemand()\"><span data-translate>\nPublicar oferta</span></md-button><md-button class=\"md-raised\" data-ng-if=\"hasPermission(\'offersPostulates\',\'POST\')\" \ndata-ui-sref=\"app.demands.get.offersPostulates({id:\'{{vm.demand.id}}\'})\"><span class=\"pt-5\" data-translate>\nAñadir plazas</span></md-button><md-button ng-click=\"vm.discardedAll()\" class=\"md-warn md-raised\" \ndata-ng-if=\"hasPermission(\'demandsRequestsDiscardedAll\',\'POST\') &&\n                                           vm.demand.status!==\'draft\' &&\n                                           vm.demand.seats_method!==vm.demand.assigned\" \naria-label=\"{{\'Descartar plazas no asignadas\' | translate}}\"><span data-translate>Descartar plazas no asignadas</span>\n</md-button></div><div class=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" \nlayout=\"column\" layout-align=\"end end\"><span>{{vm.getFullNameDegree(vm.demand.subject_data.degree)}} </span><span>\n{{vm.getFullNameSubject(vm.demand.subject_data)}}</span></div></div></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div class=\"widget-group mb-40\" layout=\"row\" flex=\"100\" layout-wrap \ndata-ng-if=\"hasPermission(\'demandsPublished\',\'POST\')\"><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-account\"></md-icon><div class=\"h3\" translate>Alumnos</div></div></div><div class=\"pb-8 h1\">\n{{vm.demand.students}}</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-domain\"></md-icon><div class=\"h3\" translate>Empresas con ofertas</div></div></div><div \nclass=\"pb-8 h1\">{{vm.demand.companies}}</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-account-multiple\"></md-icon><div class=\"h3\" translate>Plazas en empresas</div>\n</div></div><div class=\"pb-8 h1\">{{vm.demand.seats_method}}</div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-account-multiple\"></md-icon><div \nclass=\"h3\" translate>alumnos asignados</div></div></div><div class=\"pb-8 h1\">{{vm.demand.assigned}}</div>\n</ms-widget-front></ms-widget></div><div layout=\"column\" layout-xs=\"column\" layout-align=\"space-between start\" flex>\n<form name=\"demandForm\" class=\"md-inline-form ms-form-wizard-form fullwidth\" novalidate><div class=\"mb-20\" \ndata-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"space-between start\" layout-wrap><div \ndata-layout=\"column\" data-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/demands/views/detail/demand-schedules.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/demands/views/detail/demand-profiles.html\'\"></div></div><div class=\"md-whiteframe-z1 p-20\" \nflex=\"35\" flex-xs=\"100\"><md-autocomplete md-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"degree\" md-min-length=\"3\" md-selected-item=\"vm.demand.subject_data.degree\" \nmd-search-text=\"searchTextDegree\" ng-disabled=\"true\" md-items=\"degree in vm.getDegrees(searchTextDegree)\" \nmd-min-length=\"0\" md-item-text=\"vm.getFullNameDegree(degree)\" placeholder=\"{{\'Titulación\' | translate}}\" \nmd-autocomplete-translate><md-item-template><span md-highlight-text=\"searchTextDegree\">{{vm.getFullNameDegree(degree)}}\n</span></md-item-template><md-not-found><span data-translate>No hay ninguna titulación con ese nombre</span>\n</md-not-found></md-autocomplete><md-autocomplete md-floating-label=\"{{\'Asignatura\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"subject\" md-min-length=\"3\" md-selected-item=\"vm.demand.subject_data\" md-search-text=\"searchTextSubject\" \nng-disabled=\"true\" md-items=\"subject in vm.getSubjects(searchTextSubject)\" md-min-length=\"0\" \nmd-item-text=\"vm.getFullNameSubject(subject)\" placeholder=\"{{\'Asignatura\' | translate}}\" md-autocomplete-translate>\n<md-item-template><span md-highlight-text=\"searchTextSubject\">{{vm.getFullNameSubject(subject)}}</span>\n</md-item-template><md-not-found><span data-translate>No hay ninguna asignatura con ese nombre</span></md-not-found>\n</md-autocomplete><div class=\"hint\" layout=\"row\"><span data-translate>Cŕeditos</span> <span>: </span><span>\n{{vm.demand.practice_credits}}</span></div><div class=\"hint\" layout=\"row\" \nng-if=\"vm.degreeCoordinator.teacher_data.full_name\"><span data-translate>Coordinador</span> <span>: </span><span>\n{{vm.degreeCoordinator.teacher_data.full_name}}</span> <span ng-if=\"vm.degreeCoordinator.teacher_data.email\">\n({{vm.degreeCoordinator.teacher_data.email}})</span></div></div></div></form></div></md-content></div></div></div>");
$templateCache.put("app/main/demands/views/demandsCompanies/demandsCompanies.html","<div id=\"demandsCompanies\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/demands/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span data-translate>\nEmpresas con ofertas</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-layout-wrap><div class=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\"><label class=\"search\" \ndata-layout=\"row\" data-layout-align=\"start center\" data-flex><input class=\"search-input no-margin\" type=\"text\" \nplaceholder=\"{{ \'Buscar\' | translate}}\" data-ng-model=\"vm.filters.search\" data-flex></label></div></div><div \nclass=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"column\" \nlayout-align=\"end end\"><span>{{vm.getFullNameDegree(vm.demand.subject_data.degree)}} </span><span>\n{{vm.getFullNameSubject(vm.demand.subject_data)}}</span></div></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.demandsCompanies.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-domain\"></md-icon><div class=\"message-text\" \ntranslate>Sin empresas</div></div></div><div class=\"todo-item pointer\" layout=\"row\" layout-align=\"start center\" \nmd-ink-ripple data-ui-sref=\"app.demands.get.offersPostulates({id:\'{{vm.demand.id}}\',company:\'{{demandsCompany.id}}\'})\" \nng-repeat=\"demandsCompany in vm.demandsCompanies.data | filter:vm.filters.search\" ng-if=\"demandsCompany.id\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{demandsCompany.name}}</div><div class=\"tags\" layout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\"><span data-translate>Plazas:</span> <span>{{demandsCompany.postulated_offers}}</span></div>\n</div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\">\n</md-icon><div class=\"ml-10 tag-label\"><span data-translate>Asignadas:</span> <span>{{demandsCompany.assigned_places}}\n</span></div></div></div></div></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/demands/views/list/demands.html","<div id=\"demands\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-multiplication\"></md-icon><span>Ofertas</span></div><div class=\"count secondary-text\"><span\n data-translate>Número de ofertas:</span> <span>{{vm.demands.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nng-if=\"!vm.myDemands\" src=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'demands\'\"></ng-include><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'demands\',\'POST\')\">\n<md-button class=\"md-raised\" aria-label=\"{{\'Nueva oferta\' | translate}}\" data-ng-click=\"vm.openDemandDialog($event)\">\n<md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Añadir nueva asignatura de prácticas\n</span></md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content \nclass=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div \nclass=\"no-results text-center\" ng-if=\"vm.demands.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-multiplication\"></md-icon><div class=\"message-text\" translate>Sin ofertas</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" md-ink-ripple \nng-class=\"{\'pointer\':hasPermission(\'demands\',\'GET\')}\" data-ui-sref=\"app.demands.get.detail({demand:\'{{demand.id}}\'})\" \ndata-dir-paginate=\"demand in vm.demands.data | itemsPerPage: 10 | orderBy:\'order\'\" data-total-items=\"vm.demands.count\" \ndata-current-page=\"vm.demands.filters.page\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\">\n{{demand.subject_data.degree.name}} - {{demand.subject_data.name}}</div><div class=\"tags\" layout=\"column\" \nlayout-align=\"start start\" layout-wrap><div layout=\"row\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-multiplication\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span data-translate>\nOferta:</span> <span>{{demand.code}}</span></div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account-multiple\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><ng-pluralize \ncount=\"demand.seats_method\" \nwhen=\"{\'0\': \'Plazas\',\n                                                                                 \'one\': \'1 Plaza\',\n                                                                                 \'other\': \'{} Plazas\'}\">\n</ng-pluralize></div><md-tooltip md-direction=\"bottom\">Plazas ofertadas</md-tooltip></div><div class=\"tag\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\"><span>{{demand.companies}}</span></div><md-tooltip md-direction=\"bottom\">Número de empresas\n</md-tooltip></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-account-multiple\" class=\"green-900-fg s16\"></md-icon><div class=\"ml-10 tag-label green-900-fg\">\n<span>{{demand.assigned}}</span></div><md-tooltip md-direction=\"bottom\">Plazas asignadas</md-tooltip></div><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"red-900-fg s16\"></md-icon><div class=\"ml-10 tag-label red-900-fg\"><span \nng-if=\"demand.seats_method-demand.assigned>0\">{{demand.seats_method-demand.assigned}}</span> <span \nng-if=\"demand.seats_method-demand.assigned<1\">0</span></div><md-tooltip md-direction=\"bottom\">Plazas sin asignar\n</md-tooltip></div></div><span class=\"mt-8 text-boxed m-0 white-fg orange-bg\" data-ng-if=\"demand.status === \'draft\'\">\nNo publicada </span><span class=\"mt-8 text-boxed m-0 white-fg green-bg\" data-ng-if=\"demand.status === \'published\'\">\nPublicada </span><span class=\"mt-8 text-boxed m-0 white-fg green-bg\" data-ng-if=\"demand.status === \'filed\'\">Finalizada\n</span></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'demands\',\'DELETE\')\" \ndata-ng-click=\"vm.removeDemand($event, demand); $event.stopPropagation()\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/demands/views/pendingAssignments/pendingAssignments.html","<div id=\"pendingAssignments\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/demands/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><span data-translate>Asignaciones pendientes</span></div></div><div \nlayout=\"column\" layout-align=\"end end\"><div class=\"white-fg mb-20\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h3\" layout=\"column\" layout-align=\"end end\"><span>{{vm.getFullNameDegree(vm.demand.subject_data.degree)}} </span>\n<span>{{vm.getFullNameSubject(vm.demand.subject_data)}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"space-between center\" data-layout-wrap><div class=\"search pt-10\" data-layout=\"row\" \ndata-layout-align=\"start center\"><label class=\"search\" data-layout=\"row\" data-layout-align=\"start center\" data-flex>\n<input class=\"search-input no-margin\" type=\"text\" placeholder=\"{{ \'Buscar\' | translate}}\" \ndata-ng-model=\"vm.filters.search\" data-flex></label></div><div class=\"search pt-10\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-sort\" class=\"white-text icon\"></md-icon><md-icon \nmd-font-icon=\"icon-account\" class=\"white-text icon ml-5\"></md-icon><md-select ng-model=\"vm.orders.student\" \nplaceholder=\"Ordenar alumnos por\" class=\"simplified\" aria-label=\"filtro\"><md-option value=\"\" data-translate>\nLimpiar orden</md-option><md-option value=\"town_name\" data-translate>Municipio</md-option><md-option \nvalue=\"qualification.average\" data-translate>Nota media</md-option></md-select></div><div class=\"search pt-10\" \ndata-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-sort\" class=\"white-text icon\"></md-icon>\n<md-icon md-font-icon=\"icon-domain\" class=\"white-text icon ml-5\"></md-icon><md-select ng-model=\"vm.orders.company\" \nplaceholder=\"Ordenar empresas por\" class=\"simplified\" aria-label=\"filtro\"><md-option value=\"\" data-translate>\nLimpiar orden</md-option><md-option value=\"seat_data.town_data.name\" data-translate>Municipio</md-option><md-option \nvalue=\"students\" data-translate>Alumnos asignados</md-option></md-select></div><div class=\"search pt-10\" \ndata-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"white-text icon\">\n</md-icon><md-select ng-model=\"vm.filters.assignments\" placeholder=\"Filtrar\" class=\"simplified\" aria-label=\"filtro\">\n<md-option value=\"\" data-translate>Limpiar filtro</md-option><md-option value=\"without-assignments\" data-translate>\nSin asignaciones</md-option><md-option value=\"with-assignments\" data-translate>Con asignaciones</md-option></md-select>\n</div><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'demandsRequestsCreateDossier\',\'POST\') && vm.demand.status!==\'filed\'\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Crear expedientes\' | translate}}\" data-debouce-click \ndata-ng-click=\"vm.createDossiers()\"><md-icon md-font-icon=\"icon-document\"></md-icon><span data-translate>\nCrear expedientes</span></md-button></div></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex>\n<md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div \nclass=\"no-results text-center\" ng-if=\"vm.students.length == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-account\"></md-icon><div class=\"message-text\" data-translate>Sin resultados</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"student in vm.students | orderBy:vm.orders.student | filter:vm.filters.search\" \nng-if=\"(vm.filters.assignments===\'with-assignments\' && student.offer_data) ||\n                         (vm.filters.assignments===\'without-assignments\' && !student.offer_data) ||\n                         (!vm.filters.assignments)\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"title\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>{{student.identification}} </span><span>- \n</span><span>{{student.name}} {{student.surname}} {{student.second_surname}}</span></div><div class=\"tags\" \nlayout=\"row\" layout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\" \ndata-ng-if=\"student.town_name\"><md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\">{{student.town_name}}</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-school\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span data-translate>Nota media:\n</span> <span data-ng-if=\"student.qualification.average != null && student.qualification.average !== \'\'\">\n{{student.qualification.average | number:1}}</span> <span \ndata-ng-if=\"student.qualification.average == null || student.qualification.average === \'\'\">&mdash;</span></div></div>\n<div class=\"mt-5\" data-ng-if=\"student.has_dossier\"><span class=\"text-boxed m-0 white-fg green-bg\" data-translate>\nCon expediente creado</span></div></div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap \nng-if=\"student.offer_data\"><div layout=\"row\" layout-align=\"start center\"><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\">\n<span>{{student.offer_data.seat_data.company_name}} ({{student.offer_data.seat_data.town_data.name}})</span></div>\n</div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\" class=\"s16\">\n</md-icon><div class=\"ml-10 tag-label\"><span>{{student.offer_data.demand_profile_name}}</span></div></div><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-box\" class=\"s16\"></md-icon>\n<div class=\"ml-10 tag-label\"><span data-translate>Tutor profesional:</span> <span \ndata-ng-if=\"student.offer_data.professional_tutor_data\">\n{{student.offer_data.professional_tutor_data.name}} {{student.offer_data.professional_tutor_data.surname}} {{student.offer_data.professional_tutor_data.second_surname}} \n</span><span data-translate data-ng-if=\"!student.offer_data.professional_tutor_data\">Sin tutor</span></div></div><div \nclass=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div \nclass=\"ml-10 tag-label\"><span>{{student.offer_data.start_date | date:\'dd/MM/yyyy\'}}</span> <span \nng-repeat=\"workingday in vm.workingdays\" class=\"workingDays ml-10\" \nng-if=\"workingday.id===student.offer_data.schedule_data.working_day\">{{workingday.value}}</span></div></div></div>\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-debouce-click aria-label=\"{{\'Ver expediente\' | translate}}\" \ndata-ng-if=\"hasPermission(\'dossiers\',\'GET\') &&\n                                                               student.offer_data &&\n                                                               student.offer_data.request_offer_data.dossier\" \nui-sref=\"app.dossiers.get.edit({dossier:\'{{student.offer_data.request_offer_data.dossier}}\'})\"><md-icon \nclass=\"pt-5 green-700-fg\" title=\"{{\'Ver expediente\' | translate}}\" md-font-icon=\"icon-document\"></md-icon><span \nclass=\"pt-5 green-700-fg\" data-translate>Ver expediente</span></md-button><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-debouce-click aria-label=\"{{\'Crear expediente\' | translate}}\" \ndata-ng-if=\"hasPermission(\'demandsRequestsCreateDossier\',\'POST\') &&\n                                                               student.offer_data &&\n                                                               !student.offer_data.request_offer_data.dossier &&\n                                                               vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.createDossier(student)\"><md-icon class=\"pt-5 green-700-fg\" \ntitle=\"{{\'Crear expediente\' | translate}}\" md-font-icon=\"icon-document\"></md-icon><span class=\"pt-5 green-700-fg\" \ndata-translate>Crear expediente</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-debouce-click aria-label=\"{{\'Asignar empresa\' | translate}}\" \ndata-ng-if=\"hasPermission(\'demandsRequests\',\'GET\') &&\n                                                   !student.offer_data.request_offer_data.dossier &&\n                                                   vm.demand.status!==\'filed\'\" \nng-click=\"vm.openpendingAssignmentDialog($event,student)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Asignar empresa\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate \nng-if=\"!student.offer_data\">Asignar empresa</span> <span class=\"pt-5\" data-translate ng-if=\"student.offer_data\">\nModificar asignación</span></md-button><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" aria-label=\"{{\'Eliminar asignación\' | translate}}\" \ndata-ng-if=\"hasPermission(\'demandsRequests\',\'DELETE\') &&\n                                                               student.offer_data &&\n                                                               !student.offer_data.request_offer_data.dossier &&\n                                                               vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.removependingAssignment($event, student)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar asignación\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>\nEliminar asignación</span></md-button></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/demands/views/offersPostulates/offersPostulates.html","<div id=\"offersPostulates\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/demands/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon><span \ndata-ng-if=\"!hasPermission(\'demandsCompanies\',\'LIST\')\">Mis plazas</span> <span \ndata-ng-if=\"hasPermission(\'demandsCompanies\',\'LIST\')\">Plazas ({{vm.offersPostulates.data[0].seat_data.company_name}})\n</span></div><div class=\"count secondary-text\"><span data-translate>Número de plazas:</span> <span>\n{{vm.offersPostulates.count}}</span></div></div><div class=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\">\n<div class=\"h3\" layout=\"column\" layout-align=\"end end\"><span>{{vm.getFullNameDegree(vm.demand.subject_data.degree)}} \n</span><span>{{vm.getFullNameSubject(vm.demand.subject_data)}}</span></div></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div ng-repeat=\"demandSchedule in vm.demandsSchedules.data\" class=\"todo-item mb-50\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between start\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between start\" layout-wrap><div class=\"mr-40 mb-10\"><span data-translate>Periodo de inicio</span>\n<div class=\"title mt-10\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><span>\n{{demandSchedule.start_date_start_practices | date:\'dd/MM/yyyy\'}}</span> <span>-</span> <span>\n{{demandSchedule.end_date_start_practices | date:\'dd/MM/yyyy\'}}</span></div></div><div class=\"mr-40 mb-10\"><span \ndata-translate>Semanas</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><span>\n{{demandSchedule.duration}}</span> <span class=\"hint\">\n({{demandSchedule.duration}} semanas = {{demandSchedule.duration}} créditos = {{demandSchedule.duration*25}} horas)\n</span></div></div><div class=\"mr-40 mb-10\"><span data-translate>Límite fin de prácticas</span><div \nclass=\"title mt-10\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><span>\n{{demandSchedule.end_date_practices | date:\'dd/MM/yyyy\'}}</span></div></div><div><span data-translate>Jornada</span>\n<div class=\"title mt-10\"><md-icon md-font-icon=\"icon-clock\"></md-icon><span ng-repeat=\"workingday in vm.workingdays\" \nng-if=\"workingday.id===demandSchedule.working_day\">{{workingday.value}}</span></div></div></div></div><md-toolbar \nclass=\"md-accent mt-20\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate><ng-pluralize count=\"filtered.length\" \nwhen=\"{\'0\': \'Plazas\',\n                                                             \'one\': \'1 Plaza\',\n                                                             \'other\': \'{} Plazas\'}\">\n</ng-pluralize></h2><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.openOffersPostulateDialog($event, demandSchedule)\" \ndata-ng-if=\"hasPermission(\'offersPostulates\',\'POST\') && vm.demand.status!==\'filed\'\" \naria-label=\"{{\'Añadir plazas\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth pl-20 md-whiteframe-z1\"><div data-ng-if=\"filtered.length<1\" \nclass=\"todo-item\"><div class=\"title\" data-translate data-ng-if=\"!hasPermission(\'offersPostulates\',\'POST\')\">\nNo hay plazas añadidas para este periodo</div><md-button class=\"md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'offersPostulates\',\'POST\') && vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.openOffersPostulateDialog($event, demandSchedule)\"><span class=\"pt-5\" data-translate>\nAñadir plazas a este periodo</span></md-button></div><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\" \nng-repeat=\"offersPostulate in vm.offersPostulates.data | filter:{ schedule: demandSchedule.id } as filtered\"><div \nlayout=\"row\"><div layout=\"column\" class=\"mr-50 border-bottom\"><strong data-translate ng-if=\"$index==0\" class=\"mb-20\">\nFecha inicio</strong> <span>{{offersPostulate.start_date | date:\'dd/MM/yyyy\'}}</span></div><div layout=\"column\" \nclass=\"mr-50 border-bottom\" ng-if=\"offersPostulate.professional_tutor_data\"><strong data-translate ng-if=\"$index==0\" \nclass=\"mb-20\">Tutor profesional</strong> <span>\n{{offersPostulate.professional_tutor_data.name}} {{offersPostulate.professional_tutor_data.surname}} {{offersPostulate.professional_tutor_data.second_surname}}\n</span></div><div layout=\"column\" class=\"mr-50 border-bottom\" ng-if=\"offersPostulate.seat_data\"><strong data-translate \nng-if=\"$index==0\" class=\"mb-20\">Sede</strong> <span>\n{{offersPostulate.seat_data.name || offersPostulate.seat_data.address}}</span></div><div layout=\"column\" \nclass=\"mr-50 border-bottom\" ng-if=\"offersPostulate.demand_profile_data\"><strong data-translate ng-if=\"$index==0\" \nclass=\"mb-20\">Perfil</strong> <span>{{offersPostulate.demand_profile_data.name}}</span></div><div layout=\"column\" \nclass=\"mr-50 border-bottom\"><strong data-translate ng-if=\"$index==0\" class=\"mb-20\">Nombre y apellidos</strong> <span \ndata-ng-if=\"offersPostulate.request_offer_data.dossier_data.id\">\n{{offersPostulate.request_offer_data.student_data.contact_student_data.name}} {{offersPostulate.request_offer_data.student_data.contact_student_data.surname}} {{offersPostulate.request_offer_data.student_data.contact_student_data.second_surname}} \n</span><span data-ng-if=\"!offersPostulate.request_offer_data.dossier_data.id\" data-translate>{{\'Plaza no asignada\'}}\n</span></div><div layout=\"column\" class=\"mr-50 border-bottom\"><strong data-translate ng-if=\"$index==0\" class=\"mb-20\">\nNIF alumno</strong> <span data-ng-if=\"offersPostulate.request_offer_data.dossier_data.id\">\n{{offersPostulate.request_offer_data.student_data.contact_student_data.identification}} </span><span \ndata-ng-if=\"!offersPostulate.request_offer_data.dossier_data.id\" data-translate>{{\'Plaza no asignada\'}}</span></div>\n<div layout=\"column\" class=\"mr-50 border-bottom\"><strong data-translate ng-if=\"$index==0\" class=\"mb-20\">Observaciones\n</strong> <span data-ng-if=\"offersPostulate.observations\"><span>\n{{offersPostulate.observations | limitTo: 75 }}{{offersPostulate.observations.length > 75 ? \'...\' : \'\'}}</span> <span \ndata-ng-if=\"offersPostulate.observations && offersPostulate.observations.length>75\"><md-button \nclass=\"md-icon-button md-primary\" data-ng-click=\"vm.showObservations($event, offersPostulate.observations)\"><md-icon \ntitle=\"{{\'Ver observaciones\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon></md-button></span></span></div></div>\n<div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'demandsRequestsDiscarded\',\'POST\') &&\n                                                               !offersPostulate.request_offer_data.dossier_data.id &&\n                                                               vm.demand.status!==\'filed\'\" \ndata-ng-click=\"vm.discarded(offersPostulate)\"><md-icon class=\"pt-5\" title=\"{{\'Descartar plaza\' | translate}}\" \nmd-font-icon=\"icon-trash\"></md-icon><span class=\"pt-5\" data-translate>Descartar plaza</span></md-button><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" data-debouce-click \ndata-ng-if=\"hasPermission(\'dossiers\',\'GET\') &&\n                                                                   offersPostulate.request_offer_data.dossier_data.id\" \nui-sref=\"app.dossiers.get.edit({dossier:\'{{offersPostulate.request_offer_data.dossier_data.id}}\'})\"><md-icon \nclass=\"pt-5 green-700-fg\" title=\"{{\'Ver expediente\' | translate}}\" md-font-icon=\"icon-document\"></md-icon><span \nclass=\"pt-5 green-700-fg\" data-translate>Ver expediente</span></md-button></div></div></md-content></div></div></div>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/documents/dialogs/documentPermissions/documentPermissions-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"documentPermissionForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\" \nclass=\"md-icon-float md-icon-right md-block\"><label data-translate>Permisos para:</label><md-select \nng-model=\"vm.documentPermission.roles_permission\" name=\"roles_permission\" multiple=\"multiple\" required \nclass=\"simplified no-margin\" aria-label=\"destinatarios\"><md-option ng-repeat=\"(value,text) in vm.permissions\" \nng-value=\"value\">{{text}}</md-option></md-select><error-messages field=\"documentPermissionForm.roles_permission\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions \ndata-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\">\n<md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveDocumentPermission()\" \nclass=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"documentPermissionForm.$invalid || documentPermissionForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/documents/dialogs/document/document-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"documentForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container \nflex=\"100\"><input type=\"text\" name=\"name\" data-ng-model=\"vm.document.name\" \nplaceholder=\"{{\'Nombre del documento\' | translate}}\" md-autofocus required><error-messages field=\"documentForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container \ndata-layout=\"column\"><md-checkbox ng-model=\"vm.document.curricular\" aria-label=\"{{\'Curricular\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>Curricular</span></md-checkbox></md-input-container>\n<md-input-container data-layout=\"column\"><md-checkbox ng-model=\"vm.document.extracurricular\" \naria-label=\"{{\'Extracurricular\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>Extracurricular\n</span></md-checkbox></md-input-container><div class=\"actions\" layout=\"row\" layout-align=\"center center\"><md-button \ntype=\"button\" class=\"md-accent md-raised\" ng-click=\"vm.openFiles()\"><span data-translate ng-if=\"!vm.document.document\">\nSubir archivo</span> <span data-translate ng-if=\"vm.document.document\">Reemplazar archivo</span></md-button><input \ntype=\"file\" id=\"file-uploader\" ng-show=\"false\" name=\"document\" ng-model=\"vm.document.document\"><error-messages \nfield=\"documentForm.document\" server-errors=\"vm.serverErrors\" required></error-messages></div></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveDocument()\" class=\"send-button md-accent md-raised\" data-ng-disabled=\"documentForm.$invalid\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/documents/dialogs/documentPreview/documentPreview-dialog.html","<md-dialog class=\"document-preview-dialog\" aria-label=\"{{vm.title}}\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\"><span class=\"title\" \ntitle=\"{{vm.title}}\">{{vm.title}}</span><md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\" \naria-label=\"{{\'Cerrar\' | translate}}\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content class=\"preview-content\" flex><div class=\"preview-frame\" \ndata-ng-if=\"vm.canPreview && !vm.printFailed\"><iframe id=\"document-preview-frame\" title=\"{{vm.title}}\"></iframe><div \nclass=\"preview-loading\" data-ng-if=\"!vm.loaded\" data-layout=\"column\" data-layout-align=\"center center\">\n<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"48\"></md-progress-circular></div></div><div \nclass=\"preview-fallback\" data-ng-if=\"!vm.canPreview || vm.printFailed\" data-layout=\"column\" \ndata-layout-align=\"center center\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"s64\"></md-icon><p data-translate>\nSu navegador no puede mostrar el PDF; descárguelo para imprimirlo.</p></div></md-dialog-content><md-dialog-actions \ndata-layout=\"row\" data-layout-align=\"end center\"><md-button data-ng-click=\"vm.closeDialog()\" \naria-label=\"{{\'Cerrar\' | translate}}\"><span data-translate>Cerrar</span></md-button><md-button \ndata-ng-click=\"vm.download()\" aria-label=\"{{\'Descargar\' | translate}}\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n<span data-translate>Descargar</span></md-button><md-button class=\"md-accent md-raised\" \ndata-ng-if=\"vm.canPreview && !vm.printFailed\" data-ng-disabled=\"!vm.loaded\" data-ng-click=\"vm.print()\" \naria-label=\"{{\'Imprimir\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><span data-translate>Imprimir\n</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/documents/views/detail/document.html","<div id=\"document\"></div>");
$templateCache.put("app/main/documents/views/list/documents-list.html","<div id=\"documents\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-file\"></md-icon><span>Documentos</span></div><div class=\"count secondary-text\"><span \ndata-translate>Número de documentos:</span> <span>{{vm.documents.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'documents\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Nueva documento\' | translate}}\" data-ng-click=\"vm.openDocumentDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo documento</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.documents.count == 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-file\"></md-icon><div class=\"message-text\" \ntranslate>Sin documentos</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"document in vm.documents.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.documents.count\" data-current-page=\"vm.documents.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<md-icon md-font-icon=\"icon-file\"></md-icon>{{document.name}}</div></div><span \nclass=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"document.curricular\" data-translate>Curricular </span><span\n class=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"document.extracurricular\" data-translate>Extracurricular\n</span></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'documents\',\'GET\')\" data-ng-click=\"getDocument(document)\">\n<md-icon class=\"pt-5\" title=\"{{\'Descargar\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" \ndata-translate>Descargar</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'documents\',\'GET\') && isPrintable(document)\" data-ng-click=\"printDocument(document, $event)\">\n<md-icon class=\"pt-5\" title=\"{{\'Imprimir\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" \ndata-translate>Imprimir</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'documents\',\'PATCH\')\" \ndata-ng-click=\"vm.openDocumentDialog($event, document)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'documents\',\'DELETE\')\" \ndata-ng-click=\"vm.removeDocument($event, document)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/dossiers/views/detail/dossier-actions.html","<md-button ng-click=\"vm.openDocumentDialog()\" class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersDocuments\',\'POST\') &&\n                                                (vm.dossier.status===\'draft\' || vm.dossier.status===\'confirmed\' || vm.dossier.status===\'signed\') &&\n                                                ((vm.dossier.program_data.student_iban_required && !vm.dossier.iban_student) ||\n                                                (vm.dossier.program_data.student_iban_required && !vm.dossier.iban_student_number) ||\n                                                (vm.dossier.program_data.student_nif_required && !vm.dossier.dni_student) ||\n                                                (vm.dossier.program_data.student_ss_required && !vm.dossier.ss_student))\" \naria-label=\"{{\'Subir documentación requerida\' | translate}}\"><span data-translate>Subir documentación requerida</span>\n</md-button><md-button data-debouce-click type=\"submit\" ng-click=\"vm.acceptDossier()\" \nclass=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersAccept\',\'POST\') && vm.dossier.status===\'signed\'\" \naria-label=\"{{\'Confirmar aceptación del expediente de prácticas\' | translate}}\"><span data-translate>\nConfirmar aceptación del expediente de prácticas</span></md-button><md-button \nng-click=\"vm.confirmDossierProfesionalTutor()\" data-debouce-click class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersConfirmProfesionalTutor\',\'POST\') &&\n                                           vm.dossier.curricular &&\n                                           vm.dossier.status===\'draft\'\" \naria-label=\"{{\'Confirmar\' | translate}}\"><span data-translate>Confirmar</span></md-button><md-button type=\"submit\" \nng-click=\"vm.discardDossier()\" class=\"md-warn md-raised\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'PATCH\') &&\n                                                vm.dossier.status!==\'in progress\' &&\n                                                vm.dossier.status!==\'closed-without-certificate\' &&\n                                                vm.dossier.status!==\'filed\' && !vm.dossier.curricular\" \naria-label=\"{{\'Rechazar oferta\' | translate}}\"><span data-translate>Rechazar oferta</span></md-button><md-button \ntype=\"submit\" ng-click=\"vm.reportRequest()\" class=\"send-button md-accent md-raised\" data-debouce-click \ndata-ng-if=\"hasPermission(\'dossierReportRequests\',\'POST\') &&\n                                                vm.dossier.status!==\'draft\' &&\n                                                vm.dossier.status!==\'confirmed\' &&\n                                                vm.dossier.status!==\'signed\' &&\n                                                vm.dossier.status!==\'filed\' &&\n                                                !vm.dossier.curricular &&\n                                                vm.dossier.evaluations_points.length===0\" \naria-label=\"{{\'Solicitar evaluación\' | translate}}\"><span data-translate>Solicitar evaluación</span></md-button>");
$templateCache.put("app/main/dossiers/views/detail/dossier-company.html","<div class=\"mb-20 detail-company\" data-ng-if=\"!hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\">\n</md-icon><span class=\"ml-20\">{{vm.dossier.offer.company.business_name}}</span></div><div \nui-sref=\"app.company.detail({id:\'{{vm.dossier.offer.company.id}}\'})\" class=\"mb-20 detail-company pointer\" \ndata-ng-if=\"hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span class=\"ml-20\">\n{{vm.dossier.offer.company.business_name}}</span></div><div data-layout=\"column\" data-layout-align=\"start start\" \nlayout-wrap><div class=\"border-bottom fullwidth\"><h2 data-translate>Sede</h2><span>\n{{vm.dossier.seat_data.name}} {{vm.dossier.seat_data.address}}</span></div><div class=\"pl-20 mb-20 mt-20\" \nng-if=\"vm.dossier.seat_data\"><div class=\"secondary-text\" ng-if=\"vm.offer.organic\" \ndata-ng-if=\"vm.offer.company.identification === UCA_COMPANY_CIF && vm.offer.organic.organic_code\"><md-icon \nmd-font-icon=\"icon-assignment\" class=\"icon\"></md-icon><span>\n{{vm.offer.organic.organic_code}} - {{vm.offer.organic.organic_title}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.seat_data.address\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>\n{{vm.dossier.seat_data.address}}</span></div><div class=\"secondary-text\" data-ng-if=\"vm.dossier.seat_data.email\">\n<md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>{{vm.dossier.seat_data.email}}</span></div><div \nclass=\"secondary-text\" data-ng-if=\"vm.dossier.seat_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.seat_data.phone}}</span></div></div></div><div class=\"border-bottom fullwidth\"><h4 \ndata-translate>Departamento / Área</h4><span>{{vm.dossier.department}}</span></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap><h2 data-translate>Contactos</h2><div class=\"border-bottom fullwidth\" \nng-if=\"vm.dossier.professional_tutor_data\"><h4 data-translate>Tutor profesional</h4><span>\n{{vm.dossier.professional_tutor_data.name}} {{vm.dossier.professional_tutor_data.surname}} {{vm.dossier.professional_tutor_data.second_surname}}\n</span></div><div class=\"pl-20 mb-20 mt-20\" ng-if=\"vm.dossier.professional_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.user.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.dossier.professional_tutor_data.user.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.dossier.professional_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.professional_tutor_data.mobile}}</span></div></div><div class=\"border-bottom fullwidth\" \nng-if=\"vm.dossier.academic_tutor_data\"><h4 data-translate>Tutor académico</h4><span>\n{{vm.dossier.academic_tutor_data.name}} {{vm.dossier.academic_tutor_data.surname}} {{vm.dossier.academic_tutor_data.second_surname}}\n</span></div><div class=\"pl-20 mb-20 mt-20\" ng-if=\"vm.dossier.academic_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.dossier.academic_tutor_data.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.dossier.academic_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.academic_tutor_data.mobile}}</span></div></div></div>");
$templateCache.put("app/main/dossiers/views/detail/dossier.html","<div id=\"dossier-detail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\"><div \nclass=\"content-avantar-fotuca\"><img ng-src=\"{{vm.photo}}\" alt=\"avatar\" class=\"avatar-fotuca\"></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span>\n{{vm.dossier.student.contact_student_data.name}} {{vm.dossier.student.contact_student_data.surname}} {{vm.dossier.student.contact_student_data.second_surname}}\n</span></div><div class=\"count secondary-text\" data-ng-if=\"vm.dossier.student.contact_student_data.identification\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"icon\"></md-icon><span>\n{{vm.dossier.student.contact_student_data.identification}}</span></div><div class=\"count secondary-text\" \ndata-ng-if=\"vm.dossier.student.contact_student_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.dossier.student.contact_student_data.email}}</span></div><div class=\"count secondary-text\" \ndata-ng-if=\"vm.dossier.student.contact_student_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon>\n<span>{{vm.dossier.student.contact_student_data.phone}}</span></div></div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"end end\"><div data-layout=\"column\" data-layout-align=\"end end\" class=\"h-100\"><div data-layout=\"row\" \ndata-layout-align=\"end center\" ng-if=\"vm.dossier.student.professional_cv_data\"><md-button \ndata-ng-click=\"getDocument(vm.dossier.student.professional_cv_data)\" class=\"md-raised\" \naria-label=\"{{\'CV profesional\' | translate}}\"><span data-translate>CV profesional</span></md-button><md-button \nclass=\"md-icon-button md-raised\" ng-if=\"isPrintable(vm.dossier.student.professional_cv_data)\" \ndata-ng-click=\"printDocument(vm.dossier.student.professional_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV profesional\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV profesional</span></md-tooltip></md-button></div><div \ndata-layout=\"row\" data-layout-align=\"end center\" ng-if=\"vm.dossier.student.researcher_cv_data\"><md-button \ndata-ng-click=\"getDocument(vm.dossier.student.researcher_cv_data)\" class=\"md-raised\" \naria-label=\"{{\'CV investigador\' | translate}}\"><span data-translate>CV investigador</span></md-button><md-button \nclass=\"md-icon-button md-raised\" ng-if=\"isPrintable(vm.dossier.student.researcher_cv_data)\" \ndata-ng-click=\"printDocument(vm.dossier.student.researcher_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV investigador\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV investigador</span></md-tooltip></md-button></div></div><span><span \nng-if=\"vm.dossier.curricular\" class=\"badge badge-pill badge-primary\">Curricular</span> <span \nng-if=\"!vm.dossier.curricular\" class=\"badge badge-pill badge-success\">Extracurricular</span> <span \nng-if=\"vm.dossier.program_data\">- {{vm.dossier.program_data.name}}</span></span><div class=\"h1\"><span><span \ndata-translate>Expediente </span>( <span \ndata-ng-if=\"(vm.dossier.status === \'draft\' || vm.dossier.status == \'blocked\') && !vm.dossier.is_cancelled\">Borrador \n</span><span data-ng-if=\"vm.dossier.status === \'confirmed\' && !vm.dossier.curricular && !vm.dossier.is_cancelled\">\nPendiente de firma </span><span \ndata-ng-if=\"vm.dossier.status === \'confirmed\' && vm.dossier.curricular && !vm.dossier.is_cancelled\">\nPendiente de confirmar </span><span data-ng-if=\"vm.dossier.status === \'signed\' && !vm.dossier.is_cancelled\">Firmado \n</span><span data-ng-if=\"vm.dossier.status === \'in progress\' && !vm.dossier.is_cancelled\">En proceso </span><span \ndata-ng-if=\"vm.dossier.status === \'closed-without-certificate\' && !vm.dossier.is_cancelled\">Finalizado </span><span \ndata-ng-if=\"vm.dossier.status === \'filed\' && !vm.dossier.is_cancelled\">Finalizado </span><span \ndata-ng-if=\"vm.dossier.is_cancelled\">Cancelado </span><span \ndata-ng-if=\"vm.dossier.status === \'pending-by-at\' && !vm.dossier.is_cancelled\">Completado </span>) </span><span>\n: {{vm.dossier.code}}</span></div><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-layout-wrap ng-include=\"\'app/main/dossiers/views/detail/dossier-actions.html\'\"></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content\n class=\"content p-20\" flex ms-scroll><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" flex><form\n name=\"dossierForm\" class=\"md-inline-form ms-form-wizard-form fullwidth\" novalidate><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"space-between start\" layout-wrap><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start start\" layout-wrap><div class=\"mr-50 border-bottom\"><h4 data-translate>Fecha inicio</h4><span>\n{{vm.dossier.start_date | date:\'dd/MM/yyyy\'}}</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>Fecha fin\n</h4><span>{{vm.dossier.end_date | date:\'dd/MM/yyyy\'}}</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>\nDuración</h4><span>{{vm.dossier.duration_display}}</span></div><div class=\"border-bottom\" \ndata-ng-if=\"!vm.dossier.curricular\"><h4 data-translate>Dotación mensual bruta (€)</h4><span>\n{{vm.dossier.economic_endowment | currency}}</span></div></div><div data-layout=\"column\" \ndata-layout-align=\"space-between center\" layout-wrap class=\"fullwidth\"><div class=\"md-block border-bottom fullwidth\">\n<h4 data-translate>Proyecto formativo (actividades a desarrollar)</h4><span>{{vm.dossier.objectives}}</span></div>\n</div></div><div class=\"md-whiteframe-z1 p-20\" flex=\"35\" flex-xs=\"100\" \nng-include=\"\'app/main/dossiers/views/detail/dossier-company.html\'\"></div></div></form></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/dossiers/views/dossierExtensions/dossierExtensions.html","<div id=\"dossierExtensions\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-brightness-1\"></md-icon><span data-translate>\nPrórrogas</span></div><div class=\"count secondary-text\"><span data-translate>Número de prórrogas:</span> <span>\n{{vm.dossierExtensions.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-layout-wrap><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-ng-if=\"hasPermission(\'dossierExtensions\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Solicitar prórroga\' | translate}}\" data-ng-click=\"vm.openDossierExtensionDialog($event)\"><span \ndata-translate>Solicitar prórroga</span></md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" \ndata-flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.dossierExtensions.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-brightness-1\"></md-icon><div class=\"message-text\" translate>Sin prórrogas</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"dossierExtension in vm.dossierExtensions.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.dossierExtensions.count\" data-current-page=\"vm.dossierExtensions.filters.page\" \nng-class=\"{\'green-100-bg\': dossierExtension.status == \'done\',\n                                    \'red-100-bg\': dossierExtension.status===\'rejected\'}\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"title\"><span data-translate>Se ha solicitado prórroga de las prácticas en el siguiente periodo:</span>\n</div><div layout=\"row\" layout-wrap layout-align=\"start end\"><div class=\"mr-50 border-bottom\"><h4 data-translate>\nFecha inicio</h4><span>{{dossierExtension.start_date | date:\'dd/MM/yyyy\'}}</span></div><div \nclass=\"mr-50 border-bottom\"><h4 data-translate>Fecha fin</h4><span>{{dossierExtension.end_date | date:\'dd/MM/yyyy\'}}\n</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>Duración</h4><span>\n{{dossierExtension.duration_display}}</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>Horas totales\n</h4><span>{{dossierExtension.hours}}</span></div><div class=\"border-bottom\"><h4 data-translate>\nDotación mensual bruta (€)</h4><span>{{dossierExtension.economic_endowment | currency}}</span></div><md-button \nclass=\"md-fab md-mini\" aria-label=\"cofinanciación\" data-ng-if=\"hasPermission(\'dossierCofinancingCalculate\',\'GET\')\" \nng-click=\"vm.cofinancingCalculate(dossierExtension)\"><md-icon md-font-icon=\"icon-calculator\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Calcular cofinanciación</span></md-tooltip></md-button><span class=\"hint\">\n{{dossierExtension.messageCofinance}}</span></div><div class=\"mt-10\" \ndata-ng-if=\"dossierExtension.rejected_message && dossierExtension.status===\'rejected\'\"><strong data-translate>\nMotivo del rechazo:</strong><div>{{dossierExtension.rejected_message}}</div></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div data-ng-if=\"dossierExtension.document\"><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-click=\"getDocument(dossierExtension.document)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Descargar\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" data-translate>Descargar\n</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"isPrintable(dossierExtension.document)\" data-ng-click=\"printDocument(dossierExtension.document, $event)\">\n<md-icon class=\"pt-5\" title=\"{{\'Imprimir\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" \ndata-translate>Imprimir</span></md-button></div><div data-ng-if=\"dossierExtension.acceptance_document\"><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-click=\"getDocument(dossierExtension.acceptance_document)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Descargar documento de aceptación\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" \ndata-translate>Descargar aceptación</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"isPrintable(dossierExtension.acceptance_document)\" \ndata-ng-click=\"printDocument(dossierExtension.acceptance_document, $event)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Imprimir documento de aceptación\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" \ndata-translate>Imprimir aceptación</span></md-button></div><div \ndata-ng-if=\"dossierExtension.adjudication_resolution_document\"><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-click=\"getDocument(dossierExtension.adjudication_resolution_document)\">\n<md-icon class=\"pt-5\" title=\"{{\'Descargar resolución de adjudicación\' | translate}}\" md-font-icon=\"icon-download\">\n</md-icon><span class=\"pt-5\" data-translate>Descargar adjudicación</span></md-button><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-if=\"isPrintable(dossierExtension.adjudication_resolution_document)\" \ndata-ng-click=\"printDocument(dossierExtension.adjudication_resolution_document, $event)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Imprimir resolución de adjudicación\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" \ndata-translate>Imprimir adjudicación</span></md-button></div><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" \ndata-ng-if=\"dossierExtension.adjudication_resolution_can_be_sent && !dossierExtension.adjudication_resolution_sent && vm.user.group_type===\'manager\'\" \ndata-ng-click=\"vm.sendAdjudicationResolution($event, dossierExtension)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Enviar a firma la resolución de adjudicación\' | translate}}\" md-font-icon=\"icon-send\"></md-icon><span \nclass=\"pt-5\" data-translate>Enviar a firma</span></md-button><div layout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"dossierExtension.status!==\'done\' && dossierExtension.status!==\'rejected\'\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierExtensions\',\'PATCH\') &&\n                                                                                dossierExtension.status===\'pending\' &&\n                                                                                dossierExtension.pending_by_role===\'pending_by_uca\'\" \ndata-ng-click=\"vm.openDossierExtensionDialog($event, dossierExtension)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierExtensions\',\'DELETE\') && dossierExtension.status===\'pending\' &&\n                                                                    dossierExtension.pending_by_role===\'pending_by_uca\'\" \ndata-ng-click=\"vm.removeDossierExtension($event, dossierExtension)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Cancelar solicitud\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>\nCancelar solicitud</span></md-button><div layout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"(dossierExtension.pending_by_role===\'pending_by_company\' && (vm.user.group_type===\'company_manager\' || vm.user.group_type===\'human_resource_manager\' )) ||\n                                             (dossierExtension.pending_by_role===\'pending_by_student\' && (vm.user.group_type===\'student\' || vm.user.group_type===\'manager\')) ||\n                                             (dossierExtension.pending_by_role===\'pending_by_uca\' && vm.user.group_type===\'manager\')\">\n<md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierExtensionsAccept\',\'POST\')\" data-debouce-click \ndata-ng-click=\"vm.acceptExtension($event, dossierExtension)\"><md-icon class=\"pt-5\" title=\"{{\'Aceptar\' | translate}}\" \nmd-font-icon=\"icon-check\"></md-icon><span class=\"pt-5\" data-translate>Aceptar</span></md-button></div><div \nlayout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"(dossierExtension.pending_by_role===\'pending_by_company\' && (vm.user.group_type===\'company_manager\' || vm.user.group_type===\'human_resource_manager\' )) ||\n                                             (dossierExtension.pending_by_role===\'pending_by_student\' && vm.user.group_type===\'student\') ||\n                                             (dossierExtension.pending_by_role===\'pending_by_uca\' && vm.user.group_type===\'manager\') ||\n                                             (dossierExtension.status===\'pending-signature\' && vm.user.group_type===\'manager\') ||\n                                             (dossierExtension.pending_by_role===\'pending_by_student\')\">\n<md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierExtensionsReject\',\'POST\')\" \ndata-ng-click=\"vm.rejectExtension($event, dossierExtension)\"><md-icon class=\"pt-5\" title=\"{{\'Rechazar\' | translate}}\" \nmd-font-icon=\"icon-close\"></md-icon><span class=\"pt-5\" data-translate>Rechazar</span></md-button></div></div></div>\n</div></div></div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></md-content>\n</div></div></div><script type=\"text/ng-template\" id=\"prompt.html\">\n<md-dialog aria-label=\"prompt\" class=\"task-dialog\">\n        <md-toolbar class=\"md-accent md-hue-2\">\n            <div class=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\">\n                <span class=\"title\">{{vm.prompt.title}}</span>\n                <md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\">\n                    <md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content ms-scroll>\n            <form layout-padding layout=\"column\">\n                <md-input-container>\n                    <label>{{vm.prompt.textContent}}</label>\n                    <textarea name=\"result\" ng-model=\"vm.prompt.result\" max-rows=\"5\"></textarea>\n                </md-input-container>\n            </form>\n        </md-dialog-content>\n        <md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\">\n            <div data-layout=\"row\" data-layout-align=\"start center\">\n                <md-button data-debouce-click data-ng-click=\"vm.prompt.save(vm.prompt.result)\"\n                           class=\"send-button md-accent md-raised\" aria-label=\"{{vm.prompt.ok}}\">\n                    <span>{{vm.prompt.ok}}</span>\n                </md-button>\n            </div>\n        </md-dialog-actions>\n    </md-dialog>\n</script>");
$templateCache.put("app/main/dossiers/views/dossierDocuments/dossierDocuments.html","<div id=\"dossierDocuments\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file\"></md-icon><span>Documentos</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de documentos:</span> <span>{{vm.dossierDocuments.count}}\n</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'documents\',\'POST\')\">\n<md-button class=\"md-raised\" aria-label=\"{{\'Nueva documento\' | translate}}\" \ndata-ng-click=\"vm.openDocumentDialog($event)\"><md-icon md-font-icon=\"icon-plus-circle-outline\"></md-icon><span \ndata-translate>Nuevo documento</span></md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" \ndata-flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.dossierDocuments.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-file\">\n</md-icon><div class=\"message-text\" translate>Sin documentos</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-ng-repeat=\"dossierDocument in vm.dossierDocuments.data\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<md-icon md-font-icon=\"icon-file\"></md-icon>{{dossierDocument.name}}</div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierDocuments\',\'GET\')\" data-ng-click=\"getDocument(dossierDocument)\"><md-icon \nclass=\"pt-5\" title=\"{{\'Descargar\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" \ndata-translate>Descargar</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierDocuments\',\'GET\') && isPrintable(dossierDocument)\" \ndata-ng-click=\"printDocument(dossierDocument, $event)\"><md-icon class=\"pt-5\" title=\"{{\'Imprimir\' | translate}}\" \nmd-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" data-translate>Imprimir</span></md-button><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'documents\',\'PATCH\') &&\n                                                   (vm.user.id==dossierDocument.user || vm.user.group_type===\'manager\')\" \ndata-ng-click=\"vm.openDocumentDialog($event, dossierDocument)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'documentPermissions\',\'PATCH\')\" \ndata-ng-click=\"vm.openDocumentPermissionDialog($event, dossierDocument)\"><md-icon class=\"pt-5 green-700-fg\" \ntitle=\"{{\'Editar permisos\' | translate}}\" md-font-icon=\"icon-account\"></md-icon><span class=\"pt-5 green-700-fg\" \ndata-translate>Editar permisos</span></md-button><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'documents\',\'DELETE\') &&\n                                                   (vm.user.id==dossierDocument.user || vm.user.group_type===\'manager\')\" \ndata-ng-click=\"vm.removeDocument($event, dossierDocument)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/dossiers/views/dossierInterruptions/dossierInterruptions.html","<div id=\"dossierInterruptions\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-brightness-1\"></md-icon><span>Interrupciones</span></div><div class=\"count secondary-text\">\n<span data-translate>Número de interrupciones:</span> <span>{{vm.dossierInterruptions.count}}</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'dossierInterruptions\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Solicitar interrupcion\' | translate}}\" data-ng-click=\"vm.openDossierInterruptionDialog($event)\"><span \ndata-translate>Solicitar interrupcion</span></md-button></div></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex \nms-scroll><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"vm.dossierInterruptions.count == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-brightness-1\"></md-icon><div class=\"message-text\" translate>Sin interrupciones</div></div></div><div\n class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"dossierInterruption in vm.dossierInterruptions.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.dossierInterruptions.count\" data-current-page=\"vm.dossierInterruptions.filters.page\" \nng-class=\"{\'green-100-bg\': dossierInterruption.status == \'done\',\n                                    \'red-100-bg\': dossierInterruption.status===\'rejected\'}\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"title\"><span data-translate>Se ha solicitado la interrupción de las prácticas en este periodo:</span></div>\n<div class=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\">\n{{dossierInterruption.start_date | date:\'dd/MM/yyyy\'}} - {{dossierInterruption.end_date | date:\'dd/MM/yyyy\'}}</div>\n</div><span class=\"text-boxed white-fg red-bg\" data-translate data-ng-if=\"dossierInterruption.status===\'rejected\'\">\nRechazada </span><span class=\"text-boxed white-fg orange-bg\" data-translate \ndata-ng-if=\"dossierInterruption.status===\'pending-signature\' && vm.user.group_type===\'manager\'\">Pendiente de firma \n</span><span class=\"text-boxed white-fg orange-bg\" data-translate \ndata-ng-if=\"dossierInterruption.status===\'pending\' ||\n                                                      (dossierInterruption.status===\'pending-signature\' && !vm.user.group_type===\'manager\')\">\nEn proceso </span><span class=\"text-boxed white-fg green-bg\" data-translate \ndata-ng-if=\"dossierInterruption.status===\'done\'\">Aceptada</span></div><div class=\"mt-10\" \ndata-ng-if=\"dossierInterruption.rejected_message && dossierInterruption.status===\'rejected\'\"><strong data-translate>\nMotivo del rechazo:</strong><div>{{dossierInterruption.rejected_message}}</div></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><div data-ng-if=\"dossierInterruption.document\"><md-button data-layout=\"column\" \ndata-layout-align=\"start center\" data-ng-click=\"getDocument(dossierInterruption.document)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Descargar\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" data-translate>Descargar\n</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"isPrintable(dossierInterruption.document)\" \ndata-ng-click=\"printDocument(dossierInterruption.document, $event)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Imprimir\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" data-translate>Imprimir\n</span></md-button></div><div layout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"(dossierInterruption.pending_by_role===\'pending_by_company\' && (vm.user.group_type===\'company_manager\' || vm.user.group_type===\'human_resource_manager\' )) ||\n                                             (dossierInterruption.pending_by_role===\'pending_by_student\' && vm.user.group_type===\'student\') ||\n                                             (dossierInterruption.pending_by_role===\'pending_by_vicerector\' && vm.user.group_type===\'manager\')\">\n<md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierInterruptionsAccept\',\'POST\')\" data-debouce-click \ndata-ng-click=\"vm.acceptInterrumption($event, dossierInterruption)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Aceptar\' | translate}}\" md-font-icon=\"icon-check\"></md-icon><span class=\"pt-5\" data-translate>Aceptar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierInterruptionsReject\',\'POST\')\" \ndata-ng-click=\"vm.rejectInterrumption($event, dossierInterruption)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Rechazar\' | translate}}\" md-font-icon=\"icon-close\"></md-icon><span class=\"pt-5\" data-translate>Rechazar\n</span></md-button></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div><script type=\"text/ng-template\" id=\"prompt.html\">\n<md-dialog aria-label=\"prompt\" class=\"task-dialog\">\n        <md-toolbar class=\"md-accent md-hue-2\">\n            <div class=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\">\n                <span class=\"title\">{{vm.prompt.title}}</span>\n                <md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\">\n                    <md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content ms-scroll>\n            <form layout-padding layout=\"column\">\n                <md-input-container>\n                    <label>{{vm.prompt.textContent}}</label>\n                    <textarea name=\"result\" ng-model=\"vm.prompt.result\" max-rows=\"5\"></textarea>\n                </md-input-container>\n            </form>\n        </md-dialog-content>\n        <md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\">\n            <div data-layout=\"row\" data-layout-align=\"start center\">\n                <md-button data-debouce-click data-ng-click=\"vm.prompt.save(vm.prompt.result)\"\n                           class=\"send-button md-accent md-raised\" aria-label=\"{{vm.prompt.ok}}\">\n                    <span>{{vm.prompt.ok}}</span>\n                </md-button>\n            </div>\n        </md-dialog-actions>\n    </md-dialog>\n</script>");
$templateCache.put("app/main/dossiers/views/dossierQuotes/dossierQuotes.html","<div id=\"dossierQuotes\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"main-sidenav\" ng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper>\n</md-sidenav><div class=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file\"></md-icon><span>Cotizaciones</span></div>\n</div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div \nclass=\"pb-10 border-bottom secondary-text\" data-ng-if=\"vm.dossier.exclude_ss_contribution\" data-translate>\nEste expediente no genera cotización a la Seguridad Social (exención marcada en Datos básicos): no genera nuevos días de cotización ni se incluye en el fichero de inscripciones; las cotizaciones ya generadas se conservan.\n</div><div layout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" \ndata-ng-if=\"vm.dossierQuotes.length == 0\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-file\"></md-icon><div class=\"message-text\" translate>Sin cotizaciones</div></div></div><div \nclass=\"todo-item\" layout=\"row\" layout-align=\"start center\" data-ng-repeat=\"dossierQuote in vm.dossierQuotes\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n<strong>{{vm.monthsLabel[dossierQuote.month]}} {{dossierQuote.year}}</strong>,<ng-pluralize \ncount=\"dossierQuote.worked_days\" \nwhen=\"{\'0\': \' Ningún día trabajado.\',\n                       \'one\': \' 1 día trabajado.\',\n                       \'other\': \' {} días trabajados.\'}\">\n</ng-pluralize><br></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" data-ng-click=\"vm.openQuoteDialog($event, dossierQuote)\"><md-icon \nclass=\"pt-5\" title=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>\nEditar</span></md-button></div></div></div></div></div></div></md-content></div></div></div>");
$templateCache.put("app/main/dossiers/views/dossierResignations/dossierResignations.html","<div id=\"dossierResignations\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-brightness-1\"></md-icon><span>Cancelaciones</span></div><div class=\"count secondary-text\">\n<span data-translate>Número de cancelaciones:</span> <span>{{vm.dossierResignations.count}}</span></div></div><div \ndata-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\" data-ng-if=\"hasPermission(\'dossierResignations\',\'POST\')\"><md-button class=\"md-raised\" \naria-label=\"{{\'Solicitar cancelacion\' | translate}}\" \ndata-ng-if=\"vm.dossier.status !== \'filed\' && vmdossier.status !== \'closed-without-certificate\'\" \ndata-ng-click=\"vm.openDossierResignationDialog($event)\"><span data-translate>Solicitar cancelacion</span></md-button>\n</div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.dossierResignations.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-brightness-1\"></md-icon><div class=\"message-text\" \ntranslate>Sin cancelaciones</div></div></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"dossierResignation in vm.dossierResignations.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.dossierResignations.count\" data-current-page=\"vm.dossierResignations.filters.page\" \nng-class=\"{\'green-100-bg\': dossierResignation.status == \'done\',\n                                    \'red-100-bg\': dossierResignation.status===\'rejected\'}\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"mt-10\" \ndata-ng-if=\"dossierResignation.reason &&\n                                                                        ((dossierResignation.user_data.group_type===\'companycontact\' && (vm.user.group_type===\'company_manager\' || vm.user.group_type===\'human_resource_manager\' )) ||\n                                                                        (dossierResignation.user_data.group_type===\'student\' && vm.user.group_type===\'student\') ||\n                                                                        (vm.user.group_type===\'manager\') ||\n                                                                        (vm.user.group_type===\'curricular_practices_tutor\')) &&\n                                                                        dossierResignation.reason!==dossierResignation.resolution\">\n<strong ng-if=\"dossierResignation.user_data.group_type===\'student\'\" data-translate>\nEl alumno ha solicitado la rescisión de las prácticas por el siguiente motivo: </strong><strong \nng-if=\"dossierResignation.user_data.group_type!==\'student\'\" data-translate>\nLa empresa ha solicitado la rescisión de las prácticas por el siguiente motivo:</strong><div>\n{{dossierResignation.reason}}</div></div><div class=\"mt-10\" data-ng-if=\"dossierResignation.resolution\"><strong \nng-if=\"dossierResignation.status == \'done\'\" data-translate>\nEstas prácticas han sido rescindidas por el siguiente motivo:</strong> <strong \nng-if=\"dossierResignation.status == \'rejected\'\" data-translate>\nEstas prácticas no han sido rescindidas por el siguiente motivo:</strong><div>{{dossierResignation.resolution}}</div>\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><div data-ng-if=\"dossierResignation.document\"><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" data-ng-click=\"getDocument(dossierResignation.document)\"><md-icon\n class=\"pt-5\" title=\"{{\'Descargar\' | translate}}\" md-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" \ndata-translate>Descargar</span></md-button><md-button data-layout=\"column\" data-layout-align=\"start center\" \ndata-ng-if=\"isPrintable(dossierResignation.document)\" \ndata-ng-click=\"printDocument(dossierResignation.document, $event)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Imprimir\' | translate}}\" md-font-icon=\"icon-printer\"></md-icon><span class=\"pt-5\" data-translate>Imprimir\n</span></md-button></div><div \ndata-ng-if=\"dossierResignation.status!==\'done\' && dossierResignation.status!==\'rejected\'\"><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierResignations\',\'DELETE\') &&\n                                                           ((dossierResignation.user_data.group_type===\'student\' && vm.user.group_type===\'student\') ||\n                                                           (dossierResignation.user_data.group_type===\'companycontact\' && (vm.user.group_type===\'company_manager\' || vm.user.group_type===\'human_resource_manager\' )))\" \ndata-ng-click=\"vm.removeDossierResignation($event, dossierResignation)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Cancelar solicitud\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>\nCancelar solicitud</span></md-button></div><div layout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"dossierResignation.status===\'pending\'\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'dossierResignationsAccept\',\'POST\')\" \ndata-ng-click=\"vm.acceptResignation($event, dossierResignation)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Aceptar\' | translate}}\" md-font-icon=\"icon-check\"></md-icon><span class=\"pt-5\" data-translate>Aceptar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'dossierResignationsReject\',\'POST\')\" \ndata-ng-click=\"vm.rejectResignation($event, dossierResignation)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Rechazar\' | translate}}\" md-font-icon=\"icon-close\"></md-icon><span class=\"pt-5\" data-translate>Rechazar\n</span></md-button></div></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div><script type=\"text/ng-template\" id=\"prompt.html\">\n<md-dialog aria-label=\"prompt\" class=\"task-dialog\">\n        <md-toolbar class=\"md-accent md-hue-2\">\n            <div class=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\">\n                <span class=\"title\">{{vm.prompt.title}}</span>\n                <md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\">\n                    <md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content ms-scroll>\n            <form layout-padding layout=\"column\">\n                <md-input-container>\n                    <label>{{vm.prompt.textContent}}</label>\n                    <textarea name=\"result\" ng-model=\"vm.prompt.result\" max-rows=\"5\"></textarea>\n                </md-input-container>\n                <md-input-container data-ng-if=\"vm.prompt.showEffectiveEndDate\">\n                    <h4>{{vm.prompt.effectiveEndDateLabel}}</h4>\n                    <md-datepicker name=\"effective_end_date\" data-ng-model=\"vm.prompt.effective_end_date\"\n                                   md-placeholder=\"dd/mm/yyyy\" required></md-datepicker>\n                </md-input-container>\n            </form>\n        </md-dialog-content>\n        <md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\">\n            <div data-layout=\"row\" data-layout-align=\"start center\">\n                <md-button data-ng-click=\"vm.prompt.save(vm.prompt.result)\" class=\"send-button md-accent md-raised\"\n                           data-ng-disabled=\"vm.prompt.showEffectiveEndDate && !vm.prompt.effective_end_date\"\n                           aria-label=\"{{vm.prompt.ok}}\">\n                    <span>{{vm.prompt.ok}}</span>\n                </md-button>\n            </div>\n        </md-dialog-actions>\n    </md-dialog>\n</script>");
$templateCache.put("app/main/dossiers/views/edit/dossier-actions.html","<md-button ng-click=\"vm.saveDossier()\" class=\"send-button md-accent md-raised\" data-debouce-click \ndata-ng-if=\"hasPermission(\'dossiers\',\'PATCH\')\" ng-disabled=\"dossierForm.$invalid || dossierForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button><md-button \nng-click=\"vm.confirmDossier()\" data-debouce-click class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersSign\',\'POST\') && vm.dossier.status===\'draft\' && !vm.dossier.curricular\" \naria-label=\"{{\'Confirmar para firma\' | translate}}\"><span data-translate>Confirmar para firma</span></md-button>\n<md-button ng-click=\"vm.confirmDossierCurricular()\" data-debouce-click class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersConfirm\',\'POST\') &&\n                                       vm.dossier.curricular &&\n                                       vm.dossier.status===\'signed\'\" \naria-label=\"{{\'Confirmar\' | translate}}\"><span data-translate>Confirmar</span></md-button><md-button \nng-click=\"vm.confirmDossierAcademicTutor()\" data-debouce-click class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'dossiersConfirmAcademicTutor\',\'POST\') &&\n                                       vm.dossier.curricular &&\n                                       vm.dossier.status===\'confirmed\'\" \naria-label=\"{{\'Confirmar\' | translate}}\"><span data-translate>Confirmar</span></md-button><md-button type=\"submit\" \nng-click=\"vm.discardDossier()\" class=\"md-warn md-raised\" \ndata-ng-if=\"(hasPermission(\'offersRequests\',\'PATCH\') || hasPermission(\'dossiers\',\'DELETE\')) &&\n                                            vm.dossier.status!==\'in progress\' &&\n                                            vm.dossier.status!==\'closed-without-certificate\' &&\n                                            vm.dossier.status!==\'pending-by-at\' &&\n                                            vm.dossier.status!==\'filed\'\" \naria-label=\"{{\'Rechazar expediente\' | translate}}\"><span ng-if=\"vm.user.group_type===\'manager\'\" data-translate>\nEliminar expediente</span> <span ng-if=\"vm.user.group_type!==\'manager\'\" data-translate>Rechazar candidato</span>\n</md-button>");
$templateCache.put("app/main/dossiers/views/edit/dossier-company.html","<div class=\"mb-20 detail-company\" data-ng-if=\"!hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\">\n</md-icon><span class=\"ml-20\">{{vm.dossier.seat_data.company_name}}</span></div><div \nui-sref=\"app.company.detail({id:\'{{vm.dossier.seat_data.company}}\'})\" class=\"mb-20 detail-company pointer\" \ndata-ng-if=\"hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span class=\"ml-20\">\n{{vm.dossier.seat_data.company_name}}</span></div><div data-layout=\"column\" data-layout-align=\"start start\" \nlayout-wrap><md-input-container class=\"sede\" ng-if=\"vm.centers.length>0\"><label data-translate>Centro de trabajo\n</label><md-select data-ng-model=\"vm.dossier.seat_data.id\" name=\"seat\" ng-disabled=\"vm.disabledInputs\"><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name}} {{center.address}}</md-option>\n</md-select></md-input-container><md-autocomplete md-floating-label=\"{{\'Sede\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"seat\" md-min-length=\"3\" md-selected-item=\"vm.dossier.seat_data\" md-search-text=\"searchTextCenter\" \nng-if=\"vm.centers.length<1\" ng-disabled=\"vm.disabledInputs\" md-items=\"center in vm.getCenters(searchTextCenter)\" \nclass=\"fullwidth\" md-item-text=\"vm.getFullNameCenter(center)\" placeholder=\"{{\'Sede\' | translate}}\"><md-item-template>\n<span md-highlight-text=\"searchTextCenter\">{{vm.getFullNameCenter(center)}}</span></md-item-template><md-not-found>\n<span data-translate>No hay ningún centro con ese nombre</span></md-not-found></md-autocomplete><md-input-container \nclass=\"no-margin\"><error-messages field=\"dossierForm.seat\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><div class=\"pl-20 mb-20\" ng-if=\"vm.dossier.seat_data\"><div class=\"secondary-text\" \nng-if=\"vm.offer.organic\" \ndata-ng-if=\"vm.offer.company.identification === UCA_COMPANY_CIF && vm.offer.organic.organic_code\"><md-icon \nmd-font-icon=\"icon-assignment\" class=\"icon\"></md-icon><span>\n{{vm.offer.organic.organic_code}} - {{vm.offer.organic.organic_title}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.seat_data.address\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>\n{{vm.dossier.seat_data.address}}</span></div><div class=\"secondary-text\" data-ng-if=\"vm.dossier.seat_data.email\">\n<md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>{{vm.dossier.seat_data.email}}</span></div><div \nclass=\"secondary-text\" data-ng-if=\"vm.dossier.seat_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.seat_data.phone}}</span></div></div></div><div><md-input-container><label data-translate>\nDepartamento / Área</label><input name=\"department\" data-ng-model=\"vm.dossier.department\" \nng-disabled=\"vm.disabledInputs\"><error-messages field=\"dossierForm.department\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container></div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap><h2 \ndata-translate>Contactos</h2><md-input-container ng-if=\"vm.tutors.length>0\"><label data-translate>Tutor profesional\n</label><md-select data-ng-model=\"vm.dossier.professional_tutor_data.id\" name=\"professional_tutor\"><md-option \ndata-ng-repeat=\"tutor in vm.tutors\" data-ng-value=\"tutor.id\">{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}\n</md-option></md-select></md-input-container><md-autocomplete md-floating-label=\"{{\'Tutor profesional\' | translate}}\" \nmd-delay=\"300\" md-input-name=\"professional_tutor\" md-min-length=\"3\" \nmd-selected-item=\"vm.dossier.professional_tutor_data\" md-search-text=\"searchTextProfessionalTutor\" \nng-if=\"vm.tutors.length<1\" md-items=\"professionalTutor in vm.getProfessionalTutors(searchTextProfessionalTutor)\" \nclass=\"fullwidth\" md-item-text=\"vm.getFullNameTutor(professionalTutor)\" \nplaceholder=\"{{\'Tutor profesional\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextProfessionalTutor\">{{vm.getFullNameTutor(professionalTutor)}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ningún tutor con ese nombre</span></md-not-found></md-autocomplete>\n<md-input-container class=\"no-margin\"><error-messages field=\"dossierForm.professional_tutor\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><div class=\"pl-20 mb-20\" \nng-if=\"vm.dossier.professional_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.user.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.dossier.professional_tutor_data.user.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.dossier.professional_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.professional_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.professional_tutor_data.mobile}}</span></div></div><md-input-container \nng-if=\"vm.managementContacts.length>0\"><label data-translate>Gestión</label><md-select \ndata-ng-model=\"vm.dossier.management_contact_data.id\" name=\"management_contact\"><md-option \ndata-ng-repeat=\"managementContact in vm.managementContacts\" data-ng-value=\"managementContact.id\">\n{{managementContact.name}} {{managementContact.surname}} {{managementContact.second_surname}}</md-option></md-select>\n</md-input-container><md-autocomplete md-floating-label=\"{{\'Gestión\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"management_contact\" md-min-length=\"3\" md-selected-item=\"vm.dossier.management_contact_data\" \nmd-search-text=\"searchTextManagementContact\" ng-if=\"vm.managementContacts.length<1\" \nmd-items=\"managementContact in vm.getManagementContacts(searchTextManagementContact)\" class=\"fullwidth\" \nmd-item-text=\"vm.getFullNameTutor(managementContact)\" placeholder=\"{{\'Gestión\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextManagementContact\">{{vm.getFullNameTutor(managementContact)}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ningún gestor con ese nombre</span></md-not-found></md-autocomplete>\n<md-input-container class=\"no-margin\"><error-messages field=\"dossierForm.management_contact\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><div class=\"pl-20 mb-20\" \nng-if=\"vm.dossier.management_contact_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.management_contact_data.user.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.dossier.management_contact_data.user.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.management_contact_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.dossier.management_contact_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.management_contact_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.management_contact_data.mobile}}</span></div></div><md-autocomplete \nmd-floating-label=\"{{\'Tutor académico\' | translate}}\" md-delay=\"300\" md-input-name=\"academic_tutor\" md-min-length=\"3\" \nmd-selected-item=\"vm.dossier.academic_tutor_data\" md-search-text=\"searchTextTutor\" \ndata-ng-if=\"vm.user.group_type===\'manager\'\" md-items=\"tutor in vm.getTutors(searchTextTutor)\" \nmd-item-text=\"vm.getFullNameTutor(tutor)\" placeholder=\"{{\'Tutor académico\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextTutor\">{{vm.getFullNameTutor(tutor)}}</span></md-item-template><md-not-found><span \ndata-translate>No hay ningún tutor con ese nombre</span></md-not-found></md-autocomplete><md-input-container \nclass=\"no-margin\"><error-messages field=\"dossierForm.academic_tutor\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><div class=\"pl-20 mb-20\" ng-if=\"vm.dossier.academic_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.dossier.academic_tutor_data.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.dossier.academic_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.dossier.academic_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.dossier.academic_tutor_data.mobile}}</span></div></div></div>");
$templateCache.put("app/main/dossiers/views/edit/dossier.html","<div id=\"dossier-edit\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"row\"><div \nclass=\"content-avantar-fotuca\"><img ng-src=\"{{vm.photo}}\" alt=\"avatar\" class=\"avatar-fotuca\"></div><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span>\n{{vm.dossier.student.contact_student_data.name}} {{vm.dossier.student.contact_student_data.surname}} {{vm.dossier.student.contact_student_data.second_surname}}\n</span></div><div layout=\"row\" layout-xs=\"column\"><div><div class=\"count secondary-text\" \ndata-ng-if=\"vm.dossier.student.contact_student_data.identification\"><md-icon md-font-icon=\"icon-folder-account\" \nclass=\"icon\"></md-icon><span>{{vm.dossier.student.contact_student_data.identification}}</span></div><div \nclass=\"count secondary-text\" data-ng-if=\"vm.dossier.student.contact_student_data.email\"><md-icon \nmd-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>{{vm.dossier.student.contact_student_data.email}}</span></div>\n<div class=\"count secondary-text\" data-ng-if=\"vm.dossier.student.contact_student_data.phone\"><md-icon \nmd-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>{{vm.dossier.student.contact_student_data.phone}}</span></div>\n</div><div><div class=\"count secondary-text\" data-ng-if=\"vm.dossier.degree_data.academic_year\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"icon\"></md-icon><span>{{vm.dossier.degree_data.academic_year}}</span></div><div \nclass=\"count secondary-text\" data-ng-if=\"vm.dossier.degree_data.degree\"><md-icon md-font-icon=\"icon-book-open\" \nclass=\"icon\"></md-icon><span>{{vm.dossier.degree_data.degree}}</span></div><div class=\"count secondary-text\" \ndata-ng-if=\"vm.dossier.degree_data.center\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>\n{{vm.dossier.degree_data.center}}</span> <span data-ng-if=\"vm.dossier.degree_data.campus\">\n({{vm.dossier.degree_data.campus}})</span></div></div></div></div></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"end end\"><div data-layout=\"column\" data-layout-align=\"end end\" class=\"h-100\"><div data-layout=\"row\" \ndata-layout-align=\"end center\" ng-if=\"vm.dossier.student.professional_cv_data\"><md-button \ndata-ng-click=\"getDocument(vm.dossier.student.professional_cv_data)\" class=\"md-raised\" \naria-label=\"{{\'CV profesional\' | translate}}\"><span data-translate>CV profesional</span></md-button><md-button \nclass=\"md-icon-button md-raised\" ng-if=\"isPrintable(vm.dossier.student.professional_cv_data)\" \ndata-ng-click=\"printDocument(vm.dossier.student.professional_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV profesional\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV profesional</span></md-tooltip></md-button></div><div \ndata-layout=\"row\" data-layout-align=\"end center\" ng-if=\"vm.dossier.student.researcher_cv_data\"><md-button \ndata-ng-click=\"getDocument(vm.dossier.student.researcher_cv_data)\" class=\"md-raised\" \naria-label=\"{{\'CV investigador\' | translate}}\"><span data-translate>CV investigador</span></md-button><md-button \nclass=\"md-icon-button md-raised\" ng-if=\"isPrintable(vm.dossier.student.researcher_cv_data)\" \ndata-ng-click=\"printDocument(vm.dossier.student.researcher_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV investigador\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV investigador</span></md-tooltip></md-button></div></div><span><span \nng-if=\"vm.dossier.curricular\" class=\"badge badge-pill badge-primary\" data-translate>Curricular</span> <span \nng-if=\"!vm.dossier.curricular\" class=\"badge badge-pill badge-success\" data-translate>Extracurricular</span> <span \nng-if=\"vm.dossier.program_data\">- {{vm.dossier.program_data.name}}</span> </span><span ng-if=\"vm.dossier.offer_info\">\n<span data-translate>Oferta</span> <span>:</span> <span>{{vm.dossier.offer_info}}</span></span><div class=\"h1\"><span>\n<span data-translate>Expediente </span>( <span \ndata-ng-if=\"(vm.dossier.status === \'draft\' || vm.dossier.status === \'blocked\') && !vm.dossier.is_cancelled\">Borrador \n</span><span data-ng-if=\"vm.dossier.status === \'confirmed\' && !vm.dossier.is_cancelled\">Pendiente de firma </span><span\n data-ng-if=\"vm.dossier.status === \'signed\' && !vm.dossier.is_cancelled\">Firmado </span><span \ndata-ng-if=\"vm.dossier.status === \'in progress\' && !vm.dossier.is_cancelled\">En proceso </span><span \ndata-ng-if=\"vm.dossier.status === \'closed-without-certificate\' && !vm.dossier.is_cancelled\">Finalizado </span><span \ndata-ng-if=\"vm.dossier.is_cancelled\">Cancelado </span><span \ndata-ng-if=\"vm.dossier.status === \'filed\' && !vm.dossier.is_cancelled\">Finalizado </span><span \ndata-ng-if=\"vm.dossier.status === \'pending-by-at\' && !vm.dossier.is_cancelled\">Completado </span>) </span><span>\n: {{vm.dossier.code}}</span></div><div class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \ndata-layout-wrap ng-include=\"\'app/main/dossiers/views/edit/dossier-actions.html\'\"></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content\n class=\"content p-20\" flex ms-scroll><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between start\" flex><form\n name=\"dossierForm\" class=\"md-inline-form ms-form-wizard-form full-width\" novalidate><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"space-between start\" layout-wrap><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start start\" layout-wrap><div><md-input-container><h4 data-translate>Fecha inicio</h4><md-datepicker\n name=\"start_date\" data-ng-model=\"vm.dossier.start_date\" \nng-disabled=\"vm.user.group_type !== \'manager\' &&\n                                                           (vm.user.group_type !== \'subject_coordinator\' || (vm.dossier.status !== \'draft\' && vm.dossier.status !== \'blocked\'))\" \nmd-placeholder=\"dd/mm/yyyy\" required></md-datepicker><error-messages field=\"dossierForm.start_date\" \nserver-errors=\"vm.serverErrors\" forcechange required></error-messages></md-input-container></div><div class=\"mr-50\">\n<md-input-container><h4 data-translate>Fecha fin</h4><md-datepicker name=\"end_date\" \ndata-ng-model=\"vm.dossier.end_date\" \nng-disabled=\"vm.user.group_type !== \'manager\' &&\n                                                           (vm.user.group_type !== \'subject_coordinator\' || (vm.dossier.status !== \'draft\' && vm.dossier.status !== \'blocked\'))\" \nmd-placeholder=\"dd/mm/yyyy\"></md-datepicker><error-messages field=\"dossierForm.end_date\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div><div \nclass=\"mr-50 duration-label\" data-ng-if=\"vm.dossier.curricular\"><h4 data-translate>Duración</h4><p>\n{{vm.durationLabel()}}</p></div><div class=\"mr-50 duration-group\" data-ng-if=\"!vm.dossier.curricular\"><h4 \ndata-translate>Duración</h4><div layout=\"row\"><md-input-container class=\"months duration-part\"><label data-translate>\nMeses</label><input type=\"number\" name=\"duration_months\" min=\"0\" step=\"1\" data-ng-model=\"vm.durationMonths\" required \nng-disabled=\"vm.disabledInputs\" ng-change=\"vm.updateDurationDays(dossierForm)\"></md-input-container><md-input-container\n class=\"months duration-part\"><label data-translate>Días</label><input type=\"number\" name=\"duration_days_part\" min=\"0\" \nstep=\"1\" data-ng-model=\"vm.durationDays\" required ng-disabled=\"vm.disabledInputs\" \nng-change=\"vm.updateDurationDays(dossierForm)\"></md-input-container></div><div class=\"duration-errors\"><error-messages \nfield=\"dossierForm.duration_months\" server-errors=\"vm.serverErrors\" required></error-messages><div class=\"ng-hide\">\n<error-messages field=\"dossierForm.duration_days_part\" server-errors=\"vm.serverErrors\"></error-messages></div>\n<error-messages field=\"dossierForm.duration_days_part\" required></error-messages></div></div><div class=\"mt-50\" \ndata-ng-if=\"!vm.dossier.curricular\"><md-input-container class=\"eur\"><label data-translate>Dotación mensual bruta (€)\n</label><input type=\"number\" name=\"economic_endowment\" data-ng-model=\"vm.dossier.economic_endowment\" required \nng-disabled=\"vm.disabledInputs\"><error-messages field=\"dossierForm.economic_endowment\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container></div></div><div class=\"pb-10\" \ndata-ng-if=\"vm.dossier.curricular && hasPermission(\'dossiers\',\'PATCH\')\"><md-checkbox name=\"exclude_ss_contribution\" \nng-model=\"vm.dossier.exclude_ss_contribution\" ng-disabled=\"vm.ssExemptionLocked()\" \naria-label=\"{{\'No genera cotización a la Seguridad Social\' | translate}}\"><span data-translate>\nNo genera cotización a la Seguridad Social</span></md-checkbox><div class=\"secondary-text\" data-translate>\nDebe decidirse antes de comenzar la práctica: una vez el expediente esté en curso no podrá desmarcarse. Al activarlo, el expediente deja de generar días de cotización y no se incluye en el fichero de inscripciones a la Seguridad Social; las cotizaciones ya generadas se conservan.\n</div></div><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap>\n<md-input-container class=\"md-block\" flex=\"100\"><label data-translate>Proyecto formativo (actividades a desarrollar)\n</label><textarea name=\"objectives\" ng-model=\"vm.dossier.objectives\" max-rows=\"5\" ng-disabled=\"vm.disabledInputs\">\n</textarea><error-messages field=\"dossierForm.objectives\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\"><label data-translate>Observaciones privadas\n</label><textarea name=\"private_observations\" ng-model=\"vm.dossier.private_observations\" \nng-disabled=\"vm.disabledInputs\" max-rows=\"5\"></textarea><error-messages field=\"dossierForm.private_observations\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div></div><div class=\"md-whiteframe-z1 p-20\" \nflex=\"35\" flex-xs=\"100\" ng-include=\"\'app/main/dossiers/views/edit/dossier-company.html\'\"></div></div></form></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/dossiers/views/list/dossiers.html","<div id=\"dossiers\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-if=\"vm.offer\" ng-include=\"\'app/main/offers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n<md-sidenav id=\"students-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-if=\"vm.form\" ng-include=\"\'app/main/students/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav>\n<md-sidenav id=\"demands-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-if=\"vm.demand\" ng-include=\"\'app/main/demands/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-document\"></md-icon><span>Expedientes</span> <span \ndata-ng-if=\"vm.user.group_type===\'manager\' && vm.form\" class=\"ml-10\">({{vm.form.contact_student_data.identification}})\n</span></div><div class=\"count secondary-text\"><span data-translate>Número de expedientes:</span> <span>\n{{vm.dossiers.count}}</span></div></div><div data-layout=\"row\" data-layout-align=\"end start\" data-layout-wrap \nng-if=\"!vm.form && !vm.offer && !vm.demand\"><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'dossiers\'\"></ng-include></div><div \ndata-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap ng-if=\"vm.demand\"><div \nclass=\"search pt-10\" data-layout=\"row\" data-layout-align=\"start center\"><label class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-flex><input class=\"search-input no-margin\" type=\"text\" \nplaceholder=\"{{ \'Buscar\' | translate}}\" data-ng-model=\"vm.filter.search\" data-flex></label></div></div><div \nclass=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\" ng-if=\"vm.demand\"><div class=\"h3\" layout=\"column\" \nlayout-align=\"end end\"><span>{{vm.getFullNameDegree(vm.demand.subject_data.degree)}} </span><span>\n{{vm.getFullNameSubject(vm.demand.subject_data)}}</span></div></div><div data-layout=\"column\" \ndata-layout-align=\"space-between end\" ng-if=\"vm.offer\"><div class=\"white-fg mt-20\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"column\" layout-align=\"end end\"><span><span data-translate>Oferta:\n</span> <span>{{vm.offer.code}}</span> </span><span><span data-translate>Programa:</span> <span>\n{{vm.offer.program_data.name}}</span></span></div></div></div></div><div class=\"content-card\" data-layout=\"column\" \ndata-flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md \nng-if=\"vm.form || vm.offer || vm.demand\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.dossiers.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-document\"></md-icon><div class=\"message-text\" \ntranslate>Sin expedientes</div></div></div><div class=\"todo-item\" md-ink-ripple layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.go(dossier)\" \ndata-dir-paginate=\"dossier in vm.dossiers.data | itemsPerPage: vm.pageSize | filter:vm.filter.search\" \ndata-total-items=\"vm.dossiers.count\" data-current-page=\"vm.dossiers.filters.page\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div><div class=\"title\"><md-icon md-font-icon=\"icon-account\"></md-icon><span>\n{{dossier.student.contact_student_data.identification}} </span><span>- </span><span>\n{{dossier.student.contact_student_data.name}} {{dossier.student.contact_student_data.surname}} {{dossier.student.contact_student_data.second_surname}}\n</span></div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-domain\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\" \nng-if=\"dossier.seat.company_name\"><span>{{dossier.seat.company_name}}</span> <span>- </span><span>\n{{dossier.seat.name}}({{dossier.seat.address}})</span></div><div class=\"ml-10 tag-label\" \nng-if=\"dossier.seat_data.company_name\"><span>{{dossier.seat_data.company_name}}</span> <span>- </span><span>\n{{dossier.seat_data.name}}({{dossier.seat_data.address}})</span></div></div><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\" ng-if=\"dossier.degree_data.degree\"><md-icon md-font-icon=\"icon-book-open\" class=\"s16\">\n</md-icon><div class=\"ml-10 tag-label\"><span>{{dossier.degree_data.degree}}</span> <span \nng-if=\"dossier.degree_data.academic_year\">({{dossier.degree_data.academic_year}})</span></div></div></div><div \nclass=\"mt-8\"><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"(dossier.status === \'draft\' || dossier.status == \'blocked\') && !dossier.is_cancelled\" data-translate>\nBorrador </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"dossier.status === \'confirmed\' && !dossier.is_cancelled\" data-translate>Pendiente de firma </span><span \nclass=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"dossier.status === \'pending-by-at\' && !dossier.is_cancelled\" \ndata-translate>Completado </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"dossier.status === \'signed\' && !dossier.is_cancelled\" data-translate>Firmado </span><span \nclass=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"dossier.status === \'in progress\' && !dossier.is_cancelled\" \ndata-translate>En proceso </span><span class=\"text-boxed m-0 white-fg red-bg\" data-ng-if=\"dossier.is_cancelled\" \ndata-translate>Cancelado </span><span class=\"text-boxed m-0 white-fg green-bg\" \ndata-ng-if=\"dossier.status === \'closed-without-certificate\' && !dossier.is_cancelled\" data-translate>Finalizado </span>\n<span class=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"dossier.status === \'filed\' && !dossier.is_cancelled\" \ndata-translate>Finalizado </span><span class=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"dossier.curricular\" \ndata-translate>Curricular </span><span class=\"text-boxed m-0 white-fg indigo-bg ml-10\" \ndata-ng-if=\"!dossier.curricular\" data-translate>Extracurricular</span></div></div><div><div class=\"title\"><md-icon \nmd-font-icon=\"icon-document\"></md-icon><span data-translate>Expediente: </span><span>{{dossier.code}}</span></div>\n</div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/download/views/view/view.html","<div id=\"downloadview\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/download/sidenavs/download-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" data-layout=\"column\" flex><div class=\"header\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div class=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\">\n<div class=\"h1\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span>\nSeguridad Social</span></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div \ndata-layout=\"column\" data-layout-align=\"space-between start\" \nng-if=\"(vm.categoryDownload == 1 || vm.categoryDownload == 2)\"><div class=\"todo-item\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-ng-repeat=\"data in vm.zones\"><div data-layout=\"row\" \ndata-layout-align=\"start center\" flex ng-if=\"vm.categoryDownload == data.id\"><div class=\"info\" flex=\"auto\"><div \ndata-layout=\"row\" data-layout-xs=\"column\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div><div class=\"title\"><md-icon md-font-icon=\"icon-note-text\"></md-icon>\n{{data.name}}</div></div></div><div data-layout=\"row\" data-layout-align=\"end center\"><div data-layout=\"row\" flex=\"100\" \nstyle=\"width: 400px\" ng-if=\"vm.categoryDownload == 1\"><md-input-container flex=\"100\"><label><span data-translate>Desde\n</span></label><md-datepicker ng-model=\"vm.date.from\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker></md-input-container>\n<md-input-container flex=\"100\"><label><span data-translate>Hasta</span></label><md-datepicker ng-model=\"vm.date.to\" \nmd-placeholder=\"dd/mm/yyyy\"></md-datepicker></md-input-container></div><div class=\"quotes-filters\" data-layout=\"row\" \ndata-layout-align=\"end center\" layout-wrap ng-if=\"vm.categoryDownload == 2\"><md-input-container><label><span \ndata-translate>Desde (mes)</span></label><md-select ng-model=\"vm.period.fromMonth\"><md-option ng-value=\"null\" \ndata-translate>--</md-option><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">{{month.name}}</md-option>\n</md-select></md-input-container><md-input-container><label><span data-translate>Desde (año)</span></label><md-select \nng-model=\"vm.period.fromYear\"><md-option ng-value=\"null\" data-translate>--</md-option><md-option \nng-repeat=\"year in vm.years\" ng-value=\"year\">{{year}}</md-option></md-select></md-input-container><md-input-container>\n<label><span data-translate>Hasta (mes)</span></label><md-select ng-model=\"vm.period.toMonth\"><md-option \nng-value=\"null\" data-translate>--</md-option><md-option ng-repeat=\"month in vm.months\" ng-value=\"month.id\">\n{{month.name}}</md-option></md-select></md-input-container><md-input-container><label><span data-translate>Hasta (año)\n</span></label><md-select ng-model=\"vm.period.toYear\"><md-option ng-value=\"null\" data-translate>--</md-option>\n<md-option ng-repeat=\"year in vm.years\" ng-value=\"year\">{{year}}</md-option></md-select></md-input-container>\n<md-checkbox class=\"mb-0\" ng-model=\"vm.includeDownloaded\" aria-label=\"Mostrar también descargadas\"><span \ndata-translate>Mostrar también descargadas</span></md-checkbox><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'role\',\'PATCH\')\" data-ng-click=\"vm.viewQuotes()\"><md-icon \nclass=\"pt-5\" title=\"{{\'Ver listado\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5\" data-translate>\nVer listado</span></md-button></div><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \nng-disabled=\"vm.disabled\" data-ng-disabled=\"vm.disabled\" \ndata-ng-if=\"hasPermission(\'role\',\'PATCH\') && data.name !== \'Cotizaciones\'\" \ndata-ng-click=\"vm.downloadDocument(data.name)\"><md-icon class=\"pt-5\" title=\"{{\'Descargar\' | translate}}\" \nmd-font-icon=\"icon-download\"></md-icon><span class=\"pt-5\" data-translate>Descargar</span></md-button></div></div></div>\n</div></div></div><div data-layout=\"column\" data-layout-align=\"space-between start\" ng-if=\"vm.categoryDownload == 3\">\n<h1>Calendario</h1><div ui-calendar=\"vm.uiConfig.calendar\" ng-model=\"vm.eventSources\"></div></div></md-content></div>\n</div></div>");
$templateCache.put("app/main/evaluations/views/answers/answers.html","<div id=\"answers\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/dossiers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><span ng-if=\"vm.questionnaire.id\">{{vm.questionnaire.name}}\n</span> <span ng-if=\"!vm.questionnaire.id\" data-translate>Evaluación pendiente del alumno y del tutor profesional\n</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div \nclass=\"actions\" data-layout=\"row\" data-layout-align=\"end center\"><md-button class=\"md-raised\" \naria-label=\"{{\'Finalizar evaluación\' | translate}}\" \ndata-ng-if=\"hasPermission(\'evaluationsFinalize\',\'GET\') && !vm.evaluation.finished && vm.questionnaire.id && vm.canEdit()\" \ndata-debouce-click data-ng-click=\"vm.confirmFinalizeEvaluation()\"><span data-translate>Finalizar cuestionario</span>\n</md-button></div></div></div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" \nlayout=\"row\" layout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\" class=\"mb-20\"><div class=\"no-results text-center\" \nng-if=\"vm.questions.count == 0 && vm.questionnaire.id\"><div class=\"message\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-question-mark-circle\"></md-icon><div class=\"message-text\" translate>Sin cuestiones que responder\n</div></div></div><div class=\"no-results text-center\" ng-if=\"!vm.questionnaire.id\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-question-mark-circle\"></md-icon><div class=\"message-text\" translate>\nAún no puede responder a las preguntas</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-ng-if=\"vm.questionnaire.id\" data-ng-repeat=\"question in vm.questions.data\" \nng-class=\"{\'green-100-bg\': question.answer}\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\">{{question.body}}</div><span>\n{{question.observations | limitTo:90}}{{question.observations.length > 90 ? \'...\' : \'\'}}</span><div \nng-if=\"question.answer\"><strong data-translate>Respuesta:</strong> {{question.answer.body_data}}</div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\"><md-button \ndata-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" data-ng-if=\"vm.canEdit()\" \ndata-ng-click=\"vm.openAnswerDialog($event, question)\"><md-icon class=\"pt-5\" title=\"{{\'responder\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Responder</span></md-button></div></div></div>\n</div></div></div></div><form name=\"evaluationForm\" class=\"md-inline-form ms-form-wizard-form full-width\" novalidate>\n<div data-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap flex=\"100\"><md-input-container \nclass=\"md-block\" flex=\"45\" flex-xs=\"100\"><label data-translate>Observaciones</label><textarea name=\"observations\" \nng-model=\"vm.evaluation.observations\" max-rows=\"5\" ng-disabled=\"!vm.canEdit()\"></textarea><error-messages \nfield=\"evaluationForm.observations\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><div \nclass=\"md-block\" flex=\"45\" flex-xs=\"100\" layout=\"column\" layout-align=\"start end\" \nng-if=\"(hasPermission(\'evaluationsPointsEvaluate\',\'POST\') || hasPermission(\'evaluationsPoints\', \'GET\')) \n                                    && vm.dossier.curricular == true &&\n                                    (vm.questionnaire.type===\'academic_tutor_pc\' || vm.questionnaire.type===\'academic_tutor_pex\')\">\n<div layout=\"row\" layout-align=\"start center\" style=\"width: 100%\"><div class=\"mb-15 mr-60\"><strong>\nNota Tutor Profesional:</strong><div class=\"bb text-right\">{{vm.point.professional_tutor_average}}</div></div></div>\n<div layout=\"column\" layout-align=\"start center\" style=\"width: 100%\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><md-input-container><label>Nota final de prácticas: <strong \nng-if=\"vm.point.calification\" ng-disabled=\"!hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\">\n{{vm.literalCalification(vm.point.calification)}}</strong></label><input type=\"number\" name=\"calification\" \ndata-ng-model=\"vm.point.calification\"><error-messages field=\"evaluationForm.calification\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"{{\'Establecer nota\' | translate}}\" style=\"width: 180px\" \nng-if=\"hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\" \nng-disabled=\"!vm.point.calification || vm.pointOriginal.calification === vm.point.calification\" data-debouce-click \ndata-ng-click=\"vm.evaluate()\"><span data-translate>Establecer nota</span></md-button></div><span class=\"alert_input\" \nng-if=\"vm.pointOriginal.calification !== vm.point.calification\">Pulsar en \"Establecer Nota\" para guardar el valor\n</span></div><div layout=\"column\" layout-align=\"start center\" class=\"mt-20\" style=\"width: 100%\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><md-input-container><label>Horas</label><input type=\"number\" \nid=\"inputHours\" name=\"hours\" ng-disabled=\"!hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\" \ndata-ng-model=\"vm.point.hours\"><error-messages field=\"evaluationForm.hours\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"{{\'Establecer horas\' | translate}}\" style=\"width: 180px\" \nng-if=\"hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\" \nng-disabled=\"!vm.point.hours || vm.pointOriginal.hours === vm.point.hours\" data-debouce-click \ndata-ng-click=\"vm.setHours()\"><span data-translate>Establecer horas</span></md-button></div><span class=\"alert_input\" \nng-if=\"vm.pointOriginal.hours !== vm.point.hours\">Pulsar en \"Establecer Horas\" para guardar el valor</span></div><div \nlayout=\"column\" layout-align=\"start center\" class=\"mt-20\" style=\"width: 100%\"><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><md-input-container><label>Créditos</label><input \ntype=\"number\" name=\"credits\" ng-disabled=\"!hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\" \ndata-ng-model=\"vm.point.credits\"><error-messages field=\"evaluationForm.credits\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container><md-button class=\"md-raised md-accent\" style=\"width: 180px\" \naria-label=\"{{\'Establecer creditos\' | translate}}\" ng-if=\"hasPermission(\'evaluationsPointsEvaluate\',\'POST\')\" \nng-disabled=\"!vm.point.credits || vm.pointOriginal.credits === vm.point.credits\" data-debouce-click \ndata-ng-click=\"vm.setCredits()\"><span data-translate>Establecer créditos</span></md-button></div><span \nclass=\"alert_input\" ng-if=\"vm.pointOriginal.credits !== vm.point.credits\">\nPulsar en \"Establecer Creditos\" para guardar el valor</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"mt-20 border pl-20\" ng-if=\"vm.point.hours.professional_tutor_average\"><div \nclass=\"mr-20\" data-translate>Media tutor profesional</div><div class=\"p-20 bl\">\n{{vm.point.hours.professional_tutor_average}}</div></div></div><md-input-container class=\"md-block\" flex=\"45\" \nflex-xs=\"100\" ng-show=\"vm.evaluation.show_practices_memories\"><div ng-if=\"vm.canEdit()\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.formFlow.practiceFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileSuccess($message)\" flow-files-submitted=\"$flow.upload()\" flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div><p \nng-if=\"vm.evaluation.practice_memories_data.name\"><span data-translate>Memoria:</span>\n {{vm.evaluation.practice_memories_data.name}}</p><md-button flow-btn class=\"md-accent md-raised\" \naria-label=\"{{\'Memoria\' | translate}}\"><span ng-if=\"!vm.evaluation.practice_memories && !$flow.files[0]\" \ndata-translate>Subir memoria</span><span ng-if=\"vm.evaluation.practice_memories || $flow.files[0]\" data-translate>\nModificar memoria</span></md-button></div></div><md-button \nng-if=\"hasPermission(\'evaluations\',\'PATCH\') && vm.evaluation.practice_memories\" class=\"md-accent md-raised\" \ndata-ng-click=\"getDocument(vm.evaluation.practice_memories_data)\" aria-label=\"{{\'Memoria\' | translate}}\"><span \ndata-translate>Descargar memoria</span></md-button><md-button \nng-if=\"hasPermission(\'evaluations\',\'PATCH\') && vm.evaluation.practice_memories && isPrintable(vm.evaluation.practice_memories_data)\" \nclass=\"md-accent md-raised\" data-ng-click=\"printDocument(vm.evaluation.practice_memories_data, $event)\" \naria-label=\"{{\'Imprimir memoria\' | translate}}\"><span data-translate>Imprimir memoria</span></md-button>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveEvaluation()\" class=\"send-button md-raised\" data-ng-if=\"vm.canEdit()\" \nng-disabled=\"vm.evaluation.finished\" aria-label=\"{{\'Guardar borrador\' | translate}}\"><span data-translate>\nGuardar borrador</span></md-button><md-button class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'evaluationsFinalize\',\'GET\') && !vm.evaluation.finished && vm.questionnaire.id && vm.canEdit()\" \ndata-debouce-click data-ng-click=\"vm.confirmFinalizeEvaluation()\" \naria-label=\"{{\'Finalizar cuestionario\' | translate}}\"><span data-translate>Finalizar cuestionario</span></md-button>\n</div></form></md-content></div></div></div>");
$templateCache.put("app/main/evaluations/views/questions/questions.html","<div id=\"questions\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"dossiers-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/evaluations/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-question-mark-circle\"></md-icon><span>{{vm.questionnaire.name}}</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de preguntas:</span> <span>{{vm.questions.count}}</span></div>\n</div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'questions\',\'POST\')\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Nueva pregunta\' | translate}}\" data-ng-click=\"vm.openQuestionDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva pregunta</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.questions.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-question-mark-circle\"></md-icon><div \nclass=\"message-text\" translate>Sin preguntas</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-dir-paginate=\"question in vm.questions.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.questions.count\" data-current-page=\"vm.questions.filters.page\" \nng-class=\"{\'green-100-bg\': question.status == \'done\',\n                                    \'red-100-bg\': question.status===\'rejected\'}\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div>\n<div class=\"title\">{{question.body}}</div><span>\n{{question.observations | limitTo:90}}{{question.observations.length > 90 ? \'...\' : \'\'}}</span></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"end center\" \ndata-ng-if=\"question.type===\'assessment\'\"><div class=\"boxAssessment\"><p data-translate>Mínimo</p><div>\n{{question.minimum}}</div></div><div class=\"boxAssessment\"><p data-translate>Máximo</p><div>{{question.maximum}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" class=\"mr-40\"><md-icon class=\"pt-5\" \nmd-font-icon=\"icon-checkbox-blank-outline\" data-ng-if=\"!question.no_answer\"></md-icon><md-icon class=\"pt-5\" \nmd-font-icon=\"icon-checkbox-marked-outline\" data-ng-if=\"question.no_answer\"></md-icon><div class=\"ml-10\"><p \ndata-translate>ns/nc</p></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" \nclass=\"md-accent\" data-layout-align=\"start center\" \nng-if=\"question.type==\'options\' && hasPermission(\'questionOptions\',\'LIST\')\" \ndata-ng-click=\"vm.openQuestionOptionsDialog($event, question)\"><md-icon class=\"pt-5 yellow-800-fg\" \nmd-font-icon=\"icon-image-filter-vintage\"></md-icon><span class=\"pt-5 yellow-800-fg\" data-translate>Opciones de selector\n</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'questions\',\'PATCH\')\" data-ng-click=\"vm.openQuestionDialog($event, question)\"><md-icon \nclass=\"pt-5\" title=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>\nEditar</span></md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'questions\',\'DELETE\')\" data-ng-click=\"vm.removeQuestion($event, question)\"><md-icon \nclass=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>\nEliminar</span></md-button></div></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div><script type=\"text/ng-template\" id=\"prompt.html\">\n<md-dialog aria-label=\"prompt\" class=\"task-dialog\">\n        <md-toolbar class=\"md-accent md-hue-2\">\n            <div class=\"md-toolbar-tools\" data-layout=\"row\" data-layout-align=\"space-between center\">\n                <span class=\"title\">{{vm.prompt.title}}</span>\n                <md-button class=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\">\n                    <md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon>\n                </md-button>\n            </div>\n        </md-toolbar>\n        <md-dialog-content ms-scroll>\n            <form layout-padding layout=\"column\">\n                <md-input-container>\n                    <label>{{vm.prompt.textContent}}</label>\n                    <textarea name=\"result\" ng-model=\"vm.prompt.result\" max-rows=\"5\"></textarea>\n                </md-input-container>\n            </form>\n        </md-dialog-content>\n        <md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\">\n            <div data-layout=\"row\" data-layout-align=\"start center\">\n                <md-button data-ng-click=\"vm.prompt.save(vm.prompt.result)\" class=\"send-button md-accent md-raised\"\n                           aria-label=\"{{vm.prompt.ok}}\">\n                    <span>{{vm.prompt.ok}}</span>\n                </md-button>\n            </div>\n        </md-dialog-actions>\n    </md-dialog>\n</script>");
$templateCache.put("app/main/eventNotifications/dialogs/eventNotification/eventNotification-dialog.html","<md-dialog class=\"eventNotification-dialog task-dialog\" aria-label=\"New Task\"><form name=\"eventNotificationForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \ndata-layout=\"row\" data-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container \nflex=\"100\"><input type=\"text\" name=\"name\" data-ng-model=\"vm.eventNotification.name\" \nplaceholder=\"{{\'Nombre\' | translate}}\" required md-autofocus><error-messages field=\"eventNotificationForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container class=\"md-block\" \nflex=\"50\" flex-xs=\"100\"><label data-translate>Descripción</label><textarea name=\"description\" \nng-model=\"vm.eventNotification.description\" max-rows=\"5\" required></textarea><error-messages \nfield=\"eventNotificationForm.description\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container><md-input-container flex=\"100\" class=\"md-icon-float md-icon-right md-block\"><label translate>\nUsuarios destinatarios</label><md-chips name=\"recipients\" ng-model=\"vm.eventNotification.recipients_user\" \nmd-autocomplete-snap=\"\" md-require-match=\"\" md-add-on-blur></md-chips><parameters parameters=\"vm.parameters\" \nfilter=\"\'data_user\'\" model=\"vm.eventNotification.recipients_user\"></parameters><error-messages \nfield=\"eventNotificationForm.recipients\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container flex=\"100\" class=\"md-icon-float md-icon-right md-block\"><label translate>\nGrupo destinatarios</label><md-chips name=\"recipients\" ng-model=\"vm.eventNotification.recipients_group\" \nmd-autocomplete-snap=\"\" md-require-match=\"\" md-add-on-blur></md-chips><parameters parameters=\"vm.parameters\" \nfilter=\"\'data_group\'\" model=\"vm.eventNotification.recipients_group\"></parameters><error-messages \nfield=\"eventNotificationForm.recipients\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container flex=\"100\"><span class=\"hint\" data-translate>\nPuede hacer que todos los destinatarios anteriores vean la misma notificación, es decir, si un usuario lee la notificación se marcará como leida para todos.\n</span><div layout=\"row\" layout-align=\"start center\"><span class=\"mr-20\" \nng-click=\"vm.eventNotification.collective=false\">Notificaciones individuales<md-icon class=\"pointer\" \nmd-font-icon=\"icon-account\" aria-label=\"Close dialog\"></md-icon></span><md-switch \nng-model=\"vm.eventNotification.collective\" aria-label=\"collective\"></md-switch><span class=\"ml-20\" \nng-click=\"vm.eventNotification.collective=true\"><md-icon class=\"pointer\" md-font-icon=\"icon-account-multiple\" \naria-label=\"Close dialog\"></md-icon>Notificación colectiva</span></div></md-input-container><md-input-container \nflex=\"100\" class=\"md-icon-float md-icon-right md-block\"><label translate>Destinatarios con email</label><md-chips \nname=\"recipients\" ng-model=\"vm.eventNotification.recipients_email\" md-autocomplete-snap=\"\" md-require-match=\"\" \nmd-add-on-blur></md-chips><parameters parameters=\"vm.parameters\" filter=\"\'data_email\'\" \nmodel=\"vm.eventNotification.recipients_email\"></parameters><error-messages field=\"eventNotificationForm.recipients\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container flex=\"100\" \nclass=\"md-icon-float md-icon-right md-block\"><input type=\"text\" name=\"subject\" \ndata-ng-model=\"vm.eventNotification.subject\" placeholder=\"{{\'Titulo\' | translate}}\" required><parameters \nparameters=\"vm.parameters\" filter=\"\'data_body\'\" model=\"vm.eventNotification.subject\"></parameters><error-messages \nfield=\"eventNotificationForm.subject\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<div class=\"md-input-container\"><div><label data-translate>Mensaje:</label><parameters parameters=\"vm.parameters\" \nfilter=\"\'data_body\'\" model=\"vm.eventNotification.message\"></parameters></div><text-angular name=\"message\" \nta-toolbar=\"vm.taToolbar\" data-ng-model=\"vm.eventNotification.message\" class=\"pb-32\" required></text-angular></div>\n<md-input-container flex=\"100\"><error-messages field=\"eventNotificationForm.message\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container><md-input-container flex=\"100\" \nclass=\"md-icon-float md-icon-right md-block\"><label translate>Archivos adjuntos</label><md-chips name=\"files\" \nng-model=\"vm.eventNotification.prov_files\" md-autocomplete-snap=\"\" md-require-match=\"\" md-add-on-blur></md-chips>\n<parameters parameters=\"vm.parameters\" filter=\"\'data_file\'\" model=\"vm.eventNotification.prov_files\" \nicon=\"icon-paperclip\"></parameters><error-messages field=\"eventNotificationForm.files\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveEventNotification()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"eventNotificationForm.$invalid || eventNotificationForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/gadesDegrees/dialogs/gadesDegree/gadesDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"gadesDegreeForm\" class=\"md-inline-form\" novalidate \ndata-form-translate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container>\n<input type=\"text\" name=\"name\" data-ng-model=\"vm.gadesDegree.name\" \nplaceholder=\"{{\'Nombre de la titulación\' | translate}}\" required data-input-translate><error-messages \nfield=\"gadesDegreeForm.name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveGadesDegree()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"gadesDegreeForm.$invalid || gadesDegreeForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/managerDegrees/dialogs/managerDegree/managerDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"managerDegreeForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div class=\"attachment-list p-20\"><div class=\"attachment\" \ndata-layout=\"column\" data-ng-repeat=\"degree_managed in vm.degrees_managed\"><div data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div><span class=\"filename\">\n{{degree_managed.degree_data.id}} - {{degree_managed.degree_data.name}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"Delete attachment\" data-ng-click=\"vm.removeManagerDegree($event,degree_managed)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></div><div data-layout=\"column\">\n<md-autocomplete md-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"degree\" \nmd-min-length=\"3\" md-selected-item=\"vm.managerDegree.degree_data\" md-search-text=\"searchTextDegree\" \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"0\" md-autofocus \nmd-item-text=\"vm.getFullNameDegree(degree)\" placeholder=\"{{\'Titulación\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextDegree\">{{vm.getFullNameDegree(degree)}}</span></md-item-template><md-not-found><span \ndata-translate>No hay ninguna titulación con ese nombre</span></md-not-found></md-autocomplete><md-input-container>\n<error-messages field=\"managerDegreeForm.degree\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container flex=\"100\" ng-if=\"!vm.managerDegree.exist\"><input type=\"text\" name=\"identification\" \ndata-ng-model=\"vm.managerDegree.identification\" placeholder=\"{{\'Identificación\' | translate}}\"><error-messages \nfield=\"managerDegreeForm.identification\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveManagerDegree()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"managerDegreeForm.$invalid || managerDegreeForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate ng-if=\"!vm.managerDegree.exist\">Guardar</span> <span data-translate \nng-if=\"vm.managerDegree.exist\">Añadir nueva titulación</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/notifications/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"pl-10\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button close-thread\" aria-label=\"Back\" \nng-click=\"vm.closeThread()\" ng-if=\"vm.currentThread\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"5\">\n</dir-pagination-controls><md-menu class=\"settings-menu\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span translate>\nVista clásica</span></md-button></md-menu-item><md-menu-item hide-xs><md-button ng-click=\"vm.changeView(\'outlook\')\">\n<md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate>\nVista moderna</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" \nlayout=\"column\" flex><div class=\"content thread-detail\" ng-if=\"vm.currentThread\" \nng-include=\"\'app/main/notifications/views/classic/detail/detail.html\'\" ms-scroll flex></div><div \nclass=\"content thread-list\" ng-if=\"!vm.currentThread\" \nng-include=\"\'app/main/notifications/views/classic/list/list.html\'\" ms-scroll flex></div></div>");
$templateCache.put("app/main/notifications/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"pl-10\" layout=\"row\" \nlayout-align=\"start center\"></div><div layout=\"row\" layout-align=\"start center\"><dir-pagination-controls max-size=\"5\">\n</dir-pagination-controls><md-menu class=\"settings-menu\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span translate>\nVista clásica</span></md-button></md-menu-item><md-menu-item hide-xs><md-button ng-click=\"vm.changeView(\'outlook\')\">\n<md-icon md-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate>\nVista moderna</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" \nlayout=\"row\" flex><div class=\"content thread-list\" ng-include=\"\'app/main/notifications/views/outlook/list/list.html\'\" \nms-scroll flex=\"50\"></div><div class=\"content thread-detail\" \nng-include=\"\'app/main/notifications/views/outlook/detail/detail.html\'\" ms-scroll layout=\"column\" flex=\"50\"></div></div>");
$templateCache.put("app/main/offers/dialogs/offer/offer-dialog.html","<md-dialog id=\"new-offer\" class=\"task-dialog\" aria-label=\"New Task\"><form name=\"passwordForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"no-results text-center\" ng-if=\"vm.programs.count == 0\"><div \nclass=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-star\"></md-icon><div class=\"message-text\" \ntranslate>Aún no hay creado ningún programa</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" data-dir-paginate=\"program in vm.programs.data | itemsPerPage: 10\" \ndata-total-items=\"vm.programs.count\" data-current-page=\"vm.programs.filters.page\"><div flex=\"100\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{program.name}}</div><span>{{program.description}}</span></div></div><div layout=\"row\" layout-align=\"end center\">\n<md-button data-debouce-click class=\"md-raised md-primary\" \ndata-ng-if=\"vm.hasPermission(\'offersCreateFromTemplate\',\'POST\')\" aria-label=\"{{\'Plantillas\' | translate}}\" \ndata-ng-click=\"vm.showTemplates(program)\"><span data-translate>Plantillas</span></md-button><md-button \nclass=\"md-raised md-accent\" aria-label=\"{{\'Nueva oferta\' | translate}}\" data-ng-click=\"vm.saveOffer(program)\"><span \ndata-translate>Nueva oferta</span></md-button></div></div></div></div><div data-ng-if=\"program.showTemplates\" \nclass=\"p-20\"><div class=\"no-results text-center\" ng-if=\"vm.templates.count<1\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-document\"></md-icon><div class=\"message-text\" translate>\nNo hay plantillas creadas para este programa</div></div></div><div data-ng-repeat=\"template in vm.templates.data\"><div \nclass=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">{{template.template_name}}</div></div></div>\n<div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"{{\'Usar esta plantilla\' | translate}}\" data-ng-click=\"vm.saveOfferTemplate(template)\"><span data-translate>\nUsar esta plantilla</span></md-button></div></div></div></div></div></div></div><dir-pagination-controls \nclass=\"bottomFixed\"></dir-pagination-controls></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/offers/dialogs/offersDegree/offersDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersDegreeForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"degree\" md-min-length=\"3\" \nmd-selected-item=\"vm.offersDegree.degree_data\" md-search-text=\"searchTextDegree\" required \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"0\" md-item-text=\"vm.getFullNameDegree(degree)\" \nplaceholder=\"{{\'Titulación\' | translate}}\" required><md-item-template><span md-highlight-text=\"searchTextDegree\">\n{{vm.getFullNameDegree(degree)}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ninguna titulación con ese nombre</span></md-not-found></md-autocomplete><md-input-container><error-messages \nfield=\"offersDegreeForm.degree\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveOffersDegree()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersDegreeForm.$invalid || offersDegreeForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span\n data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offers/dialogs/offersLanguage/offersLanguage-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersLanguageForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Idioma\' | translate}}\" md-delay=\"300\" md-input-name=\"language\" \nmd-selected-item=\"vm.offersLanguage.language_data\" md-search-text=\"searchTextLanguage\" \nmd-items=\"language in vm.getLanguages(searchTextLanguage)\" md-min-length=\"0\" md-item-text=\"language.name\" \nplaceholder=\"{{\'Idioma\' | translate}}\" required md-autocomplete-translate><md-item-template><span \nmd-highlight-text=\"searchTextLanguage\">{{language.name}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ningun idioma con ese nombre</span></md-not-found></md-autocomplete><md-input-container class=\"mr-20\">\n<error-messages field=\"offersLanguageForm.language\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel de lectura</label><md-select \ndata-ng-model=\"vm.offersLanguage.reading_level\" name=\"reading_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"offersLanguageForm.reading_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel hablado</label><md-select \ndata-ng-model=\"vm.offersLanguage.speaking_level\" name=\"speaking_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"offersLanguageForm.speaking_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel de escritura</label><md-select \ndata-ng-model=\"vm.offersLanguage.writing_level\" name=\"writing_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"offersLanguageForm.writing_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersLanguage()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersLanguageForm.$invalid || offersLanguageForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offers/dialogs/offersSkill/offersSkill-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersSkillForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container><label data-translate>\nCategoría</label><md-select data-ng-model=\"vm.offersSkill.skill_data.category\" name=\"category\" \nng-change=\"vm.loadSkills()\"><md-option ng-repeat=\"category in vm.categories\" value=\"{{category.id}}\"><span>\n{{category.name}}</span></md-option></md-select></md-input-container><md-input-container ng-if=\"vm.skills.length<1\">\n<label data-translate>Competencia</label><md-select data-ng-model=\"none\" name=\"skill\" required \nng-disabled=\"vm.skills.length<1\"><md-option value=\"none\"><span>none</span></md-option></md-select><error-messages \nfield=\"offersSkillForm.skill\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container ng-if=\"vm.skills.length>0\"><label data-translate>Competencia</label><md-select \ndata-ng-model=\"vm.offersSkill.skill\" name=\"skill\" required><md-option ng-repeat=\"skill in vm.skills\" \nvalue=\"{{skill.id}}\"><span>{{skill.name}}</span></md-option></md-select><error-messages field=\"offersSkillForm.skill\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container><label \ndata-translate>Nivel</label><md-select data-ng-model=\"vm.offersSkill.level\" name=\"level\" required vm.skills><md-option \nvalue=\"initial\"><span data-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio\n</span></md-option><md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select>\n<error-messages field=\"offersSkillForm.level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersSkill()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersSkillForm.$invalid || offersSkillForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offers/views/detail/offer-company.html","<div class=\"mb-20 detail-company\" data-ng-if=\"!hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\">\n</md-icon><span class=\"ml-20\">{{vm.offer.company.business_name}}</span></div><div \nui-sref=\"app.company.detail({id:\'{{vm.offer.company.id}}\'})\" class=\"mb-20 detail-company pointer\" \ndata-ng-if=\"hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span class=\"ml-20\">\n{{vm.offer.company.business_name}}</span></div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap>\n<div class=\"border-bottom\"><h2 ng-if=\"UCA_COMPANY_CIF!==vm.offer.company.identification\" data-translate>\nCentro de trabajo</h2><h2 ng-if=\"UCA_COMPANY_CIF==vm.offer.company.identification\" data-translate>Sede</h2><span>\n{{vm.offer.seat_data.name || vm.offer.seat_data.address}}</span></div></div><div class=\"pl-20 mb-20 mt-20\" \nng-if=\"vm.offer.seat_data\"><div class=\"secondary-text\" ng-if=\"vm.offer.organic\" \ndata-ng-if=\"vm.offer.company.identification === UCA_COMPANY_CIF && vm.offer.organic.organic_code\"><md-icon \nmd-font-icon=\"icon-assignment\" class=\"icon\"></md-icon><span>\n{{vm.offer.organic.organic_code}} - {{vm.offer.organic.organic_title}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.seat_data.address\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>\n{{vm.offer.seat_data.address}}</span></div><div class=\"secondary-text\" data-ng-if=\"vm.offer.seat_data.town_data\">\n<md-icon md-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>{{vm.offer.seat_data.town_data.name}}</span></div>\n<div class=\"secondary-text\" data-ng-if=\"vm.offer.seat_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\">\n</md-icon><span>{{vm.offer.seat_data.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.seat_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.offer.seat_data.phone}}</span></div></div><div class=\"border-bottom\"><h4 data-translate>Departamento / Área</h4>\n<span>{{vm.offer.department}}</span></div>");
$templateCache.put("app/main/offers/views/detail/offer-degrees.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Titulaciones requeridas</h2></div></md-toolbar><md-content layout-padding \nclass=\"fullwidth\"><div data-ng-if=\"vm.offersDegrees.count<1\" class=\"todo-item\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div \nclass=\"mr-50\"><div class=\"title\" data-translate>No hay titulaciones seleccionadas</div></div></div></div></div></div>\n</div><div ng-repeat=\"offersDegree in vm.offersDegrees.data\" class=\"todo-item\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{offersDegree.degree_data.id}} - {{offersDegree.degree_data.name}}</div></div></div></div></div></div></div>\n</md-content>");
$templateCache.put("app/main/offers/views/detail/offer-languages.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Idiomas</h2></div></md-toolbar><md-content layout-padding class=\"fullwidth\"><div \ndata-ng-if=\"vm.offersLanguages.count<1\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" \ndata-translate>No hay idiomas seleccionados</div></div></div></div></div></div></div><div \ndata-ng-repeat=\"offerLanguage in vm.offersLanguages.data\" class=\"todo-item\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div \nclass=\"mr-50\"><div class=\"title\">{{offerLanguage.language_data.name}}</div></div><div class=\"tasktable\" flex=\"auto\">\n<table class=\"simple small\" ms-responsive-table><thead><tr><th class=\"text-center\"><md-icon title=\"Lectura\" \nmd-font-icon=\"icon-book-open\"></md-icon></th><th class=\"text-center\"><md-icon title=\"Conversación\" \nmd-font-icon=\"icon-account-multiple-outline\"></md-icon></th><th class=\"text-center\"><md-icon title=\"Escritura\" \nmd-font-icon=\"icon-pencil\"></md-icon></th></tr></thead><tbody><tr><td class=\"text-center\">\n{{offerLanguage.reading_level | level}}</td><td class=\"text-center\">{{offerLanguage.speaking_level | level}}</td><td \nclass=\"text-center\">{{offerLanguage.writing_level | level}}</td></tr></tbody></table></div></div></div></div></div>\n</div></md-content>");
$templateCache.put("app/main/offers/views/detail/offer-skills.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Competencias</h2></div></md-toolbar><md-content layout-padding class=\"fullwidth\"><div \ndata-ng-if=\"vm.offersSkills.count<1\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" \ndata-translate>No hay competencias seleccionadas</div></div></div></div></div></div></div><div \nng-repeat=\"offerSkill in vm.offersSkills.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">{{offerSkill.skill_data.name}}</div><div \nclass=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><strong data-translate>Categoria:</strong><div class=\"ml-10 tag-label\">\n{{offerSkill.skill_data.category_data.name}}</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<strong data-translate>Nivel:</strong><div class=\"ml-10 tag-label\">{{offerSkill.level | level}}</div></div></div></div>\n</div></div></div></div></div></md-content>");
$templateCache.put("app/main/offers/views/detail/offer.html","<div id=\"offer-detail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/offers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><md-icon \nmd-font-icon=\"icon-multiplication-box\"></md-icon><span data-translate>Datos básicos</span></div></div><div \ndata-layout=\"column\" data-layout-align=\"space-between end\"><div class=\"white-fg mt-20\" layout=\"column\" \nlayout-align=\"start start\"><div class=\"h3\" layout=\"column\" layout-align=\"end end\"><span><span data-translate>Oferta:\n</span> <span>{{vm.offer.code}}</span> </span><span><span data-translate>Programa:</span> <span>\n{{vm.offer.program_data.name}}</span></span></div></div></div></div><div class=\"content-card\" layout=\"column\" flex><div\n class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-xs=\"column\" layout-align=\"space-between start\" flex><form name=\"offerForm\" \nclass=\"md-inline-form ms-form-wizard-form fullwidth\" novalidate><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"space-between start\" layout-wrap><div data-layout=\"column\" data-layout-align=\"start start\" \nlayout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start center\" \nlayout-wrap><div class=\"border-bottom\"><h4 data-translate>Número de plazas</h4><span>{{vm.offer.seats}}</span></div>\n</div><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start start\" layout-wrap><div \nclass=\"mr-50 border-bottom\"><h4 data-translate>Fecha inicio</h4><span>{{vm.offer.start_date | date:\'dd/MM/yyyy\'}}\n</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>Duración</h4><span>{{vm.offer.duration_display}}\n</span></div><div class=\"mr-50 border-bottom\"><h4 data-translate>Horas totales</h4><span>{{vm.offer.total_hours}}\n</span></div><div class=\"border-bottom\"><h4 data-translate>Dotación mensual bruta (€)</h4><span>\n{{vm.offer.economic_endowment | currency}}</span></div></div><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"m-0\"><md-checkbox \nng-model=\"vm.offer.has_interruption\" aria-label=\"{{\'checkbox interruption\'}}\" class=\"md-align-top-left\" flex \ndisabled=\"disabled\"><span data-translate>Durante el periodo de prácticas existirá interrupción de las mismas</span>\n</md-checkbox></md-input-container></div><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap ng-if=\"vm.offer.has_interruption\"><div class=\"mr-50 border-bottom\"><h4 \ndata-translate>Fecha inicio interrupción</h4><span>{{vm.offer.start_date_interruption | date:\'dd/MM/yyyy\'}}</span>\n</div><div class=\"border-bottom\"><h4 data-translate>Fecha fin interrupción</h4><span>\n{{vm.offer.end_date_interruption | date:\'dd/MM/yyyy\'}}</span></div></div><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"start center\" layout-wrap><md-input-container class=\"m-0\"><md-checkbox \nng-model=\"vm.offer.contact_with_minors\" aria-label=\"{{\'checkbox contact with minors\'}}\" class=\"md-align-top-left\" flex \ndisabled=\"disabled\"><span data-translate>Durante el periodo de prácticas se tendrá contacto con menores</span>\n</md-checkbox></md-input-container></div><div data-layout=\"column\" data-layout-align=\"start start\" \ndata-ng-if=\"vm.offersDegrees.count>0\" layout-wrap class=\"fullwidth md-whiteframe-z1 mt-30 mb-30\" \nng-include=\"\'app/main/offers/views/detail/offer-degrees.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"vm.offersLanguages.count>0\" ng-include=\"\'app/main/offers/views/detail/offer-languages.html\'\"></div><div \ndata-layout=\"column\" data-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"vm.offersSkills.count>0\" ng-include=\"\'app/main/offers/views/detail/offer-skills.html\'\"></div><div \ndata-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start center\" layout-wrap><div \nclass=\"mr-50 border-bottom\"><h4 data-translate>Disponibilidad</h4><span ng-if=\"vm.offer.availability===\'indifferent\'\" \ndata-translate>Indiferente</span> <span ng-if=\"vm.offer.availability===\'morning\'\" data-translate>Mañanas</span> <span \nng-if=\"vm.offer.availability===\'afternoon\'\" data-translate>Tardes</span></div><div class=\"mr-50 border-bottom\"><h4 \ndata-translate>Carnet de conducir</h4><span ng-if=\"vm.offer.driven_license===\'none\'\" data-translate>Ninguno</span> \n<span ng-if=\"vm.offer.driven_license===\'A\'\">A</span> <span ng-if=\"vm.offer.driven_license===\'B\'\">B</span> <span \nng-if=\"vm.offer.driven_license===\'C\'\">C</span> <span ng-if=\"vm.offer.driven_license===\'D\'\">D</span> <span \nng-if=\"vm.offer.driven_license===\'E\'\">E</span></div><md-input-container><md-checkbox ng-model=\"vm.offer.own_vehicle\" \naria-label=\"{{\'Vehículo propio\'}}\" disabled=\"disabled\" class=\"md-align-top-left\" flex><span data-translate>\nVehículo propio</span></md-checkbox></md-input-container></div></div><div class=\"md-whiteframe-z1 p-20\" flex=\"35\" \nflex-xs=\"100\" ng-include=\"\'app/main/offers/views/detail/offer-company.html\'\"></div></div><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap><div class=\"md-block border-bottom\" flex=\"45\" \nflex-xs=\"100\"><h4 data-translate>Proyecto formativo (actividades a desarrollar)</h4><span>{{vm.offer.objectives}}\n</span></div></div><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap>\n<div class=\"md-block border-bottom\" flex=\"45\" flex-xs=\"100\"><h4 data-translate>Observaciones</h4><span>\n{{vm.offer.observations}}</span></div></div><div layout=\"row\" layout-align=\"start center\" class=\"mt-50 mb-50\">\n<md-button data-debouce-click type=\"submit\" ng-click=\"vm.saveOffersRequest(\'accepted\')\" \nclass=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'PATCH\') &&\n                                                   vm.myOfferRequest &&\n                                                   vm.myOfferRequest.status===\'selected\'\" \naria-label=\"{{\'Solicitar plaza\' | translate}}\"><span data-translate>Aceptar plaza</span></md-button><md-button \ndata-debouce-click type=\"submit\" ng-click=\"vm.saveOffersRequest(\'rejected\')\" class=\"send-button md-warn md-raised\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'PATCH\') &&\n                                                   vm.myOfferRequest &&\n                                                   vm.myOfferRequest.status===\'selected\'\" \naria-label=\"{{\'Solicitar plaza\' | translate}}\"><span data-translate>Rechazar plaza</span></md-button><md-button \ndata-debouce-click type=\"submit\" ng-click=\"vm.saveOffersRequest()\" class=\"send-button md-accent md-raised\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'POST\') && !vm.myOfferRequest\" \naria-label=\"{{\'Solicitar plaza\' | translate}}\"><span data-translate>Solicitar plaza</span></md-button></div></form>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/offers/views/edit/offer-company.html","<div class=\"mb-20 detail-company\" data-ng-if=\"!hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\">\n</md-icon><span class=\"ml-20\">{{vm.offer.company.business_name}}</span></div><div \nui-sref=\"app.company.detail({id:\'{{vm.offer.company.id}}\'})\" class=\"mb-20 detail-company pointer\" \ndata-ng-if=\"hasPermission(\'companyList\',\'GET\')\"><md-icon md-font-icon=\"icon-domain\"></md-icon><span class=\"ml-20\">\n{{vm.offer.company.business_name}}</span></div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap>\n<md-input-container class=\"sede\" ng-if=\"!vm.centers.length<1\"><label data-translate>Centro de trabajo</label><md-select\n data-ng-model=\"vm.offer.seat_data.id\" name=\"seat\" ng-disabled=\"vm.disabledInputs\"><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name || center.address}}</md-option>\n</md-select></md-input-container><md-autocomplete \nmd-floating-label=\"{{(UCA_COMPANY_CIF===vm.offer.company.identification)?\'Sede de la UCA\':\'Centro de trabajo\' | translate}}\" \nmd-delay=\"300\" md-input-name=\"seat\" md-min-length=\"3\" md-selected-item=\"vm.offer.seat_data\" \nmd-search-text=\"searchTextCenter\" ng-if=\"vm.centers.length<1\" ng-disabled=\"vm.disabledInputs\" \nmd-items=\"center in vm.getCenters(searchTextCenter)\" class=\"fullwidth\" md-item-text=\"vm.getFullNameCenter(center)\" \nplaceholder=\"{{\'Centro de trabajo\' | translate}}\"><md-item-template><span md-highlight-text=\"searchTextCenter\">\n{{vm.getFullNameCenter(center)}}</span></md-item-template><md-not-found><span \nng-if=\"UCA_COMPANY_CIF!==vm.offer.company.identification\" data-translate>No hay ningún centro con ese nombre</span> \n<span ng-if=\"UCA_COMPANY_CIF===vm.offer.company.identification\" data-translate>No hay ninguna sede con ese nombre\n</span></md-not-found></md-autocomplete><md-input-container class=\"no-margin\"><error-messages field=\"offerForm.seat\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><div class=\"pl-20 mb-20\" \nng-if=\"vm.offer.seat_data\"><div class=\"secondary-text\" data-ng-if=\"vm.offer.seat_data.address\"><md-icon \nmd-font-icon=\"icon-map-marker\" class=\"icon\"></md-icon><span>{{vm.offer.seat_data.address}}</span></div><div \nclass=\"secondary-text\" data-ng-if=\"vm.offer.seat_data.town_data\"><md-icon md-font-icon=\"icon-map-marker\" class=\"icon\">\n</md-icon><span>{{vm.offer.seat_data.town_data.name}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.seat_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.offer.seat_data.email}}</span></div><div class=\"secondary-text\" data-ng-if=\"vm.offer.seat_data.phone\"><md-icon \nmd-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>{{vm.offer.seat_data.phone}}</span></div></div></div><div \nng-if=\"vm.offer.company.identification === UCA_COMPANY_CIF && !vm.offer.schedule\"><md-input-container><label \ndata-translate>Orgánica</label><input name=\"organic\" data-ng-model=\"vm.offer.organic\" ng-disabled=\"vm.disabledInputs\">\n<error-messages field=\"offerForm.organic\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div>\n<div><md-input-container><label data-translate>Departamento / Área</label><input name=\"department\" \ndata-ng-model=\"vm.offer.department\" ng-disabled=\"vm.disabledInputs\"><error-messages field=\"offerForm.department\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap><h2 data-translate>Contactos</h2><md-input-container \nng-if=\"!vm.tutors.length<1\"><label data-translate>Tutor profesional</label><md-select \ndata-ng-model=\"vm.offer.professional_tutor_data.id\" name=\"professional_tutor\" ng-disabled=\"vm.disabledInputs\">\n<md-option data-ng-repeat=\"tutor in vm.tutors\" data-ng-value=\"tutor.id\">\n{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}</md-option></md-select></md-input-container><md-autocomplete \nmd-floating-label=\"{{\'Tutor profesional\' | translate}}\" md-delay=\"300\" md-input-name=\"professional_tutor\" \nmd-min-length=\"3\" md-selected-item=\"vm.offer.professional_tutor_data\" md-search-text=\"searchTextProfessionalTutor\" \nng-if=\"vm.tutors.length<1\" md-items=\"professionalTutor in vm.getProfessionalTutors(searchTextProfessionalTutor)\" \nclass=\"fullwidth\" md-item-text=\"vm.getFullNameTutor(professionalTutor)\" \nplaceholder=\"{{\'Tutor profesional\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextProfessionalTutor\">{{vm.getFullNameTutor(professionalTutor)}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ningún tutor con ese nombre</span></md-not-found></md-autocomplete>\n<md-input-container class=\"no-margin\"><error-messages field=\"offerForm.professional_tutor\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><div class=\"pl-20 mb-20\" \nng-if=\"vm.offer.professional_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.professional_tutor_data.user.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.offer.professional_tutor_data.user.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.professional_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.offer.professional_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.professional_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.offer.professional_tutor_data.mobile}}</span></div></div><md-input-container \nng-if=\"!vm.managementContacts.length<1\"><label data-translate>Gestión</label><md-select \ndata-ng-model=\"vm.offer.management_contact_data.id\" name=\"management_contact\" ng-disabled=\"vm.disabledInputs\">\n<md-option data-ng-repeat=\"managementContact in vm.managementContacts\" data-ng-value=\"managementContact.id\">\n{{managementContact.name}} {{managementContact.surname}} {{managementContact.second_surname}}</md-option></md-select>\n</md-input-container><md-autocomplete md-floating-label=\"{{\'Gestión\' | translate}}\" md-delay=\"300\" \nmd-input-name=\"management_contact\" md-min-length=\"3\" md-selected-item=\"vm.offer.management_contact_data\" \nmd-search-text=\"searchTextManagementContact\" ng-if=\"vm.managementContacts.length<1\" \nmd-items=\"managementContact in vm.getManagementContacts(searchTextManagementContact)\" class=\"fullwidth\" \nmd-item-text=\"vm.getFullNameTutor(managementContact)\" placeholder=\"{{\'Gestión\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextManagementContact\">{{vm.getFullNameTutor(managementContact)}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ningún gestor con ese nombre</span></md-not-found></md-autocomplete>\n<md-input-container class=\"no-margin\"><error-messages field=\"offerForm.management_contact\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><div class=\"pl-20 mb-20\" \nng-if=\"vm.offer.management_contact_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.management_contact_data.user.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon>\n<span>{{vm.offer.management_contact_data.user.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.management_contact_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.offer.management_contact_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.management_contact_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\">\n</md-icon><span>{{vm.offer.management_contact_data.mobile}}</span></div></div><md-autocomplete \nmd-floating-label=\"{{\'Tutor académico\' | translate}}\" md-delay=\"300\" md-input-name=\"academic_tutor\" md-min-length=\"3\" \nmd-selected-item=\"vm.offer.academic_tutor_data\" md-search-text=\"searchTextTutor\" \ndata-ng-if=\"vm.user.group_type===\'manager\'\" md-items=\"tutor in vm.getTutors(searchTextTutor)\" \nmd-item-text=\"vm.getFullNameTutor(tutor)\" placeholder=\"{{\'Tutor académico\' | translate}}\"><md-item-template><span \nmd-highlight-text=\"searchTextTutor\">{{vm.getFullNameTutor(tutor)}}</span></md-item-template><md-not-found><span \ndata-translate>No hay ningún tutor con ese nombre</span></md-not-found></md-autocomplete><md-input-container \nclass=\"no-margin\"><error-messages field=\"offerForm.academic_tutor\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container><div class=\"pl-20 mb-20\" ng-if=\"vm.offer.academic_tutor_data\"><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.academic_tutor_data.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.offer.academic_tutor_data.email}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.academic_tutor_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"icon\"></md-icon><span>\n{{vm.offer.academic_tutor_data.phone}}</span></div><div class=\"secondary-text\" \ndata-ng-if=\"vm.offer.academic_tutor_data.mobile\"><md-icon md-font-icon=\"icon-cellphone-iphone\" class=\"icon\"></md-icon>\n<span>{{vm.offer.academic_tutor_data.mobile}}</span></div></div></div><md-input-container><md-content \nclass=\"content-normative\" ms-scroll><p ng-bind-html=\"vm.offer.normative\"></p></md-content><md-checkbox \nname=\"accepted_regulations\" ng-model=\"vm.offer.accept\" aria-label=\"{{\'Acepto la normativa\' | translate}}\" \nclass=\"md-align-top-left\" flex ng-disabled=\"vm.disabledInputs\"><span data-translate>Acepto la normativa</span>\n</md-checkbox><error-messages field=\"offerForm.accepted_regulations\" server-errors=\"vm.serverErrors\" forcechange>\n</error-messages></md-input-container>");
$templateCache.put("app/main/offers/views/edit/offer-degrees.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Titulaciones requeridas</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openOffersDegreeDialog($event)\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'offersDegrees\',\'POST\')\" \naria-label=\"{{\'Añadir titulación\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.offersDegrees.count<1\" class=\"todo-item\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>\nNo hay titulaciones seleccionadas</div></div></div></div></div></div></div><div \nng-repeat=\"offersDegree in vm.offersDegrees.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">{{offersDegree.degree_data.name}}</div></div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'offersDegrees\',\'DELETE\')\" \ndata-ng-click=\"vm.removeOffersDegree($event, offersDegree)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div></md-content>");
$templateCache.put("app/main/offers/views/edit/offer-languages.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Idiomas</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openOffersLanguageDialog($event)\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'offersLanguages\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.offersLanguages.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>No hay idiomas seleccionados\n</div></div></div></div></div></div></div><div data-ng-repeat=\"offerLanguage in vm.offersLanguages.data\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\">{{offerLanguage.language_data.name}}</div>\n</div><div class=\"tasktable\" flex=\"auto\"><table class=\"simple small\" ms-responsive-table><thead><tr><th \nclass=\"text-center\"><md-icon title=\"Lectura\" md-font-icon=\"icon-book-open\"></md-icon></th><th class=\"text-center\">\n<md-icon title=\"Conversación\" md-font-icon=\"icon-account-multiple-outline\"></md-icon></th><th class=\"text-center\">\n<md-icon title=\"Escritura\" md-font-icon=\"icon-pencil\"></md-icon></th></tr></thead><tbody><tr><td class=\"text-center\">\n{{offerLanguage.reading_level | level}}</td><td class=\"text-center\">{{offerLanguage.speaking_level | level}}</td><td \nclass=\"text-center\">{{offerLanguage.writing_level | level}}</td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'offersLanguages\',\'PATCH\')\" \ndata-ng-click=\"vm.openOffersLanguageDialog($event, offerLanguage)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Editar\' | translate}}\" md-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span>\n</md-button><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'offersLanguages\',\'DELETE\')\" \ndata-ng-click=\"vm.removeOffersLanguage($event, offerLanguage)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/offers/views/edit/offer-requests.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Candidatos seleccionados</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openOffersRequestDialog($event)\" \ndata-ng-if=\"vm.offersRequests.count<vm.offer.seats && hasPermission(\'offersRequests\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.offersRequests.count<1\" \nclass=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>\nNo hay candidatos seleccionados</div></div></div></div></div></div></div><div \nng-repeat=\"offersRequest in vm.offersRequests.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{offersRequest.student_data.contact_student.identification || offersRequest.student_data.contact_student_data.identification}}\n</div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'offersRequests\',\'PATCH\')\" \ndata-ng-click=\"vm.removeOffersRequest($event, offersRequest)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Descartar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Descartar\n</span></md-button><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'PATCH\')\" data-ng-click=\"vm.openOffersStudentDialog($event, offersRequest)\">\n<md-icon class=\"pt-5\" title=\"{{\'Ver ficha\' | translate}}\" md-font-icon=\"icon-clipboard-account\"></md-icon><span \nclass=\"pt-5\" data-translate>Ver ficha</span></md-button></div></div></div></div></div></md-content>");
$templateCache.put("app/main/offers/views/edit/offer-skills.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><h2 \nclass=\"md-flex\" data-translate>Competencias</h2><md-button class=\"md-icon-button\" \nng-click=\"vm.openOffersSkillDialog($event)\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'offersSkills\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</md-toolbar><md-content layout-padding class=\"fullwidth\"><div data-ng-if=\"vm.offersSkills.count<1\" class=\"todo-item\">\n<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\" data-translate>\nNo hay competencias seleccionadas</div></div></div></div></div></div></div><div \nng-repeat=\"offerSkill in vm.offersSkills.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">{{offerSkill.skill_data.name}}</div><div \nclass=\"tags\" layout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><strong data-translate>Categoria:</strong><div class=\"ml-10 tag-label\">\n{{offerSkill.skill_data.category_data.name}}</div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\">\n<strong data-translate>Nivel:</strong><div class=\"ml-10 tag-label\">{{offerSkill.level | level}}</div></div></div></div>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" \ndata-layout-align=\"start center\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'offersSkills\',\'PATCH\')\" \ndata-ng-click=\"vm.openOffersSkillDialog($event, offerSkill)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-pencil\"></md-icon><span class=\"pt-5\" data-translate>Editar</span></md-button><md-button \ndata-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'offersSkills\',\'DELETE\')\" \ndata-ng-click=\"vm.removeOffersSkill($event, offerSkill)\"><md-icon class=\"pt-5\" title=\"{{\'Eliminar\' | translate}}\" \nmd-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar</span></md-button></div></div></div>\n</div></div></md-content>");
$templateCache.put("app/main/offers/views/edit/offer.html","<div id=\"offer-edit\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/offers/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><md-icon \nmd-font-icon=\"icon-multiplication-box\"></md-icon><span data-translate>Datos básicos</span></div></div><div \ndata-layout=\"column\" data-layout-align=\"space-between end\" data-layout-wrap><div class=\"actions\" data-layout=\"row\" \ndata-layout-align=\"end center\"><md-button class=\"md-raised md-primary\" aria-label=\"{{\'Solicitar oferta\' | translate}}\" \nng-click=\"vm.publishOffer()\" ng-if=\"hasPermission(\'offersPublished\',\'POST\') && vm.offer.status===\'draft\'\"><span \ndata-translate>Solicitar oferta</span></md-button><md-button class=\"md-raised md-primary\" \naria-label=\"{{\'Aceptar solicitud\' | translate}}\" \ndata-ng-if=\"hasPermission(\'offersConfirmed\',\'POST\') && (vm.offer.status===\'draft\' || vm.offer.status===\'pending\')\" \nng-click=\"vm.confirmOffer()\"><span data-translate>Aceptar solicitud</span></md-button></div><div \nclass=\"white-fg mt-20\" layout=\"column\" layout-align=\"start start\"><div class=\"h3\" layout=\"column\" \nlayout-align=\"end end\"><span><span data-translate>Oferta:</span> <span>{{vm.offer.code}}</span> </span><span><span \ndata-translate>Programa:</span> <span>{{vm.offer.program_data.name}}</span></span></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content\n class=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-xs=\"column\" layout-align=\"space-between start\" flex>\n<form name=\"offerForm\" class=\"md-inline-form ms-form-wizard-form fullwidth\" novalidate><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"space-between start\" layout-wrap><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><div><md-input-container><label data-translate>Número de plazas</label>\n<input name=\"seats\" data-ng-model=\"vm.offer.seats\" required ng-disabled=\"vm.disabledInputs\"><error-messages \nfield=\"offerForm.seats\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></div><div\n data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start start\" layout-wrap><div><md-input-container><h4 \ndata-translate>Fecha inicio</h4><md-datepicker name=\"start_date\" data-ng-model=\"vm.offer.start_date\" \nmd-placeholder=\"dd/mm/yyyy\" required ng-disabled=\"vm.offer.signed\"></md-datepicker><error-messages \nfield=\"offerForm.start_date\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container></div><div class=\"mr-50 duration-group\"><h4 data-translate>Duración</h4><div layout=\"row\">\n<md-input-container class=\"months duration-part\"><label data-translate>Meses</label><input type=\"number\" \nname=\"duration_months\" min=\"0\" step=\"1\" data-ng-model=\"vm.durationMonths\" required ng-disabled=\"vm.disabledInputs\" \nng-change=\"vm.updateDurationDays(offerForm)\" ng-blur=\"vm.durationBlur()\"></md-input-container><md-input-container \nclass=\"months duration-part\"><label data-translate>Días</label><input type=\"number\" name=\"duration_days_part\" min=\"0\" \nstep=\"1\" data-ng-model=\"vm.durationDays\" required ng-disabled=\"vm.disabledInputs\" \nng-change=\"vm.updateDurationDays(offerForm)\" ng-blur=\"vm.durationBlur()\"></md-input-container></div><div \nclass=\"duration-errors\"><error-messages field=\"offerForm.duration_months\" server-errors=\"vm.serverErrors\" required>\n</error-messages><div class=\"ng-hide\"><error-messages field=\"offerForm.duration_days_part\" \nserver-errors=\"vm.serverErrors\"></error-messages></div><error-messages field=\"offerForm.duration_days_part\" required>\n</error-messages></div></div><div class=\"mr-50 mt-50\"><md-input-container class=\"months\"><label data-translate>\nHoras totales</label><input type=\"number\" name=\"total_hours\" data-ng-model=\"vm.offer.total_hours\" required \nng-disabled=\"vm.disabledInputs\"><error-messages field=\"offerForm.total_hours\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div><div class=\"mt-50\" layout=\"column\"><div><md-input-container class=\"eur\">\n<label data-translate>Dotación mensual bruta (€)</label><input type=\"number\" name=\"economic_endowment\" \ndata-ng-model=\"vm.offer.economic_endowment\" required ng-disabled=\"vm.disabledInputs\" \nng-blur=\"vm.cofinancingCalculate()\"><error-messages field=\"offerForm.economic_endowment\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-button class=\"md-fab md-mini\" \naria-label=\"cofinanciación\" data-ng-if=\"hasPermission(\'offerCofinancingCalculate\',\'GET\')\" \nng-click=\"vm.cofinancingCalculate()\"><md-icon md-font-icon=\"icon-calculator\"></md-icon><md-tooltip \nmd-direction=\"right\"><span translate>Calcular cofinanciación</span></md-tooltip></md-button></div><span class=\"hint\">\n{{vm.messageCofinance}}</span></div></div><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"m-0\"><md-checkbox \nng-model=\"vm.offer.has_interruption\" aria-label=\"{{\'checkbox interruption\'}}\" class=\"md-align-top-left\" flex \nng-disabled=\"vm.disabledInputs\"><span data-translate>\nDurante el periodo de prácticas existirá interrupción de las mismas</span></md-checkbox></md-input-container></div><div\n data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start center\" layout-wrap \nng-if=\"vm.offer.has_interruption\"><div><md-input-container class=\"mt-0\"><h4 data-translate>Fecha inicio interrupción\n</h4><md-datepicker name=\"start_date_interruption\" data-ng-model=\"vm.offer.start_date_interruption\" \nng-disabled=\"vm.disabledInputs\" md-placeholder=\"dd/mm/yyyy\" required></md-datepicker><error-messages \nfield=\"offerForm.start_date_interruption\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container></div><div><md-input-container class=\"mt-0\"><h4 data-translate>Fecha fin interrupción</h4>\n<md-datepicker name=\"end_date_interruption\" data-ng-model=\"vm.offer.end_date_interruption\" \nng-disabled=\"vm.disabledInputs\" md-placeholder=\"dd/mm/yyyy\" required></md-datepicker><error-messages \nfield=\"offerForm.end_date_interruption\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container></div></div><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start center\" \nlayout-wrap><md-input-container class=\"m-0\"><md-checkbox ng-model=\"vm.offer.contact_with_minors\" \naria-label=\"{{\'checkbox contact with minors\'}}\" class=\"md-align-top-left\" flex ng-disabled=\"vm.disabledInputs\"><span \ndata-translate>Durante el periodo de prácticas se tendrá contacto con menores</span></md-checkbox></md-input-container>\n</div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap \nclass=\"fullwidth md-whiteframe-z1 mt-30 mb-30\" ng-include=\"\'app/main/offers/views/edit/offer-degrees.html\'\"></div><div \ndata-layout=\"column\" data-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/offers/views/edit/offer-languages.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/offers/views/edit/offer-skills.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"hasPermission(\'offersRequests\',\'LIST\')\" ng-include=\"\'app/main/offers/views/edit/offer-requests.html\'\">\n</div><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"start center\" layout-wrap><md-input-container \nclass=\"mr-20\"><label data-translate>Disponibilidad</label><md-select data-ng-model=\"vm.offer.availability\" \nname=\"availability\" ng-disabled=\"vm.disabledInputs\"><md-option value=\"indifferent\"><span data-translate>Indiferente\n</span></md-option><md-option value=\"morning\"><span data-translate>Mañanas</span></md-option><md-option \nvalue=\"afternoon\"><span data-translate>Tardes</span></md-option></md-select><error-messages \nfield=\"offerForm.availability\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container class=\"mr-20\"><label data-translate>Carnet de conducir</label><md-select \ndata-ng-model=\"vm.offer.driven_license\" name=\"driven_license\" ng-disabled=\"vm.disabledInputs\"><md-option value=\"none\">\n<span data-translate>Ninguno</span></md-option><md-option value=\"A\"><span>A</span></md-option><md-option value=\"B\">\n<span>B</span></md-option><md-option value=\"C\"><span>C</span></md-option><md-option value=\"D\"><span>D</span>\n</md-option><md-option value=\"E\"><span>E</span></md-option></md-select><error-messages \nfield=\"offerForm.driven_license\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container><md-checkbox ng-model=\"vm.offer.own_vehicle\" aria-label=\"{{\'checkbox contact with minors\'}}\" \nng-disabled=\"vm.disabledInputs\" class=\"md-align-top-left\" flex><span data-translate>Vehículo propio</span>\n</md-checkbox></md-input-container></div></div><div class=\"md-whiteframe-z1 p-20\" flex=\"35\" flex-xs=\"100\" \nng-include=\"\'app/main/offers/views/edit/offer-company.html\'\"></div></div><div data-layout-xs=\"column\" \ndata-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap><md-input-container class=\"md-block\" flex=\"45\" \nflex-xs=\"100\"><label data-translate>Proyecto formativo (actividades a desarrollar)</label><textarea name=\"objectives\" \nng-model=\"vm.offer.objectives\" max-rows=\"5\" ng-disabled=\"vm.disabledInputs\"></textarea><error-messages \nfield=\"offerForm.objectives\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div \ndata-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"space-between center\" layout-wrap><md-input-container \nclass=\"md-block\" flex=\"45\" flex-xs=\"100\"><label data-translate>Observaciones públicas</label><textarea \nname=\"observations\" ng-model=\"vm.offer.observations\" max-rows=\"5\" ng-disabled=\"vm.disabledInputs\"></textarea>\n<error-messages field=\"offerForm.observations\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container class=\"md-block\" flex=\"45\" flex-xs=\"100\"><label data-translate>Observaciones privadas</label>\n<textarea name=\"private_observations\" ng-model=\"vm.offer.private_observations\" max-rows=\"5\"></textarea><error-messages \nfield=\"offerForm.private_observations\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div\n layout=\"row\" layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" ng-click=\"vm.saveOffer()\" \nclass=\"send-button md-accent md-raised\" data-ng-if=\"hasPermission(\'offers\',\'PATCH\')\" \nng-disabled=\"offerForm.$invalid || offerForm.$pristine || vm.offer.signed\" aria-label=\"{{\'Guardar\' | translate}}\"><span\n data-translate>Guardar</span></md-button><md-button ng-click=\"vm.openOffersTemplateDialog()\" \nclass=\"md-accent md-raised\" data-ng-if=\"hasPermission(\'offersTemplatesCreate\',\'POST\')\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar como plantilla</span></md-button></div></form>\n</div></md-content></div></div></div>");
$templateCache.put("app/main/offers/views/list/offers.html","<div id=\"offers\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-multiplication-box\"></md-icon><span>Ofertas</span></div><div class=\"count secondary-text\">\n<span data-translate>Número de ofertas:</span> <span>{{vm.offers.count}}</span></div></div><div data-layout=\"row\" \ndata-layout-align=\"end start\" data-layout-wrap><ng-include data-layout=\"row\" data-layout-align=\"end start\" \nsrc=\"\'app/main/searchsAdvances/searchsBasics.html\'\" ng-init=\"module=\'offers\'\"></ng-include><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'offers\',\'POST\')\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Nueva oferta\' | translate}}\" data-ng-click=\"vm.openOfferDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nueva oferta</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><md-content class=\"content p-20\" flex ms-scroll><div \nlayout=\"column\" layout-align=\"space-between start\"><div class=\"no-results text-center\" ng-if=\"vm.offers.count == 0\">\n<div class=\"message\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-multiplication-box\"></md-icon><div \nclass=\"message-text\" translate>Sin ofertas</div></div></div><div class=\"todo-item\" layout=\"row\" \nlayout-align=\"start center\" md-ink-ripple \nng-class=\"{\'pointer\':hasPermission(\'offers\',\'GET\') || hasPermission(\'offers\',\'PATCH\')}\" data-ng-click=\"vm.go(offer)\" \ndata-dir-paginate=\"offer in vm.offers.data | itemsPerPage: 10 | orderBy:\'order\'\" data-total-items=\"vm.offers.count\" \ndata-current-page=\"vm.offers.filters.page\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" \nflex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\">{{offer.company_name}} -<ng-pluralize count=\"offer.seats\" \nwhen=\"{\'0\': \'Plazas\',\n                                                                     \'one\': \'1 Plaza\',\n                                                                     \'other\': \'{} Plazas\'}\">\n</ng-pluralize></div><div class=\"tags\" layout=\"column\" layout-align=\"start start\" layout-wrap><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-multiplication-box\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span data-translate>Oferta:\n</span> <span>{{offer.code}}</span></div></div><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span>\n{{offer.start_date | date:\'dd/MM/yyyy\'}}</span></div></div><div ng-if=\"offer.program_name\" class=\"tag\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-star\" class=\"s16\"></md-icon><div class=\"ml-10 tag-label\"><span>\n{{offer.program_name}}</span></div></div></div><div class=\"mt-8\" ng-if=\"vm.user.group_type!==\'student\'\"><span \nclass=\"text-boxed m-0 white-fg orange-bg\" data-ng-if=\"offer.status === \'draft\'\">No publicada </span><span \nclass=\"text-boxed m-0 white-fg purple-bg\" data-ng-if=\"offer.status === \'pending\'\">Pendiente </span><span \nclass=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"offer.status === \'published\'\">Publicada </span><span \nclass=\"text-boxed m-0 white-fg green-bg\" data-ng-if=\"offer.status === \'filed\'\">Finalizada</span></div><div \nclass=\"mt-8\" ng-if=\"offer.pending_validation\"><span class=\"text-boxed m-0 white-fg blue-bg\">\n{{offer.pending_validation}} <span data-translate>candidatos pendientes de validar</span></span></div><div \nclass=\"mt-8\" ng-if=\"offer.request_status\"><span class=\"text-boxed m-0 white-fg blue-bg\">{{offer.request_status}}</span>\n</div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" \ndata-layout-align=\"start center\" data-ng-if=\"hasPermission(\'offers\',\'DELETE\')\" \ndata-ng-click=\"vm.removeOffer($event, offer);$event.stopPropagation()\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><dir-pagination-controls class=\"bottomFixed\">\n</dir-pagination-controls></div></md-content></div></div></div>");
$templateCache.put("app/main/offersRequests/dialogs/offersRequest/offersRequest-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersRequestForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"identification\" data-ng-model=\"vm.offersRequest.identification\" \nplaceholder=\"{{\'Identificación\' | translate}}\" required><error-messages field=\"offersRequestForm.identification\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersRequest()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"offersRequestForm.$invalid || offersRequestForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/offersRequests/dialogs/offersStudent/offersStudent-dialog.html","<md-dialog id=\"offerStudentDialog\" class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersStudentForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \ndata-layout=\"row\" data-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"row\" \nclass=\"mb-50\" data-layout-align=\"space-between start\"><div data-layout=\"row\"><img ng-src=\"{{vm.photo}}\" \nalt=\"Imágen de perfil\" class=\"mr-20 avatar-100\"><div><div class=\"mb-10\"><strong>\n{{vm.offersStudent.student_data.contact_student_data.name}} {{vm.offersStudent.student_data.contact_student_data.surname}} {{vm.offersStudent.student_data.contact_student_data.second_surname}}\n</strong></div><div><md-icon md-font-icon=\"icon-folder-account\" class=\"s16\"></md-icon><span>\n{{vm.offersStudent.student_data.contact_student.identification || vm.offersStudent.student_data.contact_student_data.identification}}\n</span></div><div ng-if=\"vm.offersStudent.student_data.contact_student_data.email\"><md-icon md-font-icon=\"icon-email\" \nclass=\"s16\"></md-icon><span>{{vm.offersStudent.student_data.contact_student_data.email}}</span></div><div \nng-if=\"vm.offersStudent.student_data.contact_student_data.phone\"><md-icon md-font-icon=\"icon-phone\" class=\"s16\">\n</md-icon><span>{{vm.offersStudent.student_data.contact_student_data.phone}}</span></div><div data-layout=\"row\" \nng-repeat=\"degrees in vm.offersStudent.student_data.degrees_data\"><div layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><div class=\"mr-50\"><div class=\"title\">{{degrees.id}} - {{degrees.name}}</div><div>\n<span class=\"text-boxed m-0 white-fg indigo-bg\"><span data-translate>Calificación:</span> <span>\n{{degrees.qualification || \"?\"}}</span></span></div></div></div></div></div></div><div data-layout=\"column\" \ndata-layout-align=\"end end\"><div data-layout=\"row\" data-layout-align=\"end center\" \nng-if=\"vm.offersStudent.student_data.professional_cv_data\"><md-button \ndata-ng-click=\"vm.getDocument(vm.offersStudent.student_data.professional_cv_data)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"{{\'CV profesional\' | translate}}\"><span data-translate>\nCV profesional</span></md-button><md-button class=\"md-icon-button md-raised\" \nng-if=\"vm.isPrintable(vm.offersStudent.student_data.professional_cv_data)\" \ndata-ng-click=\"vm.printDocument(vm.offersStudent.student_data.professional_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV profesional\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV profesional</span></md-tooltip></md-button></div><div \ndata-layout=\"row\" data-layout-align=\"end center\" ng-if=\"vm.offersStudent.student_data.researcher_cv_data\"><md-button \ndata-ng-click=\"vm.getDocument(vm.offersStudent.student_data.researcher_cv_data)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"{{\'CV investigador\' | translate}}\"><span data-translate>\nCV investigador</span></md-button><md-button class=\"md-icon-button md-raised\" \nng-if=\"vm.isPrintable(vm.offersStudent.student_data.researcher_cv_data)\" \ndata-ng-click=\"vm.printDocument(vm.offersStudent.student_data.researcher_cv_data, $event)\" \naria-label=\"{{\'Imprimir CV investigador\' | translate}}\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip \nmd-direction=\"bottom\"><span translate>Imprimir CV investigador</span></md-tooltip></md-button></div></div></div><div \nclass=\"md-whiteframe-z1 p-20 mb-40\" \nng-repeat=\"qualification in vm.offersStudent.student_data.contact_student_data.qualifications\" \nng-include=\"\'app/main/students/studentsDetail/student-degrees.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"vm.studentsSkills.count>0\" ng-include=\"\'app/main/students/studentsDetail/student-skills.html\'\"></div><div \ndata-layout=\"column\" data-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"vm.studentsLanguages.count>0\" ng-include=\"\'app/main/students/studentsDetail/student-languages.html\'\"></div>\n</div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\" \nng-if=\"vm.offersStudent.status!==\'discarded\' &&\n                                                                                            vm.offersStudent.status!==\'rejected\'\">\n<div data-layout=\"row\" data-layout-align=\"start center\" ng-if=\"vm.offersStudent.status!==\'pre-signed up\'\"><md-button \ndata-debouce-click type=\"submit\" \nng-if=\"vm.offersStudent.status!==\'pre-selected\' &&\n                                                                    vm.offersStudent.status!==\'selected\' &&\n                                                                    vm.offersStudent.status!==\'accepted\'\" \ndata-ng-click=\"vm.saveOffersStudent(\'pre-selected\')\" class=\"white-fg orange-bg md-raised\" \naria-label=\"{{\'Preseleccionar\' | translate}}\"><span data-translate>Preseleccionar</span></md-button><md-button \ndata-debouce-click type=\"submit\" ng-if=\"vm.offersStudent.status!==\'discarded\'\" \ndata-ng-click=\"vm.saveOffersStudent(\'discarded\')\" class=\"md-warn md-raised\" aria-label=\"{{\'Descartar\' | translate}}\">\n<span data-translate>Descartar</span></md-button></div><div data-layout=\"row\" data-layout-align=\"start center\" \nng-if=\"vm.offersStudent.status!==\'pre-signed up\'\"><md-button data-debouce-click type=\"submit\" \nng-if=\"vm.offersStudent.status!==\'selected\' &&\n                                                                    vm.offersStudent.status!==\'accepted\'\" \ndata-ng-click=\"vm.saveOffersStudent(\'selected\')\" class=\"md-accent md-raised\" \naria-label=\"{{\'Seleccionar para la oferta\' | translate}}\"><span data-translate>Seleccionar para la oferta</span>\n</md-button></div><div data-layout=\"row\" data-layout-align=\"start center\" \nng-if=\"vm.offersStudent.status===\'pre-signed up\'\"><md-button data-debouce-click type=\"submit\" \nclass=\"md-accent md-raised\" data-ng-click=\"vm.confirmRequest()\" ng-if=\"vm.hasPermission(\'confirmRequest\',\'POST\')\" \naria-label=\"{{\'Mostrar solicitud a la empresa\' | translate}}\"><span data-translate>Mostrar solicitud a la empresa\n</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/offersTemplates/dialogs/offersTemplate/offersTemplate-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersTemplateForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"template_name\" data-ng-model=\"vm.offersTemplate.template_name\" \nplaceholder=\"{{\'Nombre de la plantilla\' | translate}}\" required><error-messages \nfield=\"offersTemplateForm.template_name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersTemplate()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersTemplateForm.$invalid || offersTemplateForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/programs/dialogs/program/program-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"programForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"name\" data-ng-model=\"vm.program.name\" placeholder=\"{{\'Nombre\' | translate}}\" required md-autofocus>\n<error-messages field=\"programForm.name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container flex=\"100\"><label data-translate>Descripción</label><textarea \nname=\"description\" data-ng-model=\"vm.program.description\"></textarea><error-messages field=\"programForm.description\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div data-layout=\"row\" \ndata-layout-align=\"start center\"><div class=\"mr-50\"><md-input-container><h4 data-translate>Fecha inicio</h4>\n<md-datepicker name=\"start_date\" data-ng-model=\"vm.program.start_date\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker>\n<error-messages field=\"programForm.start_date\" server-errors=\"vm.serverErrors\" forcechange></error-messages>\n</md-input-container></div><div><md-input-container><h4 data-translate>Fecha fin</h4><md-datepicker name=\"end_date\" \ndata-ng-model=\"vm.program.end_date\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><error-messages \nfield=\"programForm.end_date\" server-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div>\n</div><md-input-container data-layout=\"column\"><md-checkbox ng-model=\"vm.program.companies_visible\" \naria-label=\"{{\'Visible para empresas\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nVisible para empresas</span></md-checkbox><md-checkbox ng-model=\"vm.program.UCA_visible\" \naria-label=\"{{\'Visible para entidades UCA\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nVisible para entidades UCA</span></md-checkbox><md-checkbox ng-model=\"vm.program.student_nif_required\" \naria-label=\"{{\'Requiere que el alumno adjunte su DNI\' | translate}}\" class=\"md-align-top-left\" flex><span \ndata-translate>Requiere que el alumno adjunte su DNI</span></md-checkbox><md-checkbox \nng-model=\"vm.program.student_iban_required\" \naria-label=\"{{\'Requiere que el alumno adjunte documento acreditativo de cuenta bancaria\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>\nRequiere que el alumno adjunte documento acreditativo de cuenta bancaria</span></md-checkbox><md-checkbox \nng-model=\"vm.program.student_ss_required\" \naria-label=\"{{\'Requiere que el alumno adjunte el número de la seguridad social\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>Requiere que el alumno adjunte el número de la seguridad social\n</span></md-checkbox><md-checkbox ng-model=\"vm.program.liability_document\" \naria-label=\"{{\'Genera documento de responsabilidad civil\' | translate}}\" class=\"md-align-top-left\" flex><span \ndata-translate>Genera documento de responsabilidad civil</span></md-checkbox></md-input-container><md-input-container \nflex=\"100\"><input type=\"number\" name=\"min_monthly_payment\" data-ng-model=\"vm.program.min_monthly_payment\" \nplaceholder=\"{{\'Mínima retribución mensual\' | translate}}\"><error-messages field=\"programForm.min_monthly_payment\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"number\" name=\"max_monthly_payment\" data-ng-model=\"vm.program.max_monthly_payment\" \nplaceholder=\"{{\'Máxima retribución mensual\' | translate}}\"><error-messages field=\"programForm.max_monthly_payment\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container data-layout=\"column\">\n<md-checkbox ng-model=\"vm.program.payment_through_UCA\" aria-label=\"{{\'Cofinancia prórroga\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>Pago a través de la UCA</span></md-checkbox></md-input-container>\n<div data-layout=\"column\" ng-show=\"vm.program.payment_through_UCA\"><md-input-container flex=\"100\"><input type=\"text\" \nname=\"cofinancing_agency\" data-ng-model=\"vm.program.cofinancing_agency\" \nplaceholder=\"{{\'Organismo cofinanciación\' | translate}}\"><error-messages field=\"programForm.cofinancing_agency\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"number\" name=\"cofinancing_percent\" data-ng-model=\"vm.program.cofinancing_percent\" \nplaceholder=\"{{\'Porcentaje de cofinanciación\' | translate}}\"><error-messages field=\"programForm.cofinancing_percent\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"number\" name=\"max_monthly\" data-ng-model=\"vm.program.max_monthly\" \nplaceholder=\"{{\'Máximo mensual (€)\' | translate}}\"><error-messages field=\"programForm.max_monthly\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"number\" name=\"cofinancing_max_months\" data-ng-model=\"vm.program.cofinancing_max_months\" \nplaceholder=\"{{\'Máximo de meses de cofinanciación\' | translate}}\"><error-messages \nfield=\"programForm.cofinancing_max_months\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container data-layout=\"column\"><md-checkbox ng-model=\"vm.program.cofinancing_extension\" \naria-label=\"{{\'Cofinancia prórroga\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nCofinancia prórroga</span></md-checkbox></md-input-container></div><div ng-if=\"vm.program.events\"><h2 data-translate>\nNotificaciones que genera</h2><div data-ng-repeat=\"event in vm.program.events\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span>{{event.name}}</span><md-button class=\"send-button md-accent md-raised\" \ndata-ng-click=\"vm.closeDialog()\" \ndata-ui-sref=\"app.eventNotifications({\'category\':\'{{event.category}}\',\'event\':\'{{event.id}}\'})\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Ver notificaciones</span></md-button></div></div></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveProgram()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"programForm.$invalid || programForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/programs/dialogs/programManagers/programManagers-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"programManagerForm\" class=\"md-inline-form\" novalidate \ndata-form-translate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><div class=\"attachment-list p-20\"><div class=\"attachment\" data-layout=\"column\" \ndata-ng-repeat=\"manager in vm.programManagers.data\"><div data-layout=\"row\" data-layout-align=\"space-between center\">\n<div><span class=\"filename\" var-translate>{{manager.email}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"Delete attachment\" data-ng-click=\"vm.removeProgramManager($event,manager)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></div><md-dialog-content ms-scroll><div \ndata-layout-xs=\"column\" data-layout=\"column\"><md-input-container data-flex=\"100\"><input type=\"text\" name=\"email\" \ndata-ng-model=\"vm.programManager.email\" placeholder=\"{{\'Nuevo gestor\' | translate}}\" data-input-translate>\n<error-messages field=\"programManagerForm.email\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveProgramManager()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"programManagerForm.$invalid\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>\nGuardar nuevo gestor</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/programs/dialogs/programXls/programXls-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"programXlsForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\" \nlayout=\"column\"><md-button type=\"button\" class=\"md-accent md-raised\" ng-click=\"vm.openFiles()\"><span data-translate \nng-if=\"!vm.programXls.file && vm.type===\'student\'\">Subir XLS con alumnos autorizados</span> <span data-translate \nng-if=\"vm.programXls.file && vm.type===\'student\'\">Modificar XLS con alumnos autorizados</span> <span data-translate \nng-if=\"!vm.programXls.file && vm.type===\'company\'\">Subir XLS con empresas autorizadas</span> <span data-translate \nng-if=\"vm.programXls.file && vm.type===\'company\'\">Modificar XLS con empresas autorizadas</span></md-button><span \nclass=\"hint\" data-translate>Si sube un nuevo archivo reemplazará la configuración existente.</span> <span class=\"hint\" \ndata-translate>Si no añade nada todos los usuarios tendrán acceso a este programa.</span> <span class=\"hint\" \nng-if=\"vm.type===\'student\'\" data-translate>El formato del archivo debe ser un nif en una única columna.</span> <span \nclass=\"hint\" ng-if=\"vm.type===\'company\'\" data-translate>El formato del archivo debe ser un cif en una única columna.\n</span> <input type=\"file\" id=\"file-uploader\" ng-show=\"false\" name=\"file\" ng-model=\"vm.programXls.file\"><error-messages\n field=\"programXlsForm.file\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveProgramXls()\" class=\"send-button md-accent md-raised\" data-ng-disabled=\"!vm.programXls.file\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/pyconfrests/dialogs/pyconfrest/pyconfrest-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"pyconfrestForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div ng-if=\"vm.pyconfrest.choices.length<1\">\n<md-input-container data-flex=\"100\" class=\"fullwidth\" ng-if=\"vm.pyconfrest.type===\'CharField\'\"><label>\n{{vm.pyconfrest.verbose_name}}</label><input type=\"text\" name=\"{{vm.pyconfrest.key}}\" \ndata-ng-model=\"vm.pyconfrest.value\" md-autofocus><div class=\"hint\">{{vm.pyconfrest.help_text}}</div><error-messages \nfield=\"pyconfrestForm[vm.pyconfrest.key]\" server-errors=\"ExtraFields.serverErrors\"></error-messages>\n</md-input-container><md-input-container data-flex=\"100\" class=\"fullwidth\" ng-if=\"vm.pyconfrest.type===\'TextField\'\"><p>\n{{vm.pyconfrest.verbose_name}}</p><text-angular ng-if=\"vm.isRt(vm.pyconfrest.key)\" name=\"{{vm.pyconfrest.key}}\" \nta-toolbar=\"vm.taToolbar\" ng-model=\"vm.pyconfrest.value\" class=\"pb-32\"></text-angular><textarea \nng-if=\"!vm.isRt(vm.pyconfrest.key)\" name=\"{{vm.pyconfrest.key}}\" ng-model=\"vm.pyconfrest.value\" max-rows=\"5\" \nmd-autofocus></textarea><div class=\"hint\">{{vm.pyconfrest.help_text}}</div><error-messages \nfield=\"pyconfrestForm[vm.pyconfrest.key]\" server-errors=\"ExtraFields.serverErrors\"></error-messages>\n</md-input-container><md-input-container data-flex=\"100\" class=\"fullwidth\" \nng-if=\"vm.pyconfrest.type===\'IntegerField\' || vm.pyconfrest.type===\'FloatField\'\"><label>{{vm.pyconfrest.verbose_name}}\n</label><input type=\"number\" name=\"{{vm.pyconfrest.key}}\" data-ng-model=\"vm.pyconfrest.value\" md-autofocus><div \nclass=\"hint\">{{vm.pyconfrest.help_text}}</div><error-messages field=\"pyconfrestForm[vm.pyconfrest.key]\" \nserver-errors=\"ExtraFields.serverErrors\"></error-messages></md-input-container><md-input-container data-flex=\"100\" \nng-if=\"vm.pyconfrest.type===\'DateField\'\"><label>{{vm.pyconfrest.verbose_name}}</label><md-datepicker \nname=\"{{vm.pyconfrest.key}}\" data-ng-model=\"vm.pyconfrest.value\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker>\n<error-messages field=\"pyconfrestForm[vm.pyconfrest.key]\" server-errors=\"ExtraFields.serverErrors\" forcechange>\n</error-messages></md-input-container><div ng-if=\"vm.pyconfrest.type===\'check\'\"><md-checkbox \ndata-ng-model=\"vm.pyconfrest.value\" name=\"{{vm.pyconfrest.key}}\" aria-label=\"{{vm.pyconfrest.verbose_name}}\"><span>\n{{vm.pyconfrest.verbose_name}}</span></md-checkbox></div></div><div ng-if=\"vm.pyconfrest.choices.length>0\">\n<md-input-container><label>{{vm.pyconfrest.verbose_name}}</label><md-select data-ng-model=\"vm.pyconfrest.value\" \nname=\"{{vm.pyconfrest.key}}\"><md-option data-ng-repeat=\"option in vm.pyconfrest.choices\" data-ng-value=\"option[0]\">\n<span>{{option[1]}}</span></md-option></md-select><error-messages field=\"pyconfrestForm[vm.pyconfrest.key]\" \nserver-errors=\"ExtraFields.serverErrors\"></error-messages></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.savePyconfrest()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"pyconfrestForm.$invalid || pyconfrestForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/reports/dialogs/report/report-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"reportForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"name\" data-ng-model=\"vm.report.name\" placeholder=\"{{\'Nombre\' | translate}}\" required md-autofocus>\n<error-messages field=\"reportForm.name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"100\"><label data-translate>Descripción</label><textarea name=\"description\" \ndata-ng-model=\"vm.report.description\"></textarea><error-messages field=\"reportForm.description\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div><strong data-translate>\nCampos variables:</strong><div layout=\"row\" layout-wrap><md-input-container \ndata-ng-repeat=\"field in vm.searchsAdvances\" flex=\"50\" class=\"no-margin\"><md-checkbox ng-model=\"field.variable\" \naria-label=\"{{field.title}}\" class=\"md-align-top-left no-margin\" flex><span data-translate>{{field.title}}</span>\n</md-checkbox></md-input-container></div></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveReport()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"reportForm.$invalid || reportForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/dialogs/role/role-dialog.html","<md-dialog class=\"teleco-dialog\" aria-label=\"Nuevo Tag\"><form name=\"editForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label>Nombre</label><input name=\"name\" ng-model=\"vm.role.name\" \nrequired><error-messages field=\"editForm.name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button debouce-click type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"editForm.$invalid || editForm.$pristine\" aria-label=\"Guardar\">\nGuardar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/roles/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-switch\" class=\"s24\"></md-icon>\n</span><span class=\"logo-text\">Roles</span></div><div class=\"add-button\"><md-button \nng-if=\"hasPermission(\'role\',\'POST\')\" class=\"md-default md-raised\" ng-click=\"vm.newRole($event)\" aria-label=\"Nuevo Rol\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon>Nuevo Rol</md-button></div></div><md-content class=\"content\" \nflex ms-scroll></md-content>");
$templateCache.put("app/main/roles/sidenavs/main/users-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between\"><div class=\"logo\" layout=\"column\" \nlayout-align=\"start start\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s32\"></md-icon>\n</span><span class=\"logo-text\">Rol</span> <span class=\"group-name\">{{vm.role.name}}</span></div></div><md-content \nclass=\"content\" flex ms-scroll><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><input flex \nng-model=\"searchText\" type=\"text\" placeholder=\"Buscar un contacto...\"><md-button data-debouce-click \nclass=\"md-primary md-icon-button\" ng-click=\"vm.searchContact(searchText)\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></md-button></div><div class=\"contacts\"><ul><li ng-hide=\"contact.groups.indexOf(vm.role.id)!==-1\" \nng-repeat=\"contact in vm.contactSearch\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex \nlayout=\"column\"><span class=\"name\">{{contact.name}}</span> <span class=\"description\">{{contact.email}}</span></div><div\n class=\"actions\"><md-button data-debouce-click ng-click=\"vm.addContact($event, contact)\" class=\"md-icon-button\" \naria-label=\"Añadir contacto\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></li></ul><p \nng-show=\"vm.contactSearch.length === 0 && !vm.hideFirstMessage\">Introduce al menos tres caracteres</p><p \nng-show=\"vm.contactSearch.length === 0 && !vm.hideFirstMessage\">\nPuedes usar el buscador para filtrar contactos y añadirlos al grupo.</p><p \nng-show=\"vm.contactSearch.length === 0 && vm.hideFirstMessage\">No se han encontrado resultados.</p></div></md-content>");
$templateCache.put("app/main/roles/views/edit/edit.html","<div id=\"roleedit\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\"><div class=\"header white-fg\" \nlayout=\"row\" layout-align=\"start center\" flex><div layout=\"row\"><md-button class=\"md-button\" ui-sref=\"^.\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon>Volver</md-button></div><div class=\"spacer\" layout=\"row\"></div>\n<div layout=\"row\"><span class=\"h2\">{{vm.role.name}}</span></div></div><div layout=\"row\" \nng-if=\"hasPermission(\'role\',\'PATCH\')\"><md-button class=\"md-raised md-default\" ng-click=\"vm.save()\" data-debouce-click>\n<md-icon md-font-icon=\"icon-content-save\"></md-icon><span data-translate>Guardar</span></md-button></div></div><div \nclass=\"content-card\" layout=\"row\" flex><md-content class=\"content\" ms-scroll flex=\"100\" layout=\"column\"><form>\n<md-input-container class=\"md-block\"><label>Nombre</label><input name=\"name\" ng-model=\"vm.role.name\" required \nmd-autofocus><error-messages field=\"editForm.name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></form><div class=\"permissions\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\">\n<md-content class=\"content permission-box1\" ms-scroll flex=\"45\"><div class=\"perms\" \nng-repeat=\"permission in vm.permissions | filter:vm.filterPermissions\"><md-checkbox ng-model=\"permission.selected\">\n{{ permission.name }}</md-checkbox></div></md-content><div layout=\"column\" flex=\"10\" layout-align=\"center center\" \nng-if=\"hasPermission(\'role\',\'PATCH\')\"><md-button ng-click=\"vm.addPermissions()\" class=\"md-fab md-green-600-bg\" \naria-label=\"Dar permiso\"><md-icon md-font-icon=\"icon-chevron-right s32\"></md-icon></md-button><md-button \nng-click=\"vm.removePermissions()\" class=\"md-fab md-red-600-bg\" aria-label=\"Quitar permiso\"><md-icon \nmd-font-icon=\"icon-chevron-left s32\"></md-icon></md-button></div><md-content class=\"content permission-box2\" ms-scroll \nflex=\"45\"><div class=\"\" flex=\"100\" ng-repeat=\"permission in vm.role.permissions_groups_data\"><md-checkbox \nng-model=\"permission.selected\">{{ permission.name }}</md-checkbox></div></md-content></div></md-content></div></div>\n</div>");
$templateCache.put("app/main/roles/views/list/list.html","<div id=\"roles\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav\n class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/roles/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Abrir barra lateral\" translate><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"searchText\" type=\"text\" ng-init=\"searchText = vm.roles.filters.search\" placeholder=\"Buscar un rol...\">\n<md-button ng-show=\"vm.roles.filters.search\" class=\"md-primary md-button cancel-search\" \nng-click=\"searchText=\'\'; vm.roles.filters.search = \'\'; vm.roles.filters.page=1;  vm.filter()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><md-button class=\"md-primary md-button\" \nng-click=\"vm.roles.filters.search = searchText; vm.roles.filters.page=1;  vm.filter()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon>Buscar</md-button></div></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content\" layout=\"column\" flex><md-content class=\"main-list-pane\" flex ms-scroll=\"vm.msScrollOptions\">\n<div class=\"main-items\"><div class=\"main-item\" layout=\"row\" layout-align=\"start center\" \ndir-paginate=\"role in vm.roles.data | itemsPerPage: 10 track by $index\" total-items=\"vm.roles.count\" \ncurrent-page=\"vm.roles.filters.page\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex \nlayout=\"column\"><span class=\"name\">{{role.name}}</span></div><div class=\"issues\"><span \nclass=\"text-boxed blue-600-bg white-fg\">{{role.members}}</span> miembros</div></div><div class=\"actions\"><span \nclass=\"datedisplay border-right pr-20 mr-15\" am-time-ago=\"download.last_update\"></span><md-button \nui-sref=\"^.roleUsers({id: role.id})\" class=\"md-icon-button\" aria-label=\"Listado de contactos\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button><md-button ui-sref=\".edit({id: role.id})\" \nclass=\"md-icon-button\" aria-label=\"Editar\"><md-tooltip md-delay=\"300\">\n{{hasPermission(\'role\',\'PATCH\') ? \"Editar\" : \"Ver\"}}</md-tooltip><md-icon md-font-icon=\"\" \nng-class=\"hasPermission(\'role\',\'PATCH\') ? \'icon-pencil\' : \'icon-eye\'\"></md-icon></md-button><md-button \nng-if=\"hasPermission(\'role\',\'DELETE\')\" ng-click=\"vm.removeRole($event, role)\" class=\"md-icon-button\" \naria-label=\"Eliminar\"><md-tooltip md-delay=\"300\">Eliminar</md-tooltip><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></div></div></div><div ng-show=\"vm.roles.count === 0\" class=\"empty-item\"><div class=\"main-item no-records\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s64 md-accent\" \nmd-font-icon=\"icon-file-outline\"></md-icon></div><span class=\"app-title\">Sin resultados</span> <span \nclass=\"hide show-gt-md secondary-text\">No se ha encontrado ningún rol</span></div></div></md-content>\n<dir-pagination-controls on-page-change=\"vm.filter()\" class=\"bottomFixed\"></dir-pagination-controls></div></div></div>\n</div>");
$templateCache.put("app/main/roles/views/users/users.html","<div id=\"roles\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav\n class=\"sidenav users\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/roles/sidenavs/main/users-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper\" flex layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md aria-label=\"Abrir barra lateral\" translate><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content\" layout=\"column\" flex><md-content class=\"main-list-pane\" flex ms-scroll=\"vm.msScrollOptions\"><div \nclass=\"main-items\"><div class=\"main-item\" layout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"contact in vm.contacts.data | itemsPerPage: 10\" data-total-items=\"vm.contacts.count\" \ndata-current-page=\"vm.contacts.filters.page\"><div class=\"actions\"><md-button data-debouce-click \nng-click=\"vm.removeFromRole($event, contact)\" class=\"md-icon-button\" aria-label=\"Quitar del grupo\"><md-tooltip \nmd-delay=\"300\">Quitar del grupo</md-tooltip><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button></div><div \nlayout=\"row\" layout-align=\"space-between center\" flex><div class=\"info\" flex layout=\"column\"><span class=\"name\">\n{{contact.name}}</span> <span class=\"description\">{{contact.email}}</span></div></div></div></div><div \nng-show=\"vm.contacts.count === 0\" class=\"empty-item\"><div class=\"main-item no-records\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s64 md-accent\" \nmd-font-icon=\"icon-file-outline\"></md-icon></div><span class=\"app-title\">Sin resultados</span> <span \nclass=\"hide show-gt-md secondary-text\">No se ha encontrado ningún contacto</span></div></div></md-content>\n<dir-pagination-controls on-page-change=\"vm.filter()\" class=\"bottomFixed\"></dir-pagination-controls></div></div></div>\n</div>");
$templateCache.put("app/main/searchsAdvances/dialogs/searchsAdvance/searchsAdvance-dialog.html","<md-dialog id=\"searchsAdvancesDialog\" class=\"task-dialog\" aria-label=\"New Task\"><div name=\"searchsAdvanceForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" \ndata-layout=\"row\" data-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" data-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-tabs \nmd-selected=\"vm.selectedFilter\" class=\"icontab\" ng-class=\"{\'onlyone\':vm.searchTabs.length==1}\"><md-tab \nng-repeat=\"filter in vm.searchTabs\"><md-tab-label><span>Filtro {{$index + 1}}</span></md-tab-label><md-tab-body><form \nname=\"contactForm[$index]\" class=\"p-20\"><div layout=\"row\" data-ng-repeat=\"field in vm.searchsAdvances\" flex=\"100\" \nflex-xs=\"100\" ng-init=\"filter[field.field_name].option=field.filters[0]\" \ndata-ng-if=\"vm.existVariableField(field.field_name)\"><md-input-container class=\"md-block\" flex=\"100\"><label \nng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} <span \ndata-ng-if=\"filter[field.field_name].option===\'range\'\" data-translate>(desde)</span></label><input \nng-model=\"filter[field.field_name].value\" ng-if=\"!field.options && field.type===\'text\'\"><md-datepicker \nng-model=\"filter[field.field_name].value\" \nng-init=\"filter[field.field_name].value=filter[field.field_name].value||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"filter[field.field_name].value\" aria-label=\"filtro\"><span \nng-if=\"field.type===\'boolean\'\" ng-init=\"filter[field.field_name].option=\'boolean\'\"></span><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"100\" data-ng-if=\"filter[field.field_name].option===\'range\'\"><label \nng-class=\"{\'md-no-float\':(!field.options && field.type===\'date\')}\">{{field.title}} <span \ndata-ng-if=\"filter[field.field_name].option===\'range\'\" data-translate>(hasta)</span></label><input \nng-model=\"filter[field.field_name].value_range\" ng-if=\"!field.options && field.type===\'text\'\"><md-datepicker \nng-model=\"filter[field.field_name].value_range\" \nng-init=\"filter[field.field_name].value_range=filter[field.field_name].value_range||null\" \nng-if=\"!field.options && field.type===\'date\'\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><md-select \nng-if=\"field.options\" ng-model=\"filter[field.field_name].value_range\" aria-label=\"filtro\"><md-option \nng-repeat=\"(value,text) in field.options\" ng-value=\"value\">{{text}}</md-option></md-select></md-input-container>\n<md-select ng-if=\"field.filters.length>1\" ng-model=\"filter[field.field_name].option\" class=\"filterOptions\" \naria-label=\"filtro\"><md-option ng-repeat=\"filter in field.filters\" title=\"{{filter | filterOptions}}\" \nng-value=\"filter\">{{filter | filterOptionsIcons}}</md-option></md-select></div></form></md-tab-body></md-tab></md-tabs>\n</div></md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button type=\"submit\" data-ng-click=\"vm.search()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate \nng-if=\"vm.action!==\'export\'\">Ver informe</span> <span data-translate ng-if=\"vm.action===\'export\'\">Exportar</span>\n</md-button></div></md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/skills/dialogs/skill/skill-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"skillForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"45\"><label \ndata-translate>Tipo de competencia</label><md-select data-ng-model=\"vm.skill.category\" name=\"type\" required><md-option \ndata-ng-repeat=\"skillsType in vm.skillsTypes\" data-ng-value=\"skillsType.id\">{{skillsType.name}}</md-option></md-select>\n<md-icon md-font-icon=\"icon-plus pointer\" ng-click=\"vm.showNewCategory=true\"></md-icon><error-messages \nfield=\"skillForm.type\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"100\" class=\"md-icon-float md-icon-right md-block\" ng-if=\"vm.showNewCategory\"><input \ntype=\"text\" data-ng-model=\"vm.categorySkill.name\" placeholder=\"{{\'Nueva competencia\' | translate}}\"><md-icon \nmd-font-icon=\"icon-content-save pointer\" ng-click=\"vm.saveCategorySkill()\"></md-icon></md-input-container>\n<md-input-container flex=\"100\"><input type=\"text\" name=\"name\" data-ng-model=\"vm.skill.name\" \nplaceholder=\"{{\'Nombre\' | translate}}\" required><error-messages field=\"skillForm.name\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveSkill()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"skillForm.$invalid || skillForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/dialogs/student/student-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"studentForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\" md-no-float \nclass=\"md-block\" ng-if=\"!vm.edit\"><input type=\"text\" name=\"identification\" data-ng-model=\"vm.student.identification\" \nng-change=\"vm.validDNI(vm.student.identification)\" autocomplete=\"new-password\" placeholder=\"{{\'DNI\' | translate}}\" \nrequired md-autofocus><md-icon ng-if=\"vm.isDNIValid\" md-font-icon=\"icon-checkbox-marked-circle green-fg\" \ntitle=\"{{\'DNI válido\' | translate}}\"></md-icon><md-icon ng-if=\"!vm.isDNIValid && !vm.foundStudent.id\" \nmd-font-icon=\"icon-close-circle red-fg\" title=\"{{\'DNI inválido\' | translate}}\"></md-icon><md-icon \nui-sref=\"app.students.detail({id:\'{{vm.foundStudent.id}}\'})\" ng-if=\"!vm.isDNIValid && vm.foundStudent.id\" \ndata-ng-click=\"vm.closeDialog()\" md-font-icon=\"icon-eye green-fg pointer\" title=\"{{\'Ver estudiante\' | translate}}\">\n</md-icon><error-messages field=\"studentForm.identification\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><div ng-show=\"vm.isDNIValid || vm.edit\" data-layout=\"column\"><md-input-container flex=\"100\"><input\n type=\"text\" name=\"name\" data-ng-model=\"vm.student.name\" placeholder=\"{{\'Nombre\' | translate}}\" required>\n<error-messages field=\"studentForm.name\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container flex=\"100\"><input type=\"text\" name=\"surname\" \ndata-ng-model=\"vm.student.surname\" placeholder=\"{{\'Primer apellido\' | translate}}\" required><error-messages \nfield=\"studentForm.surname\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"100\"><input type=\"text\" name=\"second_surname\" data-ng-model=\"vm.student.second_surname\" \nplaceholder=\"{{\'Segundo apellido\' | translate}}\"><error-messages field=\"studentForm.second_surname\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"email\" data-ng-model=\"vm.student.email\" placeholder=\"{{\'Email\' | translate}}\" required>\n<error-messages field=\"studentForm.email\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container flex=\"100\"><input type=\"text\" name=\"country_name\" \ndata-ng-model=\"vm.student.country_name\" placeholder=\"{{\'Pais\' | translate}}\"><error-messages \nfield=\"studentForm.country_name\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container flex=\"100\"><input type=\"text\" name=\"province_name\" data-ng-model=\"vm.student.province_name\" \nplaceholder=\"{{\'Provincia\' | translate}}\"><error-messages field=\"studentForm.province_name\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"town_name\" data-ng-model=\"vm.student.town_name\" placeholder=\"{{\'Localidad\' | translate}}\">\n<error-messages field=\"studentForm.town_name\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container flex=\"100\"><input type=\"text\" name=\"phone\" data-ng-model=\"vm.student.phone\" \nplaceholder=\"{{\'Teléfono\' | translate}}\"><error-messages field=\"studentForm.phone\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveStudent()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"studentForm.$invalid || studentForm.$pristine || (!vm.isDNIValid && !vm.edit)  \" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/students/dialogs/studentsDegree/studentsDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"studentsDegreeForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"subject\" \nmd-selected-item=\"vm.studentsDegree.degree_data\" md-search-text=\"searchTextDegree\" \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"0\" md-item-text=\"degree.name\" \nplaceholder=\"{{\'Titulación\' | translate}}\" required md-autocomplete-translate><md-item-template><span \nmd-highlight-text=\"searchTextDegree\">{{degree.name}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ninguna titulación con ese nombre</span></md-not-found></md-autocomplete><md-input-container class=\"mr-20\">\n<error-messages field=\"studentsDegreeForm.subject\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveStudentsDegree()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"studentsDegreeForm.$invalid || studentsDegreeForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/students/dialogs/studentsLanguage/studentsLanguage-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"studentsLanguageForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Idioma\' | translate}}\" md-delay=\"300\" md-input-name=\"language\" \nmd-selected-item=\"vm.studentsLanguage.language_data\" md-search-text=\"searchTextLanguage\" \nmd-items=\"language in vm.getLanguages(searchTextLanguage)\" md-min-length=\"0\" md-item-text=\"language.name\" \nplaceholder=\"{{\'Idioma\' | translate}}\" required md-autocomplete-translate><md-item-template><span \nmd-highlight-text=\"searchTextLanguage\">{{language.name}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ningun idioma con ese nombre</span></md-not-found></md-autocomplete><md-input-container class=\"mr-20\">\n<error-messages field=\"studentsLanguageForm.language\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel de lectura</label><md-select \ndata-ng-model=\"vm.studentsLanguage.reading_level\" name=\"reading_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"studentsLanguageForm.reading_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel hablado</label><md-select \ndata-ng-model=\"vm.studentsLanguage.speaking_level\" name=\"speaking_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"studentsLanguageForm.speaking_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container class=\"mr-20\"><label data-translate>Nivel de escritura</label><md-select \ndata-ng-model=\"vm.studentsLanguage.writing_level\" name=\"writing_level\" required><md-option value=\"initial\"><span \ndata-translate>Inicial</span></md-option><md-option value=\"medium\"><span data-translate>Medio</span></md-option>\n<md-option value=\"advanced\"><span data-translate>Avanzado</span></md-option></md-select><error-messages \nfield=\"studentsLanguageForm.writing_level\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveStudentsLanguage()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"studentsLanguageForm.$invalid || studentsLanguageForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/students/dialogs/studentsSkill/studentsSkill-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"studentsSkillForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container><label data-translate>\nCategoría</label><md-select data-ng-model=\"vm.studentsSkill.skill_data.category\" name=\"category\" \nng-change=\"vm.loadSkills()\"><md-option ng-repeat=\"category in vm.categories\" value=\"{{category.id}}\"><span>\n{{category.name}}</span></md-option></md-select></md-input-container><md-input-container ng-if=\"vm.skills.length<1\">\n<label data-translate>Competencia</label><md-select data-ng-model=\"none\" name=\"skill\" required \nng-disabled=\"vm.skills.length<1\"><md-option value=\"none\"><span>none</span></md-option></md-select><error-messages \nfield=\"studentsSkillForm.skill\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container ng-if=\"vm.skills.length>0\"><label data-translate>Competencia</label><md-select \ndata-ng-model=\"vm.studentsSkill.skill\" name=\"skill\" required><md-option ng-repeat=\"skill in vm.skills\" \nvalue=\"{{skill.id}}\"><span>{{skill.name}}</span></md-option></md-select><error-messages \nfield=\"studentsSkillForm.skill\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container><label data-translate>Nivel</label><md-select data-ng-model=\"vm.studentsSkill.level\" name=\"level\" \nrequired vm.skills><md-option value=\"initial\"><span data-translate>Inicial</span></md-option><md-option value=\"medium\">\n<span data-translate>Medio</span></md-option><md-option value=\"advanced\"><span data-translate>Avanzado</span>\n</md-option></md-select><error-messages field=\"studentsSkillForm.level\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveStudentsSkill()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"studentsSkillForm.$invalid || studentsSkillForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\">\n<span data-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/teachers/dialogs/teachersCoordinatorDegree/teachersCoordinatorDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"teachersCoordinatorDegreeForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-autocomplete \nmd-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"degree\" md-min-length=\"3\" \nmd-selected-item=\"vm.teachersCoordinatorDegree.degree_data\" md-search-text=\"searchTextDegree\" required \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"0\" md-autofocus \nmd-item-text=\"vm.getFullNameDegree(degree)\" placeholder=\"{{\'Titulación\' | translate}}\" required \nmd-autocomplete-translate><md-item-template><span md-highlight-text=\"searchTextDegree\">{{vm.getFullNameDegree(degree)}}\n</span></md-item-template><md-not-found><span data-translate>No hay ninguna titulación con ese nombre</span>\n</md-not-found></md-autocomplete><md-input-container><error-messages field=\"teachersCoordinatorDegreeForm.degree\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div \nng-if=\"!vm.teachersCoordinatorDegree.coordinator\"><md-autocomplete md-floating-label=\"{{\'Profesor\' | translate}}\" \nmd-delay=\"300\" md-input-name=\"coordinator\" md-min-length=\"3\" \nmd-selected-item=\"vm.teachersCoordinatorDegree.coordinator_data\" md-search-text=\"searchTextCoordinator\" required \nmd-items=\"coordinator in vm.getCoordinators(searchTextCoordinator)\" md-min-length=\"0\" \nmd-item-text=\"vm.getFullTextCoordinator(coordinator)\" placeholder=\"{{\'Profesor\' | translate}}\" required>\n<md-item-template><span md-highlight-text=\"searchTextCoordinator\">{{vm.getFullTextCoordinator(coordinator)}}</span>\n</md-item-template><md-not-found><span data-translate>No hay ningun profesor con ese nombre</span></md-not-found>\n</md-autocomplete><md-input-container><error-messages field=\"teachersCoordinatorDegreeForm.coordinator\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveTeachersCoordinatorDegree()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"teachersCoordinatorDegreeForm.$invalid || teachersCoordinatorDegreeForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/teachers/dialogs/teachersDegree/teachersDegree-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"teachersDegreeForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div ng-if=\"!vm.teachersDegree.tutor\">\n<md-autocomplete md-floating-label=\"{{\'Profesor\' | translate}}\" md-delay=\"300\" md-input-name=\"tutor\" md-min-length=\"3\" \nmd-selected-item=\"vm.teachersDegree.tutor_data\" md-search-text=\"searchTextTutor\" required \nmd-items=\"tutor in vm.getTutors(searchTextTutor)\" md-item-text=\"vm.getFullTextTutor(tutor)\" \nplaceholder=\"{{\'Profesor\' | translate}}\" required><md-item-template><span md-highlight-text=\"searchTextTutor\">\n{{vm.getFullTextTutor(tutor)}}</span></md-item-template><md-not-found><span data-translate>\nNo hay ningun profesor con ese nombre</span></md-not-found></md-autocomplete><md-input-container><error-messages \nfield=\"teachersDegreeForm.tutor\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div>\n<md-autocomplete md-floating-label=\"{{\'Titulación\' | translate}}\" md-delay=\"300\" md-input-name=\"degree\" \nmd-selected-item=\"vm.teachersDegree.degree_data\" md-search-text=\"searchTextDegree\" required \nng-disabled=\"!vm.teachersDegree.tutor_data.id && !vm.teachersDegree.tutor\" \nmd-items=\"degree in vm.getDegrees(searchTextDegree)\" md-min-length=\"3\" md-autofocus \nmd-item-text=\"vm.getFullNameDegree(degree)\" placeholder=\"{{\'Titulación\' | translate}}\" required \nmd-autocomplete-translate><md-item-template><span md-highlight-text=\"searchTextDegree\">{{vm.getFullNameDegree(degree)}}\n</span></md-item-template><md-not-found><span data-translate>No hay ninguna titulación con ese nombre</span>\n</md-not-found></md-autocomplete><md-input-container><error-messages field=\"teachersDegreeForm.degree\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveTeachersDegree()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"teachersDegreeForm.$invalid || teachersDegreeForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/teachers/views/detail/teacher-coordinator-degrees.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\" data-translate>\nCoordinador de asignatura</h2></div></md-toolbar><md-content layout-padding class=\"fullwidth\"><div \nng-repeat=\"teacherDegree in vm.teachersCoordinatorDegrees.data\" class=\"todo-item\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{teacherDegree.degree_data.id}} - {{teacherDegree.degree_data.name}}</div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'teachersCoordinatorDegrees\',\'DELETE\')\" \ndata-ng-click=\"vm.removeTeachersCoordinatorDegree($event, teacherDegree)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><md-button ng-click=\"vm.openTeachersCoordinatorDegreeDialog($event)\" \nclass=\"md-accent md-raised\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'teachersCoordinatorDegrees\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><span data-translate>Añadir titulación</span></md-button>\n</md-content>");
$templateCache.put("app/main/teachers/views/detail/teacher-students.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\" data-translate>Alumnos tutorizados</h2>\n</div></md-toolbar><md-content layout-padding class=\"fullwidth\"><div \nng-repeat=\"student in vm.teacher.tutored_students\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{student.contact_student_data.identification}} - {{student.contact_student_data.name}} {{student.contact_student_data.surname}} {{student.contact_student_data.second_surname}}\n</div></div></div></div></div></div></div></md-content>");
$templateCache.put("app/main/teachers/views/detail/teacher-tutor-degrees.html","<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\" data-translate>\nTutor de practicas extracurricular</h2></div></md-toolbar><md-content layout-padding class=\"fullwidth\"><div \nng-repeat=\"teacherDegree in vm.teachersDegrees.data\" class=\"todo-item\"><div layout=\"row\" layout-align=\"start center\" \nflex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{teacherDegree.degree_data.id}} - {{teacherDegree.degree_data.name}}</div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-warn\" data-layout-align=\"start center\" \ndata-ng-if=\"!vm.disabledInputs && hasPermission(\'teachersDegrees\',\'DELETE\')\" \ndata-ng-click=\"vm.removeTeachersDegree($event, teacherDegree)\"><md-icon class=\"pt-5\" \ntitle=\"{{\'Eliminar\' | translate}}\" md-font-icon=\"icon-delete\"></md-icon><span class=\"pt-5\" data-translate>Eliminar\n</span></md-button></div></div></div></div></div><md-button ng-click=\"vm.openTeachersDegreeDialog($event)\" \nclass=\"md-accent md-raised\" data-ng-if=\"!vm.disabledInputs && hasPermission(\'teachersDegrees\',\'POST\')\" \naria-label=\"{{\'Añadir competencia\' | translate}}\"><span data-translate>Añadir titulación</span></md-button>\n</md-content>");
$templateCache.put("app/main/teachers/views/detail/teacher.html","<div id=\"teacher-detail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><md-icon \nmd-font-icon=\"icon-multiplication-box\"></md-icon><span>\n{{vm.teacher.name}} {{vm.teacher.surname}} {{vm.teacher.second_surname}}</span></div><div class=\"count secondary-text\">\n<md-icon md-font-icon=\"icon-folder-account\" class=\"icon\"></md-icon><span>{{vm.teacher.id}}</span></div><div \nclass=\"count secondary-text\" ng-if=\"vm.teacher.email\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><span>\n{{vm.teacher.email}}</span></div><div class=\"count secondary-text\"><md-icon md-font-icon=\"icon-calendar\" class=\"icon\">\n</md-icon><span>{{vm.teacher.academic_year}}</span></div></div></div><div class=\"content-card\" layout=\"column\" flex>\n<md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-xs=\"column\" \nlayout-align=\"space-between start\" flex><form name=\"teacherForm\" class=\"md-inline-form ms-form-wizard-form fullwidth\" \nnovalidate><div data-layout-xs=\"column\" data-layout=\"row\" data-layout-align=\"space-between start\" layout-wrap><div \ndata-layout=\"column\" data-layout-align=\"start start\" layout-wrap flex=\"60\" flex-xs=\"100\"><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \ndata-ng-if=\"vm.teacher.tutored_students.length>0\" ng-include=\"\'app/main/teachers/views/detail/teacher-students.html\'\">\n</div><div data-layout=\"column\" data-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/teachers/views/detail/teacher-tutor-degrees.html\'\"></div><div data-layout=\"column\" \ndata-layout-align=\"start start\" layout-wrap class=\"fullwidth md-whiteframe-z1 mb-30\" \nng-include=\"\'app/main/teachers/views/detail/teacher-coordinator-degrees.html\'\"></div></div></div></form></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/users/dialogs/users/user-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"passwordForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container flex=\"100\"><input type=\"password\" name=\"password\" \nng-model=\"vm.user.password\" placeholder=\"{{\'Nueva contraseña\' | translate}}\"></md-input-container><md-input-container \nflex=\"100\"><input match-password=\"password\" type=\"password\" name=\"password2\" ng-model=\"vm.user.password2\" \nplaceholder=\"{{\'Repite la nueva contraseña\' | translate}}\"><error-messages field=\"passwordForm.password2\" \nserver-errors=\"vm.serverErrors\" password-match></error-messages></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button data-debouce-click type=\"submit\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"passwordForm.$invalid || passwordForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span translate>\nGuardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/users/views/detail/user-detail.html","<div id=\"user\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" data-layout=\"column\" \ndata-layout-align=\"center center\" data-layout-gt-sm=\"row\" data-layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" data-layout=\"column\" data-layout-align=\"center center\" data-layout-gt-sm=\"row\" \ndata-layout-align-gt-sm=\"start center\"><img class=\"profile-image avatar huge\" src=\"assets/images/avatars/profile.jpg\">\n<div class=\"name\">{{ vm.user.name}} {{ vm.user.surname}} {{ vm.user.second_surname }}</div></div><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\"><md-button class=\"md-raised md-warn\" \naria-label=\"{{\'Cambiar contraseña\' | translate}}\" data-ng-click=\"vm.openUserDialog($event, vm.user)\"><span \ndata-translate>Cambiar contraseña</span></md-button></div></div><div class=\"content\" data-flex><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span data-translate>Información</span></md-tab-label><md-tab-body><md-content \nclass=\"timeline-tab ms-form-wizard\"><form name=\"userForm\" class=\"md-inline-form ms-form-wizard-form\" novalidate>\n<md-input-container class=\"md-block\"><label data-translate>Nombre</label><input name=\"name\" \ndata-ng-model=\"vm.user.name\" required md-autofocus><error-messages field=\"userForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container class=\"md-block\">\n<label data-translate>Primer apellido</label><input name=\"surname\" data-ng-model=\"vm.user.surname\"><error-messages \nfield=\"userForm.surname\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container \nclass=\"md-block\"><label data-translate>Segundo apellido</label><input name=\"second_surname\" \ndata-ng-model=\"vm.user.second_surname\"><error-messages field=\"userForm.second_surname\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container><md-input-container class=\"md-block\"><label data-translate>Documento</label>\n<input name=\"document\" data-ng-model=\"vm.user.document\" required><error-messages field=\"userForm.document\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container class=\"md-block\">\n<label data-translate>Email</label><input name=\"email\" data-ng-model=\"vm.user.email\"><error-messages \nfield=\"userForm.email\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container \nclass=\"md-block\"><label data-translate>Idioma</label><md-select data-ng-model=\"vm.user.fav_lang\" name=\"fav_lang\">\n<md-option data-ng-value=\"\">Rellenar mensaje mas abajo</md-option><md-option data-ng-repeat=\"language in vm.languages\" \ndata-ng-value=\"language.code\"><span var-translate>{{language.name}}</span></md-option></md-select><error-messages \nfield=\"userForm.fav_lang\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button debouce-click type=\"submit\" data-ng-click=\"vm.saveUser()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"userForm.$invalid || userForm.$pristine\" \naria-label=\"Guardar\"><span data-translate>Guardar</span></md-button></div></form></md-content></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/users/views/list/users-list.html","<div id=\"user-list\" class=\"page-layout carded fullwidth\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" data-layout=\"column\" data-flex><div class=\"header\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div class=\"white-fg\" data-layout=\"column\" data-layout-align=\"start start\">\n<div class=\"h1\" data-layout=\"row\" data-layout-align=\"start center\"><md-icon md-font-icon=\"icon-account-multiple\">\n</md-icon><span data-translate>Usuarios</span></div><div class=\"count secondary-text\"><span data-translate>\nNúmero de usuarios:</span> <span>{{vm.users.count}}</span></div></div><div class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\" data-flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\">\n</md-icon><input class=\"search-input\" type=\"text\" placeholder=\"{{\'Buscar\' | translate }}\" \ndata-ng-model=\"vm.users.filters.search\" data-flex></div><div class=\"search\" data-layout=\"row\" \ndata-layout-align=\"start center\"><md-icon md-font-icon=\"icon-filter\" class=\"white-text icon\"></md-icon><md-select \nclass=\"simplified\" data-ng-model=\"vm.users.filters.profile_type\" \ndata-placeholder=\"{{\'Filtrar por rol de usuario\' | translate }}\" \naria-label=\"{{\'Filtrar por rol de usuario\' | translate }}\"><md-option value=\"title\" data-translate>Coordinador\n</md-option><md-option value=\"cliente\" data-translate>Solicitante</md-option><md-option value=\"manager\" data-translate>\nManager</md-option><md-option value=\"date\" data-translate>Universidad</md-option></md-select></div><div><md-button \nclass=\"md-raised md-background\" data-ng-click=\"vm.openUserDialog($event)\"><md-icon md-font-icon=\"icon-account-plus\">\n</md-icon><span data-translate>Nuevo usuario</span></md-button></div></div><div class=\"content-card\" \ndata-layout=\"column\" data-flex><div class=\"content fullpage-datatable\" data-layout=\"column\" data-flex><div \nclass=\"dataTables_wrapper\" style=\"overflow-x:auto\"><div table-fixed-header ms-scroll class=\"dataTables_scroll\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th data-translate>Apellidos</th><th data-translate>Nombre</th><th \ndata-translate>Email</th><th data-translate>Rol de usuario</th></tr></thead><tbody><tr \ndata-ng-show=\"vm.users.count === 0\"><td colspan=\"4\" class=\"text-center\" data-translate>No se han encontrado usuarios\n</td></tr><tr data-dir-paginate=\"user in vm.users.data | itemsPerPage: 10\" data-total-items=\"vm.users.count\" \ndata-current-page=\"vm.users.filters.page\"><td><strong>{{user.surname}} {{user.second_surname}}</strong></td><td>\n<strong>{{user.name}}</strong></td><td>{{user.email}}</td><td><span data-ng-repeat=\"(key,value) in user.profiles\" \nclass=\"text-boxed m-0 green-bg white-fg mr-5\">{{key}}</span></td></tr></tbody></table></div></div>\n<dir-pagination-controls max-size=\"5\" class=\"bottomFixed\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\">\n{{step.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/company/agreements/dialogs/agreement/agreement-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"agreementForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"space-around center\"><div><md-input-container><h4 data-translate>Fecha inicio</h4><md-datepicker \nname=\"validity\" data-ng-model=\"vm.agreement.start_date\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><error-messages \nfield=\"agreementForm.validity\" server-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div>\n<div><md-input-container><h4 data-translate>Fecha fin</h4><md-datepicker name=\"renovation_date\" \ndata-ng-model=\"vm.agreement.end_date\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker><error-messages \nfield=\"agreementForm.renovation_date\" server-errors=\"vm.serverErrors\" forcechange></error-messages>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveAgreement()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"agreementForm.$invalid\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/agreements/views/list/agreement.html","<div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" \ndata-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\" \nlayout-wrap><div class=\"mr-20\"><div class=\"title\"><md-icon md-font-icon=\"icon-file-document\" class=\"s32\"></md-icon>\n<span data-translate>Convenio</span> <span>{{agreement.start_date | date:\"dd/MM/yyyy\"}}</span> <span>- </span><span>\n{{agreement.end_date | date:\"dd/MM/yyyy\"}}</span></div></div><div data-ng-if=\"agreement.agreement_renewal\"><div \nclass=\"title\"><md-icon md-font-icon=\"icon-file-document\" class=\"s32\"></md-icon><span data-translate>Renovación</span> \n<span>{{agreement.agreement_renewal_data.start_date | date:\"dd/MM/yyyy\"}}</span> <span>- </span><span>\n{{agreement.agreement_renewal_data.end_date | date:\"dd/MM/yyyy\"}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"agreement.is_renewable && hasPermission(\'agreements\',\'POST\')\" \ndata-ng-click=\"vm.openAgreementDialog($event, agreement)\"><md-icon class=\"pt-5\" title=\"{{\'Editar\' | translate}}\" \nmd-font-icon=\"icon-reload\"></md-icon><span class=\"pt-5\" data-translate>Renovar</span></md-button><md-button \ndata-layout=\"column\" data-layout-align=\"start center\" data-ng-if=\"hasPermission(\'agreements\',\'GET\')\" \ndata-ui-sref=\"app.company.agreement({agreement:\'{{agreement.id}}\'})\"><md-icon class=\"pt-5 green-900-fg\" \ntitle=\"{{\'Becas\' | translate}}\" md-font-icon=\"icon-eye\"></md-icon><span class=\"pt-5 green-900-fg\" data-translate>\nAcceder</span></md-button></div></div></div></div>");
$templateCache.put("app/main/company/agreements/views/list/agreements.html","<div id=\"agreements\" class=\"page-layout carded left-sidenav\" data-layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/company/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \ndata-layout=\"column\" data-flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-table-large\"></md-icon><span>Convenios</span> <span \ndata-ng-if=\"hasPermission(\'companyList\',\'LIST\')\" class=\"ml-10\">({{vm.form.business_name}})</span></div><div \nclass=\"count secondary-text\"><span data-translate>Número de convenios:</span> <span>\n{{vm.agreements_historical.count + vm.agreements_valid.length + vm.agreements_in_progress.length+ vm.agreements_partially_signed.length}}\n</span></div></div><div data-layout=\"row\" data-layout-align=\"space-between center\" data-layout-wrap \nng-if=\"vm.form.status!==\'not-validated\' && vm.form.status!==\'validation-candidate\'\"><div class=\"actions\" \ndata-layout=\"row\" data-layout-align=\"end center\" data-ng-if=\"hasPermission(\'agreements\',\'POST\')\"><md-button \nclass=\"md-raised\" aria-label=\"{{\'Nuevo convenio\' | translate}}\" data-ng-click=\"vm.openAgreementDialog($event)\"><md-icon\n md-font-icon=\"icon-plus-circle-outline\"></md-icon><span data-translate>Nuevo convenio</span></md-button></div></div>\n</div><div class=\"content-card\" data-layout=\"column\" data-flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\" hide-gt-md><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><md-content class=\"content p-20\" flex ms-scroll><div layout=\"column\" \nlayout-align=\"space-between start\"><div class=\"no-results text-center\" \nng-if=\"(vm.agreements_historical.count + vm.agreements_valid.length + vm.agreements_in_progress.length+ vm.agreements_partially_signed.length) == 0\">\n<div class=\"message\" ng-if=\"vm.form.status!==\'not-validated\' && vm.form.status!==\'validation-candidate\'\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-table-large\"></md-icon><div class=\"message-text\" translate>Sin convenios\n</div></div><div class=\"message\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.form.status===\'not-validated\' || vm.form.status===\'validation-candidate\'\"><md-icon class=\"message-icon s96\" \nmd-font-icon=\"icon-table-large\"></md-icon><div class=\"message-text\" translate>Empresa pendiente de validación</div><div\n class=\"actions\" data-layout=\"row\" data-layout-align=\"end center\" \nng-if=\"vm.user.group_type===\'manager\' && vm.form.status===\'validation-candidate\'\"><md-button \nclass=\"md-raised md-accent\" aria-label=\"{{\'Nuevo convenio\' | translate}}\" data-ng-click=\"vm.setValid()\"><span \ndata-translate>Validar y crear nuevo convenio</span></md-button></div></div></div><div \nng-if=\"vm.agreements_valid.length!==0\" class=\"fullwidth\"><h2 data-translate>Convenio actual</h2><div class=\"todo-item\" \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"agreement in vm.agreements_valid\"><ng-include \nsrc=\"\'app/main/company/agreements/views/list/agreement.html\'\" class=\"fullwidth\"></ng-include></div></div><div \nng-if=\"vm.agreements_in_progress.length!==0\" class=\"fullwidth\"><h2 data-translate>Convenios en proceso de firma</h2>\n<div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" ng-repeat=\"agreement in vm.agreements_in_progress\">\n<ng-include src=\"\'app/main/company/agreements/views/list/agreement.html\'\" class=\"fullwidth\"></ng-include></div></div>\n<div ng-if=\"vm.agreements_partially_signed.length!==0\" class=\"fullwidth\"><h2 data-translate>\nConvenios en proceso de firma</h2><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"agreement in vm.agreements_partially_signed\"><ng-include \nsrc=\"\'app/main/company/agreements/views/list/agreement.html\'\" class=\"fullwidth\"></ng-include></div></div><div \nng-if=\"vm.agreements_historical.count!==0\" class=\"fullwidth\"><h2 data-translate>Histórico</h2><div class=\"todo-item\" \nlayout=\"row\" layout-align=\"start center\" \ndata-dir-paginate=\"agreement in vm.agreements_historical.data | itemsPerPage: 10 | orderBy:\'order\'\" \ndata-total-items=\"vm.agreements_historical.count\" data-current-page=\"vm.agreements_historical.filters.page\"><ng-include\n src=\"\'app/main/company/agreements/views/list/agreement.html\'\" class=\"fullwidth\"></ng-include></div>\n<dir-pagination-controls class=\"bottomFixed\"></dir-pagination-controls></div></div></md-content></div></div></div>");
$templateCache.put("app/main/company/agreementsConditions/dialogs/agreementsCondition/agreementsCondition-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"agreementsConditionForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container flex=\"100\"><input \ntype=\"text\" name=\"name\" data-ng-model=\"vm.agreementsCondition.name\" \nplaceholder=\"{{\'Título de la cláusula\' | translate}}\" required \nng-disabled=\"vm.user.group_type!==\'manager\' && !vm.newCondition\"><error-messages field=\"agreementsConditionForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div class=\"md-input-container\"><label \ndata-translate>Texto propuesto para esta cláusula:</label><md-button class=\"md-icon-button\" data-ng-click=\"vm.copy()\">\n<md-icon md-font-icon=\"icon-content-copy\" aria-label=\"copy\"></md-icon><md-tooltip><span data-translate>\nCopiar cláusula vigente</span></md-tooltip></md-button><text-angular name=\"description\" ta-toolbar=\"vm.taToolbar\" \ndata-ng-model=\"vm.agreementsCondition.description\" class=\"pb-32\" data-input-translate></text-angular></div>\n<md-input-container flex=\"100\"><error-messages field=\"agreementsConditionForm.description\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container><div \nng-if=\"(!vm.agreementsCondition.status || vm.agreementsCondition.status===\'done\') && vm.agreementsCondition.modified_condition\">\n<div class=\"md-input-container md-whiteframe-1dp\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 \nclass=\"md-flex\" data-translate>Texto vigente para esta cláusula</h2></div></md-toolbar><md-content flex layout-padding \nng-bind-html=\"vm.agreementsCondition.modified_condition.description\"></md-content></div><div \nclass=\"md-input-container md-whiteframe-1dp\" ng-if=\"vm.agreementsCondition.modified_condition.original_condition\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\" data-translate>\nVersión original de esta cláusula</h2></div></md-toolbar><md-content flex layout-padding \nng-bind-html=\"vm.agreementsCondition.modified_condition.original_condition\"></md-content></div></div><div \nng-if=\"vm.agreementsCondition.status===\'rejected\' || vm.agreementsCondition.status===\'pending\'\"><div \nclass=\"md-input-container md-whiteframe-1dp\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 \nclass=\"md-flex\" data-translate>Texto vigente para esta cláusula</h2></div></md-toolbar><md-content flex layout-padding \nng-bind-html=\"vm.agreementsCondition.previous_version\"></md-content></div><div \nclass=\"md-input-container md-whiteframe-1dp\" ng-if=\"vm.agreementsCondition.original_condition\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-flex\" data-translate>Versión original de esta cláusula\n</h2></div></md-toolbar><md-content flex layout-padding ng-bind-html=\"vm.agreementsCondition.original_condition\">\n</md-content></div></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveAgreementsCondition()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"agreementsConditionForm.$invalid\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-ng-if=\"vm.user.group_type!==\'manager\'\" data-translate>Guardar</span> <span \ndata-ng-if=\"vm.user.group_type===\'manager\'\" data-translate>Guardar y aceptar</span></md-button><md-button \ndata-ng-click=\"vm.closeDialog()\" class=\"md-primary md-raised\" aria-label=\"{{\'Cancelar\' | translate}}\"><span \ndata-translate>Cancelar</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/agreements/views/detail/agreement.html","<div id=\"agreement-detail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav id=\"company-sidenav\" class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/company/sidenavs/sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\" layout-wrap><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start start\"><div class=\"h1 ml-20\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span data-translate>Convenio</span> <span>\n{{vm.agreement.start_date | date:\"dd/MM/yyyy\"}}</span> <span>- </span><span>\n{{vm.agreement.end_date | date:\"dd/MM/yyyy\"}}</span> <span data-ng-if=\"hasPermission(\'companyList\',\'LIST\')\" \nclass=\"ml-10\">({{vm.form.business_name}})</span><div data-ng-if=\"vm.agreement.agreement_renewal\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><span data-translate>Renovación</span> <span>\n{{vm.agreement.agreement_renewal_data.start_date | date:\"dd/MM/yyyy\"}}</span> <span>- </span><span>\n{{vm.agreement.agreement_renewal_data.end_date | date:\"dd/MM/yyyy\"}}</span></div></div></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\" hide-gt-md>\n<md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content\n class=\"content p-20\" flex ms-scroll><div layout=\"column\" layout-xs=\"column\" layout-align=\"space-between start\" flex>\n<form name=\"agreementForm\" class=\"md-inline-form ms-form-wizard-form full-width\" novalidate \ndata-ng-if=\"hasPermission(\'agreements\',\'PATCH\')\"><div data-layout-xs=\"column\" data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><div><md-input-container><h4 data-translate>Fecha inicio</h4>\n<md-datepicker name=\"start_date\" data-ng-model=\"vm.agreement.start_date\" md-placeholder=\"dd/mm/yyyy\" required \nng-disabled=\"vm.agreement.signature_status===\'signed\'\"></md-datepicker><error-messages \nfield=\"agreementForm.start_date\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container></div><div><md-input-container><h4 data-translate>Fecha fin</h4><md-datepicker name=\"end_date\" \ndata-ng-model=\"vm.agreement.end_date\" md-placeholder=\"dd/mm/yyyy\" \nng-disabled=\"vm.agreement.signature_status===\'signed\'\"></md-datepicker><error-messages field=\"agreementForm.end_date\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div><div class=\"mr-30\">\n<md-input-container><label data-translate>Tipo de convenio</label><md-select data-ng-model=\"vm.agreement.type\" \nname=\"type\" ng-disabled=\"vm.agreement.signature_status===\'signed\' || vm.agreement.agreement_renewal\"><md-option \ndata-ng-repeat=\"type in vm.types\" data-ng-value=\"type.id\">{{type.value}}</md-option></md-select><error-messages \nfield=\"agreementForm.type\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveWithNotify()\" \nclass=\"send-button md-accent md-raised\" \nng-disabled=\"agreementForm.$invalid || agreementForm.$pristine || vm.agreement.signature_status===\'signed\'\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></div></form><ng-include \nsrc=\"\'app/main/company/agreements/views/detail/signers.html\'\" class=\"fullwidth\"></ng-include><ng-include \nsrc=\"\'app/main/company/agreementsConditions/agreementsConditions.html\'\" class=\"fullwidth\"></ng-include></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/company/agreements/views/detail/signers.html","<div layout=\"column\" layout-align=\"start start\" class=\"fullwidth mt-20\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"fullwidth\" layout-wrap><h2 data-translate>Firmantes</h2><div layout=\"row\" \nlayout-align=\"start center\" data-ng-if=\"vm.user.group_type===\'manager\' && hasPermission(\'agreements\',\'PATCH\')\" \nlayout-wrap><md-button ng-click=\"vm.setSigned()\" class=\"send-button md-accent md-raised\" \ndata-ng-if=\"vm.agreement.signature_status!==\'signed\'\" aria-label=\"{{\'toggle signed\' | translate}}\"><span \ndata-translate>Marcar como firmado</span></md-button><md-button ng-click=\"vm.changeSwapSignature()\" \nclass=\"send-button md-accent md-raised\" data-ng-if=\"vm.agreement.signature_status!==\'signed\'\" \naria-label=\"{{\'Permutar el orden de firma\' | translate}}\"><span data-translate>Permutar el orden de firma</span>\n</md-button></div></div><div layout=\"column\" class=\"fullwidth\"><div flex \nflex-order=\"{{vm.agreement.swap_signature ? 3:1}}\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"fullwidth\"><h3 data-translate>Por parte de la empresa</h3></div><span data-ng-if=\"vm.signers.length<1\" \ndata-translate>Ningún contacto de la empresa tiene capacidad de firmar el convenio</span><div class=\"todo-item\" \nlayout=\"row\" layout-align=\"start center\" data-ng-repeat=\"signer in vm.signers\"><div layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"space-between center\"><div><div class=\"title\">\n{{signer.name}} {{signer.surname}} {{signer.second_surname}} - {{signer.identification}} ({{signer.user.email}})</div>\n</div></div><div layout=\"row\" layout-align=\"end center\" \nng-if=\"!vm.agreement.swap_signature || vm.agreement.signature_status===\'signed-by-uca\'\"><div \ndata-ng-if=\"vm.user.id==signer.user.id &&\n                                           vm.agreement.signature_status!==\'signed\' && !vm.isSignedByContact(signer)\">\n<digisigner data=\"vm.getBase64\" success-callback=\"vm.digisignerSuccess\" error-callback=\"vm.digisignerError\">\n</digisigner></div><span class=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"vm.isSignedByContact(signer)\" \ndata-translate>Firmado </span><span class=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-ng-if=\"vm.agreement.signed\" \ndata-translate>Firmado fuera de la plataforma</span></div></div></div></div></div></div><div flex flex-order=\"2\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"fullwidth\" data-ng-if=\"vm.signers.length>0\"><h3 data-translate>\nPor parte de la Universidad de Cádiz</h3></div><div class=\"todo-item\" layout=\"row\" layout-align=\"start center\" \ndata-ng-if=\"vm.signers.length>0\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"info\" flex=\"auto\"><div \nlayout=\"row\" data-layout-xs=\"column\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"title\"><span data-ng-if=\"vm.agreement.uca_signer===\'vicerector\'\">\nVicerrector Estudiantes y Empleo </span><span data-ng-if=\"vm.agreement.uca_signer===\'rector\'\">Rector </span><span \ndata-ng-if=\"vm.agreement.uca_signer===\'absence\'\">Firma por ausencia</span></div></div><div layout=\"row\" \ndata-ng-if=\"vm.user.group_type===\'manager\'\"><md-button data-ng-click=\"vm.changeUCASigner(\'vicerector\')\" \nclass=\"md-accent md-raised\" data-ng-if=\"vm.agreement.uca_signer!==\'vicerector\'\" layout=\"row\" \naria-label=\"{{\'Descargar en formato PDF\' | translate}}\"><span data-translate>Firma Vicerrector</span></md-button>\n<md-button data-ng-click=\"vm.changeUCASigner(\'rector\')\" class=\"md-accent md-raised\" \ndata-ng-if=\"vm.agreement.uca_signer!==\'rector\'\" layout=\"row\" aria-label=\"{{\'Descargar en formato PDF\' | translate}}\">\n<span data-translate>Firma Rector</span></md-button><md-button data-ng-click=\"vm.changeUCASigner(\'absence\')\" \nclass=\"md-accent md-raised\" data-ng-if=\"vm.agreement.uca_signer!==\'absence\'\" layout=\"row\" \naria-label=\"{{\'Descargar en formato PDF\' | translate}}\"><span data-translate>Firma por ausencia</span></md-button>\n</div></div><div layout=\"row\" layout-align=\"end center\"><div layout=\"row\" layout-align=\"end center\" \nng-if=\"vm.agreement.swap_signature  || vm.agreement.signature_status===\'signed-by-company\'\"><md-button \ndata-debouce-click data-layout=\"column\" class=\"md-accent\" data-layout-align=\"start center\" \ndata-ng-if=\"vm.user.group_type===\'manager\' &&\n                                                       vm.agreement.signature_status!==\'signed\' &&\n                                                       vm.agreement.signature_status!==\'signed-by-uca\' &&\n                                                       vm.agreement.signature_status!==\'waiting_for_uca_signerbox\'\" \nng-click=\"vm.contactSigner()\"><md-icon class=\"pt-5\" title=\"{{\'Firmar\' | translate}}\" md-font-icon=\"icon-pencil\">\n</md-icon><span class=\"pt-5\" data-translate>Firmar</span></md-button></div><span \nclass=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-translate \ndata-ng-if=\"vm.agreement.signature_status===\'waiting_for_uca_signerbox\'\">Enviado al portafirmas </span><span \nclass=\"text-boxed m-0 white-fg indigo-bg ml-10\" data-translate \ndata-ng-if=\"vm.agreement.signature_status===\'signed\' || vm.agreement.signature_status===\'signed-by-uca\'\">Firmado</span>\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/company/centers/dialogs/center/center-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"centerForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container>\n<input ng-if=\"vm.UCA_COMPANY_CIF===vm.company.identification\" type=\"text\" name=\"name\" data-ng-model=\"vm.center.name\" \nplaceholder=\"{{\'Nombre del organismo\' | translate}}\" required md-autofocus> <input \nng-if=\"vm.UCA_COMPANY_CIF!==vm.company.identification\" type=\"text\" name=\"name\" data-ng-model=\"vm.center.name\" \nplaceholder=\"{{\'Nombre del centro\' | translate}}\" required md-autofocus><error-messages field=\"centerForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container><input type=\"email\" \nname=\"email\" data-ng-model=\"vm.center.email\" placeholder=\"{{\'Email\' | translate}}\"><error-messages \nfield=\"centerForm.email\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container>\n<input type=\"text\" name=\"phone\" data-ng-model=\"vm.center.phone\" placeholder=\"{{\'Teléfono\' | translate}}\">\n<error-messages field=\"centerForm.phone\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container>\n<md-input-container><input type=\"text\" name=\"mobile\" data-ng-model=\"vm.center.mobile\" \nplaceholder=\"{{\'Móvil\' | translate}}\"><error-messages field=\"centerForm.mobile\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container><div><md-autocomplete md-floating-label=\"{{\'Provincia\' | translate }}\" \nmd-delay=\"300\" md-input-name=\"province\" md-no-cache=\"true\" required md-selected-item=\"vm.center.province_data\" \nmd-search-text=\"searchTextProvince\" md-items=\"province in vm.getProvinces(searchTextProvince)\" md-min-length=\"0\" \nmd-item-text=\"province.name\"><md-item-template><span md-highlight-text=\"searchTextProvince\">{{province.name}}</span>\n</md-item-template><md-not-found><span data-translate>No hay ningun provincia con ese nombre</span></md-not-found>\n</md-autocomplete><md-input-container flex=\"100\" class=\"no-margin\"><error-messages field=\"centerForm.province\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div><md-autocomplete \nmd-floating-label=\"{{\'Localidad\' | translate }}\" md-delay=\"300\" md-input-name=\"town\" md-no-cache=\"true\" required \nmd-selected-item=\"vm.center.town_data\" md-search-text=\"searchTextLocality\" \nmd-items=\"locality in vm.getLocalities(searchTextLocality)\" md-min-length=\"0\" md-item-text=\"locality.name\">\n<md-item-template><span md-highlight-text=\"searchTextLocality\">{{locality.name}}</span></md-item-template>\n<md-not-found><span data-translate>No hay ninguna localidad</span></md-not-found></md-autocomplete><md-input-container \nflex=\"100\" class=\"no-margin\"><error-messages field=\"centerForm.town\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container></div><md-input-container><input type=\"text\" name=\"address\" \ndata-ng-model=\"vm.center.address\" placeholder=\"{{\'Dirección\' | translate}}\"><error-messages field=\"centerForm.address\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div></md-dialog-content><md-dialog-actions \ndata-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\">\n<md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveCenter()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"centerForm.$invalid || centerForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/company/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><div \ndata-layout=\"row\" data-layout-align=\"start center\" layout-wrap><md-input-container class=\"mr-20\"><label data-translate>\nTipo de identificación</label><md-select data-ng-model=\"vm.form.identification_type\" name=\"identification_type\" \nrequired><md-option data-ng-repeat=\"identification_type in vm.identification_types\" \ndata-ng-value=\"identification_type.id\">{{identification_type.value}}</md-option></md-select><error-messages \nfield=\"contactForm.identification_type\" server-errors=\"vm.serverErrors\" forcechange required></error-messages>\n</md-input-container><md-input-container><label data-translate>Identificación</label><input name=\"identification\" \ndata-ng-model=\"vm.form.identification\" required md-autofocus><error-messages field=\"contactForm.identification\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"mr-20\"><label data-translate>Nombre</label>\n<input name=\"name\" data-ng-model=\"vm.form.name\" required><error-messages field=\"contactForm.name\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container class=\"mr-20\"><label\n data-translate>Primer apellido</label><input name=\"surname\" data-ng-model=\"vm.form.surname\" required><error-messages \nfield=\"contactForm.surname\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container><label data-translate>Segundo apellido</label><input name=\"second_surname\" \ndata-ng-model=\"vm.form.second_surname\"><error-messages field=\"contactForm.second_surname\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div data-layout=\"row\" \ndata-layout-align=\"start center\" layout-wrap><md-input-container class=\"mr-20\"><label data-translate>Cargo</label>\n<input name=\"position\" data-ng-model=\"vm.form.position\"><error-messages field=\"contactForm.position\" \nserver-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container class=\"mr-20\"><label \ndata-translate>Teléfono</label><input name=\"phone\" data-ng-model=\"vm.form.phone\"><error-messages \nfield=\"contactForm.phone\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container><md-input-container \nng-if=\"vm.centers.length>0\"><label data-translate>Sede</label><md-select data-ng-model=\"vm.form.centers\" \nname=\"centers\" multiple=\"multiple\" ng-disabled=\"vm.user.id===vm.form.user_id\"><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name}} {{center.address}}</md-option>\n</md-select><error-messages field=\"contactForm.centers\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div><div ng-if=\"vm.centers.length>=0\"><p data-translate>Centros</p><ul><li \nng-repeat=\"center in vm.form.centers_data\">{{center.name}} {{center.address}}</li></ul></div><div data-layout=\"row\" \ndata-layout-align=\"space-between start\"><md-input-container flex=\"100\"><label data-translate>Email</label><input \nname=\"email\" data-ng-model=\"vm.form.user.email\" required><error-messages field=\"contactForm.email\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div data-layout=\"row\" \ndata-layout-align=\"space-between start\" ng-if=\"!vm.form.id\"><md-input-container flex=\"50\"><label data-translate>\nContraseña</label><input type=\"password\" name=\"password\" data-ng-model=\"vm.form.user.password\" required><error-messages\n field=\"contactForm.password\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"50\"><input match-password=\"password\" type=\"password\" name=\"password2\" \nng-model=\"vm.form.user.password2\" placeholder=\"Repite la contraseña\" required><error-messages \nfield=\"contactForm.password2\" server-errors=\"vm.serverErrors\" password-match required></error-messages>\n</md-input-container></div><md-input-container data-layout=\"column\"><md-radio-group \nng-model=\"vm.form.responsible_signing_agreement\"><md-radio-button value=\"cannotsign\" \naria-label=\"{{\'No puede firmar el Convenio de Colaboración\' | translate}}\" class=\"md-align-top-left\" flex><span \ndata-translate>No puede firmar el Convenio de Colaboración</span></md-radio-button><md-radio-button value=\"single\" \naria-label=\"{{\'Es responsable de la empresa con capacidad de firmar el Convenio de Colaboración\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>\nEs responsable de la empresa con capacidad de firmar el Convenio de Colaboración</span></md-radio-button>\n<md-radio-button value=\"joint\" \naria-label=\"{{\'Es responsable de la empresa con capacidad de firmar el Convenio de Colaboración de forma Macomunada\' | translate}}\" \nclass=\"md-align-top-left\" flex><span data-translate>\nEs responsable de la empresa con capacidad de firmar el Convenio de Colaboración de forma Macomunada</span>\n</md-radio-button></md-radio-group><div><md-checkbox ng-model=\"vm.form.company_manager\" name=\"company_manager\" \naria-label=\"{{\'Es gestor administrativo\' | translate}}\" class=\"md-align-top-left\" flex><span \nng-if=\"vm.UCA_COMPANY_CIF===vm.company.identification\" data-translate>Es gestor de sede</span> <span \nng-if=\"vm.UCA_COMPANY_CIF!==vm.company.identification\" data-translate>Es gestor administrativo</span></md-checkbox>\n<error-messages field=\"contactForm.company_manager\" server-errors=\"vm.serverErrors\" forcechange></error-messages></div>\n<div><md-checkbox ng-model=\"vm.form.human_resource_manager\" name=\"human_resource_manager\" \naria-label=\"{{\'Es responsable de recursos humanos\' | translate}}\" class=\"md-align-top-left\" flex><span \nng-if=\"vm.UCA_COMPANY_CIF===vm.company.identification\" data-translate>Es responsable de orgánica</span> <span \nng-if=\"vm.UCA_COMPANY_CIF!==vm.company.identification\" data-translate>Es responsable de recursos humanos</span>\n</md-checkbox><error-messages field=\"contactForm.human_resource_manager\" server-errors=\"vm.serverErrors\" forcechange>\n</error-messages></div><div><md-checkbox ng-model=\"vm.form.professional_tutor\" name=\"professional_tutor\" \naria-label=\"{{\'Es tutor/a de prácticas\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nEs tutor/a de prácticas</span></md-checkbox><error-messages field=\"contactForm.professional_tutor\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></div><div><md-checkbox \nng-model=\"vm.form.agreement_monitoring\" name=\"agreement_monitoring\" \naria-label=\"{{\'Es tutor/a de prácticas\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nEs miembro de la comisión de seguimiento del convenio</span></md-checkbox><error-messages \nfield=\"contactForm.agreement_monitoring\" server-errors=\"vm.serverErrors\" forcechange></error-messages></div>\n</md-input-container><md-input-container><pre>{{vm.privacyPolicy}}</pre><md-checkbox \nng-model=\"vm.form.accept_privacy_policy\" name=\"accept_privacy_policy\" \naria-label=\"{{\'Acepto la política de privacidad\' | translate}}\" class=\"md-align-top-left\" flex><span data-translate>\nAcepto la política de privacidad</span></md-checkbox><error-messages field=\"contactForm.accept_privacy_policy\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div></md-dialog-content>\n<md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveContact()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/notifications/views/classic/detail/detail.html","<div class=\"thread-content pt-0\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div \nlayout=\"column\" layout-align=\"start start\"><div layout=\"row\" layout-align=\"start center\"><div><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{vm.currentThread.notification.subject[0] || \'N\'}}</div></div><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"name\">\n{{vm.currentThread.notification.subject || \'Notificación del sistema\' | translate}}</div></div></div><div \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate>Fecha:\n</span></div><div layout=\"column\"><span class=\"detail\">\n{{vm.currentThread.notification.creation_datetime | date:\'d MMM\'}}</span></div></div></div></div><div \nng-bind-html=\"vm.currentThread.notification.message\"></div></div><div \nng-show=\"vm.currentThread.notification.showFiles\" class=\"thread-attachments\" \nng-init=\"vm.currentThread.notification.showFiles=false\"><div class=\"title\"><span translate>Archivos adjuntos</span>\n</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div class=\"attachment\" layout=\"column\" \nng-init=\"vm.currentThread.notification.showFiles=true\" \nng-repeat=\"file in vm.currentThread.notification.files | filter:vm.filterFiles\"><div class=\"preview\">\n{{file.document.name}}</div><div layout=\"column\"><a data-ng-click=\"getDocument(file.document)\" \nclass=\"md-accent-color link pointer\">Descargar</a> <a data-ng-if=\"isPrintable(file.document)\" \ndata-ng-click=\"printDocument(file.document, $event)\" class=\"md-accent-color link pointer\" data-translate>Imprimir</a>\n<div class=\"size\">({{file.document.size/1048576 | number:2}} Mb)</div></div></div></div></div>");
$templateCache.put("app/main/notifications/views/classic/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.count == 0\">No hay notificaciones</div><div class=\"thread\" md-ink-ripple \ndata-dir-paginate=\"thread in vm.threads.data | itemsPerPage: 10\" data-total-items=\"vm.threads.count\" \ndata-current-page=\"vm.threads.filters.page\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': (!thread.is_read),\'current-thread\': vm.currentThread.id == thread.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar\" ms-random-class=\"vm.colors\">{{thread.notification.subject[0] || \"N\"}}\n</div><span class=\"text-truncate\">{{thread.notification.subject || \'Notificación del sistema\' | translate}}</span>\n</div><div class=\"subject text-truncate\">{{thread.title}}</div><div class=\"message text-truncate\" \nng-init=\"message=(thread.notification.message | findBodyHtml | htmlToPlaintext)\"><span>\n{{message | limitTo:90}}{{message.length > 90 ? \'...\' : \'\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between end\"><span class=\"mr-10\" ng-click=\"vm.toggleImportant(thread); $event.stopPropagation();\">\n<md-icon ng-if=\"thread.is_important\" md-font-icon=\"icon-star\" class=\"orange-fg\"></md-icon><md-icon \nng-if=\"!thread.is_important\" md-font-icon=\"icon-star-outline\"></md-icon></span><div class=\"time\">\n{{thread.notification.creation_datetime | date:\'d MMM\'}}</div></div></div></div>");
$templateCache.put("app/main/notifications/views/outlook/detail/detail.html","<div ng-if=\"!vm.currentThread\" class=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"icon-bell\" class=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\" translate>\nSelecciona una notificación para leer</span></div><div ng-if=\"vm.currentThread\"><div class=\"thread-content\"><div \nclass=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start start\"><div \nlayout=\"row\" layout-align=\"start center\"><div><div class=\"avatar\" ms-random-class=\"vm.colors\">\n{{vm.currentThread.notification.subject[0] || \'N\'}}</div></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"name\">{{vm.currentThread.notification.subject || \'Notificación del sistema\' | translate}}</div></div></div><div \nclass=\"details\" layout=\"row\" layout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate>Fecha:\n</span></div><div layout=\"column\"><span class=\"detail\">\n{{vm.currentThread.notification.creation_datetime | date:\'d MMM\'}}</span></div></div></div></div><div \nng-bind-html=\"vm.currentThread.notification.message\"></div></div><div \nng-show=\"vm.currentThread.notification.showFiles\" class=\"thread-attachments\" \nng-init=\"vm.currentThread.notification.showFiles=false\"><div class=\"title\"><span translate>Archivos adjuntos</span>\n</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div class=\"attachment\" layout=\"column\" \nng-init=\"vm.currentThread.notification.showFiles=true\" \nng-repeat=\"file in vm.currentThread.notification.files | filter:vm.filterFiles\"><div class=\"preview\">\n{{file.document.name}}</div><div layout=\"column\"><a data-ng-click=\"getDocument(file.document)\" \nclass=\"md-accent-color link pointer\">Descargar</a> <a data-ng-if=\"isPrintable(file.document)\" \ndata-ng-click=\"printDocument(file.document, $event)\" class=\"md-accent-color link pointer\" data-translate>Imprimir</a>\n<div class=\"size\">({{file.document.size/1048576 | number:2}} Mb)</div></div></div></div></div></div>");
$templateCache.put("app/main/notifications/views/outlook/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.count == 0\" translate>No hay notificaciones</div><div class=\"thread\" \nmd-ink-ripple data-dir-paginate=\"thread in vm.threads.data | itemsPerPage: 10\" data-total-items=\"vm.threads.count\" \ndata-current-page=\"vm.threads.filters.page\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': (!thread.is_read),\'current-thread\': vm.currentThread.id == thread.id}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar\" ms-random-class=\"vm.colors\">{{thread.notification.subject[0] || \"N\"}}\n</div><span class=\"text-truncate\">{{thread.notification.subject || \'Notificación del sistema\' | translate}}</span>\n</div><div class=\"subject text-truncate\">{{thread.title}}</div><div class=\"message text-truncate\" \nng-init=\"message=(thread.notification.message | findBodyHtml | htmlToPlaintext)\"><span>\n{{message | limitTo:90}}{{message.length > 90 ? \'...\' : \'\'}}</span></div></div><div layout=\"row\" \nlayout-align=\"space-between end\"><span class=\"mr-10\" ng-click=\"vm.toggleImportant(thread); $event.stopPropagation();\">\n<md-icon ng-if=\"thread.is_important\" md-font-icon=\"icon-star\" class=\"orange-fg\"></md-icon><md-icon \nng-if=\"!thread.is_important\" md-font-icon=\"icon-star-outline\"></md-icon></span><div class=\"time\">\n{{thread.notification.creation_datetime | date:\'d MMM\'}}</div></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/demands/views/pendingAssignments/dialogs/pendingAssignment/pendingAssignment-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"pendingAssignmentForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><md-input-container><label data-translate>\nEmpresa</label><md-select data-ng-model=\"vm.pendingAssignment.company\" name=\"company\" required><md-option \ndata-ng-repeat=\"(key,company) in vm.companies | orderBy : vm.orders.company\" data-ng-value=\"key\">\n{{company.business_name}} <span ng-if=\"company.seat_data.town_data.name\">({{company.seat_data.town_data.name}})</span>\n</md-option></md-select></md-input-container><md-input-container class=\"sede\"><label data-translate>Fecha de inicio\n</label><md-select data-ng-model=\"vm.pendingAssignment.offer\" name=\"offer\" \nmd-container-class=\"pending-assignment-offer-select\" ng-disabled=\"vm.pendingAssignment.company<0\" required><md-option \ndata-ng-repeat=\"offer in vm.offers[vm.pendingAssignment.company]\" data-ng-value=\"offer.id\"><div><span \nng-repeat=\"workingday in vm.workingdays\" class=\"workingDays ml-10\" \nng-if=\"workingday.id===offer.schedule_data.working_day\">{{workingday.value}} </span>\n[{{offer.seat_data.name}}] {{offer.start_date | date:\'dd-MM-yyyy\'}} ({{offer.demand_profile_name}})</div><div \nclass=\"offer-tutor-line\"><md-icon md-font-icon=\"icon-account-box\" class=\"s16\"></md-icon><span data-translate>\nTutor profesional:</span> <span ng-if=\"offer.professional_tutor_data\">\n{{offer.professional_tutor_data.name}} {{offer.professional_tutor_data.surname}} {{offer.professional_tutor_data.second_surname}} \n</span><span data-translate ng-if=\"!offer.professional_tutor_data\">Sin tutor</span></div></md-option></md-select>\n<error-messages field=\"pendingAssignmentForm.offer\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><div class=\"mb-15\" data-ng-if=\"vm.getSelectedOffer()\"><md-icon md-font-icon=\"icon-account-box\" \nclass=\"s16\"></md-icon><span class=\"ml-5\"><span data-translate>Tutor profesional:</span> <span \ndata-ng-if=\"vm.getSelectedOffer().professional_tutor_data\">\n{{vm.getSelectedOffer().professional_tutor_data.name}} {{vm.getSelectedOffer().professional_tutor_data.surname}} {{vm.getSelectedOffer().professional_tutor_data.second_surname}} \n</span><span data-translate data-ng-if=\"!vm.getSelectedOffer().professional_tutor_data\">Sin tutor</span></span></div>\n<md-input-container><label data-translate>Tutor</label><md-select data-ng-model=\"vm.pendingAssignment.academic_tutor\" \nname=\"academic_tutor\" required><md-option data-ng-repeat=\"teacher in vm.subjectsTeachers.data\" \ndata-ng-value=\"teacher.id\">{{teacher.full_name}}</md-option></md-select><error-messages \nfield=\"pendingAssignmentForm.academic_tutor\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.savependingAssignment()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"pendingAssignmentForm.$invalid || pendingAssignmentForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/demands/views/offersPostulates/dialogs/offersCurricular/offersCurricular-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersCurricularForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div><md-input-container class=\"mr-80\"><h4 \ndata-translate>Fecha inicio</h4><md-datepicker name=\"start_date\" data-ng-model=\"vm.offersCurricular.start_date\" \nmd-placeholder=\"dd/mm/yyyy\" required></md-datepicker><error-messages field=\"offersCurricularForm.start_date\" \nserver-errors=\"vm.serverErrors\" forcechange required></error-messages></md-input-container></div><md-input-container>\n<label data-translate>Tutor profesional</label><md-select data-ng-model=\"vm.offersCurricular.professional_tutor\" \nname=\"professional_tutor\" required><md-option data-ng-repeat=\"tutor in vm.tutors\" data-ng-value=\"tutor.id\">\n{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}</md-option></md-select><error-messages \nfield=\"offersCurricularForm.professional_tutor\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersCurricular()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersCurricularForm.$invalid || offersCurricularForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/demands/views/offersPostulates/dialogs/offersPostulate/offersPostulate-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"offersPostulateForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div layout=\"row\" data-layout-xs=\"column\" \nlayout-align=\"start start\" layout-wrap style=\"background: #dedede;padding: 5px;border-radius: 5px\"><div \nclass=\"mr-40 mb-10\"><span data-translate>Periodo de inicio</span><div class=\"title mt-10\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><span>{{vm.demands.start_date_start_practices | date:\'dd/MM/yyyy\'}}</span> \n<span>-</span> <span>{{vm.demands.end_date_start_practices | date:\'dd/MM/yyyy\'}}</span></div></div><div \nclass=\"mr-40 mb-10\"><span data-translate>Semanas</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-view-week\">\n</md-icon><span>{{vm.demands.duration}}</span> <span class=\"hint\">\n({{vm.demands.duration}} semanas = {{vm.demands.duration}} créditos = {{vm.demands.duration*25}} horas)</span></div>\n</div><div class=\"mr-40 mb-10\"><span data-translate>Límite fin de prácticas</span><div class=\"title mt-10\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><span>{{vm.demands.end_date_practices | date:\'dd/MM/yyyy\'}}</span></div></div>\n<div><span data-translate>Jornada</span><div class=\"title mt-10\"><md-icon md-font-icon=\"icon-clock\"></md-icon><span \nng-repeat=\"workingday in vm.workingdays\" ng-if=\"workingday.id===vm.demands.working_day\">{{workingday.value}}</span>\n</div></div></div><md-input-container class=\"mr-80\"><h4 data-translate>Fecha de inicio</h4><md-datepicker \nname=\"start_date\" data-ng-model=\"vm.offersPostulate.start_date\" md-placeholder=\"dd/mm/yyyy\" required></md-datepicker>\n<error-messages field=\"offersPostulateForm.start_date\" server-errors=\"vm.serverErrors\" forcechange required>\n</error-messages></md-input-container><md-input-container flex=\"100\"><input type=\"number\" name=\"seats\" \ndata-ng-model=\"vm.offersPostulate.seats\" placeholder=\"{{\'Plazas\' | translate}}\" required><error-messages \nfield=\"offersPostulateForm.seats\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container><label data-translate>Tutor profesional</label><md-select \ndata-ng-model=\"vm.offersPostulate.professional_tutor\" name=\"professional_tutor\" required><md-option \ndata-ng-repeat=\"tutor in vm.tutors\" data-ng-value=\"tutor.id\">{{tutor.name}} {{tutor.surname}} {{tutor.second_surname}}\n</md-option></md-select><error-messages field=\"offersPostulateForm.professional_tutor\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container><md-input-container><label data-translate>Centro de trabajo</label>\n<md-select data-ng-model=\"vm.offersPostulate.seat\" name=\"seat\" required><md-option \ndata-ng-repeat=\"center in vm.centers\" data-ng-value=\"center.id\">{{center.name || center.address}}</md-option>\n</md-select><error-messages field=\"offersPostulateForm.seat\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><md-input-container><label data-translate>Perfil</label><md-select \ndata-ng-model=\"vm.offersPostulate.demand_profile\" name=\"demand_profile\" required><md-option \ndata-ng-repeat=\"demandsProfile in vm.demandsProfiles.data\" data-ng-value=\"demandsProfile.id\">{{demandsProfile.name}}\n</md-option></md-select><error-messages field=\"offersPostulateForm.demand_profile\" server-errors=\"vm.serverErrors\" \nrequired></error-messages></md-input-container><md-input-container class=\"md-block\"><label data-translate>Observaciones\n</label><textarea name=\"observations\" ng-model=\"vm.offersPostulate.observations\" max-rows=\"5\"></textarea>\n<error-messages field=\"offersPostulateForm.observations\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveOffersPostulate()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"offersPostulateForm.$invalid || offersPostulateForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierExtensions/dialogs/dossierExtension/dossierExtension-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierExtensionForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"row\" \ndata-layout-align=\"start start\"><div class=\"mr-50\" style=\"width: 200px\"><md-input-container><h4 data-translate>\nFecha inicio prórroga</h4><md-datepicker name=\"start_date\" data-ng-model=\"vm.dossierExtension.start_date\" \nmd-placeholder=\"dd/mm/yyyy\" ng-disabled=\"true\"></md-datepicker><error-messages field=\"dossierExtensionForm.start_date\" \nserver-errors=\"vm.serverErrors\" forcechange></error-messages></md-input-container></div><div class=\"mr-50\" \nstyle=\"width: 220px\"><md-input-container><h4 data-translate>Fecha fin prórroga</h4><md-datepicker name=\"end_date\" \ndata-ng-model=\"vm.endDate\" md-placeholder=\"dd/mm/yyyy\" required md-min-date=\"vm.dossierExtension.start_date\" \nng-disabled=\"vm.disabledInputs\" ng-change=\"vm.updateDuration(dossierExtensionForm)\"></md-datepicker><error-messages \nfield=\"dossierExtensionForm.end_date\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n</div><div class=\"mt-16\"><h4 data-translate>Duración</h4><p style=\"white-space: nowrap\">{{vm.durationText()}}</p></div>\n</div><div data-layout=\"row\" data-layout-align=\"start center\"><div class=\"mr-50\"><md-input-container class=\"months\">\n<label data-translate>Horas</label><input type=\"number\" name=\"hours\" data-ng-model=\"vm.dossierExtension.hours\" \nrequired ng-disabled=\"vm.disabledInputs\"><error-messages field=\"dossierExtensionForm.hours\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><div><md-input-container \nclass=\"eur\"><label data-translate>Dotación mensual bruta (€)</label><input type=\"number\" name=\"economic_endowment\" \ndata-ng-model=\"vm.dossierExtension.economic_endowment\" required ng-disabled=\"vm.disabledInputs\"><error-messages \nfield=\"dossierExtensionForm.economic_endowment\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDossierExtension()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"dossierExtensionForm.$invalid || dossierExtensionForm.$pristine\" \naria-label=\"{{\'Solicitar\' | translate}}\"><span data-translate>{{vm.title}}</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierDocuments/dialogs/dossierDocument/dossierDocument-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierDocumentForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container \nflex=\"100\"><input type=\"text\" name=\"name\" data-ng-model=\"vm.dossierDocument.name\" \nplaceholder=\"{{\'Nombre del documento\' | translate}}\" md-autofocus required><error-messages \nfield=\"dossierDocumentForm.name\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container><div \nclass=\"actions\" layout=\"row\" layout-align=\"center center\"><md-button type=\"button\" class=\"md-accent md-raised\" \nng-click=\"vm.openFiles()\"><span data-translate ng-if=\"!vm.dossierDocument.document\">Subir archivo</span> <span \ndata-translate ng-if=\"vm.dossierDocument.document\">Reemplazar archivo</span></md-button><input type=\"file\" \nid=\"file-uploader\" ng-show=\"false\" name=\"document\" ng-model=\"vm.dossierDocument.document\"><error-messages \nfield=\"dossierDocumentForm.document\" server-errors=\"vm.serverErrors\" required></error-messages></div></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveDossierDocument()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"dossierDocumentForm.$invalid\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar\n</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierDocuments/dialogs/dossierDocumentRequired/dossierDocumentRequired-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierDocumentRequiredForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container \nclass=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_iban_required && !vm.dossier.iban_student\"><div \nflow-init=\"vm.ngFlowOptionsIban\" flow-name=\"vm.formFlow.ibanFlow\" flow-drop \nflow-file-error=\"vm.fileError($file, $message, $flow)\" flow-file-success=\"vm.fileSuccessIban($message)\" \nflow-files-submitted=\"$flow.upload()\" flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div><md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" \naria-label=\"{{\'IBAN\' | translate}}\"><md-icon ng-if=\"!vm.dossier.iban_student && !$flow.files[0]\" \nmd-font-icon=\"icon-upload\"></md-icon><md-icon ng-if=\"vm.dossier.iban_student || $flow.files[0]\" \nmd-font-icon=\"icon-pencil\"></md-icon><span ng-if=\"!vm.dossier.iban_student && !$flow.files[0]\" data-translate>\nAdjuntar IBAN</span><span ng-if=\"vm.dossier.iban_student || $flow.files[0]\" data-translate>Modificar IBAN</span>\n</md-button></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_nif_required && !vm.dossier.dni_student\"><div flow-init=\"vm.ngFlowOptionsDNI\" \nflow-name=\"vm.formFlow.dniFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileSuccessDNI($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" aria-label=\"{{\'DNI\' | translate}}\"><md-icon \nng-if=\"!vm.dossier.dni_student && !$flow.files[0]\" md-font-icon=\"icon-upload\"></md-icon><md-icon \nng-if=\"vm.dossier.dni_student || $flow.files[0]\" md-font-icon=\"icon-pencil\"></md-icon><span \nng-if=\"!vm.dossier.dni_student && !$flow.files[0]\" data-translate>Adjuntar DNI</span><span \nng-if=\"vm.dossier.dni_student || $flow.files[0]\" data-translate>Modificar DNI</span></md-button></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_ss_required && !vm.dossier.ss_student\"><div flow-init=\"vm.ngFlowOptionsSS\" \nflow-name=\"vm.formFlow.ssFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileSuccessSS($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" aria-label=\"{{\'SS\' | translate}}\"><md-icon \nng-if=\"!vm.dossier.ss_student && !$flow.files[0]\" md-font-icon=\"icon-upload\"></md-icon><md-icon \nng-if=\"vm.dossier.ss_student || $flow.files[0]\" md-font-icon=\"icon-pencil\"></md-icon><span \nng-if=\"!vm.dossier.ss_student && !$flow.files[0]\" data-translate>Adjuntar nº de la seguridad social</span><span \nng-if=\"vm.dossier.ss_student || $flow.files[0]\" data-translate>Modificar nº de la seguridad social</span></md-button>\n</div></div></md-input-container><div data-ng-if=\"!vm.dossier.curricular\"><md-input-container class=\"md-block\" \nflex=\"100\"><label data-translate>IBAN</label><input type=\"text\" name=\"iban_student_number\" \ndata-ng-model=\"vm.documents.iban_student_number\"><error-messages \nfield=\"dossierDocumentRequiredForm.iban_student_number\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDossierDocumentRequired()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"dossierDocumentRequiredForm.$invalid\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierInterruptions/dialogs/dossierInterruption/dossierInterruption-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierInterruptionForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><div class=\"mr-50\"><md-input-container><h4 data-translate>Fecha inicio</h4>\n<md-datepicker name=\"start_date\" data-ng-model=\"vm.dossierInterruption.start_date\" md-placeholder=\"dd/mm/yyyy\">\n</md-datepicker><error-messages field=\"dossierInterruptionForm.start_date\" server-errors=\"vm.serverErrors\" forcechange>\n</error-messages></md-input-container></div><div><md-input-container><h4 data-translate>Fecha fin</h4><md-datepicker \nname=\"end_date\" data-ng-model=\"vm.dossierInterruption.end_date\" md-placeholder=\"dd/mm/yyyy\"></md-datepicker>\n<error-messages field=\"dossierInterruptionForm.end_date\" server-errors=\"vm.serverErrors\" forcechange></error-messages>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDossierInterruption()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"dossierInterruptionForm.$invalid || dossierInterruptionForm.$pristine\" \naria-label=\"{{\'Solicitar\' | translate}}\"><span data-translate>Solicitar</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierQuotes/dialogs/dossierQuotes/dossierQuotes-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierQuotesForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container \nflex=\"100\"><input type=\"text\" name=\"name\" data-ng-model=\"vm.dossierQuotes.worked_days\" \nplaceholder=\"{{\'Dias trabajados\' | translate}}\" md-autofocus required><error-messages \nfield=\"dossierQuotesForm.worked_days\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n</div></md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\"><div \ndata-layout=\"row\" data-layout-align=\"start center\"><md-button data-debouce-click type=\"submit\" \ndata-ng-click=\"vm.saveDossierQuotes()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"dossierQuotesForm.$invalid\" aria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar\n</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierQuotes/dialogs/dossierQuotesRequired/dossierQuotesRequired-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierDocumentRequiredForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout-xs=\"column\" data-layout=\"column\"><md-input-container \nclass=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_iban_required && !vm.dossier.iban_student\"><div \nflow-init=\"vm.ngFlowOptionsIban\" flow-name=\"vm.formFlow.ibanFlow\" flow-drop \nflow-file-error=\"vm.fileError($file, $message, $flow)\" flow-file-success=\"vm.fileSuccessIban($message)\" \nflow-files-submitted=\"$flow.upload()\" flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div><md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" \naria-label=\"{{\'IBAN\' | translate}}\"><md-icon ng-if=\"!vm.dossier.iban_student && !$flow.files[0]\" \nmd-font-icon=\"icon-upload\"></md-icon><md-icon ng-if=\"vm.dossier.iban_student || $flow.files[0]\" \nmd-font-icon=\"icon-pencil\"></md-icon><span ng-if=\"!vm.dossier.iban_student && !$flow.files[0]\" data-translate>\nAdjuntar IBAN</span><span ng-if=\"vm.dossier.iban_student || $flow.files[0]\" data-translate>Modificar IBAN</span>\n</md-button></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_nif_required && !vm.dossier.dni_student\"><div flow-init=\"vm.ngFlowOptionsDNI\" \nflow-name=\"vm.formFlow.dniFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileSuccessDNI($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" aria-label=\"{{\'DNI\' | translate}}\"><md-icon \nng-if=\"!vm.dossier.dni_student && !$flow.files[0]\" md-font-icon=\"icon-upload\"></md-icon><md-icon \nng-if=\"vm.dossier.dni_student || $flow.files[0]\" md-font-icon=\"icon-pencil\"></md-icon><span \nng-if=\"!vm.dossier.dni_student && !$flow.files[0]\" data-translate>Adjuntar DNI</span><span \nng-if=\"vm.dossier.dni_student || $flow.files[0]\" data-translate>Modificar DNI</span></md-button></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"45\" flex-xs=\"100\" \nng-show=\"vm.dossier.program_data.student_ss_required && !vm.dossier.ss_student\"><div flow-init=\"vm.ngFlowOptionsSS\" \nflow-name=\"vm.formFlow.ssFlow\" flow-drop flow-file-error=\"vm.fileError($file, $message, $flow)\" \nflow-file-success=\"vm.fileSuccessSS($message)\" flow-files-submitted=\"$flow.upload()\" \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div>\n<md-button flow-btn class=\"md-accent md-raised md-green-700-bg\" aria-label=\"{{\'SS\' | translate}}\"><md-icon \nng-if=\"!vm.dossier.ss_student && !$flow.files[0]\" md-font-icon=\"icon-upload\"></md-icon><md-icon \nng-if=\"vm.dossier.ss_student || $flow.files[0]\" md-font-icon=\"icon-pencil\"></md-icon><span \nng-if=\"!vm.dossier.ss_student && !$flow.files[0]\" data-translate>Adjuntar nº de la seguridad social</span><span \nng-if=\"vm.dossier.ss_student || $flow.files[0]\" data-translate>Modificar nº de la seguridad social</span></md-button>\n</div></div></md-input-container><div data-ng-if=\"!vm.dossier.curricular\"><md-input-container class=\"md-block\" \nflex=\"100\"><label data-translate>IBAN</label><input type=\"text\" name=\"iban_student_number\" \ndata-ng-model=\"vm.documents.iban_student_number\"><error-messages \nfield=\"dossierDocumentRequiredForm.iban_student_number\" server-errors=\"vm.serverErrors\"></error-messages>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDossierDocumentRequired()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"dossierDocumentRequiredForm.$invalid\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/dossiers/views/dossierResignations/dialogs/dossierResignation/dossierResignation-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"dossierResignationForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"row\" \ndata-layout-align=\"start center\"><md-input-container class=\"md-block fullwidth\"><label data-translate>\nSolicitar rescisión de las prácticas por el siguiente motivo:</label><textarea name=\"reason\" \nng-model=\"vm.dossierResignation.reason\" max-rows=\"5\" md-autofocus></textarea><error-messages \nfield=\"dossierResignationForm.reason\" server-errors=\"vm.serverErrors\"></error-messages></md-input-container></div><div \ndata-layout=\"row\" data-layout-align=\"start center\" data-ng-if=\"vm.requiresEffectiveEndDate\"><md-input-container><h4 \ndata-translate>Fecha efectiva de cese</h4><md-datepicker name=\"effective_end_date\" \ndata-ng-model=\"vm.dossierResignation.effective_end_date\" md-placeholder=\"dd/mm/yyyy\" required></md-datepicker>\n<error-messages field=\"dossierResignationForm.effective_end_date\" server-errors=\"vm.serverErrors\" forcechange>\n</error-messages></md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveDossierResignation()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"dossierResignationForm.$invalid || dossierResignationForm.$pristine\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar</span></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/evaluations/views/answers/dialogs/answer/answer-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"answerForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"column\" \ndata-layout-align=\"start start\"><md-input-container class=\"md-block fullwidth\" data-ng-if=\"vm.question.type===\'text\'\">\n<label>{{vm.question.body}}</label><input type=\"text\" name=\"body\" data-ng-model=\"vm.answer.body\" \nng-disabled=\"vm.evaluation.finished\" required md-autofocus> <span class=\"hint\">{{vm.question.observations}}</span>\n<error-messages field=\"answerForm.body\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container class=\"md-block fullwidth\" data-ng-if=\"vm.question.type===\'assessment\'\"><label>{{vm.question.body}}\n</label><input type=\"number\" name=\"body\" data-ng-model=\"vm.answer.body\" ng-disabled=\"vm.evaluation.finished\" \nmin=\"{{vm.question.minimum}}\" max=\"{{vm.question.maximum}}\" required md-autofocus> <span class=\"hint\">\n{{vm.question.observations}}</span><error-messages field=\"answerForm.body\" server-errors=\"vm.serverErrors\" required>\n</error-messages></md-input-container><md-input-container class=\"md-block fullwidth\" \ndata-ng-if=\"vm.question.type===\'options\'\"><label>{{vm.question.body}}</label><md-select name=\"body\" \ndata-ng-model=\"vm.answer.body\" required ng-disabled=\"vm.evaluation.finished\"><md-option \ndata-ng-repeat=\"option in vm.options\" data-ng-value=\"option.id\">{{option.body}}</md-option></md-select><error-messages \nfield=\"answerForm.body\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-ng-if=\"!vm.evaluation.finished\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveAnswer()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"answerForm.$invalid || answerForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/evaluations/views/questions/dialogs/question/question-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"questionForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div data-layout=\"column\"><div data-layout=\"column\" \ndata-layout-align=\"start start\"><md-input-container class=\"md-block fullwidth\"><input type=\"text\" name=\"body\" \ndata-ng-model=\"vm.question.body\" placeholder=\"{{\'Pregunta\' | translate}}\" required md-autofocus><error-messages \nfield=\"questionForm.body\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container class=\"md-block fullwidth\"><label data-translate>Descripción:</label><textarea name=\"observations\" \nng-model=\"vm.question.observations\" max-rows=\"5\" required></textarea><error-messages field=\"questionForm.observations\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container><md-input-container><md-checkbox \nng-model=\"vm.question.no_answer\" aria-label=\"no_answer\" class=\"md-align-top-left\" flex><span data-translate>\nPermitir no sabe no contesta</span></md-checkbox></md-input-container><md-input-container class=\"md-block fullwidth\">\n<label data-translate>Tipo de pregunta</label><md-select data-ng-model=\"vm.question.type\" name=\"type\" required>\n<md-option data-ng-repeat=\"type in vm.typeQuestions\" data-ng-value=\"type.id\">{{type.value}}</md-option></md-select>\n<error-messages field=\"questionForm.type\" server-errors=\"vm.serverErrors\" required></error-messages>\n</md-input-container><div data-layout=\"row\" data-layout-align=\"start start\" \ndata-ng-if=\"vm.question.type===\'assessment\'\"><md-input-container flex=\"100\"><input type=\"number\" name=\"minimum\" \ndata-ng-model=\"vm.question.minimum\" placeholder=\"{{\'Mínimo\' | translate}}\" required><error-messages \nfield=\"questionForm.minimum\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container>\n<md-input-container flex=\"100\"><input type=\"number\" name=\"maximum\" data-ng-model=\"vm.question.maximum\" \nplaceholder=\"{{\'Máximo\' | translate}}\" required><error-messages field=\"questionForm.maximum\" \nserver-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div><md-input-container \nclass=\"md-block fullwidth\" ng-if=\"vm.question.id\"><input type=\"number\" name=\"order\" data-ng-model=\"vm.question.order\" \nplaceholder=\"{{\'Orden\' | translate}}\"><error-messages field=\"questionForm.order\" server-errors=\"vm.serverErrors\">\n</error-messages></md-input-container></div></div></md-dialog-content><md-dialog-actions data-layout=\"row\" \ndata-layout-align=\"space-between center\"><div data-layout=\"row\" data-layout-align=\"start center\"><md-button \ndata-debouce-click type=\"submit\" data-ng-click=\"vm.saveQuestion()\" class=\"send-button md-accent md-raised\" \ndata-ng-disabled=\"questionForm.$invalid || questionForm.$pristine\" aria-label=\"{{\'Guardar\' | translate}}\"><span \ndata-translate>Guardar</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/evaluations/views/questions/dialogs/questionOptions/questionOptions-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"questionOptionForm\" class=\"md-inline-form\" novalidate \ndata-form-translate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" data-layout=\"row\" \ndata-layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \ndata-ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button>\n</div></md-toolbar><div class=\"attachment-list p-20\"><div class=\"attachment\" data-layout=\"column\" \ndata-ng-repeat=\"option in vm.questionOptions.data\"><div data-layout=\"row\" data-layout-align=\"space-between center\">\n<div><span class=\"filename\" var-translate>{{option.body}}</span></div><md-button class=\"md-icon-button\" \naria-label=\"Delete attachment\" data-ng-click=\"vm.removeQuestionOption($event,option)\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></div><md-dialog-content ms-scroll><div \ndata-layout-xs=\"column\" data-layout=\"column\"><md-input-container data-flex=\"100\"><input type=\"text\" name=\"body\" \ndata-ng-model=\"vm.questionOption.body\" placeholder=\"{{\'Nueva opción\' | translate}}\" md-autofocus><error-messages \nfield=\"questionOptionForm.body\" server-errors=\"vm.serverErrors\" required></error-messages></md-input-container></div>\n</md-dialog-content><md-dialog-actions data-layout=\"row\" data-layout-align=\"space-between center\" \ndata-ng-if=\"vm.hasPermission(\'questionOptions\',\'POST\')\"><div data-layout=\"row\" data-layout-align=\"start center\">\n<md-button data-debouce-click type=\"submit\" data-ng-click=\"vm.saveQuestionOption()\" \nclass=\"send-button md-accent md-raised\" data-ng-disabled=\"questionOptionForm.$invalid\" \naria-label=\"{{\'Guardar\' | translate}}\"><span data-translate>Guardar nueva opción</span></md-button></div>\n</md-dialog-actions></form></md-dialog>");}]);